(function() {
  typeof window > "u" || ("SVGPathSeg" in window || (window.SVGPathSeg = function(r, e, t) {
    this.pathSegType = r, this.pathSegTypeAsLetter = e, this._owningPathSegList = t;
  }, window.SVGPathSeg.prototype.classname = "SVGPathSeg", window.SVGPathSeg.PATHSEG_UNKNOWN = 0, window.SVGPathSeg.PATHSEG_CLOSEPATH = 1, window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2, window.SVGPathSeg.PATHSEG_MOVETO_REL = 3, window.SVGPathSeg.PATHSEG_LINETO_ABS = 4, window.SVGPathSeg.PATHSEG_LINETO_REL = 5, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9, window.SVGPathSeg.PATHSEG_ARC_ABS = 10, window.SVGPathSeg.PATHSEG_ARC_REL = 11, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19, window.SVGPathSeg.prototype._segmentChanged = function() {
    this._owningPathSegList && this._owningPathSegList.segmentChanged(this);
  }, window.SVGPathSegClosePath = function(r) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", r);
  }, window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegClosePath.prototype.toString = function() {
    return "[object SVGPathSegClosePath]";
  }, window.SVGPathSegClosePath.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter;
  }, window.SVGPathSegClosePath.prototype.clone = function() {
    return new window.SVGPathSegClosePath(void 0);
  }, window.SVGPathSegMovetoAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", r), this._x = e, this._y = t;
  }, window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoAbs.prototype.toString = function() {
    return "[object SVGPathSegMovetoAbs]";
  }, window.SVGPathSegMovetoAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegMovetoAbs.prototype.clone = function() {
    return new window.SVGPathSegMovetoAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegMovetoRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", r), this._x = e, this._y = t;
  }, window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoRel.prototype.toString = function() {
    return "[object SVGPathSegMovetoRel]";
  }, window.SVGPathSegMovetoRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegMovetoRel.prototype.clone = function() {
    return new window.SVGPathSegMovetoRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", r), this._x = e, this._y = t;
  }, window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoAbs]";
  }, window.SVGPathSegLinetoAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegLinetoAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", r), this._x = e, this._y = t;
  }, window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoRel]";
  }, window.SVGPathSegLinetoRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegLinetoRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicAbs = function(r, e, t, A, n, i, s) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n, this._x2 = i, this._y2 = s;
  }, window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicAbs]";
  }, window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicAbs(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicRel = function(r, e, t, A, n, i, s) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n, this._x2 = i, this._y2 = s;
  }, window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicRel]";
  }, window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicRel(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticAbs = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n;
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticAbs]";
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticAbs(void 0, this._x, this._y, this._x1, this._y1);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticRel = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n;
  }, window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticRel]";
  }, window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticRel(void 0, this._x, this._y, this._x1, this._y1);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegArcAbs = function(r, e, t, A, n, i, s, a) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", r), this._x = e, this._y = t, this._r1 = A, this._r2 = n, this._angle = i, this._largeArcFlag = s, this._sweepFlag = a;
  }, window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcAbs.prototype.toString = function() {
    return "[object SVGPathSegArcAbs]";
  }, window.SVGPathSegArcAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
  }, window.SVGPathSegArcAbs.prototype.clone = function() {
    return new window.SVGPathSegArcAbs(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
  }, Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function() {
    return this._r1;
  }, set: function(r) {
    this._r1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function() {
    return this._r2;
  }, set: function(r) {
    this._r2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function() {
    return this._angle;
  }, set: function(r) {
    this._angle = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function() {
    return this._largeArcFlag;
  }, set: function(r) {
    this._largeArcFlag = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function() {
    return this._sweepFlag;
  }, set: function(r) {
    this._sweepFlag = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegArcRel = function(r, e, t, A, n, i, s, a) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", r), this._x = e, this._y = t, this._r1 = A, this._r2 = n, this._angle = i, this._largeArcFlag = s, this._sweepFlag = a;
  }, window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcRel.prototype.toString = function() {
    return "[object SVGPathSegArcRel]";
  }, window.SVGPathSegArcRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
  }, window.SVGPathSegArcRel.prototype.clone = function() {
    return new window.SVGPathSegArcRel(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
  }, Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function() {
    return this._r1;
  }, set: function(r) {
    this._r1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function() {
    return this._r2;
  }, set: function(r) {
    this._r2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function() {
    return this._angle;
  }, set: function(r) {
    this._angle = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function() {
    return this._largeArcFlag;
  }, set: function(r) {
    this._largeArcFlag = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function() {
    return this._sweepFlag;
  }, set: function(r) {
    this._sweepFlag = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoHorizontalAbs = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", r), this._x = e;
  }, window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoHorizontalAbs]";
  }, window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x;
  }, window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoHorizontalAbs(void 0, this._x);
  }, Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoHorizontalRel = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", r), this._x = e;
  }, window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoHorizontalRel]";
  }, window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x;
  }, window.SVGPathSegLinetoHorizontalRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoHorizontalRel(void 0, this._x);
  }, Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoVerticalAbs = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", r), this._y = e;
  }, window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoVerticalAbs]";
  }, window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._y;
  }, window.SVGPathSegLinetoVerticalAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoVerticalAbs(void 0, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoVerticalRel = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", r), this._y = e;
  }, window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoVerticalRel]";
  }, window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._y;
  }, window.SVGPathSegLinetoVerticalRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoVerticalRel(void 0, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicSmoothAbs = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", r), this._x = e, this._y = t, this._x2 = A, this._y2 = n;
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicSmoothAbs]";
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, this._x, this._y, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicSmoothRel = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", r), this._x = e, this._y = t, this._x2 = A, this._y2 = n;
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicSmoothRel]";
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, this._x, this._y, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticSmoothAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", r), this._x = e, this._y = t;
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticSmoothRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", r), this._x = e, this._y = t;
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathElement.prototype.createSVGPathSegClosePath = function() {
    return new window.SVGPathSegClosePath(void 0);
  }, window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(r, e) {
    return new window.SVGPathSegMovetoAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function(r, e) {
    return new window.SVGPathSegMovetoRel(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(r, e) {
    return new window.SVGPathSegLinetoAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function(r, e) {
    return new window.SVGPathSegLinetoRel(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(r, e, t, A, n, i) {
    return new window.SVGPathSegCurvetoCubicAbs(void 0, r, e, t, A, n, i);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(r, e, t, A, n, i) {
    return new window.SVGPathSegCurvetoCubicRel(void 0, r, e, t, A, n, i);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoQuadraticAbs(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoQuadraticRel(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegArcAbs = function(r, e, t, A, n, i, s) {
    return new window.SVGPathSegArcAbs(void 0, r, e, t, A, n, i, s);
  }, window.SVGPathElement.prototype.createSVGPathSegArcRel = function(r, e, t, A, n, i, s) {
    return new window.SVGPathSegArcRel(void 0, r, e, t, A, n, i, s);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(r) {
    return new window.SVGPathSegLinetoHorizontalAbs(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(r) {
    return new window.SVGPathSegLinetoHorizontalRel(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(r) {
    return new window.SVGPathSegLinetoVerticalAbs(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(r) {
    return new window.SVGPathSegLinetoVerticalRel(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(r, e) {
    return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(r, e) {
    return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, r, e);
  }, "getPathSegAtLength" in window.SVGPathElement.prototype || (window.SVGPathElement.prototype.getPathSegAtLength = function(r) {
    if (r === void 0 || !isFinite(r))
      throw "Invalid arguments.";
    var e = document.createElementNS("http://www.w3.org/2000/svg", "path");
    e.setAttribute("d", this.getAttribute("d"));
    var t = e.pathSegList.numberOfItems - 1;
    if (t <= 0)
      return 0;
    do {
      if (e.pathSegList.removeItem(t), r > e.getTotalLength())
        break;
      t--;
    } while (t > 0);
    return t;
  })), (!("SVGPathSegList" in window) || !("appendItem" in window.SVGPathSegList.prototype)) && (window.SVGPathSegList = function(r) {
    this._pathElement = r, this._list = this._parsePath(this._pathElement.getAttribute("d")), this._mutationObserverConfig = { attributes: !0, attributeFilter: ["d"] }, this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
  }, window.SVGPathSegList.prototype.classname = "SVGPathSegList", Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
    get: function() {
      return this._checkPathSynchronizedToList(), this._list.length;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathSegList.prototype, "length", {
    get: function() {
      return this._checkPathSynchronizedToList(), this._list.length;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
    get: function() {
      return this._pathSegList || (this._pathSegList = new window.SVGPathSegList(this)), this._pathSegList;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), window.SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
    this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
  }, window.SVGPathSegList.prototype._updateListFromPathMutations = function(r) {
    if (this._pathElement) {
      var e = !1;
      r.forEach(function(t) {
        t.attributeName == "d" && (e = !0);
      }), e && (this._list = this._parsePath(this._pathElement.getAttribute("d")));
    }
  }, window.SVGPathSegList.prototype._writeListToPath = function() {
    this._pathElementMutationObserver.disconnect(), this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
  }, window.SVGPathSegList.prototype.segmentChanged = function(r) {
    this._writeListToPath();
  }, window.SVGPathSegList.prototype.clear = function() {
    this._checkPathSynchronizedToList(), this._list.forEach(function(r) {
      r._owningPathSegList = null;
    }), this._list = [], this._writeListToPath();
  }, window.SVGPathSegList.prototype.initialize = function(r) {
    return this._checkPathSynchronizedToList(), this._list = [r], r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype._checkValidIndex = function(r) {
    if (isNaN(r) || r < 0 || r >= this.numberOfItems)
      throw "INDEX_SIZE_ERR";
  }, window.SVGPathSegList.prototype.getItem = function(r) {
    return this._checkPathSynchronizedToList(), this._checkValidIndex(r), this._list[r];
  }, window.SVGPathSegList.prototype.insertItemBefore = function(r, e) {
    return this._checkPathSynchronizedToList(), e > this.numberOfItems && (e = this.numberOfItems), r._owningPathSegList && (r = r.clone()), this._list.splice(e, 0, r), r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype.replaceItem = function(r, e) {
    return this._checkPathSynchronizedToList(), r._owningPathSegList && (r = r.clone()), this._checkValidIndex(e), this._list[e] = r, r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype.removeItem = function(r) {
    this._checkPathSynchronizedToList(), this._checkValidIndex(r);
    var e = this._list[r];
    return this._list.splice(r, 1), this._writeListToPath(), e;
  }, window.SVGPathSegList.prototype.appendItem = function(r) {
    return this._checkPathSynchronizedToList(), r._owningPathSegList && (r = r.clone()), this._list.push(r), r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList._pathSegArrayAsString = function(r) {
    var e = "", t = !0;
    return r.forEach(function(A) {
      t ? (t = !1, e += A._asPathString()) : e += " " + A._asPathString();
    }), e;
  }, window.SVGPathSegList.prototype._parsePath = function(r) {
    if (!r || r.length == 0)
      return [];
    var e = this, t = function() {
      this.pathSegList = [];
    };
    t.prototype.appendSegment = function(a) {
      this.pathSegList.push(a);
    };
    var A = function(a) {
      this._string = a, this._currentIndex = 0, this._endIndex = this._string.length, this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN, this._skipOptionalSpaces();
    };
    A.prototype._isCurrentSpace = function() {
      var a = this._string[this._currentIndex];
      return a <= " " && (a == " " || a == `
` || a == "	" || a == "\r" || a == "\f");
    }, A.prototype._skipOptionalSpaces = function() {
      for (; this._currentIndex < this._endIndex && this._isCurrentSpace(); )
        this._currentIndex++;
      return this._currentIndex < this._endIndex;
    }, A.prototype._skipOptionalSpacesOrDelimiter = function() {
      return this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != "," ? !1 : (this._skipOptionalSpaces() && this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "," && (this._currentIndex++, this._skipOptionalSpaces()), this._currentIndex < this._endIndex);
    }, A.prototype.hasMoreData = function() {
      return this._currentIndex < this._endIndex;
    }, A.prototype.peekSegmentType = function() {
      var a = this._string[this._currentIndex];
      return this._pathSegTypeFromChar(a);
    }, A.prototype._pathSegTypeFromChar = function(a) {
      switch (a) {
        case "Z":
        case "z":
          return window.SVGPathSeg.PATHSEG_CLOSEPATH;
        case "M":
          return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
        case "m":
          return window.SVGPathSeg.PATHSEG_MOVETO_REL;
        case "L":
          return window.SVGPathSeg.PATHSEG_LINETO_ABS;
        case "l":
          return window.SVGPathSeg.PATHSEG_LINETO_REL;
        case "C":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
        case "c":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
        case "Q":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
        case "q":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
        case "A":
          return window.SVGPathSeg.PATHSEG_ARC_ABS;
        case "a":
          return window.SVGPathSeg.PATHSEG_ARC_REL;
        case "H":
          return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
        case "h":
          return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
        case "V":
          return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
        case "v":
          return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
        case "S":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
        case "s":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
        case "T":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
        case "t":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
        default:
          return window.SVGPathSeg.PATHSEG_UNKNOWN;
      }
    }, A.prototype._nextCommandHelper = function(a, o) {
      return (a == "+" || a == "-" || a == "." || a >= "0" && a <= "9") && o != window.SVGPathSeg.PATHSEG_CLOSEPATH ? o == window.SVGPathSeg.PATHSEG_MOVETO_ABS ? window.SVGPathSeg.PATHSEG_LINETO_ABS : o == window.SVGPathSeg.PATHSEG_MOVETO_REL ? window.SVGPathSeg.PATHSEG_LINETO_REL : o : window.SVGPathSeg.PATHSEG_UNKNOWN;
    }, A.prototype.initialCommandIsMoveTo = function() {
      if (!this.hasMoreData())
        return !0;
      var a = this.peekSegmentType();
      return a == window.SVGPathSeg.PATHSEG_MOVETO_ABS || a == window.SVGPathSeg.PATHSEG_MOVETO_REL;
    }, A.prototype._parseNumber = function() {
      var a = 0, o = 0, l = 1, u = 0, c = 1, f = 1, h = this._currentIndex;
      if (this._skipOptionalSpaces(), this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, c = -1), !(this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")) {
        for (var g = this._currentIndex; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
          this._currentIndex++;
        if (this._currentIndex != g)
          for (var p = this._currentIndex - 1, v = 1; p >= g; )
            o += v * (this._string.charAt(p--) - "0"), v *= 10;
        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
          if (this._currentIndex++, this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return;
          for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
            l *= 10, u += (this._string.charAt(this._currentIndex) - "0") / l, this._currentIndex += 1;
        }
        if (this._currentIndex != h && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
          if (this._currentIndex++, this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, f = -1), this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return;
          for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
            a *= 10, a += this._string.charAt(this._currentIndex) - "0", this._currentIndex++;
        }
        var w = o + u;
        if (w *= c, a && (w *= Math.pow(10, f * a)), h != this._currentIndex)
          return this._skipOptionalSpacesOrDelimiter(), w;
      }
    }, A.prototype._parseArcFlag = function() {
      if (!(this._currentIndex >= this._endIndex)) {
        var a = !1, o = this._string.charAt(this._currentIndex++);
        if (o == "0")
          a = !1;
        else if (o == "1")
          a = !0;
        else
          return;
        return this._skipOptionalSpacesOrDelimiter(), a;
      }
    }, A.prototype.parseSegment = function() {
      var a = this._string[this._currentIndex], o = this._pathSegTypeFromChar(a);
      if (o == window.SVGPathSeg.PATHSEG_UNKNOWN) {
        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN || (o = this._nextCommandHelper(a, this._previousCommand), o == window.SVGPathSeg.PATHSEG_UNKNOWN))
          return null;
      } else
        this._currentIndex++;
      switch (this._previousCommand = o, o) {
        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
          return new window.SVGPathSegMovetoRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
          return new window.SVGPathSegMovetoAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_REL:
          return new window.SVGPathSegLinetoRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
          return new window.SVGPathSegLinetoAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
          return new window.SVGPathSegLinetoHorizontalRel(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
          return new window.SVGPathSegLinetoHorizontalAbs(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
          return new window.SVGPathSegLinetoVerticalRel(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
          return new window.SVGPathSegLinetoVerticalAbs(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
          return this._skipOptionalSpaces(), new window.SVGPathSegClosePath(e);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicRel(e, l.x, l.y, l.x1, l.y1, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicAbs(e, l.x, l.y, l.x1, l.y1, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
          var l = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicSmoothRel(e, l.x, l.y, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
          var l = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicSmoothAbs(e, l.x, l.y, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoQuadraticRel(e, l.x, l.y, l.x1, l.y1);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoQuadraticAbs(e, l.x, l.y, l.x1, l.y1);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
          return new window.SVGPathSegCurvetoQuadraticSmoothRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
          return new window.SVGPathSegCurvetoQuadraticSmoothAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_ARC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegArcRel(e, l.x, l.y, l.x1, l.y1, l.arcAngle, l.arcLarge, l.arcSweep);
        case window.SVGPathSeg.PATHSEG_ARC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegArcAbs(e, l.x, l.y, l.x1, l.y1, l.arcAngle, l.arcLarge, l.arcSweep);
        default:
          throw "Unknown path seg type.";
      }
    };
    var n = new t(), i = new A(r);
    if (!i.initialCommandIsMoveTo())
      return [];
    for (; i.hasMoreData(); ) {
      var s = i.parseSegment();
      if (!s)
        return [];
      n.appendSegment(s);
    }
    return n.pathSegList;
  }));
})();
class ni {
  static #e(e) {
    const t = Number(e);
    return Number.isFinite(t) ? Math.min(100, Math.max(0, t)) : 100;
  }
  static #t(e) {
    if (e == null) return null;
    const t = String(e).trim();
    return t ? t === "none" ? "none" : t.startsWith("#") ? t.slice(1) : t : null;
  }
  static #r(e) {
    if (!e) return null;
    const t = String(e).trim();
    if (!t) return null;
    if (t.startsWith("#")) return t.slice(1);
    const A = t.match(/url\(\s*['"]?#([^'")\s]+)['"]?\s*\)/);
    if (A?.[1]) return A[1];
    const n = t.lastIndexOf("#");
    return n >= 0 && n < t.length - 1 ? t.slice(n + 1) : null;
  }
  static #A(e) {
    if (!e?.cloneNode) return null;
    const t = e.ownerDocument || document, A = /* @__PURE__ */ new Set(), n = e.cloneNode(!0);
    let i = ni.#r(
      n.getAttribute("href") || n.getAttribute("xlink:href")
    );
    for (; i && !A.has(i); ) {
      A.add(i);
      const s = t.getElementById(i);
      if (!s?.getAttribute) break;
      const a = String(n.tagName || "").toLowerCase(), o = String(s.tagName || "").toLowerCase();
      if (!["lineargradient", "radialgradient"].includes(o) || o !== a)
        break;
      for (const l of s.attributes || []) {
        const u = l.name;
        if (u === "id" || u === "href" || u === "xlink:href") continue;
        const c = n.getAttribute(u);
        (c === null || c === "") && n.setAttribute(u, l.value);
      }
      if (n.querySelectorAll("stop").length === 0)
        for (const l of s.querySelectorAll?.("stop") || [])
          n.append(l.cloneNode(!0));
      i = ni.#r(
        s.getAttribute("href") || s.getAttribute("xlink:href")
      );
    }
    return n.removeAttribute("href"), n.removeAttribute("xlink:href"), n;
  }
  /**
   * @param {module:jGraduate.jGraduatePaintOptions} [opt]
   */
  constructor(e) {
    const t = e || {};
    if (this.alpha = ni.#e(t.alpha), t.copy)
      switch (this.type = t.copy.type, this.alpha = ni.#e(t.copy.alpha), this.solidColor = null, this.linearGradient = null, this.radialGradient = null, this.type) {
        case "none":
          break;
        case "solidColor":
          this.solidColor = ni.#t(t.copy.solidColor);
          break;
        case "linearGradient":
          this.linearGradient = t.copy.linearGradient?.cloneNode ? t.copy.linearGradient.cloneNode(!0) : null;
          break;
        case "radialGradient":
          this.radialGradient = t.copy.radialGradient?.cloneNode ? t.copy.radialGradient.cloneNode(!0) : null;
          break;
      }
    else t.linearGradient ? (this.type = "linearGradient", this.solidColor = null, this.radialGradient = null, this.linearGradient = ni.#A(t.linearGradient)) : t.radialGradient ? (this.type = "radialGradient", this.solidColor = null, this.linearGradient = null, this.radialGradient = ni.#A(t.radialGradient)) : t.solidColor ? (this.type = "solidColor", this.solidColor = ni.#t(t.solidColor)) : (this.type = "none", this.solidColor = null, this.linearGradient = null, this.radialGradient = null);
  }
}
const R4 = {
  prefix: "[SVGCanvas]"
}, bS = (r, e = "") => {
  const t = e ? ` [${e}]` : "";
  return `${R4.prefix}${t} ${r}`;
}, Ro = (r, e, t = "") => {
  console.error(bS(r, t)), e && console.error(e);
}, kA = (r, e, t = "") => {
  console.warn(bS(r, t)), e !== void 0 && console.warn(e);
};
const H1 = "http://www.w3.org/2000/svg", BS = ["x", "x1", "cx", "rx", "width"], CS = ["y", "y1", "cy", "ry", "height"], k4 = ["r", "radius", ...BS, ...CS];
let To, lu = {};
const H4 = (r) => {
  To = r;
  const e = document.createElementNS(H1, "svg");
  document.body.append(e);
  const t = document.createElementNS(H1, "rect");
  t.setAttribute("width", "1em"), t.setAttribute("height", "1ex"), t.setAttribute("x", "1in"), e.append(t);
  const A = t.getBBox();
  e.remove();
  const n = A.x;
  lu = {
    em: A.width,
    ex: A.height,
    in: n,
    cm: n / 2.54,
    mm: n / 25.4,
    pt: n / 72,
    pc: n / 6,
    px: 1,
    "%": 0
  };
}, Ym = () => lu, Cn = (r) => {
  const e = To.getRoundDigits();
  return isNaN(r) ? Array.isArray(r) ? `${Cn(r[0])},${Cn(r[1])}` : Number.parseFloat(r).toFixed(e) - 0 : Number(Number(r).toFixed(e));
}, mh = (r, e) => (e = e || To.getBaseUnit(), Cn(r / lu[e])), D4 = (r, e, t) => {
  r.setAttribute(e, t);
}, yr = (r, e) => {
  if (!isNaN(e))
    return e - 0;
  if (e.substr(-1) === "%") {
    const n = e.substr(0, e.length - 1) / 100, i = To.getWidth(), s = To.getHeight();
    return BS.includes(r) ? n * i : CS.includes(r) ? n * s : n * Math.sqrt(i * i + s * s) / Math.sqrt(2);
  }
  const t = e.slice(-2);
  return e.slice(0, -2) * lu[t];
}, G4 = (r, e, t) => {
  if (k4.includes(r))
    return isNaN(e) ? (e = e.toLowerCase(), Object.keys(lu).some((A) => new RegExp(`^-?[\\d\\.]+${A}$`).test(e))) : !0;
  if (r === "id") {
    let A = !1;
    try {
      const n = To.getElement(e);
      A = !n || n === t;
    } catch (n) {
      Ro("Error getting element by ID", n, "units");
    }
    return A;
  }
  return !0;
};
const et = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATH: "http://www.w3.org/1998/Math/MathML",
  SE: "http://svg-edit.googlecode.com",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  OI: "http://www.optimistik.fr/namespace/svg/OIdata",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
  // see http://www.w3.org/TR/REC-xml-names/#xmlReserved
  // SODIPODI: 'http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd',
  // INKSCAPE: 'http://www.inkscape.org/namespaces/inkscape',
  // RDF: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  // OSB: 'http://www.openswatchbook.org/uri/2009/osb',
  // CC: 'http://creativecommons.org/ns#',
  // DC: 'http://purl.org/dc/elements/1.1/'
}, SS = () => {
  const r = {};
  for (const [e, t] of Object.entries(et))
    r[t] = e.toLowerCase();
  return r;
};
const Ca = 1e-10, si = document.createElementNS(et.SVG, "svg"), D1 = (r) => {
  const e = (t) => {
    const A = si.createSVGMatrix();
    return Object.assign(A, {
      a: t.a,
      b: t.b,
      c: t.c,
      d: t.d,
      e: t.e,
      f: t.f
    }), A;
  };
  try {
    return si.createSVGTransformFromMatrix(r);
  } catch {
    const A = si.createSVGTransform();
    try {
      return A.setMatrix(r), A;
    } catch {
      try {
        return si.createSVGTransformFromMatrix(e(r));
      } catch {
        return A.setMatrix(e(r)), A;
      }
    }
  }
}, Rt = (r, e, t) => ({
  x: t.a * r + t.c * e + t.e,
  y: t.b * r + t.d * e + t.f
}), jt = (r) => {
  if (r.transform?.baseVal)
    return r.transform.baseVal;
  if (r.gradientTransform?.baseVal)
    return r.gradientTransform.baseVal;
  if (r.patternTransform?.baseVal)
    return r.patternTransform.baseVal;
  kA("No transform list found. Check browser compatibility.", r, "math");
}, xS = (r) => Math.abs(r.a - 1) < Ca && Math.abs(r.b) < Ca && Math.abs(r.c) < Ca && Math.abs(r.d - 1) < Ca && Math.abs(r.e) < Ca && Math.abs(r.f) < Ca, dA = (...r) => {
  if (r.length === 0)
    return si.createSVGMatrix();
  const e = (A) => {
    const n = ["a", "b", "c", "d", "e", "f"];
    for (const i of n)
      Math.abs(A[i]) < Ca && (A[i] = 0);
    return A;
  };
  if (typeof DOMMatrix == "function" && typeof DOMMatrix.fromMatrix == "function") {
    const A = r.reduce(
      (i, s) => i.multiply(DOMMatrix.fromMatrix(s)),
      new DOMMatrix()
    ), n = si.createSVGMatrix();
    return Object.assign(n, {
      a: A.a,
      b: A.b,
      c: A.c,
      d: A.d,
      e: A.e,
      f: A.f
    }), e(n);
  }
  let t = si.createSVGMatrix();
  for (const A of r) {
    const n = si.createSVGMatrix();
    Object.assign(n, {
      a: t.a * A.a + t.c * A.b,
      b: t.b * A.a + t.d * A.b,
      c: t.a * A.c + t.c * A.d,
      d: t.b * A.c + t.d * A.d,
      e: t.a * A.e + t.c * A.f + t.e,
      f: t.b * A.e + t.d * A.f + t.f
    }), t = n;
  }
  return e(t);
}, Ra = (r) => {
  if (!r) return !1;
  for (let e = 0; e < r.numberOfItems; e++) {
    const t = r.getItem(e);
    if (t.type === SVGTransform.SVG_TRANSFORM_MATRIX && !xS(t.matrix))
      return !0;
  }
  return !1;
}, $m = (r, e, t, A, n) => {
  const i = Rt(r, e, n), s = Rt(r + t, e, n), a = Rt(r, e + A, n), o = Rt(r + t, e + A, n), l = Math.min(i.x, s.x, a.x, o.x), u = Math.max(i.x, s.x, a.x, o.x), c = Math.min(i.y, s.y, a.y, o.y), f = Math.max(i.y, s.y, a.y, o.y);
  return {
    tl: i,
    tr: s,
    bl: a,
    br: o,
    aabox: {
      x: l,
      y: c,
      width: u - l,
      height: f - c
    }
  };
}, Ht = (r, e = 0, t = null) => {
  if (!r)
    return D1(si.createSVGMatrix());
  const A = Number.parseInt(e, 10), n = Number.parseInt(t ?? r.numberOfItems - 1, 10), [i, s] = [Math.min(A, n), Math.max(A, n)], a = [];
  for (let u = i; u <= s; u++) {
    const c = u >= 0 && u < r.numberOfItems ? r.getItem(u).matrix : si.createSVGMatrix();
    a.push(c);
  }
  const o = dA(...a), l = si.createSVGMatrix();
  return Object.assign(l, {
    a: o.a,
    b: o.b,
    c: o.c,
    d: o.d,
    e: o.e,
    f: o.f
  }), D1(l);
}, Jm = (r) => {
  const e = jt(r);
  return Ht(e).matrix;
}, K0 = (r, e, t, A) => {
  const n = Math.PI / 4, i = t - r, s = A - e, a = Math.atan2(s, i), o = Math.hypot(i, s), l = Math.round(a / n) * n;
  return {
    x: r + o * Math.cos(l),
    y: e + o * Math.sin(l),
    a: l
  };
}, ES = (r, e) => e.x < r.x + r.width && e.x + e.width > r.x && e.y < r.y + r.height && e.y + e.height > r.y, V4 = (r) => {
  let e = 0, t = 0;
  if (r?.offsetParent) {
    let A = r;
    do
      e += A.offsetLeft, t += A.offsetTop, A = A.offsetParent;
    while (A);
  }
  return { left: e, top: t };
}, Yf = (r) => r && typeof r == "object" && !Array.isArray(r), uu = (r, e) => {
  const t = { ...r };
  if (Yf(r) && Yf(e))
    for (const A of Object.keys(e))
      Yf(e[A]) ? t[A] = A in r ? uu(r[A], e[A]) : e[A] : t[A] = e[A];
  return t;
}, cu = (r, e) => {
  if (r?.closest)
    try {
      return r.closest(e);
    } catch {
    }
  const t = {
    ".": (i, s) => i.classList?.contains(s.slice(1)),
    "#": (i, s) => i.id === s.slice(1),
    "[": (i, s) => {
      const [a, o] = s.slice(1, -1).split("=").map((l) => l.replace(/["']/g, ""));
      return o ? i.getAttribute(a) === o : i.hasAttribute(a);
    },
    tag: (i, s) => i.tagName?.toLowerCase() === s
  }, A = e.charAt(0), n = t[A] || t.tag;
  for (let i = r; i && i !== document && i.nodeType === 1; i = i.parentNode)
    if (n(i, e)) return i;
  return null;
}, hu = (r, e) => {
  const t = [], A = {
    ".": (s, a) => s.classList?.contains(a.slice(1)),
    "#": (s, a) => s.id === a.slice(1),
    "[": (s, a) => s.hasAttribute(a.slice(1, -1)),
    tag: (s, a) => s.tagName?.toLowerCase() === a
  }, n = e?.charAt(0), i = e ? A[n] || A.tag : null;
  for (let s = r; s && s !== document; s = s.parentNode)
    (!e || i(s, e)) && t.push(s);
  return t.length > 0 ? t : null;
}, K4 = (r, e, t) => {
  const A = [], n = {
    ".": (a, o) => a.classList?.contains(o.slice(1)),
    "#": (a, o) => a.id === o.slice(1),
    "[": (a, o) => a.hasAttribute(o.slice(1, -1)),
    tag: (a, o) => a.tagName?.toLowerCase() === o
  }, i = (a) => {
    if (!a) return null;
    const o = a.charAt(0);
    return n[o] || n.tag;
  }, s = i(e);
  i(t);
  for (let a = r; a && a !== document && !s?.(a, e); a = a.parentNode)
    A.push(a);
  return A.length > 0 ? A : null;
};
const j4 = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use,clipPath", q4 = j4.split(",");
let as = null, FS = null;
const z4 = (r) => {
  as = r, FS = r.getSvgRoot();
}, Gl = (r) => {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;"
    // Note: `&apos;` is XML only
  };
  return r.replace(/[&<>"']/g, (t) => e[t]);
}, _S = (r) => {
  const e = Y4(r);
  return window.btoa(e);
}, US = (r) => X4(window.atob(r)), W4 = (r) => {
  if (r.length === 0) return 0;
  let e = 0;
  for (let t = 0; t < r.length; t++) {
    const A = r.charCodeAt(t);
    e = (e << 5) - e + A | 0;
  }
  return e;
}, X4 = (r) => decodeURIComponent(escape(r)), Y4 = (r) => unescape(encodeURIComponent(r)), $4 = (r) => !r || typeof URL > "u" || !URL.createObjectURL ? "" : URL.createObjectURL(r), J4 = (() => {
  if (typeof Blob > "u")
    return "";
  const r = new Blob(
    ["<html><head><title>SVG-edit</title></head><body>&nbsp;</body></html>"],
    { type: "text/html" }
  );
  return $4(r);
})(), Zm = (r) => {
  let e = r;
  e.includes("<svg:svg") && (e = e.replace(/<(\/?)svg:/g, "<$1").replace("xmlns:svg", "xmlns"));
  let t;
  try {
    t = new DOMParser(), t.async = !1;
  } catch {
    throw new Error("XML Parser could not be instantiated");
  }
  try {
    return t.parseFromString(e, "text/xml");
  } catch (A) {
    throw new Error(`Error parsing XML string: ${A.message}`);
  }
}, Z4 = ({ x: r, y: e, width: t, height: A }) => ({ x: r, y: e, width: t, height: A }), os = (r, e) => {
  if (r?.nodeType === 1) {
    e(r);
    let t = r.childNodes.length;
    for (; t--; )
      os(r.childNodes.item(t), e);
  }
}, e_ = (r, e) => {
  if (r?.nodeType === 1) {
    let t = r.childNodes.length;
    for (; t--; )
      os(r.childNodes.item(t), e);
    e(r);
  }
}, eu = (r) => {
  if (!r?.startsWith("url(")) return null;
  const e = [
    { start: 'url("', end: '"', offset: 5 },
    { start: "url('", end: "'", offset: 5 },
    { start: "url(", end: ")", offset: 4 }
  ];
  for (const { start: t, end: A, offset: n } of e)
    if (r.startsWith(t)) {
      const i = r.indexOf(A, n + 1);
      return i > 0 ? r.substring(n, i) : null;
    }
  return null;
};
let Ei = (r) => r.getAttribute("href") ?? r.getAttributeNS(et.XLINK, "href"), Dn = (r, e) => {
  r.setAttribute("href", e);
};
const an = () => {
  const r = as.getSvgContent(), e = r.getElementsByTagNameNS(et.SVG, "defs");
  if (e.length > 0)
    return e[0];
  const t = r.ownerDocument.createElementNS(et.SVG, "defs"), A = r.firstChild?.nextSibling;
  return A ? r.insertBefore(t, A) : r.append(t), t;
}, Ir = (r) => {
  const e = r ?? as.getSelectedElements()[0];
  if (r.nodeType !== 1) return null;
  const t = e.nodeName;
  let A = null;
  switch (t) {
    case "text":
      e.textContent === "" ? (e.textContent = "a", A = e.getBBox(), e.textContent = "") : e.getBBox && (A = e.getBBox());
      break;
    case "path":
    case "g":
    case "a":
      e.getBBox && (A = e.getBBox());
      break;
    default:
      if (t === "use")
        A = e.getBBox();
      else if (q4.includes(t))
        if (e)
          try {
            A = e.getBBox();
          } catch {
            const i = e.getExtentOfChar(0), s = e.getComputedTextLength();
            A = {
              x: i.x,
              y: i.y,
              width: s,
              height: i.height
            };
          }
        else {
          const n = cu(e.parentNode, "foreignObject");
          n.length && n[0].getBBox && (A = n[0].getBBox());
        }
  }
  if (A) {
    if (A.width === 0 && A.height === 0) {
      const n = t.toLowerCase(), i = (a, o = 0) => Number.parseFloat(e.getAttribute(a) ?? o), s = (() => {
        switch (n) {
          case "path": {
            const o = ((e.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((l) => !Number.isNaN(l));
            if (o.length >= 2) {
              const l = o.filter((c, f) => f % 2 === 0), u = o.filter((c, f) => f % 2 === 1);
              return {
                x: Math.min(...l),
                y: Math.min(...u),
                width: Math.max(...l) - Math.min(...l),
                height: Math.max(...u) - Math.min(...u)
              };
            }
            break;
          }
          case "rect":
            return { x: i("x"), y: i("y"), width: i("width"), height: i("height") };
          case "line": {
            const a = i("x1"), o = i("x2"), l = i("y1"), u = i("y2");
            return { x: Math.min(a, o), y: Math.min(l, u), width: Math.abs(o - a), height: Math.abs(u - l) };
          }
          case "g": {
            const a = Array.from(e.children || []).map((o) => Ir(o)).filter(Boolean);
            if (a.length) {
              const o = Math.min(...a.map((f) => f.x)), l = Math.min(...a.map((f) => f.y)), u = Math.max(...a.map((f) => f.x + f.width)), c = Math.max(...a.map((f) => f.y + f.height));
              return { x: o, y: l, width: u - o, height: c - l };
            }
            break;
          }
        }
      })();
      s && (A = s);
    }
    A = Z4(A);
  }
  return A;
}, $f = (r) => r.map(([e, t]) => {
  const A = [];
  for (let n = 0; n < t.length; n += 2)
    A.push(`${t[n]},${t[n + 1]}`);
  return e + A.join(" ");
}).join(" "), IS = (r) => {
  let e = 1.81, t, A, n;
  switch (r.tagName) {
    case "ellipse":
    case "circle": {
      A = Number(r.getAttribute("rx")), n = Number(r.getAttribute("ry"));
      const i = Number(r.getAttribute("cx")), s = Number(r.getAttribute("cy"));
      r.tagName === "circle" && r.hasAttribute("r") && (n = Number(r.getAttribute("r")), A = n), t = $f([
        ["M", [i - A, s]],
        ["C", [i - A, s - n / e, i - A / e, s - n, i, s - n]],
        ["C", [i + A / e, s - n, i + A, s - n / e, i + A, s]],
        ["C", [i + A, s + n / e, i + A / e, s + n, i, s + n]],
        ["C", [i - A / e, s + n, i - A, s + n / e, i - A, s]],
        ["Z", []]
      ]);
      break;
    }
    case "path":
      t = r.getAttribute("d");
      break;
    case "line": {
      const i = r.getAttribute("x1"), s = r.getAttribute("y1"), a = r.getAttribute("x2"), o = r.getAttribute("y2");
      t = `M${i},${s}L${a},${o}`;
      break;
    }
    case "polyline":
      t = `M${r.getAttribute("points")}`;
      break;
    case "polygon":
      t = `M${r.getAttribute("points")} Z`;
      break;
    case "rect": {
      A = Number(r.getAttribute("rx")), n = Number(r.getAttribute("ry"));
      const i = r.getBBox(), { x: s, y: a } = i, o = i.width, l = i.height;
      e = 4 - e, t = $f(!A && !n ? [
        ["M", [s, a]],
        ["L", [s + o, a]],
        ["L", [s + o, a + l]],
        ["L", [s, a + l]],
        ["L", [s, a]],
        ["Z", []]
      ] : [
        ["M", [s, a + n]],
        ["C", [s, a + n / e, s + A / e, a, s + A, a]],
        ["L", [s + o - A, a]],
        ["C", [s + o - A / e, a, s + o, a + n / e, s + o, a + n]],
        ["L", [s + o, a + l - n]],
        [
          "C",
          [
            s + o,
            a + l - n / e,
            s + o - A / e,
            a + l,
            s + o - A,
            a + l
          ]
        ],
        ["L", [s + A, a + l]],
        ["C", [s + A / e, a + l, s, a + l - n / e, s, a + l - n]],
        ["L", [s, a + n]],
        ["Z", []]
      ]);
      break;
    }
  }
  return t;
}, QS = (r) => ["marker-start", "marker-end", "marker-mid", "filter", "clip-path"].reduce((t, A) => {
  const n = r.getAttribute(A);
  return n && (t[A] = n), t;
}, {}), j0 = (r, e, t) => {
  const A = e({
    element: "path",
    attr: QS(r)
  }), n = r.getAttribute("transform");
  n && A.setAttribute("transform", n);
  const { parentNode: i } = r;
  r.nextSibling ? r.before(A) : i.append(A);
  const s = IS(r);
  s ? A.setAttribute("d", s) : A.remove(), t.resetOrientation(A);
  let a = !1;
  try {
    a = A.getBBox();
  } catch {
  }
  if (a && a.width === 0 && a.height === 0) {
    const l = ((A.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((u) => !Number.isNaN(u));
    if (l.length >= 2) {
      const u = l.filter((f, h) => h % 2 === 0), c = l.filter((f, h) => h % 2 === 1);
      a = {
        x: Math.min(...u),
        y: Math.min(...c),
        width: Math.max(...u) - Math.min(...u),
        height: Math.max(...c) - Math.min(...c)
      };
    }
  }
  return A.remove(), a;
}, t_ = (r, e, t) => {
  const A = new t.history.BatchCommand("Convert element to Path");
  e = uu(e, QS(r));
  const n = t.addSVGElementsFromJson({
    element: "path",
    attr: e
  }), i = r.getAttribute("transform");
  i && n.setAttribute("transform", i);
  const { id: s } = r, { parentNode: a } = r;
  r.nextSibling ? r.before(n) : a.append(n);
  const o = IS(r);
  if (o) {
    if (n.setAttribute("d", o), i) {
      const u = jt(n);
      Ra(u) && t.pathActions.resetOrientation(n);
    }
    const { nextSibling: l } = r;
    return A.addSubCommand(
      new t.history.RemoveElementCommand(
        r,
        l,
        r.parentNode
      )
    ), t.clearSelection(), r.remove(), A.addSubCommand(new t.history.InsertElementCommand(n)), n.setAttribute("id", s), n.removeAttribute("visibility"), t.addToSelection([n], !0), t.addCommandToHistory(A), n;
  }
  return n.remove(), null;
}, r_ = (r, e) => {
  const t = r % 90, A = t < -89.99 || t > 89.99, n = t > -1e-3 && t < 1e-3;
  return e || !(n || A);
}, G1 = (r, e, t) => {
  let A = Ir(r);
  if (!A) return null;
  const n = r.getAttribute?.("transform") ?? "", i = n.includes("matrix(");
  if (n.includes("rotate(") && !i) {
    const l = n.match(/-?\d*\.?\d+/g)?.map(Number) || [], [u = 0, c = 0, f = 0] = l, h = u * Math.PI / 180, g = Math.cos(h), p = Math.sin(h), v = r.tagName?.toLowerCase();
    let w = [];
    if (v === "path") {
      const S = ((r.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((B) => !Number.isNaN(B));
      for (let B = 0; B < S.length; B += 2)
        w.push({ x: S[B], y: S[B + 1] ?? 0 });
    } else if (v === "rect") {
      const b = Number(r.getAttribute("x") ?? 0), S = Number(r.getAttribute("y") ?? 0), B = Number(r.getAttribute("width") ?? 0), x = Number(r.getAttribute("height") ?? 0);
      w = [
        { x: b, y: S },
        { x: b + B, y: S },
        { x: b, y: S + x },
        { x: b + B, y: S + x }
      ];
    }
    if (w.length) {
      const b = w.map((N) => {
        const _ = N.x - c, R = N.y - f;
        return {
          x: c + (_ * g - R * p),
          y: f + (_ * p + R * g)
        };
      }), S = b.map((N) => N.x), B = b.map((N) => N.y);
      let x = {
        x: Math.min(...S),
        y: Math.min(...B),
        width: Math.max(...S) - Math.min(...S),
        height: Math.max(...B) - Math.min(...B)
      };
      const U = n.match(/matrix\(([^)]+)\)/);
      if (U) {
        const N = U[1].split(/[,\s]+/).filter(Boolean).map(Number), _ = N[4] ?? 0, R = N[5] ?? 0;
        x = { ...x, x: x.x + _, y: x.y + R };
      }
      const Q = Math.abs(u % 90) < 1e-3;
      return v !== "path" && Q && typeof e == "function" && e({ element: "path", attr: {} }), x;
    }
  }
  const s = jt(r), a = NS(s), o = Ra(s);
  if (a || o) {
    let l = !1;
    if (r_(a, o)) {
      if (["ellipse", "path", "line", "polyline", "polygon"].includes(r.tagName)) {
        const c = j0(
          r,
          e,
          t
        );
        c && !(c.width === 0 && c.height === 0) && (l = c, A = c);
      } else if (r.tagName === "rect") {
        const c = Number(r.getAttribute("rx")), f = Number(r.getAttribute("ry"));
        if (c || f) {
          const h = j0(
            r,
            e,
            t
          );
          h && !(h.width === 0 && h.height === 0) && (l = h, A = h);
        }
      }
    }
    if (!l) {
      const { matrix: u } = Ht(s);
      A = $m(A.x, A.y, A.width, A.height, u).aabox;
    }
  }
  return A;
}, V1 = (r) => {
  const e = r.getAttribute("stroke-width");
  return !isNaN(e) && r.getAttribute("stroke") !== "none" ? e / 2 : 0;
}, LS = (r, e, t) => {
  if (!r || !r.length)
    return !1;
  let A;
  if (r.forEach((o) => {
    A || o.parentNode && (A = G1(o, e, t));
  }), !A)
    return null;
  let n = A.x + A.width, i = A.y + A.height, s = A.x, a = A.y;
  if (r.length === 1) {
    const o = V1(r[0]);
    s -= o, a -= o, n += o, i += o;
  } else
    r.forEach((o) => {
      const l = G1(
        o,
        e,
        t
      );
      if (l) {
        const u = V1(o);
        s = Math.min(s, l.x - u), a = Math.min(a, l.y - u), o.nodeType === 1 && (n = Math.max(n, l.x + l.width + u), i = Math.max(i, l.y + l.height + u));
      }
    });
  return A.x = Cn(s), A.y = Cn(a), A.width = Cn(n - s), A.height = Cn(i - a), A;
}, fu = (r) => {
  if (!r) {
    const t = as.getSvgContent();
    for (let A = 0; A < t.children.length; A++)
      if (t.children[A].getBBox) {
        const n = t.children[A].getBBox();
        if (n.width !== 0 && n.height !== 0 && n.width !== 0 && n.height !== 0) {
          r = t.children[A];
          break;
        }
      }
  }
  const e = [];
  if (r) {
    const t = r.children;
    Array.from(t, (A) => {
      A.getBBox && e.push(A);
    });
  }
  return e.reverse();
}, Hn = (r) => (r || (r = fu()), LS(
  r,
  as.addSVGElementsFromJson,
  as.pathActions
)), NS = (r, e) => {
  if (!r)
    return 0;
  for (let t = 0; t < r.numberOfItems; ++t) {
    const A = r.getItem(t);
    if (A.type === 4)
      return e ? A.angle * Math.PI / 180 : A.angle;
  }
  return 0;
};
let bA = (r, e) => {
  const t = r || as.getSelectedElements()[0], A = jt(t);
  return NS(A, e);
};
const qs = (r) => {
  if (!r) return null;
  const e = eu(r);
  if (!e) return null;
  const t = e[0] === "#" ? e.slice(1) : e;
  return Jt(t);
}, q0 = (r) => {
  if (r?.firstChild?.tagName === "feGaussianBlur")
    return r.firstChild;
  {
    const e = r.children;
    for (const [t, A] of Object.entries(e))
      if (A.tagName === "feGaussianBlur")
        return A;
  }
  return null;
}, Jt = (r) => FS.querySelector(`#${r}`), Yt = (r, e, t, A) => {
  for (const [n, i] of Object.entries(e)) {
    const s = n.startsWith("xml:") ? et.XML : n.startsWith("xlink:") ? et.XLINK : null;
    if (i === void 0) {
      s ? r.removeAttributeNS(s, n) : r.removeAttribute(n);
      continue;
    }
    s ? r.setAttributeNS(s, n, i) : A ? D4(r, n, i) : r.setAttribute(n, i);
  }
}, Rh = (r) => {
  const e = {
    "fill-opacity": 1,
    "stop-opacity": 1,
    opacity: 1,
    stroke: "none",
    "stroke-dasharray": "none",
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    "stroke-opacity": 1,
    "stroke-width": 1,
    rx: 0,
    ry: 0
  };
  r.nodeName === "ellipse" && (delete e.rx, delete e.ry), Object.entries(e).forEach(([t, A]) => {
    r.getAttribute(t) === String(A) && r.removeAttribute(t);
  });
}, Ot = (r) => {
  const e = as.getBaseUnit();
  let t = as.getSnappingStep();
  return e !== "px" && (t *= Ym()[e]), r = Math.round(r / t) * t, r;
}, ev = (r) => {
  vh(r, (e) => {
    e.preventDefault();
  });
}, TS = (r) => new DOMParser().parseFromString(r, "text/html").body.firstChild, A_ = (r, e, t = 0) => {
  const A = TS(e);
  t >= r.children.length ? r.appendChild(A) : r.insertBefore(A, r.children[t]);
}, PS = (r) => document.getElementById(r), OS = (r) => document.querySelector(r), MS = (r) => [...document.querySelectorAll(r)], vh = (r, e) => {
  r.addEventListener("click", e), r.addEventListener("touchend", e);
};
const Il = {
  BEFORE_APPLY: "before_apply",
  AFTER_APPLY: "after_apply",
  BEFORE_UNAPPLY: "before_unapply",
  AFTER_UNAPPLY: "after_unapply"
};
class ko {
  /**
  * @returns {string}
  */
  getText() {
    return this.text;
  }
  /**
   * @param {module:history.HistoryEventHandler} handler
   * @param {callback} applyFunction
   * @returns {void}
  */
  apply(e, t) {
    e && e.handleHistoryEvent(Il.BEFORE_APPLY, this), t(e), e && e.handleHistoryEvent(Il.AFTER_APPLY, this);
  }
  /**
   * @param {module:history.HistoryEventHandler} handler
   * @param {callback} unapplyFunction
   * @returns {void}
  */
  unapply(e, t) {
    e && e.handleHistoryEvent(Il.BEFORE_UNAPPLY, this), t(), e && e.handleHistoryEvent(Il.AFTER_UNAPPLY, this);
  }
  /**
   * @returns {Element[]} Array with element associated with this command
   * This function needs to be surcharged if multiple elements are returned.
  */
  elements() {
    return [this.elem];
  }
  /**
    * @returns {string} String with element associated with this command
  */
  type() {
    return this.constructor.name;
  }
}
let RS = class extends ko {
  /**
  * @param {Element} elem - The DOM element that was moved
  * @param {Element} oldNextSibling - The element's next sibling before it was moved
  * @param {Element} oldParent - The element's parent before it was moved
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e, t, A, n) {
    super(), this.elem = e, this.text = n ? `Move ${e.tagName} to ${n}` : `Move ${e.tagName}`, this.oldNextSibling = t, this.oldParent = A, this.newNextSibling = e.nextSibling, this.newParent = e.parentNode;
  }
  /**
   * Re-positions the element.
   * @param {module:history.HistoryEventHandler} handler
   * @fires module:history~Command#event:history
   * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      const t = this.newNextSibling && this.newNextSibling.parentNode === this.newParent ? this.newNextSibling : null;
      this.elem = this.newParent.insertBefore(this.elem, t);
    });
  }
  /**
   * Positions the element back to its original location.
   * @param {module:history.HistoryEventHandler} handler
   * @fires module:history~Command#event:history
   * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      const t = this.oldNextSibling && this.oldNextSibling.parentNode === this.oldParent ? this.oldNextSibling : null;
      this.elem = this.oldParent.insertBefore(this.elem, t);
    });
  }
}, kS = class extends ko {
  /**
   * @param {Element} elem - The newly added DOM element
   * @param {string} text - An optional string visible to user related to this change
  */
  constructor(e, t) {
    super(), this.elem = e, this.text = t || `Create ${e.tagName}`, this.parent = e.parentNode, this.nextSibling = this.elem.nextSibling;
  }
  /**
  * Re-inserts the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      const t = this.nextSibling && this.nextSibling.parentNode === this.parent ? this.nextSibling : null;
      this.elem = this.parent.insertBefore(this.elem, t);
    });
  }
  /**
  * Removes the element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      this.parent = this.elem.parentNode, this.elem.remove();
    });
  }
}, HS = class extends ko {
  /**
  * @param {Element} elem - The removed DOM element
  * @param {Node} oldNextSibling - The DOM element's nextSibling when it was in the DOM
  * @param {Element} oldParent - The DOM element's parent
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e, t, A, n) {
    super(), this.elem = e, this.text = n || `Delete ${e.tagName}`, this.nextSibling = t, this.parent = A;
  }
  /**
  * Re-removes the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.parent = this.elem.parentNode, this.elem.remove();
    });
  }
  /**
  * Re-adds the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      const t = this.nextSibling && this.nextSibling.parentNode === this.parent ? this.nextSibling : null;
      this.parent.insertBefore(this.elem, t);
    });
  }
}, Ho = class extends ko {
  /**
  * @param {Element} elem - The DOM element that was changed
  * @param {module:history.CommandAttributes} attrs - Attributes to be changed with the values they had *before* the change
  * @param {string} text - An optional string visible to user related to this change
   */
  constructor(e, t, A) {
    super(), this.elem = e, this.text = A ? `Change ${e.tagName} ${A}` : `Change ${e.tagName}`, this.newValues = {}, this.oldValues = t;
    for (const n in t)
      n === "#text" ? this.newValues[n] = e ? e.textContent : "" : n === "#href" ? this.newValues[n] = Ei(e) : this.newValues[n] = e.getAttribute(n);
  }
  /**
  * Performs the stored change action.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      let t = !1;
      if (Object.entries(this.newValues).forEach(([A, n]) => {
        const i = n == null || n === "";
        A === "#text" ? this.elem.textContent = n == null ? "" : String(n) : A === "#href" ? i ? (this.elem.removeAttribute("href"), this.elem.removeAttributeNS(et.XLINK, "href")) : Dn(this.elem, String(n)) : i ? (this.elem.setAttribute(A, ""), this.elem.removeAttribute(A)) : this.elem.setAttribute(A, n), A === "transform" && (t = !0);
      }), !t) {
        const A = bA(this.elem);
        if (A) {
          const n = Ir(this.elem);
          if (!n) return;
          const i = n.x + n.width / 2, s = n.y + n.height / 2, a = ["rotate(", A, " ", i, ",", s, ")"].join("");
          a !== this.elem.getAttribute("transform") && this.elem.setAttribute("transform", a);
        }
      }
    });
  }
  /**
  * Reverses the stored change action.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      let t = !1;
      if (Object.entries(this.oldValues).forEach(([A, n]) => {
        const i = n == null || n === "";
        A === "#text" ? this.elem.textContent = n == null ? "" : String(n) : A === "#href" ? i ? (this.elem.removeAttribute("href"), this.elem.removeAttributeNS(et.XLINK, "href")) : Dn(this.elem, String(n)) : i ? this.elem.removeAttribute(A) : this.elem.setAttribute(A, n), A === "transform" && (t = !0);
      }), !t) {
        const A = bA(this.elem);
        if (A) {
          const n = Ir(this.elem);
          if (!n) return;
          const i = n.x + n.width / 2, s = n.y + n.height / 2, a = ["rotate(", A, " ", i, ",", s, ")"].join("");
          a !== this.elem.getAttribute("transform") && this.elem.setAttribute("transform", a);
        }
      }
    });
  }
}, du = class extends ko {
  /**
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e) {
    super(), this.text = e || "Batch Command", this.stack = [];
  }
  /**
  * Runs "apply" on all subcommands.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.stack.forEach((t) => {
        console.assert(t, "stack item should not be null"), t && t.apply(e);
      });
    });
  }
  /**
  * Runs "unapply" on all subcommands.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      [...this.stack].reverse().forEach((t) => {
        console.assert(t, "stack item should not be null"), t && t.unapply(e);
      });
    });
  }
  /**
  * Iterate through all our subcommands.
  * @returns {Element[]} All the elements we are changing
  */
  elements() {
    const e = [];
    let t = this.stack.length;
    for (; t--; ) {
      if (!this.stack[t]) continue;
      const A = this.stack[t].elements();
      let n = A.length;
      for (; n--; )
        e.includes(A[n]) || e.push(A[n]);
    }
    return e;
  }
  /**
  * Adds a given command to the history stack.
  * @param {Command} cmd - The undo command object to add
  * @returns {void}
  */
  addSubCommand(e) {
    console.assert(e !== null, "cmd should not be null"), this.stack.push(e);
  }
  /**
  * @returns {boolean} Indicates whether or not the batch command is empty
  */
  isEmpty() {
    return !this.stack.length;
  }
}, n_ = class {
  /**
  * @param {module:history.HistoryEventHandler} historyEventHandler
  */
  constructor(e) {
    this.handler_ = e || null, this.undoStackPointer = 0, this.undoStack = [], this.undoChangeStackPointer = -1, this.undoableChangeStack = [];
  }
  /**
  * Resets the undo stack, effectively clearing the undo/redo history.
  * @returns {void}
  */
  resetUndoStack() {
    this.undoStack = [], this.undoStackPointer = 0;
  }
  /**
  * @returns {Integer} Current size of the undo history stack
  */
  getUndoStackSize() {
    return this.undoStackPointer;
  }
  /**
  * @returns {Integer} Current size of the redo history stack
  */
  getRedoStackSize() {
    return this.undoStack.length - this.undoStackPointer;
  }
  /**
  * @returns {string} String associated with the next undo command
  */
  getNextUndoCommandText() {
    return this.undoStackPointer > 0 ? this.undoStack[this.undoStackPointer - 1].getText() : "";
  }
  /**
  * @returns {string} String associated with the next redo command
  */
  getNextRedoCommandText() {
    return this.undoStackPointer < this.undoStack.length ? this.undoStack[this.undoStackPointer].getText() : "";
  }
  /**
  * Performs an undo step.
  * @returns {void}
  */
  undo() {
    this.undoStackPointer > 0 && this.undoStack[--this.undoStackPointer].unapply(this.handler_);
  }
  /**
  * Performs a redo step.
  * @returns {void}
  */
  redo() {
    this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && this.undoStack[this.undoStackPointer++].apply(this.handler_);
  }
  /**
  * Adds a command object to the undo history stack.
  * @param {Command} cmd - The command object to add
  * @returns {void}
  */
  addCommandToHistory(e) {
    this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && (this.undoStack = this.undoStack.splice(0, this.undoStackPointer)), this.undoStack.push(e), this.undoStackPointer = this.undoStack.length;
  }
  /**
  * This function tells the canvas to remember the old values of the
  * `attrName` attribute for each element sent in.  The elements and values
  * are stored on a stack, so the next call to `finishUndoableChange()` will
  * pop the elements and old values off the stack, gets the current values
  * from the DOM and uses all of these to construct the undo-able command.
  * @param {string} attrName - The name of the attribute being changed
  * @param {Element[]} elems - Array of DOM elements being changed
  * @returns {void}
  */
  beginUndoableChange(e, t) {
    const A = ++this.undoChangeStackPointer;
    let n = t.length;
    const i = new Array(n), s = new Array(n);
    for (; n--; ) {
      const a = t[n];
      a && (s[n] = a, i[n] = a.getAttribute(e));
    }
    this.undoableChangeStack[A] = {
      attrName: e,
      oldValues: i,
      elements: s
    };
  }
  /**
  * This function returns a `BatchCommand` object which summarizes the
  * change since `beginUndoableChange` was called.  The command can then
  * be added to the command history.
  * @returns {BatchCommand} Batch command object with resulting changes
  */
  finishUndoableChange() {
    const e = this.undoChangeStackPointer--, t = this.undoableChangeStack[e], { attrName: A } = t, n = new du(`Change ${A}`);
    let i = t.elements.length;
    for (; i--; ) {
      const s = t.elements[i];
      if (!s)
        continue;
      const a = {};
      a[A] = t.oldValues[i], a[A] !== s.getAttribute(A) && n.addSubCommand(new Ho(s, a, A));
    }
    return this.undoableChangeStack[e] = null, n;
  }
};
const Va = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatchCommand: du,
  ChangeElementCommand: Ho,
  Command: ko,
  HistoryEventTypes: Il,
  InsertElementCommand: kS,
  MoveElementCommand: RS,
  RemoveElementCommand: HS,
  UndoManager: n_
}, Symbol.toStringTag, { value: "Module" }));
const DS = {
  1: "Z",
  2: "M",
  3: "m",
  4: "L",
  5: "l",
  6: "C",
  7: "c",
  8: "Q",
  9: "q",
  10: "A",
  11: "a",
  12: "H",
  13: "h",
  14: "V",
  15: "v",
  16: "S",
  17: "s",
  18: "T",
  19: "t"
}, K1 = Object.fromEntries(
  Object.entries(DS).map(([r, e]) => [e, Number(r)])
);
class i_ {
  constructor(e) {
    this.elem = e;
  }
  _getData() {
    return this.elem.getPathData();
  }
  _setData(e) {
    this.elem.setPathData(e);
  }
  get numberOfItems() {
    return this._getData().length;
  }
  _entryToSeg(e) {
    const { type: t, values: A = [] } = e, i = { pathSegType: K1[t] || K1[t?.toUpperCase?.()] };
    switch (String(t).toUpperCase()) {
      case "H":
        [i.x] = A;
        break;
      case "V":
        [i.y] = A;
        break;
      case "M":
      case "L":
      case "T":
        [i.x, i.y] = A;
        break;
      case "S":
        [i.x2, i.y2, i.x, i.y] = A;
        break;
      case "C":
        [i.x1, i.y1, i.x2, i.y2, i.x, i.y] = A;
        break;
      case "Q":
        [i.x1, i.y1, i.x, i.y] = A;
        break;
      case "A":
        [
          i.r1,
          i.r2,
          i.angle,
          i.largeArcFlag,
          i.sweepFlag,
          i.x,
          i.y
        ] = A;
        break;
    }
    return i;
  }
  _segToEntry(e) {
    const t = DS[e.pathSegType] || e.type;
    if (!t)
      return { type: "Z", values: [] };
    const A = String(t).toUpperCase();
    let n = [];
    switch (A) {
      case "H":
        n = [e.x];
        break;
      case "V":
        n = [e.y];
        break;
      case "M":
      case "L":
      case "T":
        n = [e.x, e.y];
        break;
      case "S":
        n = [e.x2, e.y2, e.x, e.y];
        break;
      case "C":
        n = [e.x1, e.y1, e.x2, e.y2, e.x, e.y];
        break;
      case "Q":
        n = [e.x1, e.y1, e.x, e.y];
        break;
      case "A":
        n = [
          e.r1,
          e.r2,
          e.angle,
          Number(e.largeArcFlag),
          Number(e.sweepFlag),
          e.x,
          e.y
        ];
        break;
      default:
        n = [];
    }
    return { type: t, values: n };
  }
  getItem(e) {
    const t = this._getData()[e];
    return t ? this._entryToSeg(t) : null;
  }
  replaceItem(e, t) {
    const A = this._getData();
    return A[t] = this._segToEntry(e), this._setData(A), e;
  }
  insertItemBefore(e, t) {
    const A = this._getData();
    return A.splice(t, 0, this._segToEntry(e)), this._setData(A), e;
  }
  appendItem(e) {
    const t = this._getData();
    return t.push(this._segToEntry(e)), this._setData(t), e;
  }
  removeItem(e) {
    const t = this._getData();
    t.splice(e, 1), this._setData(t);
  }
  clear() {
    this._setData([]);
  }
}
typeof SVGPathElement < "u" && typeof SVGPathElement.prototype.getPathData == "function" && typeof SVGPathElement.prototype.setPathData == "function" && !("pathSegList" in SVGPathElement.prototype) && Object.defineProperty(SVGPathElement.prototype, "pathSegList", {
  get() {
    return this._pathSegListShim || (this._pathSegListShim = new i_(this)), this._pathSegListShim;
  }
});
let zr = null;
const s_ = (r) => {
  zr = r;
}, wh = (r, e) => zr.getSegData()[r].map((n) => e[n]), ka = (r, e) => {
  const { path: t } = r;
  let A = {
    x: e ? e.x : r.item.x,
    y: e ? e.y : r.item.y
  };
  t.matrix && (A = Rt(A.x, A.y, t.matrix));
  const n = zr.getZoom();
  return A.x *= n, A.y *= n, A;
}, GS = (r, e) => {
  const t = {
    x: r.x,
    y: r.y
  };
  e.matrix && (r = Rt(t.x, t.y, e.imatrix), t.x = r.x, t.y = r.y);
  const A = zr.getZoom();
  return t.x /= A, t.y /= A, t;
}, Ka = () => {
  let r = Jt("pathpointgrip_container");
  if (!r) {
    const e = Jt("selectorParentGroup");
    r = document.createElementNS(et.SVG, "g"), e.append(r), r.id = "pathpointgrip_container";
  }
  return r;
}, tv = (r, e, t) => {
  const A = Ka();
  let n = Jt(`pathpointgrip_${r}`);
  if (!n) {
    n = document.createElementNS(et.SVG, "circle");
    const i = {
      id: `pathpointgrip_${r}`,
      display: "none",
      r: 4,
      fill: "#0FF",
      stroke: "#00F",
      "stroke-width": 2,
      cursor: "move",
      style: "pointer-events:all"
    }, s = zr.getUIStrings();
    "pathNodeTooltip" in s && (i["xlink:title"] = s.pathNodeTooltip), Yt(n, i), A.append(n), document.getElementById("pathpointgrip_" + r)?.addEventListener("dblclick", () => {
      const o = zr.getPathObj();
      o && o.setSegType();
    });
  }
  return e && t && Yt(n, {
    cx: e,
    cy: t,
    display: "inline"
  }), n;
}, rv = (r) => {
  let e = Jt("ctrlpointgrip_" + r);
  if (e)
    return e;
  e = document.createElementNS(et.SVG, "circle");
  const t = {
    id: "ctrlpointgrip_" + r,
    display: "none",
    r: 4,
    fill: "#0FF",
    stroke: "#55F",
    "stroke-width": 1,
    cursor: "move",
    style: "pointer-events:all"
  }, A = zr.getUIStrings();
  return "pathCtrlPtTooltip" in A && (t["xlink:title"] = A.pathCtrlPtTooltip), Yt(e, t), Ka().append(e), e;
}, Av = (r) => {
  let e = Jt("ctrlLine_" + r);
  return e || (e = document.createElementNS(et.SVG, "line"), Yt(e, {
    id: "ctrlLine_" + r,
    stroke: "#555",
    "stroke-width": 1,
    style: "pointer-events:none"
  }), Ka().append(e), e);
}, VS = (r, e) => {
  const { index: t } = r, A = tv(t);
  if (e) {
    const n = ka(r);
    Yt(A, {
      cx: n.x,
      cy: n.y,
      display: "inline"
    });
  }
  return A;
}, th = (r) => {
  const { item: e, index: t } = r;
  if (!("x1" in e) || !("x2" in e))
    return null;
  const A = {};
  Ka();
  const s = [zr.getPathObj().segs[t - 1].item, e];
  for (let a = 1; a < 3; a++) {
    const o = t + "c" + a, l = A[`c${a}_line`] = Av(o), u = ka(r, { x: e["x" + a], y: e["y" + a] }), c = ka(r, { x: s[a - 1].x, y: s[a - 1].y });
    Yt(l, {
      x1: u.x,
      y1: u.y,
      x2: c.x,
      y2: c.y,
      display: "inline"
    }), A[`c${a}_line`] = l;
    const f = A[`c${a}`] = rv(o);
    Yt(f, {
      cx: u.x,
      cy: u.y,
      display: "inline"
    }), A["c" + a] = f;
  }
  return A;
}, sn = (r, e, t, A) => {
  const n = zr.getPathObj(), i = A || n.elem, a = "createSVGPathSeg" + zr.getPathFuncs()[r], o = zr.getSegData?.(), l = o?.[r] || o?.[r - 1];
  if (l && t.length < l.length) {
    const c = i.pathSegList?.getItem?.(e);
    c && (t = l.map((f, h) => t[h] !== void 0 ? t[h] : c[f]));
  }
  let u;
  if (typeof i[a] == "function")
    u = i[a](...t);
  else {
    const c = l || [];
    u = { pathSegType: r }, c.forEach((f, h) => {
      u[f] = t[h];
    });
  }
  i.pathSegList.replaceItem(u, e);
}, z0 = (r, e) => {
  const { index: t } = r;
  let A = Jt(`segline_${t}`);
  if (!A) {
    const n = Ka();
    A = document.createElementNS(et.SVG, "path"), Yt(A, {
      id: `segline_${t}`,
      display: "none",
      fill: "none",
      stroke: "#0FF",
      "stroke-width": 2,
      style: "pointer-events:none",
      d: "M0,0 0,0"
    }), n.append(A);
  }
  if (e) {
    const { prev: n } = r;
    if (!n)
      return A.setAttribute("display", "none"), A;
    const i = ka(n);
    sn(2, 0, [i.x, i.y], A);
    const s = wh(r.type, r.item);
    for (let a = 0; a < s.length; a += 2) {
      const o = ka(r, { x: s[a], y: s[a + 1] });
      s[a] = o.x, s[a + 1] = o.y;
    }
    sn(r.type, 1, s, A);
  }
  return A;
};
class a_ {
  /**
  * @param {Integer} index
  * @param {SVGPathSeg} item
  * @todo Is `item` be more constrained here?
  */
  constructor(e, t) {
    this.selected = !1, this.index = e, this.item = t, this.type = t.pathSegType, this.ctrlpts = null, this.ptgrip = null, this.segsel = null;
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  showCtrlPts(e) {
    for (const t in this.ctrlpts)
      ({}).hasOwnProperty.call(this.ctrlpts, t) && this.ctrlpts[t].setAttribute("display", e ? "inline" : "none");
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  selectCtrls(e) {
    document.getElementById(`ctrlpointgrip_${this.index}c1`)?.setAttribute("fill", e ? "#0FF" : "#EEE"), document.getElementById(`ctrlpointgrip_${this.index}c2`)?.setAttribute("fill", e ? "#0FF" : "#EEE");
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  show(e) {
    this.ptgrip && (this.ptgrip.setAttribute("display", e ? "inline" : "none"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.showCtrlPts(e));
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  select(e) {
    this.ptgrip && (this.ptgrip.setAttribute("stroke", e ? "#0FF" : "#00F"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.ctrlpts && this.selectCtrls(e), this.selected = e);
  }
  /**
   * @returns {void}
   */
  addGrip() {
    this.ptgrip = VS(this, !0), this.ctrlpts = th(this), this.segsel = z0(this, !0);
  }
  /**
   * @param {boolean} full
   * @returns {void}
   */
  update(e) {
    if (this.ptgrip) {
      const t = ka(this);
      if (Yt(this.ptgrip, {
        cx: t.x,
        cy: t.y
      }), z0(this, !0), this.ctrlpts) {
        if (e) {
          const A = zr.getPathObj();
          this.item = A.elem.pathSegList.getItem(this.index), this.type = this.item.pathSegType;
        }
        th(this);
      }
    }
  }
  /**
   * @param {Integer} dx
   * @param {Integer} dy
   * @returns {void}
   */
  move(e, t) {
    const { item: A } = this;
    A.x += e, A.y += t, "x2" in A && (A.x2 += e), "y2" in A && (A.y2 += t), sn(
      this.type,
      this.index,
      wh(this.type, A)
    );
    const n = this.next?.item;
    if (n && "x1" in n && "y1" in n && (n.x1 += e, n.y1 += t, sn(this.next.type, this.next.index, wh(this.next.type, n))), this.mate) {
      const { item: i } = this.mate, s = [i.x += e, i.y += t];
      sn(this.mate.type, this.mate.index, s);
    }
    this.update(!0), this.next && this.next.update(!0);
  }
  /**
   * @param {Integer} num
   * @returns {void}
   */
  setLinked(e) {
    let t, A, n;
    if (e === 2) {
      if (A = 1, t = this.next, !t)
        return;
      n = this.item;
    } else {
      if (A = 2, t = this.prev, !t)
        return;
      n = t.item;
    }
    const { item: i } = t;
    i["x" + A] = n.x + (n.x - this.item["x" + e]), i["y" + A] = n.y + (n.y - this.item["y" + e]);
    const s = [
      i.x,
      i.y,
      i.x1,
      i.y1,
      i.x2,
      i.y2
    ];
    sn(t.type, t.index, s), t.update(!0);
  }
  /**
   * @param {Integer} num
   * @param {Integer} dx
   * @param {Integer} dy
   * @returns {void}
   */
  moveCtrl(e, t, A) {
    const { item: n } = this;
    n["x" + e] += t, n["y" + e] += A;
    const i = [
      n.x,
      n.y,
      n.x1,
      n.y1,
      n.x2,
      n.y2
    ];
    sn(this.type, this.index, i), this.update(!0);
  }
  /**
   * @param {Integer} newType Possible values set during {@link module:path.init}
   * @param {ArgumentsArray} pts
   * @returns {void}
   */
  setType(e, t) {
    sn(e, this.index, t), this.type = e;
    const A = zr.getPathObj();
    this.item = A.elem.pathSegList.getItem(this.index), this.showCtrlPts(e === 6), this.ctrlpts = th(this), this.update(!0);
  }
}
class nv {
  /**
  * @param {SVGPathElement} elem
  * @throws {Error} If constructed without a path element
  */
  constructor(e) {
    if (!e || e.tagName !== "path")
      throw new Error("svgedit.path.Path constructed without a <path> element");
    this.elem = e, this.segs = [], this.selected_pts = [], zr.setPathObj(this), this.init();
  }
  setPathContext() {
    zr.setPathObj(this);
  }
  /**
  * Reset path data.
  * @returns {module:path.Path}
  */
  init() {
    const t = Ka().querySelectorAll("*");
    Array.prototype.forEach.call(t, function(a) {
      a.setAttribute("display", "none");
    });
    const A = this.elem.pathSegList, n = A.numberOfItems;
    this.segs = [], this.selected_pts = [], this.first_seg = null;
    for (let a = 0; a < n; a++) {
      const o = A.getItem(a), l = new a_(a, o);
      l.path = this, this.segs.push(l);
    }
    const { segs: i } = this;
    let s = null;
    for (let a = 0; a < n; a++) {
      const o = i[a], l = a + 1 >= n ? null : i[a + 1], u = a - 1 < 0 ? null : i[a - 1];
      if (o.type === 2) {
        if (u && u.type !== 1) {
          const c = i[s];
          c.next = i[s + 1], c.next.prev = c, c.addGrip();
        }
        s = a;
      } else if (l?.type === 1)
        o.next = i[s + 1], o.next.prev = o, o.mate = i[s], o.addGrip(), this.first_seg || (this.first_seg = o);
      else if (l)
        o.type !== 1 && (o.addGrip(), l && l.type !== 2 && (o.next = l, o.next.prev = o));
      else if (o.type !== 1) {
        const c = i[s];
        c.next = i[s + 1], c.next.prev = c, c.addGrip(), o.addGrip(), this.first_seg || (this.first_seg = i[s]);
      }
    }
    return this;
  }
  /**
  * @callback module:path.PathEachSegCallback
  * @this module:path.Segment
  * @param {Integer} i The index of the seg being iterated
  * @returns {boolean|void} Will stop execution of `eachSeg` if returns `false`
  */
  /**
  * @param {module:path.PathEachSegCallback} fn
  * @returns {void}
  */
  eachSeg(e) {
    const t = this.segs.length;
    for (let A = 0; A < t && e.call(this.segs[A], A) !== !1; A++)
      ;
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  addSeg(e) {
    const t = this.segs[e];
    if (!t.prev)
      return;
    const { prev: A } = t;
    let n, i, s;
    switch (t.item.pathSegType) {
      case 4: {
        i = (t.item.x + A.item.x) / 2, s = (t.item.y + A.item.y) / 2, n = this.elem.createSVGPathSegLinetoAbs(i, s);
        break;
      }
      case 6: {
        const o = (A.item.x + t.item.x1) / 2, l = (t.item.x1 + t.item.x2) / 2, u = (t.item.x2 + t.item.x) / 2, c = (o + l) / 2, f = (l + u) / 2;
        i = (c + f) / 2;
        const h = (A.item.y + t.item.y1) / 2, g = (t.item.y1 + t.item.y2) / 2, p = (t.item.y2 + t.item.y) / 2, v = (h + g) / 2, w = (g + p) / 2;
        s = (v + w) / 2, n = this.elem.createSVGPathSegCurvetoCubicAbs(i, s, o, h, c, v);
        const b = [t.item.x, t.item.y, f, w, u, p];
        sn(t.type, e, b);
        break;
      }
    }
    this.elem.pathSegList.insertItemBefore(n, e);
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  deleteSeg(e) {
    const t = this.segs[e], A = this.elem.pathSegList;
    t.show(!1);
    const { next: n } = t;
    if (t.mate) {
      const i = [n.item.x, n.item.y];
      sn(2, n.index, i), sn(4, t.index, i), A.removeItem(t.mate.index);
    } else if (t.prev)
      A.removeItem(e);
    else {
      const i = [n.item.x, n.item.y];
      sn(2, t.next.index, i), A.removeItem(e);
    }
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  removePtFromSelection(e) {
    const t = this.selected_pts.indexOf(e);
    t !== -1 && (this.segs[e].select(!1), this.selected_pts.splice(t, 1));
  }
  /**
  * @returns {void}
  */
  clearSelection() {
    this.eachSeg(function() {
      this.select(!1);
    }), this.selected_pts = [];
  }
  /**
  * @returns {void}
  */
  storeD() {
    this.last_d = this.elem.getAttribute("d");
  }
  /**
  * @param {Integer} y
  * @returns {Path}
  */
  show(e) {
    return this.eachSeg(function() {
      this.show(e);
    }), e && this.selectPt(this.first_seg.index), this;
  }
  /**
  * Move selected points.
  * @param {Integer} dx
  * @param {Integer} dy
  * @returns {void}
  */
  movePts(e, t) {
    let A = this.selected_pts.length;
    for (; A--; )
      this.segs[this.selected_pts[A]].move(e, t);
  }
  /**
  * @param {Integer} dx
  * @param {Integer} dy
  * @returns {void}
  */
  moveCtrl(e, t) {
    const A = this.segs[this.selected_pts[0]];
    A.moveCtrl(this.dragctrl, e, t), zr.getLinkControlPts() && A.setLinked(this.dragctrl);
  }
  /**
  * @param {?Integer} newType See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
  * @returns {void}
  */
  setSegType(e) {
    this.storeD();
    let t = this.selected_pts.length, A;
    for (; t--; ) {
      const i = this.selected_pts[t], s = this.segs[i], { prev: a } = s;
      if (!a)
        continue;
      e || (A = "Toggle Path Segment Type", e = s.type === 6 ? 4 : 6), e = Number(e);
      const o = s.item.x, l = s.item.y, u = a.item.x, c = a.item.y;
      let f;
      switch (e) {
        case 6: {
          if (s.olditem) {
            const h = s.olditem;
            f = [o, l, h.x1, h.y1, h.x2, h.y2];
          } else {
            const h = o - u, g = l - c, p = u + h / 3, v = c + g / 3, w = o - h / 3, b = l - g / 3;
            f = [o, l, p, v, w, b];
          }
          break;
        }
        case 4: {
          f = [o, l], s.olditem = s.item;
          break;
        }
      }
      s.setType(e, f);
    }
    zr.getPathObj().endChanges(A);
  }
  /**
  * @param {Integer} pt
  * @param {Integer} ctrlNum
  * @returns {void}
  */
  selectPt(e, t) {
    this.clearSelection(), e || this.eachSeg(function(A) {
      this.prev && (e = A);
    }), this.addPtsToSelection(e), t && (this.dragctrl = t, zr.getLinkControlPts() && this.segs[e].setLinked(t));
  }
  /**
  * Update position of all points.
  * @returns {Path}
  */
  update() {
    const { elem: e } = this;
    return bA(e) ? (this.matrix = Jm(e), this.imatrix = this.matrix.inverse()) : (this.matrix = null, this.imatrix = null), this.eachSeg(function(t) {
      this.item = e.pathSegList.getItem(t), this.update();
    }), this;
  }
  /**
  * @param {string} text
  * @returns {void}
  */
  endChanges(e) {
    const t = new Ho(this.elem, { d: this.last_d }, e);
    zr.endChanges({ cmd: t, elem: this.elem });
  }
  /**
  * @param {Integer|Integer[]} indexes
  * @returns {void}
  */
  addPtsToSelection(e) {
    Array.isArray(e) || (e = [e]), e.forEach((i) => {
      this.segs[i].ptgrip && !this.selected_pts.includes(i) && i >= 0 && this.selected_pts.push(i);
    }), this.selected_pts.sort();
    let t = this.selected_pts.length;
    const A = [];
    for (A.length = t; t--; ) {
      const i = this.selected_pts[t], s = this.segs[i];
      s.select(!0), A[t] = s.ptgrip;
    }
    const n = nv.subpathIsClosed(this.selected_pts[0]);
    zr.addPtsToSelection({ grips: A, closedSubpath: n });
  }
  // STATIC
  /**
  * @param {Integer} index
  * @returns {boolean}
  */
  static subpathIsClosed(e) {
    let t = !1;
    return zr.getPathObj().eachSeg(function(n) {
      return n <= e ? !0 : this.type === 2 ? !1 : this.type === 1 ? (t = !0, !1) : !0;
    }), t;
  }
}
let De = null, Me = null;
const o_ = (r) => {
  De = r;
}, l_ = (r, e) => {
  const { pathSegList: t } = r, A = t.numberOfItems;
  let n = 0, i = 0, s = "", a = null;
  for (let o = 0; o < A; ++o) {
    const l = t.getItem(o);
    let u = l.x || 0, c = l.y || 0, f = l.x1 || 0, h = l.y1 || 0, g = l.x2 || 0, p = l.y2 || 0, v = l.pathSegTypeAsLetter;
    switch (v) {
      case "z":
      // z,Z closepath (Z/z)
      case "Z":
        s += "z", a && (n = a[0], i = a[1]);
        break;
      case "H":
        u -= n;
      // Fallthrough
      case "h":
        e ? (c = 0, n += u, v = "l") : (c = i, u += n, n = u, v = "L"), s += va(v, [[u, c]]);
        break;
      case "V":
        c -= i;
      // Fallthrough
      case "v":
        e ? (u = 0, i += c, v = "l") : (u = n, c += i, i = c, v = "L"), s += va(v, [[u, c]]);
        break;
      case "M":
      // absolute move (M)
      case "L":
      // absolute line (L)
      case "T":
        u -= n, c -= i;
      // Fallthrough
      case "l":
      // relative line (l)
      case "m":
      // relative move (m)
      case "t":
        e ? (n += u, i += c, v = v.toLowerCase()) : (u += n, c += i, n = u, i = c, v = v.toUpperCase()), (v === "m" || v === "M") && (a = [n, i]), s += va(v, [[u, c]]);
        break;
      case "C":
        u -= n, f -= n, g -= n, c -= i, h -= i, p -= i;
      // Fallthrough
      case "c":
        e ? (n += u, i += c, v = "c") : (u += n, f += n, g += n, c += i, h += i, p += i, n = u, i = c, v = "C"), s += va(v, [[f, h], [g, p], [u, c]]);
        break;
      case "Q":
        u -= n, f -= n, c -= i, h -= i;
      // Fallthrough
      case "q":
        e ? (n += u, i += c, v = "q") : (u += n, f += n, c += i, h += i, n = u, i = c, v = "Q"), s += va(v, [[f, h], [u, c]]);
        break;
      case "A":
        u -= n, c -= i;
      // fallthrough
      case "a":
        e ? (n += u, i += c, v = "a") : (u += n, c += i, n = u, i = c, v = "A"), s += va(v, [[l.r1, l.r2]], [
          l.angle,
          l.largeArcFlag ? 1 : 0,
          l.sweepFlag ? 1 : 0
        ], [u, c]);
        break;
      case "S":
        u -= n, g -= n, c -= i, p -= i;
      // Fallthrough
      case "s":
        e ? (n += u, i += c, v = "s") : (u += n, g += n, c += i, p += i, n = u, i = c, v = "S"), s += va(v, [[g, p], [u, c]]);
        break;
    }
  }
  return s;
}, va = (r, e, t, A) => [
  r + e.map((i) => Cn(i)).join(" "),
  t ? t.join(" ") : null,
  A ? Cn(A) : null
].filter(Boolean).join(" ");
class u_ {
  #e = !1;
  #t = null;
  #r = null;
  #A = null;
  #s = !1;
  /**
  * This function converts a polyline (created by the fh_path tool) into
  * a path element and coverts every three line segments into a single bezier
  * curve in an attempt to smooth out the free-hand.
  * @function smoothPolylineIntoPath
  * @param {Element} element
  * @returns {Element}
  * @private
  */
  #n = (e) => {
    const { points: t } = e, A = t.numberOfItems;
    if (A >= 4) {
      let n = t.getItem(0), i = null, s = [];
      s.push(`M${n.x},${n.y} C`);
      let a;
      for (a = 1; a <= A - 4; a += 3) {
        let o = t.getItem(a);
        const l = t.getItem(a + 1), u = t.getItem(a + 2);
        if (i) {
          const c = De.smoothControlPoints(i, o, n);
          if (c?.length === 2) {
            const f = s[s.length - 1].split(",");
            f[2] = c[0].x, f[3] = c[0].y, s[s.length - 1] = f.join(","), o = c[1];
          }
        }
        s.push([o.x, o.y, l.x, l.y, u.x, u.y].join(",")), n = u, i = l;
      }
      for (s.push("L"); a < A; ) {
        const o = t.getItem(a);
        s.push([o.x, o.y].join(",")), a++;
      }
      s = s.join(" "), e = De.addSVGElementsFromJson({
        element: "path",
        curStyles: !0,
        attr: {
          id: De.getId(),
          d: s,
          fill: "none"
        }
      });
    }
    return e;
  };
  /**
  * @param {MouseEvent} evt
  * @param {Element} mouseTarget
  * @param {Float} startX
  * @param {Float} startY
  * @returns {boolean|void}
  */
  mouseDown(e, t, A, n) {
    let i;
    if (De.getCurrentMode() === "path") {
      let a = A, o = n;
      const l = De.getZoom();
      let u = a / l, c = o / l, f = Jt("path_stretch_line");
      this.#t = [u, c], De.getGridSnapping() && (u = Ot(u), c = Ot(c), a = Ot(a), o = Ot(o)), f || (f = document.createElementNS(et.SVG, "path"), Yt(f, {
        id: "path_stretch_line",
        stroke: "#22C",
        "stroke-width": "0.5",
        fill: "none"
      }), Jt("selectorParentGroup").append(f)), f.setAttribute("display", "inline");
      let h = null, g;
      const p = De.getDrawnPath();
      if (p) {
        const v = p.pathSegList;
        let w = v.numberOfItems;
        const b = 6 / l;
        let S = !1;
        for (; w; ) {
          w--;
          const N = v.getItem(w), _ = N.x, R = N.y;
          if (u >= _ - b && u <= _ + b && c >= R - b && c <= R + b) {
            S = !0;
            break;
          }
        }
        i = De.getId(), De.removePath_(i);
        const B = Jt(i);
        let x, U;
        const Q = v.numberOfItems;
        if (S) {
          if (w <= 1 && Q >= 2) {
            const N = v.getItem(0).x, _ = v.getItem(0).y;
            U = f.pathSegList.getItem(1), x = U.pathSegType === 4 ? p.createSVGPathSegLinetoAbs(N, _) : p.createSVGPathSegCurvetoCubicAbs(N, _, U.x1 / l, U.y1 / l, N, _);
            const R = p.createSVGPathSegClosePath();
            v.appendItem(x), v.appendItem(R);
          } else if (Q < 3)
            return h = !1, h;
          if (f.remove(), De.setDrawnPath(null), De.setStarted(!1), this.#e) {
            Me.matrix && De.remapElement(B, {}, Me.matrix.inverse());
            const N = B.getAttribute("d"), _ = Me.elem.getAttribute("d");
            return Me.elem.setAttribute("d", _ + N), B.parentNode.removeChild(B), Me.matrix && De.recalcRotatedPath(), Bi.toEditMode(Me.elem), Me.selectPt(), !1;
          }
        } else {
          if (!(De.getContainer() !== De.getMouseTarget(e) && De.getContainer().contains(
            De.getMouseTarget(e)
          )))
            return !1;
          const N = p.pathSegList.numberOfItems, _ = p.pathSegList.getItem(N - 1), R = _.x, F = _.y;
          e.shiftKey && ({ x: u, y: c } = K0(R, F, u, c)), U = f.pathSegList.getItem(1), x = U.pathSegType === 4 ? p.createSVGPathSegLinetoAbs(De.round(u), De.round(c)) : p.createSVGPathSegCurvetoCubicAbs(
            De.round(u),
            De.round(c),
            U.x1 / l,
            U.y1 / l,
            U.x2 / l,
            U.y2 / l
          ), p.pathSegList.appendItem(x), u *= l, c *= l, f.setAttribute("d", ["M", u, c, u, c].join(" ")), g = N, this.#e && (g += Me.segs.length), De.addPointGrip(g, u, c);
        }
      } else {
        const v = `M${u},${c} `;
        De.setDrawnPath(De.addSVGElementsFromJson({
          element: "path",
          curStyles: !0,
          attr: {
            d: v,
            id: De.getNextId(),
            opacity: De.getOpacity() / 2
          }
        })), f.setAttribute("d", `M${a} ${o} ${a} ${o}`), g = this.#e ? Me.segs.length : 0, De.addPointGrip(g, a, o);
      }
      return;
    }
    if (!Me)
      return;
    Me.storeD(), { id: i } = e.target;
    let s;
    if (i.startsWith("pathpointgrip_")) {
      s = Me.cur_pt = Number.parseInt(i.slice(14)), Me.dragging = [A, n];
      const a = Me.segs[s];
      e.shiftKey ? a.selected ? Me.removePtFromSelection(s) : Me.addPtsToSelection(s) : ((Me.selected_pts.length <= 1 || !a.selected) && Me.clearSelection(), Me.addPtsToSelection(s));
    } else if (i.startsWith("ctrlpointgrip_")) {
      Me.dragging = [A, n];
      const a = i.split("_")[1].split("c");
      s = Number(a[0]);
      const o = Number(a[1]);
      Me.selectPt(s, o);
    }
    if (!Me.dragging) {
      let a = De.getRubberBox();
      a || (a = De.setRubberBox(
        De.selectorManager.getRubberBandBox()
      ));
      const o = De.getZoom();
      Yt(a, {
        x: A * o,
        y: n * o,
        width: 0,
        height: 0,
        display: "inline"
      });
    }
  }
  /**
    * @param {Float} mouseX
    * @param {Float} mouseY
    * @returns {void}
    */
  mouseMove(e, t) {
    const A = De.getZoom();
    this.#s = !0;
    const n = De.getDrawnPath();
    if (De.getCurrentMode() === "path") {
      if (!n)
        return;
      const i = n.pathSegList, s = i.numberOfItems - 1;
      if (this.#t) {
        const a = De.addCtrlGrip("1c1"), o = De.addCtrlGrip("0c2");
        a.setAttribute("cx", e), a.setAttribute("cy", t), a.setAttribute("display", "inline");
        const l = this.#t[0], u = this.#t[1], c = e / A, f = t / A, h = l + (l - c), g = u + (u - f);
        o.setAttribute("cx", h * A), o.setAttribute("cy", g * A), o.setAttribute("display", "inline");
        const p = De.getCtrlLine(1);
        if (Yt(p, {
          x1: e,
          y1: t,
          x2: h * A,
          y2: g * A,
          display: "inline"
        }), s === 0)
          this.#r = [e, t];
        else {
          const v = i.getItem(s - 1);
          let w = v.x, b = v.y;
          v.pathSegType === 6 ? (w += w - v.x2, b += b - v.y2) : this.#r && (w = this.#r[0] / A, b = this.#r[1] / A), De.replacePathSeg(6, s, [l, u, w, b, h, g], n);
        }
      } else {
        const a = Jt("path_stretch_line");
        if (a) {
          const o = i.getItem(s);
          if (o.pathSegType === 6) {
            const l = o.x + (o.x - o.x2), u = o.y + (o.y - o.y2);
            De.replacePathSeg(
              6,
              1,
              [e, t, l * A, u * A, e, t],
              a
            );
          } else this.#r ? De.replacePathSeg(6, 1, [e, t, this.#r[0], this.#r[1], e, t], a) : De.replacePathSeg(4, 1, [e, t], a);
        }
      }
      return;
    }
    if (Me.dragging) {
      const i = De.getPointFromGrip({
        x: Me.dragging[0],
        y: Me.dragging[1]
      }, Me), s = De.getPointFromGrip({
        x: e,
        y: t
      }, Me), a = s.x - i.x, o = s.y - i.y;
      Me.dragging = [e, t], Me.dragctrl ? Me.moveCtrl(a, o) : Me.movePts(a, o);
    } else
      Me.selected_pts = [], Me.eachSeg(function(i) {
        const s = this;
        if (!s.next && !s.prev) return;
        const a = De.getRubberBox(), o = Ir(a), l = De.getGripPt(s), u = {
          x: l.x,
          y: l.y,
          width: 0,
          height: 0
        }, c = ES(o, u);
        this.select(c), c && Me.selected_pts.push(s.index);
      });
  }
  /**
     * @typedef module:path.keepElement
     * @type {PlainObject}
     * @property {boolean} keep
     * @property {Element} element
     */
  /**
    * @param {Event} evt
    * @param {Element} element
    * @param {Float} _mouseX
    * @param {Float} _mouseY
    * @returns {module:path.keepElement|void}
    */
  mouseUp(e, t, A, n) {
    const i = De.getDrawnPath();
    if (De.getCurrentMode() === "path")
      return this.#t = null, i || (t = Jt(De.getId()), De.setStarted(!1), this.#r = null), {
        keep: !0,
        element: t
      };
    const s = De.getRubberBox();
    if (Me.dragging) {
      const a = Me.cur_pt;
      Me.dragging = !1, Me.dragctrl = !1, Me.update(), this.#s && Me.endChanges("Move path point(s)"), !e.shiftKey && !this.#s && Me.selectPt(a);
    } else s?.getAttribute("display") !== "none" ? (s.setAttribute("display", "none"), s.getAttribute("width") <= 2 && s.getAttribute("height") <= 2 && Bi.toSelectMode(e.target)) : Bi.toSelectMode(e.target);
    this.#s = !1;
  }
  /**
    * @param {Element} element
    * @returns {void}
    */
  toEditMode(e) {
    Me = De.getPath_(e), De.setCurrentMode("pathedit"), De.clearSelection(), Me.setPathContext(), Me.show(!0).update(), Me.oldbbox = Ir(Me.elem), this.#e = !1;
  }
  /**
    * @param {Element} elem
    * @fires module:svgcanvas.SvgCanvas#event:selected
    * @returns {void}
    */
  toSelectMode(e) {
    const t = e === Me.elem;
    De.setCurrentMode("select"), Me.setPathContext(), Me.show(!1), this.#A = !1, De.clearSelection(), Me.matrix && De.recalcRotatedPath(), t && (De.call("selected", [e]), De.addToSelection([e], !0));
  }
  /**
    * @param {boolean} on
    * @returns {void}
    */
  addSubPath(e) {
    e ? (De.setCurrentMode("path"), this.#e = !0) : (Bi.clear(!0), Bi.toEditMode(Me.elem));
  }
  /**
    * @param {Element} target
    * @returns {void}
    */
  select(e) {
    this.#A === e ? (Bi.toEditMode(e), De.setCurrentMode("pathedit")) : this.#A = e;
  }
  /**
    * @fires module:svgcanvas.SvgCanvas#event:changed
    * @returns {void}
    */
  reorient() {
    const e = De.getSelectedElements()[0];
    if (!e || e.nodeName !== "path" || bA(e) === 0)
      return;
    const A = new du("Reorient path"), n = {
      d: e.getAttribute("d"),
      transform: e.getAttribute("transform")
    };
    A.addSubCommand(new Ho(e, n)), De.clearSelection(), this.resetOrientation(e), De.addCommandToHistory(A), De.getPath_(e).show(!1).matrix = null, this.clear(), De.addToSelection([e], !0), De.call("changed", De.getSelectedElements());
  }
  /**
    * @param {boolean} remove Not in use
    * @returns {void}
    */
  clear() {
    const e = De.getDrawnPath();
    if (this.#A = null, e) {
      const t = Jt(De.getId()), A = Jt("path_stretch_line");
      A.parentNode.removeChild(A), t.parentNode.removeChild(t);
      const i = Jt("pathpointgrip_container").querySelectorAll("*");
      for (const s of i)
        s.setAttribute("display", "none");
      this.#r = null, De.setDrawnPath(null), De.setStarted(!1);
    } else De.getCurrentMode() === "pathedit" && this.toSelectMode();
    Me && Me.init().show(!1);
  }
  /**
    * @param {?(Element|SVGPathElement)} pth
    * @returns {false|void}
    */
  resetOrientation(e) {
    if (e?.nodeName !== "path")
      return !1;
    const t = jt(e), A = Ht(t).matrix;
    t.clear(), e.removeAttribute("transform");
    const n = e.pathSegList, i = n.numberOfItems;
    for (let s = 0; s < i; ++s) {
      const a = n.getItem(s), o = a.pathSegType;
      if (o === 1)
        continue;
      const l = [];
      for (const u of ["", 1, 2]) {
        const c = a["x" + u], f = a["y" + u];
        if (c !== void 0 && f !== void 0) {
          const h = Rt(c, f, A);
          l.push(h.x, h.y);
        }
      }
      De.replacePathSeg(o, s, l, e);
    }
    De.reorientGrads(e, A);
  }
  /**
    * @returns {void}
    */
  zoomChange() {
    De.getCurrentMode() === "pathedit" && Me.update();
  }
  /**
    * @typedef {PlainObject} module:path.NodePoint
    * @property {Float} x
    * @property {Float} y
    * @property {Integer} type
    */
  /**
    * @returns {module:path.NodePoint}
    */
  getNodePoint() {
    const e = Me.selected_pts.length ? Me.selected_pts[0] : 1, t = Me.segs[e];
    return {
      x: t.item.x,
      y: t.item.y,
      type: t.type
    };
  }
  /**
    * @param {boolean} linkPoints
    * @returns {void}
    */
  linkControlPoints(e) {
    De.setLinkControlPoints(e);
  }
  /**
    * @returns {void}
    */
  clonePathNode() {
    Me.storeD();
    const e = Me.selected_pts;
    let t = e.length;
    const A = [];
    for (; t--; ) {
      const n = e[t];
      Me.addSeg(n), A.push(n + t), A.push(n + t + 1);
    }
    Me.init().addPtsToSelection(A), Me.endChanges("Clone path node(s)");
  }
  /**
    * @returns {void}
    */
  opencloseSubPath() {
    const e = Me.selected_pts;
    if (e.length !== 1)
      return;
    const { elem: t } = Me, A = t.pathSegList, n = e[0];
    let i = null, s = null;
    if (Me.eachSeg(function(f) {
      return this.type === 2 && f <= n && (s = this.item), f <= n ? !0 : this.type === 2 ? (i = f, !1) : this.type === 1 ? (i = !1, !1) : !0;
    }), i || (i = Me.segs.length - 1), i !== !1) {
      const f = t.createSVGPathSegLinetoAbs(s.x, s.y), h = t.createSVGPathSegClosePath();
      i === Me.segs.length - 1 ? (A.appendItem(f), A.appendItem(h)) : (A.insertItemBefore(h, i), A.insertItemBefore(f, i)), Me.init().selectPt(i + 1);
      return;
    }
    if (Me.segs[n].mate) {
      A.removeItem(n), A.removeItem(n), Me.init().selectPt(n - 1);
      return;
    }
    let o, l;
    for (let f = 0; f < A.numberOfItems; f++) {
      const h = A.getItem(f);
      if (h.pathSegType === 2)
        o = f;
      else if (f === n)
        A.removeItem(o);
      else if (h.pathSegType === 1 && n < f) {
        l = f - 1, A.removeItem(f);
        break;
      }
    }
    let u = n - o - 1;
    for (; u--; )
      A.insertItemBefore(A.getItem(o), l);
    const c = A.getItem(o);
    De.replacePathSeg(2, o, [c.x, c.y]), Me.init().selectPt(0);
  }
  /**
    * @returns {void}
    */
  deletePathNode() {
    if (!Bi.canDeleteNodes)
      return;
    Me.storeD();
    const e = Me.selected_pts;
    let t = e.length;
    for (; t--; ) {
      const n = e[t];
      Me.deleteSeg(n);
    }
    const A = () => {
      const n = Me.elem.pathSegList;
      let i = n.numberOfItems;
      const s = (a, o) => {
        for (; o--; )
          n.removeItem(a);
      };
      if (i <= 1)
        return !0;
      for (; i--; ) {
        const a = n.getItem(i);
        if (a.pathSegType === 1) {
          const o = n.getItem(i - 1), l = n.getItem(i - 2);
          if (o.pathSegType === 2) {
            s(i - 1, 2), A();
            break;
          } else if (l.pathSegType === 2) {
            s(i - 2, 3), A();
            break;
          }
        } else if (a.pathSegType === 2 && i > 0) {
          const o = n.getItem(i - 1).pathSegType;
          if (o === 2) {
            s(i - 1, 1), A();
            break;
          } else if (o === 1 && n.numberOfItems - 1 === i) {
            s(i, 1), A();
            break;
          }
        }
      }
      return !1;
    };
    if (A(), Me.elem.pathSegList.numberOfItems <= 1) {
      Bi.toSelectMode(Me.elem), De.canvas.deleteSelectedElements();
      return;
    }
    Me.init(), Me.clearSelection(), window.opera && Me.elem.setAttribute("d", Me.elem.getAttribute("d")), Me.endChanges("Delete path node(s)");
  }
  // Can't seem to use `@borrows` here, so using `@see`
  /**
  * Smooth polyline into path.
  * @function module:path.pathActions.smoothPolylineIntoPath
  * @see module:path~smoothPolylineIntoPath
  */
  smoothPolylineIntoPath(e) {
    return this.#n(e);
  }
  /* eslint-enable  */
  /**
  * @param {?Integer} v See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
  * @returns {void}
  */
  setSegType(e) {
    Me?.setSegType(e);
  }
  /**
  * @param {string} attr
  * @param {Float} newValue
  * @returns {void}
  */
  moveNode(e, t) {
    const A = Me.selected_pts;
    if (!A.length)
      return;
    Me.storeD();
    const n = Me.segs[A[0]], i = { x: 0, y: 0 };
    i[e] = t - n.item[e], n.move(i.x, i.y), Me.endChanges("Move path point");
  }
  /**
  * @param {Element} elem
  * @returns {void}
  */
  fixEnd(e) {
    const t = e.pathSegList, A = t.numberOfItems;
    let n;
    for (let i = 0; i < A; ++i) {
      const s = t.getItem(i);
      if (s.pathSegType === 2 && (n = s), s.pathSegType === 1) {
        const a = t.getItem(i - 1);
        if (a.x !== n.x || a.y !== n.y) {
          const o = e.createSVGPathSegLinetoAbs(n.x, n.y);
          t.insertItemBefore(o, i), Bi.fixEnd(e);
          break;
        }
      }
    }
  }
  // Can't seem to use `@borrows` here, so using `@see`
  /**
  * Convert a path to one with only absolute or relative values.
  * @function module:path.pathActions.convertPath
  * @see module:path.convertPath
  */
  convertPath(e, t) {
    return l_(e, t);
  }
}
const Bi = new u_();
const KS = {
  2: ["x", "y"],
  // PATHSEG_MOVETO_ABS
  4: ["x", "y"],
  // PATHSEG_LINETO_ABS
  6: ["x", "y", "x1", "y1", "x2", "y2"],
  // PATHSEG_CURVETO_CUBIC_ABS
  8: ["x", "y", "x1", "y1"],
  // PATHSEG_CURVETO_QUADRATIC_ABS
  10: ["x", "y", "r1", "r2", "angle", "largeArcFlag", "sweepFlag"],
  // PATHSEG_ARC_ABS
  12: ["x"],
  // PATHSEG_LINETO_HORIZONTAL_ABS
  14: ["y"],
  // PATHSEG_LINETO_VERTICAL_ABS
  16: ["x", "y", "x2", "y2"],
  // PATHSEG_CURVETO_CUBIC_SMOOTH_ABS
  18: ["x", "y"]
  // PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS
};
let Sr;
const jS = {}, qS = (r) => {
  Object.assign(jS, r.ui);
};
let gc = [], zS = !0, tu = {};
const WS = (r) => {
  zS = r;
};
let ru = null;
const XS = (r) => {
  Sr = r, Sr.replacePathSeg = sn, Sr.addPointGrip = tv, Sr.removePath_ = iv, Sr.getPath_ = ZS, Sr.addCtrlGrip = rv, Sr.getCtrlLine = Av, Sr.getGripPt = YS, Sr.getPointFromGrip = GS, Sr.setLinkControlPoints = WS, Sr.reorientGrads = rx, Sr.recalcRotatedPath = ex, Sr.getSegData = () => KS, Sr.getUIStrings = () => jS, Sr.getPathObj = () => ru, Sr.setPathObj = (t) => {
    ru = t;
  }, Sr.getPathFuncs = () => gc, Sr.getLinkControlPts = () => zS, gc = [0, "ClosePath"], [
    "Moveto",
    "Lineto",
    "CurvetoCubic",
    "CurvetoQuadratic",
    "Arc",
    "LinetoHorizontal",
    "LinetoVertical",
    "CurvetoCubicSmooth",
    "CurvetoQuadraticSmooth"
  ].forEach((t) => {
    gc.push(t + "Abs"), gc.push(t + "Rel");
  }), o_(Sr), s_(Sr);
}, c_ = wh, YS = ka, h_ = GS, f_ = tv, d_ = Ka, g_ = rv, p_ = Av, m_ = VS, v_ = th, $S = sn, w_ = z0, JS = (r, e, t) => {
  const A = r.x - t.x, n = r.y - t.y, i = e.x - t.x, s = e.y - t.y;
  if ((A !== 0 || n !== 0) && (i !== 0 || s !== 0)) {
    const a = Math.sqrt(A * A + n * n), o = Math.sqrt(i * i + s * s), l = Sr.getSvgRoot().createSVGPoint(), u = Sr.getSvgRoot().createSVGPoint();
    let c = Math.atan2(n, A), f = Math.atan2(s, i);
    c < 0 && (c += 2 * Math.PI), f < 0 && (f += 2 * Math.PI);
    const h = Math.abs(c - f), g = Math.abs(Math.PI - h) / 2;
    let p, v;
    return c - f > 0 ? (p = h < Math.PI ? c + g : c - g, v = h < Math.PI ? f - g : f + g) : (p = h < Math.PI ? c - g : c + g, v = h < Math.PI ? f + g : f - g), l.x = a * Math.cos(p) + t.x, l.y = a * Math.sin(p) + t.y, u.x = o * Math.cos(v) + t.x, u.y = o * Math.sin(v) + t.y, [l, u];
  }
}, ZS = (r) => {
  let e = tu[r.id];
  return e || (e = tu[r.id] = new nv(r)), e;
}, iv = (r) => {
  r in tu && delete tu[r];
};
let So, xo, Vl, Kl, Eo;
const Jf = (r, e) => {
  let t = r - Vl, A = e - Kl, n = Math.sqrt(t * t + A * A), i = Math.atan2(A, t) + Eo;
  return t = n * Math.cos(i) + Vl, A = n * Math.sin(i) + Kl, t -= So, A -= xo, n = Math.sqrt(t * t + A * A), i = Math.atan2(A, t) - Eo, {
    x: n * Math.cos(i) + So,
    y: n * Math.sin(i) + xo
  };
}, ex = () => {
  const r = ru?.elem;
  if (!r || (Eo = bA(r, !0), !Eo))
    return;
  const e = ru.oldbbox;
  if (!e)
    return;
  Vl = e.x + e.width / 2, Kl = e.y + e.height / 2;
  const t = Ir(r);
  if (!t)
    return;
  So = t.x + t.width / 2, xo = t.y + t.height / 2;
  const A = So - Vl, n = xo - Kl, i = Math.sqrt(A * A + n * n), s = Math.atan2(n, A) + Eo;
  So = i * Math.cos(s) + Vl, xo = i * Math.sin(s) + Kl;
  const a = r.pathSegList;
  if (!a)
    return;
  let o = a.numberOfItems;
  for (; o; ) {
    o -= 1;
    const c = a.getItem(o), f = c.pathSegType;
    if (f === 1)
      continue;
    const h = KS[f];
    if (!h)
      continue;
    const g = {};
    if (c.x !== null && c.x !== void 0 && c.y !== null && c.y !== void 0) {
      const v = Jf(c.x, c.y);
      g.x = v.x, g.y = v.y;
    }
    if (c.x1 !== null && c.x1 !== void 0 && c.y1 !== null && c.y1 !== void 0) {
      const v = Jf(c.x1, c.y1);
      g.x1 = v.x, g.y1 = v.y;
    }
    if (c.x2 !== null && c.x2 !== void 0 && c.y2 !== null && c.y2 !== void 0) {
      const v = Jf(c.x2, c.y2);
      g.x2 = v.x, g.y2 = v.y;
    }
    const p = h.map((v) => {
      if (Object.prototype.hasOwnProperty.call(g, v))
        return g[v];
      const w = c[v];
      return w ?? 0;
    });
    $S(f, o, p);
  }
  Ir(r);
  const l = Sr.getSvgRoot().createSVGTransform(), u = jt(r);
  u && (l.setRotate(Eo * 180 / Math.PI, So, xo), u.numberOfItems ? typeof u.replaceItem == "function" ? u.replaceItem(l, 0) : (u.removeItem(0), u.insertItemBefore(l, 0)) : u.appendItem(l));
}, tx = () => {
  tu = {};
}, rx = (r, e) => {
  const t = Ir(r);
  for (let A = 0; A < 2; A++) {
    const n = A === 0 ? "fill" : "stroke", i = r.getAttribute(n);
    if (i && i.startsWith("url(")) {
      const s = qs(i);
      if (s.tagName === "linearGradient") {
        let a = s.getAttribute("x1") || 0, o = s.getAttribute("y1") || 0, l = s.getAttribute("x2") || 1, u = s.getAttribute("y2") || 0;
        a = t.width * a + t.x, o = t.height * o + t.y, l = t.width * l + t.x, u = t.height * u + t.y;
        const c = Rt(a, o, e), f = Rt(l, u, e), h = {
          x1: (c.x - t.x) / t.width,
          y1: (c.y - t.y) / t.height,
          x2: (f.x - t.x) / t.width,
          y2: (f.y - t.y) / t.height
        }, g = s.cloneNode(!0);
        for (const [p, v] of Object.entries(h))
          g.setAttribute(p, v);
        g.id = Sr.getNextId(), an().append(g), r.setAttribute(n, `url(#${g.id})`);
      }
    }
  }
}, y_ = [
  0,
  "z",
  "M",
  "m",
  "L",
  "l",
  "C",
  "c",
  "Q",
  "q",
  "A",
  "a",
  "H",
  "h",
  "V",
  "v",
  "S",
  "s",
  "T",
  "t"
], b_ = (r, e) => {
  const { pathSegList: t } = r, A = t.numberOfItems;
  let n = 0, i = 0, s = "", a = null;
  for (let o = 0; o < A; ++o) {
    const l = t.getItem(o);
    let u = l.x || 0, c = l.y || 0, f = l.x1 || 0, h = l.y1 || 0, g = l.x2 || 0, p = l.y2 || 0;
    const v = l.pathSegType;
    let w = y_[v][e ? "toLowerCase" : "toUpperCase"]();
    switch (v) {
      case 1:
        s += "z", a && (n = a[0], i = a[1]);
        break;
      case 12:
        u -= n;
      // Fallthrough
      case 13:
        e ? (c = 0, n += u, w = "l") : (c = i, u += n, n = u, w = "L"), s += wa(w, [[u, c]]);
        break;
      case 14:
        c -= i;
      // Fallthrough
      case 15:
        e ? (u = 0, i += c, w = "l") : (u = n, c += i, i = c, w = "L"), s += wa(w, [[u, c]]);
        break;
      case 2:
      // absolute move (M)
      case 4:
      // absolute line (L)
      case 18:
      // absolute smooth quad (T)
      case 10:
        u -= n, c -= i;
      // Fallthrough
      case 5:
      // relative line (l)
      case 3:
      // relative move (m)
      case 19:
        e ? (n += u, i += c) : (u += n, c += i, n = u, i = c), (v === 2 || v === 3) && (a = [n, i]), s += wa(w, [[u, c]]);
        break;
      case 6:
        u -= n, f -= n, g -= n, c -= i, h -= i, p -= i;
      // Fallthrough
      case 7:
        e ? (n += u, i += c) : (u += n, f += n, g += n, c += i, h += i, p += i, n = u, i = c), s += wa(w, [[f, h], [g, p], [u, c]]);
        break;
      case 8:
        u -= n, f -= n, c -= i, h -= i;
      // Fallthrough
      case 9:
        e ? (n += u, i += c) : (u += n, f += n, c += i, h += i, n = u, i = c), s += wa(w, [[f, h], [u, c]]);
        break;
      // Fallthrough
      case 11:
        e ? (n += u, i += c) : (u += n, c += i, n = u, i = c), s += wa(w, [[l.r1, l.r2]], [
          l.angle,
          l.largeArcFlag ? 1 : 0,
          l.sweepFlag ? 1 : 0
        ], [u, c]);
        break;
      case 16:
        u -= n, g -= n, c -= i, p -= i;
      // Fallthrough
      case 17:
        e ? (n += u, i += c) : (u += n, g += n, c += i, p += i, n = u, i = c), s += wa(w, [[g, p], [u, c]]);
        break;
    }
  }
  return s;
}, wa = (r, e, t, A) => {
  e.forEach((i, s) => {
    e[s] = Cn(i);
  });
  let n = r + e.join(" ");
  return t && (n += ` ${t.join(" ")}`), A && (n += ` ${Cn(A)}`), n;
}, B_ = Bi, Ax = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCtrlGrip: g_,
  addPointGrip: f_,
  clearData: tx,
  convertPath: b_,
  getControlPoints: v_,
  getCtrlLine: p_,
  getGripContainer: d_,
  getGripPt: YS,
  getPath_: ZS,
  getPointFromGrip: h_,
  getPointGrip: m_,
  getSegSelector: w_,
  init: XS,
  get path() {
    return ru;
  },
  pathActions: B_,
  ptObjToArr: c_,
  recalcRotatedPath: ex,
  removePath_: iv,
  reorientGrads: rx,
  replacePathSeg: $S,
  setLinkControlPoints: WS,
  setUiStrings: qS,
  smoothControlPoints: JS
}, Symbol.toStringTag, { value: "Module" }));
class Sn {
  /**
  * @param {string} name - Layer name
  * @param {SVGGElement|null} group - An existing SVG group element or null.
  *     If group and no svgElem, use group for this layer.
  *     If group and svgElem, create a new group element and insert it in the DOM after group.
  *     If no group and svgElem, create a new group element and insert it in the DOM as the last layer.
  * @param {SVGGElement} [svgElem] - The SVG DOM element. If defined, use this to add
  *     a new layer to the document.
  */
  constructor(e, t, A) {
    if (this.name_ = e, this.group_ = A ? null : t, A) {
      const n = A.ownerDocument;
      this.group_ = n.createElementNS(et.SVG, "g");
      const i = n.createElementNS(et.SVG, "title");
      i.textContent = e, this.group_.append(i), t ? t.insertAdjacentElement("afterend", this.group_) : A.append(this.group_);
    }
    C_(this.group_), os(this.group_, function(n) {
      n.style.pointerEvents = "inherit";
    }), this.group_.style.pointerEvents = A ? "all" : "none";
  }
  /**
   * Get the layer's name.
   * @returns {string} The layer name
   */
  getName() {
    return this.name_;
  }
  /**
   * Get the group element for this layer.
   * @returns {SVGGElement} The layer SVG group
   */
  getGroup() {
    return this.group_;
  }
  /**
   * Active this layer so it takes pointer events.
   * @returns {void}
   */
  activate() {
    this.group_.style.pointerEvents = "all";
  }
  /**
   * Deactive this layer so it does NOT take pointer events.
   * @returns {void}
   */
  deactivate() {
    this.group_.style.pointerEvents = "none";
  }
  /**
   * Set this layer visible or hidden based on 'visible' parameter.
   * @param {boolean} visible - If true, make visible; otherwise, hide it.
   * @returns {void}
   */
  setVisible(e) {
    const t = e === void 0 || e ? "inline" : "none";
    this.group_.getAttribute("display") !== t && this.group_.setAttribute("display", t);
  }
  /**
   * Is this layer visible?
   * @returns {boolean} True if visible.
   */
  isVisible() {
    return this.group_.getAttribute("display") !== "none";
  }
  /**
   * Get layer opacity.
   * @returns {Float} Opacity value.
   */
  getOpacity() {
    const e = this.group_.getAttribute("opacity");
    return e ? Number.parseFloat(e) : 1;
  }
  /**
   * Sets the opacity of this layer. If opacity is not a value between 0.0 and 1.0,
   * nothing happens.
   * @param {Float} opacity - A float value in the range 0.0-1.0
   * @returns {void}
   */
  setOpacity(e) {
    typeof e == "number" && e >= 0 && e <= 1 && this.group_.setAttribute("opacity", e);
  }
  /**
   * Append children to this layer.
   * @param {SVGGElement} children - The children to append to this layer.
   * @returns {void}
   */
  appendChildren(e) {
    for (const t of e)
      this.group_.append(t);
  }
  /**
  * @returns {SVGTitleElement|null}
  */
  getTitleElement() {
    const e = this.group_.childNodes.length;
    for (let t = 0; t < e; ++t) {
      const A = this.group_.childNodes.item(t);
      if (A?.tagName === "title")
        return A;
    }
    return null;
  }
  /**
   * Set the name of this layer.
   * @param {string} name - The new name.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {string|null} The new name if changed; otherwise, null.
   */
  setName(e, t) {
    const A = this.name_;
    e = Gl(e);
    const n = this.getTitleElement();
    if (n) {
      for (; n.firstChild; )
        n.removeChild(n.firstChild);
      return n.textContent = e, this.name_ = e, t && t.changeElement(n, { "#text": A }), this.name_;
    }
    return null;
  }
  /**
   * Remove this layer's group from the DOM. No more functions on group can be called after this.
   * @returns {SVGGElement} The layer SVG group that was just removed.
   */
  removeGroup() {
    const e = this.group_;
    return this.group_.remove(), this.group_ = void 0, e;
  }
  /**
   * Test whether an element is a layer or not.
   * @param {SVGGElement} elem - The SVGGElement to test.
   * @returns {boolean} True if the element is a layer
   */
  static isLayer(e) {
    return e && e.tagName === "g" && Sn.CLASS_REGEX.test(e.getAttribute("class"));
  }
}
Sn.CLASS_NAME = "layer";
Sn.CLASS_REGEX = new RegExp(`(\\s|^)${Sn.CLASS_NAME}(\\s|$)`);
const C_ = (r) => {
  const e = r.getAttribute("class");
  !e || !e.length ? r.setAttribute("class", Sn.CLASS_NAME) : Sn.CLASS_REGEX.test(e) || r.setAttribute("class", `${e} ${Sn.CLASS_NAME}`);
};
class W0 {
  /**
  * @param {history.UndoManager|null} undoManager - The undo manager.
  *     A value of `null` is valid for cases where no history recording is required.
  *     See singleton: {@link module:history.HistoryRecordingService.HistoryRecordingService.NO_HISTORY}
  */
  constructor(e) {
    this.undoManager_ = e, this.currentBatchCommand_ = null, this.batchCommandStack_ = [];
  }
  /**
   * Start a batch command so multiple commands can recorded as a single history command.
   * Requires a corresponding call to endBatchCommand. Start and end commands can be nested.
   *
   * @param {string} text - Optional string describing the batch command.
   * @returns {module:history.HistoryRecordingService}
   */
  startBatchCommand(e) {
    return this.undoManager_ ? (this.currentBatchCommand_ = new du(e), this.batchCommandStack_.push(this.currentBatchCommand_), this) : this;
  }
  /**
   * End a batch command and add it to the history or a parent batch command.
   * @returns {module:history.HistoryRecordingService}
   */
  endBatchCommand() {
    if (!this.undoManager_)
      return this;
    if (this.currentBatchCommand_) {
      const e = this.currentBatchCommand_;
      this.batchCommandStack_.pop();
      const { length: t } = this.batchCommandStack_;
      this.currentBatchCommand_ = t ? this.batchCommandStack_[t - 1] : null, e.isEmpty() || this.addCommand_(e);
    }
    return this;
  }
  /**
   * Add a `MoveElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was moved
   * @param {Element} oldNextSibling - The element's next sibling before it was moved
   * @param {Element} oldParent - The element's parent before it was moved
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  moveElement(e, t, A, n) {
    return this.undoManager_ ? (this.addCommand_(new RS(e, t, A, n)), this) : this;
  }
  /**
   * Add an `InsertElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was added
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  insertElement(e, t) {
    return this.undoManager_ ? (this.addCommand_(new kS(e, t)), this) : this;
  }
  /**
   * Add a `RemoveElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was removed
   * @param {Element} oldNextSibling - The element's next sibling before it was removed
   * @param {Element} oldParent - The element's parent before it was removed
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  removeElement(e, t, A, n) {
    return this.undoManager_ ? (this.addCommand_(new HS(e, t, A, n)), this) : this;
  }
  /**
   * Add a `ChangeElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was changed
   * @param {module:history.CommandAttributes} attrs - An object with the attributes to be changed and the values they had *before* the change
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  changeElement(e, t, A) {
    return this.undoManager_ ? (this.addCommand_(new Ho(e, t, A)), this) : this;
  }
  /**
   * Private function to add a command to the history or current batch command.
   * @private
   * @param {Command} cmd
   * @returns {module:history.HistoryRecordingService|void}
   */
  addCommand_(e) {
    if (!this.undoManager_)
      return this;
    this.currentBatchCommand_ ? this.currentBatchCommand_.addSubCommand(e) : this.undoManager_.addCommandToHistory(e);
  }
}
W0.NO_HISTORY = new W0(null);
class S_ {
  #e = /* @__PURE__ */ new WeakMap();
  /**
   * Checks if the provided element is a valid WeakMap key.
   * @param {any} element - The element to validate
   * @returns {boolean} True if the element can be used as a WeakMap key
   * @private
   */
  #t = (e) => e !== null && (typeof e == "object" || typeof e == "function");
  /**
   * Stores data associated with an element.
   * @param {Object|Function} element - The element to store data for
   * @param {string} key - The key to store the data under
   * @param {any} obj - The data to store
   * @returns {void}
   */
  put(e, t, A) {
    if (!this.#t(e))
      return;
    let n = this.#e.get(e);
    n || (n = /* @__PURE__ */ new Map(), this.#e.set(e, n)), n.set(t, A);
  }
  /**
   * Retrieves data associated with an element.
   * @param {Object|Function} element - The element to retrieve data for
   * @param {string} key - The key the data was stored under
   * @returns {any|undefined} The stored data, or undefined if not found
   */
  get(e, t) {
    if (this.#t(e))
      return this.#e.get(e)?.get(t);
  }
  /**
   * Checks if an element has data stored under a specific key.
   * @param {Object|Function} element - The element to check
   * @param {string} key - The key to check for
   * @returns {boolean} True if the element has data stored under the key
   */
  has(e, t) {
    return this.#t(e) ? this.#e.get(e)?.has(t) === !0 : !1;
  }
  /**
   * Removes data associated with an element.
   * @param {Object|Function} element - The element to remove data from
   * @param {string} key - The key the data was stored under
   * @returns {boolean} True if the data was removed, false otherwise
   */
  remove(e, t) {
    if (!this.#t(e))
      return !1;
    const A = this.#e.get(e);
    if (!A)
      return !1;
    const n = A.delete(t);
    return A.size === 0 && this.#e.delete(e), n;
  }
}
const ts = new S_(), nx = (r, e) => {
  const t = r?.ownerDocument || document, A = t.createElementNS(r.namespaceURI, r.nodeName);
  if (Array.from(r.attributes).forEach((n) => {
    n.namespaceURI ? A.setAttributeNS(n.namespaceURI, n.name, n.value) : A.setAttribute(n.name, n.value);
  }), A.removeAttribute("id"), A.id = e(), r.childNodes.forEach((n) => {
    switch (n.nodeType) {
      case 1:
        A.append(nx(n, e));
        break;
      case 3:
      // text node
      case 4:
        A.append(t.createTextNode(n.nodeValue ?? ""));
        break;
    }
  }), ts.has(r, "gsvg")) {
    const n = A.firstElementChild || A.firstChild;
    n && ts.put(A, "gsvg", n);
  }
  return ts.has(r, "symbol") && ts.put(A, "symbol", ts.get(r, "symbol")), ts.has(r, "ref") && ts.put(A, "ref", ts.get(r, "ref")), A.tagName === "image" && ev(A), A;
};
const x_ = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use".split(
  ","
), Ua = {
  LET_DOCUMENT_DECIDE: 0,
  ALWAYS_RANDOMIZE: 1,
  NEVER_RANDOMIZE: 2
};
let jl = Ua.LET_DOCUMENT_DECIDE, rh = [];
const gu = (r) => r || new W0(Bt.undoMgr), E_ = (r) => {
  const e = r.querySelector("title");
  return e ? e.textContent : "";
}, F_ = (r) => r.classList.contains("layer"), Zf = (r) => {
  let e = 1;
  for (; r.includes(`Layer ${e}`); )
    e++;
  return `Layer ${e}`;
};
class X0 {
  /**
   * @param {SVGSVGElement} svgElem - The SVG DOM Element that this JS object
   *     encapsulates.  If the svgElem has a se:nonce attribute on it, then
   *     IDs will use the nonce as they are generated.
   * @param {string} [optIdPrefix=svg_] - The ID prefix to use.
   * @throws {Error} If not initialized with an SVG element
   */
  constructor(e, t) {
    if (!e || !e.tagName || !e.namespaceURI || e.tagName !== "svg" || e.namespaceURI !== et.SVG)
      throw new Error(
        "Error: svgedit.draw.Drawing instance initialized without a <svg> element"
      );
    this.svgElem_ = e, this.obj_num = 0, this.idPrefix = t || "svg_", this.releasedNums = [], this.all_layers = [], this.layer_map = {}, this.current_layer = null, this.nonce_ = "";
    const A = this.svgElem_.getAttributeNS(et.SE, "nonce");
    A && jl !== Ua.NEVER_RANDOMIZE ? this.nonce_ = A : jl === Ua.ALWAYS_RANDOMIZE && this.setNonce(Math.floor(Math.random() * 100001));
  }
  /**
   * @param {string} id Element ID to retrieve
   * @returns {Element} SVG element within the root SVGSVGElement
   */
  getElem_(e) {
    return this.svgElem_.querySelector ? this.svgElem_.querySelector(`#${e}`) : this.svgElem_.querySelector(`[id=${e}]`);
  }
  /**
   * @returns {SVGSVGElement}
   */
  getSvgElem() {
    return this.svgElem_;
  }
  /**
   * @returns {!(string|Integer)} The previously set nonce
   */
  getNonce() {
    return this.nonce_;
  }
  /**
   * @param {!(string|Integer)} n The nonce to set
   * @returns {void}
   */
  setNonce(e) {
    this.svgElem_.setAttributeNS(et.XMLNS, "xmlns:se", et.SE), this.svgElem_.setAttributeNS(et.SE, "se:nonce", e), this.nonce_ = e;
  }
  /**
   * Clears any previously set nonce.
   * @returns {void}
   */
  clearNonce() {
    this.nonce_ = "";
  }
  /**
   * Returns the latest object id as a string.
   * @returns {string} The latest object Id.
   */
  getId() {
    return this.nonce_ ? `${this.idPrefix}${this.nonce_}_${this.obj_num}` : this.idPrefix + this.obj_num;
  }
  /**
   * Returns the next object Id as a string.
   * @returns {string} The next object Id to use.
   */
  getNextId() {
    const e = this.obj_num;
    let t = !1;
    this.releasedNums.length > 0 ? (this.obj_num = this.releasedNums.pop(), t = !0) : this.obj_num++;
    let A = this.getId();
    for (; this.getElem_(A); )
      t && (this.obj_num = e, t = !1), this.obj_num++, A = this.getId();
    return t && (this.obj_num = e), A;
  }
  /**
   * Releases the object Id, letting it be used as the next id in getNextId().
   * This method DOES NOT remove any elements from the DOM, it is expected
   * that client code will do this.
   * @param {string} id - The id to release.
   * @returns {boolean} True if the id was valid to be released, false otherwise.
   */
  releaseId(e) {
    const t = `${this.idPrefix}${this.nonce_ ? `${this.nonce_}_` : ""}`;
    if (typeof e != "string" || !e.startsWith(t))
      return !1;
    const A = e.slice(t.length);
    if (!/^[0-9]+$/.test(A))
      return !1;
    const n = Number.parseInt(A);
    return typeof n != "number" || n <= 0 || this.releasedNums.includes(n) ? !1 : (this.releasedNums.push(n), !0);
  }
  /**
   * Returns the number of layers in the current drawing.
   * @returns {Integer} The number of layers in the current drawing.
   */
  getNumLayers() {
    return this.all_layers.length;
  }
  /**
   * Check if layer with given name already exists.
   * @param {string} name - The layer name to check
   * @returns {boolean}
   */
  hasLayer(e) {
    return this.layer_map[e] !== void 0;
  }
  /**
   * Returns the name of the ith layer. If the index is out of range, an empty string is returned.
   * @param {Integer} i - The zero-based index of the layer you are querying.
   * @returns {string} The name of the ith layer (or the empty string if none found)
   */
  getLayerName(e) {
    return e >= 0 && e < this.getNumLayers() ? this.all_layers[e].getName() : "";
  }
  /**
   * @returns {SVGGElement|null} The SVGGElement representing the current layer.
   */
  getCurrentLayer() {
    return this.current_layer ? this.current_layer.getGroup() : null;
  }
  /**
   * Get a layer by name.
   * @param {string} name
   * @returns {SVGGElement} The SVGGElement representing the named layer or null.
   */
  getLayerByName(e) {
    const t = this.layer_map[e];
    return t ? t.getGroup() : null;
  }
  /**
   * Returns the name of the currently selected layer. If an error occurs, an empty string
   * is returned.
   * @returns {string} The name of the currently active layer (or the empty string if none found).
   */
  getCurrentLayerName() {
    return this.current_layer ? this.current_layer.getName() : "";
  }
  /**
   * Set the current layer's name.
   * @param {string} name - The new name.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {string|null} The new name if changed; otherwise, null.
   */
  setCurrentLayerName(e, t) {
    let A = null;
    if (this.current_layer) {
      const n = this.current_layer.getName();
      A = this.current_layer.setName(e, t), A && (delete this.layer_map[n], this.layer_map[A] = this.current_layer);
    }
    return A;
  }
  /**
   * Set the current layer's position.
   * @param {Integer} newpos - The zero-based index of the new position of the layer. Range should be 0 to layers-1
   * @returns {{title: SVGGElement, previousName: string}|null} If the name was changed, returns {title:SVGGElement, previousName:string}; otherwise null.
   */
  setCurrentLayerPosition(e) {
    const t = this.getNumLayers();
    if (!this.current_layer || e < 0 || e >= t)
      return null;
    const A = this.indexCurrentLayer();
    if (A === -1 || A === e)
      return null;
    const n = this.current_layer.getGroup(), i = n.nextSibling;
    let s = null;
    return e > A ? e < t - 1 && (s = this.all_layers[e + 1].getGroup()) : s = this.all_layers[e].getGroup(), this.svgElem_.insertBefore(n, s), this.identifyLayers(), this.setCurrentLayer(this.getLayerName(e)), {
      currentGroup: n,
      oldNextSibling: i
    };
  }
  /**
   * @param {module:history.HistoryRecordingService} hrService
   * @returns {void}
   */
  mergeLayer(e) {
    const t = this.current_layer.getGroup(), A = t.previousElementSibling;
    if (!A)
      return;
    e.startBatchCommand("Merge Layer");
    const n = t.nextSibling;
    for (e.removeElement(t, n, this.svgElem_); t.firstChild; ) {
      const s = t.firstChild;
      if (s.localName === "title") {
        e.removeElement(s, s.nextSibling, t), s.remove();
        continue;
      }
      const a = s.nextSibling;
      A.append(s), e.moveElement(s, a, t);
    }
    this.current_layer.removeGroup();
    const i = this.indexCurrentLayer();
    if (i > 0) {
      const s = this.current_layer.getName();
      this.current_layer = this.all_layers[i - 1], this.all_layers.splice(i, 1), delete this.layer_map[s];
    }
    e.endBatchCommand();
  }
  /**
   * @param {module:history.HistoryRecordingService} hrService
   * @returns {void}
   */
  mergeAllLayers(e) {
    for (this.current_layer = this.all_layers[this.all_layers.length - 1], e.startBatchCommand("Merge all Layers"); this.all_layers.length > 1; )
      this.mergeLayer(e);
    e.endBatchCommand();
  }
  /**
   * Sets the current layer. If the name is not a valid layer name, then this
   * function returns `false`. Otherwise it returns `true`. This is not an
   * undo-able action.
   * @param {string} name - The name of the layer you want to switch to.
   * @returns {boolean} `true` if the current layer was switched, otherwise `false`
   */
  setCurrentLayer(e) {
    const t = this.layer_map[e];
    return t ? (this.current_layer && this.current_layer.deactivate(), this.current_layer = t, this.current_layer.activate(), !0) : !1;
  }
  /**
   * Sets the current layer. If the name is not a valid layer name, then this
   * function returns `false`. Otherwise it returns `true`. This is not an
   * undo-able action.
   * @param {string} name - The name of the layer you want to switch to.
   * @returns {boolean} `true` if the current layer was switched, otherwise `false`
   */
  indexCurrentLayer() {
    return this.all_layers.indexOf(this.current_layer);
  }
  /**
   * Deletes the current layer from the drawing and then clears the selection.
   * This function then calls the 'changed' handler.  This is an undoable action.
   * @todo Does this actually call the 'changed' handler?
   * @returns {SVGGElement} The SVGGElement of the layer removed or null.
   */
  deleteCurrentLayer() {
    if (this.current_layer && this.getNumLayers() > 1) {
      const e = this.current_layer.removeGroup();
      return this.identifyLayers(), e;
    }
    return null;
  }
  /**
   * Updates layer system and sets the current layer to the
   * top-most layer (last `<g>` child of this drawing).
   * @returns {void}
   */
  identifyLayers() {
    this.all_layers = [], this.layer_map = {};
    const e = this.svgElem_.childNodes.length, t = [], A = [];
    let n = null, i = !1;
    for (let s = 0; s < e; ++s) {
      const a = this.svgElem_.childNodes.item(s);
      if (a?.nodeType === 1)
        if (a.tagName === "g")
          if (i = !0, F_(a)) {
            const o = E_(a);
            A.push(o), n = new Sn(o, a), this.all_layers.push(n), this.layer_map[o] = n;
          } else
            t.push(a);
        else x_.includes(a.nodeName) && t.push(a);
    }
    if (t.length > 0 || !i) {
      const s = Zf(A);
      n = new Sn(s, null, this.svgElem_), n.appendChildren(t), this.all_layers.push(n), this.layer_map[s] = n;
    } else
      n.activate();
    this.current_layer = n;
  }
  /**
   * Creates a new top-level layer in the drawing with the given name and
   * makes it the current layer.
   * @param {string} name - The given name. If the layer name exists, a new name will be generated.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {SVGGElement} The SVGGElement of the new layer, which is
   *     also the current layer of this drawing.
   */
  createLayer(e, t) {
    this.current_layer && this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = Zf(Object.keys(this.layer_map)));
    const A = new Sn(e, null, this.svgElem_);
    return t && (t.startBatchCommand("Create Layer"), t.insertElement(A.getGroup()), t.endBatchCommand()), this.all_layers.push(A), this.layer_map[e] = A, this.current_layer = A, A.getGroup();
  }
  /**
   * Creates a copy of the current layer with the given name and makes it the current layer.
   * @param {string} name - The given name. If the layer name exists, a new name will be generated.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {SVGGElement} The SVGGElement of the new layer, which is
   *     also the current layer of this drawing.
   */
  cloneLayer(e, t) {
    if (!this.current_layer)
      return null;
    this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = Zf(Object.keys(this.layer_map)));
    const A = this.current_layer.getGroup(), n = new Sn(e, A, this.svgElem_), i = n.getGroup();
    [...A.childNodes].forEach((o) => {
      if (o.nodeType !== 1) {
        i.append(o.cloneNode(!0));
        return;
      }
      o.localName !== "title" && i.append(this.copyElem(o));
    }), t && (t.startBatchCommand("Duplicate Layer"), t.insertElement(i), t.endBatchCommand());
    const a = this.indexCurrentLayer();
    return a >= 0 ? this.all_layers.splice(a + 1, 0, n) : this.all_layers.push(n), this.layer_map[e] = n, this.current_layer = n, i;
  }
  /**
   * Returns whether the layer is visible.  If the layer name is not valid,
   * then this function returns `false`.
   * @param {string} layerName - The name of the layer which you want to query.
   * @returns {boolean} The visibility state of the layer, or `false` if the layer name was invalid.
   */
  getLayerVisibility(e) {
    const t = this.layer_map[e];
    return t ? t.isVisible() : !1;
  }
  /**
   * Sets the visibility of the layer. If the layer name is not valid, this
   * function returns `null`, otherwise it returns the `SVGElement` representing
   * the layer. This is an undo-able action.
   * @param {string} layerName - The name of the layer to change the visibility
   * @param {boolean} bVisible - Whether the layer should be visible
   * @returns {?SVGGElement} The SVGGElement representing the layer if the
   *   `layerName` was valid, otherwise `null`.
   */
  setLayerVisibility(e, t) {
    if (typeof t != "boolean")
      return null;
    const A = this.layer_map[e];
    return A ? (A.setVisible(t), A.getGroup()) : null;
  }
  /**
   * Returns the opacity of the given layer.  If the input name is not a layer, `null` is returned.
   * @param {string} layerName - name of the layer on which to get the opacity
   * @returns {?Float} The opacity value of the given layer.  This will be a value between 0.0 and 1.0, or `null`
   * if `layerName` is not a valid layer
   */
  getLayerOpacity(e) {
    const t = this.layer_map[e];
    return t ? t.getOpacity() : null;
  }
  /**
   * Sets the opacity of the given layer.  If the input name is not a layer,
   * nothing happens. If opacity is not a value between 0.0 and 1.0, then
   * nothing happens.
   * NOTE: this function exists solely to apply a highlighting/de-emphasis
   * effect to a layer. When it is possible for a user to affect the opacity
   * of a layer, we will need to allow this function to produce an undo-able
   * action.
   * @param {string} layerName - Name of the layer on which to set the opacity
   * @param {Float} opacity - A float value in the range 0.0-1.0
   * @returns {void}
   */
  setLayerOpacity(e, t) {
    if (typeof t != "number" || t < 0 || t > 1)
      return;
    const A = this.layer_map[e];
    A && A.setOpacity(t);
  }
  /**
   * Create a clone of an element, updating its ID and its children's IDs when needed.
   * @param {Element} el - DOM element to clone
   * @returns {Element}
   */
  copyElem(e) {
    return nx(e, () => this.getNextId());
  }
}
const j1 = (r, e) => {
  jl = r === !1 ? Ua.NEVER_RANDOMIZE : Ua.ALWAYS_RANDOMIZE, jl === Ua.ALWAYS_RANDOMIZE && !e.getNonce() ? e.setNonce(Math.floor(Math.random() * 100001)) : jl === Ua.NEVER_RANDOMIZE && e.getNonce() && e.clearNonce();
};
let Bt;
const __ = (r) => {
  Bt = r;
}, ql = () => {
  $s(), Bt.getCurrentDrawing().identifyLayers();
}, U_ = () => Bt.getCurrentDrawing().indexCurrentLayer(), I_ = (r, e) => {
  const t = Bt.getCurrentDrawing().createLayer(r, gu(e));
  Bt.clearSelection(), Bt.call("changed", [t]);
}, Q_ = (r, e) => {
  const t = Bt.getCurrentDrawing().cloneLayer(r, gu(e));
  if (!t) {
    kA("cloneLayer: no layer returned", null, "draw");
    return;
  }
  Bt.clearSelection(), $s(), Bt.call("changed", [t]);
}, L_ = () => {
  const { BatchCommand: r, RemoveElementCommand: e } = Bt.history, t = Bt.getCurrentDrawing().getCurrentLayer();
  if (!t)
    return kA("deleteCurrentLayer: no current layer", null, "draw"), !1;
  const { nextSibling: A } = t, n = t.parentNode, i = Bt.getCurrentDrawing().deleteCurrentLayer();
  if (i && n) {
    const s = new r("Delete Layer");
    return s.addSubCommand(
      new e(i, A, n)
    ), Bt.addCommandToHistory(s), Bt.clearSelection(), Bt.call("changed", [n]), !0;
  }
  return !1;
}, N_ = (r) => {
  const e = Bt.getCurrentDrawing().setCurrentLayer(Gl(r));
  return e && Bt.clearSelection(), e;
}, T_ = (r) => {
  const e = Bt.getCurrentDrawing(), t = e.getCurrentLayer();
  return t && e.setCurrentLayerName(
    r,
    gu()
  ) ? (Bt.call("changed", [t]), !0) : !1;
}, P_ = (r) => {
  const { MoveElementCommand: e } = Bt.history, A = Bt.getCurrentDrawing().setCurrentLayerPosition(r);
  return A ? (Bt.addCommandToHistory(
    new e(
      A.currentGroup,
      A.oldNextSibling,
      Bt.getSvgContent()
    )
  ), !0) : !1;
}, O_ = (r, e) => {
  const { ChangeElementCommand: t } = Bt.history, A = Bt.getCurrentDrawing(), n = A.getLayerByName(r);
  if (!n)
    return kA("setLayerVisibility: layer not found", r, "draw"), !1;
  const i = n.getAttribute("display"), s = A.setLayerVisibility(r, e);
  return s ? (Bt.addCommandToHistory(
    new t(s, { display: i }, "Layer Visibility")
  ), s === A.getCurrentLayer() && (Bt.clearSelection(), Bt.pathActions.clear()), !0) : !1;
}, M_ = (r) => {
  const { BatchCommand: e, MoveElementCommand: t } = Bt.history, n = Bt.getCurrentDrawing().getLayerByName(r);
  if (!n)
    return !1;
  const i = new e("Move Elements to Layer"), s = Bt.getSelectedElements();
  let a = s.length;
  for (; a--; ) {
    const o = s[a], l = o?.parentNode;
    if (!o || !l || l === n)
      continue;
    const u = o.nextSibling;
    n.append(o), i.addSubCommand(
      new t(o, u, l)
    );
  }
  return i.isEmpty() ? (kA("moveSelectedToLayer: no elements moved", null, "draw"), !1) : (Bt.addCommandToHistory(i), !0);
}, R_ = (r) => {
  Bt.getCurrentDrawing().mergeLayer(gu(r)), Bt.clearSelection(), $s(), Bt.changeSvgContent();
}, k_ = (r) => {
  Bt.getCurrentDrawing().mergeAllLayers(gu(r)), Bt.clearSelection(), $s(), Bt.changeSvgContent();
}, $s = () => {
  const r = rh.length, e = Bt.getDataStorage();
  if (r) {
    for (let t = 0; t < r; t++) {
      const A = rh[t], n = e.get(A, "orig_opac");
      n == null ? A.removeAttribute("opacity") : A.setAttribute("opacity", n), A.setAttribute("style", "pointer-events: inherit"), e.remove(A, "orig_opac");
    }
    rh = [], Bt.clearSelection(!0), Bt.call("contextset", null);
  }
  Bt.setCurrentGroup(null);
}, ix = (r) => {
  const e = Bt.getDataStorage();
  if ($s(), typeof r == "string") {
    const n = r;
    try {
      r = Jt(n);
    } catch {
      r = null;
    }
    if (!r && typeof document < "u") {
      const i = document.getElementById(n), s = Bt.getSvgContent?.();
      r = i && (!s || s.contains(i)) ? i : null;
    }
  }
  if (!r)
    return;
  Bt.setCurrentGroup(r);
  const t = K4(r, "#svgcontent");
  if (!t)
    return;
  const A = [];
  t.forEach(function(n) {
    if (!n?.parentNode)
      return;
    Array.prototype.filter.call(
      n.parentNode.children,
      function(s) {
        return s !== n;
      }
    ).forEach(function(s) {
      A.push(s);
    });
  }), A.forEach(function(n) {
    const i = n.getAttribute("opacity");
    e.put(n, "orig_opac", i);
    const s = Number.parseFloat(i), a = Number.isFinite(s) ? s : 1;
    n.setAttribute("opacity", a * 0.33), n.setAttribute("style", "pointer-events: none"), rh.push(n);
  }), Bt.clearSelection(), Bt.call("contextset", Bt.getCurrentGroup());
}, {
  InsertElementCommand: H_,
  BatchCommand: D_
} = Va;
let Nn = null;
const G_ = (r) => {
  Nn = r;
}, V_ = (r, e, t) => {
  const A = sessionStorage.getItem(Nn.getClipboardID());
  let n;
  try {
    n = JSON.parse(A);
  } catch {
    return;
  }
  if (!Array.isArray(n) || !n.length) return;
  const i = [], s = new D_("Paste elements"), a = {}, o = (c) => {
    c.attr?.id && (a[c.attr.id] = Nn.getNextId(), c.attr.id = a[c.attr.id]), c.children && c.children.forEach((f) => o(f));
  };
  n.forEach((c) => o(c));
  const l = (c) => {
    const f = c?.attr;
    if (f)
      for (const [h, g] of Object.entries(f)) {
        if (typeof g != "string" || !g) continue;
        if ((h === "href" || h === "xlink:href") && g.startsWith("#")) {
          const v = g.slice(1);
          v in a && (f[h] = `#${a[v]}`);
        }
        const p = eu(g);
        if (p) {
          const v = p.slice(1);
          v in a && (f[h] = g.replace(p, `#${a[v]}`));
        }
      }
    c.children && c.children.forEach((h) => l(h));
  };
  n.forEach((c) => l(c)), Nn.runExtensions(
    "IDsUpdated",
    /** @type {module:svgcanvas.SvgCanvas#event:ext_IDsUpdated} */
    { elems: n, changes: a },
    !0
  ).forEach(function(c) {
    !c || !("remove" in c) || c.remove.forEach(function(f) {
      n = n.filter(function(h) {
        return h?.attr?.id !== f;
      });
    });
  });
  let u = n.length;
  if (u) {
    for (; u--; ) {
      const c = n[u];
      if (!c)
        continue;
      const f = Nn.addSVGElementsFromJson(c);
      i.push(f), s.addSubCommand(new H_(f)), Nn.restoreRefElements(f);
    }
    if (i.length) {
      if (Nn.selectOnly(i), r !== "in_place") {
        let c, f;
        r ? r === "point" && (c = e, f = t) : (c = Nn.getLastClickPoint("x"), f = Nn.getLastClickPoint("y"));
        const h = Hn(i);
        if (h && Number.isFinite(c) && Number.isFinite(f)) {
          const g = c - (h.x + h.width / 2), p = f - (h.y + h.height / 2), v = [], w = [];
          i.forEach(function(S) {
            v.push(g), w.push(p);
          });
          const b = Nn.moveSelectedElements(v, w, !1);
          b && s.addSubCommand(b);
        }
      }
      Nn.addCommandToHistory(s), Nn.call("changed", i);
    }
  }
}, pc = (r) => {
  r.preventDefault();
  const { changedTouches: e } = r, t = e[0];
  let A = "";
  switch (r.type) {
    case "touchstart":
      A = "mousedown";
      break;
    case "touchmove":
      A = "mousemove";
      break;
    case "touchend":
      A = "mouseup";
      break;
    default:
      return;
  }
  const { screenX: n, screenY: i, clientX: s, clientY: a } = t, o = new MouseEvent(A, {
    // Event interface
    bubbles: !0,
    cancelable: !0,
    // UIEvent interface
    view: window,
    detail: 1,
    // click count
    // MouseEvent interface (customized)
    screenX: n,
    screenY: i,
    clientX: s,
    clientY: a,
    // MouseEvent interface (defaults) - these could be removed
    ctrlKey: !1,
    altKey: !1,
    shiftKey: !1,
    metaKey: !1,
    button: 0,
    // main button (usually left)
    relatedTarget: null
  });
  e.length < 2 && t.target.dispatchEvent(o);
}, K_ = (r) => {
  r.svgroot.addEventListener("touchstart", pc), r.svgroot.addEventListener("touchmove", pc), r.svgroot.addEventListener("touchend", pc), r.svgroot.addEventListener("touchcancel", pc);
};
const j_ = (r, e) => r.importNode(
  Zm(
    `<svg id="svgroot" xmlns="${et.SVG}" xlinkns="${et.XLINK}" width="${e[0]}" 
        height="${e[1]}" x="${e[0]}" y="${e[1]}" overflow="visible">
        <defs>
          <filter id="canvashadow" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
            <feOffset in="blur" dx="5" dy="5" result="offsetBlur"/>
            <feMerge>
              <feMergeNode in="offsetBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
      </svg>`
  ).documentElement,
  !0
);
const ed = "http://www.w3.org/2000/svg";
class q_ {
  #e = navigator.userAgent;
  #t = /* @__PURE__ */ new Map();
  /**
   * Detects if the browser is WebKit-based
   * @returns {boolean}
   */
  get isWebkit() {
    return this.#t.has("isWebkit") || this.#t.set("isWebkit", this.#e.includes("AppleWebKit")), this.#t.get("isWebkit");
  }
  /**
   * Detects if the browser is Gecko-based
   * @returns {boolean}
   */
  get isGecko() {
    return this.#t.has("isGecko") || this.#t.set("isGecko", this.#e.includes("Gecko/")), this.#t.get("isGecko");
  }
  /**
   * Detects if the browser is Chrome
   * @returns {boolean}
   */
  get isChrome() {
    return this.#t.has("isChrome") || this.#t.set("isChrome", this.#e.includes("Chrome/")), this.#t.get("isChrome");
  }
  /**
   * Detects if the platform is macOS
   * @returns {boolean}
   */
  get isMac() {
    return this.#t.has("isMac") || this.#t.set("isMac", this.#e.includes("Macintosh")), this.#t.get("isMac");
  }
  /**
   * Tests if the browser supports accurate text character positioning
   * @returns {boolean}
   */
  get supportsGoodTextCharPos() {
    return this.#t.has("supportsGoodTextCharPos") || this.#t.set("supportsGoodTextCharPos", this.#r()), this.#t.get("supportsGoodTextCharPos");
  }
  /**
   * Private method to test text character positioning support
   * @returns {boolean}
   */
  #r() {
    const e = document.createElementNS(ed, "svg"), t = document.createElementNS(ed, "svg");
    document.documentElement.append(e), t.setAttribute("x", 5), e.append(t);
    const A = document.createElementNS(ed, "text");
    A.textContent = "a", t.append(A);
    try {
      return A.getStartPositionOfChar(0).x === 0;
    } catch {
      return !1;
    } finally {
      e.remove();
    }
  }
}
const kh = new q_(), sx = () => kh.isWebkit, Na = () => kh.isGecko, z_ = () => kh.isChrome, W_ = () => kh.supportsGoodTextCharPos;
const {
  UndoManager: X_,
  HistoryEventTypes: Y_
} = Va;
let Kt = null;
const $_ = (r) => {
  Kt = r, r.undoMgr = J_();
}, J_ = () => new X_({
  /**
   * @param {string} eventType One of the HistoryEvent types
   * @param {module:history.HistoryCommand} cmd Fulfills the HistoryCommand interface
   * @fires module:undo.SvgCanvas#event:changed
   * @returns {void}
   */
  handleHistoryEvent(r, e) {
    const t = Y_;
    if (r === t.BEFORE_UNAPPLY || r === t.BEFORE_APPLY)
      Kt.clearSelection();
    else if (r === t.AFTER_APPLY || r === t.AFTER_UNAPPLY) {
      const A = e.type(), n = r === t.AFTER_APPLY;
      if (A === "ChangeElementCommand" && e.elem === Kt.getSvgContent()) {
        const s = n ? e.newValues : e.oldValues;
        if (s.width !== null && s.width !== void 0 && s.width !== "") {
          const a = Number(s.width);
          Number.isFinite(a) && a > 0 && (Kt.contentW = a);
        }
        if (s.height !== null && s.height !== void 0 && s.height !== "") {
          const a = Number(s.height);
          Number.isFinite(a) && a > 0 && (Kt.contentH = a);
        }
      }
      const i = e.elements();
      if (Kt.pathActions.clear(), Kt.call("changed", i), A === "MoveElementCommand")
        (n ? e.newParent : e.oldParent) === Kt.getSvgContent() && ql();
      else if (A === "InsertElementCommand" || A === "RemoveElementCommand")
        e.parent === Kt.getSvgContent() && ql(), A === "InsertElementCommand" ? n && Kt.restoreRefElements(e.elem) : n || Kt.restoreRefElements(e.elem), e.elem?.tagName === "use" && Kt.setUseData(e.elem);
      else if (A === "ChangeElementCommand") {
        e.elem.tagName === "title" && e.elem.parentNode.parentNode === Kt.getSvgContent() && ql();
        const s = n ? e.newValues : e.oldValues;
        if (s.stdDeviation && Kt.setBlurOffsets(e.elem.parentNode, s.stdDeviation), e.elem.tagName === "text") {
          const [a, o] = [
            e.newValues.x - e.oldValues.x,
            e.newValues.y - e.oldValues.y
          ], l = e.elem.children;
          for (let u = 0; u < l.length; u++) {
            let c = Number(l[u].getAttribute("x")), f = Number(l[u].getAttribute("y"));
            const h = r === t.AFTER_UNAPPLY;
            c = h ? c - a : c + a, f = h ? f - o : f + o, l[u].setAttribute("x", c), l[u].setAttribute("y", f);
          }
        }
      }
    }
  }
}), q1 = (r) => {
  if (!Na())
    return r;
  const e = r.cloneNode(!0);
  return r.before(e), r.remove(), Kt.selectorManager.releaseSelector(r), Kt.setSelectedElements(0, e), Kt.selectorManager.requestSelector(e).showGrips(!0), e;
}, ax = (r, e, t) => {
  if (r === "id") {
    const a = t[0], o = a.id;
    o !== e && (Kt.clearSelection(), a.id = e, Kt.addToSelection([a], !0), Kt.call("elementRenamed", { elem: a, oldId: o, newId: e }));
    return;
  }
  const A = Kt.getSelectedElements(), n = Kt.getZoom();
  Kt.getCurrentMode() === "pathedit" && Kt.pathActions.moveNode(r, e), t = t ?? A;
  let i = t.length;
  const s = ["g", "polyline", "path"];
  for (; i--; ) {
    let a = t[i];
    if (!a)
      continue;
    if ((r === "x" || r === "y") && s.includes(a.tagName)) {
      const l = Hn([a]), u = r === "x" ? parseFloat(e) - l.x : 0, c = r === "y" ? parseFloat(e) - l.y : 0;
      Kt.moveSelectedElements(u * n, c * n, !0);
      continue;
    }
    let o = r === "#text" ? a.textContent : a.getAttribute(r);
    if (o || (o = ""), o !== String(e)) {
      r === "#text" ? (a.textContent = e, /rotate/.test(a.getAttribute("transform")) && (a = q1(a))) : r === "#href" ? Dn(a, e) : e ? a.setAttribute(r, isNaN(parseFloat(e)) ? e : parseFloat(e)) : typeof e == "number" ? a.setAttribute(r, e) : a.removeAttribute(r), Kt.getCurrentMode() === "textedit" && r !== "#text" && a.textContent.length && Kt.textActions.toSelectMode(a), Na() && a.nodeName === "text" && /rotate/.test(a.getAttribute("transform")) && (String(e).startsWith("url") || ["font-size", "font-family", "x", "y"].includes(r) && a.textContent) && (a = q1(a)), A.includes(a) && setTimeout(function() {
        a.parentNode && Kt.selectorManager.requestSelector(a).resize();
      }, 0);
      const l = bA(a);
      if (l !== 0 && r !== "transform") {
        const u = jt(a);
        let c = u.numberOfItems;
        for (; c--; )
          if (u.getItem(c).type === 4) {
            u.removeItem(c);
            const h = Ir(a), g = Rt(
              h.x + h.width / 2,
              h.y + h.height / 2,
              Ht(u).matrix
            ), p = g.x, v = g.y, w = Kt.getSvgRoot().createSVGTransform();
            w.setRotate(l, p, v), u.insertItemBefore(w, c);
            break;
          }
      }
    }
  }
}, Z_ = (r, e, t) => {
  const A = Kt.getSelectedElements();
  t = t || A, Kt.undoMgr.beginUndoableChange(r, t), ax(r, e, t);
  const n = Kt.undoMgr.finishUndoableChange();
  n.isEmpty() || Kt.undoMgr.addCommandToHistory(n);
};
const { BatchCommand: eU } = Va;
let gt = null;
const tU = (r) => {
  gt = r, gt.getMouseTarget = nU, gt.clearSelection = rU, gt.addToSelection = AU, gt.getIntersectionList = aU, gt.runExtensions = iU, gt.groupSvgElem = oU, gt.prepareSvg = lU, gt.recalculateAllSelectedDimensions = cU, gt.setRotationAngle = uU;
}, rU = (r) => {
  gt.getSelectedElements().forEach((t) => {
    t && gt.selectorManager.releaseSelector(t);
  }), gt?.setEmptySelectedElements(), r || gt.call("selected", gt.getSelectedElements());
}, AU = (r, e) => {
  const t = gt.getSelectedElements();
  if (!r.length)
    return;
  let A = 0;
  for (; A < t.length && t[A] !== null; )
    ++A;
  let n = r.length;
  for (; n--; ) {
    let i = r[n];
    if (!(!i || !i.getBBox) && (i.tagName === "a" && i.childNodes.length === 1 && (i = i.firstChild), !t.includes(i))) {
      t[A] = i, A++;
      const s = gt.selectorManager.requestSelector(i);
      t.length > 1 && s.showGrips(!1);
    }
  }
  if (t.length)
    for (gt.call("selected", t), t.length === 1 && gt.selectorManager.requestSelector(t[0]).showGrips(e), t.sort((i, s) => i && s && i.compareDocumentPosition ? 3 - (s.compareDocumentPosition(i) & 6) : i ? 0 : 1); !t[0]; )
      t.shift(0);
}, nU = (r) => {
  if (!r)
    return null;
  let e = r.target;
  if (e.correspondingUseElement && (e = e.correspondingUseElement), [et.MATH, et.HTML].includes(e.namespaceURI) && e.id !== "svgcanvas") {
    for (; e.nodeName !== "foreignObject"; )
      if (e = e.parentNode, !e)
        return gt.getSvgRoot();
  }
  const t = gt.getCurrentDrawing().getCurrentLayer(), A = gt.getSvgRoot(), n = gt.getDOMContainer(), i = gt.getSvgContent();
  if ([A, n, i, t].includes(e))
    return gt.getSvgRoot();
  if (cu(e.parentNode, "#selectorParentGroup"))
    return gt.selectorManager.selectorParentGroup;
  for (; !e?.parentNode?.isSameNode(
    gt.getCurrentGroup() || t
  ); )
    e = e.parentNode;
  return e;
}, iU = (r, e, t) => {
  let A = t ? [] : !1;
  for (const [n, i] of Object.entries(gt.getExtensions()))
    if (typeof e == "function" && (e = e(n)), i.eventBased) {
      const s = new CustomEvent("svgedit", {
        detail: {
          action: r,
          vars: e
        }
      });
      document.dispatchEvent(s);
    } else i[r] && (t ? A.push(i[r](e)) : A = i[r](e));
  return A;
}, sU = (r) => {
  r || (r = gt.getSvgContent().children);
  const e = [], t = r.children;
  return Array.from(t).forEach((A) => {
    A.getBBox && e.push({ elem: A, bbox: Hn([A]) });
  }), e.reverse();
}, aU = (r) => {
  const e = gt.getZoom();
  if (!gt.getRubberBox())
    return null;
  const t = gt.getCurrentGroup() || gt.getCurrentDrawing().getCurrentLayer();
  let A;
  if (r)
    A = gt.getSvgContent().createSVGRect(), A.x = r.x, A.y = r.y, A.width = r.width, A.height = r.height;
  else {
    A = Ir(gt.getRubberBox());
    const s = gt.getSvgContent().createSVGRect();
    ["x", "y", "width", "height", "top", "right", "bottom", "left"].forEach(
      (a) => {
        s[a] = A[a] / e;
      }
    ), A = s;
  }
  const n = [];
  gt.getCurBBoxes().length === 0 && gt.setCurBBoxes(sU(t));
  let i = gt.getCurBBoxes().length;
  for (; i--; ) {
    const s = gt.getCurBBoxes();
    A.width && s[i].bbox && ES(A, s[i].bbox) && n.push(s[i].elem);
  }
  return n;
}, oU = (r) => {
  const e = gt.getDataStorage(), t = document.createElementNS(et.SVG, "g");
  r.replaceWith(t), t.appendChild(r), e.put(t, "gsvg", r), t.id = gt.getNextId();
}, lU = (r) => {
  gt.sanitizeSvg(r.documentElement), [...r.getElementsByTagNameNS(et.SVG, "path")].forEach((t) => {
    const A = gt.pathActions.convertPath(t);
    t.setAttribute("d", A), gt.pathActions.fixEnd(t);
  });
}, uU = (r, e) => {
  const t = gt.getSelectedElements();
  r = Number.parseFloat(r);
  const A = t[0], n = A.getAttribute("transform"), i = Ir(A), s = i.x + i.width / 2, a = i.y + i.height / 2, o = jt(A);
  if (o.numberOfItems > 0 && o.getItem(0).type === 4 && o.removeItem(0), r !== 0) {
    const u = Rt(
      s,
      a,
      Ht(o).matrix
    ), c = Number.isFinite(u.x) ? u.x : s, f = Number.isFinite(u.y) ? u.y : a, h = gt.getSvgRoot().createSVGTransform();
    h.setRotate(r, c, f), o.numberOfItems ? o.insertItemBefore(h, 0) : o.appendItem(h);
  } else o.numberOfItems === 0 && A.removeAttribute("transform");
  if (!e) {
    let u = A.getAttribute("transform");
    if (u && u.startsWith("rotate(")) {
      const c = u.match(/^rotate\(([\d.\-e]+)\s+([\d.\-e]+)\s+([\d.\-e]+)\)(.*)/);
      if (c) {
        const f = Number.parseFloat(c[1]), h = (w) => Math.round(Number(w) + Number.EPSILON), g = h(c[2]), p = h(c[3]), v = c[4] || "";
        u = `rotate(${f} ${g} ${p})${v}`;
      }
    }
    n ? A.setAttribute("transform", n) : A.removeAttribute("transform"), gt.changeSelectedAttribute(
      "transform",
      u,
      t
    ), gt.call("changed", t);
  }
  gt.selectorManager.requestSelector(
    t[0]
  ).resize(), gt.getSelector().updateGripCursors(r);
}, cU = () => {
  const r = gt.getCurrentResizeMode() === "none" ? "position" : "size", e = new eU(r), t = gt.getSelectedElements();
  t.forEach((A) => {
    const n = gt.recalculateDimensions(A);
    n && e.addSubCommand(n);
  }), e.isEmpty() || (gt.addCommandToHistory(e), gt.call("changed", t));
};
let wr = null;
const hU = (r) => {
  wr = r;
};
class fU {
  #e = null;
  #t = null;
  #r = null;
  #A = null;
  #s = null;
  #n = [];
  #i = null;
  // , transbb;
  #o = null;
  #h = null;
  #f = null;
  #d = !1;
  /**
   *
   * @param {Integer} index
   * @returns {void}
   * @private
   */
  #u = (e = void 0) => {
    const t = this.#t.value === "";
    if (this.#t.focus(), e === void 0)
      if (t)
        e = 0;
      else {
        if (this.#t.selectionEnd !== this.#t.selectionStart)
          return;
        e = this.#t.selectionEnd;
      }
    const A = this.#n[e];
    t || this.#t.setSelectionRange(e, e), this.#r = Jt("text_cursor"), this.#r || (this.#r = document.createElementNS(et.SVG, "line"), Yt(this.#r, {
      id: "text_cursor",
      stroke: "#333",
      "stroke-width": 1
    }), Jt("selectorParentGroup").append(this.#r)), this.#s || (this.#s = setInterval(() => {
      const s = this.#r.getAttribute("display") === "none";
      this.#r.setAttribute("display", s ? "inline" : "none");
    }, 600));
    const n = this.#a(A.x, this.#i.y), i = this.#a(A.x, this.#i.y + this.#i.height);
    Yt(this.#r, {
      x1: n.x,
      y1: n.y,
      x2: i.x,
      y2: i.y,
      visibility: "visible",
      display: "inline"
    }), this.#A && this.#A.setAttribute("d", "");
  };
  /**
   *
   * @param {Integer} start
   * @param {Integer} end
   * @param {boolean} skipInput
   * @returns {void}
   * @private
   */
  #c = (e, t, A) => {
    if (e === t) {
      this.#u(t);
      return;
    }
    A || this.#t.setSelectionRange(e, t), this.#A = Jt("text_selectblock"), this.#A || (this.#A = document.createElementNS(et.SVG, "path"), Yt(this.#A, {
      id: "text_selectblock",
      fill: "green",
      opacity: 0.5,
      style: "pointer-events:none"
    }), Jt("selectorParentGroup").append(this.#A));
    const n = this.#n[e], i = this.#n[t];
    this.#r.setAttribute("visibility", "hidden");
    const s = this.#a(n.x, this.#i.y), a = this.#a(n.x + (i.x - n.x), this.#i.y), o = this.#a(n.x, this.#i.y + this.#i.height), l = this.#a(
      n.x + (i.x - n.x),
      this.#i.y + this.#i.height
    ), u = "M" + s.x + "," + s.y + " L" + a.x + "," + a.y + " " + l.x + "," + l.y + " " + o.x + "," + o.y + "z";
    Yt(this.#A, {
      d: u,
      display: "inline"
    });
  };
  /**
   *
   * @param {Float} mouseX
   * @param {Float} mouseY
   * @returns {Integer}
   * @private
   */
  #g = (e, t) => {
    const A = wr.getSvgRoot().createSVGPoint();
    if (A.x = e, A.y = t, this.#n.length === 1)
      return 0;
    let n = this.#e.getCharNumAtPosition(A);
    n < 0 ? (n = this.#n.length - 2, e <= this.#n[0].x && (n = 0)) : n >= this.#n.length - 2 && (n = this.#n.length - 2);
    const i = this.#n[n], s = i.x + i.width / 2;
    return e > s && n++, n;
  };
  /**
   *
   * @param {Float} mouseX
   * @param {Float} mouseY
   * @returns {void}
   * @private
   */
  #m = (e, t) => {
    this.#u(this.#g(e, t));
  };
  /**
   *
   * @param {Float} x
   * @param {Float} y
   * @param {boolean} apply
   * @returns {void}
   * @private
   */
  #v = (e, t, A) => {
    const n = this.#t.selectionStart, i = this.#g(e, t), s = Math.min(n, i), a = Math.max(n, i);
    this.#c(s, a, !A);
  };
  /**
   *
   * @param {Float} xIn
   * @param {Float} yIn
   * @returns {module:math.XYObject}
   * @private
   */
  #l = (e, t) => {
    const A = {
      x: e,
      y: t
    }, n = wr.getZoom();
    if (A.x /= n, A.y /= n, this.#o) {
      const i = Rt(A.x, A.y, this.#o.inverse());
      A.x = i.x, A.y = i.y;
    }
    return A;
  };
  /**
   *
   * @param {Float} xIn
   * @param {Float} yIn
   * @returns {module:math.XYObject}
   * @private
   */
  #a = (e, t) => {
    const A = {
      x: e,
      y: t
    };
    if (this.#o) {
      const i = Rt(A.x, A.y, this.#o);
      A.x = i.x, A.y = i.y;
    }
    const n = wr.getZoom();
    return A.x *= n, A.y *= n, A;
  };
  /**
   *
   * @param {Event} evt
   * @returns {void}
   * @private
   */
  #p = (e) => {
    this.#c(0, this.#e.textContent.length), e.target.removeEventListener("click", this.#p);
  };
  /**
   *
   * @param {Event} evt
   * @returns {void}
   * @private
   */
  #w = (e) => {
    if (!this.#d || !this.#e)
      return;
    const t = wr.getZoom(), A = Rt(e.pageX, e.pageY, wr.getrootSctm()), n = A.x * t, i = A.y * t, s = this.#l(n, i), a = this.#g(s.x, s.y), o = this.#e.textContent, l = o.slice(0, a).replace(/[a-z\d]+$/i, "").length, u = o.slice(a).match(/^[a-z\d]+/i), c = (u ? u[0].length : 0) + a;
    this.#c(l, c), wr.$click(e.target, this.#p), setTimeout(() => {
      e.target.removeEventListener("click", this.#p);
    }, 300);
  };
  /**
   * @param {Element} target
   * @param {Float} x
   * @param {Float} y
   * @returns {void}
   */
  select(e, t, A) {
    this.#e = e, wr.textActions.toEditMode(t, A);
  }
  /**
   * @param {Element} elem
   * @returns {void}
   */
  start(e) {
    this.#e = e, wr.textActions.toEditMode();
  }
  /**
   * @param {external:MouseEvent} evt
   * @param {Element} mouseTarget
   * @param {Float} startX
   * @param {Float} startY
   * @returns {void}
   */
  mouseDown(e, t, A, n) {
    const i = this.#l(A, n);
    this.#t.focus(), this.#m(i.x, i.y), this.#h = A, this.#f = n;
  }
  /**
   * @param {Float} mouseX
   * @param {Float} mouseY
   * @returns {void}
   */
  mouseMove(e, t) {
    const A = this.#l(e, t);
    this.#v(A.x, A.y);
  }
  /**
   * @param {external:MouseEvent} evt
   * @param {Float} mouseX
   * @param {Float} mouseY
   * @returns {void}
   */
  mouseUp(e, t, A) {
    const n = this.#l(t, A);
    this.#v(n.x, n.y, !0), e.target !== this.#e && t < this.#h + 2 && t > this.#h - 2 && A < this.#f + 2 && A > this.#f - 2 && wr.textActions.toSelectMode(!0);
  }
  /**
   * @param {Integer} index
   * @returns {void}
   */
  setCursor(e) {
    this.#u(e);
  }
  /**
   * @param {Float} x
   * @param {Float} y
   * @returns {void}
   */
  toEditMode(e, t) {
    if (this.#d = !1, wr.setCurrentMode("textedit"), wr.selectorManager.requestSelector(this.#e).showGrips(!1), wr.selectorManager.requestSelector(this.#e), wr.textActions.init(), this.#e.style.cursor = "text", arguments.length === 0)
      this.#u();
    else {
      const A = this.#l(e, t);
      this.#m(A.x, A.y);
    }
    setTimeout(() => {
      this.#d = !0;
    }, 300);
  }
  /**
   * @param {boolean|Element} selectElem
   * @fires module:svgcanvas.SvgCanvas#event:selected
   * @returns {void}
   */
  toSelectMode(e) {
    wr.setCurrentMode("select"), clearInterval(this.#s), this.#s = null, this.#A && this.#A.setAttribute("display", "none"), this.#r && this.#r.setAttribute("visibility", "hidden"), this.#e.style.cursor = "move", e && (wr.clearSelection(), this.#e.style.cursor = "move", wr.call("selected", [this.#e]), wr.addToSelection([this.#e], !0)), this.#e?.textContent.length || wr.deleteSelectedElements(), this.#t.blur(), this.#e = !1;
  }
  /**
   * @param {Element} elem
   * @returns {void}
   */
  setInputElem(e) {
    this.#t = e;
  }
  /**
   * @returns {void}
   */
  clear() {
    wr.getCurrentMode() === "textedit" && wr.textActions.toSelectMode();
  }
  /**
   * @param {Element} _inputElem Not in use
   * @returns {void}
   */
  init(e) {
    if (!this.#e)
      return;
    let t, A;
    if (!this.#e.parentNode) {
      const a = wr.getSelectedElements();
      this.#e = a[0], wr.selectorManager.requestSelector(this.#e).showGrips(!1);
    }
    const i = this.#e.textContent.length, s = this.#e.getAttribute("transform");
    for (this.#i = Ir(this.#e), this.#o = s ? Jm(this.#e) : null, this.#n = [], this.#n.length = i, this.#t.focus(), this.#e.removeEventListener("dblclick", this.#w), this.#e.addEventListener("dblclick", this.#w), i || (A = { x: this.#i.x + this.#i.width / 2, width: 0 }), t = 0; t < i; t++) {
      const a = this.#e.getStartPositionOfChar(t);
      if (A = this.#e.getEndPositionOfChar(t), !W_()) {
        const o = wr.getZoom(), l = wr.contentW * o;
        a.x -= l, A.x -= l, a.x /= o, A.x /= o;
      }
      this.#n[t] = {
        x: a.x,
        y: this.#i.y,
        // start.y?
        width: A.x - a.x,
        height: this.#i.height
      };
    }
    this.#n.push({
      x: A.x,
      width: 0
    }), this.#c(this.#t.selectionStart, this.#t.selectionEnd, !0);
  }
}
const dU = new fU();
const {
  InsertElementCommand: gU,
  BatchCommand: pU,
  ChangeElementCommand: z1
} = Va;
let I = null, Ah = !1;
const mU = (r) => {
  I = r, I.mouseDownEvent = CU, I.mouseMoveEvent = wU, I.dblClickEvent = BU, I.mouseUpEvent = bU, I.mouseOutEvent = yU, I.DOMMouseScrollEvent = SU;
}, W1 = (r) => {
  const e = { x: 0, y: 0 }, t = { x: I.getControllPoint2("x"), y: I.getControllPoint2("y") }, A = { x: I.getControllPoint1("x"), y: I.getControllPoint1("y") }, n = { x: I.getStart("x"), y: I.getStart("y") }, i = { x: I.getEnd("x"), y: I.getEnd("y") }, s = 1 / 6, a = r * r, o = a * r, l = [
    [-1, 3, -3, 1],
    [3, -6, 3, 0],
    [-3, 0, 3, 0],
    [1, 4, 1, 0]
  ];
  return e.x = s * ((t.x * l[0][0] + A.x * l[0][1] + n.x * l[0][2] + i.x * l[0][3]) * o + (t.x * l[1][0] + A.x * l[1][1] + n.x * l[1][2] + i.x * l[1][3]) * a + (t.x * l[2][0] + A.x * l[2][1] + n.x * l[2][2] + i.x * l[2][3]) * r + (t.x * l[3][0] + A.x * l[3][1] + n.x * l[3][2] + i.x * l[3][3])), e.y = s * ((t.y * l[0][0] + A.y * l[0][1] + n.y * l[0][2] + i.y * l[0][3]) * o + (t.y * l[1][0] + A.y * l[1][1] + n.y * l[1][2] + i.y * l[1][3]) * a + (t.y * l[2][0] + A.y * l[2][1] + n.y * l[2][2] + i.y * l[2][3]) * r + (t.y * l[3][0] + A.y * l[3][1] + n.y * l[3][2] + i.y * l[3][3])), {
    x: e.x,
    y: e.y
  };
}, vU = (r, e, t, A) => {
  const n = r.createSVGTransform();
  n.setTranslate(t, A);
  const i = jt(e);
  i && (i.numberOfItems ? i.getItem(0).type === 2 ? i.replaceItem(n, 0) : i.insertItemBefore(n, 0) : i.appendItem(n));
}, wU = (r) => {
  if (!I.getStarted() || r.button === 1 || I.spaceKey)
    return;
  I.textActions.init(), r.preventDefault();
  const e = I.getSelectedElements(), t = I.getZoom(), A = I.getSvgRoot(), n = e[0];
  let i, s, a, o, l, u, c, f, h;
  const g = Rt(r.clientX, r.clientY, I.getrootSctm()), p = g.x * t, v = g.y * t, w = Jt(I.getId());
  let b = p / t, S = b, B = v / t, x = B;
  I.getCurConfig().gridSnapping && (S = Ot(S), x = Ot(x));
  let U;
  switch (I.getCurrentMode()) {
    case "select": {
      if (!I.hasDragStartTransform && e.length > 0) {
        I.dragStartTransforms = /* @__PURE__ */ new Map();
        for (const Q of e) {
          if (!Q)
            continue;
          I.dragStartTransforms.set(Q, Q.getAttribute("transform") || "");
          const N = jt(Q);
          N && (N.numberOfItems ? N.insertItemBefore(A.createSVGTransform(), 0) : N.appendItem(A.createSVGTransform()));
        }
        I.hasDragStartTransform = !0;
      }
      if (n) {
        l = S - I.getStartX(), u = x - I.getStartY(), I.getCurConfig().gridSnapping && (l = Ot(l), u = Ot(u));
        const Q = 4, N = Math.abs(l) > Q || Math.abs(u) > Q;
        Ah = Ah || N, Ah && (e.forEach((_) => {
          _ && (vU(A, _, l, u), I.selectorManager.requestSelector(_).resize());
        }), I.call("transition", e));
      }
      break;
    }
    case "multiselect": {
      b *= t, B *= t, Yt(I.getRubberBox(), {
        x: Math.min(I.getRStartX(), b),
        y: Math.min(I.getRStartY(), B),
        width: Math.abs(b - I.getRStartX()),
        height: Math.abs(B - I.getRStartY())
      });
      const Q = e.slice(), N = [], _ = I.getIntersectionList();
      for (c = _.length, i = 0; i < c; ++i) {
        const R = _[i];
        e.includes(R) || N.push(R);
        const F = Q.indexOf(R);
        F !== -1 && Q.splice(F, 1);
      }
      Q.length > 0 && I.removeFromSelection(Q), N.length > 0 && I.addToSelection(N);
      break;
    }
    case "resize": {
      if (U = jt(n), !U)
        break;
      const Q = Ra(U);
      h = Q ? I.getInitBbox() : Ir(n);
      let N = h.x, _ = h.y, { width: R, height: F } = h;
      if (l = S - I.getStartX(), u = x - I.getStartY(), I.getCurConfig().gridSnapping && (l = Ot(l), u = Ot(u), F = Ot(F), R = Ot(R)), f = bA(n), f) {
        const le = Math.sqrt(l * l + u * u), se = Math.atan2(u, l) - f * Math.PI / 180;
        l = le * Math.cos(se), u = le * Math.sin(se);
      }
      !I.getCurrentResizeMode().includes("n") && !I.getCurrentResizeMode().includes("s") && (u = 0), !I.getCurrentResizeMode().includes("e") && !I.getCurrentResizeMode().includes("w") && (l = 0);
      let O = 0, G = 0, H = F ? (F + u) / F : 1, $ = R ? (R + l) / R : 1;
      I.getCurrentResizeMode().includes("n") && (H = F ? (F - u) / F : 1, G = F), I.getCurrentResizeMode().includes("w") && ($ = R ? (R - l) / R : 1, O = R);
      const ne = A.createSVGTransform(), te = A.createSVGTransform(), J = A.createSVGTransform();
      if (I.getCurConfig().gridSnapping && (N = Ot(N), O = Ot(O), _ = Ot(_), G = Ot(G)), ne.setTranslate(-(N + O), -(_ + G)), (n.tagName !== "image" && r.shiftKey || n.tagName === "image" && !r.shiftKey) && ($ === 1 ? $ = H : H = $), te.setScale($, H), J.setTranslate(N + O, _ + G), Q) {
        const le = f ? 1 : 0;
        U.replaceItem(ne, 2 + le), U.replaceItem(te, 1 + le), U.replaceItem(J, Number(le));
      } else {
        const le = U.numberOfItems;
        U.replaceItem(J, le - 3), U.replaceItem(te, le - 2), U.replaceItem(ne, le - 1);
      }
      I.selectorManager.requestSelector(n).resize(), I.call("transition", e);
      break;
    }
    case "zoom": {
      b *= t, B *= t, Yt(I.getRubberBox(), {
        x: Math.min(I.getRStartX() * t, b),
        y: Math.min(I.getRStartY() * t, B),
        width: Math.abs(b - I.getRStartX() * t),
        height: Math.abs(B - I.getRStartY() * t)
      });
      break;
    }
    case "text": {
      Yt(w, {
        x: S,
        y: x
      });
      break;
    }
    case "line": {
      I.getCurConfig().gridSnapping && (S = Ot(S), x = Ot(x));
      let Q = S, N = x;
      r.shiftKey && (s = K0(I.getStartX(), I.getStartY(), Q, N), Q = s.x, N = s.y), w.setAttribute("x2", Q), w.setAttribute("y2", N);
      break;
    }
    case "foreignObject":
    // fall through
    case "square":
    case "rect":
    case "image": {
      const Q = I.getCurrentMode() === "square" || I.getCurrentMode() === "image" && !r.shiftKey || I.getCurrentMode() !== "image" && r.shiftKey;
      let N = Math.abs(S - I.getStartX()), _ = Math.abs(x - I.getStartY()), R, F;
      Q ? (N = _ = Math.max(N, _), R = I.getStartX() < S ? I.getStartX() : I.getStartX() - N, F = I.getStartY() < x ? I.getStartY() : I.getStartY() - _) : (R = Math.min(I.getStartX(), S), F = Math.min(I.getStartY(), x)), I.getCurConfig().gridSnapping && (N = Ot(N), _ = Ot(_), R = Ot(R), F = Ot(F)), Yt(w, {
        width: N,
        height: _,
        x: R,
        y: F
      });
      break;
    }
    case "circle": {
      a = Number(w.getAttribute("cx")), o = Number(w.getAttribute("cy"));
      let Q = Math.sqrt((S - a) * (S - a) + (x - o) * (x - o));
      I.getCurConfig().gridSnapping && (Q = Ot(Q)), w.setAttribute("r", Q);
      break;
    }
    case "ellipse": {
      a = Number(w.getAttribute("cx")), o = Number(w.getAttribute("cy")), I.getCurConfig().gridSnapping && (S = Ot(S), a = Ot(a), x = Ot(x), o = Ot(o)), w.setAttribute("rx", Math.abs(S - a));
      const Q = Math.abs(r.shiftKey ? S - a : x - o);
      w.setAttribute("ry", Q);
      break;
    }
    case "fhellipse":
    case "fhrect":
      I.setFreehand("minx", Math.min(b, I.getFreehand("minx"))), I.setFreehand("maxx", Math.max(b, I.getFreehand("maxx"))), I.setFreehand("miny", Math.min(B, I.getFreehand("miny"))), I.setFreehand("maxy", Math.max(B, I.getFreehand("maxy")));
    // Fallthrough
    case "fhpath": {
      if (I.setEnd("x", b), I.setEnd("y", B), I.getControllPoint2("x") && I.getControllPoint2("y")) {
        for (i = 0; i < I.getStepCount() - 1; i++)
          if (I.setParameter(i / I.getStepCount()), I.setNextParameter((i + 1) / I.getStepCount()), I.setbSpline(W1(I.getNextParameter())), I.setNextPos({ x: I.getbSpline("x"), y: I.getbSpline("y") }), I.setbSpline(W1(I.getParameter())), I.setSumDistance(
            I.getSumDistance() + Math.sqrt((I.getNextPos("x") - I.getbSpline("x")) * (I.getNextPos("x") - I.getbSpline("x")) + (I.getNextPos("y") - I.getbSpline("y")) * (I.getNextPos("y") - I.getbSpline("y")))
          ), I.getSumDistance() > I.getThreSholdDist()) {
            I.setSumDistance(I.getSumDistance() - I.getThreSholdDist());
            const Q = I.getSvgContent().createSVGPoint();
            Q.x = I.getbSpline("x"), Q.y = I.getbSpline("y"), w.points.appendItem(Q);
          }
      }
      I.setControllPoint2("x", I.getControllPoint1("x")), I.setControllPoint2("y", I.getControllPoint1("y")), I.setControllPoint1("x", I.getStart("x")), I.setControllPoint1("y", I.getStart("y")), I.setStart({ x: I.getEnd("x"), y: I.getEnd("y") });
      break;
    }
    case "path":
    // fall through
    case "pathedit": {
      if (S *= t, x *= t, I.getCurConfig().gridSnapping && (S = Ot(S), x = Ot(x), I.setStartX(Ot(I.getStartX())), I.setStartY(Ot(I.getStartY()))), r.shiftKey) {
        const { path: Q } = Ax;
        let N, _;
        Q ? (N = Q.dragging ? Q.dragging[0] : I.getStartX(), _ = Q.dragging ? Q.dragging[1] : I.getStartY()) : (N = I.getStartX(), _ = I.getStartY()), s = K0(N, _, S, x), { x: S, y: x } = s;
      }
      I.getRubberBox()?.getAttribute("display") !== "none" && (b *= t, B *= t, Yt(I.getRubberBox(), {
        x: Math.min(I.getRStartX() * t, b),
        y: Math.min(I.getRStartY() * t, B),
        width: Math.abs(b - I.getRStartX() * t),
        height: Math.abs(B - I.getRStartY() * t)
      })), I.pathActions.mouseMove(S, x);
      break;
    }
    case "textedit": {
      S *= t, x *= t, I.textActions.mouseMove(p, v);
      break;
    }
    case "rotate": {
      h = Ir(n), a = h.x + h.width / 2, o = h.y + h.height / 2;
      const Q = Jm(n), N = Rt(a, o, Q);
      a = N.x, o = N.y, f = (Math.atan2(o - x, a - S) * (180 / Math.PI) - 90) % 360, I.getCurConfig().gridSnapping && (f = Ot(f)), r.shiftKey && (f = Math.round(f / 45) * 45), I.setRotationAngle(f < -180 ? 360 + f : f, !0), I.call("transition", e);
      break;
    }
  }
  I.runExtensions(
    "mouseMove",
    /** @type {module:svgcanvas.SvgCanvas#event:ext_mouseMove} */
    {
      event: r,
      mouse_x: p,
      mouse_y: v,
      selected: n
    }
  );
}, yU = (r) => {
  const { $id: e } = I;
  if (I.getCurrentMode() !== "select" && I.getStarted()) {
    const t = new MouseEvent("mouseup", {
      bubbles: !0,
      cancelable: !0,
      clientX: r?.clientX ?? 0,
      clientY: r?.clientY ?? 0,
      button: r?.button ?? 0,
      buttons: r?.buttons ?? 0,
      altKey: r?.altKey ?? !1,
      ctrlKey: r?.ctrlKey ?? !1,
      metaKey: r?.metaKey ?? !1,
      shiftKey: r?.shiftKey ?? !1
    });
    e("svgcanvas").dispatchEvent(t);
  }
}, bU = (r) => {
  if (r.preventDefault(), Ah = !1, r.button === 2 || !I.getStarted())
    return;
  I.textActions.init();
  const e = I.getSelectedElements(), t = I.getZoom(), A = I.getJustSelected();
  I.setJustSelected(null);
  const n = Rt(r.clientX, r.clientY, I.getrootSctm()), i = n.x * t, s = n.y * t, a = i / t, o = s / t;
  let l = Jt(I.getId()), u = !1;
  const c = a, f = o;
  I.setStarted(!1);
  let h;
  switch (I.getCurrentMode()) {
    // intentionally fall-through to select here
    case "resize":
    case "multiselect":
      I.getRubberBox() && (I.getRubberBox().setAttribute("display", "none"), I.setCurBBoxes([])), I.setCurrentMode("select");
    // Fallthrough
    case "select":
      if (e[0]) {
        if (!e[1]) {
          const v = e[0];
          switch (v.tagName) {
            case "g":
            case "use":
            case "image":
            case "foreignObject":
              break;
            case "text":
              I.setCurText("font_size", v.getAttribute("font-size")), I.setCurText("font_family", v.getAttribute("font-family"));
            // fallthrough
            default:
              I.setCurProperties("fill", v.getAttribute("fill")), I.setCurProperties("fill_opacity", v.getAttribute("fill-opacity")), I.setCurProperties("stroke", v.getAttribute("stroke")), I.setCurProperties("stroke_opacity", v.getAttribute("stroke-opacity")), I.setCurProperties("stroke_width", v.getAttribute("stroke-width")), I.setCurProperties("stroke_dasharray", v.getAttribute("stroke-dasharray")), I.setCurProperties("stroke_linejoin", v.getAttribute("stroke-linejoin")), I.setCurProperties("stroke_linecap", v.getAttribute("stroke-linecap"));
          }
          I.selectorManager.requestSelector(v).showGrips(!0);
        }
        if (c !== I.getRStartX() || f !== I.getRStartY()) {
          const v = new pU("position");
          e.forEach((b) => {
            if (!b) return;
            const S = jt(b);
            if (!S || S.numberOfItems === 0) return;
            const B = I.dragStartTransforms?.get(b) || "", U = S.getItem(0).type === 2, Q = b.tagName === "g" || b.tagName === "a";
            if (S.numberOfItems > 1 && U || Q && U) {
              const _ = Ht(S).matrix;
              for (; S.numberOfItems > 0; )
                S.removeItem(0);
              const R = I.getSvgRoot().createSVGTransform();
              R.setMatrix(_), S.appendItem(R), v.addSubCommand(new z1(b, { transform: B }));
              return;
            }
            const N = I.recalculateDimensions(b);
            N ? v.addSubCommand(N) : (b.getAttribute("transform") || "") !== B && v.addSubCommand(new z1(b, { transform: B }));
          }), v.isEmpty() || I.addCommandToHistory(v), I.dragStartTransforms = null, I.hasDragStartTransform = !1;
          const w = e.length;
          for (let b = 0; b < w && e[b]; ++b)
            I.selectorManager.requestSelector(e[b]).resize();
        } else
          h = r.target, e[0].nodeName === "path" && !e[1] ? I.pathActions.select(e[0]) : r.shiftKey && A !== h && I.removeFromSelection([h]);
        const p = e[0];
        p && (p.removeAttribute("style"), p.localName === "foreignObject" ? os(p, (v) => {
          v.style.removeProperty("pointer-events");
        }) : os(p, (v) => {
          v.removeAttribute("style");
        }));
      }
      return;
    case "zoom": {
      I.getRubberBox()?.setAttribute("display", "none");
      const p = r.shiftKey ? 0.5 : 2;
      I.call("zoomed", {
        x: Math.min(I.getRStartX(), c),
        y: Math.min(I.getRStartY(), f),
        width: Math.abs(c - I.getRStartX()),
        height: Math.abs(f - I.getRStartY()),
        factor: p
      });
      return;
    }
    case "fhpath": {
      I.setSumDistance(0), I.setControllPoint2("x", 0), I.setControllPoint2("y", 0), I.setControllPoint1("x", 0), I.setControllPoint1("y", 0), I.setStart({ x: 0, y: 0 }), I.setEnd("x", 0), I.setEnd("y", 0);
      const p = l.getAttribute("points"), v = p.indexOf(",");
      u = v >= 0 ? p.includes(",", v + 1) : p.includes(" ", p.indexOf(" ") + 1), u && (l = I.pathActions.smoothPolylineIntoPath(l));
      break;
    }
    case "line":
      {
        const p = l.getAttribute("x1"), v = l.getAttribute("y1"), w = l.getAttribute("x2"), b = l.getAttribute("y2");
        u = p !== w || v !== b;
      }
      break;
    case "foreignObject":
    case "square":
    case "rect":
    case "image":
      {
        const p = l.getAttribute("width"), v = l.getAttribute("height"), w = Number(p), b = Number(v);
        u = w >= 1 || b >= 1 || I.getCurrentMode() === "image";
      }
      break;
    case "circle":
      u = l.getAttribute("r") !== "0";
      break;
    case "ellipse":
      {
        const p = Number(l.getAttribute("rx")), v = Number(l.getAttribute("ry"));
        u = p || v;
      }
      break;
    case "fhellipse":
      I.getFreehand("maxx") - I.getFreehand("minx") > 0 && I.getFreehand("maxy") - I.getFreehand("miny") > 0 && (l = I.addSVGElementsFromJson({
        element: "ellipse",
        curStyles: !0,
        attr: {
          cx: (I.getFreehand("minx") + I.getFreehand("maxx")) / 2,
          cy: (I.getFreehand("miny") + I.getFreehand("maxy")) / 2,
          rx: (I.getFreehand("maxx") - I.getFreehand("minx")) / 2,
          ry: (I.getFreehand("maxy") - I.getFreehand("miny")) / 2,
          id: I.getId()
        }
      }), I.call("changed", [l]), u = !0);
      break;
    case "fhrect":
      I.getFreehand("maxx") - I.getFreehand("minx") > 0 && I.getFreehand("maxy") - I.getFreehand("miny") > 0 && (l = I.addSVGElementsFromJson({
        element: "rect",
        curStyles: !0,
        attr: {
          x: I.getFreehand("minx"),
          y: I.getFreehand("miny"),
          width: I.getFreehand("maxx") - I.getFreehand("minx"),
          height: I.getFreehand("maxy") - I.getFreehand("miny"),
          id: I.getId()
        }
      }), I.call("changed", [l]), u = !0);
      break;
    case "text":
      u = !0, I.selectOnly([l]), I.textActions.start(l);
      break;
    case "path": {
      l = null, I.setStarted(!0);
      const p = I.pathActions.mouseUp(r, l, i, s);
      ({ element: l } = p), { keep: u } = p;
      break;
    }
    case "pathedit":
      u = !0, l = null, I.pathActions.mouseUp(r);
      break;
    case "textedit":
      u = !1, l = null, I.textActions.mouseUp(r, i, s);
      break;
    case "rotate": {
      I.hasDragStartTransform = !1, I.dragStartTransforms = null, u = !0, l = null, I.setCurrentMode("select");
      const p = I.undoMgr.finishUndoableChange();
      p.isEmpty() || I.addCommandToHistory(p), I.recalculateAllSelectedDimensions(), I.call("changed", e);
      break;
    }
    default:
      I.hasDragStartTransform = !1, I.dragStartTransforms = null;
      break;
  }
  if (I.hasDragStartTransform = !1, I.dragStartTransforms = null, I.runExtensions("mouseUp", {
    event: r,
    mouse_x: i,
    mouse_y: s
  }, !0).forEach((p) => {
    p && (u = p.keep || u, { element: l } = p, I.setStarted(p.started || I.getStarted()));
  }), !u && l) {
    for (I.getCurrentDrawing().releaseId(I.getId()), l.remove(), l = null, h = r.target; h?.parentNode?.parentNode?.tagName === "g"; )
      h = h.parentNode;
    (I.getCurrentMode() !== "path" || !I.getDrawnPath()) && h && h.parentNode?.id !== "selectorParentGroup" && h.id !== "svgcanvas" && h.id !== "svgroot" && (I.setMode("select"), I.selectOnly([h], !0));
  } else if (l) {
    I.addedNew = !0;
    let p = 0.2, v;
    const w = I.getStyle(), b = I.getOpacAni();
    if (b.beginElement && Number.parseFloat(l.getAttribute("opacity")) !== w.opacity) {
      v = b.cloneNode(!0), v.setAttribute("to", w.opacity), v.setAttribute("dur", p), l.appendChild(v);
      try {
        v.beginElement();
      } catch {
      }
    } else
      p = 0;
    setTimeout(() => {
      v && v.remove(), l.setAttribute("opacity", w.opacity), l.setAttribute("style", "pointer-events:inherit"), Rh(l), I.getCurrentMode() === "path" ? I.pathActions.toEditMode(l) : I.getCurConfig().selectNew && (["circle", "ellipse", "square", "rect", "fhpath", "line", "fhellipse", "fhrect", "star", "polygon", "shapelib"].indexOf(I.getCurrentMode()) !== -1 && !r.altKey && I.setMode("select"), I.selectOnly([l], !0)), I.addCommandToHistory(new gU(l)), I.call("changed", [l]);
    }, p * 1e3);
  }
  I.setStartTransform(null);
}, BU = (r) => {
  const e = I.getSelectedElements(), A = r.target.parentNode;
  let n = I.getMouseTarget(r);
  const { tagName: i } = n;
  if (i === "text" && I.getCurrentMode() !== "textedit") {
    const s = Rt(r.clientX, r.clientY, I.getrootSctm());
    I.textActions.select(n, s.x, s.y);
  }
  A !== I.getCurrentGroup() && ((i === "g" || i === "a") && bA(n) && (I.pushGroupProperties(n), n = e[0], I.clearSelection(!0)), I.getCurrentGroup() && $s(), !(A.tagName !== "g" && A.tagName !== "a" || A === I.getCurrentDrawing().getCurrentLayer() || n === I.selectorManager.selectorParentGroup) && ix(n));
}, CU = (r) => {
  const e = I.getDataStorage(), t = I.getSelectedElements(), A = I.getZoom(), n = I.getStyle(), i = I.getSvgRoot(), { $id: s } = I;
  if (I.spaceKey || r.button === 1)
    return;
  const a = r.button === 2;
  r.altKey && I.cloneSelectedElements(0, 0);
  const u = s("svgcontent")?.querySelector("g")?.getScreenCTM?.();
  if (!u)
    return;
  I.setRootSctm(u.inverse());
  const c = Rt(r.clientX, r.clientY, I.getrootSctm()), f = c.x * A, h = c.y * A;
  if (r.preventDefault(), a) {
    if (I.getCurrentMode() === "path")
      return;
    I.setCurrentMode("select"), I.setLastClickPoint(c);
  }
  let g = f / A, p = h / A, v = I.getMouseTarget(r);
  v.tagName === "a" && v.childNodes.length === 1 && (v = v.firstChild);
  const w = g;
  I.setStartX(g), I.setRStartX(g);
  const b = p;
  if (I.setStartY(p), I.setRStartY(p), I.getCurConfig().gridSnapping && (g = Ot(g), p = Ot(p), I.setStartX(Ot(I.getStartX())), I.setStartY(Ot(I.getStartY()))), v === I.selectorManager.selectorParentGroup && t[0]) {
    const x = r.target, U = e.get(x, "type");
    U === "rotate" ? I.setCurrentMode("rotate") : U === "resize" && (I.setCurrentMode("resize"), I.setCurrentResizeMode(e.get(x, "dir"))), v = t[0];
  }
  I.setStartTransform(v.getAttribute("transform"));
  const S = jt(v);
  if (S?.numberOfItems > 1 && v.tagName !== "g" && v.tagName !== "a") {
    const x = Ht(S).matrix;
    for (; S.numberOfItems > 0; )
      S.removeItem(0);
    const U = I.getSvgRoot().createSVGTransform();
    U.setMatrix(x), S.appendItem(U);
  }
  switch (I.getCurrentMode()) {
    case "select":
      I.setStarted(!0), I.setCurrentResizeMode("none"), a && I.setStarted(!1), v !== i ? t.includes(v) || (r.shiftKey || I.clearSelection(!0), I.addToSelection([v]), I.setJustSelected(v), I.pathActions.clear()) : a || (I.clearSelection(), I.setCurrentMode("multiselect"), I.getRubberBox() || I.setRubberBox(I.selectorManager.getRubberBandBox()), I.setRStartX(I.getRStartX() * A), I.setRStartY(I.getRStartY() * A), Yt(I.getRubberBox(), {
        x: I.getRStartX(),
        y: I.getRStartY(),
        width: 0,
        height: 0,
        display: "inline"
      }));
      break;
    case "zoom":
      I.setStarted(!0), I.getRubberBox() || I.setRubberBox(I.selectorManager.getRubberBandBox()), Yt(I.getRubberBox(), {
        x: w * A,
        y: b * A,
        width: 0,
        height: 0,
        display: "inline"
      });
      break;
    case "resize": {
      if (!S)
        break;
      I.setStarted(!0), I.setStartX(g), I.setStartY(p), I.setInitBbox(Ir(s("selectedBox0")));
      const x = {};
      for (const [Q, N] of Object.entries(I.getInitBbox()))
        x[Q] = N / A;
      I.setInitBbox(x);
      const U = bA(v) ? 1 : 0;
      Ra(S) ? (S.insertItemBefore(i.createSVGTransform(), U), S.insertItemBefore(i.createSVGTransform(), U), S.insertItemBefore(i.createSVGTransform(), U)) : (S.appendItem(i.createSVGTransform()), S.appendItem(i.createSVGTransform()), S.appendItem(i.createSVGTransform()));
      break;
    }
    case "fhellipse":
    case "fhrect":
    case "fhpath":
      I.setStart({ x: w, y: b }), I.setControllPoint1("x", 0), I.setControllPoint1("y", 0), I.setControllPoint2("x", 0), I.setControllPoint2("y", 0), I.setStarted(!0), I.setDAttr(w + "," + b + " "), I.addSVGElementsFromJson({
        element: "polyline",
        curStyles: !0,
        attr: {
          points: I.getDAttr(),
          id: I.getNextId(),
          fill: "none",
          opacity: n.opacity / 2,
          "stroke-linecap": "round",
          style: "pointer-events:none"
        }
      }), I.setFreehand("minx", w), I.setFreehand("maxx", w), I.setFreehand("miny", b), I.setFreehand("maxy", b);
      break;
    case "image": {
      I.setStarted(!0);
      const x = I.addSVGElementsFromJson({
        element: "image",
        attr: {
          x: g,
          y: p,
          width: 0,
          height: 0,
          id: I.getNextId(),
          opacity: n.opacity / 2,
          style: "pointer-events:inherit"
        }
      });
      Dn(x, I.getLastGoodImgUrl()), ev(x);
      break;
    }
    case "square":
    // TODO: once we create the rect, we lose information that this was a square
    // (for resizing purposes this could be important)
    // Fallthrough
    case "rect":
      I.setStarted(!0), I.setStartX(g), I.setStartY(p), I.addSVGElementsFromJson({
        element: "rect",
        curStyles: !0,
        attr: {
          x: g,
          y: p,
          width: 0,
          height: 0,
          id: I.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "line": {
      I.setStarted(!0);
      const x = Number(n.stroke_width) === 0 ? 1 : n.stroke_width;
      I.addSVGElementsFromJson({
        element: "line",
        curStyles: !0,
        attr: {
          x1: g,
          y1: p,
          x2: g,
          y2: p,
          id: I.getNextId(),
          stroke: n.stroke,
          "stroke-width": x,
          "stroke-dasharray": n.stroke_dasharray,
          "stroke-linejoin": n.stroke_linejoin,
          "stroke-linecap": n.stroke_linecap,
          "stroke-opacity": n.stroke_opacity,
          fill: "none",
          opacity: n.opacity / 2,
          style: "pointer-events:none"
        }
      });
      break;
    }
    case "circle":
      I.setStarted(!0), I.addSVGElementsFromJson({
        element: "circle",
        curStyles: !0,
        attr: {
          cx: g,
          cy: p,
          r: 0,
          id: I.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "ellipse":
      I.setStarted(!0), I.addSVGElementsFromJson({
        element: "ellipse",
        curStyles: !0,
        attr: {
          cx: g,
          cy: p,
          rx: 0,
          ry: 0,
          id: I.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "text":
      I.setStarted(!0), I.addSVGElementsFromJson({
        element: "text",
        curStyles: !0,
        attr: {
          x: g,
          y: p,
          id: I.getNextId(),
          fill: I.getCurText("fill"),
          "stroke-width": I.getCurText("stroke_width"),
          "font-size": I.getCurText("font_size"),
          "font-family": I.getCurText("font_family"),
          "text-anchor": "middle",
          "xml:space": "preserve",
          opacity: n.opacity
        }
      });
      break;
    case "path":
    // Fall through
    case "pathedit":
      I.setStartX(I.getStartX() * A), I.setStartY(I.getStartY() * A), I.pathActions.mouseDown(r, v, I.getStartX(), I.getStartY()), I.setStarted(!0);
      break;
    case "textedit":
      I.setStartX(I.getStartX() * A), I.setStartY(I.getStartY() * A), I.textActions.mouseDown(r, v, I.getStartX(), I.getStartY()), I.setStarted(!0);
      break;
    case "rotate":
      I.setStarted(!0), I.undoMgr.beginUndoableChange("transform", t);
      break;
  }
  I.runExtensions("mouseDown", {
    event: r,
    start_x: I.getStartX(),
    start_y: I.getStartY(),
    selectedElements: t
  }, !0).forEach((x) => {
    x?.started && I.setStarted(!0);
  });
}, SU = (r) => {
  const e = I.getZoom(), { $id: t } = I;
  if (!r.shiftKey)
    return;
  r.preventDefault();
  const i = t("svgcontent")?.querySelector("g")?.getScreenCTM?.();
  if (!i)
    return;
  I.setRootSctm(i.inverse());
  const s = document.getElementById("workarea"), a = 15, o = I.getCurConfig().showRulers ? 16 : 0, l = Rt(r.clientX, r.clientY, I.getrootSctm()), u = parseFloat(getComputedStyle(s, null).width.replace("px", "")), c = parseFloat(getComputedStyle(s, null).height.replace("px", "")), f = u - a - o, h = c - a - o, g = f * I.getrootSctm().a, p = h * I.getrootSctm().d, v = V4(s), w = v.left + o, b = v.top + o, S = r.wheelDelta ? r.wheelDelta : r.detail ? -r.detail : 0;
  if (!S)
    return;
  let B = Math.max(3 / 4, Math.min(4 / 3, S)), x, U;
  B > 1 ? (x = Math.ceil(f / g * B * 100) / 100, U = Math.ceil(h / p * B * 100) / 100) : (x = Math.floor(f / g * B * 100) / 100, U = Math.floor(h / p * B * 100) / 100);
  let Q = Math.min(x, U);
  if (Q = Math.min(10, Math.max(0.01, Q)), Q === e)
    return;
  B = Q / e;
  const N = Rt(w, b, I.getrootSctm()), _ = {
    x: l.x - (l.x - N.x) / B,
    y: l.y - (l.y - N.y) / B
  }, R = {
    x: _.x * Q,
    y: _.y * Q
  }, F = {
    x: R.x - o + u / 2,
    y: R.y - o + c / 2
  };
  I.setZoom(Q), document.getElementById("zoom").value = (Q * 100).toFixed(1), I.call("updateCanvas", { center: !1, newCtr: F }), I.call("zoomDone");
};
let Ql = null, vo = null;
const xU = (r) => {
  Ql = r, vo = r.getDOMDocument?.() || (typeof document < "u" ? document : null);
}, ox = (r) => {
  if (!r) return null;
  if (r.nodeType === 3 || r.nodeType === 4) return r.nodeValue;
  if (r.nodeType !== 1) return null;
  const e = {
    element: r.tagName,
    // namespace: nsMap[data.namespaceURI],
    attr: {},
    children: []
  }, t = r.attributes;
  if (t)
    for (let n = 0; n < t.length; n++) {
      const i = t[n];
      i && (e.attr[i.name] = i.value);
    }
  const A = r.childNodes;
  if (A)
    for (let n = 0; n < A.length; n++) {
      const i = A[n], s = ox(i);
      s != null && e.children.push(s);
    }
  return e;
}, lx = (r) => {
  if (!vo)
    return null;
  if (r == null) return vo.createTextNode("");
  if (typeof r == "string") return vo.createTextNode(r);
  const e = r.attr || {}, t = e.id;
  let A = null;
  if (typeof t == "string" && t) {
    try {
      A = Jt(t);
    } catch {
    }
    if (!A) {
      const s = vo.getElementById?.(t), a = Ql?.getSvgRoot?.();
      s && (!a || a.contains(s)) && (A = s);
    }
  }
  const n = Ql?.getDrawing?.()?.getCurrentLayer?.();
  if (A && r.element !== A.tagName && (A.remove(), A = null), !A) {
    const s = r.namespace || et.SVG;
    A = vo.createElementNS(s, r.element), n && (Ql.getCurrentGroup() || n).append(A);
  }
  const i = Ql.getCurShape?.() || {};
  if (r.curStyles) {
    const s = Number(i.opacity), a = Number.isFinite(s) ? s / 2 : 0.5;
    Yt(A, {
      fill: i.fill,
      stroke: i.stroke,
      "stroke-width": i.stroke_width,
      "stroke-dasharray": i.stroke_dasharray,
      "stroke-linejoin": i.stroke_linejoin,
      "stroke-linecap": i.stroke_linecap,
      "stroke-opacity": i.stroke_opacity,
      "fill-opacity": i.fill_opacity,
      opacity: a,
      style: "pointer-events:inherit"
    });
  }
  if (Yt(A, e), Rh(A), r.children) {
    for (; A.firstChild; )
      A.firstChild.remove();
    r.children.forEach((s) => {
      const a = lx(s);
      a && A.append(a);
    });
  }
  return A;
};
let ue = null;
const EU = (r) => {
  ue = r, ue.getBold = DU, ue.setBold = GU, ue.getItalic = qU, ue.setItalic = zU, ue.hasTextDecoration = VU, ue.addTextDecoration = KU, ue.removeTextDecoration = jU, ue.setTextAnchor = WU, ue.setLetterSpacing = XU, ue.setWordSpacing = YU, ue.setTextLength = $U, ue.setLengthAdjust = JU, ue.getFontFamily = ZU, ue.setFontFamily = eI, ue.setFontColor = tI, ue.getFontColor = rI, ue.getFontSize = AI, ue.setFontSize = nI, ue.getText = iI, ue.setTextContent = sI, ue.setImageURL = aI, ue.setLinkURL = oI, ue.setRectRadius = lI, ue.makeHyperlink = uI, ue.removeHyperlink = cI, ue.setSegType = hI, ue.setStrokeWidth = kU, ue.getResolution = FU, ue.getTitle = _U, ue.setGroupTitle = UU, ue.setStrokeAttr = HU, ue.setBackground = fI, ue.setDocumentTitle = IU, ue.getEditorNS = LU, ue.setResolution = QU, ue.setBBoxZoom = NU, ue.setCurrentZoom = TU, ue.setColor = PU, ue.setGradient = OU, ue.setPaint = RU;
}, FU = () => {
  const r = ue.getZoom(), e = ue.getSvgContent().getAttribute("width") / r, t = ue.getSvgContent().getAttribute("height") / r;
  return {
    w: e,
    h: t,
    zoom: r
  };
}, _U = (r) => {
  const e = ue.getSelectedElements(), t = ue.getDataStorage();
  if (r = r || e[0], !r)
    return;
  t.has(r, "gsvg") ? r = t.get(r, "gsvg") : t.has(r, "symbol") && (r = t.get(r, "symbol"));
  const A = r.childNodes;
  for (const n of A)
    if (n.nodeName === "title")
      return n.textContent;
  return "";
}, UU = (r) => {
  const {
    InsertElementCommand: e,
    RemoveElementCommand: t,
    ChangeElementCommand: A,
    BatchCommand: n
  } = ue.history, i = ue.getSelectedElements(), s = ue.getDataStorage();
  let a = i[0];
  if (!a || (s.has(a, "gsvg") ? a = s.get(a, "gsvg") : s.has(a, "symbol") && (a = s.get(a, "symbol")), !a))
    return;
  const o = new n("Set Label");
  let l = null;
  for (const u of a.childNodes)
    if (u.nodeName === "title") {
      l = u;
      break;
    }
  if (r.length === 0) {
    if (!l)
      return;
    const { nextSibling: u } = l;
    l.remove(), o.addSubCommand(new t(l, u, a));
  } else if (l) {
    const u = l.textContent;
    if (u === r)
      return;
    l.textContent = r, o.addSubCommand(new A(l, { "#text": u }));
  } else
    l = ue.getDOMDocument().createElementNS(et.SVG, "title"), l.textContent = r, a.insertBefore(l, a.firstChild), o.addSubCommand(new e(l));
  o.isEmpty() || ue.addCommandToHistory(o);
}, IU = (r) => {
  const {
    InsertElementCommand: e,
    RemoveElementCommand: t,
    ChangeElementCommand: A,
    BatchCommand: n
  } = ue.history, i = ue.getSvgContent(), s = new n("Change Image Title");
  let a = null;
  for (const o of i.childNodes)
    if (o.nodeName === "title") {
      a = o;
      break;
    }
  if (a)
    if (r.length) {
      const o = a.textContent;
      if (o === r)
        return;
      a.textContent = r, s.addSubCommand(new A(a, { "#text": o }));
    } else {
      const { nextSibling: o } = a;
      a.remove(), s.addSubCommand(new t(a, o, i));
    }
  else {
    if (!r.length)
      return;
    a = ue.getDOMDocument().createElementNS(et.SVG, "title"), a.textContent = r, i.insertBefore(a, i.firstChild), s.addSubCommand(new e(a));
  }
  s.isEmpty() || ue.addCommandToHistory(s);
}, QU = (r, e) => {
  const { ChangeElementCommand: t, BatchCommand: A } = ue.history, n = ue.getResolution(), { w: i, h: s } = n;
  let a;
  if (r === "fit") {
    const u = Hn();
    if (u) {
      a = new A("Fit Canvas to Content");
      const c = fu();
      ue.addToSelection(c);
      const f = [], h = [];
      c.forEach((p, v) => {
        f.push(u.x * -1), h.push(u.y * -1);
      });
      const g = ue.moveSelectedElements(f, h, !1);
      g && a.addSubCommand(g), ue.clearSelection(), r = Math.round(u.width), e = Math.round(u.height);
    } else
      return !1;
  }
  const o = yr("width", r), l = yr("height", e);
  if (o !== i || l !== s) {
    a || (a = new A("Change Image Dimensions"));
    const u = ue.getSvgContent(), c = u.getAttribute("viewBox");
    u.setAttribute("width", o), u.setAttribute("height", l), ue.contentW = o, ue.contentH = l, u.setAttribute("viewBox", [0, 0, o, l].join(" ")), a.addSubCommand(new t(u, { width: i, height: s, viewBox: c })), ue.addCommandToHistory(a), ue.call("changed", [u]);
  }
  return !0;
}, LU = (r) => (r && ue.getSvgContent().setAttribute("xmlns:se", et.SE), et.SE), NU = (r, e, t) => {
  const A = ue.getZoom(), n = ue.getSelectedElements();
  let i = 0.85, s;
  const a = (o) => {
    if (!o || !Number.isFinite(e) || !Number.isFinite(t) || e <= 0 || t <= 0 || !Number.isFinite(o.width) || !Number.isFinite(o.height) || o.width <= 0 || o.height <= 0)
      return;
    const l = Math.round(e / o.width * 100 * i) / 100, u = Math.round(t / o.height * 100 * i) / 100, c = Math.min(l, u);
    if (!(!Number.isFinite(c) || c <= 0))
      return ue.setZoom(c), { zoom: c, bbox: o };
  };
  if (r && typeof r == "object") {
    if (s = r, s.width === 0 || s.height === 0) {
      let o = A;
      return Number.isFinite(s.zoom) && s.zoom > 0 ? o = s.zoom : Number.isFinite(s.factor) && s.factor > 0 && (o = A * s.factor), Number.isFinite(o) && o > 0 && ue.setZoom(o), { zoom: o, bbox: s };
    }
    return a(s);
  }
  switch (r) {
    case "selection": {
      if (!n[0])
        return;
      const o = n.filter(Boolean);
      s = Hn(o);
      break;
    }
    case "canvas": {
      const o = ue.getResolution();
      i = 0.95, s = { width: o.w, height: o.h, x: 0, y: 0 };
      break;
    }
    case "content":
      s = Hn();
      break;
    case "layer":
      s = Hn(fu(ue.getCurrentDrawing().getCurrentLayer()));
      break;
    default:
      return;
  }
  return a(s);
}, TU = (r) => {
  if (!Number.isFinite(r) || r <= 0)
    return;
  const e = ue.getSelectedElements(), t = ue.getResolution(), A = t.w / r, n = t.h / r;
  !Number.isFinite(A) || !Number.isFinite(n) || A <= 0 || n <= 0 || (ue.getSvgContent().setAttribute("viewBox", `0 0 ${A} ${n}`), ue.setZoom(r), e.forEach((i) => {
    if (!i)
      return;
    const s = ue.selectorManager.requestSelector(i);
    s && s.resize();
  }), ue.pathActions.zoomChange(), ue.runExtensions("zoomChanged", r));
}, PU = (r, e, t) => {
  const A = ue.getSelectedElements();
  ue.setCurShape(r, e), ue.setCurProperties(`${r}_paint`, { type: "solidColor" });
  const n = [], i = (a) => {
    a.nodeName !== "g" && n.push(a);
  };
  let s = A.length;
  for (; s--; ) {
    const a = A[s];
    a && (a.tagName === "g" ? os(a, i) : r === "fill" ? a.tagName !== "polyline" && a.tagName !== "line" && n.push(a) : n.push(a));
  }
  n.length > 0 && (t ? ue.changeSelectedAttributeNoUndo(r, e, n) : (ue.changeSelectedAttribute(r, e, n), ue.call("changed", n)));
}, OU = (r) => {
  if (!ue.getCurProperties(`${r}_paint`) || ue.getCurProperties(`${r}_paint`).type === "solidColor")
    return;
  let t = ue[r + "Grad"];
  if (!t)
    return;
  const A = MU(t), n = an();
  A ? t = A : (t = ue.getDOMDocument().importNode(t, !0), n.append(t), t.id = ue.getNextId()), ue.setColor(r, `url(#${t.id})`);
}, MU = (r) => {
  if (!r || !["linearGradient", "radialGradient"].includes(r.tagName))
    return null;
  const t = an().querySelectorAll("linearGradient, radialGradient");
  let A = t.length;
  const n = ["r", "cx", "cy", "fx", "fy"];
  for (; A--; ) {
    const i = t[A];
    if (i.tagName !== r.tagName)
      continue;
    if (r.tagName === "linearGradient") {
      if (r.getAttribute("x1") !== i.getAttribute("x1") || r.getAttribute("y1") !== i.getAttribute("y1") || r.getAttribute("x2") !== i.getAttribute("x2") || r.getAttribute("y2") !== i.getAttribute("y2"))
        continue;
    } else {
      const l = {
        r: Number(r.getAttribute("r")),
        cx: Number(r.getAttribute("cx")),
        cy: Number(r.getAttribute("cy")),
        fx: Number(r.getAttribute("fx")),
        fy: Number(r.getAttribute("fy"))
      }, u = {
        r: Number(i.getAttribute("r")),
        cx: Number(i.getAttribute("cx")),
        cy: Number(i.getAttribute("cy")),
        fx: Number(i.getAttribute("fx")),
        fy: Number(i.getAttribute("fy"))
      };
      let c = !1;
      if (n.forEach((f) => {
        l[f] !== u[f] && (c = !0);
      }), c)
        continue;
    }
    const s = r.getElementsByTagNameNS(et.SVG, "stop"), a = i.getElementsByTagNameNS(et.SVG, "stop");
    if (s.length !== a.length)
      continue;
    let o = s.length;
    for (; o--; ) {
      const l = s[o], u = a[o];
      if (l.getAttribute("offset") !== u.getAttribute("offset") || l.getAttribute("stop-opacity") !== u.getAttribute("stop-opacity") || l.getAttribute("stop-color") !== u.getAttribute("stop-color"))
        break;
    }
    if (o === -1)
      return i;
  }
  return null;
}, RU = (r, e) => {
  const t = new ni(e);
  switch (ue.setPaintOpacity(r, t.alpha / 100, !0), ue.setCurProperties(`${r}_paint`, t), t.type) {
    case "solidColor":
      ue.setColor(r, t.solidColor !== "none" ? `#${t.solidColor}` : "none");
      break;
    case "linearGradient":
    case "radialGradient":
      ue.setCanvas(r + "Grad", t[t.type]), ue.setGradient(r);
      break;
  }
}, kU = (r) => {
  const e = ue.getSelectedElements();
  if (r === 0 && ["line", "path"].includes(ue.getMode())) {
    ue.setStrokeWidth(1);
    return;
  }
  ue.setCurProperties("stroke_width", r);
  const t = [], A = (i) => {
    i.nodeName !== "g" && t.push(i);
  };
  let n = e.length;
  for (; n--; ) {
    const i = e[n];
    i && (i.tagName === "g" ? os(i, A) : t.push(i));
  }
  t.length > 0 && (ue.changeSelectedAttribute("stroke-width", r, t), ue.call("changed", e));
}, HU = (r, e) => {
  const t = ue.getSelectedElements();
  ue.setCurShape(r.replace("-", "_"), e);
  const A = [];
  let n = t.length;
  for (; n--; ) {
    const i = t[n];
    i && (i.tagName === "g" ? os(i, (s) => {
      s.nodeName !== "g" && A.push(s);
    }) : A.push(i));
  }
  A.length > 0 && (ue.changeSelectedAttribute(r, e, A), ue.call("changed", t));
}, DU = () => ue.getSelectedElements().filter((t) => t?.tagName === "text").every((t) => t.getAttribute("font-weight") === "bold"), GU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("font-weight", r ? "bold" : "normal", t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, VU = (r) => ue.getSelectedElements().filter((A) => A?.tagName === "text").every((A) => (A.getAttribute("text-decoration") || "").includes(r)), KU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = ue.history, n = ue.getSelectedElements().filter((s) => s?.tagName === "text"), i = new t();
  n.forEach((s) => {
    const a = s.getAttribute("text-decoration") || "";
    a.includes(r) || (i.addSubCommand(new e(s, { "text-decoration": a })), ue.changeSelectedAttributeNoUndo("text-decoration", `${a} ${r}`.trim(), [s]));
  }), i.isEmpty() || ue.undoMgr.addCommandToHistory(i), n.some((s) => s.textContent) || ue.textActions.setCursor();
}, jU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = ue.history, n = ue.getSelectedElements().filter((s) => s?.tagName === "text"), i = new t();
  n.forEach((s) => {
    const a = s.getAttribute("text-decoration") || "";
    i.addSubCommand(new e(s, { "text-decoration": a })), ue.changeSelectedAttributeNoUndo("text-decoration", a.replace(r, "").trim(), [s]);
  }), i.isEmpty() || ue.undoMgr.addCommandToHistory(i), n.some((s) => s.textContent) || ue.textActions.setCursor();
}, qU = () => ue.getSelectedElements().filter((t) => t?.tagName === "text").every((t) => t.getAttribute("font-style") === "italic"), zU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("font-style", r ? "italic" : "normal", t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, WU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("text-anchor", r, t);
}, XU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("letter-spacing", r, t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, YU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("word-spacing", r, t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, $U = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("textLength", r, t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, JU = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.changeSelectedAttribute("lengthAdjust", r, t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, ZU = () => ue.getCurText("font_family"), eI = (r) => {
  const t = ue.getSelectedElements().filter((A) => A?.tagName === "text");
  ue.setCurText("font_family", r), ue.changeSelectedAttribute("font-family", r, t), t.some((A) => A.textContent) || ue.textActions.setCursor();
}, tI = (r) => {
  ue.setCurText("fill", r), ue.changeSelectedAttribute("fill", r);
}, rI = () => ue.getCurText("fill"), AI = () => ue.getCurText("font_size"), nI = (r) => {
  const e = ue.getSelectedElements();
  ue.setCurText("font_size", r), ue.changeSelectedAttribute("font-size", r), e[0]?.textContent || ue.textActions.setCursor();
}, iI = () => {
  const e = ue.getSelectedElements()[0];
  return e ? e.textContent : "";
}, sI = (r) => {
  ue.changeSelectedAttribute("#text", r), ue.textActions.init(r), ue.textActions.setCursor();
}, aI = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = ue.history, n = ue.getSelectedElements()[0];
  if (!n)
    return;
  const i = {
    width: n.getAttribute("width"),
    height: n.getAttribute("height")
  }, s = !i.width || !i.height, a = Ei(n), o = a !== r;
  if (!o && !s)
    return;
  const l = new t("Change Image URL");
  o && (Dn(n, r), l.addSubCommand(new e(n, {
    "#href": a
  })));
  let u = !1;
  const c = () => {
    u || (u = !0, !l.isEmpty() && (ue.addCommandToHistory(l), ue.call("changed", [n])));
  }, f = new Image();
  f.onload = () => {
    const h = {
      width: n.getAttribute("width"),
      height: n.getAttribute("height")
    };
    n.setAttribute("width", f.width), n.setAttribute("height", f.height);
    const g = ue.selectorManager.requestSelector(n);
    g && g.resize(), l.addSubCommand(new e(n, h)), c();
  }, f.onerror = () => {
    c();
  }, f.src = r;
}, oI = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = ue.history;
  let n = ue.getSelectedElements()[0];
  if (!n)
    return;
  if (n.tagName !== "a") {
    const a = hu(n.parentNode, "a");
    if (a?.length)
      n = a[0];
    else
      return;
  }
  const i = Ei(n);
  if (i === r)
    return;
  const s = new t("Change Link URL");
  Dn(n, r), s.addSubCommand(new e(n, {
    "#href": i
  })), ue.addCommandToHistory(s);
}, lI = (r) => {
  const { ChangeElementCommand: e } = ue.history, A = ue.getSelectedElements()[0];
  if (A?.tagName !== "rect")
    return;
  const n = Number(r);
  if (!Number.isFinite(n) || n < 0)
    return;
  const i = A.getAttribute("rx"), s = A.getAttribute("ry"), a = Number(i), o = Number(s), l = i !== null && Number.isFinite(a), u = s !== null && Number.isFinite(o);
  n === 0 && i === null && s === null || l && u && a === n && o === n || (A.setAttribute("rx", n), A.setAttribute("ry", n), ue.addCommandToHistory(new e(A, { rx: i, ry: s }, "Radius")), ue.call("changed", [A]));
}, uI = (r) => {
  ue.groupSelectedElements("a", r);
}, cI = () => {
  ue.ungroupSelectedElement();
}, hI = (r) => {
  ue.pathActions.setSegType(r);
}, fI = (r, e) => {
  const t = Jt("canvasBackground");
  if (!t)
    return;
  const A = t.querySelector("rect");
  if (!A)
    return;
  let n = Jt("background_image"), i = Jt("background_pattern");
  if (A.setAttribute("fill", r === "chessboard" ? "#fff" : r), r === "chessboard") {
    if (!i) {
      i = ue.getDOMDocument().createElementNS(et.SVG, "foreignObject"), ue.assignAttributes(i, {
        id: "background_pattern",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMinYMin",
        style: "pointer-events:none"
      });
      const s = document.createElement("div");
      ue.assignAttributes(s, {
        style: "pointer-events:none;width:100%;height:100%;background-image:url(data:image/gif;base64,R0lGODlhEAAQAIAAAP///9bW1iH5BAAAAAAALAAAAAAQABAAAAIfjG+gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7);"
      }), i.append(s), t.append(i);
    }
  } else i && i.remove();
  e ? (n || (n = ue.getDOMDocument().createElementNS(et.SVG, "image"), ue.assignAttributes(n, {
    id: "background_image",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMinYMin",
    style: "pointer-events:none"
  })), Dn(n, e), t.append(n)) : n && n.remove();
};
let wo = null;
const dI = (r) => {
  if (r == null) return null;
  const e = String(r).trim();
  if (!e) return null;
  if (e.endsWith("%")) {
    const A = Number.parseFloat(e.slice(0, -1));
    return Number.isNaN(A) ? e : `${100 - A}%`;
  }
  const t = Number.parseFloat(e);
  return Number.isNaN(t) ? e : String(1 - t);
}, Is = (r, e) => {
  const t = r.getAttribute(e);
  if (t == null) return;
  const A = dI(t);
  A != null && r.setAttribute(e, A);
}, gI = (r) => {
  wo = r;
}, X1 = [
  0,
  "z",
  "M",
  "m",
  "L",
  "l",
  "C",
  "c",
  "Q",
  "q",
  "A",
  "a",
  "H",
  "h",
  "V",
  "v",
  "S",
  "s",
  "T",
  "t"
], Ll = (r, e, t) => {
  const A = (u, c) => Rt(u, c, t), n = (u) => t.a * u, i = (u) => t.d * u, s = wo.getGridSnapping?.() && r?.parentNode?.parentNode?.localName === "svg", a = () => {
    if (s)
      for (const [u, c] of Object.entries(e))
        e[u] = Ot(c);
    Yt(r, e, 1e3, !0);
  }, o = Ir(r);
  ["fill", "stroke"].forEach((u) => {
    const c = r.getAttribute(u);
    if (c?.startsWith("url(") && (t.a < 0 || t.d < 0)) {
      const f = qs(c);
      if (!f) return;
      const h = (f.tagName || "").toLowerCase();
      if (!["lineargradient", "radialgradient"].includes(h) || f.getAttribute("gradientUnits") === "userSpaceOnUse") return;
      const g = f.cloneNode(!0);
      t.a < 0 && (h === "lineargradient" ? (Is(g, "x1"), Is(g, "x2")) : (Is(g, "cx"), Is(g, "fx"))), t.d < 0 && (h === "lineargradient" ? (Is(g, "y1"), Is(g, "y2")) : (Is(g, "cy"), Is(g, "fy")));
      const v = (wo.getCurrentDrawing?.() || wo.getDrawing?.())?.getNextId?.() ?? (f.id ? `${f.id}-mirrored` : `mirrored-grad-${Date.now()}`);
      if (!v) {
        kA("Unable to mirror gradient: no drawing context available", null, "coords");
        return;
      }
      g.id = v, an().append(g), r.setAttribute(u, `url(#${g.id})`);
    }
  });
  const l = r.tagName;
  if (l !== "use")
    switch (l) {
      case "foreignObject":
      case "rect":
      case "image": {
        if (l === "image" && (t.a < 0 || t.d < 0)) {
          const u = jt(r), c = wo.getSvgRoot().createSVGTransform();
          c.setMatrix(dA(Ht(u).matrix, t)), u.clear(), u.appendItem(c);
        } else {
          const u = A(e.x, e.y);
          e.width = n(e.width), e.height = i(e.height), e.x = u.x + Math.min(0, e.width), e.y = u.y + Math.min(0, e.height), e.width = Math.abs(e.width), e.height = Math.abs(e.height);
        }
        a();
        break;
      }
      case "ellipse": {
        const u = A(e.cx, e.cy);
        e.cx = u.x, e.cy = u.y, e.rx = Math.abs(n(e.rx)), e.ry = Math.abs(i(e.ry)), a();
        break;
      }
      case "circle": {
        const u = A(e.cx, e.cy);
        e.cx = u.x, e.cy = u.y;
        const c = $m(o.x, o.y, o.width, o.height, t), f = c.tr.x - c.tl.x, h = c.bl.y - c.tl.y;
        e.r = Math.min(Math.abs(f / 2), Math.abs(h / 2)), a();
        break;
      }
      case "line": {
        const u = A(e.x1, e.y1), c = A(e.x2, e.y2);
        e.x1 = u.x, e.y1 = u.y, e.x2 = c.x, e.y2 = c.y, a();
        break;
      }
      case "text": {
        const u = A(e.x, e.y);
        e.x = u.x, e.y = u.y;
        let c = r.getAttribute("font-size");
        c || (c = window.getComputedStyle(r).fontSize);
        const f = parseFloat(c);
        isNaN(f) || (e["font-size"] = f * Math.abs(t.a)), a();
        const h = r.childNodes;
        for (let g = 0; g < h.length; g++) {
          const p = h[g];
          if (p.nodeType === 1 && p.tagName === "tspan") {
            const v = {}, w = p.hasAttribute("x"), b = p.hasAttribute("y");
            if (w) {
              const x = yr("x", p.getAttribute("x")), U = A(x, e.y).x;
              v.x = U;
            }
            if (b) {
              const x = yr("y", p.getAttribute("y")), U = A(e.x, x).y;
              v.y = U;
            }
            let S = p.getAttribute("font-size");
            S || (S = window.getComputedStyle(p).fontSize);
            const B = parseFloat(S);
            isNaN(B) || (v["font-size"] = B * Math.abs(t.a)), (w || b || v["font-size"]) && Yt(p, v, 1e3, !0);
          }
        }
        break;
      }
      case "tspan": {
        const u = A(e.x, e.y);
        e.x = u.x, e.y = u.y;
        let c = r.getAttribute("font-size");
        c || (c = window.getComputedStyle(r).fontSize);
        const f = parseFloat(c);
        isNaN(f) || (e["font-size"] = f * Math.abs(t.a)), a();
        break;
      }
      case "g": {
        const c = wo.getDataStorage().get(r, "gsvg");
        c && Yt(c, e, 1e3, !0);
        break;
      }
      case "polyline":
      case "polygon": {
        e.points.forEach((c) => {
          const { x: f, y: h } = A(c.x, c.y);
          c.x = f, c.y = h;
        });
        const u = e.points.map((c) => `${c.x},${c.y}`).join(" ");
        r.setAttribute("points", u);
        break;
      }
      case "path": {
        const u = typeof r.getPathData == "function" && typeof r.setPathData == "function", c = u ? null : r.pathSegList, f = u ? r.getPathData().length : c.numberOfItems, g = t.a * t.d - t.b * t.c < 0;
        if (e.d = [], u) {
          const B = r.getPathData();
          for (let x = 0; x < f; ++x) {
            const U = B[x], Q = U.type, N = X1.indexOf(Q);
            if (N === -1) continue;
            const _ = U.values || [], R = { type: N };
            switch (Q.toUpperCase()) {
              case "M":
              case "L":
              case "T":
                [R.x, R.y] = _;
                break;
              case "H":
                [R.x] = _;
                break;
              case "V":
                [R.y] = _;
                break;
              case "C":
                [R.x1, R.y1, R.x2, R.y2, R.x, R.y] = _;
                break;
              case "S":
                [R.x2, R.y2, R.x, R.y] = _;
                break;
              case "Q":
                [R.x1, R.y1, R.x, R.y] = _;
                break;
              case "A":
                [
                  R.r1,
                  R.r2,
                  R.angle,
                  R.largeArcFlag,
                  R.sweepFlag,
                  R.x,
                  R.y
                ] = _;
                break;
            }
            e.d[x] = R;
          }
        } else
          for (let B = 0; B < f; ++B) {
            const x = c.getItem(B);
            e.d[B] = {
              type: x.pathSegType,
              x: x.x,
              y: x.y,
              x1: x.x1,
              y1: x.y1,
              x2: x.x2,
              y2: x.y2,
              r1: x.r1,
              r2: x.r2,
              angle: x.angle,
              largeArcFlag: x.largeArcFlag,
              sweepFlag: x.sweepFlag
            };
          }
        const p = e.d[0];
        let v;
        f > 0 && (v = A(p.x, p.y), e.d[0].x = v.x, e.d[0].y = v.y);
        for (let B = 1; B < f; ++B) {
          const x = e.d[B], { type: U } = x;
          if (U % 2 === 0) {
            const Q = x.x !== void 0 ? x.x : v.x, N = x.y !== void 0 ? x.y : v.y, _ = A(Q, N);
            if (x.x = _.x, x.y = _.y, x.x1 !== void 0 && x.y1 !== void 0) {
              const R = A(x.x1, x.y1);
              x.x1 = R.x, x.y1 = R.y;
            }
            if (x.x2 !== void 0 && x.y2 !== void 0) {
              const R = A(x.x2, x.y2);
              x.x2 = R.x, x.y2 = R.y;
            }
            U === 10 && (x.r1 = Math.abs(n(x.r1)), x.r2 = Math.abs(i(x.r2)), g && (x.sweepFlag = Number(x.sweepFlag) ? 0 : 1, typeof x.angle == "number" && (x.angle = -x.angle)));
          } else
            x.x !== void 0 && (x.x = n(x.x)), x.y !== void 0 && (x.y = i(x.y)), x.x1 !== void 0 && (x.x1 = n(x.x1)), x.y1 !== void 0 && (x.y1 = i(x.y1)), x.x2 !== void 0 && (x.x2 = n(x.x2)), x.y2 !== void 0 && (x.y2 = i(x.y2)), U === 11 && (x.r1 = Math.abs(n(x.r1)), x.r2 = Math.abs(i(x.r2)), g && (x.sweepFlag = Number(x.sweepFlag) ? 0 : 1, typeof x.angle == "number" && (x.angle = -x.angle)));
        }
        let w = "";
        const b = [];
        e.d.forEach((B) => {
          const { type: x } = B, U = X1[x];
          switch (w += U, x) {
            case 13:
            // relative horizontal line (h)
            case 12:
              w += `${B.x} `, b.push({ type: U, values: [B.x] });
              break;
            case 15:
            // relative vertical line (v)
            case 14:
              w += `${B.y} `, b.push({ type: U, values: [B.y] });
              break;
            case 3:
            // relative move (m)
            case 5:
            // relative line (l)
            case 19:
            // relative smooth quad (t)
            case 2:
            // absolute move (M)
            case 4:
            // absolute line (L)
            case 18:
              w += `${B.x},${B.y} `, b.push({ type: U, values: [B.x, B.y] });
              break;
            case 7:
            // relative cubic (c)
            case 6:
              w += `${B.x1},${B.y1} ${B.x2},${B.y2} ${B.x},${B.y} `, b.push({
                type: U,
                values: [B.x1, B.y1, B.x2, B.y2, B.x, B.y]
              });
              break;
            case 9:
            // relative quad (q)
            case 8:
              w += `${B.x1},${B.y1} ${B.x},${B.y} `, b.push({ type: U, values: [B.x1, B.y1, B.x, B.y] });
              break;
            case 11:
            // relative elliptical arc (a)
            case 10:
              w += B.r1 + "," + B.r2 + " " + B.angle + " " + Number(B.largeArcFlag) + " " + Number(B.sweepFlag) + " " + B.x + "," + B.y + " ", b.push({
                type: U,
                values: [
                  B.r1,
                  B.r2,
                  B.angle,
                  Number(B.largeArcFlag),
                  Number(B.sweepFlag),
                  B.x,
                  B.y
                ]
              });
              break;
            case 17:
            // relative smooth cubic (s)
            case 16:
              w += `${B.x2},${B.y2} ${B.x},${B.y} `, b.push({ type: U, values: [B.x2, B.y2, B.x, B.y] });
              break;
          }
        });
        const S = w.trim();
        if (r.setAttribute("d", S), u)
          try {
            r.setPathData(b);
          } catch {
          }
        break;
      }
    }
};
let jr;
const pI = (r) => {
  jr = r;
}, Y0 = (r, e, t, A) => {
  const n = qs(r);
  if (!n) return;
  if (A && n.id) {
    const l = jr.getSvgContent?.();
    if (l) {
      const u = `[clip-path="url(#${n.id})"]`;
      if (l.querySelectorAll(u).length > 1) {
        const f = n.cloneNode(!0);
        return f.id = jr.getNextId(), an().append(f), A.setAttribute("clip-path", `url(#${f.id})`), Y0(`url(#${f.id})`, e, t);
      }
    }
  }
  const i = n.firstElementChild;
  if (!i) return r;
  const s = jt(i);
  if (!s) {
    const l = (i.tagName || "").toLowerCase();
    if (l === "rect") {
      const u = yr("x", i.getAttribute("x") || 0) + e, c = yr("y", i.getAttribute("y") || 0) + t;
      i.setAttribute("x", u), i.setAttribute("y", c);
    } else if (l === "circle" || l === "ellipse") {
      const u = yr("cx", i.getAttribute("cx") || 0) + e, c = yr("cy", i.getAttribute("cy") || 0) + t;
      i.setAttribute("cx", u), i.setAttribute("cy", c);
    } else if (l === "line")
      i.setAttribute("x1", yr("x1", i.getAttribute("x1") || 0) + e), i.setAttribute("y1", yr("y1", i.getAttribute("y1") || 0) + t), i.setAttribute("x2", yr("x2", i.getAttribute("x2") || 0) + e), i.setAttribute("y2", yr("y2", i.getAttribute("y2") || 0) + t);
    else if (l === "polyline" || l === "polygon") {
      const u = (i.getAttribute("points") || "").trim();
      if (u) {
        const c = u.split(/\s+/).map((f) => {
          const [h, g] = f.split(","), p = Number(h) + e, v = Number(g) + t;
          return `${p},${v}`;
        });
        i.setAttribute("points", c.join(" "));
      }
    } else
      i.setAttribute("transform", `translate(${e},${t})`);
    return r;
  }
  if (s.numberOfItems) {
    const l = jr.getSvgRoot().createSVGMatrix();
    l.e = e, l.f = t;
    const u = dA(Ht(s).matrix, l), c = jr.getSvgRoot().createSVGTransform();
    return c.setMatrix(u), s.clear(), s.appendItem(c), r;
  }
  const a = (i.tagName || "").toLowerCase();
  if ((a === "polyline" || a === "polygon") && !i.points?.numberOfItems) {
    const l = (i.getAttribute("points") || "").trim();
    if (l) {
      const u = l.split(/\s+/).map((c) => {
        const [f, h] = c.split(","), g = Number(f) + e, p = Number(h) + t;
        return `${g},${p}`;
      });
      i.setAttribute("points", u.join(" "));
    }
    return;
  }
  const o = jr.getSvgRoot().createSVGTransform();
  return o.setTranslate(e, t), s.appendItem(o), On(i), r;
}, On = (r) => {
  if (!r || r.tagName === "g" || r.tagName === "a" || r.getAttribute?.("clip-path") && r.querySelector?.("[clip-path]"))
    return null;
  const e = jr.getSvgRoot(), t = jr.getDataStorage(), A = jt(r);
  if (A?.numberOfItems > 0) {
    let c = A.numberOfItems;
    const f = c;
    for (; c--; ) {
      const h = A.getItem(c);
      if (h.type === SVGTransform.SVG_TRANSFORM_MATRIX) {
        if (xS(h.matrix)) {
          if (f === 1)
            return r.removeAttribute("transform"), null;
          A.removeItem(c);
        }
      } else (h.type === SVGTransform.SVG_TRANSFORM_ROTATE && h.angle === 0 || h.type === SVGTransform.SVG_TRANSFORM_TRANSLATE && h.matrix.e === 0 && h.matrix.f === 0) && A.removeItem(c);
    }
    if (A.numberOfItems === 1 && bA(r))
      return null;
  }
  if (!A || A.numberOfItems === 0)
    return r.removeAttribute("transform"), null;
  if (r.tagName === "use")
    return null;
  const n = new du("Transform");
  switch (r.tagName) {
    // Ignore these elements, as they can absorb the [M] transformation
    case "line":
    case "polyline":
    case "polygon":
    case "path":
      break;
    default:
      if (A.numberOfItems === 1 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX || A.numberOfItems === 2 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && A.getItem(1).type === SVGTransform.SVG_TRANSFORM_ROTATE)
        return null;
  }
  const i = t.has(r, "gsvg") ? t.get(r, "gsvg") : void 0;
  let s = {}, a = null, o = [];
  switch (r.tagName) {
    case "line":
      o = ["x1", "y1", "x2", "y2"];
      break;
    case "circle":
      o = ["cx", "cy", "r"];
      break;
    case "ellipse":
      o = ["cx", "cy", "rx", "ry"];
      break;
    case "foreignObject":
    case "rect":
    case "image":
      o = ["width", "height", "x", "y"];
      break;
    case "text":
    case "tspan":
      o = ["x", "y"];
      break;
    case "polygon":
    case "polyline": {
      a = {}, a.points = r.getAttribute("points");
      const c = r.points, f = c.numberOfItems;
      s.points = new Array(f);
      for (let h = 0; h < f; ++h) {
        const g = c.getItem(h);
        s.points[h] = { x: g.x, y: g.y };
      }
      break;
    }
    case "path":
      a = {}, a.d = r.getAttribute("d"), s.d = r.getAttribute("d");
      break;
  }
  if (o.length ? o.forEach((c) => {
    s[c] = yr(c, r.getAttribute(c));
  }) : i && (s = {
    x: Number(i.getAttribute("x")) || 0,
    y: Number(i.getAttribute("y")) || 0
  }), !a) {
    a = uu({}, s);
    for (const [c, f] of Object.entries(a))
      a[c] = yr(c, f);
  }
  a.transform = jr.getStartTransform() || "";
  let l, u;
  if (r.tagName === "g" && !i || r.tagName === "a") {
    const c = Ir(r);
    l = { x: c.x + c.width / 2, y: c.y + c.height / 2 }, u = Rt(
      c.x + c.width / 2,
      c.y + c.height / 2,
      Ht(A).matrix
    );
    const f = bA(r);
    if (f) {
      const S = f * Math.PI / 180, B = Math.abs(S) > 1e-10 ? Math.sin(S) / (1 - Math.cos(S)) : 2 / S;
      for (let x = 0; x < A.numberOfItems; ++x) {
        const U = A.getItem(x);
        if (U.type === SVGTransform.SVG_TRANSFORM_ROTATE) {
          const Q = U.matrix;
          l.y = (B * Q.e + Q.f) / 2, l.x = (Q.e - B * Q.f) / 2, A.removeItem(x);
          break;
        }
      }
    }
    const h = A.numberOfItems;
    let g = 0, p = 0, v = 0, w;
    h && (w = A.getItem(0).matrix);
    let b;
    if (h >= 3 && A.getItem(h - 2).type === SVGTransform.SVG_TRANSFORM_SCALE && A.getItem(h - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE && A.getItem(h - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      v = 3;
      const S = A.getItem(h - 3).matrix, B = A.getItem(h - 2).matrix, x = A.getItem(h - 1).matrix, U = r.childNodes;
      let Q = U.length;
      for (; Q--; ) {
        const N = U.item(Q);
        if (N.nodeType !== 1) continue;
        const _ = jt(N);
        if (!_) continue;
        const R = Ht(_).matrix, F = bA(N);
        if (b = jr.getStartTransform(), jr.setStartTransform(N.getAttribute("transform")), F || Ra(_)) {
          const G = e.createSVGTransform();
          G.setMatrix(dA(S, B, x, R)), _.clear(), _.appendItem(G);
        } else {
          const G = dA(R.inverse(), x, R), H = e.createSVGMatrix();
          H.e = -G.e, H.f = -G.f;
          const $ = dA(
            H.inverse(),
            R.inverse(),
            S,
            B,
            x,
            R,
            G.inverse()
          ), ne = e.createSVGTransform(), te = e.createSVGTransform(), J = e.createSVGTransform();
          ne.setTranslate(G.e, G.f), te.setScale($.a, $.d), J.setTranslate(H.e, H.f), _.appendItem(J), _.appendItem(te), _.appendItem(ne);
        }
        const O = On(N);
        O && n.addSubCommand(O), jr.setStartTransform(b);
      }
      A.removeItem(h - 1), A.removeItem(h - 2), A.removeItem(h - 3);
    } else if (h >= 3 && A.getItem(h - 1).type === SVGTransform.SVG_TRANSFORM_MATRIX) {
      v = 3;
      const S = Ht(A).matrix, B = e.createSVGTransform();
      B.setMatrix(S), A.clear(), A.appendItem(B);
    } else if ((h === 1 || h > 1 && A.getItem(1).type !== SVGTransform.SVG_TRANSFORM_SCALE) && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      v = 2;
      const S = Ht(A).matrix;
      A.removeItem(0);
      const B = Ht(A).matrix.inverse(), x = dA(B, S);
      if (g = x.e, p = x.f, g !== 0 || p !== 0) {
        const U = r.getAttribute?.("clip-path");
        U && Y0(U, g, p, r);
        const Q = r.childNodes;
        let N = Q.length;
        const _ = [];
        for (; N--; ) {
          const R = Q.item(N);
          if (R.nodeType !== 1) continue;
          const F = R.getAttribute("clip-path");
          if (F && !_.includes(F)) {
            const J = Y0(F, g, p, R);
            _.push(J || F);
          }
          const O = jt(R);
          if (!O) continue;
          b = jr.getStartTransform(), jr.setStartTransform(R.getAttribute("transform"));
          const G = e.createSVGTransform();
          G.setTranslate(g, p), O.numberOfItems ? O.insertItemBefore(G, 0) : O.appendItem(G);
          const H = On(R);
          H && n.addSubCommand(H);
          const $ = r.getElementsByTagNameNS(et.SVG, "use"), ne = `#${R.id}`;
          let te = $.length;
          for (; te--; ) {
            const J = $.item(te);
            if (ne === Ei(J)) {
              const re = e.createSVGTransform();
              re.setTranslate(-g, -p), jt(J)?.insertItemBefore(re, 0);
              const se = On(J);
              se && n.addSubCommand(se);
            }
          }
          jr.setStartTransform(b);
        }
      }
    } else if (h === 1 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && !f) {
      v = 1;
      const S = A.getItem(0).matrix, B = r.childNodes;
      let x = B.length;
      for (; x--; ) {
        const U = B.item(x);
        if (U.nodeType !== 1) continue;
        const Q = jt(U);
        if (!Q) continue;
        b = jr.getStartTransform(), jr.setStartTransform(U.getAttribute("transform"));
        const N = dA(S, Ht(Q).matrix), _ = e.createSVGTransform();
        _.setMatrix(N), Q.clear(), Q.appendItem(_);
        const R = On(U);
        R && n.addSubCommand(R), jr.setStartTransform(b);
        const F = U.getAttribute("stroke-width");
        if (U.getAttribute("stroke") !== "none" && !Number.isNaN(Number(F))) {
          const O = (Math.abs(N.a) + Math.abs(N.d)) / 2;
          U.setAttribute("stroke-width", Number(F) * O);
        }
      }
      A.clear();
    } else {
      if (f) {
        const S = e.createSVGTransform();
        S.setRotate(f, u.x, u.y), A.numberOfItems ? A.insertItemBefore(S, 0) : A.appendItem(S);
      }
      return A.numberOfItems === 0 && r.removeAttribute("transform"), null;
    }
    if (v === 2) {
      if (f) {
        u = {
          x: l.x + w.e,
          y: l.y + w.f
        };
        const S = e.createSVGTransform();
        S.setRotate(f, u.x, u.y), A.numberOfItems ? A.insertItemBefore(S, 0) : A.appendItem(S);
      }
    } else if (v === 3) {
      const S = Ht(A).matrix, B = e.createSVGTransform();
      B.setRotate(f, l.x, l.y);
      const x = B.matrix, U = e.createSVGTransform();
      U.setRotate(f, u.x, u.y);
      const Q = U.matrix.inverse(), N = S.inverse(), _ = dA(N, Q, x, S);
      if (g = _.e, p = _.f, g !== 0 || p !== 0) {
        const R = r.childNodes;
        let F = R.length;
        for (; F--; ) {
          const O = R.item(F);
          if (O.nodeType !== 1) continue;
          const G = jt(O);
          if (!G) continue;
          b = jr.getStartTransform(), jr.setStartTransform(O.getAttribute("transform"));
          const H = e.createSVGTransform();
          H.setTranslate(g, p), G.numberOfItems ? G.insertItemBefore(H, 0) : G.appendItem(H);
          const $ = On(O);
          $ && n.addSubCommand($), jr.setStartTransform(b);
        }
      }
      f && (A.numberOfItems ? A.insertItemBefore(U, 0) : A.appendItem(U));
    }
  } else {
    const c = Ir(r);
    if (!c && r.tagName !== "path") return null;
    let f, h = 0, g = 0;
    ["use", "image", "text", "tspan"].includes(r.tagName) && (h = yr("x", r.getAttribute("x") || "0"), g = yr("y", r.getAttribute("y") || "0"));
    const p = bA(r);
    if (p) {
      if (r.localName === "image") {
        const w = yr("x", r.getAttribute("x") || "0"), b = yr("y", r.getAttribute("y") || "0"), S = yr("width", r.getAttribute("width") || "0"), B = yr("height", r.getAttribute("height") || "0"), x = w + S / 2, U = b + B / 2;
        l = { x, y: U };
        const Q = Ht(A).matrix;
        u = Rt(x, U, Q);
      } else if (r.localName === "text") {
        const w = c.x + c.width / 2, b = c.y + c.height / 2;
        l = { x: w, y: b }, u = Rt(w, b, Ht(A).matrix);
      } else
        l = {
          x: c.x + c.width / 2 + h,
          y: c.y + c.height / 2 + g
        }, u = Rt(
          c.x + c.width / 2 + h,
          c.y + c.height / 2 + g,
          Ht(A).matrix
        );
      for (let w = 0; w < A.numberOfItems; ++w)
        if (A.getItem(w).type === SVGTransform.SVG_TRANSFORM_ROTATE) {
          A.removeItem(w);
          break;
        }
    }
    const v = A.numberOfItems;
    if (v >= 3 && A.getItem(v - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE && A.getItem(v - 2).type === SVGTransform.SVG_TRANSFORM_SCALE && A.getItem(v - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      if (f = Ht(A, v - 3, v - 1).matrix, A.removeItem(v - 1), A.removeItem(v - 2), A.removeItem(v - 3), r.tagName === "use") {
        const w = Ht(
          jt(r)
        ).matrix, b = dA(w, f);
        A.clear();
        const S = e.createSVGTransform();
        S.setMatrix(b), A.appendItem(S);
      } else
        Ll(r, s, f);
      if (p) {
        const w = Ht(A).matrix, b = e.createSVGTransform();
        b.setRotate(p, l.x, l.y);
        const S = b.matrix, B = e.createSVGTransform();
        B.setRotate(p, u.x, u.y);
        const x = B.matrix.inverse(), U = w.inverse(), Q = dA(
          U,
          x,
          S,
          w
        );
        Ll(r, s, Q), A.numberOfItems ? A.insertItemBefore(B, 0) : A.appendItem(B);
      }
    } else if ((v === 1 || v > 1 && A.getItem(1).type !== SVGTransform.SVG_TRANSFORM_SCALE) && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      const w = A.getItem(0).matrix, b = Ht(A, 1).matrix, S = b.inverse();
      if (f = dA(
        S,
        w,
        b
      ), A.removeItem(0), r.tagName === "use") {
        const B = Ht(
          jt(r)
        ).matrix, x = dA(B, f);
        A.clear();
        const U = e.createSVGTransform();
        U.setMatrix(x), A.appendItem(U);
      } else
        Ll(r, s, f);
      if (p) {
        Ra(A) || (u = {
          x: l.x + f.e,
          y: l.y + f.f
        });
        const B = e.createSVGTransform();
        B.setRotate(p, u.x, u.y), A.numberOfItems ? A.insertItemBefore(B, 0) : A.appendItem(B);
      }
    } else if (v === 1 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && !p)
      if (f = Ht(A).matrix, A.clear(), r.tagName === "use") {
        const w = Ht(
          jt(r)
        ).matrix, b = dA(w, f);
        A.clear();
        const S = e.createSVGTransform();
        S.setMatrix(b), A.appendItem(S);
      } else
        Ll(r, s, f);
    else {
      if (p) {
        const w = e.createSVGTransform();
        w.setRotate(p, u.x, u.y), A.numberOfItems ? A.insertItemBefore(w, 0) : A.appendItem(w);
      }
      return A.numberOfItems === 0 && r.removeAttribute("transform"), null;
    }
  }
  return A.numberOfItems === 0 && r.removeAttribute("transform"), n.addSubCommand(new Ho(r, a)), n;
};
const {
  MoveElementCommand: pu,
  BatchCommand: Js,
  InsertElementCommand: sv,
  RemoveElementCommand: Au,
  ChangeElementCommand: yh
} = Va;
let Se = null;
const mI = (r) => {
  Se = r, Se.copySelectedElements = _I, Se.groupSelectedElements = UI, Se.pushGroupProperties = ov, Se.ungroupSelectedElement = II, Se.moveToTopSelectedElement = vI, Se.moveToBottomSelectedElement = wI, Se.moveUpDownSelected = yI, Se.moveSelectedElements = av, Se.cloneSelectedElements = bI, Se.alignSelectedElements = BI, Se.updateCanvas = QI, Se.cycleElement = LI, Se.deleteSelectedElements = EI, Se.flipSelectedElements = FI;
}, vI = () => {
  const [r] = Se.getSelectedElements();
  if (r) {
    const e = r, t = e.parentNode, A = e.nextSibling;
    e.parentNode.append(e), A !== e.nextSibling && (Se.addCommandToHistory(
      new pu(e, A, t, "top")
    ), Se.call("changed", [e]));
  }
}, wI = () => {
  const [r] = Se.getSelectedElements();
  if (r) {
    let e = r;
    const t = e.parentNode, A = e.nextSibling;
    let n = e.parentNode.firstElementChild;
    if (n?.tagName === "title" && (n = n.nextElementSibling), n?.tagName === "defs" && (n = n.nextElementSibling), !n)
      return;
    e = e.parentNode.insertBefore(e, n), A !== e.nextSibling && (Se.addCommandToHistory(
      new pu(e, A, t, "bottom")
    ), Se.call("changed", [e]));
  }
}, yI = (r) => {
  const t = Se.getSelectedElements()[0];
  if (!t)
    return;
  Se.setCurBBoxes([]);
  let A, n;
  const i = Se.getIntersectionList(
    Hn([t])
  );
  if (r === "Down" && i.reverse(), Array.prototype.forEach.call(i, (l) => n ? (A === void 0 && (A = l), !1) : (l === t && (n = !0), !0)), !A)
    return;
  const s = t, a = s.parentNode, o = s.nextSibling;
  r === "Down" ? A.insertAdjacentElement("beforebegin", s) : A.insertAdjacentElement("afterend", s), o !== s.nextSibling && (Se.addCommandToHistory(
    new pu(s, o, a, `Move ${r}`)
  ), Se.call("changed", [s]));
}, av = (r, e, t = !0) => {
  const A = Se.getSelectedElements(), n = Se.getZoom();
  Array.isArray(r) || (r /= n, e /= n);
  const i = new Js("position");
  if (A.forEach((s, a) => {
    if (s) {
      const o = s.getAttribute("transform") || "", l = Se.getSvgRoot().createSVGTransform(), u = jt(s);
      Array.isArray(r) ? l.setTranslate(r[a], e[a]) : l.setTranslate(r, e), u.numberOfItems ? u.insertItemBefore(l, 0) : u.appendItem(l);
      const c = On(s);
      c ? i.addSubCommand(c) : (s.getAttribute("transform") || "") !== o && i.addSubCommand(
        new yh(s, { transform: o })
      ), Se.gettingSelectorManager().requestSelector(s).resize();
    }
  }), !i.isEmpty())
    return t && Se.addCommandToHistory(i), Se.call("changed", A), i;
}, bI = (r, e) => {
  const t = Se.getSelectedElements(), A = Se.getCurrentGroup();
  let n, i;
  const s = new Js("Clone Elements"), a = t.length, o = (f) => {
    if (!f) return -1;
    let h = 0, g = f;
    do
      h++, g = g.previousElementSibling;
    while (g);
    return h;
  }, l = (f, h) => o(h) - o(f);
  for (t.sort(l), n = 0; n < a && (i = t[n], !!i); ++n)
    ;
  const u = t.slice(0, n);
  Se.clearSelection(!0);
  const c = Se.getDrawing();
  for (n = u.length; n--; )
    i = u[n] = c.copyElem(u[n]), (A || c.getCurrentLayer()).append(i), s.addSubCommand(new sv(i));
  s.isEmpty() || (Se.addToSelection(u.reverse()), av(r, e, !1), Se.addCommandToHistory(s));
}, BI = (r, e) => {
  const t = Se.getSelectedElements(), A = [], n = t.length;
  if (!n)
    return;
  let i = Number.MAX_VALUE, s = Number.MIN_VALUE, a = Number.MAX_VALUE, o = Number.MIN_VALUE;
  const l = (h) => ["l", "c", "r", "left", "center", "right"].includes(h), u = (h) => ["t", "m", "b", "top", "middle", "bottom"].includes(h);
  for (let h = 0; h < n && t[h]; ++h) {
    const g = t[h];
    A[h] = Hn([g]);
  }
  switch (["smallest", "largest"].includes(e) && ["dh", "distrib_horiz", "dv", "distrib_verti"].includes(r) && (e = "selected"), e) {
    case "smallest":
      if (l(r) || u(r)) {
        const g = A.slice().sort((p, v) => p.width - v.width)[0];
        i = g.x, a = g.y, s = g.x + g.width, o = g.y + g.height;
      }
      break;
    case "largest":
      if (l(r) || u(r)) {
        const g = A.slice().sort((p, v) => p.width - v.width)[A.length - 1];
        i = g.x, a = g.y, s = g.x + g.width, o = g.y + g.height;
      }
      break;
    case "page":
      i = 0, a = 0, s = Se.getContentW(), o = Se.getContentH();
      break;
    default:
      i = Math.min(...A.map((h) => h.x)), a = Math.min(...A.map((h) => h.y)), s = Math.max(...A.map((h) => h.x + h.width)), o = Math.max(...A.map((h) => h.y + h.height));
      break;
  }
  let c = [], f = [];
  ["dh", "distrib_horiz"].includes(r) ? [c, f] = CI(e, t, A, i, s, a, o) : ["dv", "distrib_verti"].includes(r) ? [c, f] = SI(e, t, A, i, s, a, o) : [c, f] = xI(r, t, A, i, s, a, o), av(c, f);
}, CI = (r, e, t, A, n, i, s) => {
  const a = [], o = [];
  for (let g = 0; g < e.length; g++)
    o[g] = 0;
  const l = t.slice().sort((g, p) => {
    const v = g.x + g.width, w = p.x + p.width;
    return v === w ? 0 : v > w ? 1 : -1;
  });
  r === "page" && (l.unshift({ x: 0, y: 0, width: 0, height: s }), l.push({ x: n, y: 0, width: 0, height: s }));
  const u = n - A, c = l.map((g) => g.width).reduce((g, p) => g + p, 0), f = (u - c) / (l.length - 1), h = [];
  for (let g = 0; g < l.length; ++g) {
    if (h[g] = 0, g === 0)
      continue;
    const p = l[g].x;
    l[g].x = l[g - 1].x + l[g - 1].width + f, h[g] = l[g].x - p;
  }
  return l.forEach((g, p) => {
    const v = t.findIndex((w) => w === g);
    v !== -1 && (a[v] = h[p]);
  }), [a, o];
}, SI = (r, e, t, A, n, i, s) => {
  const a = [], o = [];
  for (let g = 0; g < e.length; g++)
    a[g] = 0;
  const l = t.slice().sort((g, p) => {
    const v = g.y + g.height, w = p.y + p.height;
    return v === w ? 0 : v > w ? 1 : -1;
  });
  r === "page" && (l.unshift({ x: 0, y: 0, width: n, height: 0 }), l.push({ x: 0, y: s, width: n, height: 0 }));
  const u = s - i, c = l.map((g) => g.height).reduce((g, p) => g + p, 0), f = (u - c) / (l.length - 1), h = [];
  for (let g = 0; g < l.length; ++g) {
    if (h[g] = 0, g === 0)
      continue;
    const p = l[g].y;
    l[g].y = l[g - 1].y + l[g - 1].height + f, h[g] = l[g].y - p;
  }
  return l.forEach((g, p) => {
    const v = t.findIndex((w) => w === g);
    v !== -1 && (o[v] = h[p]);
  }), [a, o];
}, xI = (r, e, t, A, n, i, s) => {
  const a = e.length, o = new Array(a), l = new Array(a);
  for (let u = 0; u < a && e[u]; ++u) {
    const c = t[u];
    switch (o[u] = 0, l[u] = 0, r) {
      case "l":
      // left (horizontal)
      case "left":
        o[u] = A - c.x;
        break;
      case "c":
      // center (horizontal)
      case "center":
        o[u] = (A + n) / 2 - (c.x + c.width / 2);
        break;
      case "r":
      // right (horizontal)
      case "right":
        o[u] = n - (c.x + c.width);
        break;
      case "t":
      // top (vertical)
      case "top":
        l[u] = i - c.y;
        break;
      case "m":
      // middle (vertical)
      case "middle":
        l[u] = (i + s) / 2 - (c.y + c.height / 2);
        break;
      case "b":
      // bottom (vertical)
      case "bottom":
        l[u] = s - (c.y + c.height);
        break;
    }
  }
  return [o, l];
}, EI = () => {
  const r = Se.getSelectedElements(), e = new Js("Delete Elements"), t = [];
  r.forEach((A) => {
    if (A) {
      let n = A.parentNode, i = A;
      Se.gettingSelectorManager().releaseSelector(i), iv(i.id), n.tagName === "a" && n.childNodes.length === 1 && (i = n, n = n.parentNode);
      const { nextSibling: s } = i;
      i.remove();
      const a = i;
      t.push(A), e.addSubCommand(new Au(a, s, n));
    }
  }), Se.setEmptySelectedElements(), e.isEmpty() || Se.addCommandToHistory(e), Se.call("changed", t), Se.clearSelection();
}, FI = (r, e) => {
  const t = Se.getSelectedElements(), A = new Js("Flip Elements"), n = Se.getSvgRoot();
  t.forEach((i) => {
    if (!i) return;
    const s = Hn([i]);
    if (!s) return;
    const a = s.x + s.width / 2, o = s.y + s.height / 2, l = i.getAttribute("transform") || "", u = n.createSVGMatrix().translate(a, o).scaleNonUniform(r, e).translate(-a, -o), c = jt(i), f = dA(
      Ht(c).matrix,
      u
    ), h = n.createSVGTransform();
    h.setMatrix(f), c.clear(), c.appendItem(h);
    const g = Se.getStartTransform ? Se.getStartTransform() : null;
    Se.setStartTransform && Se.setStartTransform(l);
    const p = On(i);
    Se.setStartTransform && Se.setStartTransform(g), p ? A.addSubCommand(p) : (i.getAttribute("transform") || "") !== l && A.addSubCommand(
      new yh(i, { transform: l })
    ), Se.gettingSelectorManager().requestSelector(i).resize();
  }), A.isEmpty() || (Se.addCommandToHistory(A), Se.call("changed", t.filter(Boolean)));
}, _I = () => {
  const r = Se.getSelectedElements().filter(Boolean), e = JSON.stringify(
    r.map((A) => Se.getJsonFromSvgElements(A))
  );
  sessionStorage.setItem(Se.getClipboardID(), e), Se.flashStorage(), document.getElementById("se-cmenu_canvas")?.setAttribute("enablemenuitems", "#paste,#paste_in_place");
}, UI = (r, e) => {
  const t = Se.getSelectedElements();
  r || (r = "g");
  let A = "", n;
  r === "a" ? (A = "Make hyperlink", n = e || "") : (r = "g", A = "Group Elements");
  const i = new Js(A), s = Se.addSVGElementsFromJson({
    element: r,
    attr: {
      id: Se.getNextId()
    }
  });
  r === "a" && Dn(s, n), i.addSubCommand(new sv(s));
  let a = t.length;
  for (; a--; ) {
    let o = t[a];
    if (!o)
      continue;
    o.parentNode.tagName === "a" && o.parentNode.childNodes.length === 1 && (o = o.parentNode);
    const l = o.nextSibling, u = o.parentNode;
    s.append(o), i.addSubCommand(
      new pu(o, l, u)
    );
  }
  i.isEmpty() || Se.addCommandToHistory(i), Se.selectOnly([s], !0);
}, ov = (r, e) => {
  const t = r.childNodes, A = t.length, n = r.getAttribute("transform"), i = jt(r), s = Ht(i).matrix, a = new Js("Push group properties"), o = bA(r), l = {
    filter: r.getAttribute("filter"),
    opacity: r.getAttribute("opacity")
  };
  let u, c, f;
  const h = Se.getDrawing();
  for (let g = 0; g < A; g++) {
    const p = t[g];
    if (p.nodeType !== 1)
      continue;
    if (l.opacity !== null && l.opacity !== 1) {
      const w = Math.round((p.getAttribute("opacity") || 1) * l.opacity * 100) / 100;
      Se.changeSelectedAttribute("opacity", w, [p]);
    }
    if (l.filter) {
      let w = Se.getBlur(p);
      const b = w;
      if (c || (c = Se.getBlur(r)), w ? w = Number(c) + Number(w) : w === 0 && (w = c), b)
        u = qs(p.getAttribute("filter"));
      else if (!u)
        u = qs(l.filter);
      else {
        u = h.copyElem(u), an().append(u);
        const x = q0(u)?.tagName === "feGaussianBlur" ? "blur" : "filter";
        u.id = `${p.id}_${x}`, Se.changeSelectedAttribute(
          "filter",
          `url(#${u.id})`,
          [p]
        );
      }
      const S = q0(u);
      w && (Se.changeSelectedAttribute("stdDeviation", w, [S]), Se.setBlurOffsets(u, w));
    }
    let v = jt(p);
    if (p.tagName.includes("Gradient") && (v = null), !!v && p.tagName !== "defs" && i.numberOfItems)
      if (o && i.numberOfItems === 1) {
        const w = i.getItem(0).matrix;
        let b = Se.getSvgRoot().createSVGMatrix();
        const S = bA(p);
        S && (b = v.getItem(0).matrix);
        const B = Ir(p), x = Ht(v).matrix, U = Rt(
          B.x + B.width / 2,
          B.y + B.height / 2,
          x
        ), Q = o + S, N = Se.getSvgRoot().createSVGTransform();
        N.setRotate(Q, U.x, U.y);
        const _ = dA(w, b, N.matrix.inverse());
        if (S && v.removeItem(0), Q && (v.numberOfItems ? v.insertItemBefore(N, 0) : v.appendItem(N)), _.e || _.f) {
          const R = Se.getSvgRoot().createSVGTransform();
          R.setTranslate(_.e, _.f), v.numberOfItems ? v.insertItemBefore(R, 0) : v.appendItem(R);
        }
      } else {
        const w = p.getAttribute("transform");
        f = {}, f.transform = w || "";
        const b = Se.getSvgRoot().createSVGTransform();
        b.setMatrix(s), v.numberOfItems ? v.insertItemBefore(b, 0) : v.appendItem(b), e && a.addSubCommand(new yh(p, f));
      }
  }
  if (n && (f = {}, f.transform = n, r.setAttribute("transform", ""), r.removeAttribute("transform"), a.addSubCommand(new yh(r, f))), e && !a.isEmpty())
    return a;
}, Y1 = (r) => {
  const e = Se.getSelectedElements();
  r || (r = e[0]);
  const t = r, A = new Js();
  let n;
  const i = Se.getDataStorage();
  if (i.has(t, "gsvg")) {
    const s = r.firstChild, a = {
      x: Number(s.getAttribute("x")),
      y: Number(s.getAttribute("y"))
    }, o = r.firstChild.firstChild;
    o && (o.outerHTML = o.innerHTML), i.remove(r, "gsvg");
    const l = jt(r), u = Se.getSvgRoot().createSVGTransform();
    u.setTranslate(a.x, a.y), l.appendItem(u), On(r), Se.call("selected", [r]);
  } else if (i.has(t, "symbol")) {
    if (r = i.get(t, "symbol"), !r) {
      kA("Unable to convert <use>: missing symbol reference", null, "selected-elem");
      return;
    }
    n = t.getAttribute("transform") || "";
    const s = {
      x: Number(t.getAttribute("x")),
      y: Number(t.getAttribute("y"))
    }, a = r.getAttribute("viewBox");
    if (a) {
      const b = a.split(/[ ,]+/);
      s.x -= Number(b[0]), s.y -= Number(b[1]);
    }
    n += " translate(" + (s.x || 0) + "," + (s.y || 0) + ")";
    const o = t.parentNode, l = t.nextSibling;
    A.addSubCommand(
      new Au(
        t,
        l,
        o
      )
    ), t.remove();
    const c = Se.getSvgContent().querySelectorAll("use").length, f = Se.getDOMDocument().createElementNS(et.SVG, "g"), h = r.childNodes;
    let g;
    for (g = 0; g < h.length; g++)
      f.append(h[g].cloneNode(!0));
    if (Na()) {
      const S = an().querySelectorAll(
        "linearGradient,radialGradient,pattern"
      );
      for (let B = 0, x = S.length; x > B; B++)
        f.appendChild(S[B].cloneNode(!0));
    }
    n && f.setAttribute("transform", n);
    const p = r.parentNode;
    if (Se.uniquifyElems(f), Na()) {
      const b = an(), S = f.querySelectorAll(
        "linearGradient,radialGradient,pattern"
      );
      for (let B = 0, x = S.length; x > B; B++)
        b.appendChild(S[B]);
    }
    if (f.id = Se.getNextId(), o && o.insertBefore(f, l), p) {
      if (!c) {
        const { nextSibling: b } = r;
        r.remove(), A.addSubCommand(
          new Au(r, b, p)
        );
      }
      A.addSubCommand(new sv(f));
    }
    Se.setUseData(f), Na() ? Se.convertGradients(an()) : Se.convertGradients(f), e_(f, (b) => {
      try {
        On(b);
      } catch (S) {
        Ro("Error recalculating dimensions", S, "selected-elem");
      }
    });
    const v = f.querySelectorAll(Se.getVisElems());
    Array.prototype.forEach.call(v, (b) => {
      b.id || (b.id = Se.getNextId());
    }), Se.selectOnly([f]);
    const w = ov(f, !0);
    w && A.addSubCommand(w), Se.addCommandToHistory(A);
  } else
    kA("Unexpected element to ungroup:", r, "selected-elem");
}, II = () => {
  const r = Se.getSelectedElements(), e = Se.getDataStorage();
  let t = r[0];
  if (!t)
    return;
  if (e.has(t, "gsvg") || e.has(t, "symbol")) {
    Y1(t);
    return;
  }
  if (t.tagName === "use") {
    const n = Ei(t);
    if (!n || !n.startsWith("#")) {
      kA("Unexpected <use> without local reference:", t, "selected-elem");
      return;
    }
    const i = Jt(n.slice(1));
    if (!i) {
      kA("Unexpected <use> without resolved reference:", t, "selected-elem");
      return;
    }
    e.put(t, "symbol", i), e.put(t, "ref", i), Y1(t);
    return;
  }
  const A = hu(t.parentNode, "a");
  if (A?.length && (t = A[0]), t.tagName === "g" || t.tagName === "a") {
    const n = new Js("Ungroup Elements"), i = ov(t, !0);
    i && n.addSubCommand(i);
    const s = t.parentNode, a = t.nextSibling, o = new Array(t.childNodes.length);
    let l = 0;
    for (; t.firstChild; ) {
      const c = t.firstChild, f = c.nextSibling, h = c.parentNode;
      if (c.tagName === "title") {
        const { nextSibling: g } = c;
        n.addSubCommand(
          new Au(c, g, h)
        ), c.remove();
        continue;
      }
      o[l++] = s.insertBefore(c, a), n.addSubCommand(
        new pu(c, f, h)
      );
    }
    Se.clearSelection();
    const u = t.nextSibling;
    t.remove(), n.addSubCommand(new Au(t, u, s)), n.isEmpty() || Se.addCommandToHistory(n), Se.addToSelection(o);
  }
}, QI = (r, e) => {
  Se.getSvgRoot().setAttribute("width", r), Se.getSvgRoot().setAttribute("height", e);
  const t = Se.getZoom(), A = document.getElementById("canvasBackground"), n = Number(Se.getSvgContent().getAttribute("x")), i = Number(Se.getSvgContent().getAttribute("y")), s = (r - Se.contentW * t) / 2, a = (e - Se.contentH * t) / 2;
  Yt(Se.getSvgContent(), {
    width: Se.contentW * t,
    height: Se.contentH * t,
    x: s,
    y: a,
    viewBox: `0 0 ${Se.contentW} ${Se.contentH}`
  }), Yt(A, {
    width: Se.getSvgContent().getAttribute("width"),
    height: Se.getSvgContent().getAttribute("height"),
    x: s,
    y: a
  });
  const o = Jt("background_image");
  return o && Yt(o, {
    width: "100%",
    height: "100%"
  }), Se.selectorManager.selectorParentGroup.setAttribute(
    "transform",
    `translate(${s},${a})`
  ), Se.runExtensions(
    "canvasUpdated",
    /**
     * @type {module:svgcanvas.SvgCanvas#event:ext_canvasUpdated}
     */
    {
      new_x: s,
      new_y: a,
      old_x: n,
      old_y: i,
      d_x: s - n,
      d_y: a - i
    }
  ), { x: s, y: a, old_x: n, old_y: i, d_x: s - n, d_y: a - i };
}, LI = (r) => {
  const e = Se.getSelectedElements(), t = Se.getCurrentGroup();
  let A;
  const n = e[0];
  let i = !1;
  const s = fu(
    t || Se.getCurrentDrawing().getCurrentLayer()
  );
  if (s.length) {
    if (!n)
      A = r ? s.length - 1 : 0, i = s[A];
    else {
      let a = s.length;
      for (; a--; )
        if (s[a] === n) {
          A = r ? a - 1 : a + 1, A >= s.length ? A = 0 : A < 0 && (A = s.length - 1), i = s[A];
          break;
        }
    }
    Se.selectOnly([i], !0), Se.call("selected", e);
  }
};
let Nt = null;
const NI = (r) => {
  Nt = r;
}, ux = (r) => !r || r.nodeType !== 1 ? null : r.querySelector("feGaussianBlur") || r.firstElementChild, TI = (r) => {
  const t = Nt.getSelectedElements()[0];
  if (!t) return;
  let A = Nt.getFilter();
  if (A || (A = Nt.getElement(`${t.id}_blur`)), r === 0)
    Nt.changeSelectedAttributeNoUndo("filter", ""), Nt.setFilterHidden(!0);
  else {
    if (!A) {
      const i = Nt.addSVGElementsFromJson({
        element: "feGaussianBlur",
        attr: {
          in: "SourceGraphic",
          stdDeviation: r
        }
      });
      A = Nt.addSVGElementsFromJson({
        element: "filter",
        attr: {
          id: `${t.id}_blur`
        }
      }), A.append(i), Nt.findDefs().append(A);
    }
    (Nt.getFilterHidden() || !t.getAttribute("filter")) && (Nt.changeSelectedAttributeNoUndo("filter", `url(#${A.id})`), Nt.setFilterHidden(!1));
    const n = ux(A);
    if (!n)
      return;
    Nt.changeSelectedAttributeNoUndo("stdDeviation", r, [n]), Nt.setBlurOffsets(A, r);
  }
}, $1 = () => {
  const r = Nt.getCurCommand();
  if (!r) {
    Nt.setCurCommand(null), Nt.setFilter(null), Nt.setFilterHidden(!1);
    return;
  }
  const e = Nt.undoMgr.finishUndoableChange();
  e.isEmpty() || r.addSubCommand(e), r.isEmpty() || Nt.addCommandToHistory(r), Nt.setCurCommand(null), Nt.setFilter(null), Nt.setFilterHidden(!1);
}, PI = (r, e) => {
  !r || r.nodeType !== 1 || (e = Number(e) || 0, e > 3 ? Nt.assignAttributes(r, {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, 100) : (r.removeAttribute("x"), r.removeAttribute("y"), r.removeAttribute("width"), r.removeAttribute("height")));
}, OI = (r, e) => {
  const {
    InsertElementCommand: t,
    ChangeElementCommand: A,
    BatchCommand: n
  } = Nt.history, i = Nt.getSelectedElements();
  if (Nt.getCurCommand()) {
    $1();
    return;
  }
  const s = i[0];
  if (!s)
    return;
  const a = s.id;
  let o = Nt.getElement(`${a}_blur`);
  Nt.setFilter(o), r = Number(r) || 0;
  const l = new n("Change blur");
  if (r === 0) {
    const f = s.getAttribute("filter");
    if (!f)
      return;
    const h = { filter: f };
    s.removeAttribute("filter"), l.addSubCommand(new A(s, h)), Nt.addCommandToHistory(l), Nt.setFilter(null), Nt.setFilterHidden(!0);
    return;
  }
  if (!o) {
    const f = Nt.addSVGElementsFromJson({
      element: "feGaussianBlur",
      attr: {
        in: "SourceGraphic",
        stdDeviation: r
      }
    });
    o = Nt.addSVGElementsFromJson({
      element: "filter",
      attr: {
        id: `${a}_blur`
      }
    }), o.append(f);
    const h = Nt.findDefs();
    h && h.ownerDocument === o.ownerDocument && h.append(o), Nt.setFilter(o), l.addSubCommand(new t(o));
  }
  const u = { filter: s.getAttribute("filter") };
  Nt.changeSelectedAttributeNoUndo("filter", `url(#${o.id})`), l.addSubCommand(new A(s, u)), Nt.setBlurOffsets(o, r), Nt.setCurCommand(l);
  const c = ux(o);
  Nt.undoMgr.beginUndoableChange("stdDeviation", [c]), e && (Nt.setBlurNoUndo(r), $1());
};
const MI = SS(), RI = ["class", "id", "display", "transform", "style"], bh = {
  // SVG Elements
  a: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "href", "mask", "opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "xlink:href", "xlink:title"],
  circle: ["clip-path", "clip-rule", "cx", "cy", "enable-background", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "r", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  clipPath: ["clipPathUnits"],
  defs: [],
  desc: [],
  ellipse: ["clip-path", "clip-rule", "cx", "cy", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "requiredFeatures", "rx", "ry", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  feBlend: ["in", "in2"],
  feColorMatrix: ["in", "type", "value", "result", "values"],
  feComposite: ["in", "operator", "result", "in2"],
  feFlood: ["flood-color", "in", "result", "flood-opacity"],
  feGaussianBlur: ["color-interpolation-filters", "in", "requiredFeatures", "stdDeviation", "result"],
  feMerge: [],
  feMergeNode: ["in"],
  feMorphology: ["in", "operator", "radius"],
  feOffset: ["dx", "in", "dy", "result"],
  filter: ["color-interpolation-filters", "filterRes", "filterUnits", "height", "href", "primitiveUnits", "requiredFeatures", "width", "x", "xlink:href", "y"],
  foreignObject: ["font-size", "height", "opacity", "requiredFeatures", "width", "x", "y"],
  g: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "font-family", "font-size", "font-style", "font-weight", "text-anchor"],
  image: [
    "clip-path",
    "clip-rule",
    "filter",
    "height",
    "mask",
    "opacity",
    "preserveAspectRatio",
    "requiredFeatures",
    "systemLanguage",
    "viewBox",
    "width",
    "x",
    "href",
    "xlink:href",
    "xlink:title",
    "y"
  ],
  line: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "x1", "x2", "y1", "y2"],
  linearGradient: ["gradientTransform", "gradientUnits", "requiredFeatures", "spreadMethod", "systemLanguage", "x1", "x2", "href", "xlink:href", "y1", "y2"],
  marker: ["markerHeight", "markerUnits", "markerWidth", "orient", "preserveAspectRatio", "refX", "refY", "se_type", "systemLanguage", "viewBox"],
  mask: ["height", "maskContentUnits", "maskUnits", "width", "x", "y"],
  metadata: [],
  path: ["clip-path", "clip-rule", "d", "enable-background", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  pattern: ["height", "patternContentUnits", "patternTransform", "patternUnits", "requiredFeatures", "systemLanguage", "viewBox", "width", "x", "href", "xlink:href", "y"],
  polygon: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "points", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "sides", "shape", "edge", "point", "starRadiusMultiplier", "r", "radialshift", "r2", "orient", "cx", "cy"],
  polyline: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "points", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "se:connector"],
  radialGradient: ["cx", "cy", "fx", "fy", "gradientTransform", "gradientUnits", "r", "requiredFeatures", "spreadMethod", "systemLanguage", "href", "xlink:href"],
  rect: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "height", "mask", "opacity", "requiredFeatures", "rx", "ry", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "width", "x", "y"],
  stop: ["offset", "requiredFeatures", "stop-opacity", "systemLanguage", "stop-color", "gradientUnits", "gradientTransform"],
  style: ["type"],
  svg: ["clip-path", "clip-rule", "enable-background", "filter", "height", "mask", "preserveAspectRatio", "requiredFeatures", "systemLanguage", "version", "viewBox", "width", "x", "xmlns", "xmlns:se", "xmlns:xlink", "xmlns:oi", "oi:animations", "y", "stroke-linejoin", "fill-rule", "aria-label", "stroke-width", "fill-rule", "xml:space"],
  switch: ["requiredFeatures", "systemLanguage"],
  symbol: ["fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "opacity", "overflow", "preserveAspectRatio", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "viewBox", "width", "height"],
  text: ["clip-path", "clip-rule", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "text-anchor", "letter-spacing", "word-spacing", "text-decoration", "textLength", "lengthAdjust", "x", "xml:space", "y"],
  textPath: ["dominant-baseline", "href", "method", "requiredFeatures", "spacing", "startOffset", "systemLanguage", "xlink:href"],
  title: [],
  tspan: ["clip-path", "clip-rule", "dx", "dy", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "mask", "opacity", "requiredFeatures", "rotate", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "text-anchor", "textLength", "x", "xml:space", "y"],
  use: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "height", "href", "mask", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "width", "x", "xlink:href", "y", "overflow"],
  // Filter Primitives
  feComponentTransfer: ["in", "result"],
  feFuncR: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncG: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncB: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncA: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feConvolveMatrix: ["in", "order", "kernelMatrix", "divisor", "bias", "targetX", "targetY", "edgeMode", "kernelUnitLength", "preserveAlpha"],
  feDiffuseLighting: ["in", "surfaceScale", "diffuseConstant", "kernelUnitLength", "lighting-color"],
  feSpecularLighting: ["in", "surfaceScale", "specularConstant", "specularExponent", "kernelUnitLength", "lighting-color"],
  feDisplacementMap: ["in", "in2", "scale", "xChannelSelector", "yChannelSelector"],
  feTurbulence: ["baseFrequency", "numOctaves", "result", "seed", "stitchTiles", "type"],
  feTile: ["in"],
  // MathML Elements
  annotation: ["encoding"],
  "annotation-xml": ["encoding"],
  maction: ["actiontype", "other", "selection"],
  math: ["xmlns"],
  menclose: ["notation"],
  merror: [],
  mfrac: ["linethickness"],
  mi: ["mathvariant"],
  mmultiscripts: [],
  mn: [],
  mo: ["fence", "lspace", "maxsize", "minsize", "rspace", "stretchy"],
  mover: [],
  mpadded: ["lspace", "width", "height", "depth", "voffset"],
  mphantom: [],
  mprescripts: [],
  mroot: [],
  mrow: ["href", "xlink:href", "xlink:type", "xmlns:xlink"],
  mspace: ["depth", "height", "width"],
  msqrt: [],
  mstyle: ["displaystyle", "mathbackground", "mathcolor", "mathvariant", "scriptlevel"],
  msub: [],
  msubsup: [],
  msup: [],
  mtable: ["align", "columnalign", "columnlines", "columnspacing", "displaystyle", "equalcolumns", "equalrows", "frame", "rowalign", "rowlines", "rowspacing", "width"],
  mtd: ["columnalign", "columnspan", "rowalign", "rowspan"],
  mtext: [],
  mtr: ["columnalign", "rowalign"],
  munder: [],
  munderover: [],
  none: [],
  semantics: [],
  // HTML Elements for use in a foreignObject
  div: [],
  p: [],
  li: [],
  pre: [],
  ol: [],
  ul: [],
  span: [],
  hr: [],
  br: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: []
};
for (const [r, e] of Object.entries(bh))
  bh[r] = [...e, ...RI];
const cx = {};
for (const [r, e] of Object.entries(bh)) {
  const t = {};
  for (const A of e)
    if (A.includes(":")) {
      const [n, i] = A.split(":");
      t[i] = et[n.toUpperCase()];
    } else
      t[A] = A === "xmlns" ? et.XMLNS : null;
  cx[r] = t;
}
const $0 = (r) => {
  if (r.nodeType === 3 && (r.nodeValue = r.nodeValue.trim(), r.nodeValue.length || r.remove()), r.nodeType !== 1)
    return;
  const e = r.ownerDocument, t = r.parentNode;
  if (!e || !t)
    return;
  const A = bh[r.nodeName], n = cx[r.nodeName];
  if (typeof A < "u") {
    const i = [];
    let s = r.attributes.length;
    for (; s--; ) {
      const l = r.attributes.item(s), u = l.nodeName, c = l.localName, f = l.namespaceURI;
      if (f !== n[c] && f !== et.XMLNS && !(f === et.XMLNS && MI[l.value]) && !(c === "href" && A.includes("href")))
        if (u.startsWith("se:") || u.startsWith("oi:") || u.startsWith("data-")) {
          const g = u.startsWith("se:") ? et.SE : u.startsWith("oi:") ? et.OI : null;
          i.push([u, l.value, g]);
        } else
          kA(`attribute ${u} in element ${r.nodeName} not in whitelist is removed: ${r.outerHTML}`, null, "sanitize"), r.removeAttributeNS(f, c);
      if (u === "style") {
        const h = l.value.split(";");
        let g = h.length;
        for (; g--; ) {
          const [p, v] = h[g].split(":"), w = (p || "").trim(), b = (v || "").trim();
          A.includes(w) && r.setAttribute(w, b);
        }
        r.removeAttribute("style");
      }
    }
    const a = r.getAttributeNS(et.XLINK, "href");
    a && (r.setAttribute("href", a), r.removeAttributeNS(et.XLINK, "href")), Object.values(i).forEach(([l, u, c]) => {
      r.setAttributeNS(c, l, u);
    });
    const o = Ei(r);
    if (o && [
      "filter",
      "linearGradient",
      "pattern",
      "radialGradient",
      "textPath",
      "use"
    ].includes(r.nodeName) && o[0] !== "#" && (Dn(r, ""), kA(`attribute href in element ${r.nodeName} pointing to a non-local reference (${o}) is removed: ${r.outerHTML}`, null, "sanitize"), r.removeAttributeNS(et.XLINK, "href"), r.removeAttribute("href")), r.nodeName === "use" && !Ei(r)) {
      kA(`element ${r.nodeName} without a xlink:href or href is removed: ${r.outerHTML}`, null, "sanitize"), r.remove();
      return;
    }
    if (r.nodeName === "use") {
      const l = qs(Ei(r));
      if (l) {
        const u = l.getAttribute("viewBox"), c = u ? u.split(/[\s,]+/).map(Number) : null, f = Number(l.getAttribute("width")), h = Number(l.getAttribute("height"));
        if (!r.hasAttribute("width")) {
          const g = c?.[2] || f;
          g && r.setAttribute("width", g);
        }
        if (!r.hasAttribute("height")) {
          const g = c?.[3] || h;
          g && r.setAttribute("height", g);
        }
      }
    }
    for (["clip-path", "fill", "filter", "marker-end", "marker-mid", "marker-start", "mask", "stroke"].forEach((l) => {
      let u = r.getAttribute(l);
      u && (u = eu(u), u && u[0] !== "#" && (r.setAttribute(l, ""), kA(`attribute ${l} in element ${r.nodeName} pointing to a non-local reference (${u}) is removed: ${r.outerHTML}`, null, "sanitize"), r.removeAttribute(l)));
    }), s = r.childNodes.length; s--; )
      $0(r.childNodes.item(s));
  } else {
    kA(`element ${r.nodeName} not supported is removed: ${r.outerHTML}`, null, "sanitize");
    const i = [];
    for (; r.hasChildNodes(); )
      i.push(t.insertBefore(r.firstChild, r));
    r.remove();
    let s = i.length;
    for (; s--; )
      $0(i[s]);
  }
};
function Xt(r) {
  "@babel/helpers - typeof";
  return Xt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xt(r);
}
var ai = Uint8Array, xn = Uint16Array, lv = Int32Array, uv = new ai([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), cv = new ai([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), J1 = new ai([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), hx = function(r, e) {
  for (var t = new xn(31), A = 0; A < 31; ++A)
    t[A] = e += 1 << r[A - 1];
  for (var n = new lv(t[30]), A = 1; A < 30; ++A)
    for (var i = t[A]; i < t[A + 1]; ++i)
      n[i] = i - t[A] << 5 | A;
  return { b: t, r: n };
}, fx = hx(uv, 2), kI = fx.b, J0 = fx.r;
kI[28] = 258, J0[258] = 28;
var HI = hx(cv, 0), Z1 = HI.r, Z0 = new xn(32768);
for (var br = 0; br < 32768; ++br) {
  var Qs = (br & 43690) >> 1 | (br & 21845) << 1;
  Qs = (Qs & 52428) >> 2 | (Qs & 13107) << 2, Qs = (Qs & 61680) >> 4 | (Qs & 3855) << 4, Z0[br] = ((Qs & 65280) >> 8 | (Qs & 255) << 8) >> 1;
}
var zl = (function(r, e, t) {
  for (var A = r.length, n = 0, i = new xn(e); n < A; ++n)
    r[n] && ++i[r[n] - 1];
  var s = new xn(e);
  for (n = 1; n < e; ++n)
    s[n] = s[n - 1] + i[n - 1] << 1;
  var a;
  if (t) {
    a = new xn(1 << e);
    var o = 15 - e;
    for (n = 0; n < A; ++n)
      if (r[n])
        for (var l = n << 4 | r[n], u = e - r[n], c = s[r[n] - 1]++ << u, f = c | (1 << u) - 1; c <= f; ++c)
          a[Z0[c] >> o] = l;
  } else
    for (a = new xn(A), n = 0; n < A; ++n)
      r[n] && (a[n] = Z0[s[r[n] - 1]++] >> 15 - r[n]);
  return a;
}), Ha = new ai(288);
for (var br = 0; br < 144; ++br)
  Ha[br] = 8;
for (var br = 144; br < 256; ++br)
  Ha[br] = 9;
for (var br = 256; br < 280; ++br)
  Ha[br] = 7;
for (var br = 280; br < 288; ++br)
  Ha[br] = 8;
var Bh = new ai(32);
for (var br = 0; br < 32; ++br)
  Bh[br] = 5;
var DI = /* @__PURE__ */ zl(Ha, 9, 0), GI = /* @__PURE__ */ zl(Bh, 5, 0), dx = function(r) {
  return (r + 7) / 8 | 0;
}, VI = function(r, e, t) {
  return (t == null || t > r.length) && (t = r.length), new ai(r.subarray(e, t));
}, Wi = function(r, e, t) {
  t <<= e & 7;
  var A = e / 8 | 0;
  r[A] |= t, r[A + 1] |= t >> 8;
}, ml = function(r, e, t) {
  t <<= e & 7;
  var A = e / 8 | 0;
  r[A] |= t, r[A + 1] |= t >> 8, r[A + 2] |= t >> 16;
}, td = function(r, e) {
  for (var t = [], A = 0; A < r.length; ++A)
    r[A] && t.push({ s: A, f: r[A] });
  var n = t.length, i = t.slice();
  if (!n)
    return { t: px, l: 0 };
  if (n == 1) {
    var s = new ai(t[0].s + 1);
    return s[t[0].s] = 1, { t: s, l: 1 };
  }
  t.sort(function(x, U) {
    return x.f - U.f;
  }), t.push({ s: -1, f: 25001 });
  var a = t[0], o = t[1], l = 0, u = 1, c = 2;
  for (t[0] = { s: -1, f: a.f + o.f, l: a, r: o }; u != n - 1; )
    a = t[t[l].f < t[c].f ? l++ : c++], o = t[l != u && t[l].f < t[c].f ? l++ : c++], t[u++] = { s: -1, f: a.f + o.f, l: a, r: o };
  for (var f = i[0].s, A = 1; A < n; ++A)
    i[A].s > f && (f = i[A].s);
  var h = new xn(f + 1), g = em(t[u - 1], h, 0);
  if (g > e) {
    var A = 0, p = 0, v = g - e, w = 1 << v;
    for (i.sort(function(U, Q) {
      return h[Q.s] - h[U.s] || U.f - Q.f;
    }); A < n; ++A) {
      var b = i[A].s;
      if (h[b] > e)
        p += w - (1 << g - h[b]), h[b] = e;
      else
        break;
    }
    for (p >>= v; p > 0; ) {
      var S = i[A].s;
      h[S] < e ? p -= 1 << e - h[S]++ - 1 : ++A;
    }
    for (; A >= 0 && p; --A) {
      var B = i[A].s;
      h[B] == e && (--h[B], ++p);
    }
    g = e;
  }
  return { t: new ai(h), l: g };
}, em = function(r, e, t) {
  return r.s == -1 ? Math.max(em(r.l, e, t + 1), em(r.r, e, t + 1)) : e[r.s] = t;
}, ew = function(r) {
  for (var e = r.length; e && !r[--e]; )
    ;
  for (var t = new xn(++e), A = 0, n = r[0], i = 1, s = function(o) {
    t[A++] = o;
  }, a = 1; a <= e; ++a)
    if (r[a] == n && a != e)
      ++i;
    else {
      if (!n && i > 2) {
        for (; i > 138; i -= 138)
          s(32754);
        i > 2 && (s(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (s(n), --i; i > 6; i -= 6)
          s(8304);
        i > 2 && (s(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        s(n);
      i = 1, n = r[a];
    }
  return { c: t.subarray(0, A), n: e };
}, vl = function(r, e) {
  for (var t = 0, A = 0; A < e.length; ++A)
    t += r[A] * e[A];
  return t;
}, gx = function(r, e, t) {
  var A = t.length, n = dx(e + 2);
  r[n] = A & 255, r[n + 1] = A >> 8, r[n + 2] = r[n] ^ 255, r[n + 3] = r[n + 1] ^ 255;
  for (var i = 0; i < A; ++i)
    r[n + i + 4] = t[i];
  return (n + 4 + A) * 8;
}, tw = function(r, e, t, A, n, i, s, a, o, l, u) {
  Wi(e, u++, t), ++n[256];
  for (var c = td(n, 15), f = c.t, h = c.l, g = td(i, 15), p = g.t, v = g.l, w = ew(f), b = w.c, S = w.n, B = ew(p), x = B.c, U = B.n, Q = new xn(19), N = 0; N < b.length; ++N)
    ++Q[b[N] & 31];
  for (var N = 0; N < x.length; ++N)
    ++Q[x[N] & 31];
  for (var _ = td(Q, 7), R = _.t, F = _.l, O = 19; O > 4 && !R[J1[O - 1]]; --O)
    ;
  var G = l + 5 << 3, H = vl(n, Ha) + vl(i, Bh) + s, $ = vl(n, f) + vl(i, p) + s + 14 + 3 * O + vl(Q, R) + 2 * Q[16] + 3 * Q[17] + 7 * Q[18];
  if (o >= 0 && G <= H && G <= $)
    return gx(e, u, r.subarray(o, o + l));
  var ne, te, J, re;
  if (Wi(e, u, 1 + ($ < H)), u += 2, $ < H) {
    ne = zl(f, h, 0), te = f, J = zl(p, v, 0), re = p;
    var le = zl(R, F, 0);
    Wi(e, u, S - 257), Wi(e, u + 5, U - 1), Wi(e, u + 10, O - 4), u += 14;
    for (var N = 0; N < O; ++N)
      Wi(e, u + 3 * N, R[J1[N]]);
    u += 3 * O;
    for (var se = [b, x], P = 0; P < 2; ++P)
      for (var V = se[P], N = 0; N < V.length; ++N) {
        var X = V[N] & 31;
        Wi(e, u, le[X]), u += R[X], X > 15 && (Wi(e, u, V[N] >> 5 & 127), u += V[N] >> 12);
      }
  } else
    ne = DI, te = Ha, J = GI, re = Bh;
  for (var N = 0; N < a; ++N) {
    var Y = A[N];
    if (Y > 255) {
      var X = Y >> 18 & 31;
      ml(e, u, ne[X + 257]), u += te[X + 257], X > 7 && (Wi(e, u, Y >> 23 & 31), u += uv[X]);
      var ee = Y & 31;
      ml(e, u, J[ee]), u += re[ee], ee > 3 && (ml(e, u, Y >> 5 & 8191), u += cv[ee]);
    } else
      ml(e, u, ne[Y]), u += te[Y];
  }
  return ml(e, u, ne[256]), u + te[256];
}, KI = /* @__PURE__ */ new lv([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), px = /* @__PURE__ */ new ai(0), jI = function(r, e, t, A, n, i) {
  var s = i.z || r.length, a = new ai(A + s + 5 * (1 + Math.ceil(s / 7e3)) + n), o = a.subarray(A, a.length - n), l = i.l, u = (i.r || 0) & 7;
  if (e) {
    u && (o[0] = i.r >> 3);
    for (var c = KI[e - 1], f = c >> 13, h = c & 8191, g = (1 << t) - 1, p = i.p || new xn(32768), v = i.h || new xn(g + 1), w = Math.ceil(t / 3), b = 2 * w, S = function(Ge) {
      return (r[Ge] ^ r[Ge + 1] << w ^ r[Ge + 2] << b) & g;
    }, B = new lv(25e3), x = new xn(288), U = new xn(32), Q = 0, N = 0, _ = i.i || 0, R = 0, F = i.w || 0, O = 0; _ + 2 < s; ++_) {
      var G = S(_), H = _ & 32767, $ = v[G];
      if (p[H] = $, v[G] = H, F <= _) {
        var ne = s - _;
        if ((Q > 7e3 || R > 24576) && (ne > 423 || !l)) {
          u = tw(r, o, 0, B, x, U, N, R, O, _ - O, u), R = Q = N = 0, O = _;
          for (var te = 0; te < 286; ++te)
            x[te] = 0;
          for (var te = 0; te < 30; ++te)
            U[te] = 0;
        }
        var J = 2, re = 0, le = h, se = H - $ & 32767;
        if (ne > 2 && G == S(_ - se))
          for (var P = Math.min(f, ne) - 1, V = Math.min(32767, _), X = Math.min(258, ne); se <= V && --le && H != $; ) {
            if (r[_ + J] == r[_ + J - se]) {
              for (var Y = 0; Y < X && r[_ + Y] == r[_ + Y - se]; ++Y)
                ;
              if (Y > J) {
                if (J = Y, re = se, Y > P)
                  break;
                for (var ee = Math.min(se, Y - 2), oe = 0, te = 0; te < ee; ++te) {
                  var ge = _ - se + te & 32767, pe = p[ge], me = ge - pe & 32767;
                  me > oe && (oe = me, $ = ge);
                }
              }
            }
            H = $, $ = p[H], se += H - $ & 32767;
          }
        if (re) {
          B[R++] = 268435456 | J0[J] << 18 | Z1[re];
          var Ee = J0[J] & 31, Ne = Z1[re] & 31;
          N += uv[Ee] + cv[Ne], ++x[257 + Ee], ++U[Ne], F = _ + J, ++Q;
        } else
          B[R++] = r[_], ++x[r[_]];
      }
    }
    for (_ = Math.max(_, F); _ < s; ++_)
      B[R++] = r[_], ++x[r[_]];
    u = tw(r, o, l, B, x, U, N, R, O, _ - O, u), l || (i.r = u & 7 | o[u / 8 | 0] << 3, u -= 7, i.h = v, i.p = p, i.i = _, i.w = F);
  } else {
    for (var _ = i.w || 0; _ < s + l; _ += 65535) {
      var Te = _ + 65535;
      Te >= s && (o[u / 8 | 0] = l, Te = s), u = gx(o, u + 1, r.subarray(_, Te));
    }
    i.i = s;
  }
  return VI(a, 0, A + dx(u) + n);
}, mx = function() {
  var r = 1, e = 0;
  return {
    p: function(t) {
      for (var A = r, n = e, i = t.length | 0, s = 0; s != i; ) {
        for (var a = Math.min(s + 2655, i); s < a; ++s)
          n += A += t[s];
        A = (A & 65535) + 15 * (A >> 16), n = (n & 65535) + 15 * (n >> 16);
      }
      r = A, e = n;
    },
    d: function() {
      return r %= 65521, e %= 65521, (r & 255) << 24 | (r & 65280) << 8 | (e & 255) << 8 | e >> 8;
    }
  };
}, qI = function(r, e, t, A, n) {
  if (!n && (n = { l: 1 }, e.dictionary)) {
    var i = e.dictionary.subarray(-32768), s = new ai(i.length + r.length);
    s.set(i), s.set(r, i.length), r = s, n.w = i.length;
  }
  return jI(r, e.level == null ? 6 : e.level, e.mem == null ? n.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(r.length))) * 1.5) : 20 : 12 + e.mem, t, A, n);
}, vx = function(r, e, t) {
  for (; t; ++e)
    r[e] = t, t >>>= 8;
}, zI = function(r, e) {
  var t = e.level, A = t == 0 ? 0 : t < 6 ? 1 : t == 9 ? 3 : 2;
  if (r[0] = 120, r[1] = A << 6 | (e.dictionary && 32), r[1] |= 31 - (r[0] << 8 | r[1]) % 31, e.dictionary) {
    var n = mx();
    n.p(e.dictionary), vx(r, 2, n.d());
  }
};
function tm(r, e) {
  e || (e = {});
  var t = mx();
  t.p(r);
  var A = qI(r, e, e.dictionary ? 6 : 2, 4);
  return zI(A, e), vx(A, A.length - 4, t.d()), A;
}
var WI = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), XI = 0;
try {
  WI.decode(px, { stream: !0 }), XI = 1;
} catch {
}
function YI(r) {
  if (Array.isArray(r)) return r;
}
function $I(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var A, n, i, s, a = [], o = !0, l = !1;
    try {
      if (i = (t = t.call(r)).next, e !== 0) for (; !(o = (A = i.call(t)).done) && (a.push(A.value), a.length !== e); o = !0) ;
    } catch (u) {
      l = !0, n = u;
    } finally {
      try {
        if (!o && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw n;
      }
    }
    return a;
  }
}
function rw(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, A = Array(e); t < e; t++) A[t] = r[t];
  return A;
}
function JI(r, e) {
  if (r) {
    if (typeof r == "string") return rw(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? rw(r, e) : void 0;
  }
}
function ZI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Aw(r, e) {
  return YI(r) || $I(r, e) || JI(r, e) || ZI();
}
function nw(r, e = "utf8") {
  return new TextDecoder(e).decode(r);
}
const e3 = new TextEncoder();
function t3(r) {
  return e3.encode(r);
}
const r3 = 1024 * 8, A3 = (() => {
  const r = new Uint8Array(4), e = new Uint32Array(r.buffer);
  return !((e[0] = 1) & r[0]);
})(), rd = {
  int8: globalThis.Int8Array,
  uint8: globalThis.Uint8Array,
  int16: globalThis.Int16Array,
  uint16: globalThis.Uint16Array,
  int32: globalThis.Int32Array,
  uint32: globalThis.Uint32Array,
  uint64: globalThis.BigUint64Array,
  int64: globalThis.BigInt64Array,
  float32: globalThis.Float32Array,
  float64: globalThis.Float64Array
};
class hv {
  /**
   * Reference to the internal ArrayBuffer object.
   */
  buffer;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  byteLength;
  /**
   * Byte offset of the internal ArrayBuffer.
   */
  byteOffset;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  length;
  /**
   * The current offset of the buffer's pointer.
   */
  offset;
  lastWrittenByte;
  littleEndian;
  _data;
  _mark;
  _marks;
  /**
   * Create a new IOBuffer.
   * @param data - The data to construct the IOBuffer with.
   * If data is a number, it will be the new buffer's length<br>
   * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
   * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
   * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
   * @param options - An object for the options.
   * @returns A new IOBuffer instance.
   */
  constructor(e = r3, t = {}) {
    let A = !1;
    typeof e == "number" ? e = new ArrayBuffer(e) : (A = !0, this.lastWrittenByte = e.byteLength);
    const n = t.offset ? t.offset >>> 0 : 0, i = e.byteLength - n;
    let s = n;
    (ArrayBuffer.isView(e) || e instanceof hv) && (e.byteLength !== e.buffer.byteLength && (s = e.byteOffset + n), e = e.buffer), A ? this.lastWrittenByte = i : this.lastWrittenByte = 0, this.buffer = e, this.length = i, this.byteLength = i, this.byteOffset = s, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, s, i), this._mark = 0, this._marks = [];
  }
  /**
   * Checks if the memory allocated to the buffer is sufficient to store more
   * bytes after the offset.
   * @param byteLength - The needed memory in bytes.
   * @returns `true` if there is sufficient space and `false` otherwise.
   */
  available(e = 1) {
    return this.offset + e <= this.length;
  }
  /**
   * Check if little-endian mode is used for reading and writing multi-byte
   * values.
   * @returns `true` if little-endian mode is used, `false` otherwise.
   */
  isLittleEndian() {
    return this.littleEndian;
  }
  /**
   * Set little-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setLittleEndian() {
    return this.littleEndian = !0, this;
  }
  /**
   * Check if big-endian mode is used for reading and writing multi-byte values.
   * @returns `true` if big-endian mode is used, `false` otherwise.
   */
  isBigEndian() {
    return !this.littleEndian;
  }
  /**
   * Switches to big-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setBigEndian() {
    return this.littleEndian = !1, this;
  }
  /**
   * Move the pointer n bytes forward.
   * @param n - Number of bytes to skip.
   * @returns This.
   */
  skip(e = 1) {
    return this.offset += e, this;
  }
  /**
   * Move the pointer n bytes backward.
   * @param n - Number of bytes to move back.
   * @returns This.
   */
  back(e = 1) {
    return this.offset -= e, this;
  }
  /**
   * Move the pointer to the given offset.
   * @param offset - The offset to move to.
   * @returns This.
   */
  seek(e) {
    return this.offset = e, this;
  }
  /**
   * Store the current pointer offset.
   * @see {@link IOBuffer#reset}
   * @returns This.
   */
  mark() {
    return this._mark = this.offset, this;
  }
  /**
   * Move the pointer back to the last pointer offset set by mark.
   * @see {@link IOBuffer#mark}
   * @returns This.
   */
  reset() {
    return this.offset = this._mark, this;
  }
  /**
   * Push the current pointer offset to the mark stack.
   * @see {@link IOBuffer#popMark}
   * @returns This.
   */
  pushMark() {
    return this._marks.push(this.offset), this;
  }
  /**
   * Pop the last pointer offset from the mark stack, and set the current
   * pointer offset to the popped value.
   * @see {@link IOBuffer#pushMark}
   * @returns This.
   */
  popMark() {
    const e = this._marks.pop();
    if (e === void 0)
      throw new Error("Mark stack empty");
    return this.seek(e), this;
  }
  /**
   * Move the pointer offset back to 0.
   * @returns This.
   */
  rewind() {
    return this.offset = 0, this;
  }
  /**
   * Make sure the buffer has sufficient memory to write a given byteLength at
   * the current pointer offset.
   * If the buffer's memory is insufficient, this method will create a new
   * buffer (a copy) with a length that is twice (byteLength + current offset).
   * @param byteLength - The needed memory in bytes.
   * @returns This.
   */
  ensureAvailable(e = 1) {
    if (!this.available(e)) {
      const A = (this.offset + e) * 2, n = new Uint8Array(A);
      n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = A, this.byteLength = A, this._data = new DataView(this.buffer);
    }
    return this;
  }
  /**
   * Read a byte and return false if the byte's value is 0, or true otherwise.
   * Moves pointer forward by one byte.
   * @returns The read boolean.
   */
  readBoolean() {
    return this.readUint8() !== 0;
  }
  /**
   * Read a signed 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readInt8() {
    return this._data.getInt8(this.offset++);
  }
  /**
   * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readUint8() {
    return this._data.getUint8(this.offset++);
  }
  /**
   * Alias for {@link IOBuffer#readUint8}.
   * @returns The read byte.
   */
  readByte() {
    return this.readUint8();
  }
  /**
   * Read `n` bytes and move pointer forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The read bytes.
   */
  readBytes(e = 1) {
    return this.readArray(e, "uint8");
  }
  /**
   * Creates an array of corresponding to the type `type` and size `size`.
   * For example type `uint8` will create a `Uint8Array`.
   * @param size - size of the resulting array
   * @param type - number type of elements to read
   * @returns The read array.
   */
  readArray(e, t) {
    const A = rd[t].BYTES_PER_ELEMENT * e, n = this.byteOffset + this.offset, i = this.buffer.slice(n, n + A);
    if (this.littleEndian === A3 && t !== "uint8" && t !== "int8") {
      const a = new Uint8Array(this.buffer.slice(n, n + A));
      a.reverse();
      const o = new rd[t](a.buffer);
      return this.offset += A, o.reverse(), o;
    }
    const s = new rd[t](i);
    return this.offset += A, s;
  }
  /**
   * Read a 16-bit signed integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readInt16() {
    const e = this._data.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, e;
  }
  /**
   * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readUint16() {
    const e = this._data.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, e;
  }
  /**
   * Read a 32-bit signed integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readInt32() {
    const e = this._data.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readUint32() {
    const e = this._data.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 32-bit floating number and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readFloat32() {
    const e = this._data.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 64-bit floating number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readFloat64() {
    const e = this._data.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigInt64() {
    const e = this._data.getBigInt64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigUint64() {
    const e = this._data.getBigUint64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 1-byte ASCII character and move pointer forward by 1 byte.
   * @returns The read character.
   */
  readChar() {
    return String.fromCharCode(this.readInt8());
  }
  /**
   * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
   * @param n - Number of characters to read.
   * @returns The read characters.
   */
  readChars(e = 1) {
    let t = "";
    for (let A = 0; A < e; A++)
      t += this.readChar();
    return t;
  }
  /**
   * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
   * forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The decoded string.
   */
  readUtf8(e = 1) {
    return nw(this.readBytes(e));
  }
  /**
   * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
   * forward by `n` bytes.
   * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
   * @param n - Number of bytes to read.
   * @param encoding - The encoding to use. Default is 'utf8'.
   * @returns The decoded string.
   */
  decodeText(e = 1, t = "utf8") {
    return nw(this.readBytes(e), t);
  }
  /**
   * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
   * forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeBoolean(e) {
    return this.writeUint8(e ? 255 : 0), this;
  }
  /**
   * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt8(e) {
    return this.ensureAvailable(1), this._data.setInt8(this.offset++, e), this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
   * byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint8(e) {
    return this.ensureAvailable(1), this._data.setUint8(this.offset++, e), this._updateLastWrittenByte(), this;
  }
  /**
   * An alias for {@link IOBuffer#writeUint8}.
   * @param value - The value to write.
   * @returns This.
   */
  writeByte(e) {
    return this.writeUint8(e);
  }
  /**
   * Write all elements of `bytes` as uint8 values and move pointer forward by
   * `bytes.length` bytes.
   * @param bytes - The array of bytes to write.
   * @returns This.
   */
  writeBytes(e) {
    this.ensureAvailable(e.length);
    for (let t = 0; t < e.length; t++)
      this._data.setUint8(this.offset++, e[t]);
    return this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit signed integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt16(e) {
    return this.ensureAvailable(2), this._data.setInt16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint16(e) {
    return this.ensureAvailable(2), this._data.setUint16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit signed integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt32(e) {
    return this.ensureAvailable(4), this._data.setInt32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint32(e) {
    return this.ensureAvailable(4), this._data.setUint32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit floating number and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat32(e) {
    return this.ensureAvailable(4), this._data.setFloat32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit floating number and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat64(e) {
    return this.ensureAvailable(8), this._data.setFloat64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit signed bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigInt64(e) {
    return this.ensureAvailable(8), this._data.setBigInt64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigUint64(e) {
    return this.ensureAvailable(8), this._data.setBigUint64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write the charCode of `str`'s first character as an 8-bit unsigned integer
   * and move pointer forward by 1 byte.
   * @param str - The character to write.
   * @returns This.
   */
  writeChar(e) {
    return this.writeUint8(e.charCodeAt(0));
  }
  /**
   * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
   * and move pointer forward by `str.length` bytes.
   * @param str - The characters to write.
   * @returns This.
   */
  writeChars(e) {
    for (let t = 0; t < e.length; t++)
      this.writeUint8(e.charCodeAt(t));
    return this;
  }
  /**
   * UTF-8 encode and write `str` to the current pointer offset and move pointer
   * forward according to the encoded length.
   * @param str - The string to write.
   * @returns This.
   */
  writeUtf8(e) {
    return this.writeBytes(t3(e));
  }
  /**
   * Export a Uint8Array view of the internal buffer.
   * The view starts at the byte offset and its length
   * is calculated to stop at the last written byte or the original length.
   * @returns A new Uint8Array view.
   */
  toArray() {
    return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
  }
  /**
   *  Get the total number of bytes written so far, regardless of the current offset.
   * @returns - Total number of bytes.
   */
  getWrittenByteLength() {
    return this.lastWrittenByte - this.byteOffset;
  }
  /**
   * Update the last written byte offset
   * @private
   */
  _updateLastWrittenByte() {
    this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
  }
}
function Do(r) {
  let e = r.length;
  for (; --e >= 0; )
    r[e] = 0;
}
const n3 = 3, i3 = 258, wx = 29, s3 = 256, a3 = s3 + 1 + wx, yx = 30, o3 = 512, l3 = new Array((a3 + 2) * 2);
Do(l3);
const u3 = new Array(yx * 2);
Do(u3);
const c3 = new Array(o3);
Do(c3);
const h3 = new Array(i3 - n3 + 1);
Do(h3);
const f3 = new Array(wx);
Do(f3);
const d3 = new Array(yx);
Do(d3);
const g3 = (r, e, t, A) => {
  let n = r & 65535 | 0, i = r >>> 16 & 65535 | 0, s = 0;
  for (; t !== 0; ) {
    s = t > 2e3 ? 2e3 : t, t -= s;
    do
      n = n + e[A++] | 0, i = i + n | 0;
    while (--s);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
};
var rm = g3;
const p3 = () => {
  let r, e = [];
  for (var t = 0; t < 256; t++) {
    r = t;
    for (var A = 0; A < 8; A++)
      r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
    e[t] = r;
  }
  return e;
}, m3 = new Uint32Array(p3()), v3 = (r, e, t, A) => {
  const n = m3, i = A + t;
  r ^= -1;
  for (let s = A; s < i; s++)
    r = r >>> 8 ^ n[(r ^ e[s]) & 255];
  return r ^ -1;
};
var yi = v3, Am = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, bx = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const w3 = (r, e) => Object.prototype.hasOwnProperty.call(r, e);
var y3 = function(r) {
  const e = Array.prototype.slice.call(arguments, 1);
  for (; e.length; ) {
    const t = e.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const A in t)
        w3(t, A) && (r[A] = t[A]);
    }
  }
  return r;
}, b3 = (r) => {
  let e = 0;
  for (let A = 0, n = r.length; A < n; A++)
    e += r[A].length;
  const t = new Uint8Array(e);
  for (let A = 0, n = 0, i = r.length; A < i; A++) {
    let s = r[A];
    t.set(s, n), n += s.length;
  }
  return t;
}, Bx = {
  assign: y3,
  flattenChunks: b3
};
let Cx = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  Cx = !1;
}
const nu = new Uint8Array(256);
for (let r = 0; r < 256; r++)
  nu[r] = r >= 252 ? 6 : r >= 248 ? 5 : r >= 240 ? 4 : r >= 224 ? 3 : r >= 192 ? 2 : 1;
nu[254] = nu[254] = 1;
var B3 = (r) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(r);
  let e, t, A, n, i, s = r.length, a = 0;
  for (n = 0; n < s; n++)
    t = r.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (A = r.charCodeAt(n + 1), (A & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (A - 56320), n++)), a += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (e = new Uint8Array(a), i = 0, n = 0; i < a; n++)
    t = r.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (A = r.charCodeAt(n + 1), (A & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (A - 56320), n++)), t < 128 ? e[i++] = t : t < 2048 ? (e[i++] = 192 | t >>> 6, e[i++] = 128 | t & 63) : t < 65536 ? (e[i++] = 224 | t >>> 12, e[i++] = 128 | t >>> 6 & 63, e[i++] = 128 | t & 63) : (e[i++] = 240 | t >>> 18, e[i++] = 128 | t >>> 12 & 63, e[i++] = 128 | t >>> 6 & 63, e[i++] = 128 | t & 63);
  return e;
};
const C3 = (r, e) => {
  if (e < 65534 && r.subarray && Cx)
    return String.fromCharCode.apply(null, r.length === e ? r : r.subarray(0, e));
  let t = "";
  for (let A = 0; A < e; A++)
    t += String.fromCharCode(r[A]);
  return t;
};
var S3 = (r, e) => {
  const t = e || r.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(r.subarray(0, e));
  let A, n;
  const i = new Array(t * 2);
  for (n = 0, A = 0; A < t; ) {
    let s = r[A++];
    if (s < 128) {
      i[n++] = s;
      continue;
    }
    let a = nu[s];
    if (a > 4) {
      i[n++] = 65533, A += a - 1;
      continue;
    }
    for (s &= a === 2 ? 31 : a === 3 ? 15 : 7; a > 1 && A < t; )
      s = s << 6 | r[A++] & 63, a--;
    if (a > 1) {
      i[n++] = 65533;
      continue;
    }
    s < 65536 ? i[n++] = s : (s -= 65536, i[n++] = 55296 | s >> 10 & 1023, i[n++] = 56320 | s & 1023);
  }
  return C3(i, n);
}, x3 = (r, e) => {
  e = e || r.length, e > r.length && (e = r.length);
  let t = e - 1;
  for (; t >= 0 && (r[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? e : t + nu[r[t]] > e ? t : e;
}, nm = {
  string2buf: B3,
  buf2string: S3,
  utf8border: x3
};
function E3() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var F3 = E3;
const mc = 16209, _3 = 16191;
var U3 = function(e, t) {
  let A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S, B, x, U, Q, N, _, R;
  const F = e.state;
  A = e.next_in, _ = e.input, n = A + (e.avail_in - 5), i = e.next_out, R = e.output, s = i - (t - e.avail_out), a = i + (e.avail_out - 257), o = F.dmax, l = F.wsize, u = F.whave, c = F.wnext, f = F.window, h = F.hold, g = F.bits, p = F.lencode, v = F.distcode, w = (1 << F.lenbits) - 1, b = (1 << F.distbits) - 1;
  e:
    do {
      g < 15 && (h += _[A++] << g, g += 8, h += _[A++] << g, g += 8), S = p[h & w];
      t:
        for (; ; ) {
          if (B = S >>> 24, h >>>= B, g -= B, B = S >>> 16 & 255, B === 0)
            R[i++] = S & 65535;
          else if (B & 16) {
            x = S & 65535, B &= 15, B && (g < B && (h += _[A++] << g, g += 8), x += h & (1 << B) - 1, h >>>= B, g -= B), g < 15 && (h += _[A++] << g, g += 8, h += _[A++] << g, g += 8), S = v[h & b];
            r:
              for (; ; ) {
                if (B = S >>> 24, h >>>= B, g -= B, B = S >>> 16 & 255, B & 16) {
                  if (U = S & 65535, B &= 15, g < B && (h += _[A++] << g, g += 8, g < B && (h += _[A++] << g, g += 8)), U += h & (1 << B) - 1, U > o) {
                    e.msg = "invalid distance too far back", F.mode = mc;
                    break e;
                  }
                  if (h >>>= B, g -= B, B = i - s, U > B) {
                    if (B = U - B, B > u && F.sane) {
                      e.msg = "invalid distance too far back", F.mode = mc;
                      break e;
                    }
                    if (Q = 0, N = f, c === 0) {
                      if (Q += l - B, B < x) {
                        x -= B;
                        do
                          R[i++] = f[Q++];
                        while (--B);
                        Q = i - U, N = R;
                      }
                    } else if (c < B) {
                      if (Q += l + c - B, B -= c, B < x) {
                        x -= B;
                        do
                          R[i++] = f[Q++];
                        while (--B);
                        if (Q = 0, c < x) {
                          B = c, x -= B;
                          do
                            R[i++] = f[Q++];
                          while (--B);
                          Q = i - U, N = R;
                        }
                      }
                    } else if (Q += c - B, B < x) {
                      x -= B;
                      do
                        R[i++] = f[Q++];
                      while (--B);
                      Q = i - U, N = R;
                    }
                    for (; x > 2; )
                      R[i++] = N[Q++], R[i++] = N[Q++], R[i++] = N[Q++], x -= 3;
                    x && (R[i++] = N[Q++], x > 1 && (R[i++] = N[Q++]));
                  } else {
                    Q = i - U;
                    do
                      R[i++] = R[Q++], R[i++] = R[Q++], R[i++] = R[Q++], x -= 3;
                    while (x > 2);
                    x && (R[i++] = R[Q++], x > 1 && (R[i++] = R[Q++]));
                  }
                } else if ((B & 64) === 0) {
                  S = v[(S & 65535) + (h & (1 << B) - 1)];
                  continue r;
                } else {
                  e.msg = "invalid distance code", F.mode = mc;
                  break e;
                }
                break;
              }
          } else if ((B & 64) === 0) {
            S = p[(S & 65535) + (h & (1 << B) - 1)];
            continue t;
          } else if (B & 32) {
            F.mode = _3;
            break e;
          } else {
            e.msg = "invalid literal/length code", F.mode = mc;
            break e;
          }
          break;
        }
    } while (A < n && i < a);
  x = g >> 3, A -= x, g -= x << 3, h &= (1 << g) - 1, e.next_in = A, e.next_out = i, e.avail_in = A < n ? 5 + (n - A) : 5 - (A - n), e.avail_out = i < a ? 257 + (a - i) : 257 - (i - a), F.hold = h, F.bits = g;
};
const ao = 15, iw = 852, sw = 592, aw = 0, Ad = 1, ow = 2, I3 = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), Q3 = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), L3 = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), N3 = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), T3 = (r, e, t, A, n, i, s, a) => {
  const o = a.bits;
  let l = 0, u = 0, c = 0, f = 0, h = 0, g = 0, p = 0, v = 0, w = 0, b = 0, S, B, x, U, Q, N = null, _;
  const R = new Uint16Array(ao + 1), F = new Uint16Array(ao + 1);
  let O = null, G, H, $;
  for (l = 0; l <= ao; l++)
    R[l] = 0;
  for (u = 0; u < A; u++)
    R[e[t + u]]++;
  for (h = o, f = ao; f >= 1 && R[f] === 0; f--)
    ;
  if (h > f && (h = f), f === 0)
    return n[i++] = 1 << 24 | 64 << 16 | 0, n[i++] = 1 << 24 | 64 << 16 | 0, a.bits = 1, 0;
  for (c = 1; c < f && R[c] === 0; c++)
    ;
  for (h < c && (h = c), v = 1, l = 1; l <= ao; l++)
    if (v <<= 1, v -= R[l], v < 0)
      return -1;
  if (v > 0 && (r === aw || f !== 1))
    return -1;
  for (F[1] = 0, l = 1; l < ao; l++)
    F[l + 1] = F[l] + R[l];
  for (u = 0; u < A; u++)
    e[t + u] !== 0 && (s[F[e[t + u]]++] = u);
  if (r === aw ? (N = O = s, _ = 20) : r === Ad ? (N = I3, O = Q3, _ = 257) : (N = L3, O = N3, _ = 0), b = 0, u = 0, l = c, Q = i, g = h, p = 0, x = -1, w = 1 << h, U = w - 1, r === Ad && w > iw || r === ow && w > sw)
    return 1;
  for (; ; ) {
    G = l - p, s[u] + 1 < _ ? (H = 0, $ = s[u]) : s[u] >= _ ? (H = O[s[u] - _], $ = N[s[u] - _]) : (H = 96, $ = 0), S = 1 << l - p, B = 1 << g, c = B;
    do
      B -= S, n[Q + (b >> p) + B] = G << 24 | H << 16 | $ | 0;
    while (B !== 0);
    for (S = 1 << l - 1; b & S; )
      S >>= 1;
    if (S !== 0 ? (b &= S - 1, b += S) : b = 0, u++, --R[l] === 0) {
      if (l === f)
        break;
      l = e[t + s[u]];
    }
    if (l > h && (b & U) !== x) {
      for (p === 0 && (p = h), Q += c, g = l - p, v = 1 << g; g + p < f && (v -= R[g + p], !(v <= 0)); )
        g++, v <<= 1;
      if (w += 1 << g, r === Ad && w > iw || r === ow && w > sw)
        return 1;
      x = b & U, n[x] = h << 24 | g << 16 | Q - i | 0;
    }
  }
  return b !== 0 && (n[Q + b] = l - p << 24 | 64 << 16 | 0), a.bits = h, 0;
};
var Wl = T3;
const P3 = 0, Sx = 1, xx = 2, {
  Z_FINISH: lw,
  Z_BLOCK: O3,
  Z_TREES: vc,
  Z_OK: Da,
  Z_STREAM_END: M3,
  Z_NEED_DICT: R3,
  Z_STREAM_ERROR: Gn,
  Z_DATA_ERROR: Ex,
  Z_MEM_ERROR: Fx,
  Z_BUF_ERROR: k3,
  Z_DEFLATED: uw
} = bx, Hh = 16180, cw = 16181, hw = 16182, fw = 16183, dw = 16184, gw = 16185, pw = 16186, mw = 16187, vw = 16188, ww = 16189, Ch = 16190, Xi = 16191, nd = 16192, yw = 16193, id = 16194, bw = 16195, Bw = 16196, Cw = 16197, Sw = 16198, wc = 16199, yc = 16200, xw = 16201, Ew = 16202, Fw = 16203, _w = 16204, Uw = 16205, sd = 16206, Iw = 16207, Qw = 16208, Br = 16209, _x = 16210, Ux = 16211, H3 = 852, D3 = 592, G3 = 15, V3 = G3, Lw = (r) => (r >>> 24 & 255) + (r >>> 8 & 65280) + ((r & 65280) << 8) + ((r & 255) << 24);
function K3() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const ja = (r) => {
  if (!r)
    return 1;
  const e = r.state;
  return !e || e.strm !== r || e.mode < Hh || e.mode > Ux ? 1 : 0;
}, Ix = (r) => {
  if (ja(r))
    return Gn;
  const e = r.state;
  return r.total_in = r.total_out = e.total = 0, r.msg = "", e.wrap && (r.adler = e.wrap & 1), e.mode = Hh, e.last = 0, e.havedict = 0, e.flags = -1, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Int32Array(H3), e.distcode = e.distdyn = new Int32Array(D3), e.sane = 1, e.back = -1, Da;
}, Qx = (r) => {
  if (ja(r))
    return Gn;
  const e = r.state;
  return e.wsize = 0, e.whave = 0, e.wnext = 0, Ix(r);
}, Lx = (r, e) => {
  let t;
  if (ja(r))
    return Gn;
  const A = r.state;
  return e < 0 ? (t = 0, e = -e) : (t = (e >> 4) + 5, e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? Gn : (A.window !== null && A.wbits !== e && (A.window = null), A.wrap = t, A.wbits = e, Qx(r));
}, Nx = (r, e) => {
  if (!r)
    return Gn;
  const t = new K3();
  r.state = t, t.strm = r, t.window = null, t.mode = Hh;
  const A = Lx(r, e);
  return A !== Da && (r.state = null), A;
}, j3 = (r) => Nx(r, V3);
let Nw = !0, ad, od;
const q3 = (r) => {
  if (Nw) {
    ad = new Int32Array(512), od = new Int32Array(32);
    let e = 0;
    for (; e < 144; )
      r.lens[e++] = 8;
    for (; e < 256; )
      r.lens[e++] = 9;
    for (; e < 280; )
      r.lens[e++] = 7;
    for (; e < 288; )
      r.lens[e++] = 8;
    for (Wl(Sx, r.lens, 0, 288, ad, 0, r.work, { bits: 9 }), e = 0; e < 32; )
      r.lens[e++] = 5;
    Wl(xx, r.lens, 0, 32, od, 0, r.work, { bits: 5 }), Nw = !1;
  }
  r.lencode = ad, r.lenbits = 9, r.distcode = od, r.distbits = 5;
}, Tx = (r, e, t, A) => {
  let n;
  const i = r.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new Uint8Array(i.wsize)), A >= i.wsize ? (i.window.set(e.subarray(t - i.wsize, t), 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > A && (n = A), i.window.set(e.subarray(t - A, t - A + n), i.wnext), A -= n, A ? (i.window.set(e.subarray(t - A, t), 0), i.wnext = A, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}, z3 = (r, e) => {
  let t, A, n, i, s, a, o, l, u, c, f, h, g, p, v = 0, w, b, S, B, x, U, Q, N;
  const _ = new Uint8Array(4);
  let R, F;
  const O = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (ja(r) || !r.output || !r.input && r.avail_in !== 0)
    return Gn;
  t = r.state, t.mode === Xi && (t.mode = nd), s = r.next_out, n = r.output, o = r.avail_out, i = r.next_in, A = r.input, a = r.avail_in, l = t.hold, u = t.bits, c = a, f = o, N = Da;
  e:
    for (; ; )
      switch (t.mode) {
        case Hh:
          if (t.wrap === 0) {
            t.mode = nd;
            break;
          }
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.wrap & 2 && l === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, _[0] = l & 255, _[1] = l >>> 8 & 255, t.check = yi(t.check, _, 2, 0), l = 0, u = 0, t.mode = cw;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            r.msg = "incorrect header check", t.mode = Br;
            break;
          }
          if ((l & 15) !== uw) {
            r.msg = "unknown compression method", t.mode = Br;
            break;
          }
          if (l >>>= 4, u -= 4, Q = (l & 15) + 8, t.wbits === 0 && (t.wbits = Q), Q > 15 || Q > t.wbits) {
            r.msg = "invalid window size", t.mode = Br;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, r.adler = t.check = 1, t.mode = l & 512 ? ww : Xi, l = 0, u = 0;
          break;
        case cw:
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.flags = l, (t.flags & 255) !== uw) {
            r.msg = "unknown compression method", t.mode = Br;
            break;
          }
          if (t.flags & 57344) {
            r.msg = "unknown header flags set", t.mode = Br;
            break;
          }
          t.head && (t.head.text = l >> 8 & 1), t.flags & 512 && t.wrap & 4 && (_[0] = l & 255, _[1] = l >>> 8 & 255, t.check = yi(t.check, _, 2, 0)), l = 0, u = 0, t.mode = hw;
        /* falls through */
        case hw:
          for (; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          t.head && (t.head.time = l), t.flags & 512 && t.wrap & 4 && (_[0] = l & 255, _[1] = l >>> 8 & 255, _[2] = l >>> 16 & 255, _[3] = l >>> 24 & 255, t.check = yi(t.check, _, 4, 0)), l = 0, u = 0, t.mode = fw;
        /* falls through */
        case fw:
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          t.head && (t.head.xflags = l & 255, t.head.os = l >> 8), t.flags & 512 && t.wrap & 4 && (_[0] = l & 255, _[1] = l >>> 8 & 255, t.check = yi(t.check, _, 2, 0)), l = 0, u = 0, t.mode = dw;
        /* falls through */
        case dw:
          if (t.flags & 1024) {
            for (; u < 16; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.length = l, t.head && (t.head.extra_len = l), t.flags & 512 && t.wrap & 4 && (_[0] = l & 255, _[1] = l >>> 8 & 255, t.check = yi(t.check, _, 2, 0)), l = 0, u = 0;
          } else t.head && (t.head.extra = null);
          t.mode = gw;
        /* falls through */
        case gw:
          if (t.flags & 1024 && (h = t.length, h > a && (h = a), h && (t.head && (Q = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            A.subarray(
              i,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              i + h
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            Q
          )), t.flags & 512 && t.wrap & 4 && (t.check = yi(t.check, A, h, i)), a -= h, i += h, t.length -= h), t.length))
            break e;
          t.length = 0, t.mode = pw;
        /* falls through */
        case pw:
          if (t.flags & 2048) {
            if (a === 0)
              break e;
            h = 0;
            do
              Q = A[i + h++], t.head && Q && t.length < 65536 && (t.head.name += String.fromCharCode(Q));
            while (Q && h < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = yi(t.check, A, h, i)), a -= h, i += h, Q)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = mw;
        /* falls through */
        case mw:
          if (t.flags & 4096) {
            if (a === 0)
              break e;
            h = 0;
            do
              Q = A[i + h++], t.head && Q && t.length < 65536 && (t.head.comment += String.fromCharCode(Q));
            while (Q && h < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = yi(t.check, A, h, i)), a -= h, i += h, Q)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = vw;
        /* falls through */
        case vw:
          if (t.flags & 512) {
            for (; u < 16; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (t.wrap & 4 && l !== (t.check & 65535)) {
              r.msg = "header crc mismatch", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), r.adler = t.check = 0, t.mode = Xi;
          break;
        case ww:
          for (; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          r.adler = t.check = Lw(l), l = 0, u = 0, t.mode = Ch;
        /* falls through */
        case Ch:
          if (t.havedict === 0)
            return r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, R3;
          r.adler = t.check = 1, t.mode = Xi;
        /* falls through */
        case Xi:
          if (e === O3 || e === vc)
            break e;
        /* falls through */
        case nd:
          if (t.last) {
            l >>>= u & 7, u -= u & 7, t.mode = sd;
            break;
          }
          for (; u < 3; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          switch (t.last = l & 1, l >>>= 1, u -= 1, l & 3) {
            case 0:
              t.mode = yw;
              break;
            case 1:
              if (q3(t), t.mode = wc, e === vc) {
                l >>>= 2, u -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = Bw;
              break;
            case 3:
              r.msg = "invalid block type", t.mode = Br;
          }
          l >>>= 2, u -= 2;
          break;
        case yw:
          for (l >>>= u & 7, u -= u & 7; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            r.msg = "invalid stored block lengths", t.mode = Br;
            break;
          }
          if (t.length = l & 65535, l = 0, u = 0, t.mode = id, e === vc)
            break e;
        /* falls through */
        case id:
          t.mode = bw;
        /* falls through */
        case bw:
          if (h = t.length, h) {
            if (h > a && (h = a), h > o && (h = o), h === 0)
              break e;
            n.set(A.subarray(i, i + h), s), a -= h, i += h, o -= h, s += h, t.length -= h;
            break;
          }
          t.mode = Xi;
          break;
        case Bw:
          for (; u < 14; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.nlen = (l & 31) + 257, l >>>= 5, u -= 5, t.ndist = (l & 31) + 1, l >>>= 5, u -= 5, t.ncode = (l & 15) + 4, l >>>= 4, u -= 4, t.nlen > 286 || t.ndist > 30) {
            r.msg = "too many length or distance symbols", t.mode = Br;
            break;
          }
          t.have = 0, t.mode = Cw;
        /* falls through */
        case Cw:
          for (; t.have < t.ncode; ) {
            for (; u < 3; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.lens[O[t.have++]] = l & 7, l >>>= 3, u -= 3;
          }
          for (; t.have < 19; )
            t.lens[O[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, R = { bits: t.lenbits }, N = Wl(P3, t.lens, 0, 19, t.lencode, 0, t.work, R), t.lenbits = R.bits, N) {
            r.msg = "invalid code lengths set", t.mode = Br;
            break;
          }
          t.have = 0, t.mode = Sw;
        /* falls through */
        case Sw:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; v = t.lencode[l & (1 << t.lenbits) - 1], w = v >>> 24, b = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (S < 16)
              l >>>= w, u -= w, t.lens[t.have++] = S;
            else {
              if (S === 16) {
                for (F = w + 2; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                if (l >>>= w, u -= w, t.have === 0) {
                  r.msg = "invalid bit length repeat", t.mode = Br;
                  break;
                }
                Q = t.lens[t.have - 1], h = 3 + (l & 3), l >>>= 2, u -= 2;
              } else if (S === 17) {
                for (F = w + 3; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                l >>>= w, u -= w, Q = 0, h = 3 + (l & 7), l >>>= 3, u -= 3;
              } else {
                for (F = w + 7; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                l >>>= w, u -= w, Q = 0, h = 11 + (l & 127), l >>>= 7, u -= 7;
              }
              if (t.have + h > t.nlen + t.ndist) {
                r.msg = "invalid bit length repeat", t.mode = Br;
                break;
              }
              for (; h--; )
                t.lens[t.have++] = Q;
            }
          }
          if (t.mode === Br)
            break;
          if (t.lens[256] === 0) {
            r.msg = "invalid code -- missing end-of-block", t.mode = Br;
            break;
          }
          if (t.lenbits = 9, R = { bits: t.lenbits }, N = Wl(Sx, t.lens, 0, t.nlen, t.lencode, 0, t.work, R), t.lenbits = R.bits, N) {
            r.msg = "invalid literal/lengths set", t.mode = Br;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, R = { bits: t.distbits }, N = Wl(xx, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, R), t.distbits = R.bits, N) {
            r.msg = "invalid distances set", t.mode = Br;
            break;
          }
          if (t.mode = wc, e === vc)
            break e;
        /* falls through */
        case wc:
          t.mode = yc;
        /* falls through */
        case yc:
          if (a >= 6 && o >= 258) {
            r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, U3(r, f), s = r.next_out, n = r.output, o = r.avail_out, i = r.next_in, A = r.input, a = r.avail_in, l = t.hold, u = t.bits, t.mode === Xi && (t.back = -1);
            break;
          }
          for (t.back = 0; v = t.lencode[l & (1 << t.lenbits) - 1], w = v >>> 24, b = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (b && (b & 240) === 0) {
            for (B = w, x = b, U = S; v = t.lencode[U + ((l & (1 << B + x) - 1) >> B)], w = v >>> 24, b = v >>> 16 & 255, S = v & 65535, !(B + w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            l >>>= B, u -= B, t.back += B;
          }
          if (l >>>= w, u -= w, t.back += w, t.length = S, b === 0) {
            t.mode = Uw;
            break;
          }
          if (b & 32) {
            t.back = -1, t.mode = Xi;
            break;
          }
          if (b & 64) {
            r.msg = "invalid literal/length code", t.mode = Br;
            break;
          }
          t.extra = b & 15, t.mode = xw;
        /* falls through */
        case xw:
          if (t.extra) {
            for (F = t.extra; u < F; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.length += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = Ew;
        /* falls through */
        case Ew:
          for (; v = t.distcode[l & (1 << t.distbits) - 1], w = v >>> 24, b = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if ((b & 240) === 0) {
            for (B = w, x = b, U = S; v = t.distcode[U + ((l & (1 << B + x) - 1) >> B)], w = v >>> 24, b = v >>> 16 & 255, S = v & 65535, !(B + w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            l >>>= B, u -= B, t.back += B;
          }
          if (l >>>= w, u -= w, t.back += w, b & 64) {
            r.msg = "invalid distance code", t.mode = Br;
            break;
          }
          t.offset = S, t.extra = b & 15, t.mode = Fw;
        /* falls through */
        case Fw:
          if (t.extra) {
            for (F = t.extra; u < F; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.offset += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            r.msg = "invalid distance too far back", t.mode = Br;
            break;
          }
          t.mode = _w;
        /* falls through */
        case _w:
          if (o === 0)
            break e;
          if (h = f - o, t.offset > h) {
            if (h = t.offset - h, h > t.whave && t.sane) {
              r.msg = "invalid distance too far back", t.mode = Br;
              break;
            }
            h > t.wnext ? (h -= t.wnext, g = t.wsize - h) : g = t.wnext - h, h > t.length && (h = t.length), p = t.window;
          } else
            p = n, g = s - t.offset, h = t.length;
          h > o && (h = o), o -= h, t.length -= h;
          do
            n[s++] = p[g++];
          while (--h);
          t.length === 0 && (t.mode = yc);
          break;
        case Uw:
          if (o === 0)
            break e;
          n[s++] = t.length, o--, t.mode = yc;
          break;
        case sd:
          if (t.wrap) {
            for (; u < 32; ) {
              if (a === 0)
                break e;
              a--, l |= A[i++] << u, u += 8;
            }
            if (f -= o, r.total_out += f, t.total += f, t.wrap & 4 && f && (r.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? yi(t.check, n, f, s - f) : rm(t.check, n, f, s - f)), f = o, t.wrap & 4 && (t.flags ? l : Lw(l)) !== t.check) {
              r.msg = "incorrect data check", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = Iw;
        /* falls through */
        case Iw:
          if (t.wrap && t.flags) {
            for (; u < 32; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (t.wrap & 4 && l !== (t.total & 4294967295)) {
              r.msg = "incorrect length check", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = Qw;
        /* falls through */
        case Qw:
          N = M3;
          break e;
        case Br:
          N = Ex;
          break e;
        case _x:
          return Fx;
        case Ux:
        /* falls through */
        default:
          return Gn;
      }
  return r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, (t.wsize || f !== r.avail_out && t.mode < Br && (t.mode < sd || e !== lw)) && Tx(r, r.output, r.next_out, f - r.avail_out), c -= r.avail_in, f -= r.avail_out, r.total_in += c, r.total_out += f, t.total += f, t.wrap & 4 && f && (r.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? yi(t.check, n, f, r.next_out - f) : rm(t.check, n, f, r.next_out - f)), r.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Xi ? 128 : 0) + (t.mode === wc || t.mode === id ? 256 : 0), (c === 0 && f === 0 || e === lw) && N === Da && (N = k3), N;
}, W3 = (r) => {
  if (ja(r))
    return Gn;
  let e = r.state;
  return e.window && (e.window = null), r.state = null, Da;
}, X3 = (r, e) => {
  if (ja(r))
    return Gn;
  const t = r.state;
  return (t.wrap & 2) === 0 ? Gn : (t.head = e, e.done = !1, Da);
}, Y3 = (r, e) => {
  const t = e.length;
  let A, n, i;
  return ja(r) || (A = r.state, A.wrap !== 0 && A.mode !== Ch) ? Gn : A.mode === Ch && (n = 1, n = rm(n, e, t, 0), n !== A.check) ? Ex : (i = Tx(r, e, t, t), i ? (A.mode = _x, Fx) : (A.havedict = 1, Da));
};
var $3 = Qx, J3 = Lx, Z3 = Ix, eQ = j3, tQ = Nx, rQ = z3, AQ = W3, nQ = X3, iQ = Y3, sQ = "pako inflate (from Nodeca project)", rs = {
  inflateReset: $3,
  inflateReset2: J3,
  inflateResetKeep: Z3,
  inflateInit: eQ,
  inflateInit2: tQ,
  inflate: rQ,
  inflateEnd: AQ,
  inflateGetHeader: nQ,
  inflateSetDictionary: iQ,
  inflateInfo: sQ
};
function aQ() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var oQ = aQ;
const Px = Object.prototype.toString, {
  Z_NO_FLUSH: lQ,
  Z_FINISH: uQ,
  Z_OK: iu,
  Z_STREAM_END: ld,
  Z_NEED_DICT: ud,
  Z_STREAM_ERROR: cQ,
  Z_DATA_ERROR: Tw,
  Z_MEM_ERROR: hQ
} = bx;
function mu(r) {
  this.options = Bx.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, r || {});
  const e = this.options;
  e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, e.windowBits === 0 && (e.windowBits = -15)), e.windowBits >= 0 && e.windowBits < 16 && !(r && r.windowBits) && (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && (e.windowBits & 15) === 0 && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new F3(), this.strm.avail_out = 0;
  let t = rs.inflateInit2(
    this.strm,
    e.windowBits
  );
  if (t !== iu)
    throw new Error(Am[t]);
  if (this.header = new oQ(), rs.inflateGetHeader(this.strm, this.header), e.dictionary && (typeof e.dictionary == "string" ? e.dictionary = nm.string2buf(e.dictionary) : Px.call(e.dictionary) === "[object ArrayBuffer]" && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (t = rs.inflateSetDictionary(this.strm, e.dictionary), t !== iu)))
    throw new Error(Am[t]);
}
mu.prototype.push = function(r, e) {
  const t = this.strm, A = this.options.chunkSize, n = this.options.dictionary;
  let i, s, a;
  if (this.ended) return !1;
  for (e === ~~e ? s = e : s = e === !0 ? uQ : lQ, Px.call(r) === "[object ArrayBuffer]" ? t.input = new Uint8Array(r) : t.input = r, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(A), t.next_out = 0, t.avail_out = A), i = rs.inflate(t, s), i === ud && n && (i = rs.inflateSetDictionary(t, n), i === iu ? i = rs.inflate(t, s) : i === Tw && (i = ud)); t.avail_in > 0 && i === ld && t.state.wrap > 0 && r[t.next_in] !== 0; )
      rs.inflateReset(t), i = rs.inflate(t, s);
    switch (i) {
      case cQ:
      case Tw:
      case ud:
      case hQ:
        return this.onEnd(i), this.ended = !0, !1;
    }
    if (a = t.avail_out, t.next_out && (t.avail_out === 0 || i === ld))
      if (this.options.to === "string") {
        let o = nm.utf8border(t.output, t.next_out), l = t.next_out - o, u = nm.buf2string(t.output, o);
        t.next_out = l, t.avail_out = A - l, l && t.output.set(t.output.subarray(o, o + l), 0), this.onData(u);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out));
    if (!(i === iu && a === 0)) {
      if (i === ld)
        return i = rs.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, !0;
      if (t.avail_in === 0) break;
    }
  }
  return !0;
};
mu.prototype.onData = function(r) {
  this.chunks.push(r);
};
mu.prototype.onEnd = function(r) {
  r === iu && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = Bx.flattenChunks(this.chunks)), this.chunks = [], this.err = r, this.msg = this.strm.msg;
};
function fQ(r, e) {
  const t = new mu(e);
  if (t.push(r), t.err) throw t.msg || Am[t.err];
  return t.result;
}
var dQ = mu, gQ = fQ, pQ = {
  Inflate: dQ,
  inflate: gQ
};
const { Inflate: mQ, inflate: vQ } = pQ;
var Pw = mQ, wQ = vQ;
const Ox = [];
for (let r = 0; r < 256; r++) {
  let e = r;
  for (let t = 0; t < 8; t++)
    e & 1 ? e = 3988292384 ^ e >>> 1 : e = e >>> 1;
  Ox[r] = e;
}
const Ow = 4294967295;
function yQ(r, e, t) {
  let A = r;
  for (let n = 0; n < t; n++)
    A = Ox[(A ^ e[n]) & 255] ^ A >>> 8;
  return A;
}
function bQ(r, e) {
  return (yQ(Ow, r, e) ^ Ow) >>> 0;
}
function Mw(r, e, t) {
  const A = r.readUint32(), n = bQ(new Uint8Array(r.buffer, r.byteOffset + r.offset - e - 4, e), e);
  if (n !== A)
    throw new Error(`CRC mismatch for chunk ${t}. Expected ${A}, found ${n}`);
}
function Mx(r, e, t) {
  for (let A = 0; A < t; A++)
    e[A] = r[A];
}
function Rx(r, e, t, A) {
  let n = 0;
  for (; n < A; n++)
    e[n] = r[n];
  for (; n < t; n++)
    e[n] = r[n] + e[n - A] & 255;
}
function kx(r, e, t, A) {
  let n = 0;
  if (t.length === 0)
    for (; n < A; n++)
      e[n] = r[n];
  else
    for (; n < A; n++)
      e[n] = r[n] + t[n] & 255;
}
function Hx(r, e, t, A, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      e[i] = r[i];
    for (; i < A; i++)
      e[i] = r[i] + (e[i - n] >> 1) & 255;
  } else {
    for (; i < n; i++)
      e[i] = r[i] + (t[i] >> 1) & 255;
    for (; i < A; i++)
      e[i] = r[i] + (e[i - n] + t[i] >> 1) & 255;
  }
}
function Dx(r, e, t, A, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      e[i] = r[i];
    for (; i < A; i++)
      e[i] = r[i] + e[i - n] & 255;
  } else {
    for (; i < n; i++)
      e[i] = r[i] + t[i] & 255;
    for (; i < A; i++)
      e[i] = r[i] + BQ(e[i - n], t[i], t[i - n]) & 255;
  }
}
function BQ(r, e, t) {
  const A = r + e - t, n = Math.abs(A - r), i = Math.abs(A - e), s = Math.abs(A - t);
  return n <= i && n <= s ? r : i <= s ? e : t;
}
function CQ(r, e, t, A, n, i) {
  switch (r) {
    case 0:
      Mx(e, t, n);
      break;
    case 1:
      Rx(e, t, n, i);
      break;
    case 2:
      kx(e, t, A, n);
      break;
    case 3:
      Hx(e, t, A, n, i);
      break;
    case 4:
      Dx(e, t, A, n, i);
      break;
    default:
      throw new Error(`Unsupported filter: ${r}`);
  }
}
const SQ = new Uint16Array([255]), xQ = new Uint8Array(SQ.buffer), EQ = xQ[0] === 255;
function FQ(r) {
  const { data: e, width: t, height: A, channels: n, depth: i } = r, s = [
    { x: 0, y: 0, xStep: 8, yStep: 8 },
    // Pass 1
    { x: 4, y: 0, xStep: 8, yStep: 8 },
    // Pass 2
    { x: 0, y: 4, xStep: 4, yStep: 8 },
    // Pass 3
    { x: 2, y: 0, xStep: 4, yStep: 4 },
    // Pass 4
    { x: 0, y: 2, xStep: 2, yStep: 4 },
    // Pass 5
    { x: 1, y: 0, xStep: 2, yStep: 2 },
    // Pass 6
    { x: 0, y: 1, xStep: 1, yStep: 2 }
    // Pass 7
  ], a = Math.ceil(i / 8) * n, o = new Uint8Array(A * t * a);
  let l = 0;
  for (let u = 0; u < 7; u++) {
    const c = s[u], f = Math.ceil((t - c.x) / c.xStep), h = Math.ceil((A - c.y) / c.yStep);
    if (f <= 0 || h <= 0)
      continue;
    const g = f * a, p = new Uint8Array(g);
    for (let v = 0; v < h; v++) {
      const w = e[l++], b = e.subarray(l, l + g);
      l += g;
      const S = new Uint8Array(g);
      CQ(w, b, S, p, g, a), p.set(S);
      for (let B = 0; B < f; B++) {
        const x = c.x + B * c.xStep, U = c.y + v * c.yStep;
        if (!(x >= t || U >= A))
          for (let Q = 0; Q < a; Q++)
            o[(U * t + x) * a + Q] = S[B * a + Q];
      }
    }
  }
  if (i === 16) {
    const u = new Uint16Array(o.buffer);
    if (EQ)
      for (let c = 0; c < u.length; c++)
        u[c] = _Q(u[c]);
    return u;
  } else
    return o;
}
function _Q(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const UQ = new Uint16Array([255]), IQ = new Uint8Array(UQ.buffer), QQ = IQ[0] === 255, LQ = new Uint8Array(0);
function Rw(r) {
  const { data: e, width: t, height: A, channels: n, depth: i } = r, s = Math.ceil(i / 8) * n, a = Math.ceil(i / 8 * n * t), o = new Uint8Array(A * a);
  let l = LQ, u = 0, c, f;
  for (let h = 0; h < A; h++) {
    switch (c = e.subarray(u + 1, u + 1 + a), f = o.subarray(h * a, (h + 1) * a), e[u]) {
      case 0:
        Mx(c, f, a);
        break;
      case 1:
        Rx(c, f, a, s);
        break;
      case 2:
        kx(c, f, l, a);
        break;
      case 3:
        Hx(c, f, l, a, s);
        break;
      case 4:
        Dx(c, f, l, a, s);
        break;
      default:
        throw new Error(`Unsupported filter: ${e[u]}`);
    }
    l = f, u += a + 1;
  }
  if (i === 16) {
    const h = new Uint16Array(o.buffer);
    if (QQ)
      for (let g = 0; g < h.length; g++)
        h[g] = NQ(h[g]);
    return h;
  } else
    return o;
}
function NQ(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const nh = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function kw(r) {
  if (!TQ(r.readBytes(nh.length)))
    throw new Error("wrong PNG signature");
}
function TQ(r) {
  if (r.length < nh.length)
    return !1;
  for (let e = 0; e < nh.length; e++)
    if (r[e] !== nh[e])
      return !1;
  return !0;
}
const PQ = "tEXt", OQ = 0, Gx = new TextDecoder("latin1");
function MQ(r) {
  if (kQ(r), r.length === 0 || r.length > 79)
    throw new Error("keyword length must be between 1 and 79");
}
const RQ = /^[\u0000-\u00FF]*$/;
function kQ(r) {
  if (!RQ.test(r))
    throw new Error("invalid latin1 text");
}
function HQ(r, e, t) {
  const A = Vx(e);
  r[A] = DQ(e, t - A.length - 1);
}
function Vx(r) {
  for (r.mark(); r.readByte() !== OQ; )
    ;
  const e = r.offset;
  r.reset();
  const t = Gx.decode(r.readBytes(e - r.offset - 1));
  return r.skip(1), MQ(t), t;
}
function DQ(r, e) {
  return Gx.decode(r.readBytes(e));
}
const bn = {
  UNKNOWN: -1,
  GREYSCALE: 0,
  TRUECOLOUR: 2,
  INDEXED_COLOUR: 3,
  GREYSCALE_ALPHA: 4,
  TRUECOLOUR_ALPHA: 6
}, cd = {
  UNKNOWN: -1,
  DEFLATE: 0
}, Hw = {
  UNKNOWN: -1,
  ADAPTIVE: 0
}, hd = {
  UNKNOWN: -1,
  NO_INTERLACE: 0,
  ADAM7: 1
}, bc = {
  NONE: 0,
  BACKGROUND: 1,
  PREVIOUS: 2
}, fd = {
  SOURCE: 0,
  OVER: 1
};
class GQ extends hv {
  _checkCrc;
  _inflator;
  _png;
  _apng;
  _end;
  _hasPalette;
  _palette;
  _hasTransparency;
  _transparency;
  _compressionMethod;
  _filterMethod;
  _interlaceMethod;
  _colorType;
  _isAnimated;
  _numberOfFrames;
  _numberOfPlays;
  _frames;
  _writingDataChunks;
  constructor(e, t = {}) {
    super(e);
    const { checkCrc: A = !1 } = t;
    this._checkCrc = A, this._inflator = new Pw(), this._png = {
      width: -1,
      height: -1,
      channels: -1,
      data: new Uint8Array(0),
      depth: 1,
      text: {}
    }, this._apng = {
      width: -1,
      height: -1,
      channels: -1,
      depth: 1,
      numberOfFrames: 1,
      numberOfPlays: 0,
      text: {},
      frames: []
    }, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = new Uint16Array(0), this._compressionMethod = cd.UNKNOWN, this._filterMethod = Hw.UNKNOWN, this._interlaceMethod = hd.UNKNOWN, this._colorType = bn.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
  }
  decode() {
    for (kw(this); !this._end; ) {
      const e = this.readUint32(), t = this.readChars(4);
      this.decodeChunk(e, t);
    }
    return this.decodeImage(), this._png;
  }
  decodeApng() {
    for (kw(this); !this._end; ) {
      const e = this.readUint32(), t = this.readChars(4);
      this.decodeApngChunk(e, t);
    }
    return this.decodeApngImage(), this._apng;
  }
  // https://www.w3.org/TR/PNG/#5Chunk-layout
  decodeChunk(e, t) {
    const A = this.offset;
    switch (t) {
      // 11.2 Critical chunks
      case "IHDR":
        this.decodeIHDR();
        break;
      case "PLTE":
        this.decodePLTE(e);
        break;
      case "IDAT":
        this.decodeIDAT(e);
        break;
      case "IEND":
        this._end = !0;
        break;
      // 11.3 Ancillary chunks
      case "tRNS":
        this.decodetRNS(e);
        break;
      case "iCCP":
        this.decodeiCCP(e);
        break;
      case PQ:
        HQ(this._png.text, this, e);
        break;
      case "pHYs":
        this.decodepHYs();
        break;
      default:
        this.skip(e);
        break;
    }
    if (this.offset - A !== e)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? Mw(this, e + 4, t) : this.skip(4);
  }
  decodeApngChunk(e, t) {
    const A = this.offset;
    switch (t !== "fdAT" && t !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), t) {
      case "acTL":
        this.decodeACTL();
        break;
      case "fcTL":
        this.decodeFCTL();
        break;
      case "fdAT":
        this.decodeFDAT(e);
        break;
      default:
        this.decodeChunk(e, t), this.offset = A + e;
        break;
    }
    if (this.offset - A !== e)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? Mw(this, e + 4, t) : this.skip(4);
  }
  // https://www.w3.org/TR/PNG/#11IHDR
  decodeIHDR() {
    const e = this._png;
    e.width = this.readUint32(), e.height = this.readUint32(), e.depth = VQ(this.readUint8());
    const t = this.readUint8();
    this._colorType = t;
    let A;
    switch (t) {
      case bn.GREYSCALE:
        A = 1;
        break;
      case bn.TRUECOLOUR:
        A = 3;
        break;
      case bn.INDEXED_COLOUR:
        A = 1;
        break;
      case bn.GREYSCALE_ALPHA:
        A = 2;
        break;
      case bn.TRUECOLOUR_ALPHA:
        A = 4;
        break;
      // Kept for exhaustiveness.
      // eslint-disable-next-line unicorn/no-useless-switch-case
      case bn.UNKNOWN:
      default:
        throw new Error(`Unknown color type: ${t}`);
    }
    if (this._png.channels = A, this._compressionMethod = this.readUint8(), this._compressionMethod !== cd.DEFLATE)
      throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
    this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
  }
  decodeACTL() {
    this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
  }
  decodeFCTL() {
    const e = {
      sequenceNumber: this.readUint32(),
      width: this.readUint32(),
      height: this.readUint32(),
      xOffset: this.readUint32(),
      yOffset: this.readUint32(),
      delayNumber: this.readUint16(),
      delayDenominator: this.readUint16(),
      disposeOp: this.readUint8(),
      blendOp: this.readUint8(),
      data: new Uint8Array(0)
    };
    this._frames.push(e);
  }
  // https://www.w3.org/TR/PNG/#11PLTE
  decodePLTE(e) {
    if (e % 3 !== 0)
      throw new RangeError(`PLTE field length must be a multiple of 3. Got ${e}`);
    const t = e / 3;
    this._hasPalette = !0;
    const A = [];
    this._palette = A;
    for (let n = 0; n < t; n++)
      A.push([this.readUint8(), this.readUint8(), this.readUint8()]);
  }
  // https://www.w3.org/TR/PNG/#11IDAT
  decodeIDAT(e) {
    this._writingDataChunks = !0;
    const t = e, A = this.offset + this.byteOffset;
    if (this._inflator.push(new Uint8Array(this.buffer, A, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  decodeFDAT(e) {
    this._writingDataChunks = !0;
    let t = e, A = this.offset + this.byteOffset;
    if (A += 4, t -= 4, this._inflator.push(new Uint8Array(this.buffer, A, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  // https://www.w3.org/TR/PNG/#11tRNS
  decodetRNS(e) {
    switch (this._colorType) {
      case bn.GREYSCALE:
      case bn.TRUECOLOUR: {
        if (e % 2 !== 0)
          throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${e}`);
        if (e / 2 > this._png.width * this._png.height)
          throw new Error(`tRNS chunk contains more alpha values than there are pixels (${e / 2} vs ${this._png.width * this._png.height})`);
        this._hasTransparency = !0, this._transparency = new Uint16Array(e / 2);
        for (let t = 0; t < e / 2; t++)
          this._transparency[t] = this.readUint16();
        break;
      }
      case bn.INDEXED_COLOUR: {
        if (e > this._palette.length)
          throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${e} vs ${this._palette.length})`);
        let t = 0;
        for (; t < e; t++) {
          const A = this.readByte();
          this._palette[t].push(A);
        }
        for (; t < this._palette.length; t++)
          this._palette[t].push(255);
        break;
      }
      // Kept for exhaustiveness.
      /* eslint-disable unicorn/no-useless-switch-case */
      case bn.UNKNOWN:
      case bn.GREYSCALE_ALPHA:
      case bn.TRUECOLOUR_ALPHA:
      default:
        throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
    }
  }
  // https://www.w3.org/TR/PNG/#11iCCP
  decodeiCCP(e) {
    const t = Vx(this), A = this.readUint8();
    if (A !== cd.DEFLATE)
      throw new Error(`Unsupported iCCP compression method: ${A}`);
    const n = this.readBytes(e - t.length - 2);
    this._png.iccEmbeddedProfile = {
      name: t,
      profile: wQ(n)
    };
  }
  // https://www.w3.org/TR/PNG/#11pHYs
  decodepHYs() {
    const e = this.readUint32(), t = this.readUint32(), A = this.readByte();
    this._png.resolution = { x: e, y: t, unit: A };
  }
  decodeApngImage() {
    this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
    for (let e = 0; e < this._numberOfFrames; e++) {
      const t = {
        sequenceNumber: this._frames[e].sequenceNumber,
        delayNumber: this._frames[e].delayNumber,
        delayDenominator: this._frames[e].delayDenominator,
        data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
      }, A = this._frames.at(e);
      if (A) {
        if (A.data = Rw({
          data: A.data,
          width: A.width,
          height: A.height,
          channels: this._apng.channels,
          depth: this._apng.depth
        }), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), e === 0 || A.xOffset === 0 && A.yOffset === 0 && A.width === this._png.width && A.height === this._png.height)
          t.data = A.data;
        else {
          const n = this._apng.frames.at(e - 1);
          this.disposeFrame(A, n, t), this.addFrameDataToCanvas(t, A);
        }
        this._apng.frames.push(t);
      }
    }
    return this._apng;
  }
  disposeFrame(e, t, A) {
    switch (e.disposeOp) {
      case bc.NONE:
        break;
      case bc.BACKGROUND:
        for (let n = 0; n < this._png.height; n++)
          for (let i = 0; i < this._png.width; i++) {
            const s = (n * e.width + i) * this._png.channels;
            for (let a = 0; a < this._png.channels; a++)
              A.data[s + a] = 0;
          }
        break;
      case bc.PREVIOUS:
        A.data.set(t.data);
        break;
      default:
        throw new Error("Unknown disposeOp");
    }
  }
  addFrameDataToCanvas(e, t) {
    const A = 1 << this._png.depth, n = (i, s) => {
      const a = ((i + t.yOffset) * this._png.width + t.xOffset + s) * this._png.channels, o = (i * t.width + s) * this._png.channels;
      return { index: a, frameIndex: o };
    };
    switch (t.blendOp) {
      case fd.SOURCE:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++)
              e.data[a + l] = t.data[o + l];
          }
        break;
      // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
      case fd.OVER:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++) {
              const u = t.data[o + this._png.channels - 1] / A, c = l % (this._png.channels - 1) === 0 ? 1 : t.data[o + l], f = Math.floor(u * c + (1 - u) * e.data[a + l]);
              e.data[a + l] += f;
            }
          }
        break;
      default:
        throw new Error("Unknown blendOp");
    }
  }
  decodeImage() {
    if (this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    const e = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
    if (this._filterMethod !== Hw.ADAPTIVE)
      throw new Error(`Filter method ${this._filterMethod} not supported`);
    if (this._interlaceMethod === hd.NO_INTERLACE)
      this._png.data = Rw({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else if (this._interlaceMethod === hd.ADAM7)
      this._png.data = FQ({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else
      throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
    this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
  }
  pushDataToFrame() {
    const e = this._inflator.result, t = this._frames.at(-1);
    t ? t.data = e : this._frames.push({
      sequenceNumber: 0,
      width: this._png.width,
      height: this._png.height,
      xOffset: 0,
      yOffset: 0,
      delayNumber: 0,
      delayDenominator: 0,
      disposeOp: bc.NONE,
      blendOp: fd.SOURCE,
      data: e
    }), this._inflator = new Pw(), this._writingDataChunks = !1;
  }
}
function VQ(r) {
  if (r !== 1 && r !== 2 && r !== 4 && r !== 8 && r !== 16)
    throw new Error(`invalid bit depth: ${r}`);
  return r;
}
var Dw;
(function(r) {
  r[r.UNKNOWN = 0] = "UNKNOWN", r[r.METRE = 1] = "METRE";
})(Dw || (Dw = {}));
function KQ(r, e) {
  return new GQ(r, e).decode();
}
var Ct = /* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
})();
function dd() {
  Ct.console && typeof Ct.console.log == "function" && Ct.console.log.apply(Ct.console, arguments);
}
var ur = { log: dd, warn: function(r) {
  Ct.console && (typeof Ct.console.warn == "function" ? Ct.console.warn.apply(Ct.console, arguments) : dd.call(null, arguments));
}, error: function(r) {
  Ct.console && (typeof Ct.console.error == "function" ? Ct.console.error.apply(Ct.console, arguments) : dd(r));
} };
function gd(r, e, t) {
  var A = new XMLHttpRequest();
  A.open("GET", r), A.responseType = "blob", A.onload = function() {
    Sa(A.response, e, t);
  }, A.onerror = function() {
    ur.error("could not download file");
  }, A.send();
}
function Gw(r) {
  var e = new XMLHttpRequest();
  e.open("HEAD", r, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function Bc(r) {
  try {
    r.dispatchEvent(new MouseEvent("click"));
  } catch {
    var e = document.createEvent("MouseEvents");
    e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), r.dispatchEvent(e);
  }
}
var Sa = Ct.saveAs || ((typeof window > "u" ? "undefined" : Xt(window)) !== "object" || window !== Ct ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(r, e, t) {
  var A = Ct.URL || Ct.webkitURL, n = document.createElement("a");
  e = e || r.name || "download", n.download = e, n.rel = "noopener", typeof r == "string" ? (n.href = r, n.origin !== location.origin ? Gw(n.href) ? gd(r, e, t) : Bc(n, n.target = "_blank") : Bc(n)) : (n.href = A.createObjectURL(r), setTimeout(function() {
    A.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    Bc(n);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(r, e, t) {
  if (e = e || r.name || "download", typeof r == "string") if (Gw(r)) gd(r, e, t);
  else {
    var A = document.createElement("a");
    A.href = r, A.target = "_blank", setTimeout(function() {
      Bc(A);
    });
  }
  else navigator.msSaveOrOpenBlob((function(n, i) {
    return i === void 0 ? i = { autoBom: !1 } : Xt(i) !== "object" && (ur.warn("Deprecated: Expected third argument to be a object"), i = { autoBom: !i }), i.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
  })(r, t), e);
} : function(r, e, t, A) {
  if ((A = A || open("", "_blank")) && (A.document.title = A.document.body.innerText = "downloading..."), typeof r == "string") return gd(r, e, t);
  var n = r.type === "application/octet-stream", i = /constructor/i.test(Ct.HTMLElement) || Ct.safari, s = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((s || n && i) && (typeof FileReader > "u" ? "undefined" : Xt(FileReader)) === "object") {
    var a = new FileReader();
    a.onloadend = function() {
      var u = a.result;
      u = s ? u : u.replace(/^data:[^;]*;/, "data:attachment/file;"), A ? A.location.href = u : location = u, A = null;
    }, a.readAsDataURL(r);
  } else {
    var o = Ct.URL || Ct.webkitURL, l = o.createObjectURL(r);
    A ? A.location = l : location.href = l, A = null, setTimeout(function() {
      o.revokeObjectURL(l);
    }, 4e4);
  }
});
function Kx(r) {
  var e;
  r = r || "", this.ok = !1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[r = (r = r.replace(/ /g, "")).toLowerCase()] || r;
  for (var t = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(a) {
    return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(a) {
    return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(a) {
    return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
  } }], A = 0; A < t.length; A++) {
    var n = t[A].re, i = t[A].process, s = n.exec(r);
    s && (e = i(s), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var a = this.r.toString(16), o = this.g.toString(16), l = this.b.toString(16);
    return a.length == 1 && (a = "0" + a), o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), "#" + a + o + l;
  };
}
var ih = Ct.atob.bind(Ct), Vw = Ct.btoa.bind(Ct);
function pd(r, e) {
  var t = r[0], A = r[1], n = r[2], i = r[3];
  t = NA(t, A, n, i, e[0], 7, -680876936), i = NA(i, t, A, n, e[1], 12, -389564586), n = NA(n, i, t, A, e[2], 17, 606105819), A = NA(A, n, i, t, e[3], 22, -1044525330), t = NA(t, A, n, i, e[4], 7, -176418897), i = NA(i, t, A, n, e[5], 12, 1200080426), n = NA(n, i, t, A, e[6], 17, -1473231341), A = NA(A, n, i, t, e[7], 22, -45705983), t = NA(t, A, n, i, e[8], 7, 1770035416), i = NA(i, t, A, n, e[9], 12, -1958414417), n = NA(n, i, t, A, e[10], 17, -42063), A = NA(A, n, i, t, e[11], 22, -1990404162), t = NA(t, A, n, i, e[12], 7, 1804603682), i = NA(i, t, A, n, e[13], 12, -40341101), n = NA(n, i, t, A, e[14], 17, -1502002290), t = TA(t, A = NA(A, n, i, t, e[15], 22, 1236535329), n, i, e[1], 5, -165796510), i = TA(i, t, A, n, e[6], 9, -1069501632), n = TA(n, i, t, A, e[11], 14, 643717713), A = TA(A, n, i, t, e[0], 20, -373897302), t = TA(t, A, n, i, e[5], 5, -701558691), i = TA(i, t, A, n, e[10], 9, 38016083), n = TA(n, i, t, A, e[15], 14, -660478335), A = TA(A, n, i, t, e[4], 20, -405537848), t = TA(t, A, n, i, e[9], 5, 568446438), i = TA(i, t, A, n, e[14], 9, -1019803690), n = TA(n, i, t, A, e[3], 14, -187363961), A = TA(A, n, i, t, e[8], 20, 1163531501), t = TA(t, A, n, i, e[13], 5, -1444681467), i = TA(i, t, A, n, e[2], 9, -51403784), n = TA(n, i, t, A, e[7], 14, 1735328473), t = PA(t, A = TA(A, n, i, t, e[12], 20, -1926607734), n, i, e[5], 4, -378558), i = PA(i, t, A, n, e[8], 11, -2022574463), n = PA(n, i, t, A, e[11], 16, 1839030562), A = PA(A, n, i, t, e[14], 23, -35309556), t = PA(t, A, n, i, e[1], 4, -1530992060), i = PA(i, t, A, n, e[4], 11, 1272893353), n = PA(n, i, t, A, e[7], 16, -155497632), A = PA(A, n, i, t, e[10], 23, -1094730640), t = PA(t, A, n, i, e[13], 4, 681279174), i = PA(i, t, A, n, e[0], 11, -358537222), n = PA(n, i, t, A, e[3], 16, -722521979), A = PA(A, n, i, t, e[6], 23, 76029189), t = PA(t, A, n, i, e[9], 4, -640364487), i = PA(i, t, A, n, e[12], 11, -421815835), n = PA(n, i, t, A, e[15], 16, 530742520), t = OA(t, A = PA(A, n, i, t, e[2], 23, -995338651), n, i, e[0], 6, -198630844), i = OA(i, t, A, n, e[7], 10, 1126891415), n = OA(n, i, t, A, e[14], 15, -1416354905), A = OA(A, n, i, t, e[5], 21, -57434055), t = OA(t, A, n, i, e[12], 6, 1700485571), i = OA(i, t, A, n, e[3], 10, -1894986606), n = OA(n, i, t, A, e[10], 15, -1051523), A = OA(A, n, i, t, e[1], 21, -2054922799), t = OA(t, A, n, i, e[8], 6, 1873313359), i = OA(i, t, A, n, e[15], 10, -30611744), n = OA(n, i, t, A, e[6], 15, -1560198380), A = OA(A, n, i, t, e[13], 21, 1309151649), t = OA(t, A, n, i, e[4], 6, -145523070), i = OA(i, t, A, n, e[11], 10, -1120210379), n = OA(n, i, t, A, e[2], 15, 718787259), A = OA(A, n, i, t, e[9], 21, -343485551), r[0] = Hs(t, r[0]), r[1] = Hs(A, r[1]), r[2] = Hs(n, r[2]), r[3] = Hs(i, r[3]);
}
function Dh(r, e, t, A, n, i) {
  return e = Hs(Hs(e, r), Hs(A, i)), Hs(e << n | e >>> 32 - n, t);
}
function NA(r, e, t, A, n, i, s) {
  return Dh(e & t | ~e & A, r, e, n, i, s);
}
function TA(r, e, t, A, n, i, s) {
  return Dh(e & A | t & ~A, r, e, n, i, s);
}
function PA(r, e, t, A, n, i, s) {
  return Dh(e ^ t ^ A, r, e, n, i, s);
}
function OA(r, e, t, A, n, i, s) {
  return Dh(t ^ (e | ~A), r, e, n, i, s);
}
function jx(r) {
  var e, t = r.length, A = [1732584193, -271733879, -1732584194, 271733878];
  for (e = 64; e <= r.length; e += 64) pd(A, jQ(r.substring(e - 64, e)));
  r = r.substring(e - 64);
  var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (e = 0; e < r.length; e++) n[e >> 2] |= r.charCodeAt(e) << (e % 4 << 3);
  if (n[e >> 2] |= 128 << (e % 4 << 3), e > 55) for (pd(A, n), e = 0; e < 16; e++) n[e] = 0;
  return n[14] = 8 * t, pd(A, n), A;
}
function jQ(r) {
  var e, t = [];
  for (e = 0; e < 64; e += 4) t[e >> 2] = r.charCodeAt(e) + (r.charCodeAt(e + 1) << 8) + (r.charCodeAt(e + 2) << 16) + (r.charCodeAt(e + 3) << 24);
  return t;
}
var Kw = "0123456789abcdef".split("");
function qQ(r) {
  for (var e = "", t = 0; t < 4; t++) e += Kw[r >> 8 * t + 4 & 15] + Kw[r >> 8 * t & 15];
  return e;
}
function zQ(r) {
  return String.fromCharCode(255 & r, (65280 & r) >> 8, (16711680 & r) >> 16, (4278190080 & r) >> 24);
}
function im(r) {
  return jx(r).map(zQ).join("");
}
var WQ = (function(r) {
  for (var e = 0; e < r.length; e++) r[e] = qQ(r[e]);
  return r.join("");
})(jx("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Hs(r, e) {
  if (WQ) {
    var t = (65535 & r) + (65535 & e);
    return (r >> 16) + (e >> 16) + (t >> 16) << 16 | 65535 & t;
  }
  return r + e & 4294967295;
}
function sm(r, e) {
  var t, A, n, i;
  if (r !== t) {
    for (var s = (n = r, i = 1 + (256 / r.length | 0), new Array(i + 1).join(n)), a = [], o = 0; o < 256; o++) a[o] = o;
    var l = 0;
    for (o = 0; o < 256; o++) {
      var u = a[o];
      l = (l + u + s.charCodeAt(o)) % 256, a[o] = a[l], a[l] = u;
    }
    t = r, A = a;
  } else a = A;
  var c = e.length, f = 0, h = 0, g = "";
  for (o = 0; o < c; o++) h = (h + (u = a[f = (f + 1) % 256])) % 256, a[f] = a[h], a[h] = u, s = a[(a[f] + a[h]) % 256], g += String.fromCharCode(e.charCodeAt(o) ^ s);
  return g;
}
var jw = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function yo(r, e, t, A) {
  this.v = 1, this.r = 2;
  var n = 192;
  r.forEach(function(a) {
    if (jw.perm !== void 0) throw new Error("Invalid permission: " + a);
    n += jw[a];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var i = (e + this.padding).substr(0, 32), s = (t + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(i, s), this.P = -(1 + (255 ^ n)), this.encryptionKey = im(i + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(A)).substr(0, 5), this.U = sm(this.encryptionKey, this.padding);
}
function bo(r) {
  if (/[^\u0000-\u00ff]/.test(r)) throw new Error("Invalid PDF Name Object: " + r + ", Only accept ASCII characters.");
  for (var e = "", t = r.length, A = 0; A < t; A++) {
    var n = r.charCodeAt(A);
    e += n < 33 || n === 35 || n === 37 || n === 40 || n === 41 || n === 47 || n === 60 || n === 62 || n === 91 || n === 93 || n === 123 || n === 125 || n > 126 ? "#" + ("0" + n.toString(16)).slice(-2) : r[A];
  }
  return e;
}
function qw(r) {
  if (Xt(r) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var e = {};
  this.subscribe = function(t, A, n) {
    if (n = n || !1, typeof t != "string" || typeof A != "function" || typeof n != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    e.hasOwnProperty(t) || (e[t] = {});
    var i = Math.random().toString(35);
    return e[t][i] = [A, !!n], i;
  }, this.unsubscribe = function(t) {
    for (var A in e) if (e[A][t]) return delete e[A][t], Object.keys(e[A]).length === 0 && delete e[A], !0;
    return !1;
  }, this.publish = function(t) {
    if (e.hasOwnProperty(t)) {
      var A = Array.prototype.slice.call(arguments, 1), n = [];
      for (var i in e[t]) {
        var s = e[t][i];
        try {
          s[0].apply(r, A);
        } catch (a) {
          Ct.console && ur.error("jsPDF PubSub Error", a.message, a);
        }
        s[1] && n.push(i);
      }
      n.length && n.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return e;
  };
}
function Ga(r) {
  if (!(this instanceof Ga)) return new Ga(r);
  var e = "opacity,stroke-opacity".split(",");
  for (var t in r) r.hasOwnProperty(t) && e.indexOf(t) >= 0 && (this[t] = r[t]);
  this.id = "", this.objectNumber = -1;
}
function qx(r, e) {
  this.gState = r, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function Rs(r, e, t, A, n) {
  if (!(this instanceof Rs)) return new Rs(r, e, t, A, n);
  this.type = r === "axial" ? 2 : 3, this.coords = e, this.colors = t, qx.call(this, A, n);
}
function Ia(r, e, t, A, n) {
  if (!(this instanceof Ia)) return new Ia(r, e, t, A, n);
  this.boundingBox = r, this.xStep = e, this.yStep = t, this.stream = "", this.cloneIndex = 0, qx.call(this, A, n);
}
function ot(r) {
  var e, t = typeof arguments[0] == "string" ? arguments[0] : "p", A = arguments[1], n = arguments[2], i = arguments[3], s = [], a = 1, o = 16, l = "S", u = null;
  Xt(r = r || {}) === "object" && (t = r.orientation, A = r.unit || A, n = r.format || n, i = r.compress || r.compressPdf || i, (u = r.encryption || null) !== null && (u.userPassword = u.userPassword || "", u.ownerPassword = u.ownerPassword || "", u.userPermissions = u.userPermissions || []), a = typeof r.userUnit == "number" ? Math.abs(r.userUnit) : 1, r.precision !== void 0 && (e = r.precision), r.floatPrecision !== void 0 && (o = r.floatPrecision), l = r.defaultPathOperation || "S"), s = r.filters || (i === !0 ? ["FlateEncode"] : s), A = A || "mm", t = ("" + (t || "P")).toLowerCase();
  var c = r.putOnlyUsedFonts || !1, f = {}, h = { internal: {}, __private__: {} };
  h.__private__.PubSub = qw;
  var g = "1.3", p = h.__private__.getPdfVersion = function() {
    return g;
  };
  h.__private__.setPdfVersion = function(y) {
    g = y;
  };
  var v = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  h.__private__.getPageFormats = function() {
    return v;
  };
  var w = h.__private__.getPageFormat = function(y) {
    return v[y];
  };
  n = n || "a4";
  var b = "compat", S = "advanced", B = b;
  function x() {
    this.saveGraphicsState(), j(new vt(dt, 0, 0, -dt, 0, oa() * dt).toString() + " cm"), this.setFontSize(this.getFontSize() / dt), l = "n", B = S;
  }
  function U() {
    this.restoreGraphicsState(), l = "S", B = b;
  }
  var Q = h.__private__.combineFontStyleAndFontWeight = function(y, L) {
    if (y == "bold" && L == "normal" || y == "bold" && L == 400 || y == "normal" && L == "italic" || y == "bold" && L == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return L && (y = L == 400 || L === "normal" ? y === "italic" ? "italic" : "normal" : L != 700 && L !== "bold" || y !== "normal" ? (L == 700 ? "bold" : L) + "" + y : "bold"), y;
  };
  h.advancedAPI = function(y) {
    var L = B === b;
    return L && x.call(this), typeof y != "function" || (y(this), L && U.call(this)), this;
  }, h.compatAPI = function(y) {
    var L = B === S;
    return L && U.call(this), typeof y != "function" || (y(this), L && x.call(this)), this;
  }, h.isAdvancedAPI = function() {
    return B === S;
  };
  var N, _ = function(y) {
    if (B !== S) throw new Error(y + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, R = h.roundToPrecision = h.__private__.roundToPrecision = function(y, L) {
    var W = e || L;
    if (isNaN(y) || isNaN(W)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return y.toFixed(W).replace(/0+$/, "");
  };
  N = h.hpf = h.__private__.hpf = typeof o == "number" ? function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return R(y, o);
  } : o === "smart" ? function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return R(y, y > -1 && y < 1 ? 16 : 5);
  } : function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return R(y, 16);
  };
  var F = h.f2 = h.__private__.f2 = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.f2");
    return R(y, 2);
  }, O = h.__private__.f3 = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.f3");
    return R(y, 3);
  }, G = h.scale = h.__private__.scale = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.scale");
    return B === b ? y * dt : B === S ? y : void 0;
  }, H = function(y) {
    return G((function(L) {
      return B === b ? oa() - L : B === S ? L : void 0;
    })(y));
  };
  h.__private__.setPrecision = h.setPrecision = function(y) {
    typeof parseInt(y, 10) == "number" && (e = parseInt(y, 10));
  };
  var $, ne = "00000000000000000000000000000000", te = h.__private__.getFileId = function() {
    return ne;
  }, J = h.__private__.setFileId = function(y) {
    return ne = y !== void 0 && /^[a-fA-F0-9]{32}$/.test(y) ? y.toUpperCase() : ne.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), u !== null && (oA = new yo(u.userPermissions, u.userPassword, u.ownerPassword, ne)), ne;
  };
  h.setFileId = function(y) {
    return J(y), this;
  }, h.getFileId = function() {
    return te();
  };
  var re = h.__private__.convertDateToPDFDate = function(y) {
    var L = y.getTimezoneOffset(), W = L < 0 ? "+" : "-", Z = Math.floor(Math.abs(L / 60)), ce = Math.abs(L % 60), be = [W, X(Z), "'", X(ce), "'"].join("");
    return ["D:", y.getFullYear(), X(y.getMonth() + 1), X(y.getDate()), X(y.getHours()), X(y.getMinutes()), X(y.getSeconds()), be].join("");
  }, le = h.__private__.convertPDFDateToDate = function(y) {
    var L = parseInt(y.substr(2, 4), 10), W = parseInt(y.substr(6, 2), 10) - 1, Z = parseInt(y.substr(8, 2), 10), ce = parseInt(y.substr(10, 2), 10), be = parseInt(y.substr(12, 2), 10), Fe = parseInt(y.substr(14, 2), 10);
    return new Date(L, W, Z, ce, be, Fe, 0);
  }, se = h.__private__.setCreationDate = function(y) {
    var L;
    if (y === void 0 && (y = /* @__PURE__ */ new Date()), y instanceof Date) L = re(y);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(y)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      L = y;
    }
    return $ = L;
  }, P = h.__private__.getCreationDate = function(y) {
    var L = $;
    return y === "jsDate" && (L = le($)), L;
  };
  h.setCreationDate = function(y) {
    return se(y), this;
  }, h.getCreationDate = function(y) {
    return P(y);
  };
  var V, X = h.__private__.padd2 = function(y) {
    return ("0" + parseInt(y)).slice(-2);
  }, Y = h.__private__.padd2Hex = function(y) {
    return ("00" + (y = y.toString())).substr(y.length);
  }, ee = 0, oe = [], ge = [], pe = 0, me = [], Ee = [], Ne = !1, Te = ge;
  h.__private__.setCustomOutputDestination = function(y) {
    Ne = !0, Te = y;
  };
  var Ge = function(y) {
    Ne || (Te = y);
  };
  h.__private__.resetCustomOutputDestination = function() {
    Ne = !1, Te = ge;
  };
  var j = h.__private__.out = function(y) {
    return y = y.toString(), pe += y.length + 1, Te.push(y), Te;
  }, Pe = h.__private__.write = function(y) {
    return j(arguments.length === 1 ? y.toString() : Array.prototype.join.call(arguments, " "));
  }, ft = h.__private__.getArrayBuffer = function(y) {
    for (var L = y.length, W = new ArrayBuffer(L), Z = new Uint8Array(W); L--; ) Z[L] = y.charCodeAt(L);
    return W;
  }, tt = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  h.__private__.getStandardFonts = function() {
    return tt;
  };
  var xe = r.fontSize || 16;
  h.__private__.setFontSize = h.setFontSize = function(y) {
    return xe = B === S ? y / dt : y, this;
  };
  var At, ke = h.__private__.getFontSize = h.getFontSize = function() {
    return B === b ? xe : xe * dt;
  }, We = r.R2L || !1;
  h.__private__.setR2L = h.setR2L = function(y) {
    return We = y, this;
  }, h.__private__.getR2L = h.getR2L = function() {
    return We;
  };
  var ze, Ce = h.__private__.setZoomMode = function(y) {
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(y)) At = y;
    else if (isNaN(y)) {
      if ([void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(y) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + y + '" is not recognized.');
      At = y;
    } else At = parseInt(y, 10);
  };
  h.__private__.getZoomMode = function() {
    return At;
  };
  var Oe, Re = h.__private__.setPageMode = function(y) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(y) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + y + '" is not recognized.');
    ze = y;
  };
  h.__private__.getPageMode = function() {
    return ze;
  };
  var Ke = h.__private__.setLayoutMode = function(y) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(y) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + y + '" is not recognized.');
    Oe = y;
  };
  h.__private__.getLayoutMode = function() {
    return Oe;
  }, h.__private__.setDisplayMode = h.setDisplayMode = function(y, L, W) {
    return Ce(y), Ke(L), Re(W), this;
  };
  var Xe = { title: "", subject: "", author: "", keywords: "", creator: "" };
  h.__private__.getDocumentProperty = function(y) {
    if (Object.keys(Xe).indexOf(y) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return Xe[y];
  }, h.__private__.getDocumentProperties = function() {
    return Xe;
  }, h.__private__.setDocumentProperties = h.setProperties = h.setDocumentProperties = function(y) {
    for (var L in Xe) Xe.hasOwnProperty(L) && y[L] && (Xe[L] = y[L]);
    return this;
  }, h.__private__.setDocumentProperty = function(y, L) {
    if (Object.keys(Xe).indexOf(y) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return Xe[y] = L;
  };
  var Ve, dt, je, Tt, Et, mt = {}, yt = {}, qt = [], it = {}, zt = {}, lt = {}, wt = {}, Zt = null, ut = 0, bt = [], Wt = new qw(h), fr = r.hotfixes || [], Er = {}, jn = {}, cn = [], vt = function y(L, W, Z, ce, be, Fe) {
    if (!(this instanceof y)) return new y(L, W, Z, ce, be, Fe);
    isNaN(L) && (L = 1), isNaN(W) && (W = 0), isNaN(Z) && (Z = 0), isNaN(ce) && (ce = 1), isNaN(be) && (be = 0), isNaN(Fe) && (Fe = 0), this._matrix = [L, W, Z, ce, be, Fe];
  };
  Object.defineProperty(vt.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(y) {
    this._matrix[0] = y;
  } }), Object.defineProperty(vt.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(y) {
    this._matrix[1] = y;
  } }), Object.defineProperty(vt.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(y) {
    this._matrix[2] = y;
  } }), Object.defineProperty(vt.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(y) {
    this._matrix[3] = y;
  } }), Object.defineProperty(vt.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(y) {
    this._matrix[4] = y;
  } }), Object.defineProperty(vt.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(y) {
    this._matrix[5] = y;
  } }), Object.defineProperty(vt.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(y) {
    this._matrix[0] = y;
  } }), Object.defineProperty(vt.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(y) {
    this._matrix[1] = y;
  } }), Object.defineProperty(vt.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(y) {
    this._matrix[2] = y;
  } }), Object.defineProperty(vt.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(y) {
    this._matrix[3] = y;
  } }), Object.defineProperty(vt.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(y) {
    this._matrix[4] = y;
  } }), Object.defineProperty(vt.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(y) {
    this._matrix[5] = y;
  } }), Object.defineProperty(vt.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(vt.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(vt.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(vt.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), vt.prototype.join = function(y) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(N).join(y);
  }, vt.prototype.multiply = function(y) {
    var L = y.sx * this.sx + y.shy * this.shx, W = y.sx * this.shy + y.shy * this.sy, Z = y.shx * this.sx + y.sy * this.shx, ce = y.shx * this.shy + y.sy * this.sy, be = y.tx * this.sx + y.ty * this.shx + this.tx, Fe = y.tx * this.shy + y.ty * this.sy + this.ty;
    return new vt(L, W, Z, ce, be, Fe);
  }, vt.prototype.decompose = function() {
    var y = this.sx, L = this.shy, W = this.shx, Z = this.sy, ce = this.tx, be = this.ty, Fe = Math.sqrt(y * y + L * L), nt = (y /= Fe) * W + (L /= Fe) * Z;
    W -= y * nt, Z -= L * nt;
    var ct = Math.sqrt(W * W + Z * Z);
    return nt /= ct, y * (Z /= ct) < L * (W /= ct) && (y = -y, L = -L, nt = -nt, Fe = -Fe), { scale: new vt(Fe, 0, 0, ct, 0, 0), translate: new vt(1, 0, 0, 1, ce, be), rotate: new vt(y, L, -L, y, 0, 0), skew: new vt(1, 0, nt, 1, 0, 0) };
  }, vt.prototype.toString = function(y) {
    return this.join(" ");
  }, vt.prototype.inversed = function() {
    var y = this.sx, L = this.shy, W = this.shx, Z = this.sy, ce = this.tx, be = this.ty, Fe = 1 / (y * Z - L * W), nt = Z * Fe, ct = -L * Fe, St = -W * Fe, It = y * Fe;
    return new vt(nt, ct, St, It, -nt * ce - St * be, -ct * ce - It * be);
  }, vt.prototype.applyToPoint = function(y) {
    var L = y.x * this.sx + y.y * this.shx + this.tx, W = y.x * this.shy + y.y * this.sy + this.ty;
    return new Mi(L, W);
  }, vt.prototype.applyToRectangle = function(y) {
    var L = this.applyToPoint(y), W = this.applyToPoint(new Mi(y.x + y.w, y.y + y.h));
    return new $o(L.x, L.y, W.x - L.x, W.y - L.y);
  }, vt.prototype.clone = function() {
    var y = this.sx, L = this.shy, W = this.shx, Z = this.sy, ce = this.tx, be = this.ty;
    return new vt(y, L, W, Z, ce, be);
  }, h.Matrix = vt;
  var En = h.matrixMult = function(y, L) {
    return L.multiply(y);
  }, Fn = new vt(1, 0, 0, 1, 0, 0);
  h.unitMatrix = h.identityMatrix = Fn;
  var ZA = function(y, L) {
    if (!zt[y]) {
      var W = (L instanceof Rs ? "Sh" : "P") + (Object.keys(it).length + 1).toString(10);
      L.id = W, zt[y] = W, it[W] = L, Wt.publish("addPattern", L);
    }
  };
  h.ShadingPattern = Rs, h.TilingPattern = Ia, h.addShadingPattern = function(y, L) {
    return _("addShadingPattern()"), ZA(y, L), this;
  }, h.beginTilingPattern = function(y) {
    _("beginTilingPattern()"), Jo(y.boundingBox[0], y.boundingBox[1], y.boundingBox[2] - y.boundingBox[0], y.boundingBox[3] - y.boundingBox[1], y.matrix);
  }, h.endTilingPattern = function(y, L) {
    _("endTilingPattern()"), L.stream = Ee[V].join(`
`), ZA(y, L), Wt.publish("endTilingPattern", L), cn.pop().restore();
  };
  var Fr, ar = h.__private__.newObject = function() {
    var y = Mr();
    return Jr(y, !0), y;
  }, Mr = h.__private__.newObjectDeferred = function() {
    return ee++, oe[ee] = function() {
      return pe;
    }, ee;
  }, Jr = function(y, L) {
    return L = typeof L == "boolean" && L, oe[y] = pe, L && j(y + " 0 obj"), y;
  }, qn = h.__private__.newAdditionalObject = function() {
    var y = { objId: Mr(), content: "" };
    return me.push(y), y;
  }, zn = Mr(), Rr = Mr(), hn = h.__private__.decodeColorString = function(y) {
    var L = y.split(" ");
    if (L.length !== 2 || L[1] !== "g" && L[1] !== "G") L.length !== 5 || L[4] !== "k" && L[4] !== "K" || (L = [(1 - L[0]) * (1 - L[3]), (1 - L[1]) * (1 - L[3]), (1 - L[2]) * (1 - L[3]), "r"]);
    else {
      var W = parseFloat(L[0]);
      L = [W, W, W, "r"];
    }
    for (var Z = "#", ce = 0; ce < 3; ce++) Z += ("0" + Math.floor(255 * parseFloat(L[ce])).toString(16)).slice(-2);
    return Z;
  }, en = h.__private__.encodeColorString = function(y) {
    var L;
    typeof y == "string" && (y = { ch1: y });
    var W = y.ch1, Z = y.ch2, ce = y.ch3, be = y.ch4, Fe = y.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof W == "string" && W.charAt(0) !== "#") {
      var nt = new Kx(W);
      if (nt.ok) W = nt.toHex();
      else if (!/^\d*\.?\d*$/.test(W)) throw new Error('Invalid color "' + W + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof W == "string" && /^#[0-9A-Fa-f]{3}$/.test(W) && (W = "#" + W[1] + W[1] + W[2] + W[2] + W[3] + W[3]), typeof W == "string" && /^#[0-9A-Fa-f]{6}$/.test(W)) {
      var ct = parseInt(W.substr(1), 16);
      W = ct >> 16 & 255, Z = ct >> 8 & 255, ce = 255 & ct;
    }
    if (Z === void 0 || be === void 0 && W === Z && Z === ce) L = typeof W == "string" ? W + " " + Fe[0] : y.precision === 2 ? F(W / 255) + " " + Fe[0] : O(W / 255) + " " + Fe[0];
    else if (be === void 0 || Xt(be) === "object") {
      if (be && !isNaN(be.a) && be.a === 0) return ["1.", "1.", "1.", Fe[1]].join(" ");
      L = typeof W == "string" ? [W, Z, ce, Fe[1]].join(" ") : y.precision === 2 ? [F(W / 255), F(Z / 255), F(ce / 255), Fe[1]].join(" ") : [O(W / 255), O(Z / 255), O(ce / 255), Fe[1]].join(" ");
    } else L = typeof W == "string" ? [W, Z, ce, be, Fe[2]].join(" ") : y.precision === 2 ? [F(W), F(Z), F(ce), F(be), Fe[2]].join(" ") : [O(W), O(Z), O(ce), O(be), Fe[2]].join(" ");
    return L;
  }, tn = h.__private__.getFilters = function() {
    return s;
  }, DA = h.__private__.putStream = function(y) {
    var L = (y = y || {}).data || "", W = y.filters || tn(), Z = y.alreadyAppliedFilters || [], ce = y.addLength1 || !1, be = L.length, Fe = y.objectId, nt = function(lA) {
      return lA;
    };
    if (u !== null && Fe === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    u !== null && (nt = oA.encryptor(Fe, 0));
    var ct = {};
    W === !0 && (W = ["FlateEncode"]);
    var St = y.additionalKeyValues || [], It = (ct = ot.API.processDataByFilters !== void 0 ? ot.API.processDataByFilters(L, W) : { data: L, reverseChain: [] }).reverseChain + (Array.isArray(Z) ? Z.join(" ") : Z.toString());
    if (ct.data.length !== 0 && (St.push({ key: "Length", value: ct.data.length }), ce === !0 && St.push({ key: "Length1", value: be })), It.length != 0) if (It.split("/").length - 1 == 1) St.push({ key: "Filter", value: It });
    else {
      St.push({ key: "Filter", value: "[" + It + "]" });
      for (var Gt = 0; Gt < St.length; Gt += 1) if (St[Gt].key === "DecodeParms") {
        for (var Ur = [], tA = 0; tA < ct.reverseChain.split("/").length - 1; tA += 1) Ur.push("null");
        Ur.push(St[Gt].value), St[Gt].value = "[" + Ur.join(" ") + "]";
      }
    }
    j("<<");
    for (var dr = 0; dr < St.length; dr++) j("/" + St[dr].key + " " + St[dr].value);
    j(">>"), ct.data.length !== 0 && (j("stream"), j(nt(ct.data)), j("endstream"));
  }, Li = h.__private__.putPage = function(y) {
    var L = y.number, W = y.data, Z = y.objId, ce = y.contentsObjId;
    Jr(Z, !0), j("<</Type /Page"), j("/Parent " + y.rootDictionaryObjId + " 0 R"), j("/Resources " + y.resourceDictionaryObjId + " 0 R"), j("/MediaBox [" + parseFloat(N(y.mediaBox.bottomLeftX)) + " " + parseFloat(N(y.mediaBox.bottomLeftY)) + " " + N(y.mediaBox.topRightX) + " " + N(y.mediaBox.topRightY) + "]"), y.cropBox !== null && j("/CropBox [" + N(y.cropBox.bottomLeftX) + " " + N(y.cropBox.bottomLeftY) + " " + N(y.cropBox.topRightX) + " " + N(y.cropBox.topRightY) + "]"), y.bleedBox !== null && j("/BleedBox [" + N(y.bleedBox.bottomLeftX) + " " + N(y.bleedBox.bottomLeftY) + " " + N(y.bleedBox.topRightX) + " " + N(y.bleedBox.topRightY) + "]"), y.trimBox !== null && j("/TrimBox [" + N(y.trimBox.bottomLeftX) + " " + N(y.trimBox.bottomLeftY) + " " + N(y.trimBox.topRightX) + " " + N(y.trimBox.topRightY) + "]"), y.artBox !== null && j("/ArtBox [" + N(y.artBox.bottomLeftX) + " " + N(y.artBox.bottomLeftY) + " " + N(y.artBox.topRightX) + " " + N(y.artBox.topRightY) + "]"), typeof y.userUnit == "number" && y.userUnit !== 1 && j("/UserUnit " + y.userUnit), Wt.publish("putPage", { objId: Z, pageContext: bt[L], pageNumber: L, page: W }), j("/Contents " + ce + " 0 R"), j(">>"), j("endobj");
    var be = W.join(`
`);
    return B === S && (be += `
Q`), Jr(ce, !0), DA({ data: be, filters: tn(), objectId: ce }), j("endobj"), Z;
  }, Je = h.__private__.putPages = function() {
    var y, L, W = [];
    for (y = 1; y <= ut; y++) bt[y].objId = Mr(), bt[y].contentsObjId = Mr();
    for (y = 1; y <= ut; y++) W.push(Li({ number: y, data: Ee[y], objId: bt[y].objId, contentsObjId: bt[y].contentsObjId, mediaBox: bt[y].mediaBox, cropBox: bt[y].cropBox, bleedBox: bt[y].bleedBox, trimBox: bt[y].trimBox, artBox: bt[y].artBox, userUnit: bt[y].userUnit, rootDictionaryObjId: zn, resourceDictionaryObjId: Rr }));
    Jr(zn, !0), j("<</Type /Pages");
    var Z = "/Kids [";
    for (L = 0; L < ut; L++) Z += W[L] + " 0 R ";
    j(Z + "]"), j("/Count " + ut), j(">>"), j("endobj"), Wt.publish("postPutPages");
  }, ie = function(y) {
    Wt.publish("putFont", { font: y, out: j, newObject: ar, putStream: DA }), y.isAlreadyPutted !== !0 && (y.objectNumber = ar(), j("<<"), j("/Type /Font"), j("/BaseFont /" + bo(y.postScriptName)), j("/Subtype /Type1"), typeof y.encoding == "string" && j("/Encoding /" + y.encoding), j("/FirstChar 32"), j("/LastChar 255"), j(">>"), j("endobj"));
  }, Qe = function(y) {
    y.objectNumber = ar();
    var L = [];
    L.push({ key: "Type", value: "/XObject" }), L.push({ key: "Subtype", value: "/Form" }), L.push({ key: "BBox", value: "[" + [N(y.x), N(y.y), N(y.x + y.width), N(y.y + y.height)].join(" ") + "]" }), L.push({ key: "Matrix", value: "[" + y.matrix.toString() + "]" });
    var W = y.pages[1].join(`
`);
    DA({ data: W, additionalKeyValues: L, objectId: y.objectNumber }), j("endobj");
  }, $e = function(y, L) {
    L || (L = 21);
    var W = ar(), Z = (function(Fe, nt) {
      var ct, St = [], It = 1 / (nt - 1);
      for (ct = 0; ct < 1; ct += It) St.push(ct);
      if (St.push(1), Fe[0].offset != 0) {
        var Gt = { offset: 0, color: Fe[0].color };
        Fe.unshift(Gt);
      }
      if (Fe[Fe.length - 1].offset != 1) {
        var Ur = { offset: 1, color: Fe[Fe.length - 1].color };
        Fe.push(Ur);
      }
      for (var tA = "", dr = 0, lA = 0; lA < St.length; lA++) {
        for (ct = St[lA]; ct > Fe[dr + 1].offset; ) dr++;
        var rA = Fe[dr].offset, CA = (ct - rA) / (Fe[dr + 1].offset - rA), Hi = Fe[dr].color, Xn = Fe[dr + 1].color;
        tA += Y(Math.round((1 - CA) * Hi[0] + CA * Xn[0]).toString(16)) + Y(Math.round((1 - CA) * Hi[1] + CA * Xn[1]).toString(16)) + Y(Math.round((1 - CA) * Hi[2] + CA * Xn[2]).toString(16));
      }
      return tA.trim();
    })(y.colors, L), ce = [];
    ce.push({ key: "FunctionType", value: "0" }), ce.push({ key: "Domain", value: "[0.0 1.0]" }), ce.push({ key: "Size", value: "[" + L + "]" }), ce.push({ key: "BitsPerSample", value: "8" }), ce.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), ce.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), DA({ data: Z, additionalKeyValues: ce, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: W }), j("endobj"), y.objectNumber = ar(), j("<< /ShadingType " + y.type), j("/ColorSpace /DeviceRGB");
    var be = "/Coords [" + N(parseFloat(y.coords[0])) + " " + N(parseFloat(y.coords[1])) + " ";
    y.type === 2 ? be += N(parseFloat(y.coords[2])) + " " + N(parseFloat(y.coords[3])) : be += N(parseFloat(y.coords[2])) + " " + N(parseFloat(y.coords[3])) + " " + N(parseFloat(y.coords[4])) + " " + N(parseFloat(y.coords[5])), j(be += "]"), y.matrix && j("/Matrix [" + y.matrix.toString() + "]"), j("/Function " + W + " 0 R"), j("/Extend [true true]"), j(">>"), j("endobj");
  }, $t = function(y, L) {
    var W = Mr(), Z = ar();
    L.push({ resourcesOid: W, objectOid: Z }), y.objectNumber = Z;
    var ce = [];
    ce.push({ key: "Type", value: "/Pattern" }), ce.push({ key: "PatternType", value: "1" }), ce.push({ key: "PaintType", value: "1" }), ce.push({ key: "TilingType", value: "1" }), ce.push({ key: "BBox", value: "[" + y.boundingBox.map(N).join(" ") + "]" }), ce.push({ key: "XStep", value: N(y.xStep) }), ce.push({ key: "YStep", value: N(y.yStep) }), ce.push({ key: "Resources", value: W + " 0 R" }), y.matrix && ce.push({ key: "Matrix", value: "[" + y.matrix.toString() + "]" }), DA({ data: y.stream, additionalKeyValues: ce, objectId: y.objectNumber }), j("endobj");
  }, Zr = function(y) {
    for (var L in y.objectNumber = ar(), j("<<"), y) switch (L) {
      case "opacity":
        j("/ca " + F(y[L]));
        break;
      case "stroke-opacity":
        j("/CA " + F(y[L]));
    }
    j(">>"), j("endobj");
  }, _r = function(y) {
    Jr(y.resourcesOid, !0), j("<<"), j("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), (function() {
      for (var L in j("/Font <<"), mt) mt.hasOwnProperty(L) && (c === !1 || c === !0 && f.hasOwnProperty(L)) && j("/" + L + " " + mt[L].objectNumber + " 0 R");
      j(">>");
    })(), (function() {
      if (Object.keys(it).length > 0) {
        for (var L in j("/Shading <<"), it) it.hasOwnProperty(L) && it[L] instanceof Rs && it[L].objectNumber >= 0 && j("/" + L + " " + it[L].objectNumber + " 0 R");
        Wt.publish("putShadingPatternDict"), j(">>");
      }
    })(), (function(L) {
      if (Object.keys(it).length > 0) {
        for (var W in j("/Pattern <<"), it) it.hasOwnProperty(W) && it[W] instanceof h.TilingPattern && it[W].objectNumber >= 0 && it[W].objectNumber < L && j("/" + W + " " + it[W].objectNumber + " 0 R");
        Wt.publish("putTilingPatternDict"), j(">>");
      }
    })(y.objectOid), (function() {
      if (Object.keys(lt).length > 0) {
        var L;
        for (L in j("/ExtGState <<"), lt) lt.hasOwnProperty(L) && lt[L].objectNumber >= 0 && j("/" + L + " " + lt[L].objectNumber + " 0 R");
        Wt.publish("putGStateDict"), j(">>");
      }
    })(), (function() {
      for (var L in j("/XObject <<"), Er) Er.hasOwnProperty(L) && Er[L].objectNumber >= 0 && j("/" + L + " " + Er[L].objectNumber + " 0 R");
      Wt.publish("putXobjectDict"), j(">>");
    })(), j(">>"), j("endobj");
  }, aA = function(y) {
    yt[y.fontName] = yt[y.fontName] || {}, yt[y.fontName][y.fontStyle] = y.id;
  }, GA = function(y, L, W, Z, ce) {
    var be = { id: "F" + (Object.keys(mt).length + 1).toString(10), postScriptName: y, fontName: L, fontStyle: W, encoding: Z, isStandardFont: ce || !1, metadata: {} };
    return Wt.publish("addFont", { font: be, instance: this }), mt[be.id] = be, aA(be), be.id;
  }, mA = h.__private__.pdfEscape = h.pdfEscape = function(y, L) {
    return (function(W, Z) {
      var ce, be, Fe, nt, ct, St, It, Gt, Ur;
      if (Fe = (Z = Z || {}).sourceEncoding || "Unicode", ct = Z.outputEncoding, (Z.autoencode || ct) && mt[Ve].metadata && mt[Ve].metadata[Fe] && mt[Ve].metadata[Fe].encoding && (nt = mt[Ve].metadata[Fe].encoding, !ct && mt[Ve].encoding && (ct = mt[Ve].encoding), !ct && nt.codePages && (ct = nt.codePages[0]), typeof ct == "string" && (ct = nt[ct]), ct)) {
        for (It = !1, St = [], ce = 0, be = W.length; ce < be; ce++) (Gt = ct[W.charCodeAt(ce)]) ? St.push(String.fromCharCode(Gt)) : St.push(W[ce]), St[ce].charCodeAt(0) >> 8 && (It = !0);
        W = St.join("");
      }
      for (ce = W.length; It === void 0 && ce !== 0; ) W.charCodeAt(ce - 1) >> 8 && (It = !0), ce--;
      if (!It) return W;
      for (St = Z.noBOM ? [] : [254, 255], ce = 0, be = W.length; ce < be; ce++) {
        if ((Ur = (Gt = W.charCodeAt(ce)) >> 8) >> 8) throw new Error("Character at position " + ce + " of string '" + W + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        St.push(Ur), St.push(Gt - (Ur << 8));
      }
      return String.fromCharCode.apply(void 0, St);
    })(y, L).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, kr = h.__private__.beginPage = function(y) {
    Ee[++ut] = [], bt[ut] = { objId: 0, contentsObjId: 0, userUnit: Number(a), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(y[0]), topRightY: Number(y[1]) } }, Ou(ut), Ge(Ee[V]);
  }, Aa = function(y, L) {
    var W, Z, ce;
    switch (t = L || t, typeof y == "string" && (W = w(y.toLowerCase()), Array.isArray(W) && (Z = W[0], ce = W[1])), Array.isArray(y) && (Z = y[0] * dt, ce = y[1] * dt), isNaN(Z) && (Z = n[0], ce = n[1]), (Z > 14400 || ce > 14400) && (ur.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), Z = Math.min(14400, Z), ce = Math.min(14400, ce)), n = [Z, ce], t.substr(0, 1)) {
      case "l":
        ce > Z && (n = [ce, Z]);
        break;
      case "p":
        Z > ce && (n = [ce, Z]);
    }
    kr(n), xt(zo), j(eo), Xo !== 0 && j(Xo + " J"), Yo !== 0 && j(Yo + " j"), Wt.publish("addPage", { pageNumber: ut });
  }, ds = function(y) {
    y > 0 && y <= ut && (Ee.splice(y, 1), bt.splice(y, 1), ut--, V > ut && (V = ut), this.setPage(V));
  }, Ou = function(y) {
    y > 0 && y <= ut && (V = y);
  }, Mu = h.__private__.getNumberOfPages = h.getNumberOfPages = function() {
    return Ee.length - 1;
  }, Ru = function(y, L, W) {
    var Z, ce = void 0;
    return W = W || {}, y = y !== void 0 ? y : mt[Ve].fontName, L = L !== void 0 ? L : mt[Ve].fontStyle, Z = y.toLowerCase(), yt[Z] !== void 0 && yt[Z][L] !== void 0 ? ce = yt[Z][L] : yt[y] !== void 0 && yt[y][L] !== void 0 ? ce = yt[y][L] : W.disableWarning === !1 && ur.warn("Unable to look up font label for font '" + y + "', '" + L + "'. Refer to getFontList() for available fonts."), ce || W.noFallback || (ce = yt.times[L]) == null && (ce = yt.times.normal), ce;
  }, di = h.__private__.putInfo = function() {
    var y = ar(), L = function(Z) {
      return Z;
    };
    for (var W in u !== null && (L = oA.encryptor(y, 0)), j("<<"), j("/Producer (" + mA(L("jsPDF " + ot.version)) + ")"), Xe) Xe.hasOwnProperty(W) && Xe[W] && j("/" + W.substr(0, 1).toUpperCase() + W.substr(1) + " (" + mA(L(Xe[W])) + ")");
    j("/CreationDate (" + mA(L($)) + ")"), j(">>"), j("endobj");
  }, $a = h.__private__.putCatalog = function(y) {
    var L = (y = y || {}).rootDictionaryObjId || zn;
    switch (ar(), j("<<"), j("/Type /Catalog"), j("/Pages " + L + " 0 R"), At || (At = "fullwidth"), At) {
      case "fullwidth":
        j("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        j("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        j("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        j("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var W = "" + At;
        W.substr(W.length - 1) === "%" && (At = parseInt(At) / 100), typeof At == "number" && j("/OpenAction [3 0 R /XYZ null null " + F(At) + "]");
    }
    switch (Oe || (Oe = "continuous"), Oe) {
      case "continuous":
        j("/PageLayout /OneColumn");
        break;
      case "single":
        j("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        j("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        j("/PageLayout /TwoColumnRight");
    }
    ze && j("/PageMode /" + ze), Wt.publish("putCatalog"), j(">>"), j("endobj");
  }, wf = h.__private__.putTrailer = function() {
    j("trailer"), j("<<"), j("/Size " + (ee + 1)), j("/Root " + ee + " 0 R"), j("/Info " + (ee - 1) + " 0 R"), u !== null && j("/Encrypt " + oA.oid + " 0 R"), j("/ID [ <" + ne + "> <" + ne + "> ]"), j(">>");
  }, eA = h.__private__.putHeader = function() {
    j("%PDF-" + g), j("%ºß¬à");
  }, ku = h.__private__.putXRef = function() {
    var y = "0000000000";
    j("xref"), j("0 " + (ee + 1)), j("0000000000 65535 f ");
    for (var L = 1; L <= ee; L++) typeof oe[L] == "function" ? j((y + oe[L]()).slice(-10) + " 00000 n ") : oe[L] !== void 0 ? j((y + oe[L]).slice(-10) + " 00000 n ") : j("0000000000 00000 n ");
  }, gi = h.__private__.buildDocument = function() {
    var y;
    ee = 0, pe = 0, ge = [], oe = [], me = [], zn = Mr(), Rr = Mr(), Ge(ge), Wt.publish("buildDocument"), eA(), Je(), (function() {
      Wt.publish("putAdditionalObjects");
      for (var W = 0; W < me.length; W++) {
        var Z = me[W];
        Jr(Z.objId, !0), j(Z.content), j("endobj");
      }
      Wt.publish("postPutAdditionalObjects");
    })(), y = [], (function() {
      for (var W in mt) mt.hasOwnProperty(W) && (c === !1 || c === !0 && f.hasOwnProperty(W)) && ie(mt[W]);
    })(), (function() {
      var W;
      for (W in lt) lt.hasOwnProperty(W) && Zr(lt[W]);
    })(), (function() {
      for (var W in Er) Er.hasOwnProperty(W) && Qe(Er[W]);
    })(), (function(W) {
      var Z;
      for (Z in it) it.hasOwnProperty(Z) && (it[Z] instanceof Rs ? $e(it[Z]) : it[Z] instanceof Ia && $t(it[Z], W));
    })(y), Wt.publish("putResources"), y.forEach(_r), _r({ resourcesOid: Rr, objectOid: Number.MAX_SAFE_INTEGER }), Wt.publish("postPutResources"), u !== null && (oA.oid = ar(), j("<<"), j("/Filter /Standard"), j("/V " + oA.v), j("/R " + oA.r), j("/U <" + oA.toHexString(oA.U) + ">"), j("/O <" + oA.toHexString(oA.O) + ">"), j("/P " + oA.P), j(">>"), j("endobj")), di(), $a();
    var L = pe;
    return ku(), wf(), j("startxref"), j("" + L), j("%%EOF"), Ge(Ee[V]), ge.join(`
`);
  }, Ja = h.__private__.getBlob = function(y) {
    return new Blob([ft(y)], { type: "application/pdf" });
  }, Hu = h.output = h.__private__.output = (Fr = function(y, L) {
    switch (typeof (L = L || {}) == "string" ? L = { filename: L } : L.filename = L.filename || "generated.pdf", y) {
      case void 0:
        return gi();
      case "save":
        h.save(L.filename);
        break;
      case "arraybuffer":
        return ft(gi());
      case "blob":
        return Ja(gi());
      case "bloburi":
      case "bloburl":
        if (Ct.URL !== void 0 && typeof Ct.URL.createObjectURL == "function") return Ct.URL && Ct.URL.createObjectURL(Ja(gi())) || void 0;
        ur.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var W = "", Z = gi();
        try {
          W = Vw(Z);
        } catch {
          W = Vw(unescape(encodeURIComponent(Z)));
        }
        return "data:application/pdf;filename=" + L.filename + ";base64," + W;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(Ct) === "[object Window]") {
          var ce = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", be = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          L.pdfObjectUrl && (ce = L.pdfObjectUrl, be = "");
          var Fe = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + ce + '"' + be + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(L) + ");<\/script></body></html>", nt = Ct.open();
          return nt !== null && nt.document.write(Fe), nt;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(Ct) === "[object Window]") {
          var ct = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (L.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + L.filename + '" width="500px" height="400px" /></body></html>', St = Ct.open();
          if (St !== null) {
            St.document.write(ct);
            var It = this;
            St.document.documentElement.querySelector("#pdfViewer").onload = function() {
              St.document.title = L.filename, St.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(It.output("bloburl"));
            };
          }
          return St;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(Ct) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var Gt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", L) + '"></iframe></body></html>', Ur = Ct.open();
        if (Ur !== null && (Ur.document.write(Gt), Ur.document.title = L.filename), Ur || typeof safari > "u") return Ur;
        break;
      case "datauri":
      case "dataurl":
        return Ct.document.location.href = this.output("datauristring", L);
      default:
        return null;
    }
  }, Fr.foo = function() {
    try {
      return Fr.apply(this, arguments);
    } catch (W) {
      var y = W.stack || "";
      ~y.indexOf(" at ") && (y = y.split(" at ")[1]);
      var L = "Error in function " + y.split(`
`)[0].split("<")[0] + ": " + W.message;
      if (!Ct.console) throw new Error(L);
      Ct.console.error(L, W), Ct.alert && alert(L);
    }
  }, Fr.foo.bar = Fr, Fr.foo), _n = function(y) {
    return Array.isArray(fr) === !0 && fr.indexOf(y) > -1;
  };
  switch (A) {
    case "pt":
      dt = 1;
      break;
    case "mm":
      dt = 72 / 25.4;
      break;
    case "cm":
      dt = 72 / 2.54;
      break;
    case "in":
      dt = 72;
      break;
    case "px":
      dt = _n("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      dt = 12;
      break;
    case "ex":
      dt = 6;
      break;
    default:
      if (typeof A != "number") throw new Error("Invalid unit: " + A);
      dt = A;
  }
  var oA = null;
  se(), J();
  var Ni = h.__private__.getPageInfo = h.getPageInfo = function(y) {
    if (isNaN(y) || y % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: bt[y].objId, pageNumber: y, pageContext: bt[y] };
  }, Du = h.__private__.getPageInfoByObjId = function(y) {
    if (isNaN(y) || y % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var L in bt) if (bt[L].objId === y) break;
    return Ni(L);
  }, yf = h.__private__.getCurrentPageInfo = h.getCurrentPageInfo = function() {
    return { objId: bt[V].objId, pageNumber: V, pageContext: bt[V] };
  };
  h.addPage = function() {
    return Aa.apply(this, arguments), this;
  }, h.setPage = function() {
    return Ou.apply(this, arguments), Ge.call(this, Ee[V]), this;
  }, h.insertPage = function(y) {
    return this.addPage(), this.movePage(V, y), this;
  }, h.movePage = function(y, L) {
    var W, Z;
    if (y > L) {
      W = Ee[y], Z = bt[y];
      for (var ce = y; ce > L; ce--) Ee[ce] = Ee[ce - 1], bt[ce] = bt[ce - 1];
      Ee[L] = W, bt[L] = Z, this.setPage(L);
    } else if (y < L) {
      W = Ee[y], Z = bt[y];
      for (var be = y; be < L; be++) Ee[be] = Ee[be + 1], bt[be] = bt[be + 1];
      Ee[L] = W, bt[L] = Z, this.setPage(L);
    }
    return this;
  }, h.deletePage = function() {
    return ds.apply(this, arguments), this;
  }, h.__private__.text = h.text = function(y, L, W, Z, ce) {
    var be, Fe, nt, ct, St, It, Gt, Ur, tA, dr = (Z = Z || {}).scope || this;
    if (typeof y == "number" && typeof L == "number" && (typeof W == "string" || Array.isArray(W))) {
      var lA = W;
      W = L, L = y, y = lA;
    }
    if (arguments[3] instanceof vt == 0 ? (nt = arguments[4], ct = arguments[5], Xt(Gt = arguments[3]) === "object" && Gt !== null || (typeof nt == "string" && (ct = nt, nt = null), typeof Gt == "string" && (ct = Gt, Gt = null), typeof Gt == "number" && (nt = Gt, Gt = null), Z = { flags: Gt, angle: nt, align: ct })) : (_("The transform parameter of text() with a Matrix value"), tA = ce), isNaN(L) || isNaN(W) || y == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (y.length === 0) return dr;
    var rA, CA = "", Hi = typeof Z.lineHeightFactor == "number" ? Z.lineHeightFactor : ia, Xn = dr.internal.scaleFactor;
    function Di(er) {
      return er = er.split("	").join(Array(Z.TabLen || 9).join(" ")), mA(er, Gt);
    }
    function el(er) {
      for (var or, Dr = er.concat(), uA = [], Ki = Dr.length; Ki--; ) typeof (or = Dr.shift()) == "string" ? uA.push(or) : Array.isArray(er) && (or.length === 1 || or[1] === void 0 && or[2] === void 0) ? uA.push(or[0]) : uA.push([or[0], or[1], or[2]]);
      return uA;
    }
    function ro(er, or) {
      var Dr;
      if (typeof er == "string") Dr = or(er)[0];
      else if (Array.isArray(er)) {
        for (var uA, Ki, ul = er.concat(), io = [], Ju = ul.length; Ju--; ) typeof (uA = ul.shift()) == "string" ? io.push(or(uA)[0]) : Array.isArray(uA) && typeof uA[0] == "string" && (Ki = or(uA[0], uA[1], uA[2]), io.push([Ki[0], Ki[1], Ki[2]]));
        Dr = io;
      }
      return Dr;
    }
    var gs = !1, la = !0;
    if (typeof y == "string") gs = !0;
    else if (Array.isArray(y)) {
      var ua = y.concat();
      Fe = [];
      for (var ps, SA = ua.length; SA--; ) (typeof (ps = ua.shift()) != "string" || Array.isArray(ps) && typeof ps[0] != "string") && (la = !1);
      gs = la;
    }
    if (gs === !1) throw new Error('Type of text must be string or Array. "' + y + '" is not recognized.');
    typeof y == "string" && (y = y.match(/[\r?\n]/) ? y.split(/\r\n|\r|\n/g) : [y]);
    var ca = xe / dr.internal.scaleFactor, ha = ca * (Hi - 1);
    switch (Z.baseline) {
      case "bottom":
        W -= ha;
        break;
      case "top":
        W += ca - ha;
        break;
      case "hanging":
        W += ca - 2 * ha;
        break;
      case "middle":
        W += ca / 2 - ha;
    }
    if ((It = Z.maxWidth || 0) > 0 && (typeof y == "string" ? y = dr.splitTextToSize(y, It) : Object.prototype.toString.call(y) === "[object Array]" && (y = y.reduce(function(er, or) {
      return er.concat(dr.splitTextToSize(or, It));
    }, []))), be = { text: y, x: L, y: W, options: Z, mutex: { pdfEscape: mA, activeFontKey: Ve, fonts: mt, activeFontSize: xe } }, Wt.publish("preProcessText", be), y = be.text, nt = (Z = be.options).angle, tA instanceof vt == 0 && nt && typeof nt == "number") {
      nt *= Math.PI / 180, Z.rotationDirection === 0 && (nt = -nt), B === S && (nt = -nt);
      var tl = Math.cos(nt), rl = Math.sin(nt);
      tA = new vt(tl, rl, -rl, tl, 0, 0);
    } else nt && nt instanceof vt && (tA = nt);
    B !== S || tA || (tA = Fn), (St = Z.charSpace || Oi) !== void 0 && (CA += N(G(St)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Ur = Z.horizontalScale) !== void 0 && (CA += N(100 * Ur) + ` Tz
`), Z.lang;
    var VA = -1, Gi = Z.renderingMode !== void 0 ? Z.renderingMode : Z.stroke, Ao = dr.internal.getCurrentPageInfo().pageContext;
    switch (Gi) {
      case 0:
      case !1:
      case "fill":
        VA = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        VA = 1;
        break;
      case 2:
      case "fillThenStroke":
        VA = 2;
        break;
      case 3:
      case "invisible":
        VA = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        VA = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        VA = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        VA = 6;
        break;
      case 7:
      case "addToPathForClipping":
        VA = 7;
    }
    var Yu = Ao.usedRenderingMode !== void 0 ? Ao.usedRenderingMode : -1;
    VA !== -1 ? CA += VA + ` Tr
` : Yu !== -1 && (CA += `0 Tr
`), VA !== -1 && (Ao.usedRenderingMode = VA), ct = Z.align || "left";
    var Un, fa = xe * Hi, Al = dr.internal.pageSize.getWidth(), nl = mt[Ve];
    St = Z.charSpace || Oi, It = Z.maxWidth || 0, Gt = Object.assign({ autoencode: !0, noBOM: !0 }, Z.flags);
    var ms = [], da = function(er) {
      return dr.getStringUnitWidth(er, { font: nl, charSpace: St, fontSize: xe, doKerning: !1 }) * xe / Xn;
    };
    if (Object.prototype.toString.call(y) === "[object Array]") {
      var fn;
      Fe = el(y), ct !== "left" && (Un = Fe.map(da));
      var dn, vs = 0;
      if (ct === "right") {
        L -= Un[0], y = [], SA = Fe.length;
        for (var Vi = 0; Vi < SA; Vi++) Vi === 0 ? (dn = Ti(L), fn = Pi(W)) : (dn = G(vs - Un[Vi]), fn = -fa), y.push([Fe[Vi], dn, fn]), vs = Un[Vi];
      } else if (ct === "center") {
        L -= Un[0] / 2, y = [], SA = Fe.length;
        for (var ws = 0; ws < SA; ws++) ws === 0 ? (dn = Ti(L), fn = Pi(W)) : (dn = G((vs - Un[ws]) / 2), fn = -fa), y.push([Fe[ws], dn, fn]), vs = Un[ws];
      } else if (ct === "left") {
        y = [], SA = Fe.length;
        for (var il = 0; il < SA; il++) y.push(Fe[il]);
      } else if (ct === "justify" && nl.encoding === "Identity-H") {
        y = [], SA = Fe.length, It = It !== 0 ? It : Al;
        for (var no = 0, Hr = 0; Hr < SA; Hr++) if (fn = Hr === 0 ? Pi(W) : -fa, dn = Hr === 0 ? Ti(L) : no, Hr < SA - 1) {
          var $u = G((It - Un[Hr]) / (Fe[Hr].split(" ").length - 1)), mi = Fe[Hr].split(" ");
          y.push([mi[0] + " ", dn, fn]), no = 0;
          for (var vi = 1; vi < mi.length; vi++) {
            var sl = (da(mi[vi - 1] + " " + mi[vi]) - da(mi[vi])) * Xn + $u;
            vi == mi.length - 1 ? y.push([mi[vi], sl, 0]) : y.push([mi[vi] + " ", sl, 0]), no -= sl;
          }
        } else y.push([Fe[Hr], dn, fn]);
        y.push(["", no, 0]);
      } else {
        if (ct !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (y = [], SA = Fe.length, It = It !== 0 ? It : Al, Hr = 0; Hr < SA; Hr++) {
          fn = Hr === 0 ? Pi(W) : -fa, dn = Hr === 0 ? Ti(L) : 0;
          var al = Fe[Hr].split(" ").length - 1, ol = al > 0 ? (It - Un[Hr]) / al : 0;
          Hr < SA - 1 ? ms.push(N(G(ol))) : ms.push(0), y.push([Fe[Hr], dn, fn]);
        }
      }
    }
    (typeof Z.R2L == "boolean" ? Z.R2L : We) === !0 && (y = ro(y, function(er, or, Dr) {
      return [er.split("").reverse().join(""), or, Dr];
    })), be = { text: y, x: L, y: W, options: Z, mutex: { pdfEscape: mA, activeFontKey: Ve, fonts: mt, activeFontSize: xe } }, Wt.publish("postProcessText", be), y = be.text, rA = be.mutex.isHex || !1;
    var ll = mt[Ve].encoding;
    ll !== "WinAnsiEncoding" && ll !== "StandardEncoding" || (y = ro(y, function(er, or, Dr) {
      return [Di(er), or, Dr];
    })), Fe = el(y), y = [];
    for (var ys, bs, Bs, ga = Array.isArray(Fe[0]) ? 1 : 0, Cs = "", pa = function(er, or, Dr) {
      var uA = "";
      return Dr instanceof vt ? (Dr = typeof Z.angle == "number" ? En(Dr, new vt(1, 0, 0, 1, er, or)) : En(new vt(1, 0, 0, 1, er, or), Dr), B === S && (Dr = En(new vt(1, 0, 0, -1, 0, 0), Dr)), uA = Dr.join(" ") + ` Tm
`) : uA = N(er) + " " + N(or) + ` Td
`, uA;
    }, In = 0; In < Fe.length; In++) {
      switch (Cs = "", ga) {
        case 1:
          Bs = (rA ? "<" : "(") + Fe[In][0] + (rA ? ">" : ")"), ys = parseFloat(Fe[In][1]), bs = parseFloat(Fe[In][2]);
          break;
        case 0:
          Bs = (rA ? "<" : "(") + Fe[In] + (rA ? ">" : ")"), ys = Ti(L), bs = Pi(W);
      }
      ms !== void 0 && ms[In] !== void 0 && (Cs = ms[In] + ` Tw
`), In === 0 ? y.push(Cs + pa(ys, bs, tA) + Bs) : ga === 0 ? y.push(Cs + Bs) : ga === 1 && y.push(Cs + pa(ys, bs, tA) + Bs);
    }
    y = ga === 0 ? y.join(` Tj
T* `) : y.join(` Tj
`), y += ` Tj
`;
    var wi = `BT
/`;
    return wi += Ve + " " + xe + ` Tf
`, wi += N(xe * Hi) + ` TL
`, wi += sa + `
`, wi += CA, wi += y, j(wi += "ET"), f[Ve] = !0, dr;
  };
  var bf = h.__private__.clip = h.clip = function(y) {
    return j(y === "evenodd" ? "W*" : "W"), this;
  };
  h.clipEvenOdd = function() {
    return bf("evenodd");
  }, h.__private__.discardPath = h.discardPath = function() {
    return j("n"), this;
  };
  var pi = h.__private__.isValidStyle = function(y) {
    var L = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(y) !== -1 && (L = !0), L;
  };
  h.__private__.setDefaultPathOperation = h.setDefaultPathOperation = function(y) {
    return pi(y) && (l = y), this;
  };
  var Gu = h.__private__.getStyle = h.getStyle = function(y) {
    var L = l;
    switch (y) {
      case "D":
      case "S":
        L = "S";
        break;
      case "F":
        L = "f";
        break;
      case "FD":
      case "DF":
        L = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        L = y;
    }
    return L;
  }, Vu = h.close = function() {
    return j("h"), this;
  };
  h.stroke = function() {
    return j("S"), this;
  }, h.fill = function(y) {
    return Za("f", y), this;
  }, h.fillEvenOdd = function(y) {
    return Za("f*", y), this;
  }, h.fillStroke = function(y) {
    return Za("B", y), this;
  }, h.fillStrokeEvenOdd = function(y) {
    return Za("B*", y), this;
  };
  var Za = function(y, L) {
    Xt(L) === "object" ? Cf(L, y) : j(y);
  }, na = function(y) {
    y === null || B === S && y === void 0 || (y = Gu(y), j(y));
  };
  function Bf(y, L, W, Z, ce) {
    var be = new Ia(L || this.boundingBox, W || this.xStep, Z || this.yStep, this.gState, ce || this.matrix);
    be.stream = this.stream;
    var Fe = y + "$$" + this.cloneIndex++ + "$$";
    return ZA(Fe, be), be;
  }
  var Cf = function(y, L) {
    var W = zt[y.key], Z = it[W];
    if (Z instanceof Rs) j("q"), j(Sf(L)), Z.gState && h.setGState(Z.gState), j(y.matrix.toString() + " cm"), j("/" + W + " sh"), j("Q");
    else if (Z instanceof Ia) {
      var ce = new vt(1, 0, 0, -1, 0, oa());
      y.matrix && (ce = ce.multiply(y.matrix || Fn), W = Bf.call(Z, y.key, y.boundingBox, y.xStep, y.yStep, ce).id), j("q"), j("/Pattern cs"), j("/" + W + " scn"), Z.gState && h.setGState(Z.gState), j(L), j("Q");
    }
  }, Sf = function(y) {
    switch (y) {
      case "f":
      case "F":
      case "n":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
      case "S":
        return "W S";
      case "B*":
        return "W* S";
    }
  }, qo = h.moveTo = function(y, L) {
    return j(N(G(y)) + " " + N(H(L)) + " m"), this;
  }, Ku = h.lineTo = function(y, L) {
    return j(N(G(y)) + " " + N(H(L)) + " l"), this;
  }, Wn = h.curveTo = function(y, L, W, Z, ce, be) {
    return j([N(G(y)), N(H(L)), N(G(W)), N(H(Z)), N(G(ce)), N(H(be)), "c"].join(" ")), this;
  };
  h.__private__.line = h.line = function(y, L, W, Z, ce) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || isNaN(Z) || !pi(ce)) throw new Error("Invalid arguments passed to jsPDF.line");
    return B === b ? this.lines([[W - y, Z - L]], y, L, [1, 1], ce || "S") : this.lines([[W - y, Z - L]], y, L, [1, 1]).stroke();
  }, h.__private__.lines = h.lines = function(y, L, W, Z, ce, be) {
    var Fe, nt, ct, St, It, Gt, Ur, tA, dr, lA, rA, CA;
    if (typeof y == "number" && (CA = W, W = L, L = y, y = CA), Z = Z || [1, 1], be = be || !1, isNaN(L) || isNaN(W) || !Array.isArray(y) || !Array.isArray(Z) || !pi(ce) || typeof be != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (qo(L, W), Fe = Z[0], nt = Z[1], St = y.length, lA = L, rA = W, ct = 0; ct < St; ct++) (It = y[ct]).length === 2 ? (lA = It[0] * Fe + lA, rA = It[1] * nt + rA, Ku(lA, rA)) : (Gt = It[0] * Fe + lA, Ur = It[1] * nt + rA, tA = It[2] * Fe + lA, dr = It[3] * nt + rA, lA = It[4] * Fe + lA, rA = It[5] * nt + rA, Wn(Gt, Ur, tA, dr, lA, rA));
    return be && Vu(), na(ce), this;
  }, h.path = function(y) {
    for (var L = 0; L < y.length; L++) {
      var W = y[L], Z = W.c;
      switch (W.op) {
        case "m":
          qo(Z[0], Z[1]);
          break;
        case "l":
          Ku(Z[0], Z[1]);
          break;
        case "c":
          Wn.apply(this, Z);
          break;
        case "h":
          Vu();
      }
    }
    return this;
  }, h.__private__.rect = h.rect = function(y, L, W, Z, ce) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || isNaN(Z) || !pi(ce)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return B === b && (Z = -Z), j([N(G(y)), N(H(L)), N(G(W)), N(G(Z)), "re"].join(" ")), na(ce), this;
  }, h.__private__.triangle = h.triangle = function(y, L, W, Z, ce, be, Fe) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || isNaN(Z) || isNaN(ce) || isNaN(be) || !pi(Fe)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[W - y, Z - L], [ce - W, be - Z], [y - ce, L - be]], y, L, [1, 1], Fe, !0), this;
  }, h.__private__.roundedRect = h.roundedRect = function(y, L, W, Z, ce, be, Fe) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || isNaN(Z) || isNaN(ce) || isNaN(be) || !pi(Fe)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var nt = 4 / 3 * (Math.SQRT2 - 1);
    return ce = Math.min(ce, 0.5 * W), be = Math.min(be, 0.5 * Z), this.lines([[W - 2 * ce, 0], [ce * nt, 0, ce, be - be * nt, ce, be], [0, Z - 2 * be], [0, be * nt, -ce * nt, be, -ce, be], [2 * ce - W, 0], [-ce * nt, 0, -ce, -be * nt, -ce, -be], [0, 2 * be - Z], [0, -be * nt, ce * nt, -be, ce, -be]], y + ce, L, [1, 1], Fe, !0), this;
  }, h.__private__.ellipse = h.ellipse = function(y, L, W, Z, ce) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || isNaN(Z) || !pi(ce)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var be = 4 / 3 * (Math.SQRT2 - 1) * W, Fe = 4 / 3 * (Math.SQRT2 - 1) * Z;
    return qo(y + W, L), Wn(y + W, L - Fe, y + be, L - Z, y, L - Z), Wn(y - be, L - Z, y - W, L - Fe, y - W, L), Wn(y - W, L + Fe, y - be, L + Z, y, L + Z), Wn(y + be, L + Z, y + W, L + Fe, y + W, L), na(ce), this;
  }, h.__private__.circle = h.circle = function(y, L, W, Z) {
    if (isNaN(y) || isNaN(L) || isNaN(W) || !pi(Z)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(y, L, W, W, Z);
  }, h.setFont = function(y, L, W) {
    return W && (L = Q(L, W)), Ve = Ru(y, L, { disableWarning: !1 }), this;
  };
  var xf = h.__private__.getFont = h.getFont = function() {
    return mt[Ru.apply(h, arguments)];
  };
  h.__private__.getFontList = h.getFontList = function() {
    var y, L, W = {};
    for (y in yt) if (yt.hasOwnProperty(y)) for (L in W[y] = [], yt[y]) yt[y].hasOwnProperty(L) && W[y].push(L);
    return W;
  }, h.addFont = function(y, L, W, Z, ce) {
    var be = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && be.indexOf(arguments[3]) !== -1 ? ce = arguments[3] : arguments[3] && be.indexOf(arguments[3]) == -1 && (W = Q(W, Z)), GA.call(this, y, L, W, ce = ce || "Identity-H");
  };
  var ia, zo = r.lineWidth || 0.200025, Ef = h.__private__.getLineWidth = h.getLineWidth = function() {
    return zo;
  }, xt = h.__private__.setLineWidth = h.setLineWidth = function(y) {
    return zo = y, j(N(G(y)) + " w"), this;
  };
  h.__private__.setLineDash = ot.API.setLineDash = ot.API.setLineDashPattern = function(y, L) {
    if (y = y || [], L = L || 0, isNaN(L) || !Array.isArray(y)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return y = y.map(function(W) {
      return N(G(W));
    }).join(" "), L = N(G(L)), j("[" + y + "] " + L + " d"), this;
  };
  var Ff = h.__private__.getLineHeight = h.getLineHeight = function() {
    return xe * ia;
  };
  h.__private__.getLineHeight = h.getLineHeight = function() {
    return xe * ia;
  };
  var _f = h.__private__.setLineHeightFactor = h.setLineHeightFactor = function(y) {
    return typeof (y = y || 1.15) == "number" && (ia = y), this;
  }, Uf = h.__private__.getLineHeightFactor = h.getLineHeightFactor = function() {
    return ia;
  };
  _f(r.lineHeight);
  var Ti = h.__private__.getHorizontalCoordinate = function(y) {
    return G(y);
  }, Pi = h.__private__.getVerticalCoordinate = function(y) {
    return B === S ? y : bt[V].mediaBox.topRightY - bt[V].mediaBox.bottomLeftY - G(y);
  }, If = h.__private__.getHorizontalCoordinateString = h.getHorizontalCoordinateString = function(y) {
    return N(Ti(y));
  }, Qf = h.__private__.getVerticalCoordinateString = h.getVerticalCoordinateString = function(y) {
    return N(Pi(y));
  }, eo = r.strokeColor || "0 G";
  h.__private__.getStrokeColor = h.getDrawColor = function() {
    return hn(eo);
  }, h.__private__.setStrokeColor = h.setDrawColor = function(y, L, W, Z) {
    return eo = en({ ch1: y, ch2: L, ch3: W, ch4: Z, pdfColorType: "draw", precision: 2 }), j(eo), this;
  };
  var Wo = r.fillColor || "0 g";
  h.__private__.getFillColor = h.getFillColor = function() {
    return hn(Wo);
  }, h.__private__.setFillColor = h.setFillColor = function(y, L, W, Z) {
    return Wo = en({ ch1: y, ch2: L, ch3: W, ch4: Z, pdfColorType: "fill", precision: 2 }), j(Wo), this;
  };
  var sa = r.textColor || "0 g", Lf = h.__private__.getTextColor = h.getTextColor = function() {
    return hn(sa);
  };
  h.__private__.setTextColor = h.setTextColor = function(y, L, W, Z) {
    return sa = en({ ch1: y, ch2: L, ch3: W, ch4: Z, pdfColorType: "text", precision: 3 }), this;
  };
  var Oi = r.charSpace, Nf = h.__private__.getCharSpace = h.getCharSpace = function() {
    return parseFloat(Oi || 0);
  };
  h.__private__.setCharSpace = h.setCharSpace = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Oi = y, this;
  };
  var Xo = 0;
  h.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, h.__private__.setLineCap = h.setLineCap = function(y) {
    var L = h.CapJoinStyles[y];
    if (L === void 0) throw new Error("Line cap style of '" + y + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Xo = L, j(L + " J"), this;
  };
  var Yo = 0;
  h.__private__.setLineJoin = h.setLineJoin = function(y) {
    var L = h.CapJoinStyles[y];
    if (L === void 0) throw new Error("Line join style of '" + y + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Yo = L, j(L + " j"), this;
  }, h.__private__.setLineMiterLimit = h.__private__.setMiterLimit = h.setLineMiterLimit = h.setMiterLimit = function(y) {
    if (y = y || 0, isNaN(y)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return j(N(G(y)) + " M"), this;
  }, h.GState = Ga, h.setGState = function(y) {
    (y = typeof y == "string" ? lt[wt[y]] : ju(null, y)).equals(Zt) || (j("/" + y.id + " gs"), Zt = y);
  };
  var ju = function(y, L) {
    if (!y || !wt[y]) {
      var W = !1;
      for (var Z in lt) if (lt.hasOwnProperty(Z) && lt[Z].equals(L)) {
        W = !0;
        break;
      }
      if (W) L = lt[Z];
      else {
        var ce = "GS" + (Object.keys(lt).length + 1).toString(10);
        lt[ce] = L, L.id = ce;
      }
      return y && (wt[y] = L.id), Wt.publish("addGState", L), L;
    }
  };
  h.addGState = function(y, L) {
    return ju(y, L), this;
  }, h.saveGraphicsState = function() {
    return j("q"), qt.push({ key: Ve, size: xe, color: sa }), this;
  }, h.restoreGraphicsState = function() {
    j("Q");
    var y = qt.pop();
    return Ve = y.key, xe = y.size, sa = y.color, Zt = null, this;
  }, h.setCurrentTransformationMatrix = function(y) {
    return j(y.toString() + " cm"), this;
  }, h.comment = function(y) {
    return j("#" + y), this;
  };
  var Mi = function(y, L) {
    var W = y || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return W;
    }, set: function(be) {
      isNaN(be) || (W = parseFloat(be));
    } });
    var Z = L || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return Z;
    }, set: function(be) {
      isNaN(be) || (Z = parseFloat(be));
    } });
    var ce = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return ce;
    }, set: function(be) {
      ce = be.toString();
    } }), this;
  }, $o = function(y, L, W, Z) {
    Mi.call(this, y, L), this.type = "rect";
    var ce = W || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return ce;
    }, set: function(Fe) {
      isNaN(Fe) || (ce = parseFloat(Fe));
    } });
    var be = Z || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return be;
    }, set: function(Fe) {
      isNaN(Fe) || (be = parseFloat(Fe));
    } }), this;
  }, to = function() {
    this.page = ut, this.currentPage = V, this.pages = Ee.slice(0), this.pagesContext = bt.slice(0), this.x = je, this.y = Tt, this.matrix = Et, this.width = Zo(V), this.height = zu(V), this.outputDestination = Te, this.id = "", this.objectNumber = -1;
  };
  to.prototype.restore = function() {
    ut = this.page, V = this.currentPage, bt = this.pagesContext, Ee = this.pages, je = this.x, Tt = this.y, Et = this.matrix, qu(V, this.width), Ri(V, this.height), Te = this.outputDestination;
  };
  var Jo = function(y, L, W, Z, ce) {
    cn.push(new to()), ut = V = 0, Ee = [], je = y, Tt = L, Et = ce, kr([W, Z]);
  };
  for (var aa in h.beginFormObject = function(y, L, W, Z, ce) {
    return Jo(y, L, W, Z, ce), this;
  }, h.endFormObject = function(y) {
    return (function(L) {
      if (jn[L]) cn.pop().restore();
      else {
        var W = new to(), Z = "Xo" + (Object.keys(Er).length + 1).toString(10);
        W.id = Z, jn[L] = Z, Er[Z] = W, Wt.publish("addFormObject", W), cn.pop().restore();
      }
    })(y), this;
  }, h.doFormObject = function(y, L) {
    var W = Er[jn[y]];
    return j("q"), j(L.toString() + " cm"), j("/" + W.id + " Do"), j("Q"), this;
  }, h.getFormObject = function(y) {
    var L = Er[jn[y]];
    return { x: L.x, y: L.y, width: L.width, height: L.height, matrix: L.matrix };
  }, h.save = function(y, L) {
    return y = y || "generated.pdf", (L = L || {}).returnPromise = L.returnPromise || !1, L.returnPromise === !1 ? (Sa(Ja(gi()), y), typeof Sa.unload == "function" && Ct.setTimeout && setTimeout(Sa.unload, 911), this) : new Promise(function(W, Z) {
      try {
        var ce = Sa(Ja(gi()), y);
        typeof Sa.unload == "function" && Ct.setTimeout && setTimeout(Sa.unload, 911), W(ce);
      } catch (be) {
        Z(be.message);
      }
    });
  }, ot.API) ot.API.hasOwnProperty(aa) && (aa === "events" && ot.API.events.length ? (function(y, L) {
    var W, Z, ce;
    for (ce = L.length - 1; ce !== -1; ce--) W = L[ce][0], Z = L[ce][1], y.subscribe.apply(y, [W].concat(typeof Z == "function" ? [Z] : Z));
  })(Wt, ot.API.events) : h[aa] = ot.API[aa]);
  function Zo(y) {
    return bt[y].mediaBox.topRightX - bt[y].mediaBox.bottomLeftX;
  }
  function qu(y, L) {
    bt[y].mediaBox.topRightX = L + bt[y].mediaBox.bottomLeftX;
  }
  function zu(y) {
    return bt[y].mediaBox.topRightY - bt[y].mediaBox.bottomLeftY;
  }
  function Ri(y, L) {
    bt[y].mediaBox.topRightY = L + bt[y].mediaBox.bottomLeftY;
  }
  var ki = h.getPageWidth = function(y) {
    return Zo(y = y || V) / dt;
  }, Wu = h.setPageWidth = function(y, L) {
    qu(y, L * dt);
  }, oa = h.getPageHeight = function(y) {
    return zu(y = y || V) / dt;
  }, Xu = h.setPageHeight = function(y, L) {
    Ri(y, L * dt);
  };
  return h.internal = { pdfEscape: mA, getStyle: Gu, getFont: xf, getFontSize: ke, getCharSpace: Nf, getTextColor: Lf, getLineHeight: Ff, getLineHeightFactor: Uf, getLineWidth: Ef, write: Pe, getHorizontalCoordinate: Ti, getVerticalCoordinate: Pi, getCoordinateString: If, getVerticalCoordinateString: Qf, collections: {}, newObject: ar, newAdditionalObject: qn, newObjectDeferred: Mr, newObjectDeferredBegin: Jr, getFilters: tn, putStream: DA, events: Wt, scaleFactor: dt, pageSize: { getWidth: function() {
    return ki(V);
  }, setWidth: function(y) {
    Wu(V, y);
  }, getHeight: function() {
    return oa(V);
  }, setHeight: function(y) {
    Xu(V, y);
  } }, encryptionOptions: u, encryption: oA, getEncryptor: function(y) {
    return u !== null ? oA.encryptor(y, 0) : function(L) {
      return L;
    };
  }, output: Hu, getNumberOfPages: Mu, get pages() {
    return Ee;
  }, out: j, f2: F, f3: O, getPageInfo: Ni, getPageInfoByObjId: Du, getCurrentPageInfo: yf, getPDFVersion: p, Point: Mi, Rectangle: $o, Matrix: vt, hasHotfix: _n }, Object.defineProperty(h.internal.pageSize, "width", { get: function() {
    return ki(V);
  }, set: function(y) {
    Wu(V, y);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.internal.pageSize, "height", { get: function() {
    return oa(V);
  }, set: function(y) {
    Xu(V, y);
  }, enumerable: !0, configurable: !0 }), (function(y) {
    for (var L = 0, W = tt.length; L < W; L++) {
      var Z = GA.call(this, y[L][0], y[L][1], y[L][2], tt[L][3], !0);
      c === !1 && (f[Z] = !0);
      var ce = y[L][0].split("-");
      aA({ id: Z, fontName: ce[0], fontStyle: ce[1] || "" });
    }
    Wt.publish("addFonts", { fonts: mt, dictionary: yt });
  }).call(h, tt), Ve = "F1", Aa(n, t), Wt.publish("initialized"), h;
}
yo.prototype.lsbFirstWord = function(r) {
  return String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, r >> 24 & 255);
}, yo.prototype.toHexString = function(r) {
  return r.split("").map(function(e) {
    return ("0" + (255 & e.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, yo.prototype.hexToBytes = function(r) {
  for (var e = [], t = 0; t < r.length; t += 2) e.push(String.fromCharCode(parseInt(r.substr(t, 2), 16)));
  return e.join("");
}, yo.prototype.processOwnerPassword = function(r, e) {
  return sm(im(e).substr(0, 5), r);
}, yo.prototype.encryptor = function(r, e) {
  var t = im(this.encryptionKey + String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
  return function(A) {
    return sm(t, A);
  };
}, Ga.prototype.equals = function(r) {
  var e, t = "id,objectNumber,equals";
  if (!r || Xt(r) !== Xt(this)) return !1;
  var A = 0;
  for (e in this) if (!(t.indexOf(e) >= 0)) {
    if (this.hasOwnProperty(e) && !r.hasOwnProperty(e) || this[e] !== r[e]) return !1;
    A++;
  }
  for (e in r) r.hasOwnProperty(e) && t.indexOf(e) < 0 && A--;
  return A === 0;
}, ot.API = { events: [] }, ot.version = "4.0.0";
var Nr = ot.API, fv = 1, qa = function(r) {
  return r.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, oo = function(r) {
  return r.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Ft = function(r) {
  return r.toFixed(2);
}, Ls = function(r) {
  return r.toFixed(5);
};
Nr.__acroform__ = {};
var ln = function(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r;
}, zw = function(r) {
  return r * fv;
}, Ci = function(r) {
  var e = new Wx(), t = rt.internal.getHeight(r) || 0, A = rt.internal.getWidth(r) || 0;
  return e.BBox = [0, 0, Number(Ft(A)), Number(Ft(t))], e;
}, XQ = Nr.__acroform__.setBit = function(r, e) {
  if (r = r || 0, e = e || 0, isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return r | 1 << e;
}, YQ = Nr.__acroform__.clearBit = function(r, e) {
  if (r = r || 0, e = e || 0, isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return r & ~(1 << e);
}, $Q = Nr.__acroform__.getBit = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return r & 1 << e ? 1 : 0;
}, Wr = Nr.__acroform__.getBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return $Q(r, e - 1);
}, Xr = Nr.__acroform__.setBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return XQ(r, e - 1);
}, Yr = Nr.__acroform__.clearBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return YQ(r, e - 1);
}, JQ = Nr.__acroform__.calculateCoordinates = function(r, e) {
  var t = e.internal.getHorizontalCoordinate, A = e.internal.getVerticalCoordinate, n = r[0], i = r[1], s = r[2], a = r[3], o = {};
  return o.lowerLeft_X = t(n) || 0, o.lowerLeft_Y = A(i + a) || 0, o.upperRight_X = t(n + s) || 0, o.upperRight_Y = A(i) || 0, [Number(Ft(o.lowerLeft_X)), Number(Ft(o.lowerLeft_Y)), Number(Ft(o.upperRight_X)), Number(Ft(o.upperRight_Y))];
}, ZQ = function(r) {
  if (r.appearanceStreamContent) return r.appearanceStreamContent;
  if (r.V || r.DV) {
    var e = [], t = r._V || r.DV, A = am(r, t), n = r.scope.internal.getFont(r.fontName, r.fontStyle).id;
    e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(r.scope.__private__.encodeColorString(r.color)), e.push("/" + n + " " + Ft(A.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(A.text), e.push("ET"), e.push("Q"), e.push("EMC");
    var i = Ci(r);
    return i.scope = r.scope, i.stream = e.join(`
`), i;
  }
}, am = function(r, e) {
  var t = r.fontSize === 0 ? r.maxFontSize : r.fontSize, A = { text: "", fontSize: "" }, n = (e = (e = e.substr(0, 1) == "(" ? e.substr(1) : e).substr(e.length - 1) == ")" ? e.substr(0, e.length - 1) : e).split(" ");
  n = r.multiline ? n.map(function(F) {
    return F.split(`
`);
  }) : n.map(function(F) {
    return [F];
  });
  var i = t, s = rt.internal.getHeight(r) || 0;
  s = s < 0 ? -s : s;
  var a = rt.internal.getWidth(r) || 0;
  a = a < 0 ? -a : a;
  var o = function(F, O, G) {
    if (F + 1 < n.length) {
      var H = O + " " + n[F + 1][0];
      return Cc(H, r, G).width <= a - 4;
    }
    return !1;
  };
  i++;
  e: for (; i > 0; ) {
    e = "", i--;
    var l, u, c = Cc("3", r, i).height, f = r.multiline ? s - i : (s - c) / 2, h = f += 2, g = 0, p = 0, v = 0;
    if (i <= 0) {
      e = `(...) Tj
`, e += "% Width of Text: " + Cc(e, r, i = 12).width + ", FieldWidth:" + a + `
`;
      break;
    }
    for (var w = "", b = 0, S = 0; S < n.length; S++) if (n.hasOwnProperty(S)) {
      var B = !1;
      if (n[S].length !== 1 && v !== n[S].length - 1) {
        if ((c + 2) * (b + 2) + 2 > s) continue e;
        w += n[S][v], B = !0, p = S, S--;
      } else {
        w = (w += n[S][v] + " ").substr(w.length - 1) == " " ? w.substr(0, w.length - 1) : w;
        var x = parseInt(S), U = o(x, w, i), Q = S >= n.length - 1;
        if (U && !Q) {
          w += " ", v = 0;
          continue;
        }
        if (U || Q) {
          if (Q) p = x;
          else if (r.multiline && (c + 2) * (b + 2) + 2 > s) continue e;
        } else {
          if (!r.multiline || (c + 2) * (b + 2) + 2 > s) continue e;
          p = x;
        }
      }
      for (var N = "", _ = g; _ <= p; _++) {
        var R = n[_];
        if (r.multiline) {
          if (_ === p) {
            N += R[v] + " ", v = (v + 1) % R.length;
            continue;
          }
          if (_ === g) {
            N += R[R.length - 1] + " ";
            continue;
          }
        }
        N += R[0] + " ";
      }
      switch (N = N.substr(N.length - 1) == " " ? N.substr(0, N.length - 1) : N, u = Cc(N, r, i).width, r.textAlign) {
        case "right":
          l = a - u - 2;
          break;
        case "center":
          l = (a - u) / 2;
          break;
        default:
          l = 2;
      }
      e += Ft(l) + " " + Ft(h) + ` Td
`, e += "(" + qa(N) + `) Tj
`, e += -Ft(l) + ` 0 Td
`, h = -(i + 2), u = 0, g = B ? p : p + 1, b++, w = "";
    }
    break;
  }
  return A.text = e, A.fontSize = i, A;
}, Cc = function(r, e, t) {
  var A = e.scope.internal.getFont(e.fontName, e.fontStyle), n = e.scope.getStringUnitWidth(r, { font: A, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t);
  return { height: e.scope.getStringUnitWidth("3", { font: A, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t) * 1.5, width: n };
}, eL = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, tL = function(r, e) {
  var t = { type: "reference", object: r };
  e.internal.getPageInfo(r.page).pageContext.annotations.find(function(A) {
    return A.type === t.type && A.object === t.object;
  }) === void 0 && e.internal.getPageInfo(r.page).pageContext.annotations.push(t);
}, rL = function(r, e) {
  if (e.scope = r, r.internal !== void 0 && (r.internal.acroformPlugin === void 0 || r.internal.acroformPlugin.isInitialized === !1)) {
    if (oi.FieldNum = 0, r.internal.acroformPlugin = JSON.parse(JSON.stringify(eL)), r.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    fv = r.internal.scaleFactor, r.internal.acroformPlugin.acroFormDictionaryRoot = new Xx(), r.internal.acroformPlugin.acroFormDictionaryRoot.scope = r, r.internal.acroformPlugin.acroFormDictionaryRoot._eventID = r.internal.events.subscribe("postPutResources", function() {
      (function(t) {
        t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
      })(r);
    }), r.internal.events.subscribe("buildDocument", function() {
      (function(t) {
        t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var A = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var n in A) if (A.hasOwnProperty(n)) {
          var i = A[n];
          i.objId = void 0, i.hasAnnotation && tL(i, t);
        }
      })(r);
    }), r.internal.events.subscribe("putCatalog", function() {
      (function(t) {
        if (t.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(r);
    }), r.internal.events.subscribe("postPutPages", function(t) {
      (function(A, n) {
        var i = !A;
        for (var s in A || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), A = A || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (A.hasOwnProperty(s)) {
          var a = A[s], o = [], l = a.Rect;
          if (a.Rect && (a.Rect = JQ(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = rt.createDefaultAppearanceStream(a), Xt(a) === "object" && typeof a.getKeyValueListForStream == "function" && (o = a.getKeyValueListForStream()), a.Rect = l, a.hasAppearanceStream && !a.appearanceStreamContent) {
            var u = ZQ(a);
            o.push({ key: "AP", value: "<</N " + u + ">>" }), n.internal.acroformPlugin.xForms.push(u);
          }
          if (a.appearanceStreamContent) {
            var c = "";
            for (var f in a.appearanceStreamContent) if (a.appearanceStreamContent.hasOwnProperty(f)) {
              var h = a.appearanceStreamContent[f];
              if (c += "/" + f + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                for (var s in h) if (h.hasOwnProperty(s)) {
                  var g = h[s];
                  typeof g == "function" && (g = g.call(n, a)), c += "/" + s + " " + g + " ", n.internal.acroformPlugin.xForms.indexOf(g) >= 0 || n.internal.acroformPlugin.xForms.push(g);
                }
              } else typeof (g = h) == "function" && (g = g.call(n, a)), c += "/" + s + " " + g, n.internal.acroformPlugin.xForms.indexOf(g) >= 0 || n.internal.acroformPlugin.xForms.push(g);
              c += ">>";
            }
            o.push({ key: "AP", value: `<<
` + c + ">>" });
          }
          n.internal.putStream({ additionalKeyValues: o, objectId: a.objId }), n.internal.out("endobj");
        }
        i && (function(p, v) {
          for (var w in p) if (p.hasOwnProperty(w)) {
            var b = w, S = p[w];
            v.internal.newObjectDeferredBegin(S.objId, !0), Xt(S) === "object" && typeof S.putStream == "function" && S.putStream(), delete p[b];
          }
        })(n.internal.acroformPlugin.xForms, n);
      })(t, r);
    }), r.internal.acroformPlugin.isInitialized = !0;
  }
}, zx = Nr.__acroform__.arrayToPdfArray = function(r, e, t) {
  var A = function(s) {
    return s;
  };
  if (Array.isArray(r)) {
    for (var n = "[", i = 0; i < r.length; i++) switch (i !== 0 && (n += " "), Xt(r[i])) {
      case "boolean":
      case "number":
      case "object":
        n += r[i].toString();
        break;
      case "string":
        r[i].substr(0, 1) !== "/" ? (e !== void 0 && t && (A = t.internal.getEncryptor(e)), n += "(" + qa(A(r[i].toString())) + ")") : n += r[i].toString();
    }
    return n + "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, md = function(r, e, t) {
  var A = function(n) {
    return n;
  };
  return e !== void 0 && t && (A = t.internal.getEncryptor(e)), (r = r || "").toString(), "(" + qa(A(r)) + ")";
}, xi = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(r) {
    this._objId = r;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
xi.prototype.toString = function() {
  return this.objId + " 0 R";
}, xi.prototype.putStream = function() {
  var r = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: r, objectId: this.objId }), this.scope.internal.out("endobj");
}, xi.prototype.getKeyValueListForStream = function() {
  var r = [], e = Object.getOwnPropertyNames(this).filter(function(i) {
    return i != "content" && i != "appearanceStreamContent" && i != "scope" && i != "objId" && i.substring(0, 1) != "_";
  });
  for (var t in e) if (Object.getOwnPropertyDescriptor(this, e[t]).configurable === !1) {
    var A = e[t], n = this[A];
    n && (Array.isArray(n) ? r.push({ key: A, value: zx(n, this.objId, this.scope) }) : n instanceof xi ? (n.scope = this.scope, r.push({ key: A, value: n.objId + " 0 R" })) : typeof n != "function" && r.push({ key: A, value: n }));
  }
  return r;
};
var Wx = function() {
  xi.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var r, e = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    e = t;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(t) {
    r = t.trim();
  }, get: function() {
    return r || null;
  } });
};
ln(Wx, xi);
var Xx = function() {
  xi.call(this);
  var r, e = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return e.length > 0 ? e : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return e;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (r) {
      var t = function(A) {
        return A;
      };
      return this.scope && (t = this.scope.internal.getEncryptor(this.objId)), "(" + qa(t(r)) + ")";
    }
  }, set: function(t) {
    r = t;
  } });
};
ln(Xx, xi);
var oi = function r() {
  xi.call(this);
  var e = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(w) {
    if (isNaN(w)) throw new Error('Invalid value "' + w + '" for attribute F supplied.');
    e = w;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(e, 3);
  }, set: function(w) {
    w ? this.F = Xr(e, 3) : this.F = Yr(e, 3);
  } });
  var t = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(w) {
    if (isNaN(w)) throw new Error('Invalid value "' + w + '" for attribute Ff supplied.');
    t = w;
  } });
  var A = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (A.length !== 0) return A;
  }, set: function(w) {
    A = w !== void 0 ? w : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[0]) ? 0 : A[0];
  }, set: function(w) {
    A[0] = w;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[1]) ? 0 : A[1];
  }, set: function(w) {
    A[1] = w;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[2]) ? 0 : A[2];
  }, set: function(w) {
    A[2] = w;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[3]) ? 0 : A[3];
  }, set: function(w) {
    A[3] = w;
  } });
  var n = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return n;
  }, set: function(w) {
    switch (w) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        n = w;
        break;
      default:
        throw new Error('Invalid value "' + w + '" for attribute FT supplied.');
    }
  } });
  var i = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!i || i.length < 1) {
      if (this instanceof Sh) return;
      i = "FieldObject" + r.FieldNum++;
    }
    var w = function(b) {
      return b;
    };
    return this.scope && (w = this.scope.internal.getEncryptor(this.objId)), "(" + qa(w(i)) + ")";
  }, set: function(w) {
    i = w.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return i;
  }, set: function(w) {
    i = w;
  } });
  var s = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(w) {
    s = w;
  } });
  var a = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return a;
  }, set: function(w) {
    a = w;
  } });
  var o = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(w) {
    o = w;
  } });
  var l = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return l === void 0 ? 50 / fv : l;
  }, set: function(w) {
    l = w;
  } });
  var u = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return u;
  }, set: function(w) {
    u = w;
  } });
  var c = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!c || this instanceof Sh || this instanceof Ta)) return md(c, this.objId, this.scope);
  }, set: function(w) {
    w = w.toString(), c = w;
  } });
  var f = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (f) return this instanceof yA == 0 ? md(f, this.objId, this.scope) : f;
  }, set: function(w) {
    w = w.toString(), f = this instanceof yA == 0 ? w.substr(0, 1) === "(" ? oo(w.substr(1, w.length - 2)) : oo(w) : w;
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof yA == 1 ? oo(f.substr(1, f.length - 1)) : f;
  }, set: function(w) {
    w = w.toString(), f = this instanceof yA == 1 ? "/" + w : w;
  } });
  var h = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (h) return h;
  }, set: function(w) {
    this.V = w;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (h) return this instanceof yA == 0 ? md(h, this.objId, this.scope) : h;
  }, set: function(w) {
    w = w.toString(), h = this instanceof yA == 0 ? w.substr(0, 1) === "(" ? oo(w.substr(1, w.length - 2)) : oo(w) : w;
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof yA == 1 ? oo(h.substr(1, h.length - 1)) : h;
  }, set: function(w) {
    w = w.toString(), h = this instanceof yA == 1 ? "/" + w : w;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var g, p = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return p;
  }, set: function(w) {
    w = !!w, p = w;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (g) return g;
  }, set: function(w) {
    g = w;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 1);
  }, set: function(w) {
    w ? this.Ff = Xr(this.Ff, 1) : this.Ff = Yr(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 2);
  }, set: function(w) {
    w ? this.Ff = Xr(this.Ff, 2) : this.Ff = Yr(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 3);
  }, set: function(w) {
    w ? this.Ff = Xr(this.Ff, 3) : this.Ff = Yr(this.Ff, 3);
  } });
  var v = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (v !== null) return v;
  }, set: function(w) {
    if ([0, 1, 2].indexOf(w) === -1) throw new Error('Invalid value "' + w + '" for attribute Q supplied.');
    v = w;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var w;
    switch (v) {
      case 0:
      default:
        w = "left";
        break;
      case 1:
        w = "center";
        break;
      case 2:
        w = "right";
    }
    return w;
  }, configurable: !0, enumerable: !0, set: function(w) {
    switch (w) {
      case "right":
      case 2:
        v = 2;
        break;
      case "center":
      case 1:
        v = 1;
        break;
      default:
        v = 0;
    }
  } });
};
ln(oi, xi);
var _o = function() {
  oi.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var r = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } });
  var e = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return zx(e, this.objId, this.scope);
  }, set: function(t) {
    var A, n;
    n = [], typeof (A = t) == "string" && (n = (function(i, s, a) {
      a || (a = 1);
      for (var o, l = []; o = s.exec(i); ) l.push(o[a]);
      return l;
    })(A, /\((.*?)\)/g)), e = n;
  } }), this.getOptions = function() {
    return e;
  }, this.setOptions = function(t) {
    e = t, this.sort && e.sort();
  }, this.addOption = function(t) {
    t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
  }, this.removeOption = function(t, A) {
    for (A = A || !1, t = (t = t || "").toString(); e.indexOf(t) !== -1 && (e.splice(e.indexOf(t), 1), A !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 18);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 18) : this.Ff = Yr(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 19);
  }, set: function(t) {
    this.combo === !0 && (t ? this.Ff = Xr(this.Ff, 19) : this.Ff = Yr(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 20);
  }, set: function(t) {
    t ? (this.Ff = Xr(this.Ff, 20), e.sort()) : this.Ff = Yr(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 22);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 22) : this.Ff = Yr(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 23);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 23) : this.Ff = Yr(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 27);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 27) : this.Ff = Yr(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
ln(_o, oi);
var Uo = function() {
  _o.call(this), this.fontName = "helvetica", this.combo = !1;
};
ln(Uo, _o);
var Io = function() {
  Uo.call(this), this.combo = !0;
};
ln(Io, Uo);
var sh = function() {
  Io.call(this), this.edit = !0;
};
ln(sh, Io);
var yA = function() {
  oi.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 15);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 15) : this.Ff = Yr(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 16);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 16) : this.Ff = Yr(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 17);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 17) : this.Ff = Yr(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 26);
  }, set: function(t) {
    t ? this.Ff = Xr(this.Ff, 26) : this.Ff = Yr(this.Ff, 26);
  } });
  var r, e = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var t = function(i) {
      return i;
    };
    if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), Object.keys(e).length !== 0) {
      var A, n = [];
      for (A in n.push("<<"), e) n.push("/" + A + " (" + qa(t(e[A])) + ")");
      return n.push(">>"), n.join(`
`);
    }
  }, set: function(t) {
    Xt(t) === "object" && (e = t);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return e.CA || "";
  }, set: function(t) {
    typeof t == "string" && (e.CA = t);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return r.substr(1, r.length - 1);
  }, set: function(t) {
    r = "/" + t;
  } });
};
ln(yA, oi);
var ah = function() {
  yA.call(this), this.pushButton = !0;
};
ln(ah, yA);
var Qo = function() {
  yA.call(this), this.radio = !0, this.pushButton = !1;
  var r = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e !== void 0 ? e : [];
  } });
};
ln(Qo, yA);
var Sh = function() {
  var r, e;
  oi.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(n) {
    r = n;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } });
  var t, A = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(a) {
      return a;
    };
    this.scope && (n = this.scope.internal.getEncryptor(this.objId));
    var i, s = [];
    for (i in s.push("<<"), A) s.push("/" + i + " (" + qa(n(A[i])) + ")");
    return s.push(">>"), s.join(`
`);
  }, set: function(n) {
    Xt(n) === "object" && (A = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return A.CA || "";
  }, set: function(n) {
    typeof n == "string" && (A.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(n) {
    t = "/" + n;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = rt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
ln(Sh, oi), Qo.prototype.setAppearance = function(r) {
  if (!("createAppearanceStream" in r) || !("getCA" in r)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var e in this.Kids) if (this.Kids.hasOwnProperty(e)) {
    var t = this.Kids[e];
    t.appearanceStreamContent = r.createAppearanceStream(t.optionName), t.caption = r.getCA();
  }
}, Qo.prototype.createOption = function(r) {
  var e = new Sh();
  return e.Parent = this, e.optionName = r, this.Kids.push(e), AL.call(this.scope, e), e;
};
var oh = function() {
  yA.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = rt.CheckBox.createAppearanceStream();
};
ln(oh, yA);
var Ta = function() {
  oi.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 13);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 13) : this.Ff = Yr(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 21);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 21) : this.Ff = Yr(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 23) : this.Ff = Yr(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 24);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 24) : this.Ff = Yr(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 25);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 25) : this.Ff = Yr(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = Xr(this.Ff, 26) : this.Ff = Yr(this.Ff, 26);
  } });
  var r = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(e) {
    Number.isInteger(e) && (r = e);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
ln(Ta, oi);
var lh = function() {
  Ta.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!Wr(this.Ff, 14);
  }, set: function(r) {
    r ? this.Ff = Xr(this.Ff, 14) : this.Ff = Yr(this.Ff, 14);
  } }), this.password = !0;
};
ln(lh, Ta);
var rt = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: rt.CheckBox.YesNormal }, D: { On: rt.CheckBox.YesPushDown, Off: rt.CheckBox.OffPushDown } };
}, YesPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [], A = r.scope.internal.getFont(r.fontName, r.fontStyle).id, n = r.scope.__private__.encodeColorString(r.color), i = am(r, r.caption);
  return t.push("0.749023 g"), t.push("0 0 " + Ft(rt.internal.getWidth(r)) + " " + Ft(rt.internal.getHeight(r)) + " re"), t.push("f"), t.push("BMC"), t.push("q"), t.push("0 0 1 rg"), t.push("/" + A + " " + Ft(i.fontSize) + " Tf " + n), t.push("BT"), t.push(i.text), t.push("ET"), t.push("Q"), t.push("EMC"), e.stream = t.join(`
`), e;
}, YesNormal: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = r.scope.internal.getFont(r.fontName, r.fontStyle).id, A = r.scope.__private__.encodeColorString(r.color), n = [], i = rt.internal.getHeight(r), s = rt.internal.getWidth(r), a = am(r, r.caption);
  return n.push("1 g"), n.push("0 0 " + Ft(s) + " " + Ft(i) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + Ft(s - 1) + " " + Ft(i - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + t + " " + Ft(a.fontSize) + " Tf " + A), n.push(a.text), n.push("ET"), n.push("Q"), e.stream = n.join(`
`), e;
}, OffPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + Ft(rt.internal.getWidth(r)) + " " + Ft(rt.internal.getHeight(r)) + " re"), t.push("f"), e.stream = t.join(`
`), e;
} }, RadioButton: { Circle: { createAppearanceStream: function(r) {
  var e = { D: { Off: rt.RadioButton.Circle.OffPushDown }, N: {} };
  return e.N[r] = rt.RadioButton.Circle.YesNormal, e.D[r] = rt.RadioButton.Circle.YesPushDown, e;
}, getCA: function() {
  return "l";
}, YesNormal: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [], A = rt.internal.getWidth(r) <= rt.internal.getHeight(r) ? rt.internal.getWidth(r) / 4 : rt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = rt.internal.Bezier_C, i = Number((A * n).toFixed(5));
  return t.push("q"), t.push("1 0 0 1 " + Ls(rt.internal.getWidth(r) / 2) + " " + Ls(rt.internal.getHeight(r) / 2) + " cm"), t.push(A + " 0 m"), t.push(A + " " + i + " " + i + " " + A + " 0 " + A + " c"), t.push("-" + i + " " + A + " -" + A + " " + i + " -" + A + " 0 c"), t.push("-" + A + " -" + i + " -" + i + " -" + A + " 0 -" + A + " c"), t.push(i + " -" + A + " " + A + " -" + i + " " + A + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
}, YesPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [], A = rt.internal.getWidth(r) <= rt.internal.getHeight(r) ? rt.internal.getWidth(r) / 4 : rt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = Number((2 * A).toFixed(5)), i = Number((n * rt.internal.Bezier_C).toFixed(5)), s = Number((A * rt.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + Ls(rt.internal.getWidth(r) / 2) + " " + Ls(rt.internal.getHeight(r) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), t.push("0 g"), t.push("q"), t.push("1 0 0 1 " + Ls(rt.internal.getWidth(r) / 2) + " " + Ls(rt.internal.getHeight(r) / 2) + " cm"), t.push(A + " 0 m"), t.push(A + " " + s + " " + s + " " + A + " 0 " + A + " c"), t.push("-" + s + " " + A + " -" + A + " " + s + " -" + A + " 0 c"), t.push("-" + A + " -" + s + " -" + s + " -" + A + " 0 -" + A + " c"), t.push(s + " -" + A + " " + A + " -" + s + " " + A + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
}, OffPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [], A = rt.internal.getWidth(r) <= rt.internal.getHeight(r) ? rt.internal.getWidth(r) / 4 : rt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = Number((2 * A).toFixed(5)), i = Number((n * rt.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + Ls(rt.internal.getWidth(r) / 2) + " " + Ls(rt.internal.getHeight(r) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
} }, Cross: { createAppearanceStream: function(r) {
  var e = { D: { Off: rt.RadioButton.Cross.OffPushDown }, N: {} };
  return e.N[r] = rt.RadioButton.Cross.YesNormal, e.D[r] = rt.RadioButton.Cross.YesPushDown, e;
}, getCA: function() {
  return "8";
}, YesNormal: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [], A = rt.internal.calculateCross(r);
  return t.push("q"), t.push("1 1 " + Ft(rt.internal.getWidth(r) - 2) + " " + Ft(rt.internal.getHeight(r) - 2) + " re"), t.push("W"), t.push("n"), t.push(Ft(A.x1.x) + " " + Ft(A.x1.y) + " m"), t.push(Ft(A.x2.x) + " " + Ft(A.x2.y) + " l"), t.push(Ft(A.x4.x) + " " + Ft(A.x4.y) + " m"), t.push(Ft(A.x3.x) + " " + Ft(A.x3.y) + " l"), t.push("s"), t.push("Q"), e.stream = t.join(`
`), e;
}, YesPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = rt.internal.calculateCross(r), A = [];
  return A.push("0.749023 g"), A.push("0 0 " + Ft(rt.internal.getWidth(r)) + " " + Ft(rt.internal.getHeight(r)) + " re"), A.push("f"), A.push("q"), A.push("1 1 " + Ft(rt.internal.getWidth(r) - 2) + " " + Ft(rt.internal.getHeight(r) - 2) + " re"), A.push("W"), A.push("n"), A.push(Ft(t.x1.x) + " " + Ft(t.x1.y) + " m"), A.push(Ft(t.x2.x) + " " + Ft(t.x2.y) + " l"), A.push(Ft(t.x4.x) + " " + Ft(t.x4.y) + " m"), A.push(Ft(t.x3.x) + " " + Ft(t.x3.y) + " l"), A.push("s"), A.push("Q"), e.stream = A.join(`
`), e;
}, OffPushDown: function(r) {
  var e = Ci(r);
  e.scope = r.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + Ft(rt.internal.getWidth(r)) + " " + Ft(rt.internal.getHeight(r)) + " re"), t.push("f"), e.stream = t.join(`
`), e;
} } }, createDefaultAppearanceStream: function(r) {
  var e = r.scope.internal.getFont(r.fontName, r.fontStyle).id, t = r.scope.__private__.encodeColorString(r.color);
  return "/" + e + " " + r.fontSize + " Tf " + t;
} };
rt.internal = { Bezier_C: 0.551915024494, calculateCross: function(r) {
  var e = rt.internal.getWidth(r), t = rt.internal.getHeight(r), A = Math.min(e, t);
  return { x1: { x: (e - A) / 2, y: (t - A) / 2 + A }, x2: { x: (e - A) / 2 + A, y: (t - A) / 2 }, x3: { x: (e - A) / 2, y: (t - A) / 2 }, x4: { x: (e - A) / 2 + A, y: (t - A) / 2 + A } };
} }, rt.internal.getWidth = function(r) {
  var e = 0;
  return Xt(r) === "object" && (e = zw(r.Rect[2])), e;
}, rt.internal.getHeight = function(r) {
  var e = 0;
  return Xt(r) === "object" && (e = zw(r.Rect[3])), e;
};
var AL = Nr.addField = function(r) {
  if (rL(this, r), !(r instanceof oi)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var e;
  return (e = r).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), r.page = r.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Nr.AcroFormChoiceField = _o, Nr.AcroFormListBox = Uo, Nr.AcroFormComboBox = Io, Nr.AcroFormEditBox = sh, Nr.AcroFormButton = yA, Nr.AcroFormPushButton = ah, Nr.AcroFormRadioButton = Qo, Nr.AcroFormCheckBox = oh, Nr.AcroFormTextField = Ta, Nr.AcroFormPasswordField = lh, Nr.AcroFormAppearance = rt, Nr.AcroForm = { ChoiceField: _o, ListBox: Uo, ComboBox: Io, EditBox: sh, Button: yA, PushButton: ah, RadioButton: Qo, CheckBox: oh, TextField: Ta, PasswordField: lh, Appearance: rt }, ot.AcroForm = { ChoiceField: _o, ListBox: Uo, ComboBox: Io, EditBox: sh, Button: yA, PushButton: ah, RadioButton: Qo, CheckBox: oh, TextField: Ta, PasswordField: lh, Appearance: rt };
ot.AcroForm;
function Yx(r) {
  return r.reduce(function(e, t, A) {
    return e[t] = A, e;
  }, {});
}
(function(r) {
  var e = "addImage_";
  r.__addimage__ = {};
  var t = "UNKNOWN", A = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, n = r.__addimage__.getImageFileTypeByImageData = function(F, O) {
    var G, H, $, ne, te, J = t;
    if ((O = O || t) === "RGBA" || F.data !== void 0 && F.data instanceof Uint8ClampedArray && "height" in F && "width" in F) return "RGBA";
    if (U(F)) for (te in A) for ($ = A[te], G = 0; G < $.length; G += 1) {
      for (ne = !0, H = 0; H < $[G].length; H += 1) if ($[G][H] !== void 0 && $[G][H] !== F[H]) {
        ne = !1;
        break;
      }
      if (ne === !0) {
        J = te;
        break;
      }
    }
    else for (te in A) for ($ = A[te], G = 0; G < $.length; G += 1) {
      for (ne = !0, H = 0; H < $[G].length; H += 1) if ($[G][H] !== void 0 && $[G][H] !== F.charCodeAt(H)) {
        ne = !1;
        break;
      }
      if (ne === !0) {
        J = te;
        break;
      }
    }
    return J === t && O !== t && (J = O), J;
  }, i = function F(O) {
    for (var G = this.internal.write, H = this.internal.putStream, $ = (0, this.internal.getFilters)(); $.indexOf("FlateEncode") !== -1; ) $.splice($.indexOf("FlateEncode"), 1);
    O.objectId = this.internal.newObject();
    var ne = [];
    if (ne.push({ key: "Type", value: "/XObject" }), ne.push({ key: "Subtype", value: "/Image" }), ne.push({ key: "Width", value: O.width }), ne.push({ key: "Height", value: O.height }), O.colorSpace === w.INDEXED ? ne.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (O.palette.length / 3 - 1) + " " + ("sMask" in O && O.sMask !== void 0 ? O.objectId + 2 : O.objectId + 1) + " 0 R]" }) : (ne.push({ key: "ColorSpace", value: "/" + O.colorSpace }), O.colorSpace === w.DEVICE_CMYK && ne.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), ne.push({ key: "BitsPerComponent", value: O.bitsPerComponent }), "decodeParameters" in O && O.decodeParameters !== void 0 && ne.push({ key: "DecodeParms", value: "<<" + O.decodeParameters + ">>" }), "transparency" in O && Array.isArray(O.transparency) && O.transparency.length > 0) {
      for (var te = "", J = 0, re = O.transparency.length; J < re; J++) te += O.transparency[J] + " " + O.transparency[J] + " ";
      ne.push({ key: "Mask", value: "[" + te + "]" });
    }
    O.sMask !== void 0 && ne.push({ key: "SMask", value: O.objectId + 1 + " 0 R" });
    var le = O.filter !== void 0 ? ["/" + O.filter] : void 0;
    if (H({ data: O.data, additionalKeyValues: ne, alreadyAppliedFilters: le, objectId: O.objectId }), G("endobj"), "sMask" in O && O.sMask !== void 0) {
      var se, P = (se = O.sMaskBitsPerComponent) !== null && se !== void 0 ? se : O.bitsPerComponent, V = { width: O.width, height: O.height, colorSpace: "DeviceGray", bitsPerComponent: P, data: O.sMask };
      "filter" in O && (V.decodeParameters = "/Predictor ".concat(O.predictor, " /Colors 1 /BitsPerComponent ").concat(P, " /Columns ").concat(O.width), V.filter = O.filter), F.call(this, V);
    }
    if (O.colorSpace === w.INDEXED) {
      var X = this.internal.newObject();
      H({ data: N(new Uint8Array(O.palette)), objectId: X }), G("endobj");
    }
  }, s = function() {
    var F = this.internal.collections[e + "images"];
    for (var O in F) i.call(this, F[O]);
  }, a = function() {
    var F, O = this.internal.collections[e + "images"], G = this.internal.write;
    for (var H in O) G("/I" + (F = O[H]).index, F.objectId, "0", "R");
  }, o = function() {
    this.internal.collections[e + "images"] || (this.internal.collections[e + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", a));
  }, l = function() {
    var F = this.internal.collections[e + "images"];
    return o.call(this), F;
  }, u = function() {
    return Object.keys(this.internal.collections[e + "images"]).length;
  }, c = function(F) {
    return typeof r["process" + F.toUpperCase()] == "function";
  }, f = function(F) {
    return Xt(F) === "object" && F.nodeType === 1;
  }, h = function(F, O) {
    if (F.nodeName === "IMG" && F.hasAttribute("src")) {
      var G = "" + F.getAttribute("src");
      if (G.indexOf("data:image/") === 0) return ih(unescape(G).split("base64,").pop());
      var H = r.loadFile(G, !0);
      if (H !== void 0) return H;
    }
    if (F.nodeName === "CANVAS") {
      if (F.width === 0 || F.height === 0) throw new Error("Given canvas must have data. Canvas width: " + F.width + ", height: " + F.height);
      var $;
      switch (O) {
        case "PNG":
          $ = "image/png";
          break;
        case "WEBP":
          $ = "image/webp";
          break;
        default:
          $ = "image/jpeg";
      }
      return ih(F.toDataURL($, 1).split("base64,").pop());
    }
  }, g = function(F) {
    var O = this.internal.collections[e + "images"];
    if (O) {
      for (var G in O) if (F === O[G].alias) return O[G];
    }
  }, p = function(F, O, G) {
    return F || O || (F = -96, O = -96), F < 0 && (F = -1 * G.width * 72 / F / this.internal.scaleFactor), O < 0 && (O = -1 * G.height * 72 / O / this.internal.scaleFactor), F === 0 && (F = O * G.width / G.height), O === 0 && (O = F * G.height / G.width), [F, O];
  }, v = function(F, O, G, H, $, ne) {
    var te = p.call(this, G, H, $), J = this.internal.getCoordinateString, re = this.internal.getVerticalCoordinateString, le = l.call(this);
    if (G = te[0], H = te[1], le[$.index] = $, ne) {
      ne *= Math.PI / 180;
      var se = Math.cos(ne), P = Math.sin(ne), V = function(Y) {
        return Y.toFixed(4);
      }, X = [V(se), V(P), V(-1 * P), V(se), 0, 0, "cm"];
    }
    this.internal.write("q"), ne ? (this.internal.write([1, "0", "0", 1, J(F), re(O + H), "cm"].join(" ")), this.internal.write(X.join(" ")), this.internal.write([J(G), "0", "0", J(H), "0", "0", "cm"].join(" "))) : this.internal.write([J(G), "0", "0", J(H), J(F), re(O + H), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + $.index + " Do"), this.internal.write("Q");
  }, w = r.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  r.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var b = r.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, S = r.__addimage__.sHashCode = function(F) {
    var O, G, H = 0;
    if (typeof F == "string") for (G = F.length, O = 0; O < G; O++) H = (H << 5) - H + F.charCodeAt(O), H |= 0;
    else if (U(F)) for (G = F.byteLength / 2, O = 0; O < G; O++) H = (H << 5) - H + F[O], H |= 0;
    return H;
  }, B = r.__addimage__.validateStringAsBase64 = function(F) {
    (F = F || "").toString().trim();
    var O = !0;
    return F.length === 0 && (O = !1), F.length % 4 != 0 && (O = !1), /^[A-Za-z0-9+/]+$/.test(F.substr(0, F.length - 2)) === !1 && (O = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(F.substr(-2)) === !1 && (O = !1), O;
  }, x = r.__addimage__.extractImageFromDataUrl = function(F) {
    if (F == null || !(F = F.trim()).startsWith("data:")) return null;
    var O = F.indexOf(",");
    return O < 0 ? null : F.substring(0, O).trim().endsWith("base64") ? F.substring(O + 1) : null;
  };
  r.__addimage__.isArrayBuffer = function(F) {
    return F instanceof ArrayBuffer;
  };
  var U = r.__addimage__.isArrayBufferView = function(F) {
    return F instanceof Int8Array || F instanceof Uint8Array || F instanceof Uint8ClampedArray || F instanceof Int16Array || F instanceof Uint16Array || F instanceof Int32Array || F instanceof Uint32Array || F instanceof Float32Array || F instanceof Float64Array;
  }, Q = r.__addimage__.binaryStringToUint8Array = function(F) {
    for (var O = F.length, G = new Uint8Array(O), H = 0; H < O; H++) G[H] = F.charCodeAt(H);
    return G;
  }, N = r.__addimage__.arrayBufferToBinaryString = function(F) {
    for (var O = "", G = U(F) ? F : new Uint8Array(F), H = 0; H < G.length; H += 8192) O += String.fromCharCode.apply(null, G.subarray(H, H + 8192));
    return O;
  };
  r.addImage = function() {
    var F, O, G, H, $, ne, te, J, re;
    if (typeof arguments[1] == "number" ? (O = t, G = arguments[1], H = arguments[2], $ = arguments[3], ne = arguments[4], te = arguments[5], J = arguments[6], re = arguments[7]) : (O = arguments[1], G = arguments[2], H = arguments[3], $ = arguments[4], ne = arguments[5], te = arguments[6], J = arguments[7], re = arguments[8]), Xt(F = arguments[0]) === "object" && !f(F) && "imageData" in F) {
      var le = F;
      F = le.imageData, O = le.format || O || t, G = le.x || G || 0, H = le.y || H || 0, $ = le.w || le.width || $, ne = le.h || le.height || ne, te = le.alias || te, J = le.compression || J, re = le.rotation || le.angle || re;
    }
    var se = this.internal.getFilters();
    if (J === void 0 && se.indexOf("FlateEncode") !== -1 && (J = "SLOW"), isNaN(G) || isNaN(H)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    o.call(this);
    var P = _.call(this, F, O, te, J);
    return v.call(this, G, H, $, ne, P, re), this;
  };
  var _ = function(F, O, G, H) {
    var $, ne, te;
    if (typeof F == "string" && n(F) === t) {
      F = unescape(F);
      var J = R(F, !1);
      (J !== "" || (J = r.loadFile(F, !0)) !== void 0) && (F = J);
    }
    if (f(F) && (F = h(F, O)), O = n(F, O), !c(O)) throw new Error("addImage does not support files of type '" + O + "', please ensure that a plugin for '" + O + "' support is added.");
    if (((te = G) == null || te.length === 0) && (G = (function(re) {
      return typeof re == "string" || U(re) ? S(re) : U(re.data) ? S(re.data) : null;
    })(F)), ($ = g.call(this, G)) || (F instanceof Uint8Array || O === "RGBA" || (ne = F, F = Q(F)), $ = this["process" + O.toUpperCase()](F, u.call(this), G, (function(re) {
      return re && typeof re == "string" && (re = re.toUpperCase()), re in r.image_compression ? re : b.NONE;
    })(H), ne)), !$) throw new Error("An unknown error occurred whilst processing the image.");
    return $;
  }, R = r.__addimage__.convertBase64ToBinaryString = function(F, O) {
    O = typeof O != "boolean" || O;
    var G, H = "";
    if (typeof F == "string") {
      var $;
      G = ($ = x(F)) !== null && $ !== void 0 ? $ : F;
      try {
        H = ih(G);
      } catch (ne) {
        if (O) throw B(G) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + ne.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return H;
  };
  r.getImageProperties = function(F) {
    var O, G, H = "";
    if (f(F) && (F = h(F)), typeof F == "string" && n(F) === t && ((H = R(F, !1)) === "" && (H = r.loadFile(F) || ""), F = H), G = n(F), !c(G)) throw new Error("addImage does not support files of type '" + G + "', please ensure that a plugin for '" + G + "' support is added.");
    if (F instanceof Uint8Array || (F = Q(F)), !(O = this["process" + G.toUpperCase()](F))) throw new Error("An unknown error occurred whilst processing the image");
    return O.fileType = G, O;
  };
})(ot.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(t) {
    if (t !== void 0 && t != "") return !0;
  };
  ot.API.events.push(["addPage", function(t) {
    this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
  }]), r.events.push(["putPage", function(t) {
    for (var A, n, i, s = this.internal.getCoordinateString, a = this.internal.getVerticalCoordinateString, o = this.internal.getPageInfoByObjId(t.objId), l = t.pageContext.annotations, u = !1, c = 0; c < l.length && !u; c++) switch ((A = l[c]).type) {
      case "link":
        (e(A.options.url) || e(A.options.pageNumber)) && (u = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        u = !0;
    }
    if (u != 0) {
      this.internal.write("/Annots [");
      for (var f = 0; f < l.length; f++) {
        A = l[f];
        var h = this.internal.pdfEscape, g = this.internal.getEncryptor(t.objId);
        switch (A.type) {
          case "reference":
            this.internal.write(" " + A.object.objId + " 0 R ");
            break;
          case "text":
            var p = this.internal.newAdditionalObject(), v = this.internal.newAdditionalObject(), w = this.internal.getEncryptor(p.objId), b = A.title || "Note";
            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + s(A.bounds.x) + " " + a(A.bounds.y + A.bounds.h) + " " + s(A.bounds.x + A.bounds.w) + " " + a(A.bounds.y) + "] ") + "/Contents (" + h(w(A.contents)) + ")", i += " /Popup " + v.objId + " 0 R", i += " /P " + o.objId + " 0 R", i += " /T (" + h(w(b)) + ") >>", p.content = i;
            var S = p.objId + " 0 R";
            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + s(A.bounds.x + 30) + " " + a(A.bounds.y + A.bounds.h) + " " + s(A.bounds.x + A.bounds.w + 30) + " " + a(A.bounds.y) + "] ") + " /Parent " + S, A.open && (i += " /Open true"), i += " >>", v.content = i, this.internal.write(p.objId, "0 R", v.objId, "0 R");
            break;
          case "freetext":
            n = "/Rect [" + s(A.bounds.x) + " " + a(A.bounds.y) + " " + s(A.bounds.x + A.bounds.w) + " " + a(A.bounds.y + A.bounds.h) + "] ";
            var B = A.color || "#000000";
            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + h(g(A.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + B + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
            break;
          case "link":
            if (A.options.name) {
              var x = this.annotations._nameMap[A.options.name];
              A.options.pageNumber = x.page, A.options.top = x.y;
            } else A.options.top || (A.options.top = 0);
            if (n = "/Rect [" + A.finalBounds.x + " " + A.finalBounds.y + " " + A.finalBounds.w + " " + A.finalBounds.h + "] ", i = "", A.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + h(g(A.options.url)) + ") >>";
            else if (A.options.pageNumber) switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(A.options.pageNumber).objId + " 0 R", A.options.magFactor = A.options.magFactor || "XYZ", A.options.magFactor) {
              case "Fit":
                i += " /Fit]";
                break;
              case "FitH":
                i += " /FitH " + A.options.top + "]";
                break;
              case "FitV":
                A.options.left = A.options.left || 0, i += " /FitV " + A.options.left + "]";
                break;
              default:
                var U = a(A.options.top);
                A.options.left = A.options.left || 0, A.options.zoom === void 0 && (A.options.zoom = 0), i += " /XYZ " + A.options.left + " " + U + " " + A.options.zoom + "]";
            }
            i != "" && (i += " >>", this.internal.write(i));
        }
      }
      this.internal.write("]");
    }
  }]), r.createAnnotation = function(t) {
    var A = this.internal.getCurrentPageInfo();
    switch (t.type) {
      case "link":
        this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
        break;
      case "text":
      case "freetext":
        A.pageContext.annotations.push(t);
    }
  }, r.link = function(t, A, n, i, s) {
    var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
    a.pageContext.annotations.push({ finalBounds: { x: o(t), y: l(A), w: o(t + n), h: l(A + i) }, options: s, type: "link" });
  }, r.textWithLink = function(t, A, n, i) {
    var s, a, o = this.getTextWidth(t), l = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (i.maxWidth !== void 0) {
      a = i.maxWidth;
      var u = this.splitTextToSize(t, a).length;
      s = Math.ceil(l * u);
    } else a = o, s = l;
    return this.text(t, A, n, i), n += 0.2 * l, i.align === "center" && (A -= o / 2), i.align === "right" && (A -= o), this.link(A, n - l, a, s, i), o;
  }, r.getTextWidth = function(t) {
    var A = this.internal.getFontSize();
    return this.getStringUnitWidth(t) * A / this.internal.scaleFactor;
  };
})(ot.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, t = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, A = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, n = [1570, 1571, 1573, 1575];
  r.__arabicParser__ = {};
  var i = r.__arabicParser__.isInArabicSubstitutionA = function(p) {
    return e[p.charCodeAt(0)] !== void 0;
  }, s = r.__arabicParser__.isArabicLetter = function(p) {
    return typeof p == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(p);
  }, a = r.__arabicParser__.isArabicEndLetter = function(p) {
    return s(p) && i(p) && e[p.charCodeAt(0)].length <= 2;
  }, o = r.__arabicParser__.isArabicAlfLetter = function(p) {
    return s(p) && n.indexOf(p.charCodeAt(0)) >= 0;
  };
  r.__arabicParser__.arabicLetterHasIsolatedForm = function(p) {
    return s(p) && i(p) && e[p.charCodeAt(0)].length >= 1;
  };
  var l = r.__arabicParser__.arabicLetterHasFinalForm = function(p) {
    return s(p) && i(p) && e[p.charCodeAt(0)].length >= 2;
  };
  r.__arabicParser__.arabicLetterHasInitialForm = function(p) {
    return s(p) && i(p) && e[p.charCodeAt(0)].length >= 3;
  };
  var u = r.__arabicParser__.arabicLetterHasMedialForm = function(p) {
    return s(p) && i(p) && e[p.charCodeAt(0)].length == 4;
  }, c = r.__arabicParser__.resolveLigatures = function(p) {
    var v = 0, w = t, b = "", S = 0;
    for (v = 0; v < p.length; v += 1) w[p.charCodeAt(v)] !== void 0 ? (S++, typeof (w = w[p.charCodeAt(v)]) == "number" && (b += String.fromCharCode(w), w = t, S = 0), v === p.length - 1 && (w = t, b += p.charAt(v - (S - 1)), v -= S - 1, S = 0)) : (w = t, b += p.charAt(v - S), v -= S, S = 0);
    return b;
  };
  r.__arabicParser__.isArabicDiacritic = function(p) {
    return p !== void 0 && A[p.charCodeAt(0)] !== void 0;
  };
  var f = r.__arabicParser__.getCorrectForm = function(p, v, w) {
    return s(p) ? i(p) === !1 ? -1 : !l(p) || !s(v) && !s(w) || !s(w) && a(v) || a(p) && !s(v) || a(p) && o(v) || a(p) && a(v) ? 0 : u(p) && s(v) && !a(v) && s(w) && l(w) ? 3 : a(p) || !s(w) ? 1 : 2 : -1;
  }, h = function(p) {
    var v = 0, w = 0, b = 0, S = "", B = "", x = "", U = (p = p || "").split("\\s+"), Q = [];
    for (v = 0; v < U.length; v += 1) {
      for (Q.push(""), w = 0; w < U[v].length; w += 1) S = U[v][w], B = U[v][w - 1], x = U[v][w + 1], s(S) ? (b = f(S, B, x), Q[v] += b !== -1 ? String.fromCharCode(e[S.charCodeAt(0)][b]) : S) : Q[v] += S;
      Q[v] = c(Q[v]);
    }
    return Q.join(" ");
  }, g = r.__arabicParser__.processArabic = r.processArabic = function() {
    var p, v = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, w = [];
    if (Array.isArray(v)) {
      var b = 0;
      for (w = [], b = 0; b < v.length; b += 1) Array.isArray(v[b]) ? w.push([h(v[b][0]), v[b][1], v[b][2]]) : w.push([h(v[b])]);
      p = w;
    } else p = h(v);
    return typeof arguments[0] == "string" ? p : (arguments[0].text = p, arguments[0]);
  };
  r.events.push(["preProcessText", g]);
})(ot.API), ot.API.autoPrint = function(r) {
  var e;
  return (r = r || {}).variant = r.variant || "non-conform", r.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    this.internal.out("/OpenAction " + e + " 0 R");
  })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function() {
    var t = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return t;
    }, set: function(a) {
      t = a;
    } });
    var A = 150;
    Object.defineProperty(this, "width", { get: function() {
      return A;
    }, set: function(a) {
      A = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 150 : a, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = A + 1);
    } });
    var n = 300;
    Object.defineProperty(this, "height", { get: function() {
      return n;
    }, set: function(a) {
      n = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 300 : a, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
    } });
    var i = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return i;
    }, set: function(a) {
      i = a;
    } });
    var s = {};
    Object.defineProperty(this, "style", { get: function() {
      return s;
    }, set: function(a) {
      s = a;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  e.prototype.getContext = function(t, A) {
    var n;
    if ((t = t || "2d") !== "2d") return null;
    for (n in A) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = A[n]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, e.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, r.events.push(["initialized", function() {
    this.canvas = new e(), this.canvas.pdf = this;
  }]);
})(ot.API), (function(r) {
  var e = { left: 0, top: 0, bottom: 0, right: 0 }, t = !1, A = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, e), this.internal.__cell__.margins.width = this.getPageWidth(), n.call(this));
  }, n = function() {
    this.internal.__cell__.lastCell = new i(), this.internal.__cell__.pages = 1;
  }, i = function() {
    var o = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return o;
    }, set: function(p) {
      o = p;
    } });
    var l = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return l;
    }, set: function(p) {
      l = p;
    } });
    var u = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return u;
    }, set: function(p) {
      u = p;
    } });
    var c = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return c;
    }, set: function(p) {
      c = p;
    } });
    var f = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return f;
    }, set: function(p) {
      f = p;
    } });
    var h = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return h;
    }, set: function(p) {
      h = p;
    } });
    var g = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return g;
    }, set: function(p) {
      g = p;
    } }), this;
  };
  i.prototype.clone = function() {
    return new i(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, i.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, r.setHeaderFunction = function(o) {
    return A.call(this), this.internal.__cell__.headerFunction = typeof o == "function" ? o : void 0, this;
  }, r.getTextDimensions = function(o, l) {
    A.call(this);
    var u = (l = l || {}).fontSize || this.getFontSize(), c = l.font || this.getFont(), f = l.scaleFactor || this.internal.scaleFactor, h = 0, g = 0, p = 0, v = this;
    if (!Array.isArray(o) && typeof o != "string") {
      if (typeof o != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      o = String(o);
    }
    var w = l.maxWidth;
    w > 0 ? typeof o == "string" ? o = this.splitTextToSize(o, w) : Object.prototype.toString.call(o) === "[object Array]" && (o = o.reduce(function(S, B) {
      return S.concat(v.splitTextToSize(B, w));
    }, [])) : o = Array.isArray(o) ? o : [o];
    for (var b = 0; b < o.length; b++) h < (p = this.getStringUnitWidth(o[b], { font: c }) * u) && (h = p);
    return h !== 0 && (g = o.length), { w: h /= f, h: Math.max((g * u * this.getLineHeightFactor() - u * (this.getLineHeightFactor() - 1)) / f, 0) };
  }, r.cellAddPage = function() {
    A.call(this), this.addPage();
    var o = this.internal.__cell__.margins || e;
    return this.internal.__cell__.lastCell = new i(o.left, o.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var s = r.cell = function() {
    var o;
    o = arguments[0] instanceof i ? arguments[0] : new i(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), A.call(this);
    var l = this.internal.__cell__.lastCell, u = this.internal.__cell__.padding, c = this.internal.__cell__.margins || e, f = this.internal.__cell__.tableHeaderRow, h = this.internal.__cell__.printHeaders;
    return l.lineNumber !== void 0 && (l.lineNumber === o.lineNumber ? (o.x = (l.x || 0) + (l.width || 0), o.y = l.y || 0) : l.y + l.height + o.height + c.bottom > this.getPageHeight() ? (this.cellAddPage(), o.y = c.top, h && f && (this.printHeaderRow(o.lineNumber, !0), o.y += f[0].height)) : o.y = l.y + l.height || o.y), o.text[0] !== void 0 && (this.rect(o.x, o.y, o.width, o.height, t === !0 ? "FD" : void 0), o.align === "right" ? this.text(o.text, o.x + o.width - u, o.y + u, { align: "right", baseline: "top" }) : o.align === "center" ? this.text(o.text, o.x + o.width / 2, o.y + u, { align: "center", baseline: "top", maxWidth: o.width - u - u }) : this.text(o.text, o.x + u, o.y + u, { align: "left", baseline: "top", maxWidth: o.width - u - u })), this.internal.__cell__.lastCell = o, this;
  };
  r.table = function(o, l, u, c, f) {
    if (A.call(this), !u) throw new Error("No data for PDF table.");
    var h, g, p, v, w = [], b = [], S = [], B = {}, x = {}, U = [], Q = [], N = (f = f || {}).autoSize || !1, _ = f.printHeaders !== !1, R = f.css && f.css["font-size"] !== void 0 ? 16 * f.css["font-size"] : f.fontSize || 12, F = f.margins || Object.assign({ width: this.getPageWidth() }, e), O = typeof f.padding == "number" ? f.padding : 3, G = f.headerBackgroundColor || "#c8c8c8", H = f.headerTextColor || "#000";
    if (n.call(this), this.internal.__cell__.printHeaders = _, this.internal.__cell__.margins = F, this.internal.__cell__.table_font_size = R, this.internal.__cell__.padding = O, this.internal.__cell__.headerBackgroundColor = G, this.internal.__cell__.headerTextColor = H, this.setFontSize(R), c == null) b = w = Object.keys(u[0]), S = w.map(function() {
      return "left";
    });
    else if (Array.isArray(c) && Xt(c[0]) === "object") for (w = c.map(function(le) {
      return le.name;
    }), b = c.map(function(le) {
      return le.prompt || le.name || "";
    }), S = c.map(function(le) {
      return le.align || "left";
    }), h = 0; h < c.length; h += 1) x[c[h].name] = 0.7499990551181103 * c[h].width;
    else Array.isArray(c) && typeof c[0] == "string" && (b = w = c, S = w.map(function() {
      return "left";
    }));
    if (N || Array.isArray(c) && typeof c[0] == "string") for (h = 0; h < w.length; h += 1) {
      for (B[v = w[h]] = u.map(function(le) {
        return le[v];
      }), this.setFont(void 0, "bold"), U.push(this.getTextDimensions(b[h], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), g = B[v], this.setFont(void 0, "normal"), p = 0; p < g.length; p += 1) U.push(this.getTextDimensions(g[p], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      x[v] = Math.max.apply(null, U) + O + O, U = [];
    }
    if (_) {
      var $ = {};
      for (h = 0; h < w.length; h += 1) $[w[h]] = {}, $[w[h]].text = b[h], $[w[h]].align = S[h];
      var ne = a.call(this, $, x);
      Q = w.map(function(le) {
        return new i(o, l, x[le], ne, $[le].text, void 0, $[le].align);
      }), this.setTableHeaderRow(Q), this.printHeaderRow(1, !1);
    }
    var te = c.reduce(function(le, se) {
      return le[se.name] = se.align, le;
    }, {});
    for (h = 0; h < u.length; h += 1) {
      "rowStart" in f && f.rowStart instanceof Function && f.rowStart({ row: h, data: u[h] }, this);
      var J = a.call(this, u[h], x);
      for (p = 0; p < w.length; p += 1) {
        var re = u[h][w[p]];
        "cellStart" in f && f.cellStart instanceof Function && f.cellStart({ row: h, col: p, data: re }, this), s.call(this, new i(o, l, x[w[p]], J, re, h + 2, te[w[p]]));
      }
    }
    return this.internal.__cell__.table_x = o, this.internal.__cell__.table_y = l, this;
  };
  var a = function(o, l) {
    var u = this.internal.__cell__.padding, c = this.internal.__cell__.table_font_size, f = this.internal.scaleFactor;
    return Object.keys(o).map(function(h) {
      var g = o[h];
      return this.splitTextToSize(g.hasOwnProperty("text") ? g.text : g, l[h] - u - u);
    }, this).map(function(h) {
      return this.getLineHeightFactor() * h.length * c / f + u + u;
    }, this).reduce(function(h, g) {
      return Math.max(h, g);
    }, 0);
  };
  r.setTableHeaderRow = function(o) {
    A.call(this), this.internal.__cell__.tableHeaderRow = o;
  }, r.printHeaderRow = function(o, l) {
    if (A.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var u;
    if (t = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var c = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new i(c[0], c[1], c[2], c[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var f = [], h = 0; h < this.internal.__cell__.tableHeaderRow.length; h += 1) {
      u = this.internal.__cell__.tableHeaderRow[h].clone(), l && (u.y = this.internal.__cell__.margins.top || 0, f.push(u)), u.lineNumber = o;
      var g = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, u), this.setTextColor(g);
    }
    f.length > 0 && this.setTableHeaderRow(f), this.setFont(void 0, "normal"), t = !1;
  };
})(ot.API);
var $x = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, Jx = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], om = Yx(Jx), Zx = [100, 200, 300, 400, 500, 600, 700, 800, 900], nL = Yx(Zx);
function vd(r) {
  var e = r.family.replace(/"|'/g, "").toLowerCase(), t = (function(i) {
    return $x[i = i || "normal"] ? i : "normal";
  })(r.style), A = (function(i) {
    return i ? typeof i == "number" ? i >= 100 && i <= 900 && i % 100 == 0 ? i : 400 : /^\d00$/.test(i) ? parseInt(i) : i === "bold" ? 700 : 400 : 400;
  })(r.weight), n = (function(i) {
    return typeof om[i = i || "normal"] == "number" ? i : "normal";
  })(r.stretch);
  return { family: e, style: t, weight: A, stretch: n, src: r.src || [], ref: r.ref || { name: e, style: [n, t, A].join(" ") } };
}
function Ww(r, e, t, A) {
  var n;
  for (n = t; n >= 0 && n < e.length; n += A) if (r[e[n]]) return r[e[n]];
  for (n = t; n >= 0 && n < e.length; n -= A) if (r[e[n]]) return r[e[n]];
}
var iL = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, Xw = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function Yw(r) {
  return [r.stretch, r.style, r.weight, r.family].join(" ");
}
function $w(r) {
  return r.trimLeft();
}
function sL(r, e) {
  for (var t = 0; t < r.length; ) {
    if (r.charAt(t) === e) return [r.substring(0, t), r.substring(t + 1)];
    t += 1;
  }
  return null;
}
function aL(r) {
  var e = r.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return e === null ? null : [e[0], r.substring(e[0].length)];
}
var Sc, Jw, Zw, lo, xc, ey, ty, ry, wd = ["times"];
function Ay(r, e, t, A, n) {
  var i = 4, s = iy;
  switch (n) {
    case ot.API.image_compression.FAST:
      i = 1, s = ny;
      break;
    case ot.API.image_compression.MEDIUM:
      i = 6, s = sy;
      break;
    case ot.API.image_compression.SLOW:
      i = 9, s = ay;
  }
  r = (function(o, l, u, c) {
    for (var f, h = o.length / l, g = new Uint8Array(o.length + h), p = [oL, ny, iy, sy, ay], v = 0; v < h; v += 1) {
      var w = v * l, b = o.subarray(w, w + l);
      if (c) g.set(c(b, u, f), w + v);
      else {
        for (var S = p.length, B = [], x = 0; x < S; x += 1) B[x] = p[x](b, u, f);
        var U = uL(B.concat());
        g.set(B[U], w + v);
      }
      f = b;
    }
    return g;
  })(r, e, Math.ceil(t * A / 8), s);
  var a = tm(r, { level: i });
  return ot.API.__addimage__.arrayBufferToBinaryString(a);
}
function oL(r) {
  var e = Array.apply([], r);
  return e.unshift(0), e;
}
function ny(r, e) {
  var t = r.length, A = [];
  A[0] = 1;
  for (var n = 0; n < t; n += 1) {
    var i = r[n - e] || 0;
    A[n + 1] = r[n] - i + 256 & 255;
  }
  return A;
}
function iy(r, e, t) {
  var A = r.length, n = [];
  n[0] = 2;
  for (var i = 0; i < A; i += 1) {
    var s = t && t[i] || 0;
    n[i + 1] = r[i] - s + 256 & 255;
  }
  return n;
}
function sy(r, e, t) {
  var A = r.length, n = [];
  n[0] = 3;
  for (var i = 0; i < A; i += 1) {
    var s = r[i - e] || 0, a = t && t[i] || 0;
    n[i + 1] = r[i] + 256 - (s + a >>> 1) & 255;
  }
  return n;
}
function ay(r, e, t) {
  var A = r.length, n = [];
  n[0] = 4;
  for (var i = 0; i < A; i += 1) {
    var s = lL(r[i - e] || 0, t && t[i] || 0, t && t[i - e] || 0);
    n[i + 1] = r[i] - s + 256 & 255;
  }
  return n;
}
function lL(r, e, t) {
  if (r === e && e === t) return r;
  var A = Math.abs(e - t), n = Math.abs(r - t), i = Math.abs(r + e - t - t);
  return A <= n && A <= i ? r : n <= i ? e : t;
}
function uL(r) {
  var e = r.map(function(t) {
    return t.reduce(function(A, n) {
      return A + Math.abs(n);
    }, 0);
  });
  return e.indexOf(Math.min.apply(null, e));
}
function yd(r, e, t) {
  var A = e * t, n = Math.floor(A / 8), i = 16 - (A - 8 * n + t), s = (1 << t) - 1;
  return e5(r, n) >> i & s;
}
function oy(r, e, t, A) {
  var n = t * A, i = Math.floor(n / 8), s = 16 - (n - 8 * i + A), a = (1 << A) - 1, o = (e & a) << s;
  (function(l, u, c) {
    if (u + 1 < l.byteLength) l.setUint16(u, c, !1);
    else {
      var f = c >> 8 & 255;
      l.setUint8(u, f);
    }
  })(r, i, e5(r, i) & ~(a << s) & 65535 | o);
}
function e5(r, e) {
  return e + 1 < r.byteLength ? r.getUint16(e, !1) : r.getUint8(e) << 8;
}
function cL(r) {
  var e = 0;
  if (r[e++] !== 71 || r[e++] !== 73 || r[e++] !== 70 || r[e++] !== 56 || (r[e++] + 1 & 253) != 56 || r[e++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var t = r[e++] | r[e++] << 8, A = r[e++] | r[e++] << 8, n = r[e++], i = n >> 7, s = 1 << 1 + (7 & n);
  r[e++], r[e++];
  var a = null, o = null;
  i && (a = e, o = s, e += 3 * s);
  var l = !0, u = [], c = 0, f = null, h = 0, g = null;
  for (this.width = t, this.height = A; l && e < r.length; ) switch (r[e++]) {
    case 33:
      switch (r[e++]) {
        case 255:
          if (r[e] !== 11 || r[e + 1] == 78 && r[e + 2] == 69 && r[e + 3] == 84 && r[e + 4] == 83 && r[e + 5] == 67 && r[e + 6] == 65 && r[e + 7] == 80 && r[e + 8] == 69 && r[e + 9] == 50 && r[e + 10] == 46 && r[e + 11] == 48 && r[e + 12] == 3 && r[e + 13] == 1 && r[e + 16] == 0) e += 14, g = r[e++] | r[e++] << 8, e++;
          else for (e += 12; ; ) {
            if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
            if (F === 0) break;
            e += F;
          }
          break;
        case 249:
          if (r[e++] !== 4 || r[e + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var p = r[e++];
          c = r[e++] | r[e++] << 8, f = r[e++], 1 & p || (f = null), h = p >> 2 & 7, e++;
          break;
        case 254:
          for (; ; ) {
            if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
            if (F === 0) break;
            e += F;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + r[e - 1].toString(16));
      }
      break;
    case 44:
      var v = r[e++] | r[e++] << 8, w = r[e++] | r[e++] << 8, b = r[e++] | r[e++] << 8, S = r[e++] | r[e++] << 8, B = r[e++], x = B >> 6 & 1, U = 1 << 1 + (7 & B), Q = a, N = o, _ = !1;
      B >> 7 && (_ = !0, Q = e, N = U, e += 3 * U);
      var R = e;
      for (e++; ; ) {
        var F;
        if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
        if (F === 0) break;
        e += F;
      }
      u.push({ x: v, y: w, width: b, height: S, has_local_palette: _, palette_offset: Q, palette_size: N, data_offset: R, data_length: e - R, transparent_index: f, interlaced: !!x, delay: c, disposal: h });
      break;
    case 59:
      l = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + r[e - 1].toString(16));
  }
  this.numFrames = function() {
    return u.length;
  }, this.loopCount = function() {
    return g;
  }, this.frameInfo = function(O) {
    if (O < 0 || O >= u.length) throw new Error("Frame index out of range.");
    return u[O];
  }, this.decodeAndBlitFrameBGRA = function(O, G) {
    var H = this.frameInfo(O), $ = H.width * H.height, ne = new Uint8Array($);
    ly(r, H.data_offset, ne, $);
    var te = H.palette_offset, J = H.transparent_index;
    J === null && (J = 256);
    var re = H.width, le = t - re, se = re, P = 4 * (H.y * t + H.x), V = 4 * ((H.y + H.height) * t + H.x), X = P, Y = 4 * le;
    H.interlaced === !0 && (Y += 4 * t * 7);
    for (var ee = 8, oe = 0, ge = ne.length; oe < ge; ++oe) {
      var pe = ne[oe];
      if (se === 0 && (se = re, (X += Y) >= V && (Y = 4 * le + 4 * t * (ee - 1), X = P + (re + le) * (ee << 1), ee >>= 1)), pe === J) X += 4;
      else {
        var me = r[te + 3 * pe], Ee = r[te + 3 * pe + 1], Ne = r[te + 3 * pe + 2];
        G[X++] = Ne, G[X++] = Ee, G[X++] = me, G[X++] = 255;
      }
      --se;
    }
  }, this.decodeAndBlitFrameRGBA = function(O, G) {
    var H = this.frameInfo(O), $ = H.width * H.height, ne = new Uint8Array($);
    ly(r, H.data_offset, ne, $);
    var te = H.palette_offset, J = H.transparent_index;
    J === null && (J = 256);
    var re = H.width, le = t - re, se = re, P = 4 * (H.y * t + H.x), V = 4 * ((H.y + H.height) * t + H.x), X = P, Y = 4 * le;
    H.interlaced === !0 && (Y += 4 * t * 7);
    for (var ee = 8, oe = 0, ge = ne.length; oe < ge; ++oe) {
      var pe = ne[oe];
      if (se === 0 && (se = re, (X += Y) >= V && (Y = 4 * le + 4 * t * (ee - 1), X = P + (re + le) * (ee << 1), ee >>= 1)), pe === J) X += 4;
      else {
        var me = r[te + 3 * pe], Ee = r[te + 3 * pe + 1], Ne = r[te + 3 * pe + 2];
        G[X++] = me, G[X++] = Ee, G[X++] = Ne, G[X++] = 255;
      }
      --se;
    }
  };
}
function ly(r, e, t, A) {
  for (var n = r[e++], i = 1 << n, s = i + 1, a = s + 1, o = n + 1, l = (1 << o) - 1, u = 0, c = 0, f = 0, h = r[e++], g = new Int32Array(4096), p = null; ; ) {
    for (; u < 16 && h !== 0; ) c |= r[e++] << u, u += 8, h === 1 ? h = r[e++] : --h;
    if (u < o) break;
    var v = c & l;
    if (c >>= o, u -= o, v !== i) {
      if (v === s) break;
      for (var w = v < a ? v : p, b = 0, S = w; S > i; ) S = g[S] >> 8, ++b;
      var B = S;
      if (f + b + (w !== v ? 1 : 0) > A) return void ur.log("Warning, gif stream longer than expected.");
      t[f++] = B;
      var x = f += b;
      for (w !== v && (t[f++] = B), S = w; b--; ) S = g[S], t[--x] = 255 & S, S >>= 8;
      p !== null && a < 4096 && (g[a++] = p << 8 | B, a >= l + 1 && o < 12 && (++o, l = l << 1 | 1)), p = v;
    } else a = s + 1, l = (1 << (o = n + 1)) - 1, p = null;
  }
  return f !== A && ur.log("Warning, gif stream shorter than expected."), t;
}
function bd(r) {
  var e, t, A, n, i, s = Math.floor, a = new Array(64), o = new Array(64), l = new Array(64), u = new Array(64), c = new Array(65535), f = new Array(65535), h = new Array(64), g = new Array(64), p = [], v = 0, w = 7, b = new Array(64), S = new Array(64), B = new Array(64), x = new Array(256), U = new Array(2048), Q = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], N = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], _ = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], R = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], F = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], O = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], G = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], H = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], $ = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function ne(P, V) {
    for (var X = 0, Y = 0, ee = new Array(), oe = 1; oe <= 16; oe++) {
      for (var ge = 1; ge <= P[oe]; ge++) ee[V[Y]] = [], ee[V[Y]][0] = X, ee[V[Y]][1] = oe, Y++, X++;
      X *= 2;
    }
    return ee;
  }
  function te(P) {
    for (var V = P[0], X = P[1] - 1; X >= 0; ) V & 1 << X && (v |= 1 << w), X--, --w < 0 && (v == 255 ? (J(255), J(0)) : J(v), w = 7, v = 0);
  }
  function J(P) {
    p.push(P);
  }
  function re(P) {
    J(P >> 8 & 255), J(255 & P);
  }
  function le(P, V, X, Y, ee) {
    for (var oe, ge = ee[0], pe = ee[240], me = (function(xe, At) {
      var ke, We, ze, Ce, Oe, Re, Ke, Xe, Ve, dt, je = 0;
      for (Ve = 0; Ve < 8; ++Ve) {
        ke = xe[je], We = xe[je + 1], ze = xe[je + 2], Ce = xe[je + 3], Oe = xe[je + 4], Re = xe[je + 5], Ke = xe[je + 6];
        var Tt = ke + (Xe = xe[je + 7]), Et = ke - Xe, mt = We + Ke, yt = We - Ke, qt = ze + Re, it = ze - Re, zt = Ce + Oe, lt = Ce - Oe, wt = Tt + zt, Zt = Tt - zt, ut = mt + qt, bt = mt - qt;
        xe[je] = wt + ut, xe[je + 4] = wt - ut;
        var Wt = 0.707106781 * (bt + Zt);
        xe[je + 2] = Zt + Wt, xe[je + 6] = Zt - Wt;
        var fr = 0.382683433 * ((wt = lt + it) - (bt = yt + Et)), Er = 0.5411961 * wt + fr, jn = 1.306562965 * bt + fr, cn = 0.707106781 * (ut = it + yt), vt = Et + cn, En = Et - cn;
        xe[je + 5] = En + Er, xe[je + 3] = En - Er, xe[je + 1] = vt + jn, xe[je + 7] = vt - jn, je += 8;
      }
      for (je = 0, Ve = 0; Ve < 8; ++Ve) {
        ke = xe[je], We = xe[je + 8], ze = xe[je + 16], Ce = xe[je + 24], Oe = xe[je + 32], Re = xe[je + 40], Ke = xe[je + 48];
        var Fn = ke + (Xe = xe[je + 56]), ZA = ke - Xe, Fr = We + Ke, ar = We - Ke, Mr = ze + Re, Jr = ze - Re, qn = Ce + Oe, zn = Ce - Oe, Rr = Fn + qn, hn = Fn - qn, en = Fr + Mr, tn = Fr - Mr;
        xe[je] = Rr + en, xe[je + 32] = Rr - en;
        var DA = 0.707106781 * (tn + hn);
        xe[je + 16] = hn + DA, xe[je + 48] = hn - DA;
        var Li = 0.382683433 * ((Rr = zn + Jr) - (tn = ar + ZA)), Je = 0.5411961 * Rr + Li, ie = 1.306562965 * tn + Li, Qe = 0.707106781 * (en = Jr + ar), $e = ZA + Qe, $t = ZA - Qe;
        xe[je + 40] = $t + Je, xe[je + 24] = $t - Je, xe[je + 8] = $e + ie, xe[je + 56] = $e - ie, je++;
      }
      for (Ve = 0; Ve < 64; ++Ve) dt = xe[Ve] * At[Ve], h[Ve] = dt > 0 ? dt + 0.5 | 0 : dt - 0.5 | 0;
      return h;
    })(P, V), Ee = 0; Ee < 64; ++Ee) g[Q[Ee]] = me[Ee];
    var Ne = g[0] - X;
    X = g[0], Ne == 0 ? te(Y[0]) : (te(Y[f[oe = 32767 + Ne]]), te(c[oe]));
    for (var Te = 63; Te > 0 && g[Te] == 0; ) Te--;
    if (Te == 0) return te(ge), X;
    for (var Ge, j = 1; j <= Te; ) {
      for (var Pe = j; g[j] == 0 && j <= Te; ) ++j;
      var ft = j - Pe;
      if (ft >= 16) {
        Ge = ft >> 4;
        for (var tt = 1; tt <= Ge; ++tt) te(pe);
        ft &= 15;
      }
      oe = 32767 + g[j], te(ee[(ft << 4) + f[oe]]), te(c[oe]), j++;
    }
    return Te != 63 && te(ge), X;
  }
  function se(P) {
    P = Math.min(Math.max(P, 1), 100), i != P && ((function(V) {
      for (var X = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], Y = 0; Y < 64; Y++) {
        var ee = s((X[Y] * V + 50) / 100);
        ee = Math.min(Math.max(ee, 1), 255), a[Q[Y]] = ee;
      }
      for (var oe = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], ge = 0; ge < 64; ge++) {
        var pe = s((oe[ge] * V + 50) / 100);
        pe = Math.min(Math.max(pe, 1), 255), o[Q[ge]] = pe;
      }
      for (var me = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], Ee = 0, Ne = 0; Ne < 8; Ne++) for (var Te = 0; Te < 8; Te++) l[Ee] = 1 / (a[Q[Ee]] * me[Ne] * me[Te] * 8), u[Ee] = 1 / (o[Q[Ee]] * me[Ne] * me[Te] * 8), Ee++;
    })(P < 50 ? Math.floor(5e3 / P) : Math.floor(200 - 2 * P)), i = P);
  }
  this.encode = function(P, V) {
    V && se(V), p = new Array(), v = 0, w = 7, re(65496), re(65504), re(16), J(74), J(70), J(73), J(70), J(0), J(1), J(1), J(0), re(1), re(1), J(0), J(0), (function() {
      re(65499), re(132), J(0);
      for (var We = 0; We < 64; We++) J(a[We]);
      J(1);
      for (var ze = 0; ze < 64; ze++) J(o[ze]);
    })(), (function(We, ze) {
      re(65472), re(17), J(8), re(ze), re(We), J(3), J(1), J(17), J(0), J(2), J(17), J(1), J(3), J(17), J(1);
    })(P.width, P.height), (function() {
      re(65476), re(418), J(0);
      for (var We = 0; We < 16; We++) J(N[We + 1]);
      for (var ze = 0; ze <= 11; ze++) J(_[ze]);
      J(16);
      for (var Ce = 0; Ce < 16; Ce++) J(R[Ce + 1]);
      for (var Oe = 0; Oe <= 161; Oe++) J(F[Oe]);
      J(1);
      for (var Re = 0; Re < 16; Re++) J(O[Re + 1]);
      for (var Ke = 0; Ke <= 11; Ke++) J(G[Ke]);
      J(17);
      for (var Xe = 0; Xe < 16; Xe++) J(H[Xe + 1]);
      for (var Ve = 0; Ve <= 161; Ve++) J($[Ve]);
    })(), re(65498), re(12), J(3), J(1), J(0), J(2), J(17), J(3), J(17), J(0), J(63), J(0);
    var X = 0, Y = 0, ee = 0;
    v = 0, w = 7, this.encode.displayName = "_encode_";
    for (var oe, ge, pe, me, Ee, Ne, Te, Ge, j, Pe = P.data, ft = P.width, tt = P.height, xe = 4 * ft, At = 0; At < tt; ) {
      for (oe = 0; oe < xe; ) {
        for (Ee = xe * At + oe, Te = -1, Ge = 0, j = 0; j < 64; j++) Ne = Ee + (Ge = j >> 3) * xe + (Te = 4 * (7 & j)), At + Ge >= tt && (Ne -= xe * (At + 1 + Ge - tt)), oe + Te >= xe && (Ne -= oe + Te - xe + 4), ge = Pe[Ne++], pe = Pe[Ne++], me = Pe[Ne++], b[j] = (U[ge] + U[pe + 256 | 0] + U[me + 512 | 0] >> 16) - 128, S[j] = (U[ge + 768 | 0] + U[pe + 1024 | 0] + U[me + 1280 | 0] >> 16) - 128, B[j] = (U[ge + 1280 | 0] + U[pe + 1536 | 0] + U[me + 1792 | 0] >> 16) - 128;
        X = le(b, l, X, e, A), Y = le(S, u, Y, t, n), ee = le(B, u, ee, t, n), oe += 32;
      }
      At += 8;
    }
    if (w >= 0) {
      var ke = [];
      ke[1] = w + 1, ke[0] = (1 << w + 1) - 1, te(ke);
    }
    return re(65497), new Uint8Array(p);
  }, r = r || 50, (function() {
    for (var P = String.fromCharCode, V = 0; V < 256; V++) x[V] = P(V);
  })(), e = ne(N, _), t = ne(O, G), A = ne(R, F), n = ne(H, $), (function() {
    for (var P = 1, V = 2, X = 1; X <= 15; X++) {
      for (var Y = P; Y < V; Y++) f[32767 + Y] = X, c[32767 + Y] = [], c[32767 + Y][1] = X, c[32767 + Y][0] = Y;
      for (var ee = -(V - 1); ee <= -P; ee++) f[32767 + ee] = X, c[32767 + ee] = [], c[32767 + ee][1] = X, c[32767 + ee][0] = V - 1 + ee;
      P <<= 1, V <<= 1;
    }
  })(), (function() {
    for (var P = 0; P < 256; P++) U[P] = 19595 * P, U[P + 256 | 0] = 38470 * P, U[P + 512 | 0] = 7471 * P + 32768, U[P + 768 | 0] = -11059 * P, U[P + 1024 | 0] = -21709 * P, U[P + 1280 | 0] = 32768 * P + 8421375, U[P + 1536 | 0] = -27439 * P, U[P + 1792 | 0] = -5329 * P;
  })(), se(r);
}
function Zn(r, e) {
  if (this.pos = 0, this.buffer = r, this.datav = new DataView(r.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function uy(r) {
  function e(_) {
    if (!_) throw Error("assert :P");
  }
  function t(_, R, F) {
    for (var O = 0; 4 > O; O++) if (_[R + O] != F.charCodeAt(O)) return !0;
    return !1;
  }
  function A(_, R, F, O, G) {
    for (var H = 0; H < G; H++) _[R + H] = F[O + H];
  }
  function n(_, R, F, O) {
    for (var G = 0; G < O; G++) _[R + G] = F;
  }
  function i(_) {
    return new Int32Array(_);
  }
  function s(_, R) {
    for (var F = [], O = 0; O < _; O++) F.push(new R());
    return F;
  }
  function a(_, R) {
    var F = [];
    return (function O(G, H, $) {
      for (var ne = $[H], te = 0; te < ne && (G.push($.length > H + 1 ? [] : new R()), !($.length < H + 1)); te++) O(G[te], H + 1, $);
    })(F, 0, _), F;
  }
  var o = function() {
    var _ = this;
    function R(d, m) {
      for (var C = 1 << m - 1 >>> 0; d & C; ) C >>>= 1;
      return C ? (d & C - 1) + C : d;
    }
    function F(d, m, C, E, T) {
      e(!(E % C));
      do
        d[m + (E -= C)] = T;
      while (0 < E);
    }
    function O(d, m, C, E, T) {
      if (e(2328 >= T), 512 >= T) var M = i(512);
      else if ((M = i(T)) == null) return 0;
      return (function(k, D, K, q, Ae, de) {
        var z, ae, he = D, ve = 1 << K, fe = i(16), ye = i(16);
        for (e(Ae != 0), e(q != null), e(k != null), e(0 < K), ae = 0; ae < Ae; ++ae) {
          if (15 < q[ae]) return 0;
          ++fe[q[ae]];
        }
        if (fe[0] == Ae) return 0;
        for (ye[1] = 0, z = 1; 15 > z; ++z) {
          if (fe[z] > 1 << z) return 0;
          ye[z + 1] = ye[z] + fe[z];
        }
        for (ae = 0; ae < Ae; ++ae) z = q[ae], 0 < q[ae] && (de[ye[z]++] = ae);
        if (ye[15] == 1) return (q = new G()).g = 0, q.value = de[0], F(k, he, 1, ve, q), ve;
        var Be, Ie = -1, _e = ve - 1, ht = 0, Ze = 1, Qt = 1, st = 1 << K;
        for (ae = 0, z = 1, Ae = 2; z <= K; ++z, Ae <<= 1) {
          if (Ze += Qt <<= 1, 0 > (Qt -= fe[z])) return 0;
          for (; 0 < fe[z]; --fe[z]) (q = new G()).g = z, q.value = de[ae++], F(k, he + ht, Ae, st, q), ht = R(ht, z);
        }
        for (z = K + 1, Ae = 2; 15 >= z; ++z, Ae <<= 1) {
          if (Ze += Qt <<= 1, 0 > (Qt -= fe[z])) return 0;
          for (; 0 < fe[z]; --fe[z]) {
            if (q = new G(), (ht & _e) != Ie) {
              for (he += st, Be = 1 << (Ie = z) - K; 15 > Ie && !(0 >= (Be -= fe[Ie])); ) ++Ie, Be <<= 1;
              ve += st = 1 << (Be = Ie - K), k[D + (Ie = ht & _e)].g = Be + K, k[D + Ie].value = he - D - Ie;
            }
            q.g = z - K, q.value = de[ae++], F(k, he + (ht >> K), Ae, st, q), ht = R(ht, z);
          }
        }
        return Ze != 2 * ye[15] - 1 ? 0 : ve;
      })(d, m, C, E, T, M);
    }
    function G() {
      this.value = this.g = 0;
    }
    function H() {
      this.value = this.g = 0;
    }
    function $() {
      this.G = s(5, G), this.H = i(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = s(da, H);
    }
    function ne(d, m, C, E) {
      e(d != null), e(m != null), e(2147483648 > E), d.Ca = 254, d.I = 0, d.b = -8, d.Ka = 0, d.oa = m, d.pa = C, d.Jd = m, d.Yc = C + E, d.Zc = 4 <= E ? C + E - 4 + 1 : C, ge(d);
    }
    function te(d, m) {
      for (var C = 0; 0 < m--; ) C |= me(d, 128) << m;
      return C;
    }
    function J(d, m) {
      var C = te(d, m);
      return pe(d) ? -C : C;
    }
    function re(d, m, C, E) {
      var T, M = 0;
      for (e(d != null), e(m != null), e(4294967288 > E), d.Sb = E, d.Ra = 0, d.u = 0, d.h = 0, 4 < E && (E = 4), T = 0; T < E; ++T) M += m[C + T] << 8 * T;
      d.Ra = M, d.bb = E, d.oa = m, d.pa = C;
    }
    function le(d) {
      for (; 8 <= d.u && d.bb < d.Sb; ) d.Ra >>>= 8, d.Ra += d.oa[d.pa + d.bb] << vs - 8 >>> 0, ++d.bb, d.u -= 8;
      Y(d) && (d.h = 1, d.u = 0);
    }
    function se(d, m) {
      if (e(0 <= m), !d.h && m <= dn) {
        var C = X(d) & fn[m];
        return d.u += m, le(d), C;
      }
      return d.h = 1, d.u = 0;
    }
    function P() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function V() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function X(d) {
      return d.Ra >>> (d.u & vs - 1) >>> 0;
    }
    function Y(d) {
      return e(d.bb <= d.Sb), d.h || d.bb == d.Sb && d.u > vs;
    }
    function ee(d, m) {
      d.u = m, d.h = Y(d);
    }
    function oe(d) {
      d.u >= Vi && (e(d.u >= Vi), le(d));
    }
    function ge(d) {
      e(d != null && d.oa != null), d.pa < d.Zc ? (d.I = (d.oa[d.pa++] | d.I << 8) >>> 0, d.b += 8) : (e(d != null && d.oa != null), d.pa < d.Yc ? (d.b += 8, d.I = d.oa[d.pa++] | d.I << 8) : d.Ka ? d.b = 0 : (d.I <<= 8, d.b += 8, d.Ka = 1));
    }
    function pe(d) {
      return te(d, 1);
    }
    function me(d, m) {
      var C = d.Ca;
      0 > d.b && ge(d);
      var E = d.b, T = C * m >>> 8, M = (d.I >>> E > T) + 0;
      for (M ? (C -= T, d.I -= T + 1 << E >>> 0) : C = T + 1, E = C, T = 0; 256 <= E; ) T += 8, E >>= 8;
      return E = 7 ^ T + ws[E], d.b -= E, d.Ca = (C << E) - 1, M;
    }
    function Ee(d, m, C) {
      d[m + 0] = C >> 24 & 255, d[m + 1] = C >> 16 & 255, d[m + 2] = C >> 8 & 255, d[m + 3] = 255 & C;
    }
    function Ne(d, m) {
      return d[m + 0] | d[m + 1] << 8;
    }
    function Te(d, m) {
      return Ne(d, m) | d[m + 2] << 16;
    }
    function Ge(d, m) {
      return Ne(d, m) | Ne(d, m + 2) << 16;
    }
    function j(d, m) {
      var C = 1 << m;
      return e(d != null), e(0 < m), d.X = i(C), d.X == null ? 0 : (d.Mb = 32 - m, d.Xa = m, 1);
    }
    function Pe(d, m) {
      e(d != null), e(m != null), e(d.Xa == m.Xa), A(m.X, 0, d.X, 0, 1 << m.Xa);
    }
    function ft() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function tt(d, m, C, E) {
      e(C != null), e(E != null);
      var T = C[0], M = E[0];
      return T == 0 && (T = (d * M + m / 2) / m), M == 0 && (M = (m * T + d / 2) / d), 0 >= T || 0 >= M ? 0 : (C[0] = T, E[0] = M, 1);
    }
    function xe(d, m) {
      return d + (1 << m) - 1 >>> m;
    }
    function At(d, m) {
      return ((4278255360 & d) + (4278255360 & m) >>> 0 & 4278255360) + ((16711935 & d) + (16711935 & m) >>> 0 & 16711935) >>> 0;
    }
    function ke(d, m) {
      _[m] = function(C, E, T, M, k, D, K) {
        var q;
        for (q = 0; q < k; ++q) {
          var Ae = _[d](D[K + q - 1], T, M + q);
          D[K + q] = At(C[E + q], Ae);
        }
      };
    }
    function We() {
      this.ud = this.hd = this.jd = 0;
    }
    function ze(d, m) {
      return ((4278124286 & (d ^ m)) >>> 1) + (d & m) >>> 0;
    }
    function Ce(d) {
      return 0 <= d && 256 > d ? d : 0 > d ? 0 : 255 < d ? 255 : void 0;
    }
    function Oe(d, m) {
      return Ce(d + (d - m + 0.5 >> 1));
    }
    function Re(d, m, C) {
      return Math.abs(m - C) - Math.abs(d - C);
    }
    function Ke(d, m, C, E, T, M, k) {
      for (E = M[k - 1], C = 0; C < T; ++C) M[k + C] = E = At(d[m + C], E);
    }
    function Xe(d, m, C, E, T) {
      var M;
      for (M = 0; M < C; ++M) {
        var k = d[m + M], D = k >> 8 & 255, K = 16711935 & (K = (K = 16711935 & k) + ((D << 16) + D));
        E[T + M] = (4278255360 & k) + K >>> 0;
      }
    }
    function Ve(d, m) {
      m.jd = 255 & d, m.hd = d >> 8 & 255, m.ud = d >> 16 & 255;
    }
    function dt(d, m, C, E, T, M) {
      var k;
      for (k = 0; k < E; ++k) {
        var D = m[C + k], K = D >>> 8, q = D, Ae = 255 & (Ae = (Ae = D >>> 16) + ((d.jd << 24 >> 24) * (K << 24 >> 24) >>> 5));
        q = 255 & (q = (q += (d.hd << 24 >> 24) * (K << 24 >> 24) >>> 5) + ((d.ud << 24 >> 24) * (Ae << 24 >> 24) >>> 5)), T[M + k] = (4278255360 & D) + (Ae << 16) + q;
      }
    }
    function je(d, m, C, E, T) {
      _[m] = function(M, k, D, K, q, Ae, de, z, ae) {
        for (K = de; K < z; ++K) for (de = 0; de < ae; ++de) q[Ae++] = T(D[E(M[k++])]);
      }, _[d] = function(M, k, D, K, q, Ae, de) {
        var z = 8 >> M.b, ae = M.Ea, he = M.K[0], ve = M.w;
        if (8 > z) for (M = (1 << M.b) - 1, ve = (1 << z) - 1; k < D; ++k) {
          var fe, ye = 0;
          for (fe = 0; fe < ae; ++fe) fe & M || (ye = E(K[q++])), Ae[de++] = T(he[ye & ve]), ye >>= z;
        }
        else _["VP8LMapColor" + C](K, q, he, ve, Ae, de, k, D, ae);
      };
    }
    function Tt(d, m, C, E, T) {
      for (C = m + C; m < C; ) {
        var M = d[m++];
        E[T++] = M >> 16 & 255, E[T++] = M >> 8 & 255, E[T++] = 255 & M;
      }
    }
    function Et(d, m, C, E, T) {
      for (C = m + C; m < C; ) {
        var M = d[m++];
        E[T++] = M >> 16 & 255, E[T++] = M >> 8 & 255, E[T++] = 255 & M, E[T++] = M >> 24 & 255;
      }
    }
    function mt(d, m, C, E, T) {
      for (C = m + C; m < C; ) {
        var M = (k = d[m++]) >> 16 & 240 | k >> 12 & 15, k = 240 & k | k >> 28 & 15;
        E[T++] = M, E[T++] = k;
      }
    }
    function yt(d, m, C, E, T) {
      for (C = m + C; m < C; ) {
        var M = (k = d[m++]) >> 16 & 248 | k >> 13 & 7, k = k >> 5 & 224 | k >> 3 & 31;
        E[T++] = M, E[T++] = k;
      }
    }
    function qt(d, m, C, E, T) {
      for (C = m + C; m < C; ) {
        var M = d[m++];
        E[T++] = 255 & M, E[T++] = M >> 8 & 255, E[T++] = M >> 16 & 255;
      }
    }
    function it(d, m, C, E, T, M) {
      if (M == 0) for (C = m + C; m < C; ) Ee(E, ((M = d[m++])[0] >> 24 | M[1] >> 8 & 65280 | M[2] << 8 & 16711680 | M[3] << 24) >>> 0), T += 32;
      else A(E, T, d, m, C);
    }
    function zt(d, m) {
      _[m][0] = _[d + "0"], _[m][1] = _[d + "1"], _[m][2] = _[d + "2"], _[m][3] = _[d + "3"], _[m][4] = _[d + "4"], _[m][5] = _[d + "5"], _[m][6] = _[d + "6"], _[m][7] = _[d + "7"], _[m][8] = _[d + "8"], _[m][9] = _[d + "9"], _[m][10] = _[d + "10"], _[m][11] = _[d + "11"], _[m][12] = _[d + "12"], _[m][13] = _[d + "13"], _[m][14] = _[d + "0"], _[m][15] = _[d + "0"];
    }
    function lt(d) {
      return d == Of || d == Mf || d == nc || d == Rf;
    }
    function wt() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function Zt() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function ut() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new wt(), this.f.kb = new Zt(), this.sd = null;
    }
    function bt() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function Wt() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function fr(d) {
      return alert("todo:WebPSamplerProcessPlane"), d.T;
    }
    function Er(d, m) {
      var C = d.T, E = m.ba.f.RGBA, T = E.eb, M = E.fb + d.ka * E.A, k = Ln[m.ba.S], D = d.y, K = d.O, q = d.f, Ae = d.N, de = d.ea, z = d.W, ae = m.cc, he = m.dc, ve = m.Mc, fe = m.Nc, ye = d.ka, Be = d.ka + d.T, Ie = d.U, _e = Ie + 1 >> 1;
      for (ye == 0 ? k(D, K, null, null, q, Ae, de, z, q, Ae, de, z, T, M, null, null, Ie) : (k(m.ec, m.fc, D, K, ae, he, ve, fe, q, Ae, de, z, T, M - E.A, T, M, Ie), ++C); ye + 2 < Be; ye += 2) ae = q, he = Ae, ve = de, fe = z, Ae += d.Rc, z += d.Rc, M += 2 * E.A, k(D, (K += 2 * d.fa) - d.fa, D, K, ae, he, ve, fe, q, Ae, de, z, T, M - E.A, T, M, Ie);
      return K += d.fa, d.j + Be < d.o ? (A(m.ec, m.fc, D, K, Ie), A(m.cc, m.dc, q, Ae, _e), A(m.Mc, m.Nc, de, z, _e), C--) : 1 & Be || k(D, K, null, null, q, Ae, de, z, q, Ae, de, z, T, M + E.A, null, null, Ie), C;
    }
    function jn(d, m, C) {
      var E = d.F, T = [d.J];
      if (E != null) {
        var M = d.U, k = m.ba.S, D = k == Ac || k == nc;
        m = m.ba.f.RGBA;
        var K = [0], q = d.ka;
        K[0] = d.T, d.Kb && (q == 0 ? --K[0] : (--q, T[0] -= d.width), d.j + d.ka + d.T == d.o && (K[0] = d.o - d.j - q));
        var Ae = m.eb;
        q = m.fb + q * m.A, d = u1(E, T[0], d.width, M, K, Ae, q + (D ? 0 : 3), m.A), e(C == K), d && lt(k) && cl(Ae, q, D, M, K, m.A);
      }
      return 0;
    }
    function cn(d) {
      var m = d.ma, C = m.ba.S, E = 11 > C, T = C == tc || C == rc || C == Ac || C == Pf || C == 12 || lt(C);
      if (m.memory = null, m.Ib = null, m.Jb = null, m.Nd = null, !Al(m.Oa, d, T ? 11 : 12)) return 0;
      if (T && lt(C) && el(), d.da) alert("todo:use_scaling");
      else {
        if (E) {
          if (m.Ib = fr, d.Kb) {
            if (C = d.U + 1 >> 1, m.memory = i(d.U + 2 * C), m.memory == null) return 0;
            m.ec = m.memory, m.fc = 0, m.cc = m.ec, m.dc = m.fc + d.U, m.Mc = m.cc, m.Nc = m.dc + C, m.Ib = Er, el();
          }
        } else alert("todo:EmitYUV");
        T && (m.Jb = jn, E && Xn());
      }
      if (E && !E1) {
        for (d = 0; 256 > d; ++d) w4[d] = 89858 * (d - 128) + sc >> ic, B4[d] = -22014 * (d - 128) + sc, b4[d] = -45773 * (d - 128), y4[d] = 113618 * (d - 128) + sc >> ic;
        for (d = fl; d < Df; ++d) m = 76283 * (d - 16) + sc >> ic, C4[d - fl] = di(m, 255), S4[d - fl] = di(m + 8 >> 4, 15);
        E1 = 1;
      }
      return 1;
    }
    function vt(d) {
      var m = d.ma, C = d.U, E = d.T;
      return e(!(1 & d.ka)), 0 >= C || 0 >= E ? 0 : (C = m.Ib(d, m), m.Jb != null && m.Jb(d, m, C), m.Dc += C, 1);
    }
    function En(d) {
      d.ma.memory = null;
    }
    function Fn(d, m, C, E) {
      return se(d, 8) != 47 ? 0 : (m[0] = se(d, 14) + 1, C[0] = se(d, 14) + 1, E[0] = se(d, 1), se(d, 3) != 0 ? 0 : !d.h);
    }
    function ZA(d, m) {
      if (4 > d) return d + 1;
      var C = d - 2 >> 1;
      return (2 + (1 & d) << C) + se(m, C) + 1;
    }
    function Fr(d, m) {
      return 120 < m ? m - 120 : 1 <= (C = ((C = i4[m - 1]) >> 4) * d + (8 - (15 & C))) ? C : 1;
      var C;
    }
    function ar(d, m, C) {
      var E = X(C), T = d[m += 255 & E].g - 8;
      return 0 < T && (ee(C, C.u + 8), E = X(C), m += d[m].value, m += E & (1 << T) - 1), ee(C, C.u + d[m].g), d[m].value;
    }
    function Mr(d, m, C) {
      return C.g += d.g, C.value += d.value << m >>> 0, e(8 >= C.g), d.g;
    }
    function Jr(d, m, C) {
      var E = d.xc;
      return e((m = E == 0 ? 0 : d.vc[d.md * (C >> E) + (m >> E)]) < d.Wb), d.Ya[m];
    }
    function qn(d, m, C, E) {
      var T = d.ab, M = d.c * m, k = d.C;
      m = k + m;
      var D = C, K = E;
      for (E = d.Ta, C = d.Ua; 0 < T--; ) {
        var q = d.gc[T], Ae = k, de = m, z = D, ae = K, he = (K = E, D = C, q.Ea);
        switch (e(Ae < de), e(de <= q.nc), q.hc) {
          case 2:
            Hr(z, ae, (de - Ae) * he, K, D);
            break;
          case 0:
            var ve = Ae, fe = de, ye = K, Be = D, Ie = (st = q).Ea;
            ve == 0 && (il(z, ae, null, null, 1, ye, Be), Ke(z, ae + 1, 0, 0, Ie - 1, ye, Be + 1), ae += Ie, Be += Ie, ++ve);
            for (var _e = 1 << st.b, ht = _e - 1, Ze = xe(Ie, st.b), Qt = st.K, st = st.w + (ve >> st.b) * Ze; ve < fe; ) {
              var kt = Qt, cA = st, Lt = 1;
              for (no(z, ae, ye, Be - Ie, 1, ye, Be); Lt < Ie; ) {
                var at = (Lt & ~ht) + _e;
                at > Ie && (at = Ie), (0, al[kt[cA++] >> 8 & 15])(z, ae + +Lt, ye, Be + Lt - Ie, at - Lt, ye, Be + Lt), Lt = at;
              }
              ae += Ie, Be += Ie, ++ve & ht || (st += Ze);
            }
            de != q.nc && A(K, D - he, K, D + (de - Ae - 1) * he, he);
            break;
          case 1:
            for (he = z, fe = ae, Ie = (z = q.Ea) - (Be = z & ~(ye = (ae = 1 << q.b) - 1)), ve = xe(z, q.b), _e = q.K, q = q.w + (Ae >> q.b) * ve; Ae < de; ) {
              for (ht = _e, Ze = q, Qt = new We(), st = fe + Be, kt = fe + z; fe < st; ) Ve(ht[Ze++], Qt), ol(Qt, he, fe, ae, K, D), fe += ae, D += ae;
              fe < kt && (Ve(ht[Ze++], Qt), ol(Qt, he, fe, Ie, K, D), fe += Ie, D += Ie), ++Ae & ye || (q += ve);
            }
            break;
          case 3:
            if (z == K && ae == D && 0 < q.b) {
              for (fe = K, z = he = D + (de - Ae) * he - (Be = (de - Ae) * xe(q.Ea, q.b)), ae = K, ye = D, ve = [], Be = (Ie = Be) - 1; 0 <= Be; --Be) ve[Be] = ae[ye + Be];
              for (Be = Ie - 1; 0 <= Be; --Be) fe[z + Be] = ve[Be];
              $u(q, Ae, de, K, he, K, D);
            } else $u(q, Ae, de, z, ae, K, D);
        }
        D = E, K = C;
      }
      K != C && A(E, C, D, K, M);
    }
    function zn(d, m) {
      var C = d.V, E = d.Ba + d.c * d.C, T = m - d.C;
      if (e(m <= d.l.o), e(16 >= T), 0 < T) {
        var M = d.l, k = d.Ta, D = d.Ua, K = M.width;
        if (qn(d, T, C, E), T = D = [D], e((C = d.C) < (E = m)), e(M.v < M.va), E > M.o && (E = M.o), C < M.j) {
          var q = M.j - C;
          C = M.j, T[0] += q * K;
        }
        if (C >= E ? C = 0 : (T[0] += 4 * M.v, M.ka = C - M.j, M.U = M.va - M.v, M.T = E - C, C = 1), C) {
          if (D = D[0], 11 > (C = d.ca).S) {
            var Ae = C.f.RGBA, de = (E = C.S, T = M.U, M = M.T, q = Ae.eb, Ae.A), z = M;
            for (Ae = Ae.fb + d.Ma * Ae.A; 0 < z--; ) {
              var ae = k, he = D, ve = T, fe = q, ye = Ae;
              switch (E) {
                case ec:
                  ll(ae, he, ve, fe, ye);
                  break;
                case tc:
                  ys(ae, he, ve, fe, ye);
                  break;
                case Of:
                  ys(ae, he, ve, fe, ye), cl(fe, ye, 0, ve, 1, 0);
                  break;
                case m1:
                  ga(ae, he, ve, fe, ye);
                  break;
                case rc:
                  it(ae, he, ve, fe, ye, 1);
                  break;
                case Mf:
                  it(ae, he, ve, fe, ye, 1), cl(fe, ye, 0, ve, 1, 0);
                  break;
                case Ac:
                  it(ae, he, ve, fe, ye, 0);
                  break;
                case nc:
                  it(ae, he, ve, fe, ye, 0), cl(fe, ye, 1, ve, 1, 0);
                  break;
                case Pf:
                  bs(ae, he, ve, fe, ye);
                  break;
                case Rf:
                  bs(ae, he, ve, fe, ye), l1(fe, ye, ve, 1, 0);
                  break;
                case v1:
                  Bs(ae, he, ve, fe, ye);
                  break;
                default:
                  e(0);
              }
              D += K, Ae += de;
            }
            d.Ma += M;
          } else alert("todo:EmitRescaledRowsYUVA");
          e(d.Ma <= C.height);
        }
      }
      d.C = m, e(d.C <= d.i);
    }
    function Rr(d) {
      var m;
      if (0 < d.ua) return 0;
      for (m = 0; m < d.Wb; ++m) {
        var C = d.Ya[m].G, E = d.Ya[m].H;
        if (0 < C[1][E[1] + 0].g || 0 < C[2][E[2] + 0].g || 0 < C[3][E[3] + 0].g) return 0;
      }
      return 1;
    }
    function hn(d, m, C, E, T, M) {
      if (d.Z != 0) {
        var k = d.qd, D = d.rd;
        for (e(xs[d.Z] != null); m < C; ++m) xs[d.Z](k, D, E, T, E, T, M), k = E, D = T, T += M;
        d.qd = k, d.rd = D;
      }
    }
    function en(d, m) {
      var C = d.l.ma, E = C.Z == 0 || C.Z == 1 ? d.l.j : d.C;
      if (E = d.C < E ? E : d.C, e(m <= d.l.o), m > E) {
        var T = d.l.width, M = C.ca, k = C.tb + T * E, D = d.V, K = d.Ba + d.c * E, q = d.gc;
        e(d.ab == 1), e(q[0].hc == 3), vi(q[0], E, m, D, K, M, k), hn(C, E, m, M, k, T);
      }
      d.C = d.Ma = m;
    }
    function tn(d, m, C, E, T, M, k) {
      var D = d.$ / E, K = d.$ % E, q = d.m, Ae = d.s, de = C + d.$, z = de;
      T = C + E * T;
      var ae = C + E * M, he = 280 + Ae.ua, ve = d.Pb ? D : 16777216, fe = 0 < Ae.ua ? Ae.Wa : null, ye = Ae.wc, Be = de < ae ? Jr(Ae, K, D) : null;
      e(d.C < M), e(ae <= T);
      var Ie = !1;
      e: for (; ; ) {
        for (; Ie || de < ae; ) {
          var _e = 0;
          if (D >= ve) {
            var ht = de - C;
            e((ve = d).Pb), ve.wd = ve.m, ve.xd = ht, 0 < ve.s.ua && Pe(ve.s.Wa, ve.s.vb), ve = D + a4;
          }
          if (K & ye || (Be = Jr(Ae, K, D)), e(Be != null), Be.Qb && (m[de] = Be.qb, Ie = !0), !Ie) if (oe(q), Be.jc) {
            _e = q, ht = m;
            var Ze = de, Qt = Be.pd[X(_e) & da - 1];
            e(Be.jc), 256 > Qt.g ? (ee(_e, _e.u + Qt.g), ht[Ze] = Qt.value, _e = 0) : (ee(_e, _e.u + Qt.g - 256), e(256 <= Qt.value), _e = Qt.value), _e == 0 && (Ie = !0);
          } else _e = ar(Be.G[0], Be.H[0], q);
          if (q.h) break;
          if (Ie || 256 > _e) {
            if (!Ie) if (Be.nd) m[de] = (Be.qb | _e << 8) >>> 0;
            else {
              if (oe(q), Ie = ar(Be.G[1], Be.H[1], q), oe(q), ht = ar(Be.G[2], Be.H[2], q), Ze = ar(Be.G[3], Be.H[3], q), q.h) break;
              m[de] = (Ze << 24 | Ie << 16 | _e << 8 | ht) >>> 0;
            }
            if (Ie = !1, ++de, ++K >= E && (K = 0, ++D, k != null && D <= M && !(D % 16) && k(d, D), fe != null)) for (; z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
          } else if (280 > _e) {
            if (_e = ZA(_e - 256, q), ht = ar(Be.G[4], Be.H[4], q), oe(q), ht = Fr(E, ht = ZA(ht, q)), q.h) break;
            if (de - C < ht || T - de < _e) break e;
            for (Ze = 0; Ze < _e; ++Ze) m[de + Ze] = m[de + Ze - ht];
            for (de += _e, K += _e; K >= E; ) K -= E, ++D, k != null && D <= M && !(D % 16) && k(d, D);
            if (e(de <= T), K & ye && (Be = Jr(Ae, K, D)), fe != null) for (; z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
          } else {
            if (!(_e < he)) break e;
            for (Ie = _e - 280, e(fe != null); z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
            _e = de, e(!(Ie >>> (ht = fe).Xa)), m[_e] = ht.X[Ie], Ie = !0;
          }
          Ie || e(q.h == Y(q));
        }
        if (d.Pb && q.h && de < T) e(d.m.h), d.a = 5, d.m = d.wd, d.$ = d.xd, 0 < d.s.ua && Pe(d.s.vb, d.s.Wa);
        else {
          if (q.h) break e;
          k?.(d, D > M ? M : D), d.a = 0, d.$ = de - C;
        }
        return 1;
      }
      return d.a = 3, 0;
    }
    function DA(d) {
      e(d != null), d.vc = null, d.yc = null, d.Ya = null;
      var m = d.Wa;
      m != null && (m.X = null), d.vb = null, e(d != null);
    }
    function Li() {
      var d = new St();
      return d == null ? null : (d.a = 0, d.xb = b1, zt("Predictor", "VP8LPredictors"), zt("Predictor", "VP8LPredictors_C"), zt("PredictorAdd", "VP8LPredictorsAdd"), zt("PredictorAdd", "VP8LPredictorsAdd_C"), Hr = Xe, ol = dt, ll = Tt, ys = Et, bs = mt, Bs = yt, ga = qt, _.VP8LMapColor32b = mi, _.VP8LMapColor8b = sl, d);
    }
    function Je(d, m, C, E, T) {
      var M = 1, k = [d], D = [m], K = E.m, q = E.s, Ae = null, de = 0;
      e: for (; ; ) {
        if (C) for (; M && se(K, 1); ) {
          var z = k, ae = D, he = E, ve = 1, fe = he.m, ye = he.gc[he.ab], Be = se(fe, 2);
          if (he.Oc & 1 << Be) M = 0;
          else {
            switch (he.Oc |= 1 << Be, ye.hc = Be, ye.Ea = z[0], ye.nc = ae[0], ye.K = [null], ++he.ab, e(4 >= he.ab), Be) {
              case 0:
              case 1:
                ye.b = se(fe, 3) + 2, ve = Je(xe(ye.Ea, ye.b), xe(ye.nc, ye.b), 0, he, ye.K), ye.K = ye.K[0];
                break;
              case 3:
                var Ie, _e = se(fe, 8) + 1, ht = 16 < _e ? 0 : 4 < _e ? 1 : 2 < _e ? 2 : 3;
                if (z[0] = xe(ye.Ea, ht), ye.b = ht, Ie = ve = Je(_e, 1, 0, he, ye.K)) {
                  var Ze, Qt = _e, st = ye, kt = 1 << (8 >> st.b), cA = i(kt);
                  if (cA == null) Ie = 0;
                  else {
                    var Lt = st.K[0], at = st.w;
                    for (cA[0] = st.K[0][0], Ze = 1; Ze < 1 * Qt; ++Ze) cA[Ze] = At(Lt[at + Ze], cA[Ze - 1]);
                    for (; Ze < 4 * kt; ++Ze) cA[Ze] = 0;
                    st.K[0] = null, st.K[0] = cA, Ie = 1;
                  }
                }
                ve = Ie;
                break;
              case 2:
                break;
              default:
                e(0);
            }
            M = ve;
          }
        }
        if (k = k[0], D = D[0], M && se(K, 1) && !(M = 1 <= (de = se(K, 4)) && 11 >= de)) {
          E.a = 3;
          break e;
        }
        var He;
        if (He = M) t: {
          var Gr, _t, Dt, vr = E, xA = k, KA = D, Qr = de, LA = C, jA = vr.m, hA = vr.s, Vt = [null], Ar = 1, Lr = 0, nr = s4[Qr];
          r: for (; ; ) {
            if (LA && se(jA, 1)) {
              var EA = se(jA, 3) + 2, $n = xe(xA, EA), Vr = xe(KA, EA), rn = $n * Vr;
              if (!Je($n, Vr, 0, vr, Vt)) break r;
              for (Vt = Vt[0], hA.xc = EA, Gr = 0; Gr < rn; ++Gr) {
                var lr = Vt[Gr] >> 8 & 65535;
                Vt[Gr] = lr, lr >= Ar && (Ar = lr + 1);
              }
            }
            if (jA.h) break r;
            for (_t = 0; 5 > _t; ++_t) {
              var fA = w1[_t];
              !_t && 0 < Qr && (fA += 1 << Qr), Lr < fA && (Lr = fA);
            }
            var pn = s(Ar * nr, G), qA = Ar, mn = s(qA, $);
            if (mn == null) var vn = null;
            else e(65536 >= qA), vn = mn;
            var An = i(Lr);
            if (vn == null || An == null || pn == null) {
              vr.a = 1;
              break r;
            }
            var wn = pn;
            for (Gr = Dt = 0; Gr < Ar; ++Gr) {
              var gr = vn[Gr], yn = gr.G, Jn = gr.H, ma = 0, qi = 1, FA = 0;
              for (_t = 0; 5 > _t; ++_t) {
                fA = w1[_t], yn[_t] = wn, Jn[_t] = Dt, !_t && 0 < Qr && (fA += 1 << Qr);
                n: {
                  var oc, Gf = fA, lc = vr, dl = An, F4 = wn, _4 = Dt, Vf = 0, Es = lc.m, U4 = se(Es, 1);
                  if (n(dl, 0, 0, Gf), U4) {
                    var I4 = se(Es, 1) + 1, Q4 = se(Es, 1), U1 = se(Es, Q4 == 0 ? 1 : 8);
                    dl[U1] = 1, I4 == 2 && (dl[U1 = se(Es, 8)] = 1);
                    var uc = 1;
                  } else {
                    var I1 = i(19), Q1 = se(Es, 4) + 4;
                    if (19 < Q1) {
                      lc.a = 3;
                      var cc = 0;
                      break n;
                    }
                    for (oc = 0; oc < Q1; ++oc) I1[n4[oc]] = se(Es, 3);
                    var Kf = void 0, gl = void 0, L1 = lc, L4 = I1, hc = Gf, N1 = dl, jf = 0, Fs = L1.m, T1 = 8, P1 = s(128, G);
                    A: for (; O(P1, 0, 7, L4, 19); ) {
                      if (se(Fs, 1)) {
                        var N4 = 2 + 2 * se(Fs, 3);
                        if ((Kf = 2 + se(Fs, N4)) > hc) break A;
                      } else Kf = hc;
                      for (gl = 0; gl < hc && Kf--; ) {
                        oe(Fs);
                        var O1 = P1[0 + (127 & X(Fs))];
                        ee(Fs, Fs.u + O1.g);
                        var so = O1.value;
                        if (16 > so) N1[gl++] = so, so != 0 && (T1 = so);
                        else {
                          var T4 = so == 16, M1 = so - 16, P4 = r4[M1], R1 = se(Fs, t4[M1]) + P4;
                          if (gl + R1 > hc) break A;
                          for (var O4 = T4 ? T1 : 0; 0 < R1--; ) N1[gl++] = O4;
                        }
                      }
                      jf = 1;
                      break A;
                    }
                    jf || (L1.a = 3), uc = jf;
                  }
                  (uc = uc && !Es.h) && (Vf = O(F4, _4, 8, dl, Gf)), uc && Vf != 0 ? cc = Vf : (lc.a = 3, cc = 0);
                }
                if (cc == 0) break r;
                if (qi && A4[_t] == 1 && (qi = wn[Dt].g == 0), ma += wn[Dt].g, Dt += cc, 3 >= _t) {
                  var pl, qf = An[0];
                  for (pl = 1; pl < fA; ++pl) An[pl] > qf && (qf = An[pl]);
                  FA += qf;
                }
              }
              if (gr.nd = qi, gr.Qb = 0, qi && (gr.qb = (yn[3][Jn[3] + 0].value << 24 | yn[1][Jn[1] + 0].value << 16 | yn[2][Jn[2] + 0].value) >>> 0, ma == 0 && 256 > yn[0][Jn[0] + 0].value && (gr.Qb = 1, gr.qb += yn[0][Jn[0] + 0].value << 8)), gr.jc = !gr.Qb && 6 > FA, gr.jc) {
                var fc, zi = gr;
                for (fc = 0; fc < da; ++fc) {
                  var _s = fc, Us = zi.pd[_s], dc = zi.G[0][zi.H[0] + _s];
                  256 <= dc.value ? (Us.g = dc.g + 256, Us.value = dc.value) : (Us.g = 0, Us.value = 0, _s >>= Mr(dc, 8, Us), _s >>= Mr(zi.G[1][zi.H[1] + _s], 16, Us), _s >>= Mr(zi.G[2][zi.H[2] + _s], 0, Us), Mr(zi.G[3][zi.H[3] + _s], 24, Us));
                }
              }
            }
            hA.vc = Vt, hA.Wb = Ar, hA.Ya = vn, hA.yc = pn, He = 1;
            break t;
          }
          He = 0;
        }
        if (!(M = He)) {
          E.a = 3;
          break e;
        }
        if (0 < de) {
          if (q.ua = 1 << de, !j(q.Wa, de)) {
            E.a = 1, M = 0;
            break e;
          }
        } else q.ua = 0;
        var zf = E, k1 = k, M4 = D, Wf = zf.s, Xf = Wf.xc;
        if (zf.c = k1, zf.i = M4, Wf.md = xe(k1, Xf), Wf.wc = Xf == 0 ? -1 : (1 << Xf) - 1, C) {
          E.xb = d4;
          break e;
        }
        if ((Ae = i(k * D)) == null) {
          E.a = 1, M = 0;
          break e;
        }
        M = (M = tn(E, Ae, 0, k, D, D, null)) && !K.h;
        break e;
      }
      return M ? (T != null ? T[0] = Ae : (e(Ae == null), e(C)), E.$ = 0, C || DA(q)) : DA(q), M;
    }
    function ie(d, m) {
      var C = d.c * d.i, E = C + m + 16 * m;
      return e(d.c <= m), d.V = i(E), d.V == null ? (d.Ta = null, d.Ua = 0, d.a = 1, 0) : (d.Ta = d.V, d.Ua = d.Ba + C + m, 1);
    }
    function Qe(d, m) {
      var C = d.C, E = m - C, T = d.V, M = d.Ba + d.c * C;
      for (e(m <= d.l.o); 0 < E; ) {
        var k = 16 < E ? 16 : E, D = d.l.ma, K = d.l.width, q = K * k, Ae = D.ca, de = D.tb + K * C, z = d.Ta, ae = d.Ua;
        qn(d, k, T, M), c1(z, ae, Ae, de, q), hn(D, C, C + k, Ae, de, K), E -= k, T += k * d.c, C += k;
      }
      e(C == m), d.C = d.Ma = m;
    }
    function $e() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function $t() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function Zr() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = i(4), this.Lb = i(4);
    }
    function _r() {
      this.Yb = (function() {
        var d = [];
        return (function m(C, E, T) {
          for (var M = T[E], k = 0; k < M && (C.push(T.length > E + 1 ? [] : 0), !(T.length < E + 1)); k++) m(C[k], E + 1, T);
        })(d, 0, [3, 11]), d;
      })();
    }
    function aA() {
      this.jb = i(3), this.Wc = a([4, 8], _r), this.Xc = a([4, 17], _r);
    }
    function GA() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new i(4), this.od = new i(4);
    }
    function mA() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function kr() {
      this.Na = this.la = 0;
    }
    function Aa() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function ds() {
      this.ad = i(384), this.Za = 0, this.Ob = i(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function Ou() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new mA()), this.Y = 0, this.ya = Array(new ds()), this.aa = 0, this.l = new $a();
    }
    function Mu() {
      this.y = i(16), this.f = i(8), this.ea = i(8);
    }
    function Ru() {
      this.cb = this.a = 0, this.sc = "", this.m = new P(), this.Od = new $e(), this.Kc = new $t(), this.ed = new GA(), this.Qa = new Zr(), this.Ic = this.$c = this.Aa = 0, this.D = new Ou(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = s(8, P), this.ia = 0, this.pb = s(4, Aa), this.Pa = new aA(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Mu()), this.Hd = 0, this.rb = Array(new kr()), this.sb = 0, this.wa = Array(new mA()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new ds()), this.L = this.aa = 0, this.gd = a([4, 2], mA), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function di(d, m) {
      return 0 > d ? 0 : d > m ? m : d;
    }
    function $a() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function wf() {
      var d = new Ru();
      return d != null && (d.a = 0, d.sc = "OK", d.cb = 0, d.Xb = 0, hl || (hl = Ja)), d;
    }
    function eA(d, m, C) {
      return d.a == 0 && (d.a = m, d.sc = C, d.cb = 0), 0;
    }
    function ku(d, m, C) {
      return 3 <= C && d[m + 0] == 157 && d[m + 1] == 1 && d[m + 2] == 42;
    }
    function gi(d, m) {
      if (d == null) return 0;
      if (d.a = 0, d.sc = "OK", m == null) return eA(d, 2, "null VP8Io passed to VP8GetHeaders()");
      var C = m.data, E = m.w, T = m.ha;
      if (4 > T) return eA(d, 7, "Truncated header.");
      var M = C[E + 0] | C[E + 1] << 8 | C[E + 2] << 16, k = d.Od;
      if (k.Rb = !(1 & M), k.td = M >> 1 & 7, k.yd = M >> 4 & 1, k.ub = M >> 5, 3 < k.td) return eA(d, 3, "Incorrect keyframe parameters.");
      if (!k.yd) return eA(d, 4, "Frame not displayable.");
      E += 3, T -= 3;
      var D = d.Kc;
      if (k.Rb) {
        if (7 > T) return eA(d, 7, "cannot parse picture header");
        if (!ku(C, E, T)) return eA(d, 3, "Bad code word");
        D.c = 16383 & (C[E + 4] << 8 | C[E + 3]), D.Td = C[E + 4] >> 6, D.i = 16383 & (C[E + 6] << 8 | C[E + 5]), D.Ud = C[E + 6] >> 6, E += 7, T -= 7, d.za = D.c + 15 >> 4, d.Ub = D.i + 15 >> 4, m.width = D.c, m.height = D.i, m.Da = 0, m.j = 0, m.v = 0, m.va = m.width, m.o = m.height, m.da = 0, m.ib = m.width, m.hb = m.height, m.U = m.width, m.T = m.height, n((M = d.Pa).jb, 0, 255, M.jb.length), e((M = d.Qa) != null), M.Cb = 0, M.Bb = 0, M.Fb = 1, n(M.Zb, 0, 0, M.Zb.length), n(M.Lb, 0, 0, M.Lb);
      }
      if (k.ub > T) return eA(d, 7, "bad partition length");
      ne(M = d.m, C, E, k.ub), E += k.ub, T -= k.ub, k.Rb && (D.Ld = pe(M), D.Kd = pe(M)), D = d.Qa;
      var K, q = d.Pa;
      if (e(M != null), e(D != null), D.Cb = pe(M), D.Cb) {
        if (D.Bb = pe(M), pe(M)) {
          for (D.Fb = pe(M), K = 0; 4 > K; ++K) D.Zb[K] = pe(M) ? J(M, 7) : 0;
          for (K = 0; 4 > K; ++K) D.Lb[K] = pe(M) ? J(M, 6) : 0;
        }
        if (D.Bb) for (K = 0; 3 > K; ++K) q.jb[K] = pe(M) ? te(M, 8) : 255;
      } else D.Bb = 0;
      if (M.Ka) return eA(d, 3, "cannot parse segment header");
      if ((D = d.ed).zd = pe(M), D.Tb = te(M, 6), D.wb = te(M, 3), D.Pc = pe(M), D.Pc && pe(M)) {
        for (q = 0; 4 > q; ++q) pe(M) && (D.vd[q] = J(M, 6));
        for (q = 0; 4 > q; ++q) pe(M) && (D.od[q] = J(M, 6));
      }
      if (d.L = D.Tb == 0 ? 0 : D.zd ? 1 : 2, M.Ka) return eA(d, 3, "cannot parse filter header");
      var Ae = T;
      if (T = K = E, E = K + Ae, D = Ae, d.Xb = (1 << te(d.m, 2)) - 1, Ae < 3 * (q = d.Xb)) C = 7;
      else {
        for (K += 3 * q, D -= 3 * q, Ae = 0; Ae < q; ++Ae) {
          var de = C[T + 0] | C[T + 1] << 8 | C[T + 2] << 16;
          de > D && (de = D), ne(d.Jc[+Ae], C, K, de), K += de, D -= de, T += 3;
        }
        ne(d.Jc[+q], C, K, D), C = K < E ? 0 : 5;
      }
      if (C != 0) return eA(d, C, "cannot parse partitions");
      for (C = te(K = d.m, 7), T = pe(K) ? J(K, 4) : 0, E = pe(K) ? J(K, 4) : 0, D = pe(K) ? J(K, 4) : 0, q = pe(K) ? J(K, 4) : 0, K = pe(K) ? J(K, 4) : 0, Ae = d.Qa, de = 0; 4 > de; ++de) {
        if (Ae.Cb) {
          var z = Ae.Zb[de];
          Ae.Fb || (z += C);
        } else {
          if (0 < de) {
            d.pb[de] = d.pb[0];
            continue;
          }
          z = C;
        }
        var ae = d.pb[de];
        ae.Sc[0] = kf[di(z + T, 127)], ae.Sc[1] = Hf[di(z + 0, 127)], ae.Eb[0] = 2 * kf[di(z + E, 127)], ae.Eb[1] = 101581 * Hf[di(z + D, 127)] >> 16, 8 > ae.Eb[1] && (ae.Eb[1] = 8), ae.Qc[0] = kf[di(z + q, 117)], ae.Qc[1] = Hf[di(z + K, 127)], ae.lc = z + K;
      }
      if (!k.Rb) return eA(d, 4, "Not a key frame.");
      for (pe(M), k = d.Pa, C = 0; 4 > C; ++C) {
        for (T = 0; 8 > T; ++T) for (E = 0; 3 > E; ++E) for (D = 0; 11 > D; ++D) q = me(M, h4[C][T][E][D]) ? te(M, 8) : u4[C][T][E][D], k.Wc[C][T].Yb[E][D] = q;
        for (T = 0; 17 > T; ++T) k.Xc[C][T] = k.Wc[C][f4[T]];
      }
      return d.kc = pe(M), d.kc && (d.Bd = te(M, 8)), d.cb = 1;
    }
    function Ja(d, m, C, E, T, M, k) {
      var D = m[T].Yb[C];
      for (C = 0; 16 > T; ++T) {
        if (!me(d, D[C + 0])) return T;
        for (; !me(d, D[C + 1]); ) if (D = m[++T].Yb[0], C = 0, T == 16) return 16;
        var K = m[T + 1].Yb;
        if (me(d, D[C + 2])) {
          var q = d, Ae = 0;
          if (me(q, (z = D)[(de = C) + 3])) if (me(q, z[de + 6])) {
            for (D = 0, de = 2 * (Ae = me(q, z[de + 8])) + (z = me(q, z[de + 9 + Ae])), Ae = 0, z = o4[de]; z[D]; ++D) Ae += Ae + me(q, z[D]);
            Ae += 3 + (8 << de);
          } else me(q, z[de + 7]) ? (Ae = 7 + 2 * me(q, 165), Ae += me(q, 145)) : Ae = 5 + me(q, 159);
          else Ae = me(q, z[de + 4]) ? 3 + me(q, z[de + 5]) : 2;
          D = K[2];
        } else Ae = 1, D = K[1];
        K = k + l4[T], 0 > (q = d).b && ge(q);
        var de, z = q.b, ae = (de = q.Ca >> 1) - (q.I >> z) >> 31;
        --q.b, q.Ca += ae, q.Ca |= 1, q.I -= (de + 1 & ae) << z, M[K] = ((Ae ^ ae) - ae) * E[(0 < T) + 0];
      }
      return 16;
    }
    function Hu(d) {
      var m = d.rb[d.sb - 1];
      m.la = 0, m.Na = 0, n(d.zc, 0, 0, d.zc.length), d.ja = 0;
    }
    function _n(d, m, C, E, T) {
      T = d[m + C + 32 * E] + (T >> 3), d[m + C + 32 * E] = -256 & T ? 0 > T ? 0 : 255 : T;
    }
    function oA(d, m, C, E, T, M) {
      _n(d, m, 0, C, E + T), _n(d, m, 1, C, E + M), _n(d, m, 2, C, E - M), _n(d, m, 3, C, E - T);
    }
    function Ni(d) {
      return (20091 * d >> 16) + d;
    }
    function Du(d, m, C, E) {
      var T, M = 0, k = i(16);
      for (T = 0; 4 > T; ++T) {
        var D = d[m + 0] + d[m + 8], K = d[m + 0] - d[m + 8], q = (35468 * d[m + 4] >> 16) - Ni(d[m + 12]), Ae = Ni(d[m + 4]) + (35468 * d[m + 12] >> 16);
        k[M + 0] = D + Ae, k[M + 1] = K + q, k[M + 2] = K - q, k[M + 3] = D - Ae, M += 4, m++;
      }
      for (T = M = 0; 4 > T; ++T) D = (d = k[M + 0] + 4) + k[M + 8], K = d - k[M + 8], q = (35468 * k[M + 4] >> 16) - Ni(k[M + 12]), _n(C, E, 0, 0, D + (Ae = Ni(k[M + 4]) + (35468 * k[M + 12] >> 16))), _n(C, E, 1, 0, K + q), _n(C, E, 2, 0, K - q), _n(C, E, 3, 0, D - Ae), M++, E += 32;
    }
    function yf(d, m, C, E) {
      var T = d[m + 0] + 4, M = 35468 * d[m + 4] >> 16, k = Ni(d[m + 4]), D = 35468 * d[m + 1] >> 16;
      oA(C, E, 0, T + k, d = Ni(d[m + 1]), D), oA(C, E, 1, T + M, d, D), oA(C, E, 2, T - M, d, D), oA(C, E, 3, T - k, d, D);
    }
    function bf(d, m, C, E, T) {
      Du(d, m, C, E), T && Du(d, m + 16, C, E + 4);
    }
    function pi(d, m, C, E) {
      pa(d, m + 0, C, E, 1), pa(d, m + 32, C, E + 128, 1);
    }
    function Gu(d, m, C, E) {
      var T;
      for (d = d[m + 0] + 4, T = 0; 4 > T; ++T) for (m = 0; 4 > m; ++m) _n(C, E, m, T, d);
    }
    function Vu(d, m, C, E) {
      d[m + 0] && er(d, m + 0, C, E), d[m + 16] && er(d, m + 16, C, E + 4), d[m + 32] && er(d, m + 32, C, E + 128), d[m + 48] && er(d, m + 48, C, E + 128 + 4);
    }
    function Za(d, m, C, E) {
      var T, M = i(16);
      for (T = 0; 4 > T; ++T) {
        var k = d[m + 0 + T] + d[m + 12 + T], D = d[m + 4 + T] + d[m + 8 + T], K = d[m + 4 + T] - d[m + 8 + T], q = d[m + 0 + T] - d[m + 12 + T];
        M[0 + T] = k + D, M[8 + T] = k - D, M[4 + T] = q + K, M[12 + T] = q - K;
      }
      for (T = 0; 4 > T; ++T) k = (d = M[0 + 4 * T] + 3) + M[3 + 4 * T], D = M[1 + 4 * T] + M[2 + 4 * T], K = M[1 + 4 * T] - M[2 + 4 * T], q = d - M[3 + 4 * T], C[E + 0] = k + D >> 3, C[E + 16] = q + K >> 3, C[E + 32] = k - D >> 3, C[E + 48] = q - K >> 3, E += 64;
    }
    function na(d, m, C) {
      var E, T = m - 32, M = gn, k = 255 - d[T - 1];
      for (E = 0; E < C; ++E) {
        var D, K = M, q = k + d[m - 1];
        for (D = 0; D < C; ++D) d[m + D] = K[q + d[T + D]];
        m += 32;
      }
    }
    function Bf(d, m) {
      na(d, m, 4);
    }
    function Cf(d, m) {
      na(d, m, 8);
    }
    function Sf(d, m) {
      na(d, m, 16);
    }
    function qo(d, m) {
      var C;
      for (C = 0; 16 > C; ++C) A(d, m + 32 * C, d, m - 32, 16);
    }
    function Ku(d, m) {
      var C;
      for (C = 16; 0 < C; --C) n(d, m, d[m - 1], 16), m += 32;
    }
    function Wn(d, m, C) {
      var E;
      for (E = 0; 16 > E; ++E) n(m, C + 32 * E, d, 16);
    }
    function xf(d, m) {
      var C, E = 16;
      for (C = 0; 16 > C; ++C) E += d[m - 1 + 32 * C] + d[m + C - 32];
      Wn(E >> 5, d, m);
    }
    function ia(d, m) {
      var C, E = 8;
      for (C = 0; 16 > C; ++C) E += d[m - 1 + 32 * C];
      Wn(E >> 4, d, m);
    }
    function zo(d, m) {
      var C, E = 8;
      for (C = 0; 16 > C; ++C) E += d[m + C - 32];
      Wn(E >> 4, d, m);
    }
    function Ef(d, m) {
      Wn(128, d, m);
    }
    function xt(d, m, C) {
      return d + 2 * m + C + 2 >> 2;
    }
    function Ff(d, m) {
      var C, E = m - 32;
      for (E = new Uint8Array([xt(d[E - 1], d[E + 0], d[E + 1]), xt(d[E + 0], d[E + 1], d[E + 2]), xt(d[E + 1], d[E + 2], d[E + 3]), xt(d[E + 2], d[E + 3], d[E + 4])]), C = 0; 4 > C; ++C) A(d, m + 32 * C, E, 0, E.length);
    }
    function _f(d, m) {
      var C = d[m - 1], E = d[m - 1 + 32], T = d[m - 1 + 64], M = d[m - 1 + 96];
      Ee(d, m + 0, 16843009 * xt(d[m - 1 - 32], C, E)), Ee(d, m + 32, 16843009 * xt(C, E, T)), Ee(d, m + 64, 16843009 * xt(E, T, M)), Ee(d, m + 96, 16843009 * xt(T, M, M));
    }
    function Uf(d, m) {
      var C, E = 4;
      for (C = 0; 4 > C; ++C) E += d[m + C - 32] + d[m - 1 + 32 * C];
      for (E >>= 3, C = 0; 4 > C; ++C) n(d, m + 32 * C, E, 4);
    }
    function Ti(d, m) {
      var C = d[m - 1 + 0], E = d[m - 1 + 32], T = d[m - 1 + 64], M = d[m - 1 - 32], k = d[m + 0 - 32], D = d[m + 1 - 32], K = d[m + 2 - 32], q = d[m + 3 - 32];
      d[m + 0 + 96] = xt(E, T, d[m - 1 + 96]), d[m + 1 + 96] = d[m + 0 + 64] = xt(C, E, T), d[m + 2 + 96] = d[m + 1 + 64] = d[m + 0 + 32] = xt(M, C, E), d[m + 3 + 96] = d[m + 2 + 64] = d[m + 1 + 32] = d[m + 0 + 0] = xt(k, M, C), d[m + 3 + 64] = d[m + 2 + 32] = d[m + 1 + 0] = xt(D, k, M), d[m + 3 + 32] = d[m + 2 + 0] = xt(K, D, k), d[m + 3 + 0] = xt(q, K, D);
    }
    function Pi(d, m) {
      var C = d[m + 1 - 32], E = d[m + 2 - 32], T = d[m + 3 - 32], M = d[m + 4 - 32], k = d[m + 5 - 32], D = d[m + 6 - 32], K = d[m + 7 - 32];
      d[m + 0 + 0] = xt(d[m + 0 - 32], C, E), d[m + 1 + 0] = d[m + 0 + 32] = xt(C, E, T), d[m + 2 + 0] = d[m + 1 + 32] = d[m + 0 + 64] = xt(E, T, M), d[m + 3 + 0] = d[m + 2 + 32] = d[m + 1 + 64] = d[m + 0 + 96] = xt(T, M, k), d[m + 3 + 32] = d[m + 2 + 64] = d[m + 1 + 96] = xt(M, k, D), d[m + 3 + 64] = d[m + 2 + 96] = xt(k, D, K), d[m + 3 + 96] = xt(D, K, K);
    }
    function If(d, m) {
      var C = d[m - 1 + 0], E = d[m - 1 + 32], T = d[m - 1 + 64], M = d[m - 1 - 32], k = d[m + 0 - 32], D = d[m + 1 - 32], K = d[m + 2 - 32], q = d[m + 3 - 32];
      d[m + 0 + 0] = d[m + 1 + 64] = M + k + 1 >> 1, d[m + 1 + 0] = d[m + 2 + 64] = k + D + 1 >> 1, d[m + 2 + 0] = d[m + 3 + 64] = D + K + 1 >> 1, d[m + 3 + 0] = K + q + 1 >> 1, d[m + 0 + 96] = xt(T, E, C), d[m + 0 + 64] = xt(E, C, M), d[m + 0 + 32] = d[m + 1 + 96] = xt(C, M, k), d[m + 1 + 32] = d[m + 2 + 96] = xt(M, k, D), d[m + 2 + 32] = d[m + 3 + 96] = xt(k, D, K), d[m + 3 + 32] = xt(D, K, q);
    }
    function Qf(d, m) {
      var C = d[m + 0 - 32], E = d[m + 1 - 32], T = d[m + 2 - 32], M = d[m + 3 - 32], k = d[m + 4 - 32], D = d[m + 5 - 32], K = d[m + 6 - 32], q = d[m + 7 - 32];
      d[m + 0 + 0] = C + E + 1 >> 1, d[m + 1 + 0] = d[m + 0 + 64] = E + T + 1 >> 1, d[m + 2 + 0] = d[m + 1 + 64] = T + M + 1 >> 1, d[m + 3 + 0] = d[m + 2 + 64] = M + k + 1 >> 1, d[m + 0 + 32] = xt(C, E, T), d[m + 1 + 32] = d[m + 0 + 96] = xt(E, T, M), d[m + 2 + 32] = d[m + 1 + 96] = xt(T, M, k), d[m + 3 + 32] = d[m + 2 + 96] = xt(M, k, D), d[m + 3 + 64] = xt(k, D, K), d[m + 3 + 96] = xt(D, K, q);
    }
    function eo(d, m) {
      var C = d[m - 1 + 0], E = d[m - 1 + 32], T = d[m - 1 + 64], M = d[m - 1 + 96];
      d[m + 0 + 0] = C + E + 1 >> 1, d[m + 2 + 0] = d[m + 0 + 32] = E + T + 1 >> 1, d[m + 2 + 32] = d[m + 0 + 64] = T + M + 1 >> 1, d[m + 1 + 0] = xt(C, E, T), d[m + 3 + 0] = d[m + 1 + 32] = xt(E, T, M), d[m + 3 + 32] = d[m + 1 + 64] = xt(T, M, M), d[m + 3 + 64] = d[m + 2 + 64] = d[m + 0 + 96] = d[m + 1 + 96] = d[m + 2 + 96] = d[m + 3 + 96] = M;
    }
    function Wo(d, m) {
      var C = d[m - 1 + 0], E = d[m - 1 + 32], T = d[m - 1 + 64], M = d[m - 1 + 96], k = d[m - 1 - 32], D = d[m + 0 - 32], K = d[m + 1 - 32], q = d[m + 2 - 32];
      d[m + 0 + 0] = d[m + 2 + 32] = C + k + 1 >> 1, d[m + 0 + 32] = d[m + 2 + 64] = E + C + 1 >> 1, d[m + 0 + 64] = d[m + 2 + 96] = T + E + 1 >> 1, d[m + 0 + 96] = M + T + 1 >> 1, d[m + 3 + 0] = xt(D, K, q), d[m + 2 + 0] = xt(k, D, K), d[m + 1 + 0] = d[m + 3 + 32] = xt(C, k, D), d[m + 1 + 32] = d[m + 3 + 64] = xt(E, C, k), d[m + 1 + 64] = d[m + 3 + 96] = xt(T, E, C), d[m + 1 + 96] = xt(M, T, E);
    }
    function sa(d, m) {
      var C;
      for (C = 0; 8 > C; ++C) A(d, m + 32 * C, d, m - 32, 8);
    }
    function Lf(d, m) {
      var C;
      for (C = 0; 8 > C; ++C) n(d, m, d[m - 1], 8), m += 32;
    }
    function Oi(d, m, C) {
      var E;
      for (E = 0; 8 > E; ++E) n(m, C + 32 * E, d, 8);
    }
    function Nf(d, m) {
      var C, E = 8;
      for (C = 0; 8 > C; ++C) E += d[m + C - 32] + d[m - 1 + 32 * C];
      Oi(E >> 4, d, m);
    }
    function Xo(d, m) {
      var C, E = 4;
      for (C = 0; 8 > C; ++C) E += d[m + C - 32];
      Oi(E >> 3, d, m);
    }
    function Yo(d, m) {
      var C, E = 4;
      for (C = 0; 8 > C; ++C) E += d[m - 1 + 32 * C];
      Oi(E >> 3, d, m);
    }
    function ju(d, m) {
      Oi(128, d, m);
    }
    function Mi(d, m, C) {
      var E = d[m - C], T = d[m + 0], M = 3 * (T - E) + Tf[1020 + d[m - 2 * C] - d[m + C]], k = Zu[112 + (M + 4 >> 3)];
      d[m - C] = gn[255 + E + Zu[112 + (M + 3 >> 3)]], d[m + 0] = gn[255 + T - k];
    }
    function $o(d, m, C, E) {
      var T = d[m + 0], M = d[m + C];
      return Qn[255 + d[m - 2 * C] - d[m - C]] > E || Qn[255 + M - T] > E;
    }
    function to(d, m, C, E) {
      return 4 * Qn[255 + d[m - C] - d[m + 0]] + Qn[255 + d[m - 2 * C] - d[m + C]] <= E;
    }
    function Jo(d, m, C, E, T) {
      var M = d[m - 3 * C], k = d[m - 2 * C], D = d[m - C], K = d[m + 0], q = d[m + C], Ae = d[m + 2 * C], de = d[m + 3 * C];
      return 4 * Qn[255 + D - K] + Qn[255 + k - q] > E ? 0 : Qn[255 + d[m - 4 * C] - M] <= T && Qn[255 + M - k] <= T && Qn[255 + k - D] <= T && Qn[255 + de - Ae] <= T && Qn[255 + Ae - q] <= T && Qn[255 + q - K] <= T;
    }
    function aa(d, m, C, E) {
      var T = 2 * E + 1;
      for (E = 0; 16 > E; ++E) to(d, m + E, C, T) && Mi(d, m + E, C);
    }
    function Zo(d, m, C, E) {
      var T = 2 * E + 1;
      for (E = 0; 16 > E; ++E) to(d, m + E * C, 1, T) && Mi(d, m + E * C, 1);
    }
    function qu(d, m, C, E) {
      var T;
      for (T = 3; 0 < T; --T) aa(d, m += 4 * C, C, E);
    }
    function zu(d, m, C, E) {
      var T;
      for (T = 3; 0 < T; --T) Zo(d, m += 4, C, E);
    }
    function Ri(d, m, C, E, T, M, k, D) {
      for (M = 2 * M + 1; 0 < T--; ) {
        if (Jo(d, m, C, M, k)) if ($o(d, m, C, D)) Mi(d, m, C);
        else {
          var K = d, q = m, Ae = C, de = K[q - 2 * Ae], z = K[q - Ae], ae = K[q + 0], he = K[q + Ae], ve = K[q + 2 * Ae], fe = 27 * (Be = Tf[1020 + 3 * (ae - z) + Tf[1020 + de - he]]) + 63 >> 7, ye = 18 * Be + 63 >> 7, Be = 9 * Be + 63 >> 7;
          K[q - 3 * Ae] = gn[255 + K[q - 3 * Ae] + Be], K[q - 2 * Ae] = gn[255 + de + ye], K[q - Ae] = gn[255 + z + fe], K[q + 0] = gn[255 + ae - fe], K[q + Ae] = gn[255 + he - ye], K[q + 2 * Ae] = gn[255 + ve - Be];
        }
        m += E;
      }
    }
    function ki(d, m, C, E, T, M, k, D) {
      for (M = 2 * M + 1; 0 < T--; ) {
        if (Jo(d, m, C, M, k)) if ($o(d, m, C, D)) Mi(d, m, C);
        else {
          var K = d, q = m, Ae = C, de = K[q - Ae], z = K[q + 0], ae = K[q + Ae], he = Zu[112 + (4 + (ve = 3 * (z - de)) >> 3)], ve = Zu[112 + (ve + 3 >> 3)], fe = he + 1 >> 1;
          K[q - 2 * Ae] = gn[255 + K[q - 2 * Ae] + fe], K[q - Ae] = gn[255 + de + ve], K[q + 0] = gn[255 + z - he], K[q + Ae] = gn[255 + ae - fe];
        }
        m += E;
      }
    }
    function Wu(d, m, C, E, T, M) {
      Ri(d, m, C, 1, 16, E, T, M);
    }
    function oa(d, m, C, E, T, M) {
      Ri(d, m, 1, C, 16, E, T, M);
    }
    function Xu(d, m, C, E, T, M) {
      var k;
      for (k = 3; 0 < k; --k) ki(d, m += 4 * C, C, 1, 16, E, T, M);
    }
    function y(d, m, C, E, T, M) {
      var k;
      for (k = 3; 0 < k; --k) ki(d, m += 4, 1, C, 16, E, T, M);
    }
    function L(d, m, C, E, T, M, k, D) {
      Ri(d, m, T, 1, 8, M, k, D), Ri(C, E, T, 1, 8, M, k, D);
    }
    function W(d, m, C, E, T, M, k, D) {
      Ri(d, m, 1, T, 8, M, k, D), Ri(C, E, 1, T, 8, M, k, D);
    }
    function Z(d, m, C, E, T, M, k, D) {
      ki(d, m + 4 * T, T, 1, 8, M, k, D), ki(C, E + 4 * T, T, 1, 8, M, k, D);
    }
    function ce(d, m, C, E, T, M, k, D) {
      ki(d, m + 4, 1, T, 8, M, k, D), ki(C, E + 4, 1, T, 8, M, k, D);
    }
    function be() {
      this.ba = new ut(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new Wt(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Fe() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function nt() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function ct() {
      this.ua = 0, this.Wa = new ft(), this.vb = new ft(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new $(), this.yc = new G();
    }
    function St() {
      this.xb = this.a = 0, this.l = new $a(), this.ca = new ut(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new V(), this.Pb = 0, this.wd = new V(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ct(), this.ab = 0, this.gc = s(4, nt), this.Oc = 0;
    }
    function It() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new $a(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function Gt(d, m, C, E, T, M, k) {
      for (d = d == null ? 0 : d[m + 0], m = 0; m < k; ++m) T[M + m] = d + C[E + m] & 255, d = T[M + m];
    }
    function Ur(d, m, C, E, T, M, k) {
      var D;
      if (d == null) Gt(null, null, C, E, T, M, k);
      else for (D = 0; D < k; ++D) T[M + D] = d[m + D] + C[E + D] & 255;
    }
    function tA(d, m, C, E, T, M, k) {
      if (d == null) Gt(null, null, C, E, T, M, k);
      else {
        var D, K = d[m + 0], q = K, Ae = K;
        for (D = 0; D < k; ++D) q = Ae + (K = d[m + D]) - q, Ae = C[E + D] + (-256 & q ? 0 > q ? 0 : 255 : q) & 255, q = K, T[M + D] = Ae;
      }
    }
    function dr(d, m, C, E) {
      var T = m.width, M = m.o;
      if (e(d != null && m != null), 0 > C || 0 >= E || C + E > M) return null;
      if (!d.Cc) {
        if (d.ga == null) {
          var k;
          if (d.ga = new It(), (k = d.ga == null) || (k = m.width * m.o, e(d.Gb.length == 0), d.Gb = i(k), d.Uc = 0, d.Gb == null ? k = 0 : (d.mb = d.Gb, d.nb = d.Uc, d.rc = null, k = 1), k = !k), !k) {
            k = d.ga;
            var D = d.Fa, K = d.P, q = d.qc, Ae = d.mb, de = d.nb, z = K + 1, ae = q - 1, he = k.l;
            if (e(D != null && Ae != null && m != null), xs[0] = null, xs[1] = Gt, xs[2] = Ur, xs[3] = tA, k.ca = Ae, k.tb = de, k.c = m.width, k.i = m.height, e(0 < k.c && 0 < k.i), 1 >= q) m = 0;
            else if (k.$a = 3 & D[K + 0], k.Z = D[K + 0] >> 2 & 3, k.Lc = D[K + 0] >> 4 & 3, K = D[K + 0] >> 6 & 3, 0 > k.$a || 1 < k.$a || 4 <= k.Z || 1 < k.Lc || K) m = 0;
            else if (he.put = vt, he.ac = cn, he.bc = En, he.ma = k, he.width = m.width, he.height = m.height, he.Da = m.Da, he.v = m.v, he.va = m.va, he.j = m.j, he.o = m.o, k.$a) e: {
              e(k.$a == 1), m = Li();
              t: for (; ; ) {
                if (m == null) {
                  m = 0;
                  break e;
                }
                if (e(k != null), k.mc = m, m.c = k.c, m.i = k.i, m.l = k.l, m.l.ma = k, m.l.width = k.c, m.l.height = k.i, m.a = 0, re(m.m, D, z, ae), !Je(k.c, k.i, 1, m, null) || (m.ab == 1 && m.gc[0].hc == 3 && Rr(m.s) ? (k.ic = 1, D = m.c * m.i, m.Ta = null, m.Ua = 0, m.V = i(D), m.Ba = 0, m.V == null ? (m.a = 1, m = 0) : m = 1) : (k.ic = 0, m = ie(m, k.c)), !m)) break t;
                m = 1;
                break e;
              }
              k.mc = null, m = 0;
            }
            else m = ae >= k.c * k.i;
            k = !m;
          }
          if (k) return null;
          d.ga.Lc != 1 ? d.Ga = 0 : E = M - C;
        }
        e(d.ga != null), e(C + E <= M);
        e: {
          if (m = (D = d.ga).c, M = D.l.o, D.$a == 0) {
            if (z = d.rc, ae = d.Vc, he = d.Fa, K = d.P + 1 + C * m, q = d.mb, Ae = d.nb + C * m, e(K <= d.P + d.qc), D.Z != 0) for (e(xs[D.Z] != null), k = 0; k < E; ++k) xs[D.Z](z, ae, he, K, q, Ae, m), z = q, ae = Ae, Ae += m, K += m;
            else for (k = 0; k < E; ++k) A(q, Ae, he, K, m), z = q, ae = Ae, Ae += m, K += m;
            d.rc = z, d.Vc = ae;
          } else {
            if (e(D.mc != null), m = C + E, e((k = D.mc) != null), e(m <= k.i), k.C >= m) m = 1;
            else if (D.ic || Xn(), D.ic) {
              D = k.V, z = k.Ba, ae = k.c;
              var ve = k.i, fe = (he = 1, K = k.$ / ae, q = k.$ % ae, Ae = k.m, de = k.s, k.$), ye = ae * ve, Be = ae * m, Ie = de.wc, _e = fe < Be ? Jr(de, q, K) : null;
              e(fe <= ye), e(m <= ve), e(Rr(de));
              t: for (; ; ) {
                for (; !Ae.h && fe < Be; ) {
                  if (q & Ie || (_e = Jr(de, q, K)), e(_e != null), oe(Ae), 256 > (ve = ar(_e.G[0], _e.H[0], Ae))) D[z + fe] = ve, ++fe, ++q >= ae && (q = 0, ++K <= m && !(K % 16) && en(k, K));
                  else {
                    if (!(280 > ve)) {
                      he = 0;
                      break t;
                    }
                    ve = ZA(ve - 256, Ae);
                    var ht, Ze = ar(_e.G[4], _e.H[4], Ae);
                    if (oe(Ae), !(fe >= (Ze = Fr(ae, Ze = ZA(Ze, Ae))) && ye - fe >= ve)) {
                      he = 0;
                      break t;
                    }
                    for (ht = 0; ht < ve; ++ht) D[z + fe + ht] = D[z + fe + ht - Ze];
                    for (fe += ve, q += ve; q >= ae; ) q -= ae, ++K <= m && !(K % 16) && en(k, K);
                    fe < Be && q & Ie && (_e = Jr(de, q, K));
                  }
                  e(Ae.h == Y(Ae));
                }
                en(k, K > m ? m : K);
                break t;
              }
              !he || Ae.h && fe < ye ? (he = 0, k.a = Ae.h ? 5 : 3) : k.$ = fe, m = he;
            } else m = tn(k, k.V, k.Ba, k.c, k.i, m, Qe);
            if (!m) {
              E = 0;
              break e;
            }
          }
          C + E >= M && (d.Cc = 1), E = 1;
        }
        if (!E) return null;
        if (d.Cc && ((E = d.ga) != null && (E.mc = null), d.ga = null, 0 < d.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return d.nb + C * T;
    }
    function lA(d, m, C, E, T, M) {
      for (; 0 < T--; ) {
        var k, D = d, K = m + (C ? 1 : 0), q = d, Ae = m + (C ? 0 : 3);
        for (k = 0; k < E; ++k) {
          var de = q[Ae + 4 * k];
          de != 255 && (de *= 32897, D[K + 4 * k + 0] = D[K + 4 * k + 0] * de >> 23, D[K + 4 * k + 1] = D[K + 4 * k + 1] * de >> 23, D[K + 4 * k + 2] = D[K + 4 * k + 2] * de >> 23);
        }
        m += M;
      }
    }
    function rA(d, m, C, E, T) {
      for (; 0 < E--; ) {
        var M;
        for (M = 0; M < C; ++M) {
          var k = d[m + 2 * M + 0], D = 15 & (q = d[m + 2 * M + 1]), K = 4369 * D, q = (240 & q | q >> 4) * K >> 16;
          d[m + 2 * M + 0] = (240 & k | k >> 4) * K >> 16 & 240 | (15 & k | k << 4) * K >> 16 >> 4 & 15, d[m + 2 * M + 1] = 240 & q | D;
        }
        m += T;
      }
    }
    function CA(d, m, C, E, T, M, k, D) {
      var K, q, Ae = 255;
      for (q = 0; q < T; ++q) {
        for (K = 0; K < E; ++K) {
          var de = d[m + K];
          M[k + 4 * K] = de, Ae &= de;
        }
        m += C, k += D;
      }
      return Ae != 255;
    }
    function Hi(d, m, C, E, T) {
      var M;
      for (M = 0; M < T; ++M) C[E + M] = d[m + M] >> 8;
    }
    function Xn() {
      cl = lA, l1 = rA, u1 = CA, c1 = Hi;
    }
    function Di(d, m, C) {
      _[d] = function(E, T, M, k, D, K, q, Ae, de, z, ae, he, ve, fe, ye, Be, Ie) {
        var _e, ht = Ie - 1 >> 1, Ze = D[K + 0] | q[Ae + 0] << 16, Qt = de[z + 0] | ae[he + 0] << 16;
        e(E != null);
        var st = 3 * Ze + Qt + 131074 >> 2;
        for (m(E[T + 0], 255 & st, st >> 16, ve, fe), M != null && (st = 3 * Qt + Ze + 131074 >> 2, m(M[k + 0], 255 & st, st >> 16, ye, Be)), _e = 1; _e <= ht; ++_e) {
          var kt = D[K + _e] | q[Ae + _e] << 16, cA = de[z + _e] | ae[he + _e] << 16, Lt = Ze + kt + Qt + cA + 524296, at = Lt + 2 * (kt + Qt) >> 3;
          st = at + Ze >> 1, Ze = (Lt = Lt + 2 * (Ze + cA) >> 3) + kt >> 1, m(E[T + 2 * _e - 1], 255 & st, st >> 16, ve, fe + (2 * _e - 1) * C), m(E[T + 2 * _e - 0], 255 & Ze, Ze >> 16, ve, fe + (2 * _e - 0) * C), M != null && (st = Lt + Qt >> 1, Ze = at + cA >> 1, m(M[k + 2 * _e - 1], 255 & st, st >> 16, ye, Be + (2 * _e - 1) * C), m(M[k + 2 * _e + 0], 255 & Ze, Ze >> 16, ye, Be + (2 * _e + 0) * C)), Ze = kt, Qt = cA;
        }
        1 & Ie || (st = 3 * Ze + Qt + 131074 >> 2, m(E[T + Ie - 1], 255 & st, st >> 16, ve, fe + (Ie - 1) * C), M != null && (st = 3 * Qt + Ze + 131074 >> 2, m(M[k + Ie - 1], 255 & st, st >> 16, ye, Be + (Ie - 1) * C)));
      };
    }
    function el() {
      Ln[ec] = g4, Ln[tc] = B1, Ln[m1] = p4, Ln[rc] = C1, Ln[Ac] = S1, Ln[Pf] = x1, Ln[v1] = m4, Ln[Of] = B1, Ln[Mf] = C1, Ln[nc] = S1, Ln[Rf] = x1;
    }
    function ro(d) {
      return d & -16384 ? 0 > d ? 0 : 255 : d >> v4;
    }
    function gs(d, m) {
      return ro((19077 * d >> 8) + (26149 * m >> 8) - 14234);
    }
    function la(d, m, C) {
      return ro((19077 * d >> 8) - (6419 * m >> 8) - (13320 * C >> 8) + 8708);
    }
    function ua(d, m) {
      return ro((19077 * d >> 8) + (33050 * m >> 8) - 17685);
    }
    function ps(d, m, C, E, T) {
      E[T + 0] = gs(d, C), E[T + 1] = la(d, m, C), E[T + 2] = ua(d, m);
    }
    function SA(d, m, C, E, T) {
      E[T + 0] = ua(d, m), E[T + 1] = la(d, m, C), E[T + 2] = gs(d, C);
    }
    function ca(d, m, C, E, T) {
      var M = la(d, m, C);
      m = M << 3 & 224 | ua(d, m) >> 3, E[T + 0] = 248 & gs(d, C) | M >> 5, E[T + 1] = m;
    }
    function ha(d, m, C, E, T) {
      var M = 240 & ua(d, m) | 15;
      E[T + 0] = 240 & gs(d, C) | la(d, m, C) >> 4, E[T + 1] = M;
    }
    function tl(d, m, C, E, T) {
      E[T + 0] = 255, ps(d, m, C, E, T + 1);
    }
    function rl(d, m, C, E, T) {
      SA(d, m, C, E, T), E[T + 3] = 255;
    }
    function VA(d, m, C, E, T) {
      ps(d, m, C, E, T), E[T + 3] = 255;
    }
    function Gi(d, m, C) {
      _[d] = function(E, T, M, k, D, K, q, Ae, de) {
        for (var z = Ae + (-2 & de) * C; Ae != z; ) m(E[T + 0], M[k + 0], D[K + 0], q, Ae), m(E[T + 1], M[k + 0], D[K + 0], q, Ae + C), T += 2, ++k, ++K, Ae += 2 * C;
        1 & de && m(E[T + 0], M[k + 0], D[K + 0], q, Ae);
      };
    }
    function Ao(d, m, C) {
      return C == 0 ? d == 0 ? m == 0 ? 6 : 5 : m == 0 ? 4 : 0 : C;
    }
    function Yu(d, m, C, E, T) {
      switch (d >>> 30) {
        case 3:
          pa(m, C, E, T, 0);
          break;
        case 2:
          In(m, C, E, T);
          break;
        case 1:
          er(m, C, E, T);
      }
    }
    function Un(d, m) {
      var C, E, T = m.M, M = m.Nb, k = d.oc, D = d.pc + 40, K = d.oc, q = d.pc + 584, Ae = d.oc, de = d.pc + 600;
      for (C = 0; 16 > C; ++C) k[D + 32 * C - 1] = 129;
      for (C = 0; 8 > C; ++C) K[q + 32 * C - 1] = 129, Ae[de + 32 * C - 1] = 129;
      for (0 < T ? k[D - 1 - 32] = K[q - 1 - 32] = Ae[de - 1 - 32] = 129 : (n(k, D - 32 - 1, 127, 21), n(K, q - 32 - 1, 127, 9), n(Ae, de - 32 - 1, 127, 9)), E = 0; E < d.za; ++E) {
        var z = m.ya[m.aa + E];
        if (0 < E) {
          for (C = -1; 16 > C; ++C) A(k, D + 32 * C - 4, k, D + 32 * C + 12, 4);
          for (C = -1; 8 > C; ++C) A(K, q + 32 * C - 4, K, q + 32 * C + 4, 4), A(Ae, de + 32 * C - 4, Ae, de + 32 * C + 4, 4);
        }
        var ae = d.Gd, he = d.Hd + E, ve = z.ad, fe = z.Hc;
        if (0 < T && (A(k, D - 32, ae[he].y, 0, 16), A(K, q - 32, ae[he].f, 0, 8), A(Ae, de - 32, ae[he].ea, 0, 8)), z.Za) {
          var ye = k, Be = D - 32 + 16;
          for (0 < T && (E >= d.za - 1 ? n(ye, Be, ae[he].y[15], 4) : A(ye, Be, ae[he + 1].y, 0, 4)), C = 0; 4 > C; C++) ye[Be + 128 + C] = ye[Be + 256 + C] = ye[Be + 384 + C] = ye[Be + 0 + C];
          for (C = 0; 16 > C; ++C, fe <<= 2) ye = k, Be = D + F1[C], Yn[z.Ob[C]](ye, Be), Yu(fe, ve, 16 * +C, ye, Be);
        } else if (ye = Ao(E, T, z.Ob[0]), Ss[ye](k, D), fe != 0) for (C = 0; 16 > C; ++C, fe <<= 2) Yu(fe, ve, 16 * +C, k, D + F1[C]);
        for (C = z.Gc, ye = Ao(E, T, z.Dd), ji[ye](K, q), ji[ye](Ae, de), fe = ve, ye = K, Be = q, 255 & (z = 0 | C) && (170 & z ? wi(fe, 256, ye, Be) : or(fe, 256, ye, Be)), z = Ae, fe = de, 255 & (C >>= 8) && (170 & C ? wi(ve, 320, z, fe) : or(ve, 320, z, fe)), T < d.Ub - 1 && (A(ae[he].y, 0, k, D + 480, 16), A(ae[he].f, 0, K, q + 224, 8), A(ae[he].ea, 0, Ae, de + 224, 8)), C = 8 * M * d.B, ae = d.sa, he = d.ta + 16 * E + 16 * M * d.R, ve = d.qa, z = d.ra + 8 * E + C, fe = d.Ha, ye = d.Ia + 8 * E + C, C = 0; 16 > C; ++C) A(ae, he + C * d.R, k, D + 32 * C, 16);
        for (C = 0; 8 > C; ++C) A(ve, z + C * d.B, K, q + 32 * C, 8), A(fe, ye + C * d.B, Ae, de + 32 * C, 8);
      }
    }
    function fa(d, m, C, E, T, M, k, D, K) {
      var q = [0], Ae = [0], de = 0, z = K != null ? K.kd : 0, ae = K ?? new Fe();
      if (d == null || 12 > C) return 7;
      ae.data = d, ae.w = m, ae.ha = C, m = [m], C = [C], ae.gb = [ae.gb];
      e: {
        var he = m, ve = C, fe = ae.gb;
        if (e(d != null), e(ve != null), e(fe != null), fe[0] = 0, 12 <= ve[0] && !t(d, he[0], "RIFF")) {
          if (t(d, he[0] + 8, "WEBP")) {
            fe = 3;
            break e;
          }
          var ye = Ge(d, he[0] + 4);
          if (12 > ye || 4294967286 < ye) {
            fe = 3;
            break e;
          }
          if (z && ye > ve[0] - 8) {
            fe = 7;
            break e;
          }
          fe[0] = ye, he[0] += 12, ve[0] -= 12;
        }
        fe = 0;
      }
      if (fe != 0) return fe;
      for (ye = 0 < ae.gb[0], C = C[0]; ; ) {
        e: {
          var Be = d;
          ve = m, fe = C;
          var Ie = q, _e = Ae, ht = he = [0];
          if ((st = de = [de])[0] = 0, 8 > fe[0]) fe = 7;
          else {
            if (!t(Be, ve[0], "VP8X")) {
              if (Ge(Be, ve[0] + 4) != 10) {
                fe = 3;
                break e;
              }
              if (18 > fe[0]) {
                fe = 7;
                break e;
              }
              var Ze = Ge(Be, ve[0] + 8), Qt = 1 + Te(Be, ve[0] + 12);
              if (2147483648 <= Qt * (Be = 1 + Te(Be, ve[0] + 15))) {
                fe = 3;
                break e;
              }
              ht != null && (ht[0] = Ze), Ie != null && (Ie[0] = Qt), _e != null && (_e[0] = Be), ve[0] += 18, fe[0] -= 18, st[0] = 1;
            }
            fe = 0;
          }
        }
        if (de = de[0], he = he[0], fe != 0) return fe;
        if (ve = !!(2 & he), !ye && de) return 3;
        if (M != null && (M[0] = !!(16 & he)), k != null && (k[0] = ve), D != null && (D[0] = 0), k = q[0], he = Ae[0], de && ve && K == null) {
          fe = 0;
          break;
        }
        if (4 > C) {
          fe = 7;
          break;
        }
        if (ye && de || !ye && !de && !t(d, m[0], "ALPH")) {
          C = [C], ae.na = [ae.na], ae.P = [ae.P], ae.Sa = [ae.Sa];
          e: {
            Ze = d, fe = m, ye = C;
            var st = ae.gb;
            Ie = ae.na, _e = ae.P, ht = ae.Sa, Qt = 22, e(Ze != null), e(ye != null), Be = fe[0];
            var kt = ye[0];
            for (e(Ie != null), e(ht != null), Ie[0] = null, _e[0] = null, ht[0] = 0; ; ) {
              if (fe[0] = Be, ye[0] = kt, 8 > kt) {
                fe = 7;
                break e;
              }
              var cA = Ge(Ze, Be + 4);
              if (4294967286 < cA) {
                fe = 3;
                break e;
              }
              var Lt = 8 + cA + 1 & -2;
              if (Qt += Lt, 0 < st && Qt > st) {
                fe = 3;
                break e;
              }
              if (!t(Ze, Be, "VP8 ") || !t(Ze, Be, "VP8L")) {
                fe = 0;
                break e;
              }
              if (kt[0] < Lt) {
                fe = 7;
                break e;
              }
              t(Ze, Be, "ALPH") || (Ie[0] = Ze, _e[0] = Be + 8, ht[0] = cA), Be += Lt, kt -= Lt;
            }
          }
          if (C = C[0], ae.na = ae.na[0], ae.P = ae.P[0], ae.Sa = ae.Sa[0], fe != 0) break;
        }
        C = [C], ae.Ja = [ae.Ja], ae.xa = [ae.xa];
        e: if (st = d, fe = m, ye = C, Ie = ae.gb[0], _e = ae.Ja, ht = ae.xa, Ze = fe[0], Be = !t(st, Ze, "VP8 "), Qt = !t(st, Ze, "VP8L"), e(st != null), e(ye != null), e(_e != null), e(ht != null), 8 > ye[0]) fe = 7;
        else {
          if (Be || Qt) {
            if (st = Ge(st, Ze + 4), 12 <= Ie && st > Ie - 12) {
              fe = 3;
              break e;
            }
            if (z && st > ye[0] - 8) {
              fe = 7;
              break e;
            }
            _e[0] = st, fe[0] += 8, ye[0] -= 8, ht[0] = Qt;
          } else ht[0] = 5 <= ye[0] && st[Ze + 0] == 47 && !(st[Ze + 4] >> 5), _e[0] = ye[0];
          fe = 0;
        }
        if (C = C[0], ae.Ja = ae.Ja[0], ae.xa = ae.xa[0], m = m[0], fe != 0) break;
        if (4294967286 < ae.Ja) return 3;
        if (D == null || ve || (D[0] = ae.xa ? 2 : 1), k = [k], he = [he], ae.xa) {
          if (5 > C) {
            fe = 7;
            break;
          }
          D = k, z = he, ve = M, d == null || 5 > C ? d = 0 : 5 <= C && d[m + 0] == 47 && !(d[m + 4] >> 5) ? (ye = [0], st = [0], Ie = [0], re(_e = new V(), d, m, C), Fn(_e, ye, st, Ie) ? (D != null && (D[0] = ye[0]), z != null && (z[0] = st[0]), ve != null && (ve[0] = Ie[0]), d = 1) : d = 0) : d = 0;
        } else {
          if (10 > C) {
            fe = 7;
            break;
          }
          D = he, d == null || 10 > C || !ku(d, m + 3, C - 3) ? d = 0 : (z = d[m + 0] | d[m + 1] << 8 | d[m + 2] << 16, ve = 16383 & (d[m + 7] << 8 | d[m + 6]), d = 16383 & (d[m + 9] << 8 | d[m + 8]), 1 & z || 3 < (z >> 1 & 7) || !(z >> 4 & 1) || z >> 5 >= ae.Ja || !ve || !d ? d = 0 : (k && (k[0] = ve), D && (D[0] = d), d = 1));
        }
        if (!d || (k = k[0], he = he[0], de && (q[0] != k || Ae[0] != he))) return 3;
        K != null && (K[0] = ae, K.offset = m - K.w, e(4294967286 > m - K.w), e(K.offset == K.ha - C));
        break;
      }
      return fe == 0 || fe == 7 && de && K == null ? (M != null && (M[0] |= ae.na != null && 0 < ae.na.length), E != null && (E[0] = k), T != null && (T[0] = he), 0) : fe;
    }
    function Al(d, m, C) {
      var E = m.width, T = m.height, M = 0, k = 0, D = E, K = T;
      if (m.Da = d != null && 0 < d.Da, m.Da && (D = d.cd, K = d.bd, M = d.v, k = d.j, 11 > C || (M &= -2, k &= -2), 0 > M || 0 > k || 0 >= D || 0 >= K || M + D > E || k + K > T)) return 0;
      if (m.v = M, m.j = k, m.va = M + D, m.o = k + K, m.U = D, m.T = K, m.da = d != null && 0 < d.da, m.da) {
        if (!tt(D, K, C = [d.ib], M = [d.hb])) return 0;
        m.ib = C[0], m.hb = M[0];
      }
      return m.ob = d != null && d.ob, m.Kb = d == null || !d.Sd, m.da && (m.ob = m.ib < 3 * E / 4 && m.hb < 3 * T / 4, m.Kb = 0), 1;
    }
    function nl(d) {
      if (d == null) return 2;
      if (11 > d.S) {
        var m = d.f.RGBA;
        m.fb += (d.height - 1) * m.A, m.A = -m.A;
      } else m = d.f.kb, d = d.height, m.O += (d - 1) * m.fa, m.fa = -m.fa, m.N += (d - 1 >> 1) * m.Ab, m.Ab = -m.Ab, m.W += (d - 1 >> 1) * m.Db, m.Db = -m.Db, m.F != null && (m.J += (d - 1) * m.lb, m.lb = -m.lb);
      return 0;
    }
    function ms(d, m, C, E) {
      if (E == null || 0 >= d || 0 >= m) return 2;
      if (C != null) {
        if (C.Da) {
          var T = C.cd, M = C.bd, k = -2 & C.v, D = -2 & C.j;
          if (0 > k || 0 > D || 0 >= T || 0 >= M || k + T > d || D + M > m) return 2;
          d = T, m = M;
        }
        if (C.da) {
          if (!tt(d, m, T = [C.ib], M = [C.hb])) return 2;
          d = T[0], m = M[0];
        }
      }
      E.width = d, E.height = m;
      e: {
        var K = E.width, q = E.height;
        if (d = E.S, 0 >= K || 0 >= q || !(d >= ec && 13 > d)) d = 2;
        else {
          if (0 >= E.Rd && E.sd == null) {
            k = M = T = m = 0;
            var Ae = (D = K * _1[d]) * q;
            if (11 > d || (M = (q + 1) / 2 * (m = (K + 1) / 2), d == 12 && (k = (T = K) * q)), (q = i(Ae + 2 * M + k)) == null) {
              d = 1;
              break e;
            }
            E.sd = q, 11 > d ? ((K = E.f.RGBA).eb = q, K.fb = 0, K.A = D, K.size = Ae) : ((K = E.f.kb).y = q, K.O = 0, K.fa = D, K.Fd = Ae, K.f = q, K.N = 0 + Ae, K.Ab = m, K.Cd = M, K.ea = q, K.W = 0 + Ae + M, K.Db = m, K.Ed = M, d == 12 && (K.F = q, K.J = 0 + Ae + 2 * M), K.Tc = k, K.lb = T);
          }
          if (m = 1, T = E.S, M = E.width, k = E.height, T >= ec && 13 > T) if (11 > T) d = E.f.RGBA, m &= (D = Math.abs(d.A)) * (k - 1) + M <= d.size, m &= D >= M * _1[T], m &= d.eb != null;
          else {
            d = E.f.kb, D = (M + 1) / 2, Ae = (k + 1) / 2, K = Math.abs(d.fa), q = Math.abs(d.Ab);
            var de = Math.abs(d.Db), z = Math.abs(d.lb), ae = z * (k - 1) + M;
            m &= K * (k - 1) + M <= d.Fd, m &= q * (Ae - 1) + D <= d.Cd, m = (m &= de * (Ae - 1) + D <= d.Ed) & K >= M & q >= D & de >= D, m &= d.y != null, m &= d.f != null, m &= d.ea != null, T == 12 && (m &= z >= M, m &= ae <= d.Tc, m &= d.F != null);
          }
          else m = 0;
          d = m ? 0 : 2;
        }
      }
      return d != 0 || C != null && C.fd && (d = nl(E)), d;
    }
    var da = 64, fn = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], dn = 24, vs = 32, Vi = 8, ws = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    ke("Predictor0", "PredictorAdd0"), _.Predictor0 = function() {
      return 4278190080;
    }, _.Predictor1 = function(d) {
      return d;
    }, _.Predictor2 = function(d, m, C) {
      return m[C + 0];
    }, _.Predictor3 = function(d, m, C) {
      return m[C + 1];
    }, _.Predictor4 = function(d, m, C) {
      return m[C - 1];
    }, _.Predictor5 = function(d, m, C) {
      return ze(ze(d, m[C + 1]), m[C + 0]);
    }, _.Predictor6 = function(d, m, C) {
      return ze(d, m[C - 1]);
    }, _.Predictor7 = function(d, m, C) {
      return ze(d, m[C + 0]);
    }, _.Predictor8 = function(d, m, C) {
      return ze(m[C - 1], m[C + 0]);
    }, _.Predictor9 = function(d, m, C) {
      return ze(m[C + 0], m[C + 1]);
    }, _.Predictor10 = function(d, m, C) {
      return ze(ze(d, m[C - 1]), ze(m[C + 0], m[C + 1]));
    }, _.Predictor11 = function(d, m, C) {
      var E = m[C + 0];
      return 0 >= Re(E >> 24 & 255, d >> 24 & 255, (m = m[C - 1]) >> 24 & 255) + Re(E >> 16 & 255, d >> 16 & 255, m >> 16 & 255) + Re(E >> 8 & 255, d >> 8 & 255, m >> 8 & 255) + Re(255 & E, 255 & d, 255 & m) ? E : d;
    }, _.Predictor12 = function(d, m, C) {
      var E = m[C + 0];
      return (Ce((d >> 24 & 255) + (E >> 24 & 255) - ((m = m[C - 1]) >> 24 & 255)) << 24 | Ce((d >> 16 & 255) + (E >> 16 & 255) - (m >> 16 & 255)) << 16 | Ce((d >> 8 & 255) + (E >> 8 & 255) - (m >> 8 & 255)) << 8 | Ce((255 & d) + (255 & E) - (255 & m))) >>> 0;
    }, _.Predictor13 = function(d, m, C) {
      var E = m[C - 1];
      return (Oe((d = ze(d, m[C + 0])) >> 24 & 255, E >> 24 & 255) << 24 | Oe(d >> 16 & 255, E >> 16 & 255) << 16 | Oe(d >> 8 & 255, E >> 8 & 255) << 8 | Oe(255 & d, 255 & E)) >>> 0;
    };
    var il = _.PredictorAdd0;
    _.PredictorAdd1 = Ke, ke("Predictor2", "PredictorAdd2"), ke("Predictor3", "PredictorAdd3"), ke("Predictor4", "PredictorAdd4"), ke("Predictor5", "PredictorAdd5"), ke("Predictor6", "PredictorAdd6"), ke("Predictor7", "PredictorAdd7"), ke("Predictor8", "PredictorAdd8"), ke("Predictor9", "PredictorAdd9"), ke("Predictor10", "PredictorAdd10"), ke("Predictor11", "PredictorAdd11"), ke("Predictor12", "PredictorAdd12"), ke("Predictor13", "PredictorAdd13");
    var no = _.PredictorAdd2;
    je("ColorIndexInverseTransform", "MapARGB", "32b", function(d) {
      return d >> 8 & 255;
    }, function(d) {
      return d;
    }), je("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(d) {
      return d;
    }, function(d) {
      return d >> 8 & 255;
    });
    var Hr, $u = _.ColorIndexInverseTransform, mi = _.MapARGB, vi = _.VP8LColorIndexInverseTransformAlpha, sl = _.MapAlpha, al = _.VP8LPredictorsAdd = [];
    al.length = 16, (_.VP8LPredictors = []).length = 16, (_.VP8LPredictorsAdd_C = []).length = 16, (_.VP8LPredictors_C = []).length = 16;
    var ol, ll, ys, bs, Bs, ga, Cs, pa, In, wi, er, or, Dr, uA, Ki, ul, io, Ju, A1, n1, i1, s1, a1, o1, cl, l1, u1, c1, h1 = i(511), f1 = i(2041), d1 = i(225), g1 = i(767), p1 = 0, Tf = f1, Zu = d1, gn = g1, Qn = h1, ec = 0, tc = 1, m1 = 2, rc = 3, Ac = 4, Pf = 5, v1 = 6, Of = 7, Mf = 8, nc = 9, Rf = 10, t4 = [2, 3, 7], r4 = [3, 3, 11], w1 = [280, 256, 256, 256, 40], A4 = [0, 1, 1, 1, 0], n4 = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], i4 = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], s4 = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], a4 = 8, kf = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Hf = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], hl = null, o4 = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], l4 = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], y1 = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], u4 = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], c4 = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], h4 = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], f4 = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], Ss = [], Yn = [], ji = [], d4 = 1, b1 = 2, xs = [], Ln = [];
    Di("UpsampleRgbLinePair", ps, 3), Di("UpsampleBgrLinePair", SA, 3), Di("UpsampleRgbaLinePair", VA, 4), Di("UpsampleBgraLinePair", rl, 4), Di("UpsampleArgbLinePair", tl, 4), Di("UpsampleRgba4444LinePair", ha, 2), Di("UpsampleRgb565LinePair", ca, 2);
    var g4 = _.UpsampleRgbLinePair, p4 = _.UpsampleBgrLinePair, B1 = _.UpsampleRgbaLinePair, C1 = _.UpsampleBgraLinePair, S1 = _.UpsampleArgbLinePair, x1 = _.UpsampleRgba4444LinePair, m4 = _.UpsampleRgb565LinePair, ic = 16, sc = 1 << ic - 1, fl = -227, Df = 482, v4 = 6, E1 = 0, w4 = i(256), y4 = i(256), b4 = i(256), B4 = i(256), C4 = i(Df - fl), S4 = i(Df - fl);
    Gi("YuvToRgbRow", ps, 3), Gi("YuvToBgrRow", SA, 3), Gi("YuvToRgbaRow", VA, 4), Gi("YuvToBgraRow", rl, 4), Gi("YuvToArgbRow", tl, 4), Gi("YuvToRgba4444Row", ha, 2), Gi("YuvToRgb565Row", ca, 2);
    var F1 = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], ac = [0, 2, 8], x4 = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], E4 = 1;
    this.WebPDecodeRGBA = function(d, m, C, E, T) {
      var M = tc, k = new be(), D = new ut();
      k.ba = D, D.S = M, D.width = [D.width], D.height = [D.height];
      var K = D.width, q = D.height, Ae = new bt();
      if (Ae == null || d == null) var de = 2;
      else e(Ae != null), de = fa(d, m, C, Ae.width, Ae.height, Ae.Pd, Ae.Qd, Ae.format, null);
      if (de != 0 ? K = 0 : (K != null && (K[0] = Ae.width[0]), q != null && (q[0] = Ae.height[0]), K = 1), K) {
        D.width = D.width[0], D.height = D.height[0], E != null && (E[0] = D.width), T != null && (T[0] = D.height);
        e: {
          if (E = new $a(), (T = new Fe()).data = d, T.w = m, T.ha = C, T.kd = 1, m = [0], e(T != null), ((d = fa(T.data, T.w, T.ha, null, null, null, m, null, T)) == 0 || d == 7) && m[0] && (d = 4), (m = d) == 0) {
            if (e(k != null), E.data = T.data, E.w = T.w + T.offset, E.ha = T.ha - T.offset, E.put = vt, E.ac = cn, E.bc = En, E.ma = k, T.xa) {
              if ((d = Li()) == null) {
                k = 1;
                break e;
              }
              if ((function(z, ae) {
                var he = [0], ve = [0], fe = [0];
                t: for (; ; ) {
                  if (z == null) return 0;
                  if (ae == null) return z.a = 2, 0;
                  if (z.l = ae, z.a = 0, re(z.m, ae.data, ae.w, ae.ha), !Fn(z.m, he, ve, fe)) {
                    z.a = 3;
                    break t;
                  }
                  if (z.xb = b1, ae.width = he[0], ae.height = ve[0], !Je(he[0], ve[0], 1, z, null)) break t;
                  return 1;
                }
                return e(z.a != 0), 0;
              })(d, E)) {
                if (E = (m = ms(E.width, E.height, k.Oa, k.ba)) == 0) {
                  t: {
                    E = d;
                    r: for (; ; ) {
                      if (E == null) {
                        E = 0;
                        break t;
                      }
                      if (e(E.s.yc != null), e(E.s.Ya != null), e(0 < E.s.Wb), e((C = E.l) != null), e((T = C.ma) != null), E.xb != 0) {
                        if (E.ca = T.ba, E.tb = T.tb, e(E.ca != null), !Al(T.Oa, C, rc)) {
                          E.a = 2;
                          break r;
                        }
                        if (!ie(E, C.width) || C.da) break r;
                        if ((C.da || lt(E.ca.S)) && Xn(), 11 > E.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), E.ca.f.kb.F != null && Xn()), E.Pb && 0 < E.s.ua && E.s.vb.X == null && !j(E.s.vb, E.s.Wa.Xa)) {
                          E.a = 1;
                          break r;
                        }
                        E.xb = 0;
                      }
                      if (!tn(E, E.V, E.Ba, E.c, E.i, C.o, zn)) break r;
                      T.Dc = E.Ma, E = 1;
                      break t;
                    }
                    e(E.a != 0), E = 0;
                  }
                  E = !E;
                }
                E && (m = d.a);
              } else m = d.a;
            } else {
              if ((d = new wf()) == null) {
                k = 1;
                break e;
              }
              if (d.Fa = T.na, d.P = T.P, d.qc = T.Sa, gi(d, E)) {
                if ((m = ms(E.width, E.height, k.Oa, k.ba)) == 0) {
                  if (d.Aa = 0, C = k.Oa, e((T = d) != null), C != null) {
                    if (0 < (K = 0 > (K = C.Md) ? 0 : 100 < K ? 255 : 255 * K / 100)) {
                      for (q = Ae = 0; 4 > q; ++q) 12 > (de = T.pb[q]).lc && (de.ia = K * x4[0 > de.lc ? 0 : de.lc] >> 3), Ae |= de.ia;
                      Ae && (alert("todo:VP8InitRandom"), T.ia = 1);
                    }
                    T.Ga = C.Id, 100 < T.Ga ? T.Ga = 100 : 0 > T.Ga && (T.Ga = 0);
                  }
                  (function(z, ae) {
                    if (z == null) return 0;
                    if (ae == null) return eA(z, 2, "NULL VP8Io parameter in VP8Decode().");
                    if (!z.cb && !gi(z, ae)) return 0;
                    if (e(z.cb), ae.ac == null || ae.ac(ae)) {
                      ae.ob && (z.L = 0);
                      var he = ac[z.L];
                      if (z.L == 2 ? (z.yb = 0, z.zb = 0) : (z.yb = ae.v - he >> 4, z.zb = ae.j - he >> 4, 0 > z.yb && (z.yb = 0), 0 > z.zb && (z.zb = 0)), z.Va = ae.o + 15 + he >> 4, z.Hb = ae.va + 15 + he >> 4, z.Hb > z.za && (z.Hb = z.za), z.Va > z.Ub && (z.Va = z.Ub), 0 < z.L) {
                        var ve = z.ed;
                        for (he = 0; 4 > he; ++he) {
                          var fe;
                          if (z.Qa.Cb) {
                            var ye = z.Qa.Lb[he];
                            z.Qa.Fb || (ye += ve.Tb);
                          } else ye = ve.Tb;
                          for (fe = 0; 1 >= fe; ++fe) {
                            var Be = z.gd[he][fe], Ie = ye;
                            if (ve.Pc && (Ie += ve.vd[0], fe && (Ie += ve.od[0])), 0 < (Ie = 0 > Ie ? 0 : 63 < Ie ? 63 : Ie)) {
                              var _e = Ie;
                              0 < ve.wb && (_e = 4 < ve.wb ? _e >> 2 : _e >> 1) > 9 - ve.wb && (_e = 9 - ve.wb), 1 > _e && (_e = 1), Be.dd = _e, Be.tc = 2 * Ie + _e, Be.ld = 40 <= Ie ? 2 : 15 <= Ie ? 1 : 0;
                            } else Be.tc = 0;
                            Be.La = fe;
                          }
                        }
                      }
                      he = 0;
                    } else eA(z, 6, "Frame setup failed"), he = z.a;
                    if (he = he == 0) {
                      if (he) {
                        z.$c = 0, 0 < z.Aa || (z.Ic = E4);
                        t: {
                          he = z.Ic, ve = 4 * (_e = z.za);
                          var ht = 32 * _e, Ze = _e + 1, Qt = 0 < z.L ? _e * (0 < z.Aa ? 2 : 1) : 0, st = (z.Aa == 2 ? 2 : 1) * _e;
                          if ((Be = ve + 832 + (fe = 3 * (16 * he + ac[z.L]) / 2 * ht) + (ye = z.Fa != null && 0 < z.Fa.length ? z.Kc.c * z.Kc.i : 0)) != Be) he = 0;
                          else {
                            if (Be > z.Vb) {
                              if (z.Vb = 0, z.Ec = i(Be), z.Fc = 0, z.Ec == null) {
                                he = eA(z, 1, "no memory during frame initialization.");
                                break t;
                              }
                              z.Vb = Be;
                            }
                            Be = z.Ec, Ie = z.Fc, z.Ac = Be, z.Bc = Ie, Ie += ve, z.Gd = s(ht, Mu), z.Hd = 0, z.rb = s(Ze + 1, kr), z.sb = 1, z.wa = Qt ? s(Qt, mA) : null, z.Y = 0, z.D.Nb = 0, z.D.wa = z.wa, z.D.Y = z.Y, 0 < z.Aa && (z.D.Y += _e), e(!0), z.oc = Be, z.pc = Ie, Ie += 832, z.ya = s(st, ds), z.aa = 0, z.D.ya = z.ya, z.D.aa = z.aa, z.Aa == 2 && (z.D.aa += _e), z.R = 16 * _e, z.B = 8 * _e, _e = (ht = ac[z.L]) * z.R, ht = ht / 2 * z.B, z.sa = Be, z.ta = Ie + _e, z.qa = z.sa, z.ra = z.ta + 16 * he * z.R + ht, z.Ha = z.qa, z.Ia = z.ra + 8 * he * z.B + ht, z.$c = 0, Ie += fe, z.mb = ye ? Be : null, z.nb = ye ? Ie : null, e(Ie + ye <= z.Fc + z.Vb), Hu(z), n(z.Ac, z.Bc, 0, ve), he = 1;
                          }
                        }
                        if (he) {
                          if (ae.ka = 0, ae.y = z.sa, ae.O = z.ta, ae.f = z.qa, ae.N = z.ra, ae.ea = z.Ha, ae.Vd = z.Ia, ae.fa = z.R, ae.Rc = z.B, ae.F = null, ae.J = 0, !p1) {
                            for (he = -255; 255 >= he; ++he) h1[255 + he] = 0 > he ? -he : he;
                            for (he = -1020; 1020 >= he; ++he) f1[1020 + he] = -128 > he ? -128 : 127 < he ? 127 : he;
                            for (he = -112; 112 >= he; ++he) d1[112 + he] = -16 > he ? -16 : 15 < he ? 15 : he;
                            for (he = -255; 510 >= he; ++he) g1[255 + he] = 0 > he ? 0 : 255 < he ? 255 : he;
                            p1 = 1;
                          }
                          Cs = Za, pa = bf, wi = pi, er = Gu, or = Vu, In = yf, Dr = Wu, uA = oa, Ki = L, ul = W, io = Xu, Ju = y, A1 = Z, n1 = ce, i1 = aa, s1 = Zo, a1 = qu, o1 = zu, Yn[0] = Uf, Yn[1] = Bf, Yn[2] = Ff, Yn[3] = _f, Yn[4] = Ti, Yn[5] = If, Yn[6] = Pi, Yn[7] = Qf, Yn[8] = Wo, Yn[9] = eo, Ss[0] = xf, Ss[1] = Sf, Ss[2] = qo, Ss[3] = Ku, Ss[4] = ia, Ss[5] = zo, Ss[6] = Ef, ji[0] = Nf, ji[1] = Cf, ji[2] = sa, ji[3] = Lf, ji[4] = Yo, ji[5] = Xo, ji[6] = ju, he = 1;
                        } else he = 0;
                      }
                      he && (he = (function(kt, cA) {
                        for (kt.M = 0; kt.M < kt.Va; ++kt.M) {
                          var Lt, at = kt.Jc[kt.M & kt.Xb], He = kt.m, Gr = kt;
                          for (Lt = 0; Lt < Gr.za; ++Lt) {
                            var _t = He, Dt = Gr, vr = Dt.Ac, xA = Dt.Bc + 4 * Lt, KA = Dt.zc, Qr = Dt.ya[Dt.aa + Lt];
                            if (Dt.Qa.Bb ? Qr.$b = me(_t, Dt.Pa.jb[0]) ? 2 + me(_t, Dt.Pa.jb[2]) : me(_t, Dt.Pa.jb[1]) : Qr.$b = 0, Dt.kc && (Qr.Ad = me(_t, Dt.Bd)), Qr.Za = !me(_t, 145) + 0, Qr.Za) {
                              var LA = Qr.Ob, jA = 0;
                              for (Dt = 0; 4 > Dt; ++Dt) {
                                var hA, Vt = KA[0 + Dt];
                                for (hA = 0; 4 > hA; ++hA) {
                                  Vt = c4[vr[xA + hA]][Vt];
                                  for (var Ar = y1[me(_t, Vt[0])]; 0 < Ar; ) Ar = y1[2 * Ar + me(_t, Vt[Ar])];
                                  Vt = -Ar, vr[xA + hA] = Vt;
                                }
                                A(LA, jA, vr, xA, 4), jA += 4, KA[0 + Dt] = Vt;
                              }
                            } else Vt = me(_t, 156) ? me(_t, 128) ? 1 : 3 : me(_t, 163) ? 2 : 0, Qr.Ob[0] = Vt, n(vr, xA, Vt, 4), n(KA, 0, Vt, 4);
                            Qr.Dd = me(_t, 142) ? me(_t, 114) ? me(_t, 183) ? 1 : 3 : 2 : 0;
                          }
                          if (Gr.m.Ka) return eA(kt, 7, "Premature end-of-partition0 encountered.");
                          for (; kt.ja < kt.za; ++kt.ja) {
                            if (Gr = at, _t = (He = kt).rb[He.sb - 1], vr = He.rb[He.sb + He.ja], Lt = He.ya[He.aa + He.ja], xA = He.kc ? Lt.Ad : 0) _t.la = vr.la = 0, Lt.Za || (_t.Na = vr.Na = 0), Lt.Hc = 0, Lt.Gc = 0, Lt.ia = 0;
                            else {
                              var Lr, nr;
                              if (_t = vr, vr = Gr, xA = He.Pa.Xc, KA = He.ya[He.aa + He.ja], Qr = He.pb[KA.$b], Dt = KA.ad, LA = 0, jA = He.rb[He.sb - 1], Vt = hA = 0, n(Dt, LA, 0, 384), KA.Za) var EA = 0, $n = xA[3];
                              else {
                                Ar = i(16);
                                var Vr = _t.Na + jA.Na;
                                if (Vr = hl(vr, xA[1], Vr, Qr.Eb, 0, Ar, 0), _t.Na = jA.Na = (0 < Vr) + 0, 1 < Vr) Cs(Ar, 0, Dt, LA);
                                else {
                                  var rn = Ar[0] + 3 >> 3;
                                  for (Ar = 0; 256 > Ar; Ar += 16) Dt[LA + Ar] = rn;
                                }
                                EA = 1, $n = xA[0];
                              }
                              var lr = 15 & _t.la, fA = 15 & jA.la;
                              for (Ar = 0; 4 > Ar; ++Ar) {
                                var pn = 1 & fA;
                                for (rn = nr = 0; 4 > rn; ++rn) lr = lr >> 1 | (pn = (Vr = hl(vr, $n, Vr = pn + (1 & lr), Qr.Sc, EA, Dt, LA)) > EA) << 7, nr = nr << 2 | (3 < Vr ? 3 : 1 < Vr ? 2 : Dt[LA + 0] != 0), LA += 16;
                                lr >>= 4, fA = fA >> 1 | pn << 7, hA = (hA << 8 | nr) >>> 0;
                              }
                              for ($n = lr, EA = fA >> 4, Lr = 0; 4 > Lr; Lr += 2) {
                                for (nr = 0, lr = _t.la >> 4 + Lr, fA = jA.la >> 4 + Lr, Ar = 0; 2 > Ar; ++Ar) {
                                  for (pn = 1 & fA, rn = 0; 2 > rn; ++rn) Vr = pn + (1 & lr), lr = lr >> 1 | (pn = 0 < (Vr = hl(vr, xA[2], Vr, Qr.Qc, 0, Dt, LA))) << 3, nr = nr << 2 | (3 < Vr ? 3 : 1 < Vr ? 2 : Dt[LA + 0] != 0), LA += 16;
                                  lr >>= 2, fA = fA >> 1 | pn << 5;
                                }
                                Vt |= nr << 4 * Lr, $n |= lr << 4 << Lr, EA |= (240 & fA) << Lr;
                              }
                              _t.la = $n, jA.la = EA, KA.Hc = hA, KA.Gc = Vt, KA.ia = 43690 & Vt ? 0 : Qr.ia, xA = !(hA | Vt);
                            }
                            if (0 < He.L && (He.wa[He.Y + He.ja] = He.gd[Lt.$b][Lt.Za], He.wa[He.Y + He.ja].La |= !xA), Gr.Ka) return eA(kt, 7, "Premature end-of-file encountered.");
                          }
                          if (Hu(kt), He = cA, Gr = 1, Lt = (at = kt).D, _t = 0 < at.L && at.M >= at.zb && at.M <= at.Va, at.Aa == 0) t: {
                            if (Lt.M = at.M, Lt.uc = _t, Un(at, Lt), Gr = 1, Lt = (nr = at.D).Nb, _t = (Vt = ac[at.L]) * at.R, vr = Vt / 2 * at.B, Ar = 16 * Lt * at.R, rn = 8 * Lt * at.B, xA = at.sa, KA = at.ta - _t + Ar, Qr = at.qa, Dt = at.ra - vr + rn, LA = at.Ha, jA = at.Ia - vr + rn, fA = (lr = nr.M) == 0, hA = lr >= at.Va - 1, at.Aa == 2 && Un(at, nr), nr.uc) for (pn = (Vr = at).D.M, e(Vr.D.uc), nr = Vr.yb; nr < Vr.Hb; ++nr) {
                              EA = nr, $n = pn;
                              var qA = (mn = (FA = Vr).D).Nb;
                              Lr = FA.R;
                              var mn = mn.wa[mn.Y + EA], vn = FA.sa, An = FA.ta + 16 * qA * Lr + 16 * EA, wn = mn.dd, gr = mn.tc;
                              if (gr != 0) if (e(3 <= gr), FA.L == 1) 0 < EA && s1(vn, An, Lr, gr + 4), mn.La && o1(vn, An, Lr, gr), 0 < $n && i1(vn, An, Lr, gr + 4), mn.La && a1(vn, An, Lr, gr);
                              else {
                                var yn = FA.B, Jn = FA.qa, ma = FA.ra + 8 * qA * yn + 8 * EA, qi = FA.Ha, FA = FA.Ia + 8 * qA * yn + 8 * EA;
                                qA = mn.ld, 0 < EA && (uA(vn, An, Lr, gr + 4, wn, qA), ul(Jn, ma, qi, FA, yn, gr + 4, wn, qA)), mn.La && (Ju(vn, An, Lr, gr, wn, qA), n1(Jn, ma, qi, FA, yn, gr, wn, qA)), 0 < $n && (Dr(vn, An, Lr, gr + 4, wn, qA), Ki(Jn, ma, qi, FA, yn, gr + 4, wn, qA)), mn.La && (io(vn, An, Lr, gr, wn, qA), A1(Jn, ma, qi, FA, yn, gr, wn, qA));
                              }
                            }
                            if (at.ia && alert("todo:DitherRow"), He.put != null) {
                              if (nr = 16 * lr, lr = 16 * (lr + 1), fA ? (He.y = at.sa, He.O = at.ta + Ar, He.f = at.qa, He.N = at.ra + rn, He.ea = at.Ha, He.W = at.Ia + rn) : (nr -= Vt, He.y = xA, He.O = KA, He.f = Qr, He.N = Dt, He.ea = LA, He.W = jA), hA || (lr -= Vt), lr > He.o && (lr = He.o), He.F = null, He.J = null, at.Fa != null && 0 < at.Fa.length && nr < lr && (He.J = dr(at, He, nr, lr - nr), He.F = at.mb, He.F == null && He.F.length == 0)) {
                                Gr = eA(at, 3, "Could not decode alpha data.");
                                break t;
                              }
                              nr < He.j && (Vt = He.j - nr, nr = He.j, e(!(1 & Vt)), He.O += at.R * Vt, He.N += at.B * (Vt >> 1), He.W += at.B * (Vt >> 1), He.F != null && (He.J += He.width * Vt)), nr < lr && (He.O += He.v, He.N += He.v >> 1, He.W += He.v >> 1, He.F != null && (He.J += He.v), He.ka = nr - He.j, He.U = He.va - He.v, He.T = lr - nr, Gr = He.put(He));
                            }
                            Lt + 1 != at.Ic || hA || (A(at.sa, at.ta - _t, xA, KA + 16 * at.R, _t), A(at.qa, at.ra - vr, Qr, Dt + 8 * at.B, vr), A(at.Ha, at.Ia - vr, LA, jA + 8 * at.B, vr));
                          }
                          if (!Gr) return eA(kt, 6, "Output aborted.");
                        }
                        return 1;
                      })(z, ae)), ae.bc != null && ae.bc(ae), he &= 1;
                    }
                    return he ? (z.cb = 0, he) : 0;
                  })(d, E) || (m = d.a);
                }
              } else m = d.a;
            }
            m == 0 && k.Oa != null && k.Oa.fd && (m = nl(k.ba));
          }
          k = m;
        }
        M = k != 0 ? null : 11 > M ? D.f.RGBA.eb : D.f.kb.y;
      } else M = null;
      return M;
    };
    var _1 = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function l(_, R) {
    for (var F = "", O = 0; O < 4; O++) F += String.fromCharCode(_[R++]);
    return F;
  }
  function u(_, R) {
    return _[R + 0] | _[R + 1] << 8;
  }
  function c(_, R) {
    return (_[R + 0] | _[R + 1] << 8 | _[R + 2] << 16) >>> 0;
  }
  function f(_, R) {
    return (_[R + 0] | _[R + 1] << 8 | _[R + 2] << 16 | _[R + 3] << 24) >>> 0;
  }
  new o();
  var h = [0], g = [0], p = [], v = new o(), w = r, b = (function(_, R) {
    var F = {}, O = 0, G = !1, H = 0, $ = 0;
    if (F.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    (function(P, V) {
      for (var X = 0; X < 4; X++) if (P[V + X] != "RIFF".charCodeAt(X)) return !0;
      return !1;
    })(_, R)) {
      for (f(_, R += 4), R += 8; R < _.length; ) {
        var ne = l(_, R), te = f(_, R += 4);
        R += 4;
        var J = te + (1 & te);
        switch (ne) {
          case "VP8 ":
          case "VP8L":
            F.frames[O] === void 0 && (F.frames[O] = {}), (se = F.frames[O]).src_off = G ? $ : R - 8, se.src_size = H + te + 8, O++, G && (G = !1, H = 0, $ = 0);
            break;
          case "VP8X":
            (se = F.header = {}).feature_flags = _[R];
            var re = R + 4;
            se.canvas_width = 1 + c(_, re), re += 3, se.canvas_height = 1 + c(_, re), re += 3;
            break;
          case "ALPH":
            G = !0, H = J + 8, $ = R - 8;
            break;
          case "ANIM":
            (se = F.header).bgcolor = f(_, R), re = R + 4, se.loop_count = u(_, re), re += 2;
            break;
          case "ANMF":
            var le, se;
            (se = F.frames[O] = {}).offset_x = 2 * c(_, R), R += 3, se.offset_y = 2 * c(_, R), R += 3, se.width = 1 + c(_, R), R += 3, se.height = 1 + c(_, R), R += 3, se.duration = c(_, R), R += 3, le = _[R++], se.dispose = 1 & le, se.blend = le >> 1 & 1;
        }
        ne != "ANMF" && (R += J);
      }
      return F;
    }
  })(w, 0);
  b.response = w, b.rgbaoutput = !0, b.dataurl = !1;
  var S = b.header ? b.header : null, B = b.frames ? b.frames : null;
  if (S) {
    S.loop_counter = S.loop_count, h = [S.canvas_height], g = [S.canvas_width];
    for (var x = 0; x < B.length && B[x].blend != 0; x++) ;
  }
  var U = B[0], Q = v.WebPDecodeRGBA(w, U.src_off, U.src_size, g, h);
  U.rgba = Q, U.imgwidth = g[0], U.imgheight = h[0];
  for (var N = 0; N < g[0] * h[0] * 4; N++) p[N] = Q[N];
  return this.width = g, this.height = h, this.data = p, this;
}
(function(r) {
  var e, t, A, n, i, s, a, o, l, u = function(P) {
    return P = P || {}, this.isStrokeTransparent = P.isStrokeTransparent || !1, this.strokeOpacity = P.strokeOpacity || 1, this.strokeStyle = P.strokeStyle || "#000000", this.fillStyle = P.fillStyle || "#000000", this.isFillTransparent = P.isFillTransparent || !1, this.fillOpacity = P.fillOpacity || 1, this.font = P.font || "10px sans-serif", this.textBaseline = P.textBaseline || "alphabetic", this.textAlign = P.textAlign || "left", this.lineWidth = P.lineWidth || 1, this.lineJoin = P.lineJoin || "miter", this.lineCap = P.lineCap || "butt", this.path = P.path || [], this.transform = P.transform !== void 0 ? P.transform.clone() : new o(), this.globalCompositeOperation = P.globalCompositeOperation || "normal", this.globalAlpha = P.globalAlpha || 1, this.clip_path = P.clip_path || [], this.currentPoint = P.currentPoint || new s(), this.miterLimit = P.miterLimit || 10, this.lastPoint = P.lastPoint || new s(), this.lineDashOffset = P.lineDashOffset || 0, this.lineDash = P.lineDash || [], this.margin = P.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = P.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof P.ignoreClearRect != "boolean" || P.ignoreClearRect, this;
  };
  r.events.push(["initialized", function() {
    this.context2d = new c(this), e = this.internal.f2, t = this.internal.getCoordinateString, A = this.internal.getVerticalCoordinateString, n = this.internal.getHorizontalCoordinate, i = this.internal.getVerticalCoordinate, s = this.internal.Point, a = this.internal.Rectangle, o = this.internal.Matrix, l = new u();
  }]);
  var c = function(P) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var V = P;
    Object.defineProperty(this, "pdf", { get: function() {
      return V;
    } });
    var X = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return X;
    }, set: function(j) {
      X = !!j;
    } });
    var Y = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return Y;
    }, set: function(j) {
      Y = !!j;
    } });
    var ee = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return ee;
    }, set: function(j) {
      isNaN(j) || (ee = j);
    } });
    var oe = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return oe;
    }, set: function(j) {
      isNaN(j) || (oe = j);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return l.margin;
    }, set: function(j) {
      var Pe;
      typeof j == "number" ? Pe = [j, j, j, j] : ((Pe = new Array(4))[0] = j[0], Pe[1] = j.length >= 2 ? j[1] : Pe[0], Pe[2] = j.length >= 3 ? j[2] : Pe[0], Pe[3] = j.length >= 4 ? j[3] : Pe[1]), l.margin = Pe;
    } });
    var ge = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return ge;
    }, set: function(j) {
      ge = j;
    } });
    var pe = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return pe;
    }, set: function(j) {
      pe = j;
    } });
    var me = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return me;
    }, set: function(j) {
      me = j;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return l;
    }, set: function(j) {
      j instanceof u && (l = j);
    } }), Object.defineProperty(this, "path", { get: function() {
      return l.path;
    }, set: function(j) {
      l.path = j;
    } });
    var Ee = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return Ee;
    }, set: function(j) {
      Ee = j;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(j) {
      var Pe;
      Pe = f(j), this.ctx.fillStyle = Pe.style, this.ctx.isFillTransparent = Pe.a === 0, this.ctx.fillOpacity = Pe.a, this.pdf.setFillColor(Pe.r, Pe.g, Pe.b, { a: Pe.a }), this.pdf.setTextColor(Pe.r, Pe.g, Pe.b, { a: Pe.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(j) {
      var Pe = f(j);
      this.ctx.strokeStyle = Pe.style, this.ctx.isStrokeTransparent = Pe.a === 0, this.ctx.strokeOpacity = Pe.a, Pe.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (Pe.a, this.pdf.setDrawColor(Pe.r, Pe.g, Pe.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(j) {
      ["butt", "round", "square"].indexOf(j) !== -1 && (this.ctx.lineCap = j, this.pdf.setLineCap(j));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(j) {
      isNaN(j) || (this.ctx.lineWidth = j, this.pdf.setLineWidth(j));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(j) {
      ["bevel", "round", "miter"].indexOf(j) !== -1 && (this.ctx.lineJoin = j, this.pdf.setLineJoin(j));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(j) {
      isNaN(j) || (this.ctx.miterLimit = j, this.pdf.setMiterLimit(j));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(j) {
      this.ctx.textBaseline = j;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(j) {
      ["right", "end", "center", "left", "start"].indexOf(j) !== -1 && (this.ctx.textAlign = j);
    } });
    var Ne = null, Te = null, Ge = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return Ge;
    }, set: function(j) {
      Ne = null, Te = null, Ge = j;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(j) {
      var Pe;
      if (this.ctx.font = j, (Pe = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(j)) !== null) {
        var ft = Pe[1];
        Pe[2];
        var tt = Pe[3], xe = Pe[4];
        Pe[5];
        var At = Pe[6], ke = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(xe)[2];
        xe = Math.floor(ke === "px" ? parseFloat(xe) * this.pdf.internal.scaleFactor : ke === "em" ? parseFloat(xe) * this.pdf.getFontSize() : parseFloat(xe) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(xe);
        var We = (function(je) {
          var Tt, Et, mt = [], yt = je.trim();
          if (yt === "") return wd;
          if (yt in Xw) return [Xw[yt]];
          for (; yt !== ""; ) {
            switch (Et = null, Tt = (yt = $w(yt)).charAt(0)) {
              case '"':
              case "'":
                Et = sL(yt.substring(1), Tt);
                break;
              default:
                Et = aL(yt);
            }
            if (Et === null || (mt.push(Et[0]), (yt = $w(Et[1])) !== "" && yt.charAt(0) !== ",")) return wd;
            yt = yt.replace(/^,/, "");
          }
          return mt;
        })(At);
        if (this.fontFaces) {
          var ze = (function(je, Tt) {
            var Et = je.getFontList(), mt = JSON.stringify(Et);
            if (Ne === null || Te !== mt) {
              var yt = (function(qt) {
                var it = [];
                return Object.keys(qt).forEach(function(zt) {
                  qt[zt].forEach(function(lt) {
                    var wt = null;
                    switch (lt) {
                      case "bold":
                        wt = { family: zt, weight: "bold" };
                        break;
                      case "italic":
                        wt = { family: zt, style: "italic" };
                        break;
                      case "bolditalic":
                        wt = { family: zt, weight: "bold", style: "italic" };
                        break;
                      case "":
                      case "normal":
                        wt = { family: zt };
                    }
                    wt !== null && (wt.ref = { name: zt, style: lt }, it.push(wt));
                  });
                }), it;
              })(Et);
              Ne = (function(qt) {
                for (var it = {}, zt = 0; zt < qt.length; ++zt) {
                  var lt = vd(qt[zt]), wt = lt.family, Zt = lt.stretch, ut = lt.style, bt = lt.weight;
                  it[wt] = it[wt] || {}, it[wt][Zt] = it[wt][Zt] || {}, it[wt][Zt][ut] = it[wt][Zt][ut] || {}, it[wt][Zt][ut][bt] = lt;
                }
                return it;
              })(yt.concat(Tt)), Te = mt;
            }
            return Ne;
          })(this.pdf, this.fontFaces), Ce = We.map(function(je) {
            return { family: je, stretch: "normal", weight: tt, style: ft };
          }), Oe = (function(je, Tt, Et) {
            for (var mt = (Et = Et || {}).defaultFontFamily || "times", yt = Object.assign({}, iL, Et.genericFontFamilies || {}), qt = null, it = null, zt = 0; zt < Tt.length; ++zt) if (yt[(qt = vd(Tt[zt])).family] && (qt.family = yt[qt.family]), je.hasOwnProperty(qt.family)) {
              it = je[qt.family];
              break;
            }
            if (!(it = it || je[mt])) throw new Error("Could not find a font-family for the rule '" + Yw(qt) + "' and default family '" + mt + "'.");
            if (it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              var Zt = om[lt], ut = Zt <= om.normal ? -1 : 1, bt = Ww(wt, Jx, Zt, ut);
              if (!bt) throw new Error("Could not find a matching font-stretch value for " + lt);
              return bt;
            })(qt.stretch, it), it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              for (var Zt = $x[lt], ut = 0; ut < Zt.length; ++ut) if (wt[Zt[ut]]) return wt[Zt[ut]];
              throw new Error("Could not find a matching font-style for " + lt);
            })(qt.style, it), !(it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              if (lt === 400 && wt[500]) return wt[500];
              if (lt === 500 && wt[400]) return wt[400];
              var Zt = nL[lt], ut = Ww(wt, Zx, Zt, lt < 400 ? -1 : 1);
              if (!ut) throw new Error("Could not find a matching font-weight for value " + lt);
              return ut;
            })(qt.weight, it))) throw new Error("Failed to resolve a font for the rule '" + Yw(qt) + "'.");
            return it;
          })(ze, Ce);
          this.pdf.setFont(Oe.ref.name, Oe.ref.style);
        } else {
          var Re = "";
          (tt === "bold" || parseInt(tt, 10) >= 700 || ft === "bold") && (Re = "bold"), ft === "italic" && (Re += "italic"), Re.length === 0 && (Re = "normal");
          for (var Ke = "", Xe = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, Ve = 0; Ve < We.length; Ve++) {
            if (this.pdf.internal.getFont(We[Ve], Re, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ke = We[Ve];
              break;
            }
            if (Re === "bolditalic" && this.pdf.internal.getFont(We[Ve], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) Ke = We[Ve], Re = "bold";
            else if (this.pdf.internal.getFont(We[Ve], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ke = We[Ve], Re = "normal";
              break;
            }
          }
          if (Ke === "") {
            for (var dt = 0; dt < We.length; dt++) if (Xe[We[dt]]) {
              Ke = Xe[We[dt]];
              break;
            }
          }
          Ke = Ke === "" ? "Times" : Ke, this.pdf.setFont(Ke, Re);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(j) {
      this.ctx.globalCompositeOperation = j;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(j) {
      this.ctx.globalAlpha = j;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(j) {
      this.ctx.lineDashOffset = j, se.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(j) {
      this.ctx.lineDash = j, se.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(j) {
      this.ctx.ignoreClearRect = !!j;
    } });
  };
  c.prototype.setLineDash = function(P) {
    this.lineDash = P;
  }, c.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, c.prototype.fill = function() {
    B.call(this, "fill", !1);
  }, c.prototype.stroke = function() {
    B.call(this, "stroke", !1);
  }, c.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, c.prototype.moveTo = function(P, V) {
    if (isNaN(P) || isNaN(V)) throw ur.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var X = this.ctx.transform.applyToPoint(new s(P, V));
    this.path.push({ type: "mt", x: X.x, y: X.y }), this.ctx.lastPoint = new s(P, V);
  }, c.prototype.closePath = function() {
    var P = new s(0, 0), V = 0;
    for (V = this.path.length - 1; V !== -1; V--) if (this.path[V].type === "begin" && Xt(this.path[V + 1]) === "object" && typeof this.path[V + 1].x == "number") {
      P = new s(this.path[V + 1].x, this.path[V + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new s(P.x, P.y);
  }, c.prototype.lineTo = function(P, V) {
    if (isNaN(P) || isNaN(V)) throw ur.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var X = this.ctx.transform.applyToPoint(new s(P, V));
    this.path.push({ type: "lt", x: X.x, y: X.y }), this.ctx.lastPoint = new s(X.x, X.y);
  }, c.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), B.call(this, null, !0);
  }, c.prototype.quadraticCurveTo = function(P, V, X, Y) {
    if (isNaN(X) || isNaN(Y) || isNaN(P) || isNaN(V)) throw ur.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var ee = this.ctx.transform.applyToPoint(new s(X, Y)), oe = this.ctx.transform.applyToPoint(new s(P, V));
    this.path.push({ type: "qct", x1: oe.x, y1: oe.y, x: ee.x, y: ee.y }), this.ctx.lastPoint = new s(ee.x, ee.y);
  }, c.prototype.bezierCurveTo = function(P, V, X, Y, ee, oe) {
    if (isNaN(ee) || isNaN(oe) || isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y)) throw ur.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var ge = this.ctx.transform.applyToPoint(new s(ee, oe)), pe = this.ctx.transform.applyToPoint(new s(P, V)), me = this.ctx.transform.applyToPoint(new s(X, Y));
    this.path.push({ type: "bct", x1: pe.x, y1: pe.y, x2: me.x, y2: me.y, x: ge.x, y: ge.y }), this.ctx.lastPoint = new s(ge.x, ge.y);
  }, c.prototype.arc = function(P, V, X, Y, ee, oe) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y) || isNaN(ee)) throw ur.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (oe = !!oe, !this.ctx.transform.isIdentity) {
      var ge = this.ctx.transform.applyToPoint(new s(P, V));
      P = ge.x, V = ge.y;
      var pe = this.ctx.transform.applyToPoint(new s(0, X)), me = this.ctx.transform.applyToPoint(new s(0, 0));
      X = Math.sqrt(Math.pow(pe.x - me.x, 2) + Math.pow(pe.y - me.y, 2));
    }
    Math.abs(ee - Y) >= 2 * Math.PI && (Y = 0, ee = 2 * Math.PI), this.path.push({ type: "arc", x: P, y: V, radius: X, startAngle: Y, endAngle: ee, counterclockwise: oe });
  }, c.prototype.arcTo = function(P, V, X, Y, ee) {
    throw new Error("arcTo not implemented.");
  }, c.prototype.rect = function(P, V, X, Y) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y)) throw ur.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(P, V), this.lineTo(P + X, V), this.lineTo(P + X, V + Y), this.lineTo(P, V + Y), this.lineTo(P, V), this.lineTo(P + X, V), this.lineTo(P, V);
  }, c.prototype.fillRect = function(P, V, X, Y) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y)) throw ur.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!h.call(this)) {
      var ee = {};
      this.lineCap !== "butt" && (ee.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (ee.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(P, V, X, Y), this.fill(), ee.hasOwnProperty("lineCap") && (this.lineCap = ee.lineCap), ee.hasOwnProperty("lineJoin") && (this.lineJoin = ee.lineJoin);
    }
  }, c.prototype.strokeRect = function(P, V, X, Y) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y)) throw ur.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    g.call(this) || (this.beginPath(), this.rect(P, V, X, Y), this.stroke());
  }, c.prototype.clearRect = function(P, V, X, Y) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y)) throw ur.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(P, V, X, Y));
  }, c.prototype.save = function(P) {
    P = typeof P != "boolean" || P;
    for (var V = this.pdf.internal.getCurrentPageInfo().pageNumber, X = 0; X < this.pdf.internal.getNumberOfPages(); X++) this.pdf.setPage(X + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(V), P) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var Y = new u(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = Y;
    }
  }, c.prototype.restore = function(P) {
    P = typeof P != "boolean" || P;
    for (var V = this.pdf.internal.getCurrentPageInfo().pageNumber, X = 0; X < this.pdf.internal.getNumberOfPages(); X++) this.pdf.setPage(X + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(V), P && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, c.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var f = function(P) {
    var V, X, Y, ee;
    if (P.isCanvasGradient === !0 && (P = P.getColor()), !P) return { r: 0, g: 0, b: 0, a: 0, style: P };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(P)) V = 0, X = 0, Y = 0, ee = 0;
    else {
      var oe = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(P);
      if (oe !== null) V = parseInt(oe[1]), X = parseInt(oe[2]), Y = parseInt(oe[3]), ee = 1;
      else if ((oe = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(P)) !== null) V = parseInt(oe[1]), X = parseInt(oe[2]), Y = parseInt(oe[3]), ee = parseFloat(oe[4]);
      else {
        if (ee = 1, typeof P == "string" && P.charAt(0) !== "#") {
          var ge = new Kx(P);
          P = ge.ok ? ge.toHex() : "#000000";
        }
        P.length === 4 ? (V = P.substring(1, 2), V += V, X = P.substring(2, 3), X += X, Y = P.substring(3, 4), Y += Y) : (V = P.substring(1, 3), X = P.substring(3, 5), Y = P.substring(5, 7)), V = parseInt(V, 16), X = parseInt(X, 16), Y = parseInt(Y, 16);
      }
    }
    return { r: V, g: X, b: Y, a: ee, style: P };
  }, h = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, g = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  c.prototype.fillText = function(P, V, X, Y) {
    if (isNaN(V) || isNaN(X) || typeof P != "string") throw ur.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (Y = isNaN(Y) ? void 0 : Y, !h.call(this)) {
      var ee = J(this.ctx.transform.rotation), oe = this.ctx.transform.scaleX;
      O.call(this, { text: P, x: V, y: X, scale: oe, angle: ee, align: this.textAlign, maxWidth: Y });
    }
  }, c.prototype.strokeText = function(P, V, X, Y) {
    if (isNaN(V) || isNaN(X) || typeof P != "string") throw ur.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!g.call(this)) {
      Y = isNaN(Y) ? void 0 : Y;
      var ee = J(this.ctx.transform.rotation), oe = this.ctx.transform.scaleX;
      O.call(this, { text: P, x: V, y: X, scale: oe, renderingMode: "stroke", angle: ee, align: this.textAlign, maxWidth: Y });
    }
  }, c.prototype.measureText = function(P) {
    if (typeof P != "string") throw ur.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var V = this.pdf, X = this.pdf.internal.scaleFactor, Y = V.internal.getFontSize(), ee = V.getStringUnitWidth(P) * Y / V.internal.scaleFactor;
    return new function(oe) {
      var ge = (oe = oe || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return ge;
      } }), this;
    }({ width: ee *= Math.round(96 * X / 72 * 1e4) / 1e4 });
  }, c.prototype.scale = function(P, V) {
    if (isNaN(P) || isNaN(V)) throw ur.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var X = new o(P, 0, 0, V, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(X);
  }, c.prototype.rotate = function(P) {
    if (isNaN(P)) throw ur.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var V = new o(Math.cos(P), Math.sin(P), -Math.sin(P), Math.cos(P), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(V);
  }, c.prototype.translate = function(P, V) {
    if (isNaN(P) || isNaN(V)) throw ur.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var X = new o(1, 0, 0, 1, P, V);
    this.ctx.transform = this.ctx.transform.multiply(X);
  }, c.prototype.transform = function(P, V, X, Y, ee, oe) {
    if (isNaN(P) || isNaN(V) || isNaN(X) || isNaN(Y) || isNaN(ee) || isNaN(oe)) throw ur.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var ge = new o(P, V, X, Y, ee, oe);
    this.ctx.transform = this.ctx.transform.multiply(ge);
  }, c.prototype.setTransform = function(P, V, X, Y, ee, oe) {
    P = isNaN(P) ? 1 : P, V = isNaN(V) ? 0 : V, X = isNaN(X) ? 0 : X, Y = isNaN(Y) ? 1 : Y, ee = isNaN(ee) ? 0 : ee, oe = isNaN(oe) ? 0 : oe, this.ctx.transform = new o(P, V, X, Y, ee, oe);
  };
  var p = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  c.prototype.drawImage = function(P, V, X, Y, ee, oe, ge, pe, me) {
    var Ee = this.pdf.getImageProperties(P), Ne = 1, Te = 1, Ge = 1, j = 1;
    Y !== void 0 && pe !== void 0 && (Ge = pe / Y, j = me / ee, Ne = Ee.width / Y * pe / Y, Te = Ee.height / ee * me / ee), oe === void 0 && (oe = V, ge = X, V = 0, X = 0), Y !== void 0 && pe === void 0 && (pe = Y, me = ee), Y === void 0 && pe === void 0 && (pe = Ee.width, me = Ee.height);
    var Pe = this.ctx.transform.decompose(), ft = J(Pe.rotate.shx), tt = new o(), xe = (tt = (tt = (tt = tt.multiply(Pe.translate)).multiply(Pe.skew)).multiply(Pe.scale)).applyToRectangle(new a(oe - V * Ge, ge - X * j, Y * Ne, ee * Te));
    if (this.autoPaging) {
      for (var At, ke = v.call(this, xe), We = [], ze = 0; ze < ke.length; ze += 1) We.indexOf(ke[ze]) === -1 && We.push(ke[ze]);
      S(We);
      for (var Ce = We[0], Oe = We[We.length - 1], Re = Ce; Re < Oe + 1; Re++) {
        this.pdf.setPage(Re);
        var Ke = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], Xe = Re === 1 ? this.posY + this.margin[0] : this.margin[0], Ve = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], dt = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], je = Re === 1 ? 0 : Ve + (Re - 2) * dt;
        if (this.ctx.clip_path.length !== 0) {
          var Tt = this.path;
          At = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(At, this.posX + this.margin[3], -je + Xe + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = Tt;
        }
        var Et = JSON.parse(JSON.stringify(xe));
        Et = b([Et], this.posX + this.margin[3], -je + Xe + this.ctx.prevPageLastElemOffset)[0];
        var mt = (Re > Ce || Re < Oe) && p.call(this);
        mt && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Ke, dt, null).clip().discardPath()), this.pdf.addImage(P, "JPEG", Et.x, Et.y, Et.w, Et.h, null, null, ft), mt && this.pdf.restoreGraphicsState();
      }
    } else this.pdf.addImage(P, "JPEG", xe.x, xe.y, xe.w, xe.h, null, null, ft);
  };
  var v = function(P, V, X) {
    var Y = [];
    V = V || this.pdf.internal.pageSize.width, X = X || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var ee = this.posY + this.ctx.prevPageLastElemOffset;
    switch (P.type) {
      default:
      case "mt":
      case "lt":
        Y.push(Math.floor((P.y + ee) / X) + 1);
        break;
      case "arc":
        Y.push(Math.floor((P.y + ee - P.radius) / X) + 1), Y.push(Math.floor((P.y + ee + P.radius) / X) + 1);
        break;
      case "qct":
        var oe = re(this.ctx.lastPoint.x, this.ctx.lastPoint.y, P.x1, P.y1, P.x, P.y);
        Y.push(Math.floor((oe.y + ee) / X) + 1), Y.push(Math.floor((oe.y + oe.h + ee) / X) + 1);
        break;
      case "bct":
        var ge = le(this.ctx.lastPoint.x, this.ctx.lastPoint.y, P.x1, P.y1, P.x2, P.y2, P.x, P.y);
        Y.push(Math.floor((ge.y + ee) / X) + 1), Y.push(Math.floor((ge.y + ge.h + ee) / X) + 1);
        break;
      case "rect":
        Y.push(Math.floor((P.y + ee) / X) + 1), Y.push(Math.floor((P.y + P.h + ee) / X) + 1);
    }
    for (var pe = 0; pe < Y.length; pe += 1) for (; this.pdf.internal.getNumberOfPages() < Y[pe]; ) w.call(this);
    return Y;
  }, w = function() {
    var P = this.fillStyle, V = this.strokeStyle, X = this.font, Y = this.lineCap, ee = this.lineWidth, oe = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = P, this.strokeStyle = V, this.font = X, this.lineCap = Y, this.lineWidth = ee, this.lineJoin = oe;
  }, b = function(P, V, X) {
    for (var Y = 0; Y < P.length; Y++) switch (P[Y].type) {
      case "bct":
        P[Y].x2 += V, P[Y].y2 += X;
      case "qct":
        P[Y].x1 += V, P[Y].y1 += X;
      default:
        P[Y].x += V, P[Y].y += X;
    }
    return P;
  }, S = function(P) {
    return P.sort(function(V, X) {
      return V - X;
    });
  }, B = function(P, V) {
    var X = this.fillStyle, Y = this.strokeStyle, ee = this.lineCap, oe = this.lineWidth, ge = Math.abs(oe * this.ctx.transform.scaleX), pe = this.lineJoin;
    if (this.autoPaging) {
      for (var me, Ee, Ne = JSON.parse(JSON.stringify(this.path)), Te = JSON.parse(JSON.stringify(this.path)), Ge = [], j = 0; j < Te.length; j++) if (Te[j].x !== void 0) for (var Pe = v.call(this, Te[j]), ft = 0; ft < Pe.length; ft += 1) Ge.indexOf(Pe[ft]) === -1 && Ge.push(Pe[ft]);
      for (var tt = 0; tt < Ge.length; tt++) for (; this.pdf.internal.getNumberOfPages() < Ge[tt]; ) w.call(this);
      S(Ge);
      for (var xe = Ge[0], At = Ge[Ge.length - 1], ke = xe; ke < At + 1; ke++) {
        this.pdf.setPage(ke), this.fillStyle = X, this.strokeStyle = Y, this.lineCap = ee, this.lineWidth = ge, this.lineJoin = pe;
        var We = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], ze = ke === 1 ? this.posY + this.margin[0] : this.margin[0], Ce = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Oe = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], Re = ke === 1 ? 0 : Ce + (ke - 2) * Oe;
        if (this.ctx.clip_path.length !== 0) {
          var Ke = this.path;
          me = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(me, this.posX + this.margin[3], -Re + ze + this.ctx.prevPageLastElemOffset), x.call(this, P, !0), this.path = Ke;
        }
        if (Ee = JSON.parse(JSON.stringify(Ne)), this.path = b(Ee, this.posX + this.margin[3], -Re + ze + this.ctx.prevPageLastElemOffset), V === !1 || ke === 0) {
          var Xe = (ke > xe || ke < At) && p.call(this);
          Xe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], We, Oe, null).clip().discardPath()), x.call(this, P, V), Xe && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = oe;
      }
      this.path = Ne;
    } else this.lineWidth = ge, x.call(this, P, V), this.lineWidth = oe;
  }, x = function(P, V) {
    if ((P !== "stroke" || V || !g.call(this)) && (P === "stroke" || V || !h.call(this))) {
      for (var X, Y, ee = [], oe = this.path, ge = 0; ge < oe.length; ge++) {
        var pe = oe[ge];
        switch (pe.type) {
          case "begin":
            ee.push({ begin: !0 });
            break;
          case "close":
            ee.push({ close: !0 });
            break;
          case "mt":
            ee.push({ start: pe, deltas: [], abs: [] });
            break;
          case "lt":
            var me = ee.length;
            if (oe[ge - 1] && !isNaN(oe[ge - 1].x) && (X = [pe.x - oe[ge - 1].x, pe.y - oe[ge - 1].y], me > 0)) {
              for (; me >= 0; me--) if (ee[me - 1].close !== !0 && ee[me - 1].begin !== !0) {
                ee[me - 1].deltas.push(X), ee[me - 1].abs.push(pe);
                break;
              }
            }
            break;
          case "bct":
            X = [pe.x1 - oe[ge - 1].x, pe.y1 - oe[ge - 1].y, pe.x2 - oe[ge - 1].x, pe.y2 - oe[ge - 1].y, pe.x - oe[ge - 1].x, pe.y - oe[ge - 1].y], ee[ee.length - 1].deltas.push(X);
            break;
          case "qct":
            var Ee = oe[ge - 1].x + 2 / 3 * (pe.x1 - oe[ge - 1].x), Ne = oe[ge - 1].y + 2 / 3 * (pe.y1 - oe[ge - 1].y), Te = pe.x + 2 / 3 * (pe.x1 - pe.x), Ge = pe.y + 2 / 3 * (pe.y1 - pe.y), j = pe.x, Pe = pe.y;
            X = [Ee - oe[ge - 1].x, Ne - oe[ge - 1].y, Te - oe[ge - 1].x, Ge - oe[ge - 1].y, j - oe[ge - 1].x, Pe - oe[ge - 1].y], ee[ee.length - 1].deltas.push(X);
            break;
          case "arc":
            ee.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(ee[ee.length - 1].abs) && ee[ee.length - 1].abs.push(pe);
        }
      }
      Y = V ? null : P === "stroke" ? "stroke" : "fill";
      for (var ft = !1, tt = 0; tt < ee.length; tt++) if (ee[tt].arc) for (var xe = ee[tt].abs, At = 0; At < xe.length; At++) {
        var ke = xe[At];
        ke.type === "arc" ? N.call(this, ke.x, ke.y, ke.radius, ke.startAngle, ke.endAngle, ke.counterclockwise, void 0, V, !ft) : G.call(this, ke.x, ke.y), ft = !0;
      }
      else if (ee[tt].close === !0) this.pdf.internal.out("h"), ft = !1;
      else if (ee[tt].begin !== !0) {
        var We = ee[tt].start.x, ze = ee[tt].start.y;
        H.call(this, ee[tt].deltas, We, ze), ft = !0;
      }
      Y && _.call(this, Y), V && R.call(this);
    }
  }, U = function(P) {
    var V = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, X = V * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return P - X;
      case "top":
        return P + V - X;
      case "hanging":
        return P + V - 2 * X;
      case "middle":
        return P + V / 2 - X;
      default:
        return P;
    }
  }, Q = function(P) {
    return P + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  c.prototype.createLinearGradient = function() {
    var P = function() {
    };
    return P.colorStops = [], P.addColorStop = function(V, X) {
      this.colorStops.push([V, X]);
    }, P.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, P.isCanvasGradient = !0, P;
  }, c.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, c.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var N = function(P, V, X, Y, ee, oe, ge, pe, me) {
    for (var Ee = ne.call(this, X, Y, ee, oe), Ne = 0; Ne < Ee.length; Ne++) {
      var Te = Ee[Ne];
      Ne === 0 && (me ? F.call(this, Te.x1 + P, Te.y1 + V) : G.call(this, Te.x1 + P, Te.y1 + V)), $.call(this, P, V, Te.x2, Te.y2, Te.x3, Te.y3, Te.x4, Te.y4);
    }
    pe ? R.call(this) : _.call(this, ge);
  }, _ = function(P) {
    switch (P) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, R = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, F = function(P, V) {
    this.pdf.internal.out(t(P) + " " + A(V) + " m");
  }, O = function(P) {
    var V;
    switch (P.align) {
      case "right":
      case "end":
        V = "right";
        break;
      case "center":
        V = "center";
        break;
      default:
        V = "left";
    }
    var X, Y, ee, oe = this.pdf.getTextDimensions(P.text), ge = U.call(this, P.y), pe = Q.call(this, ge) - oe.h, me = this.ctx.transform.applyToPoint(new s(P.x, ge));
    if (this.autoPaging) {
      var Ee = this.ctx.transform.decompose(), Ne = new o();
      Ne = (Ne = (Ne = Ne.multiply(Ee.translate)).multiply(Ee.skew)).multiply(Ee.scale);
      for (var Te = this.ctx.transform.applyToRectangle(new a(P.x, ge, oe.w, oe.h)), Ge = Ne.applyToRectangle(new a(P.x, pe, oe.w, oe.h)), j = v.call(this, Ge), Pe = [], ft = 0; ft < j.length; ft += 1) Pe.indexOf(j[ft]) === -1 && Pe.push(j[ft]);
      S(Pe);
      for (var tt = Pe[0], xe = Pe[Pe.length - 1], At = tt; At < xe + 1; At++) {
        this.pdf.setPage(At);
        var ke = At === 1 ? this.posY + this.margin[0] : this.margin[0], We = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ze = this.pdf.internal.pageSize.height - this.margin[2], Ce = ze - this.margin[0], Oe = this.pdf.internal.pageSize.width - this.margin[1], Re = Oe - this.margin[3], Ke = At === 1 ? 0 : We + (At - 2) * Ce;
        if (this.ctx.clip_path.length !== 0) {
          var Xe = this.path;
          X = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(X, this.posX + this.margin[3], -1 * Ke + ke), x.call(this, "fill", !0), this.path = Xe;
        }
        var Ve = b([JSON.parse(JSON.stringify(Ge))], this.posX + this.margin[3], -Ke + ke + this.ctx.prevPageLastElemOffset)[0];
        P.scale >= 0.01 && (Y = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Y * P.scale), ee = this.lineWidth, this.lineWidth = ee * P.scale);
        var dt = this.autoPaging !== "text";
        if (dt || Ve.y + Ve.h <= ze) {
          if (dt || Ve.y >= ke && Ve.x <= Oe) {
            var je = dt ? P.text : this.pdf.splitTextToSize(P.text, P.maxWidth || Oe - Ve.x)[0], Tt = b([JSON.parse(JSON.stringify(Te))], this.posX + this.margin[3], -Ke + ke + this.ctx.prevPageLastElemOffset)[0], Et = dt && (At > tt || At < xe) && p.call(this);
            Et && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Re, Ce, null).clip().discardPath()), this.pdf.text(je, Tt.x, Tt.y, { angle: P.angle, align: V, renderingMode: P.renderingMode }), Et && this.pdf.restoreGraphicsState();
          }
        } else Ve.y < ze && (this.ctx.prevPageLastElemOffset += ze - Ve.y);
        P.scale >= 0.01 && (this.pdf.setFontSize(Y), this.lineWidth = ee);
      }
    } else P.scale >= 0.01 && (Y = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Y * P.scale), ee = this.lineWidth, this.lineWidth = ee * P.scale), this.pdf.text(P.text, me.x + this.posX, me.y + this.posY, { angle: P.angle, align: V, renderingMode: P.renderingMode, maxWidth: P.maxWidth }), P.scale >= 0.01 && (this.pdf.setFontSize(Y), this.lineWidth = ee);
  }, G = function(P, V, X, Y) {
    X = X || 0, Y = Y || 0, this.pdf.internal.out(t(P + X) + " " + A(V + Y) + " l");
  }, H = function(P, V, X) {
    return this.pdf.lines(P, V, X, null, null);
  }, $ = function(P, V, X, Y, ee, oe, ge, pe) {
    this.pdf.internal.out([e(n(X + P)), e(i(Y + V)), e(n(ee + P)), e(i(oe + V)), e(n(ge + P)), e(i(pe + V)), "c"].join(" "));
  }, ne = function(P, V, X, Y) {
    for (var ee = 2 * Math.PI, oe = Math.PI / 2; V > X; ) V -= ee;
    var ge = Math.abs(X - V);
    ge < ee && Y && (ge = ee - ge);
    for (var pe = [], me = Y ? -1 : 1, Ee = V; ge > 1e-5; ) {
      var Ne = Ee + me * Math.min(ge, oe);
      pe.push(te.call(this, P, Ee, Ne)), ge -= Math.abs(Ne - Ee), Ee = Ne;
    }
    return pe;
  }, te = function(P, V, X) {
    var Y = (X - V) / 2, ee = P * Math.cos(Y), oe = P * Math.sin(Y), ge = ee, pe = -oe, me = ge * ge + pe * pe, Ee = me + ge * ee + pe * oe, Ne = 4 / 3 * (Math.sqrt(2 * me * Ee) - Ee) / (ge * oe - pe * ee), Te = ge - Ne * pe, Ge = pe + Ne * ge, j = Te, Pe = -Ge, ft = Y + V, tt = Math.cos(ft), xe = Math.sin(ft);
    return { x1: P * Math.cos(V), y1: P * Math.sin(V), x2: Te * tt - Ge * xe, y2: Te * xe + Ge * tt, x3: j * tt - Pe * xe, y3: j * xe + Pe * tt, x4: P * Math.cos(X), y4: P * Math.sin(X) };
  }, J = function(P) {
    return 180 * P / Math.PI;
  }, re = function(P, V, X, Y, ee, oe) {
    var ge = P + 0.5 * (X - P), pe = V + 0.5 * (Y - V), me = ee + 0.5 * (X - ee), Ee = oe + 0.5 * (Y - oe), Ne = Math.min(P, ee, ge, me), Te = Math.max(P, ee, ge, me), Ge = Math.min(V, oe, pe, Ee), j = Math.max(V, oe, pe, Ee);
    return new a(Ne, Ge, Te - Ne, j - Ge);
  }, le = function(P, V, X, Y, ee, oe, ge, pe) {
    var me, Ee, Ne, Te, Ge, j, Pe, ft, tt, xe, At, ke, We, ze, Ce = X - P, Oe = Y - V, Re = ee - X, Ke = oe - Y, Xe = ge - ee, Ve = pe - oe;
    for (Ee = 0; Ee < 41; Ee++) tt = (Pe = (Ne = P + (me = Ee / 40) * Ce) + me * ((Ge = X + me * Re) - Ne)) + me * (Ge + me * (ee + me * Xe - Ge) - Pe), xe = (ft = (Te = V + me * Oe) + me * ((j = Y + me * Ke) - Te)) + me * (j + me * (oe + me * Ve - j) - ft), Ee == 0 ? (At = tt, ke = xe, We = tt, ze = xe) : (At = Math.min(At, tt), ke = Math.min(ke, xe), We = Math.max(We, tt), ze = Math.max(ze, xe));
    return new a(Math.round(At), Math.round(ke), Math.round(We - At), Math.round(ze - ke));
  }, se = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var P, V, X = (P = this.ctx.lineDash, V = this.ctx.lineDashOffset, JSON.stringify({ lineDash: P, lineDashOffset: V }));
      this.prevLineDash !== X && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = X);
    }
  };
})(ot.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(s) {
    var a, o, l, u, c, f, h, g, p, v;
    for (o = [], l = 0, u = (s += a = "\0\0\0\0".slice(s.length % 4 || 4)).length; u > l; l += 4) (c = (s.charCodeAt(l) << 24) + (s.charCodeAt(l + 1) << 16) + (s.charCodeAt(l + 2) << 8) + s.charCodeAt(l + 3)) !== 0 ? (f = (c = ((c = ((c = ((c = (c - (v = c % 85)) / 85) - (p = c % 85)) / 85) - (g = c % 85)) / 85) - (h = c % 85)) / 85) % 85, o.push(f + 33, h + 33, g + 33, p + 33, v + 33)) : o.push(122);
    return (function(w, b) {
      for (var S = b; S > 0; S--) w.pop();
    })(o, a.length), String.fromCharCode.apply(String, o) + "~>";
  }, t = function(s) {
    var a, o, l, u, c, f = String, h = "length", g = 255, p = "charCodeAt", v = "slice", w = "replace";
    for (s[v](-2), s = s[v](0, -2)[w](/\s/g, "")[w]("z", "!!!!!"), l = [], u = 0, c = (s += a = "uuuuu"[v](s[h] % 5 || 5))[h]; c > u; u += 5) o = 52200625 * (s[p](u) - 33) + 614125 * (s[p](u + 1) - 33) + 7225 * (s[p](u + 2) - 33) + 85 * (s[p](u + 3) - 33) + (s[p](u + 4) - 33), l.push(g & o >> 24, g & o >> 16, g & o >> 8, g & o);
    return (function(b, S) {
      for (var B = S; B > 0; B--) b.pop();
    })(l, a[h]), f.fromCharCode.apply(f, l);
  }, A = function(s) {
    return s.split("").map(function(a) {
      return ("0" + a.charCodeAt().toString(16)).slice(-2);
    }).join("") + ">";
  }, n = function(s) {
    var a = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((s = s.replace(/\s/g, "")).indexOf(">") !== -1 && (s = s.substr(0, s.indexOf(">"))), s.length % 2 && (s += "0"), a.test(s) === !1) return "";
    for (var o = "", l = 0; l < s.length; l += 2) o += String.fromCharCode("0x" + (s[l] + s[l + 1]));
    return o;
  }, i = function(s) {
    for (var a = new Uint8Array(s.length), o = s.length; o--; ) a[o] = s.charCodeAt(o);
    return (a = tm(a)).reduce(function(l, u) {
      return l + String.fromCharCode(u);
    }, "");
  };
  r.processDataByFilters = function(s, a) {
    var o = 0, l = s || "", u = [];
    for (typeof (a = a || []) == "string" && (a = [a]), o = 0; o < a.length; o += 1) switch (a[o]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        l = t(l), u.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        l = e(l), u.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        l = n(l), u.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        l = A(l), u.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        l = i(l), u.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + a[o] + '" is not implemented');
    }
    return { data: l, reverseChain: u.reverse().join(" ") };
  };
})(ot.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.loadFile = function(e, t, A) {
    return (function(n, i, s) {
      i = i !== !1, s = typeof s == "function" ? s : function() {
      };
      var a = void 0;
      try {
        a = (function(o, l, u) {
          var c = new XMLHttpRequest(), f = 0, h = function(g) {
            var p = g.length, v = [], w = String.fromCharCode;
            for (f = 0; f < p; f += 1) v.push(w(255 & g.charCodeAt(f)));
            return v.join("");
          };
          if (c.open("GET", o, !l), c.overrideMimeType("text/plain; charset=x-user-defined"), l === !1 && (c.onload = function() {
            c.status === 200 ? u(h(this.responseText)) : u(void 0);
          }), c.send(null), l && c.status === 200) return h(c.responseText);
        })(n, i, s);
      } catch {
      }
      return a;
    })(e, t, A);
  }, r.allowFsRead = void 0, r.loadImageFile = r.loadFile;
})(ot.API), (function(r) {
  function e() {
    return (Ct.html2canvas ? Promise.resolve(Ct.html2canvas) : Promise.resolve().then(() => sk)).catch(function(a) {
      return Promise.reject(new Error("Could not load html2canvas: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  function t() {
    return (Ct.DOMPurify ? Promise.resolve(Ct.DOMPurify) : Promise.resolve().then(() => Uk)).catch(function(a) {
      return Promise.reject(new Error("Could not load dompurify: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  var A = function(a) {
    var o = Xt(a);
    return o === "undefined" ? "undefined" : o === "string" || a instanceof String ? "string" : o === "number" || a instanceof Number ? "number" : o === "function" || a instanceof Function ? "function" : a && a.constructor === Array ? "array" : a && a.nodeType === 1 ? "element" : o === "object" ? "object" : "unknown";
  }, n = function(a, o) {
    var l = document.createElement(a);
    for (var u in o.className && (l.className = o.className), o.innerHTML && o.dompurify && (l.innerHTML = o.dompurify.sanitize(o.innerHTML)), o.style) l.style[u] = o.style[u];
    return l;
  }, i = function a(o, l) {
    for (var u = o.nodeType === 3 ? document.createTextNode(o.nodeValue) : o.cloneNode(!1), c = o.firstChild; c; c = c.nextSibling) l !== !0 && c.nodeType === 1 && c.nodeName === "SCRIPT" || u.appendChild(a(c, l));
    return o.nodeType === 1 && (o.nodeName === "CANVAS" ? (u.width = o.width, u.height = o.height, u.getContext("2d").drawImage(o, 0, 0)) : o.nodeName !== "TEXTAREA" && o.nodeName !== "SELECT" || (u.value = o.value), u.addEventListener("load", function() {
      u.scrollTop = o.scrollTop, u.scrollLeft = o.scrollLeft;
    }, !0)), u;
  }, s = function a(o) {
    var l = Object.assign(a.convert(Promise.resolve()), JSON.parse(JSON.stringify(a.template))), u = a.convert(Promise.resolve(), l);
    return (u = u.setProgress(1, a, 1, [a])).set(o);
  };
  (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(a, o) {
    return a.__proto__ = o || s.prototype, a;
  }, s.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, s.prototype.from = function(a, o) {
    return this.then(function() {
      switch (o = o || (function(l) {
        switch (A(l)) {
          case "string":
            return "string";
          case "element":
            return l.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      })(a), o) {
        case "string":
          return this.then(t).then(function(l) {
            return this.set({ src: n("div", { innerHTML: a, dompurify: l }) });
          });
        case "element":
          return this.set({ src: a });
        case "canvas":
          return this.set({ canvas: a });
        case "img":
          return this.set({ img: a });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, s.prototype.to = function(a) {
    switch (a) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, s.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var a = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, o = i(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      o.tagName === "BODY" && (a.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = n("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = n("div", { className: "html2pdf__container", style: a }), this.prop.container.appendChild(o), this.prop.container.firstChild.appendChild(n("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, s.prototype.toCanvas = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var l = Object.assign({}, this.opt.html2canvas);
      return delete l.onrendered, o(this.prop.container, l);
    }).then(function(o) {
      (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toContext2d = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var l = this.opt.jsPDF, u = this.opt.fontFaces, c = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, f = Object.assign({ async: !0, allowTaint: !0, scale: c, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete f.onrendered, l.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, l.context2d.posX = this.opt.x, l.context2d.posY = this.opt.y, l.context2d.margin = this.opt.margin, l.context2d.fontFaces = u, u) for (var h = 0; h < u.length; ++h) {
        var g = u[h], p = g.src.find(function(v) {
          return v.format === "truetype";
        });
        p && l.addFont(p.url, g.ref.name, g.ref.style);
      }
      return f.windowHeight = f.windowHeight || 0, f.windowHeight = f.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : f.windowHeight, l.context2d.save(!0), o(this.prop.container, f);
    }).then(function(o) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var a = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = a;
    });
  }, s.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, s.prototype.output = function(a, o, l) {
    return (l = l || "pdf").toLowerCase() === "img" || l.toLowerCase() === "image" ? this.outputImg(a, o) : this.outputPdf(a, o);
  }, s.prototype.outputPdf = function(a, o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(a, o);
    });
  }, s.prototype.outputImg = function(a) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (a) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + a + '" is not supported.';
      }
    });
  }, s.prototype.save = function(a) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(a ? { filename: a } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, s.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, s.prototype.set = function(a) {
    if (A(a) !== "object") return this;
    var o = Object.keys(a || {}).map(function(l) {
      if (l in s.template.prop) return function() {
        this.prop[l] = a[l];
      };
      switch (l) {
        case "margin":
          return this.setMargin.bind(this, a.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = a.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, a.pageSize);
        default:
          return function() {
            this.opt[l] = a[l];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(o);
    });
  }, s.prototype.get = function(a, o) {
    return this.then(function() {
      var l = a in s.template.prop ? this.prop[a] : this.opt[a];
      return o ? o(l) : l;
    });
  }, s.prototype.setMargin = function(a) {
    return this.then(function() {
      switch (A(a)) {
        case "number":
          a = [a, a, a, a];
        case "array":
          if (a.length === 2 && (a = [a[0], a[1], a[0], a[1]]), a.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = a;
    }).then(this.setPageSize);
  }, s.prototype.setPageSize = function(a) {
    function o(l, u) {
      return Math.floor(l * u / 72 * 96);
    }
    return this.then(function() {
      (a = a || ot.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (a.inner = { width: a.width - this.opt.margin[1] - this.opt.margin[3], height: a.height - this.opt.margin[0] - this.opt.margin[2] }, a.inner.px = { width: o(a.inner.width, a.k), height: o(a.inner.height, a.k) }, a.inner.ratio = a.inner.height / a.inner.width), this.prop.pageSize = a;
    });
  }, s.prototype.setProgress = function(a, o, l, u) {
    return a != null && (this.progress.val = a), o != null && (this.progress.state = o), l != null && (this.progress.n = l), u != null && (this.progress.stack = u), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, s.prototype.updateProgress = function(a, o, l, u) {
    return this.setProgress(a ? this.progress.val + a : null, o || null, l ? this.progress.n + l : null, u ? this.progress.stack.concat(u) : null);
  }, s.prototype.then = function(a, o) {
    var l = this;
    return this.thenCore(a, o, function(u, c) {
      return l.updateProgress(null, null, 1, [u]), Promise.prototype.then.call(this, function(f) {
        return l.updateProgress(null, u), f;
      }).then(u, c).then(function(f) {
        return l.updateProgress(1), f;
      });
    });
  }, s.prototype.thenCore = function(a, o, l) {
    l = l || Promise.prototype.then;
    var u = this;
    a && (a = a.bind(u)), o && (o = o.bind(u));
    var c = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? u : s.convert(Object.assign({}, u), Promise.prototype), f = l.call(c, a, o);
    return s.convert(f, u.__proto__);
  }, s.prototype.thenExternal = function(a, o) {
    return Promise.prototype.then.call(this, a, o);
  }, s.prototype.thenList = function(a) {
    var o = this;
    return a.forEach(function(l) {
      o = o.thenCore(l);
    }), o;
  }, s.prototype.catch = function(a) {
    a && (a = a.bind(this));
    var o = Promise.prototype.catch.call(this, a);
    return s.convert(o, this);
  }, s.prototype.catchExternal = function(a) {
    return Promise.prototype.catch.call(this, a);
  }, s.prototype.error = function(a) {
    return this.then(function() {
      throw new Error(a);
    });
  }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, ot.getPageSize = function(a, o, l) {
    if (Xt(a) === "object") {
      var u = a;
      a = u.orientation, o = u.unit || o, l = u.format || l;
    }
    o = o || "mm", l = l || "a4", a = ("" + (a || "P")).toLowerCase();
    var c, f = ("" + l).toLowerCase(), h = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (o) {
      case "pt":
        c = 1;
        break;
      case "mm":
        c = 72 / 25.4;
        break;
      case "cm":
        c = 72 / 2.54;
        break;
      case "in":
        c = 72;
        break;
      case "px":
        c = 0.75;
        break;
      case "pc":
      case "em":
        c = 12;
        break;
      case "ex":
        c = 6;
        break;
      default:
        throw "Invalid unit: " + o;
    }
    var g, p = 0, v = 0;
    if (h.hasOwnProperty(f)) p = h[f][1] / c, v = h[f][0] / c;
    else try {
      p = l[1], v = l[0];
    } catch {
      throw new Error("Invalid format: " + l);
    }
    if (a === "p" || a === "portrait") a = "p", v > p && (g = v, v = p, p = g);
    else {
      if (a !== "l" && a !== "landscape") throw "Invalid orientation: " + a;
      a = "l", p > v && (g = v, v = p, p = g);
    }
    return { width: v, height: p, unit: o, k: c, orientation: a };
  }, r.html = function(a, o) {
    (o = o || {}).callback = o.callback || function() {
    }, o.html2canvas = o.html2canvas || {}, o.html2canvas.canvas = o.html2canvas.canvas || this.canvas, o.jsPDF = o.jsPDF || this, o.fontFaces = o.fontFaces ? o.fontFaces.map(vd) : null;
    var l = new s(o);
    return o.worker ? l : l.from(a).doCallback();
  };
})(ot.API), ot.API.addJS = function(r) {
  return Zw = r, this.internal.events.subscribe("postPutResources", function() {
    Sc = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Sc + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), Jw = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Zw + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    Sc !== void 0 && Jw !== void 0 && this.internal.out("/Names <</JavaScript " + Sc + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e;
  r.events.push(["postPutResources", function() {
    var t = this, A = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
      var s = n[i], a = A.exec(s);
      if (a != null) {
        var o = a[1];
        t.internal.newObjectDeferredBegin(o, !1);
      }
      t.internal.write(s);
    }
    if (this.outline.createNamedDestinations) {
      var l = this.internal.pages.length, u = [];
      for (i = 0; i < l; i++) {
        var c = t.internal.newObject();
        u.push(c);
        var f = t.internal.getPageInfo(i + 1);
        t.internal.write("<< /D[" + f.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var h = t.internal.newObject();
      for (t.internal.write("<< /Names [ "), i = 0; i < u.length; i++) t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
      t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + h + " 0 R"), t.internal.write(">>", "endobj");
    }
  }]), r.events.push(["putCatalog", function() {
    var t = this;
    t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
  }]), r.events.push(["initialized", function() {
    var t = this;
    t.outline = { createNamedDestinations: !1, root: { children: [] } }, t.outline.add = function(A, n, i) {
      var s = { title: n, options: i, children: [] };
      return A == null && (A = this.root), A.children.push(s), s;
    }, t.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, t.outline.genIds_r = function(A) {
      A.id = t.internal.newObjectDeferred();
      for (var n = 0; n < A.children.length; n++) this.genIds_r(A.children[n]);
    }, t.outline.renderRoot = function(A) {
      this.objStart(A), this.line("/Type /Outlines"), A.children.length > 0 && (this.line("/First " + this.makeRef(A.children[0])), this.line("/Last " + this.makeRef(A.children[A.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, A)), this.objEnd();
    }, t.outline.renderItems = function(A) {
      for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, i = 0; i < A.children.length; i++) {
        var s = A.children[i];
        this.objStart(s), this.line("/Title " + this.makeString(s.title)), this.line("/Parent " + this.makeRef(A)), i > 0 && this.line("/Prev " + this.makeRef(A.children[i - 1])), i < A.children.length - 1 && this.line("/Next " + this.makeRef(A.children[i + 1])), s.children.length > 0 && (this.line("/First " + this.makeRef(s.children[0])), this.line("/Last " + this.makeRef(s.children[s.children.length - 1])));
        var a = this.count = this.count_r({ count: 0 }, s);
        if (a > 0 && this.line("/Count " + a), s.options && s.options.pageNumber) {
          var o = t.internal.getPageInfo(s.options.pageNumber);
          this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
        }
        this.objEnd();
      }
      for (var l = 0; l < A.children.length; l++) this.renderItems(A.children[l]);
    }, t.outline.line = function(A) {
      this.ctx.val += A + `\r
`;
    }, t.outline.makeRef = function(A) {
      return A.id + " 0 R";
    }, t.outline.makeString = function(A) {
      return "(" + t.internal.pdfEscape(A) + ")";
    }, t.outline.objStart = function(A) {
      this.ctx.val += `\r
` + A.id + ` 0 obj\r
<<\r
`;
    }, t.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, t.outline.count_r = function(A, n) {
      for (var i = 0; i < n.children.length; i++) A.count++, this.count_r(A, n.children[i]);
      return A.count;
    };
  }]);
})(ot.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = [192, 193, 194, 195, 196, 197, 198, 199];
  r.processJPEG = function(t, A, n, i, s, a) {
    var o, l = this.decode.DCT_DECODE, u = null;
    if (typeof t == "string" || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
      switch (t = s || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, o = (function(c) {
        for (var f, h = 256 * c.charCodeAt(4) + c.charCodeAt(5), g = c.length, p = { width: 0, height: 0, numcomponents: 1 }, v = 4; v < g; v += 2) {
          if (v += h, e.indexOf(c.charCodeAt(v + 1)) !== -1) {
            f = 256 * c.charCodeAt(v + 5) + c.charCodeAt(v + 6), p = { width: 256 * c.charCodeAt(v + 7) + c.charCodeAt(v + 8), height: f, numcomponents: c.charCodeAt(v + 9) };
            break;
          }
          h = 256 * c.charCodeAt(v + 2) + c.charCodeAt(v + 3);
        }
        return p;
      })(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), o.numcomponents) {
        case 1:
          a = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          a = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          a = this.color_spaces.DEVICE_RGB;
      }
      u = { data: t, width: o.width, height: o.height, colorSpace: a, bitsPerComponent: 8, filter: l, index: A, alias: n };
    }
    return u;
  };
})(ot.API), ot.API.processPNG = function(r, e, t, A) {
  if (this.__addimage__.isArrayBuffer(r) && (r = new Uint8Array(r)), this.__addimage__.isArrayBufferView(r)) {
    var n, i = KQ(r, { checkCrc: !0 }), s = i.width, a = i.height, o = i.channels, l = i.palette, u = i.depth;
    n = l && o === 1 ? (function(N) {
      for (var _ = N.width, R = N.height, F = N.data, O = N.palette, G = N.depth, H = !1, $ = [], ne = [], te = void 0, J = !1, re = 0, le = 0; le < O.length; le++) {
        var se = Aw(O[le], 4), P = se[0], V = se[1], X = se[2], Y = se[3];
        $.push(P, V, X), Y != null && (Y === 0 ? (re++, ne.length < 1 && ne.push(le)) : Y < 255 && (J = !0));
      }
      if (J || re > 1) {
        H = !0, ne = void 0;
        var ee = _ * R;
        te = new Uint8Array(ee);
        for (var oe = new DataView(F.buffer), ge = 0; ge < ee; ge++) {
          var pe = yd(oe, ge, G), me = Aw(O[pe], 4)[3];
          te[ge] = me;
        }
      } else re === 0 && (ne = void 0);
      return { colorSpace: "Indexed", colorsPerPixel: 1, sMaskBitsPerComponent: H ? 8 : void 0, colorBytes: F, alphaBytes: te, needSMask: H, palette: $, mask: ne };
    })(i) : o === 2 || o === 4 ? (function(N) {
      for (var _ = N.data, R = N.width, F = N.height, O = N.channels, G = N.depth, H = O === 2 ? "DeviceGray" : "DeviceRGB", $ = O - 1, ne = R * F, te = $, J = ne * te, re = 1 * ne, le = Math.ceil(J * G / 8), se = Math.ceil(re * G / 8), P = new Uint8Array(le), V = new Uint8Array(se), X = new DataView(_.buffer), Y = new DataView(P.buffer), ee = new DataView(V.buffer), oe = !1, ge = 0; ge < ne; ge++) {
        for (var pe = ge * O, me = 0; me < te; me++) oy(Y, yd(X, pe + me, G), ge * te + me, G);
        var Ee = yd(X, pe + te, G);
        Ee < (1 << G) - 1 && (oe = !0), oy(ee, Ee, 1 * ge, G);
      }
      return { colorSpace: H, colorsPerPixel: $, sMaskBitsPerComponent: oe ? G : void 0, colorBytes: P, alphaBytes: V, needSMask: oe };
    })(i) : (function(N) {
      var _ = N.data, R = N.channels === 1 ? "DeviceGray" : "DeviceRGB";
      return { colorSpace: R, colorsPerPixel: R === "DeviceGray" ? 1 : 3, colorBytes: _ instanceof Uint16Array ? (function(F) {
        for (var O = F.length, G = new Uint8Array(2 * O), H = new DataView(G.buffer, G.byteOffset, G.byteLength), $ = 0; $ < O; $++) H.setUint16(2 * $, F[$], !1);
        return G;
      })(_) : _, needSMask: !1 };
    })(i);
    var c, f, h, g = n, p = g.colorSpace, v = g.colorsPerPixel, w = g.sMaskBitsPerComponent, b = g.colorBytes, S = g.alphaBytes, B = g.needSMask, x = g.palette, U = g.mask, Q = null;
    return A !== ot.API.image_compression.NONE && typeof tm == "function" ? (Q = (function(N) {
      var _;
      switch (N) {
        case ot.API.image_compression.FAST:
          _ = 11;
          break;
        case ot.API.image_compression.MEDIUM:
          _ = 13;
          break;
        case ot.API.image_compression.SLOW:
          _ = 14;
          break;
        default:
          _ = 12;
      }
      return _;
    })(A), c = this.decode.FLATE_DECODE, f = "/Predictor ".concat(Q, " /Colors ").concat(v, " /BitsPerComponent ").concat(u, " /Columns ").concat(s), r = Ay(b, Math.ceil(s * v * u / 8), v, u, A), B && (h = Ay(S, Math.ceil(s * w / 8), 1, w, A))) : (c = void 0, f = void 0, r = b, B && (h = S)), (this.__addimage__.isArrayBuffer(r) || this.__addimage__.isArrayBufferView(r)) && (r = this.__addimage__.arrayBufferToBinaryString(r)), (h && this.__addimage__.isArrayBuffer(h) || this.__addimage__.isArrayBufferView(h)) && (h = this.__addimage__.arrayBufferToBinaryString(h)), { alias: t, data: r, index: e, filter: c, decodeParameters: f, transparency: U, palette: x, sMask: h, predictor: Q, width: s, height: a, bitsPerComponent: u, sMaskBitsPerComponent: w, colorSpace: p };
  }
}, (function(r) {
  r.processGIF89A = function(e, t, A, n) {
    var i = new cL(e), s = i.width, a = i.height, o = [];
    i.decodeAndBlitFrameRGBA(0, o);
    var l = { data: o, width: s, height: a }, u = new bd(100).encode(l, 100);
    return r.processJPEG.call(this, u, t, A, n);
  }, r.processGIF87A = r.processGIF89A;
})(ot.API), Zn.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var r = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(r);
    for (var e = 0; e < r; e++) {
      var t = this.datav.getUint8(this.pos++, !0), A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0);
      this.palette[e] = { red: n, green: A, blue: t, quad: i };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, Zn.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var r = "bit" + this.bitPP, e = this.width * this.height * 4;
    this.data = new Uint8Array(e), this[r]();
  } catch (t) {
    ur.log("bit decode error:" + t);
  }
}, Zn.prototype.bit1 = function() {
  var r, e = Math.ceil(this.width / 8), t = e % 4;
  for (r = this.height - 1; r >= 0; r--) {
    for (var A = this.bottom_up ? r : this.height - 1 - r, n = 0; n < e; n++) for (var i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 8 * n * 4, a = 0; a < 8 && 8 * n + a < this.width; a++) {
      var o = this.palette[i >> 7 - a & 1];
      this.data[s + 4 * a] = o.blue, this.data[s + 4 * a + 1] = o.green, this.data[s + 4 * a + 2] = o.red, this.data[s + 4 * a + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, Zn.prototype.bit4 = function() {
  for (var r = Math.ceil(this.width / 2), e = r % 4, t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, n = 0; n < r; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 2 * n * 4, a = i >> 4, o = 15 & i, l = this.palette[a];
      if (this.data[s] = l.blue, this.data[s + 1] = l.green, this.data[s + 2] = l.red, this.data[s + 3] = 255, 2 * n + 1 >= this.width) break;
      l = this.palette[o], this.data[s + 4] = l.blue, this.data[s + 4 + 1] = l.green, this.data[s + 4 + 2] = l.red, this.data[s + 4 + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, Zn.prototype.bit8 = function() {
  for (var r = this.width % 4, e = this.height - 1; e >= 0; e--) {
    for (var t = this.bottom_up ? e : this.height - 1 - e, A = 0; A < this.width; A++) {
      var n = this.datav.getUint8(this.pos++, !0), i = t * this.width * 4 + 4 * A;
      if (n < this.palette.length) {
        var s = this.palette[n];
        this.data[i] = s.red, this.data[i + 1] = s.green, this.data[i + 2] = s.blue, this.data[i + 3] = 255;
      } else this.data[i] = 255, this.data[i + 1] = 255, this.data[i + 2] = 255, this.data[i + 3] = 255;
    }
    r !== 0 && (this.pos += 4 - r);
  }
}, Zn.prototype.bit15 = function() {
  for (var r = this.width % 3, e = parseInt("11111", 2), t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (i & e) / e * 255 | 0, a = (i >> 5 & e) / e * 255 | 0, o = (i >> 10 & e) / e * 255 | 0, l = i >> 15 ? 255 : 0, u = A * this.width * 4 + 4 * n;
      this.data[u] = o, this.data[u + 1] = a, this.data[u + 2] = s, this.data[u + 3] = l;
    }
    this.pos += r;
  }
}, Zn.prototype.bit16 = function() {
  for (var r = this.width % 3, e = parseInt("11111", 2), t = parseInt("111111", 2), A = this.height - 1; A >= 0; A--) {
    for (var n = this.bottom_up ? A : this.height - 1 - A, i = 0; i < this.width; i++) {
      var s = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var a = (s & e) / e * 255 | 0, o = (s >> 5 & t) / t * 255 | 0, l = (s >> 11) / e * 255 | 0, u = n * this.width * 4 + 4 * i;
      this.data[u] = l, this.data[u + 1] = o, this.data[u + 2] = a, this.data[u + 3] = 255;
    }
    this.pos += r;
  }
}, Zn.prototype.bit24 = function() {
  for (var r = this.height - 1; r >= 0; r--) {
    for (var e = this.bottom_up ? r : this.height - 1 - r, t = 0; t < this.width; t++) {
      var A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * t;
      this.data[s] = i, this.data[s + 1] = n, this.data[s + 2] = A, this.data[s + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, Zn.prototype.bit32 = function() {
  for (var r = this.height - 1; r >= 0; r--) for (var e = this.bottom_up ? r : this.height - 1 - r, t = 0; t < this.width; t++) {
    var A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * t;
    this.data[a] = i, this.data[a + 1] = n, this.data[a + 2] = A, this.data[a + 3] = s;
  }
}, Zn.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processBMP = function(e, t, A, n) {
    var i = new Zn(e, !1), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new bd(100).encode(o, 100);
    return r.processJPEG.call(this, l, t, A, n);
  };
})(ot.API), uy.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processWEBP = function(e, t, A, n) {
    var i = new uy(e), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new bd(100).encode(o, 100);
    return r.processJPEG.call(this, l, t, A, n);
  };
})(ot.API), ot.API.processRGBA = function(r, e, t) {
  for (var A = r.data, n = A.length, i = new Uint8Array(n / 4 * 3), s = new Uint8Array(n / 4), a = 0, o = 0, l = 0; l < n; l += 4) {
    var u = A[l], c = A[l + 1], f = A[l + 2], h = A[l + 3];
    i[a++] = u, i[a++] = c, i[a++] = f, s[o++] = h;
  }
  var g = this.__addimage__.arrayBufferToBinaryString(i);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(s), data: g, index: e, alias: t, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: r.width, height: r.height };
}, ot.API.setLanguage = function(r) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[r] !== void 0 && (this.internal.languageSettings.languageCode = r, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, lo = ot.API, xc = lo.getCharWidthsArray = function(r, e) {
  var t, A, n = (e = e || {}).font || this.internal.getFont(), i = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), a = e.widths ? e.widths : n.metadata.Unicode.widths, o = a.fof ? a.fof : 1, l = e.kerning ? e.kerning : n.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, c = e.doKerning !== !1, f = 0, h = r.length, g = 0, p = a[0] || o, v = [];
  for (t = 0; t < h; t++) A = r.charCodeAt(t), typeof n.metadata.widthOfString == "function" ? v.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(A)) + s * (1e3 / i) || 0) / 1e3) : (f = c && Xt(l[A]) === "object" && !isNaN(parseInt(l[A][g], 10)) ? l[A][g] / u : 0, v.push((a[A] || p) / o + f)), g = A;
  return v;
}, ey = lo.getStringUnitWidth = function(r, e) {
  var t = (e = e || {}).fontSize || this.internal.getFontSize(), A = e.font || this.internal.getFont(), n = e.charSpace || this.internal.getCharSpace();
  return lo.processArabic && (r = lo.processArabic(r)), typeof A.metadata.widthOfString == "function" ? A.metadata.widthOfString(r, t, n) / t : xc.apply(this, arguments).reduce(function(i, s) {
    return i + s;
  }, 0);
}, ty = function(r, e, t, A) {
  for (var n = [], i = 0, s = r.length, a = 0; i !== s && a + e[i] < t; ) a += e[i], i++;
  n.push(r.slice(0, i));
  var o = i;
  for (a = 0; i !== s; ) a + e[i] > A && (n.push(r.slice(o, i)), a = 0, o = i), a += e[i], i++;
  return o !== i && n.push(r.slice(o, i)), n;
}, ry = function(r, e, t) {
  t || (t = {});
  var A, n, i, s, a, o, l, u = [], c = [u], f = t.textIndent || 0, h = 0, g = 0, p = r.split(" "), v = xc.apply(this, [" ", t])[0];
  if (o = t.lineIndent === -1 ? p[0].length + 2 : t.lineIndent || 0) {
    var w = Array(o).join(" "), b = [];
    p.map(function(B) {
      (B = B.split(/\s*\n/)).length > 1 ? b = b.concat(B.map(function(x, U) {
        return (U && x.length ? `
` : "") + x;
      })) : b.push(B[0]);
    }), p = b, o = ey.apply(this, [w, t]);
  }
  for (i = 0, s = p.length; i < s; i++) {
    var S = 0;
    if (A = p[i], o && A[0] == `
` && (A = A.substr(1), S = 1), f + h + (g = (n = xc.apply(this, [A, t])).reduce(function(B, x) {
      return B + x;
    }, 0)) > e || S) {
      if (g > e) {
        for (a = ty.apply(this, [A, n, e - (f + h), e]), u.push(a.shift()), u = [a.pop()]; a.length; ) c.push([a.shift()]);
        g = n.slice(A.length - (u[0] ? u[0].length : 0)).reduce(function(B, x) {
          return B + x;
        }, 0);
      } else u = [A];
      c.push(u), f = g + o, h = v;
    } else u.push(A), f += h + g, h = v;
  }
  return l = o ? function(B, x) {
    return (x ? w : "") + B.join(" ");
  } : function(B) {
    return B.join(" ");
  }, c.map(l);
}, lo.splitTextToSize = function(r, e, t) {
  var A, n = (t = t || {}).fontSize || this.internal.getFontSize(), i = (function(u) {
    if (u.widths && u.kerning) return { widths: u.widths, kerning: u.kerning };
    var c = this.internal.getFont(u.fontName, u.fontStyle), f = "Unicode";
    return c.metadata[f] ? { widths: c.metadata[f].widths || { 0: 1 }, kerning: c.metadata[f].kerning || {} } : { font: c.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, t);
  A = Array.isArray(r) ? r : String(r).split(/\r?\n/);
  var s = 1 * this.internal.scaleFactor * e / n;
  i.textIndent = t.textIndent ? 1 * t.textIndent * this.internal.scaleFactor / n : 0, i.lineIndent = t.lineIndent;
  var a, o, l = [];
  for (a = 0, o = A.length; a < o; a++) l = l.concat(ry.apply(this, [A[a], s, i]));
  return l;
}, (function(r) {
  r.__fontmetrics__ = r.__fontmetrics__ || {};
  for (var e = "0123456789abcdef", t = "klmnopqrstuvwxyz", A = {}, n = {}, i = 0; i < 16; i++) A[t[i]] = e[i], n[e[i]] = t[i];
  var s = function(f) {
    return "0x" + parseInt(f, 10).toString(16);
  }, a = r.__fontmetrics__.compress = function(f) {
    var h, g, p, v, w = ["{"];
    for (var b in f) {
      if (h = f[b], isNaN(parseInt(b, 10)) ? g = "'" + b + "'" : (b = parseInt(b, 10), g = (g = s(b).slice(2)).slice(0, -1) + n[g.slice(-1)]), typeof h == "number") h < 0 ? (p = s(h).slice(3), v = "-") : (p = s(h).slice(2), v = ""), p = v + p.slice(0, -1) + n[p.slice(-1)];
      else {
        if (Xt(h) !== "object") throw new Error("Don't know what to do with value type " + Xt(h) + ".");
        p = a(h);
      }
      w.push(g + p);
    }
    return w.push("}"), w.join("");
  }, o = r.__fontmetrics__.uncompress = function(f) {
    if (typeof f != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var h, g, p, v, w = {}, b = 1, S = w, B = [], x = "", U = "", Q = f.length - 1, N = 1; N < Q; N += 1) (v = f[N]) == "'" ? h ? (p = h.join(""), h = void 0) : h = [] : h ? h.push(v) : v == "{" ? (B.push([S, p]), S = {}, p = void 0) : v == "}" ? ((g = B.pop())[0][g[1]] = S, p = void 0, S = g[0]) : v == "-" ? b = -1 : p === void 0 ? A.hasOwnProperty(v) ? (x += A[v], p = parseInt(x, 16) * b, b = 1, x = "") : x += v : A.hasOwnProperty(v) ? (U += A[v], S[p] = parseInt(U, 16) * b, b = 1, p = void 0, U = "") : U += v;
    return w;
  }, l = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: o("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, u = { Unicode: { Courier: l, "Courier-Bold": l, "Courier-BoldOblique": l, "Courier-Oblique": l, Helvetica: l, "Helvetica-Bold": l, "Helvetica-BoldOblique": l, "Helvetica-Oblique": l, "Times-Roman": l, "Times-Bold": l, "Times-BoldItalic": l, "Times-Italic": l } }, c = { Unicode: { "Courier-Oblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": o("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": o("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: o("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: o("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": o("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": o("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  r.events.push(["addFont", function(f) {
    var h = f.font, g = c.Unicode[h.postScriptName];
    g && (h.metadata.Unicode = {}, h.metadata.Unicode.widths = g.widths, h.metadata.Unicode.kerning = g.kerning);
    var p = u.Unicode[h.postScriptName];
    p && (h.metadata.Unicode.encoding = p, h.encoding = p.codePages[0]);
  }]);
})(ot.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(t) {
    for (var A = t.length, n = new Uint8Array(A), i = 0; i < A; i++) n[i] = t.charCodeAt(i);
    return n;
  };
  r.API.events.push(["addFont", function(t) {
    var A = void 0, n = t.font, i = t.instance;
    if (!n.isStandardFont) {
      if (i === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      if (typeof (A = i.existsFileInVFS(n.postScriptName) === !1 ? i.loadFile(n.postScriptName) : i.getFileFromVFS(n.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      (function(s, a) {
        a = /^\x00\x01\x00\x00/.test(a) ? e(a) : e(ih(a)), s.metadata = r.API.TTFFont.open(a), s.metadata.Unicode = s.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, s.metadata.glyIdsUsed = [0];
      })(n, A);
    }
  }]);
})(ot), ot.API.addSvgAsImage = function(r, e, t, A, n, i, s, a) {
  if (isNaN(e) || isNaN(t)) throw ur.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
  if (isNaN(A) || isNaN(n)) throw ur.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
  var o = document.createElement("canvas");
  o.width = A, o.height = n;
  var l = o.getContext("2d");
  l.fillStyle = "#fff", l.fillRect(0, 0, o.width, o.height);
  var u = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, c = this;
  return (Ct.canvg ? Promise.resolve(Ct.canvg) : Promise.resolve().then(() => O8)).catch(function(f) {
    return Promise.reject(new Error("Could not load canvg: " + f));
  }).then(function(f) {
    return f.default ? f.default : f;
  }).then(function(f) {
    return f.fromString(l, r, u);
  }, function() {
    return Promise.reject(new Error("Could not load canvg."));
  }).then(function(f) {
    return f.render(u);
  }).then(function() {
    c.addImage(o.toDataURL("image/jpeg", 1), e, t, A, n, s, a);
  });
}, ot.API.putTotalPages = function(r) {
  var e, t = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(r, "g"), t = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(r, this.internal.getFont()), "g"), t = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var A = 1; A <= this.internal.getNumberOfPages(); A++) for (var n = 0; n < this.internal.pages[A].length; n++) this.internal.pages[A][n] = this.internal.pages[A][n].replace(e, t);
  return this;
}, ot.API.viewerPreferences = function(r, e) {
  var t;
  r = r || {}, e = e || !1;
  var A, n, i, s = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, a = Object.keys(s), o = [], l = 0, u = 0, c = 0;
  function f(g, p) {
    var v, w = !1;
    for (v = 0; v < g.length; v += 1) g[v] === p && (w = !0);
    return w;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), t = this.internal.viewerpreferences.configuration, r === "reset" || e === !0) {
    var h = a.length;
    for (c = 0; c < h; c += 1) t[a[c]].value = t[a[c]].defaultValue, t[a[c]].explicitSet = !1;
  }
  if (Xt(r) === "object") {
    for (n in r) if (i = r[n], f(a, n) && i !== void 0) {
      if (t[n].type === "boolean" && typeof i == "boolean") t[n].value = i;
      else if (t[n].type === "name" && f(t[n].valueSet, i)) t[n].value = i;
      else if (t[n].type === "integer" && Number.isInteger(i)) t[n].value = i;
      else if (t[n].type === "array") {
        for (l = 0; l < i.length; l += 1) if (A = !0, i[l].length === 1 && typeof i[l][0] == "number") o.push(String(i[l] - 1));
        else if (i[l].length > 1) {
          for (u = 0; u < i[l].length; u += 1) typeof i[l][u] != "number" && (A = !1);
          A === !0 && o.push([i[l][0] - 1, i[l][1] - 1].join(" "));
        }
        t[n].value = "[" + o.join(" ") + "]";
      } else t[n].value = t[n].defaultValue;
      t[n].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var g, p = [];
    for (g in t) t[g].explicitSet === !0 && (t[g].type === "name" ? p.push("/" + g + " /" + t[g].value) : p.push("/" + g + " " + t[g].value));
    p.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + p.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = t, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
(function(r) {
  var e = function() {
    var A = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', n = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), i = unescape(encodeURIComponent(A)), s = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), a = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), l = i.length + s.length + a.length + n.length + o.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + l + " >>"), this.internal.write("stream"), this.internal.write(n + i + s + a + o), this.internal.write("endstream"), this.internal.write("endobj");
  }, t = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  r.addMetadata = function(A, n) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: A, namespaceuri: n || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", t), this.internal.events.subscribe("postPutResources", e)), this;
  };
})(ot.API), (function(r) {
  var e = r.API, t = e.pdfEscape16 = function(i, s) {
    for (var a, o = s.metadata.Unicode.widths, l = ["", "0", "00", "000", "0000"], u = [""], c = 0, f = i.length; c < f; ++c) {
      if (a = s.metadata.characterToGlyph(i.charCodeAt(c)), s.metadata.glyIdsUsed.push(a), s.metadata.toUnicode[a] = i.charCodeAt(c), o.indexOf(a) == -1 && (o.push(a), o.push([parseInt(s.metadata.widthOfGlyph(a), 10)])), a == "0") return u.join("");
      a = a.toString(16), u.push(l[4 - a.length], a);
    }
    return u.join("");
  }, A = function(i) {
    var s, a, o, l, u, c, f;
    for (u = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, o = [], c = 0, f = (a = Object.keys(i).sort(function(h, g) {
      return h - g;
    })).length; c < f; c++) s = a[c], o.length >= 100 && (u += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar`, o = []), i[s] !== void 0 && i[s] !== null && typeof i[s].toString == "function" && (l = ("0000" + i[s].toString(16)).slice(-4), s = ("0000" + (+s).toString(16)).slice(-4), o.push("<" + s + "><" + l + ">"));
    return o.length && (u += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar
`), u + `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  e.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, u = s.putStream;
      if (a.metadata instanceof r.API.TTFFont && a.encoding === "Identity-H") {
        for (var c = a.metadata.Unicode.widths, f = a.metadata.subset.encode(a.metadata.glyIdsUsed, 1), h = "", g = 0; g < f.length; g++) h += String.fromCharCode(f[g]);
        var p = l();
        u({ data: h, addLength1: !0, objectId: p }), o("endobj");
        var v = l();
        u({ data: A(a.metadata.toUnicode), addLength1: !0, objectId: v }), o("endobj");
        var w = l();
        o("<<"), o("/Type /FontDescriptor"), o("/FontName /" + bo(a.fontName)), o("/FontFile2 " + p + " 0 R"), o("/FontBBox " + r.API.PDFObject.convert(a.metadata.bbox)), o("/Flags " + a.metadata.flags), o("/StemV " + a.metadata.stemV), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o(">>"), o("endobj");
        var b = l();
        o("<<"), o("/Type /Font"), o("/BaseFont /" + bo(a.fontName)), o("/FontDescriptor " + w + " 0 R"), o("/W " + r.API.PDFObject.convert(c)), o("/CIDToGIDMap /Identity"), o("/DW 1000"), o("/Subtype /CIDFontType2"), o("/CIDSystemInfo"), o("<<"), o("/Supplement 0"), o("/Registry (Adobe)"), o("/Ordering (" + a.encoding + ")"), o(">>"), o(">>"), o("endobj"), a.objectNumber = l(), o("<<"), o("/Type /Font"), o("/Subtype /Type0"), o("/ToUnicode " + v + " 0 R"), o("/BaseFont /" + bo(a.fontName)), o("/Encoding /" + a.encoding), o("/DescendantFonts [" + b + " 0 R]"), o(">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]), e.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, u = s.putStream;
      if (a.metadata instanceof r.API.TTFFont && a.encoding === "WinAnsiEncoding") {
        for (var c = a.metadata.rawData, f = "", h = 0; h < c.length; h++) f += String.fromCharCode(c[h]);
        var g = l();
        u({ data: f, addLength1: !0, objectId: g }), o("endobj");
        var p = l();
        u({ data: A(a.metadata.toUnicode), addLength1: !0, objectId: p }), o("endobj");
        var v = l();
        o("<<"), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o("/StemV " + a.metadata.stemV), o("/Type /FontDescriptor"), o("/FontFile2 " + g + " 0 R"), o("/Flags 96"), o("/FontBBox " + r.API.PDFObject.convert(a.metadata.bbox)), o("/FontName /" + bo(a.fontName)), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o(">>"), o("endobj"), a.objectNumber = l();
        for (var w = 0; w < a.metadata.hmtx.widths.length; w++) a.metadata.hmtx.widths[w] = parseInt(a.metadata.hmtx.widths[w] * (1e3 / a.metadata.head.unitsPerEm));
        o("<</Subtype/TrueType/Type/Font/ToUnicode " + p + " 0 R/BaseFont/" + bo(a.fontName) + "/FontDescriptor " + v + " 0 R/Encoding/" + a.encoding + " /FirstChar 29 /LastChar 255 /Widths " + r.API.PDFObject.convert(a.metadata.hmtx.widths) + ">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]);
  var n = function(i) {
    var s, a = i.text || "", o = i.x, l = i.y, u = i.options || {}, c = i.mutex || {}, f = c.pdfEscape, h = c.activeFontKey, g = c.fonts, p = h, v = "", w = 0, b = "", S = g[p].encoding;
    if (g[p].encoding !== "Identity-H") return { text: a, x: o, y: l, options: u, mutex: c };
    for (b = a, p = h, Array.isArray(a) && (b = a[0]), w = 0; w < b.length; w += 1) g[p].metadata.hasOwnProperty("cmap") && (s = g[p].metadata.cmap.unicode.codeMap[b[w].charCodeAt(0)]), s || b[w].charCodeAt(0) < 256 && g[p].metadata.hasOwnProperty("Unicode") ? v += b[w] : v += "";
    var B = "";
    return parseInt(p.slice(1)) < 14 || S === "WinAnsiEncoding" ? B = f(v, p).split("").map(function(x) {
      return x.charCodeAt(0).toString(16);
    }).join("") : S === "Identity-H" && (B = t(v, g[p])), c.isHex = !0, { text: B, x: o, y: l, options: u, mutex: c };
  };
  e.events.push(["postProcessText", function(i) {
    var s = i.text || "", a = [], o = { text: s, x: i.x, y: i.y, options: i.options, mutex: i.mutex };
    if (Array.isArray(s)) {
      var l = 0;
      for (l = 0; l < s.length; l += 1) Array.isArray(s[l]) && s[l].length === 3 ? a.push([n(Object.assign({}, o, { text: s[l][0] })).text, s[l][1], s[l][2]]) : a.push(n(Object.assign({}, o, { text: s[l] })).text);
      i.text = a;
    } else i.text = n(Object.assign({}, o, { text: s })).text;
  }]);
})(ot), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  r.existsFileInVFS = function(t) {
    return e.call(this), this.internal.vFS[t] !== void 0;
  }, r.addFileToVFS = function(t, A) {
    return e.call(this), this.internal.vFS[t] = A, this;
  }, r.getFileFromVFS = function(t) {
    return e.call(this), this.internal.vFS[t] !== void 0 ? this.internal.vFS[t] : null;
  };
})(ot.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
(function(r) {
  r.__bidiEngine__ = r.prototype.__bidiEngine__ = function(A) {
    var n, i, s, a, o, l, u, c = e, f = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], h = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], g = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, p = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, v = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], w = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), b = !1, S = 0;
    this.__bidiEngine__ = {};
    var B = function(F) {
      var O = F.charCodeAt(), G = O >> 8, H = p[G];
      return H !== void 0 ? c[256 * H + (255 & O)] : G === 252 || G === 253 ? "AL" : w.test(G) ? "L" : G === 8 ? "R" : "N";
    }, x = function(F) {
      for (var O, G = 0; G < F.length; G++) {
        if ((O = B(F.charAt(G))) === "L") return !1;
        if (O === "R") return !0;
      }
      return !1;
    }, U = function(F, O, G, H) {
      var $, ne, te, J, re = O[H];
      switch (re) {
        case "L":
        case "R":
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          b = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          b && (re = "AN");
          break;
        case "AL":
          b = !0, re = "R";
          break;
        case "WS":
        case "BN":
          re = "N";
          break;
        case "CS":
          H < 1 || H + 1 >= O.length || ($ = G[H - 1]) !== "EN" && $ !== "AN" || (ne = O[H + 1]) !== "EN" && ne !== "AN" ? re = "N" : b && (ne = "AN"), re = ne === $ ? ne : "N";
          break;
        case "ES":
          re = ($ = H > 0 ? G[H - 1] : "B") === "EN" && H + 1 < O.length && O[H + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (H > 0 && G[H - 1] === "EN") {
            re = "EN";
            break;
          }
          if (b) {
            re = "N";
            break;
          }
          for (te = H + 1, J = O.length; te < J && O[te] === "ET"; ) te++;
          re = te < J && O[te] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (s && !a) {
            for (J = O.length, te = H + 1; te < J && O[te] === "NSM"; ) te++;
            if (te < J) {
              var le = F[H], se = le >= 1425 && le <= 2303 || le === 64286;
              if ($ = O[te], se && ($ === "R" || $ === "AL")) {
                re = "R";
                break;
              }
            }
          }
          re = H < 1 || ($ = O[H - 1]) === "B" ? "N" : G[H - 1];
          break;
        case "B":
          b = !1, n = !0, re = S;
          break;
        case "S":
          i = !0, re = "N";
      }
      return re;
    }, Q = function(F, O, G) {
      var H = F.split("");
      return G && N(H, G, { hiLevel: S }), H.reverse(), O && O.reverse(), H.join("");
    }, N = function(F, O, G) {
      var H, $, ne, te, J, re = -1, le = F.length, se = 0, P = [], V = S ? h : f, X = [];
      for (b = !1, n = !1, i = !1, $ = 0; $ < le; $++) X[$] = B(F[$]);
      for (ne = 0; ne < le; ne++) {
        if (J = se, P[ne] = U(F, X, P, ne), H = 240 & (se = V[J][g[P[ne]]]), se &= 15, O[ne] = te = V[se][5], H > 0) if (H === 16) {
          for ($ = re; $ < ne; $++) O[$] = 1;
          re = -1;
        } else re = -1;
        if (V[se][6]) re === -1 && (re = ne);
        else if (re > -1) {
          for ($ = re; $ < ne; $++) O[$] = te;
          re = -1;
        }
        X[ne] === "B" && (O[ne] = 0), G.hiLevel |= te;
      }
      i && (function(Y, ee, oe) {
        for (var ge = 0; ge < oe; ge++) if (Y[ge] === "S") {
          ee[ge] = S;
          for (var pe = ge - 1; pe >= 0 && Y[pe] === "WS"; pe--) ee[pe] = S;
        }
      })(X, O, le);
    }, _ = function(F, O, G, H, $) {
      if (!($.hiLevel < F)) {
        if (F === 1 && S === 1 && !n) return O.reverse(), void (G && G.reverse());
        for (var ne, te, J, re, le = O.length, se = 0; se < le; ) {
          if (H[se] >= F) {
            for (J = se + 1; J < le && H[J] >= F; ) J++;
            for (re = se, te = J - 1; re < te; re++, te--) ne = O[re], O[re] = O[te], O[te] = ne, G && (ne = G[re], G[re] = G[te], G[te] = ne);
            se = J;
          }
          se++;
        }
      }
    }, R = function(F, O, G) {
      var H = F.split(""), $ = { hiLevel: S };
      return G || (G = []), N(H, G, $), (function(ne, te, J) {
        if (J.hiLevel !== 0 && u) for (var re, le = 0; le < ne.length; le++) te[le] === 1 && (re = v.indexOf(ne[le])) >= 0 && (ne[le] = v[re + 1]);
      })(H, G, $), _(2, H, O, G, $), _(1, H, O, G, $), H.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(F, O, G) {
      if ((function($, ne) {
        if (ne) for (var te = 0; te < $.length; te++) ne[te] = te;
        a === void 0 && (a = x($)), l === void 0 && (l = x($));
      })(F, O), s || !o || l) if (s && o && a ^ l) S = a ? 1 : 0, F = Q(F, O, G);
      else if (!s && o && l) S = a ? 1 : 0, F = R(F, O, G), F = Q(F, O);
      else if (!s || a || o || l) {
        if (s && !o && a ^ l) F = Q(F, O), a ? (S = 0, F = R(F, O, G)) : (S = 1, F = R(F, O, G), F = Q(F, O));
        else if (s && a && !o && l) S = 1, F = R(F, O, G), F = Q(F, O);
        else if (!s && !o && a ^ l) {
          var H = u;
          a ? (S = 1, F = R(F, O, G), S = 0, u = !1, F = R(F, O, G), u = H) : (S = 0, F = R(F, O, G), F = Q(F, O), S = 1, u = !1, F = R(F, O, G), u = H, F = Q(F, O));
        }
      } else S = 0, F = R(F, O, G);
      else S = a ? 1 : 0, F = R(F, O, G);
      return F;
    }, this.__bidiEngine__.setOptions = function(F) {
      F && (s = F.isInputVisual, o = F.isOutputVisual, a = F.isInputRtl, l = F.isOutputRtl, u = F.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(A), this.__bidiEngine__;
  };
  var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], t = new r.__bidiEngine__({ isInputVisual: !0 });
  r.API.events.push(["postProcessText", function(A) {
    var n = A.text;
    A.x, A.y;
    var i = A.options || {};
    A.mutex, i.lang;
    var s = [];
    if (i.isInputVisual = typeof i.isInputVisual != "boolean" || i.isInputVisual, t.setOptions(i), Object.prototype.toString.call(n) === "[object Array]") {
      var a = 0;
      for (s = [], a = 0; a < n.length; a += 1) Object.prototype.toString.call(n[a]) === "[object Array]" ? s.push([t.doBidiReorder(n[a][0]), n[a][1], n[a][2]]) : s.push([t.doBidiReorder(n[a])]);
      A.text = s;
    } else A.text = t.doBidiReorder(n);
    t.setOptions({ isInputVisual: !0 });
  }]);
})(ot), ot.API.TTFFont = (function() {
  function r(e) {
    var t;
    if (this.rawData = e, t = this.contents = new zs(e), this.contents.pos = 4, t.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    t.pos = 0, this.parse(), this.subset = new EL(this), this.registerTTF();
  }
  return r.open = function(e) {
    return new r(e);
  }, r.prototype.parse = function() {
    return this.directory = new hL(this.contents), this.head = new dL(this), this.name = new wL(this), this.cmap = new t5(this), this.toUnicode = {}, this.hhea = new gL(this), this.maxp = new yL(this), this.hmtx = new bL(this), this.post = new mL(this), this.os2 = new pL(this), this.loca = new xL(this), this.glyf = new BL(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, r.prototype.registerTTF = function() {
    var e, t, A, n, i;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var s, a, o, l;
      for (l = [], s = 0, a = (o = this.bbox).length; s < a; s++) e = o[s], l.push(Math.round(e * this.scaleFactor));
      return l;
    }).call(this), this.stemV = 0, this.post.exists ? (A = 255 & (n = this.post.italic_angle), 32768 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + A)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, r.prototype.characterToGlyph = function(e) {
    var t;
    return ((t = this.cmap.unicode) != null ? t.codeMap[e] : void 0) || 0;
  }, r.prototype.widthOfGlyph = function(e) {
    var t;
    return t = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(e).advance * t;
  }, r.prototype.widthOfString = function(e, t, A) {
    var n, i, s, a;
    for (s = 0, i = 0, a = (e = "" + e).length; 0 <= a ? i < a : i > a; i = 0 <= a ? ++i : --i) n = e.charCodeAt(i), s += this.widthOfGlyph(this.characterToGlyph(n)) + A * (1e3 / t) || 0;
    return s * (t / 1e3);
  }, r.prototype.lineHeight = function(e, t) {
    var A;
    return t == null && (t = !1), A = t ? this.lineGap : 0, (this.ascender + A - this.decender) / 1e3 * e;
  }, r;
})();
var li, zs = (function() {
  function r(e) {
    this.data = e ?? [], this.pos = 0, this.length = this.data.length;
  }
  return r.prototype.readByte = function() {
    return this.data[this.pos++];
  }, r.prototype.writeByte = function(e) {
    return this.data[this.pos++] = e;
  }, r.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, r.prototype.writeUInt32 = function(e) {
    return this.writeByte(e >>> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, r.prototype.readInt32 = function() {
    var e;
    return (e = this.readUInt32()) >= 2147483648 ? e - 4294967296 : e;
  }, r.prototype.writeInt32 = function(e) {
    return e < 0 && (e += 4294967296), this.writeUInt32(e);
  }, r.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, r.prototype.writeUInt16 = function(e) {
    return this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, r.prototype.readInt16 = function() {
    var e;
    return (e = this.readUInt16()) >= 32768 ? e - 65536 : e;
  }, r.prototype.writeInt16 = function(e) {
    return e < 0 && (e += 65536), this.writeUInt16(e);
  }, r.prototype.readString = function(e) {
    var t, A;
    for (A = [], t = 0; 0 <= e ? t < e : t > e; t = 0 <= e ? ++t : --t) A[t] = String.fromCharCode(this.readByte());
    return A.join("");
  }, r.prototype.writeString = function(e) {
    var t, A, n;
    for (n = [], t = 0, A = e.length; 0 <= A ? t < A : t > A; t = 0 <= A ? ++t : --t) n.push(this.writeByte(e.charCodeAt(t)));
    return n;
  }, r.prototype.readShort = function() {
    return this.readInt16();
  }, r.prototype.writeShort = function(e) {
    return this.writeInt16(e);
  }, r.prototype.readLongLong = function() {
    var e, t, A, n, i, s, a, o;
    return e = this.readByte(), t = this.readByte(), A = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), a = this.readByte(), o = this.readByte(), 128 & e ? -1 * (72057594037927940 * (255 ^ e) + 281474976710656 * (255 ^ t) + 1099511627776 * (255 ^ A) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ s) + 256 * (255 ^ a) + (255 ^ o) + 1) : 72057594037927940 * e + 281474976710656 * t + 1099511627776 * A + 4294967296 * n + 16777216 * i + 65536 * s + 256 * a + o;
  }, r.prototype.writeLongLong = function(e) {
    var t, A;
    return t = Math.floor(e / 4294967296), A = 4294967295 & e, this.writeByte(t >> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t), this.writeByte(A >> 24 & 255), this.writeByte(A >> 16 & 255), this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, r.prototype.readInt = function() {
    return this.readInt32();
  }, r.prototype.writeInt = function(e) {
    return this.writeInt32(e);
  }, r.prototype.read = function(e) {
    var t, A;
    for (t = [], A = 0; 0 <= e ? A < e : A > e; A = 0 <= e ? ++A : --A) t.push(this.readByte());
    return t;
  }, r.prototype.write = function(e) {
    var t, A, n, i;
    for (i = [], A = 0, n = e.length; A < n; A++) t = e[A], i.push(this.writeByte(t));
    return i;
  }, r;
})(), hL = (function() {
  var r;
  function e(t) {
    var A, n, i;
    for (this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, i = this.tableCount; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) A = { tag: t.readString(4), checksum: t.readInt(), offset: t.readInt(), length: t.readInt() }, this.tables[A.tag] = A;
  }
  return e.prototype.encode = function(t) {
    var A, n, i, s, a, o, l, u, c, f, h, g, p;
    for (p in h = Object.keys(t).length, o = Math.log(2), c = 16 * Math.floor(Math.log(h) / o), s = Math.floor(c / o), u = 16 * h - c, (n = new zs()).writeInt(this.scalarType), n.writeShort(h), n.writeShort(c), n.writeShort(s), n.writeShort(u), i = 16 * h, l = n.pos + i, a = null, g = [], t) for (f = t[p], n.writeString(p), n.writeInt(r(f)), n.writeInt(l), n.writeInt(f.length), g = g.concat(f), p === "head" && (a = l), l += f.length; l % 4; ) g.push(0), l++;
    return n.write(g), A = 2981146554 - r(n.data), n.pos = a + 8, n.writeUInt32(A), n.data;
  }, r = function(t) {
    var A, n, i, s;
    for (t = r5.call(t); t.length % 4; ) t.push(0);
    for (i = new zs(t), n = 0, A = 0, s = t.length; A < s; A = A += 4) n += i.readUInt32();
    return 4294967295 & n;
  }, e;
})(), fL = {}.hasOwnProperty, Fi = function(r, e) {
  for (var t in e) fL.call(e, t) && (r[t] = e[t]);
  function A() {
    this.constructor = r;
  }
  return A.prototype = e.prototype, r.prototype = new A(), r.__super__ = e.prototype, r;
};
li = (function() {
  function r(e) {
    var t;
    this.file = e, t = this.file.directory.tables[this.tag], this.exists = !!t, t && (this.offset = t.offset, this.length = t.length, this.parse(this.file.contents));
  }
  return r.prototype.parse = function() {
  }, r.prototype.encode = function() {
  }, r.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, r;
})();
var dL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "head", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.revision = e.readInt(), this.checkSumAdjustment = e.readInt(), this.magicNumber = e.readInt(), this.flags = e.readShort(), this.unitsPerEm = e.readShort(), this.created = e.readLongLong(), this.modified = e.readLongLong(), this.xMin = e.readShort(), this.yMin = e.readShort(), this.xMax = e.readShort(), this.yMax = e.readShort(), this.macStyle = e.readShort(), this.lowestRecPPEM = e.readShort(), this.fontDirectionHint = e.readShort(), this.indexToLocFormat = e.readShort(), this.glyphDataFormat = e.readShort();
  }, r.prototype.encode = function(e) {
    var t;
    return (t = new zs()).writeInt(this.version), t.writeInt(this.revision), t.writeInt(this.checkSumAdjustment), t.writeInt(this.magicNumber), t.writeShort(this.flags), t.writeShort(this.unitsPerEm), t.writeLongLong(this.created), t.writeLongLong(this.modified), t.writeShort(this.xMin), t.writeShort(this.yMin), t.writeShort(this.xMax), t.writeShort(this.yMax), t.writeShort(this.macStyle), t.writeShort(this.lowestRecPPEM), t.writeShort(this.fontDirectionHint), t.writeShort(e), t.writeShort(this.glyphDataFormat), t.data;
  }, r;
})(), cy = (function() {
  function r(e, t) {
    var A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S;
    switch (this.platformID = e.readUInt16(), this.encodingID = e.readShort(), this.offset = t + e.readInt(), c = e.pos, e.pos = this.offset, this.format = e.readUInt16(), this.length = e.readUInt16(), this.language = e.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (o = 0; o < 256; ++o) this.codeMap[o] = e.readByte();
        break;
      case 4:
        for (h = e.readUInt16(), f = h / 2, e.pos += 6, i = (function() {
          var B, x;
          for (x = [], o = B = 0; 0 <= f ? B < f : B > f; o = 0 <= f ? ++B : --B) x.push(e.readUInt16());
          return x;
        })(), e.pos += 2, p = (function() {
          var B, x;
          for (x = [], o = B = 0; 0 <= f ? B < f : B > f; o = 0 <= f ? ++B : --B) x.push(e.readUInt16());
          return x;
        })(), l = (function() {
          var B, x;
          for (x = [], o = B = 0; 0 <= f ? B < f : B > f; o = 0 <= f ? ++B : --B) x.push(e.readUInt16());
          return x;
        })(), u = (function() {
          var B, x;
          for (x = [], o = B = 0; 0 <= f ? B < f : B > f; o = 0 <= f ? ++B : --B) x.push(e.readUInt16());
          return x;
        })(), n = (this.length - e.pos + this.offset) / 2, a = (function() {
          var B, x;
          for (x = [], o = B = 0; 0 <= n ? B < n : B > n; o = 0 <= n ? ++B : --B) x.push(e.readUInt16());
          return x;
        })(), o = w = 0, S = i.length; w < S; o = ++w) for (v = i[o], A = b = g = p[o]; g <= v ? b <= v : b >= v; A = g <= v ? ++b : --b) u[o] === 0 ? s = A + l[o] : (s = a[u[o] / 2 + (A - g) - (f - o)] || 0) !== 0 && (s += l[o]), this.codeMap[A] = 65535 & s;
    }
    e.pos = c;
  }
  return r.encode = function(e, t) {
    var A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S, B, x, U, Q, N, _, R, F, O, G, H, $, ne, te, J, re, le, se, P, V, X, Y, ee, oe, ge, pe, me, Ee, Ne;
    switch (H = new zs(), s = Object.keys(e).sort(function(Te, Ge) {
      return Te - Ge;
    }), t) {
      case "macroman":
        for (p = 0, v = (function() {
          var Te = [];
          for (g = 0; g < 256; ++g) Te.push(0);
          return Te;
        })(), b = { 0: 0 }, i = {}, $ = 0, re = s.length; $ < re; $++) b[pe = e[n = s[$]]] == null && (b[pe] = ++p), i[n] = { old: e[n], new: b[e[n]] }, v[n] = b[e[n]];
        return H.writeUInt16(1), H.writeUInt16(0), H.writeUInt32(12), H.writeUInt16(0), H.writeUInt16(262), H.writeUInt16(0), H.write(v), { charMap: i, subtable: H.data, maxGlyphID: p + 1 };
      case "unicode":
        for (O = [], c = [], S = 0, b = {}, A = {}, w = l = null, ne = 0, le = s.length; ne < le; ne++) b[x = e[n = s[ne]]] == null && (b[x] = ++S), A[n] = { old: x, new: b[x] }, a = b[x] - n, w != null && a === l || (w && c.push(w), O.push(n), l = a), w = n;
        for (w && c.push(w), c.push(65535), O.push(65535), R = 2 * (_ = O.length), N = 2 * Math.pow(Math.log(_) / Math.LN2, 2), f = Math.log(N / 2) / Math.LN2, Q = 2 * _ - N, o = [], U = [], h = [], g = te = 0, se = O.length; te < se; g = ++te) {
          if (F = O[g], u = c[g], F === 65535) {
            o.push(0), U.push(0);
            break;
          }
          if (F - (G = A[F].new) >= 32768) for (o.push(0), U.push(2 * (h.length + _ - g)), n = J = F; F <= u ? J <= u : J >= u; n = F <= u ? ++J : --J) h.push(A[n].new);
          else o.push(G - F), U.push(0);
        }
        for (H.writeUInt16(3), H.writeUInt16(1), H.writeUInt32(12), H.writeUInt16(4), H.writeUInt16(16 + 8 * _ + 2 * h.length), H.writeUInt16(0), H.writeUInt16(R), H.writeUInt16(N), H.writeUInt16(f), H.writeUInt16(Q), oe = 0, P = c.length; oe < P; oe++) n = c[oe], H.writeUInt16(n);
        for (H.writeUInt16(0), ge = 0, V = O.length; ge < V; ge++) n = O[ge], H.writeUInt16(n);
        for (me = 0, X = o.length; me < X; me++) a = o[me], H.writeUInt16(a);
        for (Ee = 0, Y = U.length; Ee < Y; Ee++) B = U[Ee], H.writeUInt16(B);
        for (Ne = 0, ee = h.length; Ne < ee; Ne++) p = h[Ne], H.writeUInt16(p);
        return { charMap: A, subtable: H.data, maxGlyphID: S + 1 };
    }
  }, r;
})(), t5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "cmap", r.prototype.parse = function(e) {
    var t, A, n;
    for (e.pos = this.offset, this.version = e.readUInt16(), n = e.readUInt16(), this.tables = [], this.unicode = null, A = 0; 0 <= n ? A < n : A > n; A = 0 <= n ? ++A : --A) t = new cy(e, this.offset), this.tables.push(t), t.isUnicode && this.unicode == null && (this.unicode = t);
    return !0;
  }, r.encode = function(e, t) {
    var A, n;
    return t == null && (t = "macroman"), A = cy.encode(e, t), (n = new zs()).writeUInt16(0), n.writeUInt16(1), A.table = n.data.concat(A.subtable), A;
  }, r;
})(), gL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "hhea", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.ascender = e.readShort(), this.decender = e.readShort(), this.lineGap = e.readShort(), this.advanceWidthMax = e.readShort(), this.minLeftSideBearing = e.readShort(), this.minRightSideBearing = e.readShort(), this.xMaxExtent = e.readShort(), this.caretSlopeRise = e.readShort(), this.caretSlopeRun = e.readShort(), this.caretOffset = e.readShort(), e.pos += 8, this.metricDataFormat = e.readShort(), this.numberOfMetrics = e.readUInt16();
  }, r;
})(), pL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "OS/2", r.prototype.parse = function(e) {
    if (e.pos = this.offset, this.version = e.readUInt16(), this.averageCharWidth = e.readShort(), this.weightClass = e.readUInt16(), this.widthClass = e.readUInt16(), this.type = e.readShort(), this.ySubscriptXSize = e.readShort(), this.ySubscriptYSize = e.readShort(), this.ySubscriptXOffset = e.readShort(), this.ySubscriptYOffset = e.readShort(), this.ySuperscriptXSize = e.readShort(), this.ySuperscriptYSize = e.readShort(), this.ySuperscriptXOffset = e.readShort(), this.ySuperscriptYOffset = e.readShort(), this.yStrikeoutSize = e.readShort(), this.yStrikeoutPosition = e.readShort(), this.familyClass = e.readShort(), this.panose = (function() {
      var t, A;
      for (A = [], t = 0; t < 10; ++t) A.push(e.readByte());
      return A;
    })(), this.charRange = (function() {
      var t, A;
      for (A = [], t = 0; t < 4; ++t) A.push(e.readInt());
      return A;
    })(), this.vendorID = e.readString(4), this.selection = e.readShort(), this.firstCharIndex = e.readShort(), this.lastCharIndex = e.readShort(), this.version > 0 && (this.ascent = e.readShort(), this.descent = e.readShort(), this.lineGap = e.readShort(), this.winAscent = e.readShort(), this.winDescent = e.readShort(), this.codePageRange = (function() {
      var t, A;
      for (A = [], t = 0; t < 2; t = ++t) A.push(e.readInt());
      return A;
    })(), this.version > 1)) return this.xHeight = e.readShort(), this.capHeight = e.readShort(), this.defaultChar = e.readShort(), this.breakChar = e.readShort(), this.maxContext = e.readShort();
  }, r;
})(), mL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "post", r.prototype.parse = function(e) {
    var t, A, n;
    switch (e.pos = this.offset, this.format = e.readInt(), this.italicAngle = e.readInt(), this.underlinePosition = e.readShort(), this.underlineThickness = e.readShort(), this.isFixedPitch = e.readInt(), this.minMemType42 = e.readInt(), this.maxMemType42 = e.readInt(), this.minMemType1 = e.readInt(), this.maxMemType1 = e.readInt(), this.format) {
      case 65536:
      case 196608:
        break;
      case 131072:
        var i;
        for (A = e.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= A ? i < A : i > A; i = 0 <= A ? ++i : --i) this.glyphNameIndex.push(e.readUInt16());
        for (this.names = [], n = []; e.pos < this.offset + this.length; ) t = e.readByte(), n.push(this.names.push(e.readString(t)));
        return n;
      case 151552:
        return A = e.readUInt16(), this.offsets = e.read(A);
      case 262144:
        return this.map = (function() {
          var s, a, o;
          for (o = [], i = s = 0, a = this.file.maxp.numGlyphs; 0 <= a ? s < a : s > a; i = 0 <= a ? ++s : --s) o.push(e.readUInt32());
          return o;
        }).call(this);
    }
  }, r;
})(), vL = function(r, e) {
  this.raw = r, this.length = r.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, wL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "name", r.prototype.parse = function(e) {
    var t, A, n, i, s, a, o, l, u, c, f;
    for (e.pos = this.offset, e.readShort(), t = e.readShort(), a = e.readShort(), A = [], i = 0; 0 <= t ? i < t : i > t; i = 0 <= t ? ++i : --i) A.push({ platformID: e.readShort(), encodingID: e.readShort(), languageID: e.readShort(), nameID: e.readShort(), length: e.readShort(), offset: this.offset + a + e.readShort() });
    for (o = {}, i = u = 0, c = A.length; u < c; i = ++u) n = A[i], e.pos = n.offset, l = e.readString(n.length), s = new vL(l, n), o[f = n.nameID] == null && (o[f] = []), o[n.nameID].push(s);
    this.strings = o, this.copyright = o[0], this.fontFamily = o[1], this.fontSubfamily = o[2], this.uniqueSubfamily = o[3], this.fontName = o[4], this.version = o[5];
    try {
      this.postscriptName = o[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = o[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = o[7], this.manufacturer = o[8], this.designer = o[9], this.description = o[10], this.vendorUrl = o[11], this.designerUrl = o[12], this.license = o[13], this.licenseUrl = o[14], this.preferredFamily = o[15], this.preferredSubfamily = o[17], this.compatibleFull = o[18], this.sampleText = o[19];
  }, r;
})(), yL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "maxp", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.numGlyphs = e.readUInt16(), this.maxPoints = e.readUInt16(), this.maxContours = e.readUInt16(), this.maxCompositePoints = e.readUInt16(), this.maxComponentContours = e.readUInt16(), this.maxZones = e.readUInt16(), this.maxTwilightPoints = e.readUInt16(), this.maxStorage = e.readUInt16(), this.maxFunctionDefs = e.readUInt16(), this.maxInstructionDefs = e.readUInt16(), this.maxStackElements = e.readUInt16(), this.maxSizeOfInstructions = e.readUInt16(), this.maxComponentElements = e.readUInt16(), this.maxComponentDepth = e.readUInt16();
  }, r;
})(), bL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "hmtx", r.prototype.parse = function(e) {
    var t, A, n, i, s, a, o;
    for (e.pos = this.offset, this.metrics = [], t = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? t < a : t > a; t = 0 <= a ? ++t : --t) this.metrics.push({ advance: e.readUInt16(), lsb: e.readInt16() });
    for (n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = (function() {
      var l, u;
      for (u = [], t = l = 0; 0 <= n ? l < n : l > n; t = 0 <= n ? ++l : --l) u.push(e.readInt16());
      return u;
    })(), this.widths = (function() {
      var l, u, c, f;
      for (f = [], l = 0, u = (c = this.metrics).length; l < u; l++) i = c[l], f.push(i.advance);
      return f;
    }).call(this), A = this.widths[this.widths.length - 1], o = [], t = s = 0; 0 <= n ? s < n : s > n; t = 0 <= n ? ++s : --s) o.push(this.widths.push(A));
    return o;
  }, r.prototype.forGlyph = function(e) {
    return e in this.metrics ? this.metrics[e] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[e - this.metrics.length] };
  }, r;
})(), r5 = [].slice, BL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "glyf", r.prototype.parse = function() {
    return this.cache = {};
  }, r.prototype.glyphFor = function(e) {
    var t, A, n, i, s, a, o, l, u, c;
    return e in this.cache ? this.cache[e] : (i = this.file.loca, t = this.file.contents, A = i.indexOf(e), (n = i.lengthOf(e)) === 0 ? this.cache[e] = null : (t.pos = this.offset + A, s = (a = new zs(t.read(n))).readShort(), l = a.readShort(), c = a.readShort(), o = a.readShort(), u = a.readShort(), this.cache[e] = s === -1 ? new SL(a, l, c, o, u) : new CL(a, s, l, c, o, u), this.cache[e]));
  }, r.prototype.encode = function(e, t, A) {
    var n, i, s, a, o;
    for (s = [], i = [], a = 0, o = t.length; a < o; a++) n = e[t[a]], i.push(s.length), n && (s = s.concat(n.encode(A)));
    return i.push(s.length), { table: s, offsets: i };
  }, r;
})(), CL = (function() {
  function r(e, t, A, n, i, s) {
    this.raw = e, this.numberOfContours = t, this.xMin = A, this.yMin = n, this.xMax = i, this.yMax = s, this.compound = !1;
  }
  return r.prototype.encode = function() {
    return this.raw.data;
  }, r;
})(), SL = (function() {
  function r(e, t, A, n, i) {
    var s, a;
    for (this.raw = e, this.xMin = t, this.yMin = A, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], s = this.raw; a = s.readShort(), this.glyphOffsets.push(s.pos), this.glyphIDs.push(s.readUInt16()), 32 & a; ) s.pos += 1 & a ? 4 : 2, 128 & a ? s.pos += 8 : 64 & a ? s.pos += 4 : 8 & a && (s.pos += 2);
  }
  return r.prototype.encode = function() {
    var e, t, A;
    for (t = new zs(r5.call(this.raw.data)), e = 0, A = this.glyphIDs.length; e < A; ++e) t.pos = this.glyphOffsets[e];
    return t.data;
  }, r;
})(), xL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Fi(r, li), r.prototype.tag = "loca", r.prototype.parse = function(e) {
    var t, A;
    return e.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = t === 0 ? (function() {
      var n, i;
      for (i = [], A = 0, n = this.length; A < n; A += 2) i.push(2 * e.readUInt16());
      return i;
    }).call(this) : (function() {
      var n, i;
      for (i = [], A = 0, n = this.length; A < n; A += 4) i.push(e.readUInt32());
      return i;
    }).call(this);
  }, r.prototype.indexOf = function(e) {
    return this.offsets[e];
  }, r.prototype.lengthOf = function(e) {
    return this.offsets[e + 1] - this.offsets[e];
  }, r.prototype.encode = function(e, t) {
    for (var A = new Uint32Array(this.offsets.length), n = 0, i = 0, s = 0; s < A.length; ++s) if (A[s] = n, i < t.length && t[i] == s) {
      ++i, A[s] = n;
      var a = this.offsets[s], o = this.offsets[s + 1] - a;
      o > 0 && (n += o);
    }
    for (var l = new Array(4 * A.length), u = 0; u < A.length; ++u) l[4 * u + 3] = 255 & A[u], l[4 * u + 2] = (65280 & A[u]) >> 8, l[4 * u + 1] = (16711680 & A[u]) >> 16, l[4 * u] = (4278190080 & A[u]) >> 24;
    return l;
  }, r;
})(), EL = (function() {
  function r(e) {
    this.font = e, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return r.prototype.generateCmap = function() {
    var e, t, A, n, i;
    for (t in n = this.font.cmap.tables[0].codeMap, e = {}, i = this.subset) A = i[t], e[t] = n[A];
    return e;
  }, r.prototype.glyphsFor = function(e) {
    var t, A, n, i, s, a, o;
    for (n = {}, s = 0, a = e.length; s < a; s++) n[i = e[s]] = this.font.glyf.glyphFor(i);
    for (i in t = [], n) (A = n[i]) != null && A.compound && t.push.apply(t, A.glyphIDs);
    if (t.length > 0) for (i in o = this.glyphsFor(t)) A = o[i], n[i] = A;
    return n;
  }, r.prototype.encode = function(e, t) {
    var A, n, i, s, a, o, l, u, c, f, h, g, p, v, w;
    for (n in A = t5.encode(this.generateCmap(), "unicode"), s = this.glyphsFor(e), h = { 0: 0 }, w = A.charMap) h[(o = w[n]).old] = o.new;
    for (g in f = A.maxGlyphID, s) g in h || (h[g] = f++);
    return u = (function(b) {
      var S, B;
      for (S in B = {}, b) B[b[S]] = S;
      return B;
    })(h), c = Object.keys(u).sort(function(b, S) {
      return b - S;
    }), p = (function() {
      var b, S, B;
      for (B = [], b = 0, S = c.length; b < S; b++) a = c[b], B.push(u[a]);
      return B;
    })(), i = this.font.glyf.encode(s, p, h), l = this.font.loca.encode(i.offsets, p), v = { cmap: this.font.cmap.raw(), glyf: i.table, loca: l, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(t) }, this.font.os2.exists && (v["OS/2"] = this.font.os2.raw()), this.font.directory.encode(v);
  }, r;
})();
ot.API.PDFObject = (function() {
  var r;
  function e() {
  }
  return r = function(t, A) {
    return (Array(A + 1).join("0") + t).slice(-A);
  }, e.convert = function(t) {
    var A, n, i, s;
    if (Array.isArray(t)) return "[" + (function() {
      var a, o, l;
      for (l = [], a = 0, o = t.length; a < o; a++) A = t[a], l.push(e.convert(A));
      return l;
    })().join(" ") + "]";
    if (typeof t == "string") return "/" + t;
    if (t?.isString) return "(" + t + ")";
    if (t instanceof Date) return "(D:" + r(t.getUTCFullYear(), 4) + r(t.getUTCMonth(), 2) + r(t.getUTCDate(), 2) + r(t.getUTCHours(), 2) + r(t.getUTCMinutes(), 2) + r(t.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(t) === "[object Object]") {
      for (n in i = ["<<"], t) s = t[n], i.push("/" + n + " " + e.convert(s));
      return i.push(">>"), i.join(`
`);
    }
    return "" + t;
  }, e;
})();
var lm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vu(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Bd, hy;
function FL() {
  if (hy) return Bd;
  hy = 1;
  var r = {}, e = r.hasOwnProperty, t = function(o, l) {
    if (!o)
      return l;
    var u = {};
    for (var c in l)
      u[c] = e.call(o, c) ? o[c] : l[c];
    return u;
  }, A = /[ -,\.\/:-@\[-\^`\{-~]/, n = /[ -,\.\/:-@\[\]\^`\{-~]/, i = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, s = function a(o, l) {
    l = t(l, a.options), l.quotes != "single" && l.quotes != "double" && (l.quotes = "single");
    for (var u = l.quotes == "double" ? '"' : "'", c = l.isIdentifier, f = o.charAt(0), h = "", g = 0, p = o.length; g < p; ) {
      var v = o.charAt(g++), w = v.charCodeAt(), b = void 0;
      if (w < 32 || w > 126) {
        if (w >= 55296 && w <= 56319 && g < p) {
          var S = o.charCodeAt(g++);
          (S & 64512) == 56320 ? w = ((w & 1023) << 10) + (S & 1023) + 65536 : g--;
        }
        b = "\\" + w.toString(16).toUpperCase() + " ";
      } else
        l.escapeEverything ? A.test(v) ? b = "\\" + v : b = "\\" + w.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(v) ? b = "\\" + w.toString(16).toUpperCase() + " " : v == "\\" || !c && (v == '"' && u == v || v == "'" && u == v) || c && n.test(v) ? b = "\\" + v : b = v;
      h += b;
    }
    return c && (/^-[-\d]/.test(h) ? h = "\\-" + h.slice(1) : /\d/.test(f) && (h = "\\3" + f + " " + h.slice(1))), h = h.replace(i, function(B, x, U) {
      return x && x.length % 2 ? B : (x || "") + U;
    }), !c && l.wrap ? u + h + u : h;
  };
  return s.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, s.version = "3.0.0", Bd = s, Bd;
}
var _L = FL();
const A5 = /* @__PURE__ */ vu(_L);
var Cd, fy;
function UL() {
  if (fy) return Cd;
  fy = 1;
  var r = 0, e = 1, t = 2, A = 3, n = 4, i = 5, s = 6, a = /[a-z0-9_-]/i, o = /[\s\t]/, l = function(f) {
    for (var h = !0, g = r, p = "", v = 0, w, b, S = []; ; ) {
      if (b = f[v], g === r) {
        if (!b && h)
          break;
        if (!b && !h)
          throw new Error("Parse error");
        if (b === '"' || b === "'")
          w = b, g = e, h = !1;
        else if (!o.test(b)) if (a.test(b))
          g = A, h = !1, v--;
        else
          throw new Error("Parse error");
      } else if (g === e)
        if (b)
          b === "\\" ? g = t : b === w ? (S.push(p), p = "", g = n) : p += b;
        else throw new Error("Parse Error");
      else if (g === t)
        if (b === w || b === "\\")
          p += b, g = e;
        else
          throw new Error("Parse error");
      else if (g === A)
        if (b)
          a.test(b) ? p += b : b === "," ? (S.push(p), p = "", g = r) : o.test(b) ? g = i : b === "\\" && (g = s);
        else {
          S.push(p);
          break;
        }
      else if (g === s) {
        if (/[0-9a-f]/i.test(b))
          throw new Error("Parse error");
        p += b, g = A;
      } else if (g === i)
        if (b) {
          if (a.test(b))
            p += " " + b, g = A;
          else if (b === ",")
            S.push(p), p = "", g = r;
          else if (!o.test(b)) throw new Error("Parse error");
        } else {
          S.push(p);
          break;
        }
      else if (g === n)
        if (b) {
          if (b === ",")
            g = r;
          else if (!o.test(b)) throw new Error("Parse error");
        } else break;
      v++;
    }
    return S;
  }, u = /[^a-z0-9_-]/i, c = function(f, h) {
    var g = h && h.quote || '"';
    if (g !== '"' && g !== "'")
      throw new Error("Quote must be `'` or `\"`");
    for (var p = new RegExp(g, "g"), v = [], w = 0; w < f.length; ++w) {
      var b = f[w];
      u.test(b) && (b = b.replace(/\\/g, "\\\\").replace(p, "\\" + g), b = g + b + g), v.push(b);
    }
    return v.join(", ");
  };
  return Cd = {
    parse: l,
    stringify: c
  }, Cd;
}
var IL = UL();
const QL = /* @__PURE__ */ vu(IL);
var Sd, dy;
function LL() {
  if (dy) return Sd;
  dy = 1;
  var r = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = [
    5760,
    6158,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8239,
    8287,
    12288,
    65279
  ];
  function t(h) {
    return h === 10 || h === 13 || h === 8232 || h === 8233 || // Line terminators
    // White spaces
    h === 32 || h === 9 || h === 11 || h === 12 || h === 160 || h >= 5760 && e.indexOf(h) >= 0;
  }
  function A(h) {
    switch (h | 32) {
      case 109:
      case 122:
      case 108:
      case 104:
      case 118:
      case 99:
      case 115:
      case 113:
      case 116:
      case 97:
      case 114:
        return !0;
    }
    return !1;
  }
  function n(h) {
    return (h | 32) === 97;
  }
  function i(h) {
    return h >= 48 && h <= 57;
  }
  function s(h) {
    return h >= 48 && h <= 57 || /* 0..9 */
    h === 43 || /* + */
    h === 45 || /* - */
    h === 46;
  }
  function a(h) {
    this.index = 0, this.path = h, this.max = h.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
  }
  function o(h) {
    for (; h.index < h.max && t(h.path.charCodeAt(h.index)); )
      h.index++;
  }
  function l(h) {
    var g = h.path.charCodeAt(h.index);
    if (g === 48) {
      h.param = 0, h.index++;
      return;
    }
    if (g === 49) {
      h.param = 1, h.index++;
      return;
    }
    h.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + h.index + ")";
  }
  function u(h) {
    var g = h.index, p = g, v = h.max, w = !1, b = !1, S = !1, B = !1, x;
    if (p >= v) {
      h.err = "SvgPath: missed param (at pos " + p + ")";
      return;
    }
    if (x = h.path.charCodeAt(p), (x === 43 || x === 45) && (p++, x = p < v ? h.path.charCodeAt(p) : 0), !i(x) && x !== 46) {
      h.err = "SvgPath: param should start with 0..9 or `.` (at pos " + p + ")";
      return;
    }
    if (x !== 46) {
      if (w = x === 48, p++, x = p < v ? h.path.charCodeAt(p) : 0, w && p < v && x && i(x)) {
        h.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + g + ")";
        return;
      }
      for (; p < v && i(h.path.charCodeAt(p)); )
        p++, b = !0;
      x = p < v ? h.path.charCodeAt(p) : 0;
    }
    if (x === 46) {
      for (B = !0, p++; i(h.path.charCodeAt(p)); )
        p++, S = !0;
      x = p < v ? h.path.charCodeAt(p) : 0;
    }
    if (x === 101 || x === 69) {
      if (B && !b && !S) {
        h.err = "SvgPath: invalid float exponent (at pos " + p + ")";
        return;
      }
      if (p++, x = p < v ? h.path.charCodeAt(p) : 0, (x === 43 || x === 45) && p++, p < v && i(h.path.charCodeAt(p)))
        for (; p < v && i(h.path.charCodeAt(p)); )
          p++;
      else {
        h.err = "SvgPath: invalid float exponent (at pos " + p + ")";
        return;
      }
    }
    h.index = p, h.param = parseFloat(h.path.slice(g, p)) + 0;
  }
  function c(h) {
    var g, p;
    g = h.path[h.segmentStart], p = g.toLowerCase();
    var v = h.data;
    if (p === "m" && v.length > 2 && (h.result.push([g, v[0], v[1]]), v = v.slice(2), p = "l", g = g === "m" ? "l" : "L"), p === "r")
      h.result.push([g].concat(v));
    else
      for (; v.length >= r[p] && (h.result.push([g].concat(v.splice(0, r[p]))), !!r[p]); )
        ;
  }
  function f(h) {
    var g = h.max, p, v, w, b, S;
    if (h.segmentStart = h.index, p = h.path.charCodeAt(h.index), v = n(p), !A(p)) {
      h.err = "SvgPath: bad command " + h.path[h.index] + " (at pos " + h.index + ")";
      return;
    }
    if (b = r[h.path[h.index].toLowerCase()], h.index++, o(h), h.data = [], !b) {
      c(h);
      return;
    }
    for (w = !1; ; ) {
      for (S = b; S > 0; S--) {
        if (v && (S === 3 || S === 4) ? l(h) : u(h), h.err.length) {
          c(h);
          return;
        }
        h.data.push(h.param), o(h), w = !1, h.index < g && h.path.charCodeAt(h.index) === 44 && (h.index++, o(h), w = !0);
      }
      if (!w && (h.index >= h.max || !s(h.path.charCodeAt(h.index))))
        break;
    }
    c(h);
  }
  return Sd = function(g) {
    var p = new a(g), v = p.max;
    for (o(p); p.index < v && !p.err.length; )
      f(p);
    return p.result.length && ("mM".indexOf(p.result[0][0]) < 0 ? (p.err = "SvgPath: string should start with `M` or `m`", p.result = []) : p.result[0][0] = "M"), {
      err: p.err,
      segments: p.result
    };
  }, Sd;
}
var xd, gy;
function n5() {
  if (gy) return xd;
  gy = 1;
  function r(t, A) {
    return [
      t[0] * A[0] + t[2] * A[1],
      t[1] * A[0] + t[3] * A[1],
      t[0] * A[2] + t[2] * A[3],
      t[1] * A[2] + t[3] * A[3],
      t[0] * A[4] + t[2] * A[5] + t[4],
      t[1] * A[4] + t[3] * A[5] + t[5]
    ];
  }
  function e() {
    if (!(this instanceof e))
      return new e();
    this.queue = [], this.cache = null;
  }
  return e.prototype.matrix = function(t) {
    return t[0] === 1 && t[1] === 0 && t[2] === 0 && t[3] === 1 && t[4] === 0 && t[5] === 0 ? this : (this.cache = null, this.queue.push(t), this);
  }, e.prototype.translate = function(t, A) {
    return (t !== 0 || A !== 0) && (this.cache = null, this.queue.push([1, 0, 0, 1, t, A])), this;
  }, e.prototype.scale = function(t, A) {
    return (t !== 1 || A !== 1) && (this.cache = null, this.queue.push([t, 0, 0, A, 0, 0])), this;
  }, e.prototype.rotate = function(t, A, n) {
    var i, s, a;
    return t !== 0 && (this.translate(A, n), i = t * Math.PI / 180, s = Math.cos(i), a = Math.sin(i), this.queue.push([s, a, -a, s, 0, 0]), this.cache = null, this.translate(-A, -n)), this;
  }, e.prototype.skewX = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, 0, Math.tan(t * Math.PI / 180), 1, 0, 0])), this;
  }, e.prototype.skewY = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, Math.tan(t * Math.PI / 180), 0, 1, 0, 0])), this;
  }, e.prototype.toArray = function() {
    if (this.cache)
      return this.cache;
    if (!this.queue.length)
      return this.cache = [1, 0, 0, 1, 0, 0], this.cache;
    if (this.cache = this.queue[0], this.queue.length === 1)
      return this.cache;
    for (var t = 1; t < this.queue.length; t++)
      this.cache = r(this.cache, this.queue[t]);
    return this.cache;
  }, e.prototype.calc = function(t, A, n) {
    var i;
    return this.queue.length ? (this.cache || (this.cache = this.toArray()), i = this.cache, [
      t * i[0] + A * i[2] + (n ? 0 : i[4]),
      t * i[1] + A * i[3] + (n ? 0 : i[5])
    ]) : [t, A];
  }, xd = e, xd;
}
var Ed, py;
function NL() {
  if (py) return Ed;
  py = 1;
  var r = n5(), e = {
    matrix: !0,
    scale: !0,
    rotate: !0,
    translate: !0,
    skewX: !0,
    skewY: !0
  }, t = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, A = /[\s,]+/;
  return Ed = function(i) {
    var s = new r(), a, o;
    return i.split(t).forEach(function(l) {
      if (l.length) {
        if (typeof e[l] < "u") {
          a = l;
          return;
        }
        switch (o = l.split(A).map(function(u) {
          return +u || 0;
        }), a) {
          case "matrix":
            o.length === 6 && s.matrix(o);
            return;
          case "scale":
            o.length === 1 ? s.scale(o[0], o[0]) : o.length === 2 && s.scale(o[0], o[1]);
            return;
          case "rotate":
            o.length === 1 ? s.rotate(o[0], 0, 0) : o.length === 3 && s.rotate(o[0], o[1], o[2]);
            return;
          case "translate":
            o.length === 1 ? s.translate(o[0], 0) : o.length === 2 && s.translate(o[0], o[1]);
            return;
          case "skewX":
            o.length === 1 && s.skewX(o[0]);
            return;
          case "skewY":
            o.length === 1 && s.skewY(o[0]);
            return;
        }
      }
    }), s;
  }, Ed;
}
var Fd, my;
function TL() {
  if (my) return Fd;
  my = 1;
  var r = Math.PI * 2;
  function e(n, i, s, a) {
    var o = n * a - i * s < 0 ? -1 : 1, l = n * s + i * a;
    return l > 1 && (l = 1), l < -1 && (l = -1), o * Math.acos(l);
  }
  function t(n, i, s, a, o, l, u, c, f, h) {
    var g = h * (n - s) / 2 + f * (i - a) / 2, p = -f * (n - s) / 2 + h * (i - a) / 2, v = u * u, w = c * c, b = g * g, S = p * p, B = v * w - v * S - w * b;
    B < 0 && (B = 0), B /= v * S + w * b, B = Math.sqrt(B) * (o === l ? -1 : 1);
    var x = B * u / c * p, U = B * -c / u * g, Q = h * x - f * U + (n + s) / 2, N = f * x + h * U + (i + a) / 2, _ = (g - x) / u, R = (p - U) / c, F = (-g - x) / u, O = (-p - U) / c, G = e(1, 0, _, R), H = e(_, R, F, O);
    return l === 0 && H > 0 && (H -= r), l === 1 && H < 0 && (H += r), [Q, N, G, H];
  }
  function A(n, i) {
    var s = 1.3333333333333333 * Math.tan(i / 4), a = Math.cos(n), o = Math.sin(n), l = Math.cos(n + i), u = Math.sin(n + i);
    return [a, o, a - o * s, o + a * s, l + u * s, u - l * s, l, u];
  }
  return Fd = function(i, s, a, o, l, u, c, f, h) {
    var g = Math.sin(h * r / 360), p = Math.cos(h * r / 360), v = p * (i - a) / 2 + g * (s - o) / 2, w = -g * (i - a) / 2 + p * (s - o) / 2;
    if (v === 0 && w === 0)
      return [];
    if (c === 0 || f === 0)
      return [];
    c = Math.abs(c), f = Math.abs(f);
    var b = v * v / (c * c) + w * w / (f * f);
    b > 1 && (c *= Math.sqrt(b), f *= Math.sqrt(b));
    var S = t(i, s, a, o, l, u, c, f, g, p), B = [], x = S[2], U = S[3], Q = Math.max(Math.ceil(Math.abs(U) / (r / 4)), 1);
    U /= Q;
    for (var N = 0; N < Q; N++)
      B.push(A(x, U)), x += U;
    return B.map(function(_) {
      for (var R = 0; R < _.length; R += 2) {
        var F = _[R + 0], O = _[R + 1];
        F *= c, O *= f;
        var G = p * F - g * O, H = g * F + p * O;
        _[R + 0] = G + S[0], _[R + 1] = H + S[1];
      }
      return _;
    });
  }, Fd;
}
var _d, vy;
function PL() {
  if (vy) return _d;
  vy = 1;
  var r = 1e-10, e = Math.PI / 180;
  function t(A, n, i) {
    if (!(this instanceof t))
      return new t(A, n, i);
    this.rx = A, this.ry = n, this.ax = i;
  }
  return t.prototype.transform = function(A) {
    var n = Math.cos(this.ax * e), i = Math.sin(this.ax * e), s = [
      this.rx * (A[0] * n + A[2] * i),
      this.rx * (A[1] * n + A[3] * i),
      this.ry * (-A[0] * i + A[2] * n),
      this.ry * (-A[1] * i + A[3] * n)
    ], a = s[0] * s[0] + s[2] * s[2], o = s[1] * s[1] + s[3] * s[3], l = ((s[0] - s[3]) * (s[0] - s[3]) + (s[2] + s[1]) * (s[2] + s[1])) * ((s[0] + s[3]) * (s[0] + s[3]) + (s[2] - s[1]) * (s[2] - s[1])), u = (a + o) / 2;
    if (l < r * u)
      return this.rx = this.ry = Math.sqrt(u), this.ax = 0, this;
    var c = s[0] * s[1] + s[2] * s[3];
    l = Math.sqrt(l);
    var f = u + l / 2, h = u - l / 2;
    return this.ax = Math.abs(c) < r && Math.abs(f - o) < r ? 90 : Math.atan(
      Math.abs(c) > Math.abs(f - o) ? (f - a) / c : c / (f - o)
    ) * 180 / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(f), this.ry = Math.sqrt(h)) : (this.ax += 90, this.rx = Math.sqrt(h), this.ry = Math.sqrt(f)), this;
  }, t.prototype.isDegenerate = function() {
    return this.rx < r * this.ry || this.ry < r * this.rx;
  }, _d = t, _d;
}
var Ud, wy;
function OL() {
  if (wy) return Ud;
  wy = 1;
  var r = LL(), e = NL(), t = n5(), A = TL(), n = PL();
  function i(s) {
    if (!(this instanceof i))
      return new i(s);
    var a = r(s);
    this.segments = a.segments, this.err = a.err, this.__stack = [];
  }
  return i.from = function(s) {
    if (typeof s == "string") return new i(s);
    if (s instanceof i) {
      var a = new i("");
      return a.err = s.err, a.segments = s.segments.map(function(o) {
        return o.slice();
      }), a.__stack = s.__stack.map(function(o) {
        return t().matrix(o.toArray());
      }), a;
    }
    throw new Error("SvgPath.from: invalid param type " + s);
  }, i.prototype.__matrix = function(s) {
    var a = this, o;
    s.queue.length && this.iterate(function(l, u, c, f) {
      var h, g, p, v;
      switch (l[0]) {
        // Process 'assymetric' commands separately
        case "v":
          h = s.calc(0, l[1], !0), g = h[0] === 0 ? ["v", h[1]] : ["l", h[0], h[1]];
          break;
        case "V":
          h = s.calc(c, l[1], !1), g = h[0] === s.calc(c, f, !1)[0] ? ["V", h[1]] : ["L", h[0], h[1]];
          break;
        case "h":
          h = s.calc(l[1], 0, !0), g = h[1] === 0 ? ["h", h[0]] : ["l", h[0], h[1]];
          break;
        case "H":
          h = s.calc(l[1], f, !1), g = h[1] === s.calc(c, f, !1)[1] ? ["H", h[0]] : ["L", h[0], h[1]];
          break;
        case "a":
        case "A":
          var w = s.toArray(), b = n(l[1], l[2], l[3]).transform(w);
          if (w[0] * w[3] - w[1] * w[2] < 0 && (l[5] = l[5] ? "0" : "1"), h = s.calc(l[6], l[7], l[0] === "a"), l[0] === "A" && l[6] === c && l[7] === f || l[0] === "a" && l[6] === 0 && l[7] === 0) {
            g = [l[0] === "a" ? "l" : "L", h[0], h[1]];
            break;
          }
          b.isDegenerate() ? g = [l[0] === "a" ? "l" : "L", h[0], h[1]] : g = [l[0], b.rx, b.ry, b.ax, l[4], l[5], h[0], h[1]];
          break;
        case "m":
          v = u > 0, h = s.calc(l[1], l[2], v), g = ["m", h[0], h[1]];
          break;
        default:
          for (p = l[0], g = [p], v = p.toLowerCase() === p, o = 1; o < l.length; o += 2)
            h = s.calc(l[o], l[o + 1], v), g.push(h[0], h[1]);
      }
      a.segments[u] = g;
    }, !0);
  }, i.prototype.__evaluateStack = function() {
    var s, a;
    if (this.__stack.length) {
      if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]), this.__stack = [];
        return;
      }
      for (s = t(), a = this.__stack.length; --a >= 0; )
        s.matrix(this.__stack[a].toArray());
      this.__matrix(s), this.__stack = [];
    }
  }, i.prototype.toString = function() {
    var s = "", a = "", o = !1;
    this.__evaluateStack();
    for (var l = 0, u = this.segments.length; l < u; l++) {
      var c = this.segments[l], f = c[0];
      f !== a || f === "m" || f === "M" ? (f === "m" && a === "z" && (s += " "), s += f, o = !1) : o = !0;
      for (var h = 1; h < c.length; h++) {
        var g = c[h];
        h === 1 ? o && g >= 0 && (s += " ") : g >= 0 && (s += " "), s += g;
      }
      a = f;
    }
    return s;
  }, i.prototype.translate = function(s, a) {
    return this.__stack.push(t().translate(s, a || 0)), this;
  }, i.prototype.scale = function(s, a) {
    return this.__stack.push(t().scale(s, !a && a !== 0 ? s : a)), this;
  }, i.prototype.rotate = function(s, a, o) {
    return this.__stack.push(t().rotate(s, a || 0, o || 0)), this;
  }, i.prototype.skewX = function(s) {
    return this.__stack.push(t().skewX(s)), this;
  }, i.prototype.skewY = function(s) {
    return this.__stack.push(t().skewY(s)), this;
  }, i.prototype.matrix = function(s) {
    return this.__stack.push(t().matrix(s)), this;
  }, i.prototype.transform = function(s) {
    return s.trim() ? (this.__stack.push(e(s)), this) : this;
  }, i.prototype.round = function(s) {
    var a = 0, o = 0, l = 0, u = 0, c;
    return s = s || 0, this.__evaluateStack(), this.segments.forEach(function(f) {
      var h = f[0].toLowerCase() === f[0];
      switch (f[0]) {
        case "H":
        case "h":
          h && (f[1] += l), l = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "V":
        case "v":
          h && (f[1] += u), u = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "Z":
        case "z":
          l = a, u = o;
          return;
        case "M":
        case "m":
          h && (f[1] += l, f[2] += u), l = f[1] - f[1].toFixed(s), u = f[2] - f[2].toFixed(s), a = l, o = u, f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s);
          return;
        case "A":
        case "a":
          h && (f[6] += l, f[7] += u), l = f[6] - f[6].toFixed(s), u = f[7] - f[7].toFixed(s), f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s), f[3] = +f[3].toFixed(s + 2), f[6] = +f[6].toFixed(s), f[7] = +f[7].toFixed(s);
          return;
        default:
          c = f.length, h && (f[c - 2] += l, f[c - 1] += u), l = f[c - 2] - f[c - 2].toFixed(s), u = f[c - 1] - f[c - 1].toFixed(s), f.forEach(function(g, p) {
            p && (f[p] = +f[p].toFixed(s));
          });
          return;
      }
    }), this;
  }, i.prototype.iterate = function(s, a) {
    var o = this.segments, l = {}, u = !1, c = 0, f = 0, h = 0, g = 0, p, v, w;
    if (a || this.__evaluateStack(), o.forEach(function(b, S) {
      var B = s(b, S, c, f);
      Array.isArray(B) && (l[S] = B, u = !0);
      var x = b[0] === b[0].toLowerCase();
      switch (b[0]) {
        case "m":
        case "M":
          c = b[1] + (x ? c : 0), f = b[2] + (x ? f : 0), h = c, g = f;
          return;
        case "h":
        case "H":
          c = b[1] + (x ? c : 0);
          return;
        case "v":
        case "V":
          f = b[1] + (x ? f : 0);
          return;
        case "z":
        case "Z":
          c = h, f = g;
          return;
        default:
          c = b[b.length - 2] + (x ? c : 0), f = b[b.length - 1] + (x ? f : 0);
      }
    }), !u)
      return this;
    for (w = [], p = 0; p < o.length; p++)
      if (typeof l[p] < "u")
        for (v = 0; v < l[p].length; v++)
          w.push(l[p][v]);
      else
        w.push(o[p]);
    return this.segments = w, this;
  }, i.prototype.abs = function() {
    return this.iterate(function(s, a, o, l) {
      var u = s[0], c = u.toUpperCase(), f;
      if (u !== c)
        switch (s[0] = c, u) {
          case "v":
            s[1] += l;
            return;
          case "a":
            s[6] += o, s[7] += l;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] += f % 2 ? o : l;
        }
    }, !0), this;
  }, i.prototype.rel = function() {
    return this.iterate(function(s, a, o, l) {
      var u = s[0], c = u.toLowerCase(), f;
      if (u !== c && !(a === 0 && u === "M"))
        switch (s[0] = c, u) {
          case "V":
            s[1] -= l;
            return;
          case "A":
            s[6] -= o, s[7] -= l;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] -= f % 2 ? o : l;
        }
    }, !0), this;
  }, i.prototype.unarc = function() {
    return this.iterate(function(s, a, o, l) {
      var u, c, f, h = [], g = s[0];
      return g !== "A" && g !== "a" ? null : (g === "a" ? (c = o + s[6], f = l + s[7]) : (c = s[6], f = s[7]), u = A(o, l, c, f, s[4], s[5], s[1], s[2], s[3]), u.length === 0 ? [[s[0] === "a" ? "l" : "L", s[6], s[7]]] : (u.forEach(function(p) {
        h.push(["C", p[2], p[3], p[4], p[5], p[6], p[7]]);
      }), h));
    }), this;
  }, i.prototype.unshort = function() {
    var s = this.segments, a, o, l, u, c;
    return this.iterate(function(f, h, g, p) {
      var v = f[0], w = v.toUpperCase(), b;
      h && (w === "T" ? (b = v === "t", l = s[h - 1], l[0] === "Q" ? (a = l[1] - g, o = l[2] - p) : l[0] === "q" ? (a = l[1] - l[3], o = l[2] - l[4]) : (a = 0, o = 0), u = -a, c = -o, b || (u += g, c += p), s[h] = [
        b ? "q" : "Q",
        u,
        c,
        f[1],
        f[2]
      ]) : w === "S" && (b = v === "s", l = s[h - 1], l[0] === "C" ? (a = l[3] - g, o = l[4] - p) : l[0] === "c" ? (a = l[3] - l[5], o = l[4] - l[6]) : (a = 0, o = 0), u = -a, c = -o, b || (u += g, c += p), s[h] = [
        b ? "c" : "C",
        u,
        c,
        f[1],
        f[2],
        f[3],
        f[4]
      ]));
    }), this;
  }, Ud = i, Ud;
}
var Id, yy;
function ML() {
  return yy || (yy = 1, Id = OL()), Id;
}
var RL = ML();
const kL = /* @__PURE__ */ vu(RL);
var by = function(r) {
  var e = r, t, A = {
    a: 0,
    b: 0,
    c: 0
  }, n = [], i = /(\[[^\]]+\])/g, s = /(#[^\#\s\+>~\.\[:\)]+)/g, a = /(\.[^\s\+>~\.\[:\)]+)/g, o = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi, l = /(:(?!not|global|local)[\w-]+\([^\)]*\))/gi, u = /(:(?!not|global|local)[^\s\+>~\.\[:]+)/g, c = /([^\s\+>~\.\[:]+)/g;
  return t = function(f, h) {
    var g, p, v, w, b, S;
    if (f.test(e))
      for (g = e.match(f), p = 0, v = g.length; p < v; p += 1)
        A[h] += 1, w = g[p], b = e.indexOf(w), S = w.length, n.push({
          selector: r.substr(b, S),
          type: h,
          index: b,
          length: S
        }), e = e.replace(w, Array(S + 1).join(" "));
  }, (function() {
    var f = function(v) {
      var w, b, S, B;
      if (v.test(e))
        for (w = e.match(v), b = 0, S = w.length; b < S; b += 1)
          B = w[b], e = e.replace(B, Array(B.length + 1).join("A"));
    }, h = /\\[0-9A-Fa-f]{6}\s?/g, g = /\\[0-9A-Fa-f]{1,5}\s/g, p = /\\./g;
    f(h), f(g), f(p);
  })(), (function() {
    var f = /{[^]*/gm, h, g, p, v;
    if (f.test(e))
      for (h = e.match(f), g = 0, p = h.length; g < p; g += 1)
        v = h[g], e = e.replace(v, Array(v.length + 1).join(" "));
  })(), t(i, "b"), t(s, "a"), t(a, "b"), t(o, "c"), t(l, "b"), t(u, "b"), e = e.replace(/[\*\s\+>~]/g, " "), e = e.replace(/[#\.]/g, " "), e = e.replace(/:not/g, "    "), e = e.replace(/:local/g, "      "), e = e.replace(/:global/g, "       "), e = e.replace(/[\(\)]/g, " "), t(c, "c"), n.sort(function(f, h) {
    return f.index - h.index;
  }), {
    selector: r,
    specificity: "0," + A.a.toString() + "," + A.b.toString() + "," + A.c.toString(),
    specificityArray: [0, A.a, A.b, A.c],
    parts: n
  };
}, HL = function(r, e) {
  var t, A, n;
  if (typeof r == "string") {
    if (r.indexOf(",") !== -1)
      throw "Invalid CSS selector";
    t = by(r).specificityArray;
  } else if (Array.isArray(r)) {
    if (r.filter(function(i) {
      return typeof i == "number";
    }).length !== 4)
      throw "Invalid specificity array";
    t = r;
  } else
    throw "Invalid CSS selector or specificity array";
  if (typeof e == "string") {
    if (e.indexOf(",") !== -1)
      throw "Invalid CSS selector";
    A = by(e).specificityArray;
  } else if (Array.isArray(e)) {
    if (e.filter(function(i) {
      return typeof i == "number";
    }).length !== 4)
      throw "Invalid specificity array";
    A = e;
  } else
    throw "Invalid CSS selector or specificity array";
  for (n = 0; n < 4; n += 1) {
    if (t[n] < A[n])
      return -1;
    if (t[n] > A[n])
      return 1;
  }
  return 0;
}, um = function(r, e) {
  return um = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  }, um(r, e);
};
function sr(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  um(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var xh = function() {
  return xh = Object.assign || function(r) {
    for (var e, t = 1, A = arguments.length; t < A; t++) for (var n in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    return r;
  }, xh.apply(this, arguments);
};
function cr(r, e, t, A) {
  return new (t || (t = Promise))((function(n, i) {
    function s(l) {
      try {
        o(A.next(l));
      } catch (u) {
        i(u);
      }
    }
    function a(l) {
      try {
        o(A.throw(l));
      } catch (u) {
        i(u);
      }
    }
    function o(l) {
      var u;
      l.done ? n(l.value) : (u = l.value, u instanceof t ? u : new t((function(c) {
        c(u);
      }))).then(s, a);
    }
    o((A = A.apply(r, e || [])).next());
  }));
}
function hr(r, e) {
  var t, A, n, i, s = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] };
  return i = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(o) {
    return function(l) {
      return (function(u) {
        if (t) throw new TypeError("Generator is already executing.");
        for (; s; ) try {
          if (t = 1, A && (n = 2 & u[0] ? A.return : u[0] ? A.throw || ((n = A.return) && n.call(A), 0) : A.next) && !(n = n.call(A, u[1])).done) return n;
          switch (A = 0, n && (u = [2 & u[0], n.value]), u[0]) {
            case 0:
            case 1:
              n = u;
              break;
            case 4:
              return s.label++, { value: u[1], done: !1 };
            case 5:
              s.label++, A = u[1], u = [0];
              continue;
            case 7:
              u = s.ops.pop(), s.trys.pop();
              continue;
            default:
              if (n = s.trys, !((n = n.length > 0 && n[n.length - 1]) || u[0] !== 6 && u[0] !== 2)) {
                s = 0;
                continue;
              }
              if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
                s.label = u[1];
                break;
              }
              if (u[0] === 6 && s.label < n[1]) {
                s.label = n[1], n = u;
                break;
              }
              if (n && s.label < n[2]) {
                s.label = n[2], s.ops.push(u);
                break;
              }
              n[2] && s.ops.pop(), s.trys.pop();
              continue;
          }
          u = e.call(r, s);
        } catch (c) {
          u = [6, c], A = 0;
        } finally {
          t = n = 0;
        }
        if (5 & u[0]) throw u[1];
        return { value: u[0] ? u[1] : void 0, done: !0 };
      })([o, l]);
    };
  }
}
var ii = (function() {
  function r(e) {
    if (this.a = void 0, this.r = 0, this.g = 0, this.b = 0, this.simpleColors = {}, this.colorDefs = [], this.ok = !1, e) {
      for (var t in e.charAt(0) == "#" && (e = e.substr(1, 6)), e = (e = e.replace(/ /g, "")).toLowerCase(), this.simpleColors = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", grey: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }, this.simpleColors) e == t && (e = this.simpleColors[t]);
      this.colorDefs = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(o) {
        return [parseInt(o[1]), parseInt(o[2]), parseInt(o[3])];
      } }, { re: /^rgb\(([0-9.]+)%,\s*([0-9.]+)%,\s*([0-9.]+)%\)$/, example: ["rgb(50.5%, 25.75%, 75.5%)", "rgb(100%,0%,0%)"], process: function(o) {
        return [Math.round(2.55 * parseFloat(o[1])), Math.round(2.55 * parseFloat(o[2])), Math.round(2.55 * parseFloat(o[3]))];
      } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(o) {
        return [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16)];
      } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(o) {
        return [parseInt(o[1] + o[1], 16), parseInt(o[2] + o[2], 16), parseInt(o[3] + o[3], 16)];
      } }];
      for (var A = 0; A < this.colorDefs.length; A++) {
        var n = this.colorDefs[A].re, i = this.colorDefs[A].process, s = n.exec(e);
        if (s) {
          var a = i(s);
          this.r = a[0], this.g = a[1], this.b = a[2], this.ok = !0;
        }
      }
      this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
    }
  }
  return r.prototype.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, r.prototype.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + (this.a || "1") + ")";
  }, r.prototype.toHex = function() {
    var e = this.r.toString(16), t = this.g.toString(16), A = this.b.toString(16);
    return e.length == 1 && (e = "0" + e), t.length == 1 && (t = "0" + t), A.length == 1 && (A = "0" + A), "#" + e + t + A;
  }, r.prototype.getHelpXML = function() {
    for (var e = [], t = 0; t < this.colorDefs.length; t++) for (var A = this.colorDefs[t].example, n = 0; n < A.length; n++) e[e.length] = A[n];
    for (var i in this.simpleColors) e[e.length] = i;
    var s = document.createElement("ul");
    for (s.setAttribute("id", "rgbcolor-examples"), t = 0; t < e.length; t++) try {
      var a = document.createElement("li"), o = new r(e[t]), l = document.createElement("div");
      l.style.cssText = "margin: 3px; border: 1px solid black; background:" + o.toHex() + "; color:" + o.toHex(), l.appendChild(document.createTextNode("test"));
      var u = document.createTextNode(" " + e[t] + " -> " + o.toRGB() + " -> " + o.toHex());
      a.appendChild(l), a.appendChild(u), s.appendChild(a);
    } catch {
    }
    return s;
  }, r;
})(), UA = (function() {
  function r(e) {
    this.color = e;
  }
  return r.prototype.getFillData = function(e, t) {
    return cr(this, void 0, void 0, (function() {
      return hr(this, (function(A) {
        return [2, void 0];
      }));
    }));
  }, r;
})(), Po = (function() {
  function r() {
    this.xmlSpace = "", this.whiteSpace = "", this.fill = null, this.fillOpacity = 1, this.fontFamily = "", this.fontSize = 16, this.fontStyle = "", this.fontWeight = "", this.opacity = 1, this.stroke = null, this.strokeDasharray = null, this.strokeDashoffset = 0, this.strokeLinecap = "", this.strokeLinejoin = "", this.strokeMiterlimit = 4, this.strokeOpacity = 1, this.strokeWidth = 1, this.alignmentBaseline = "", this.textAnchor = "", this.visibility = "", this.color = null, this.contextFill = null, this.contextStroke = null, this.fillRule = null;
  }
  return r.prototype.clone = function() {
    var e = new r();
    return e.xmlSpace = this.xmlSpace, e.whiteSpace = this.whiteSpace, e.fill = this.fill, e.fillOpacity = this.fillOpacity, e.fontFamily = this.fontFamily, e.fontSize = this.fontSize, e.fontStyle = this.fontStyle, e.fontWeight = this.fontWeight, e.opacity = this.opacity, e.stroke = this.stroke, e.strokeDasharray = this.strokeDasharray, e.strokeDashoffset = this.strokeDashoffset, e.strokeLinecap = this.strokeLinecap, e.strokeLinejoin = this.strokeLinejoin, e.strokeMiterlimit = this.strokeMiterlimit, e.strokeOpacity = this.strokeOpacity, e.strokeWidth = this.strokeWidth, e.textAnchor = this.textAnchor, e.alignmentBaseline = this.alignmentBaseline, e.visibility = this.visibility, e.color = this.color, e.fillRule = this.fillRule, e.contextFill = this.contextFill, e.contextStroke = this.contextStroke, e;
  }, r.default = function() {
    var e = new r();
    return e.xmlSpace = "default", e.whiteSpace = "normal", e.fill = new UA(new ii("rgb(0, 0, 0)")), e.fillOpacity = 1, e.fontFamily = "times", e.fontSize = 16, e.fontStyle = "normal", e.fontWeight = "normal", e.opacity = 1, e.stroke = null, e.strokeDasharray = null, e.strokeDashoffset = 0, e.strokeLinecap = "butt", e.strokeLinejoin = "miter", e.strokeMiterlimit = 4, e.strokeOpacity = 1, e.strokeWidth = 1, e.alignmentBaseline = "baseline", e.textAnchor = "start", e.visibility = "visible", e.color = new ii("rgb(0, 0, 0)"), e.fillRule = "nonzero", e.contextFill = null, e.contextStroke = null, e;
  }, r.getContextColors = function(e, t) {
    t === void 0 && (t = !1);
    var A = {};
    return e.attributeState.contextFill && (A.contextFill = e.attributeState.contextFill), e.attributeState.contextStroke && (A.contextStroke = e.attributeState.contextStroke), t && e.attributeState.color && (A.color = e.attributeState.color), A;
  }, r;
})(), Zs = (function() {
  function r(e, t) {
    var A, n, i;
    this.pdf = e, this.svg2pdfParameters = t.svg2pdfParameters, this.attributeState = t.attributeState ? t.attributeState.clone() : Po.default(), this.viewport = t.viewport, this.refsHandler = t.refsHandler, this.styleSheets = t.styleSheets, this.textMeasure = t.textMeasure, this.transform = (A = t.transform) !== null && A !== void 0 ? A : this.pdf.unitMatrix, this.withinClipPath = (n = t.withinClipPath) !== null && n !== void 0 && n, this.withinUse = (i = t.withinUse) !== null && i !== void 0 && i;
  }
  return r.prototype.clone = function(e) {
    var t, A, n, i;
    return e === void 0 && (e = {}), new r(this.pdf, { svg2pdfParameters: this.svg2pdfParameters, attributeState: e.attributeState ? e.attributeState.clone() : this.attributeState.clone(), viewport: (t = e.viewport) !== null && t !== void 0 ? t : this.viewport, refsHandler: this.refsHandler, styleSheets: this.styleSheets, textMeasure: this.textMeasure, transform: (A = e.transform) !== null && A !== void 0 ? A : this.transform, withinClipPath: (n = e.withinClipPath) !== null && n !== void 0 ? n : this.withinClipPath, withinUse: (i = e.withinUse) !== null && i !== void 0 ? i : this.withinUse });
  }, r;
})(), i5 = (function() {
  function r(e) {
    this.renderedElements = {}, this.idMap = e, this.idPrefix = String(r.instanceCounter++);
  }
  return r.prototype.getRendered = function(e, t, A) {
    return cr(this, void 0, void 0, (function() {
      var n, i;
      return hr(this, (function(s) {
        switch (s.label) {
          case 0:
            return n = this.generateKey(e, t), this.renderedElements.hasOwnProperty(n) ? [2, this.renderedElements[e]] : (i = this.get(e), this.renderedElements[n] = i, [4, A(i)]);
          case 1:
            return s.sent(), [2, i];
        }
      }));
    }));
  }, r.prototype.get = function(e) {
    return this.idMap[A5(e, { isIdentifier: !0 })];
  }, r.prototype.generateKey = function(e, t) {
    var A = "";
    return t && (A = ["color", "contextFill", "contextStroke"].map((function(n) {
      var i, s;
      return (s = (i = t[n]) === null || i === void 0 ? void 0 : i.toRGBA()) !== null && s !== void 0 ? s : "";
    })).join("|")), this.idPrefix + "|" + e + "|" + A;
  }, r.instanceCounter = 0, r;
})();
function By(r, e) {
  return Math.atan2(e[1] - r[1], e[0] - r[0]);
}
var Cy = 2 / 3;
function Sy(r, e) {
  return [Cy * (e[0] - r[0]) + r[0], Cy * (e[1] - r[1]) + r[1]];
}
function Nl(r) {
  var e = Math.sqrt(r[0] * r[0] + r[1] * r[1]);
  return [r[0] / e, r[1] / e];
}
function uo(r, e) {
  return Nl([e[0] - r[0], e[1] - r[1]]);
}
function Ec(r, e) {
  return [r[0] + e[0], r[1] + e[1]];
}
function Qd(r, e) {
  var t = r[0], A = r[1];
  return [e.a * t + e.c * A + e.e, e.b * t + e.d * A + e.f];
}
var Oo = (function() {
  function r() {
    this.segments = [];
  }
  return r.prototype.moveTo = function(e, t) {
    return this.segments.push(new wA(e, t)), this;
  }, r.prototype.lineTo = function(e, t) {
    return this.segments.push(new ks(e, t)), this;
  }, r.prototype.curveTo = function(e, t, A, n, i, s) {
    return this.segments.push(new Si(e, t, A, n, i, s)), this;
  }, r.prototype.close = function() {
    return this.segments.push(new cm()), this;
  }, r.prototype.transform = function(e) {
    this.segments.forEach((function(t) {
      if (t instanceof wA || t instanceof ks || t instanceof Si) {
        var A = Qd([t.x, t.y], e);
        t.x = A[0], t.y = A[1];
      }
      if (t instanceof Si) {
        var n = Qd([t.x1, t.y1], e), i = Qd([t.x2, t.y2], e);
        t.x1 = n[0], t.y1 = n[1], t.x2 = i[0], t.y2 = i[1];
      }
    }));
  }, r.prototype.draw = function(e) {
    var t = e.pdf;
    this.segments.forEach((function(A) {
      A instanceof wA ? t.moveTo(A.x, A.y) : A instanceof ks ? t.lineTo(A.x, A.y) : A instanceof Si ? t.curveTo(A.x1, A.y1, A.x2, A.y2, A.x, A.y) : t.close();
    }));
  }, r;
})(), wA = function(r, e) {
  this.x = r, this.y = e;
}, ks = function(r, e) {
  this.x = r, this.y = e;
}, Si = function(r, e, t, A, n, i) {
  this.x1 = r, this.y1 = e, this.x2 = t, this.y2 = A, this.x = n, this.y = i;
}, cm = function() {
};
function Ws(r, e) {
  return e.split(",").indexOf((r.nodeName || r.tagName).toLowerCase()) >= 0;
}
function Le(r, e, t, A) {
  var n;
  A === void 0 && (A = t);
  var i = (n = r.style) === null || n === void 0 ? void 0 : n.getPropertyValue(A);
  if (i) return i;
  var s = e.getPropertyValue(r, A);
  return s || r.hasAttribute(t) && r.getAttribute(t) || void 0;
}
function hs(r, e, t) {
  if (Le(r.element, t.styleSheets, "display") === "none") return !1;
  var A = e, n = Le(r.element, t.styleSheets, "visibility");
  return n && (A = n !== "hidden"), A;
}
function ea(r, e, t) {
  var A = hs(r, e, t);
  return r.element.childNodes.length !== 0 && (r.children.forEach((function(n) {
    n.isVisible(A, t) && (A = !0);
  })), A);
}
var DL = (function() {
  function r() {
    this.markers = [];
  }
  return r.prototype.addMarker = function(e) {
    this.markers.push(e);
  }, r.prototype.draw = function(e) {
    return cr(this, void 0, void 0, (function() {
      var t, A, n, i, s, a, o, l;
      return hr(this, (function(u) {
        switch (u.label) {
          case 0:
            t = 0, u.label = 1;
          case 1:
            return t < this.markers.length ? (A = this.markers[t], n = void 0, i = A.angle, s = A.anchor, a = Math.cos(i), o = Math.sin(i), n = e.pdf.Matrix(a, o, -o, a, s[0], s[1]), n = e.pdf.matrixMult(e.pdf.Matrix(e.attributeState.strokeWidth, 0, 0, e.attributeState.strokeWidth, 0, 0), n), n = e.pdf.matrixMult(n, e.transform), e.pdf.saveGraphicsState(), l = Po.getContextColors(e), [4, e.refsHandler.getRendered(A.id, l, (function(c) {
              return c.apply(e);
            }))]) : [3, 4];
          case 2:
            u.sent(), e.pdf.doFormObject(e.refsHandler.generateKey(A.id, l), n), e.pdf.restoreGraphicsState(), u.label = 3;
          case 3:
            return t++, [3, 1];
          case 4:
            return [2];
        }
      }));
    }));
  }, r;
})(), Ns = function(r, e, t, A) {
  A === void 0 && (A = !1), this.id = r, this.anchor = e, this.angle = t, this.isStartMarker = A;
}, dv = /url\(["']?#([^"']+)["']?\)/, GL = { bottom: "bottom", "text-bottom": "bottom", top: "top", "text-top": "top", hanging: "hanging", middle: "middle", central: "middle", center: "middle", mathematical: "middle", ideographic: "ideographic", alphabetic: "alphabetic", baseline: "alphabetic" }, xy = "http://www.w3.org/2000/svg";
function As(r, e) {
  var t;
  return (t = r && r.toString().match(/^([\-0-9.]+)em$/)) ? parseFloat(t[1]) * e : (t = r && r.toString().match(/^([\-0-9.]+)(px|)$/)) ? parseFloat(t[1]) : 0;
}
function s5(r) {
  return GL[r] || "alphabetic";
}
function Mn(r) {
  for (var e, t = [], A = /[+-]?(?:(?:\d+\.?\d*)|(?:\d*\.?\d+))(?:[eE][+-]?\d+)?/g; e = A.exec(r); ) t.push(parseFloat(e[0]));
  return t;
}
function Lo(r, e) {
  if (r === "transparent") {
    var t = new ii("rgb(0,0,0)");
    return t.a = 0, t;
  }
  if (e && r.toLowerCase() === "currentcolor") return e.color || new ii("rgb(0,0,0)");
  if (e && r.toLowerCase() === "context-stroke") return e.contextStroke || new ii("rgb(0,0,0)");
  if (e && r.toLowerCase() === "context-fill") return e.contextFill || new ii("rgb(0,0,0)");
  var A = /\s*rgba\(((?:[^,\)]*,){3}[^,\)]*)\)\s*/.exec(r);
  if (A) {
    var n = Mn(A[1]), i = new ii("rgb(" + n.slice(0, 3).join(",") + ")");
    return i.a = n[3], i;
  }
  return new ii(r);
}
var ns = { "sans-serif": "helvetica", verdana: "helvetica", arial: "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", serif: "times", cursive: "times", fantasy: "times" }, Ld, VL = (Ld = ot.version.split("."), parseFloat(Ld[0]) === 2 && parseFloat(Ld[1]) === 3);
function a5(r, e) {
  return VL ? e == 400 ? r == "italic" ? "italic" : "normal" : e == 700 && r !== "italic" ? "bold" : r + "" + e : e == 400 || e === "normal" ? r === "italic" ? "italic" : "normal" : e != 700 && e !== "bold" || r !== "normal" ? (e == 700 ? "bold" : e) + "" + r : "bold";
}
function gv(r, e) {
  if (Le(e.element, r.styleSheets, "display") === "none") return [0, 0, 0, 0];
  var t = [];
  return e.children.forEach((function(A) {
    var n = A.getBoundingBox(r);
    if (n[0] !== 0 || n[1] !== 0 || n[2] !== 0 || n[3] !== 0) {
      var i = A.computeNodeTransform(r);
      n[0] = n[0] * i.sx + i.tx, n[1] = n[1] * i.sy + i.ty, n[2] = n[2] * i.sx, n[3] = n[3] * i.sy, t = t.length === 0 ? n : [Math.min(t[0], n[0]), Math.min(t[1], n[1]), Math.max(t[0] + t[2], n[0] + n[2]) - Math.min(t[0], n[0]), Math.max(t[1] + t[3], n[1] + n[3]) - Math.min(t[1], n[1])];
    }
  })), t.length === 0 ? [0, 0, 0, 0] : t;
}
function wu(r, e) {
  var t = parseFloat, A = t(r.getAttribute("x1")) || t(Le(r, e.styleSheets, "x")) || t(Le(r, e.styleSheets, "cx")) - t(Le(r, e.styleSheets, "r")) || 0, n = t(r.getAttribute("x2")) || A + t(Le(r, e.styleSheets, "width")) || t(Le(r, e.styleSheets, "cx")) + t(Le(r, e.styleSheets, "r")) || 0, i = t(r.getAttribute("y1")) || t(Le(r, e.styleSheets, "y")) || t(Le(r, e.styleSheets, "cy")) - t(Le(r, e.styleSheets, "r")) || 0, s = t(r.getAttribute("y2")) || i + t(Le(r, e.styleSheets, "height")) || t(Le(r, e.styleSheets, "cy")) + t(Le(r, e.styleSheets, "r")) || 0;
  return [Math.min(A, n), Math.min(i, s), Math.max(A, n) - Math.min(A, n), Math.max(i, s) - Math.min(i, s)];
}
function yu(r, e, t, A, n, i, s, a) {
  a === void 0 && (a = !1);
  var o, l, u = e[0], c = e[1], f = e[2], h = e[3], g = n / f, p = i / h, v = r.getAttribute("preserveAspectRatio");
  if (v) {
    var w = v.split(" ");
    w[0] === "defer" && (w = w.slice(1)), o = w[0], l = w[1] || "meet";
  } else o = "xMidYMid", l = "meet";
  if (o !== "none" && (l === "meet" ? g = p = Math.min(g, p) : l === "slice" && (g = p = Math.max(g, p))), a) return s.pdf.Matrix(g, 0, 0, p, 0, 0);
  var b = t - u * g, S = A - c * p;
  o.indexOf("xMid") >= 0 ? b += (n - f * g) / 2 : o.indexOf("xMax") >= 0 && (b += n - f * g), o.indexOf("YMid") >= 0 ? S += (i - h * p) / 2 : o.indexOf("YMax") >= 0 && (S += i - h * p);
  var B = s.pdf.Matrix(1, 0, 0, 1, b, S), x = s.pdf.Matrix(g, 0, 0, p, 0, 0);
  return s.pdf.matrixMult(x, B);
}
function Gh(r, e) {
  if (!r || r === "none") return e.pdf.unitMatrix;
  for (var t, A, n = /^[\s,]*matrix\(([^)]+)\)\s*/, i = /^[\s,]*translate\(([^)]+)\)\s*/, s = /^[\s,]*rotate\(([^)]+)\)\s*/, a = /^[\s,]*scale\(([^)]+)\)\s*/, o = /^[\s,]*skewX\(([^)]+)\)\s*/, l = /^[\s,]*skewY\(([^)]+)\)\s*/, u = e.pdf.unitMatrix; r.length > 0 && r.length !== A; ) {
    A = r.length;
    var c = n.exec(r);
    if (c && (t = Mn(c[1]), u = e.pdf.matrixMult(e.pdf.Matrix(t[0], t[1], t[2], t[3], t[4], t[5]), u), r = r.substr(c[0].length)), c = s.exec(r)) {
      t = Mn(c[1]);
      var f = Math.PI * t[0] / 180;
      if (u = e.pdf.matrixMult(e.pdf.Matrix(Math.cos(f), Math.sin(f), -Math.sin(f), Math.cos(f), 0, 0), u), t[1] || t[2]) {
        var h = e.pdf.Matrix(1, 0, 0, 1, t[1], t[2]), g = e.pdf.Matrix(1, 0, 0, 1, -t[1], -t[2]);
        u = e.pdf.matrixMult(g, e.pdf.matrixMult(u, h));
      }
      r = r.substr(c[0].length);
    }
    (c = i.exec(r)) && (t = Mn(c[1]), u = e.pdf.matrixMult(e.pdf.Matrix(1, 0, 0, 1, t[0], t[1] || 0), u), r = r.substr(c[0].length)), (c = a.exec(r)) && ((t = Mn(c[1]))[1] || (t[1] = t[0]), u = e.pdf.matrixMult(e.pdf.Matrix(t[0], 0, 0, t[1], 0, 0), u), r = r.substr(c[0].length)), (c = o.exec(r)) && (t = parseFloat(c[1]), t *= Math.PI / 180, u = e.pdf.matrixMult(e.pdf.Matrix(1, 0, Math.tan(t), 1, 0, 0), u), r = r.substr(c[0].length)), (c = l.exec(r)) && (t = parseFloat(c[1]), t *= Math.PI / 180, u = e.pdf.matrixMult(e.pdf.Matrix(1, Math.tan(t), 0, 1, 0, 0), u), r = r.substr(c[0].length));
  }
  return u;
}
var pv = (function() {
  function r(e, t) {
    this.element = e, this.children = t, this.parent = null;
  }
  return r.prototype.setParent = function(e) {
    this.parent = e;
  }, r.prototype.getParent = function() {
    return this.parent;
  }, r.prototype.getBoundingBox = function(e) {
    return Le(this.element, e.styleSheets, "display") === "none" ? [0, 0, 0, 0] : this.getBoundingBoxCore(e);
  }, r.prototype.computeNodeTransform = function(e) {
    var t = this.computeNodeTransformCore(e), A = Le(this.element, e.styleSheets, "transform");
    return A ? e.pdf.matrixMult(t, Gh(A, e)) : t;
  }, r;
})(), bu = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.render = function(t) {
    return Promise.resolve();
  }, e.prototype.getBoundingBoxCore = function(t) {
    return [];
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(pv), o5 = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, A, n) || this;
    return i.pdfGradientType = t, i.contextColor = void 0, i;
  }
  return sr(e, r), e.prototype.apply = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o;
      return hr(this, (function(l) {
        return (A = this.element.getAttribute("id")) ? (n = this.getStops(t.styleSheets), i = 0, s = !1, n.forEach((function(u) {
          var c = u.opacity;
          c && c !== 1 && (i += c, s = !0);
        })), s && (a = new Ga({ opacity: i / n.length })), o = new Rs(this.pdfGradientType, this.getCoordinates(), n, a), t.pdf.addShadingPattern(A, o), [2]) : [2];
      }));
    }));
  }, e.prototype.getStops = function(t) {
    var A = this;
    if (this.stops) return this.stops;
    if (this.contextColor === void 0) {
      this.contextColor = null;
      for (var n = this; n; ) {
        var i = Le(n.element, t, "color");
        if (i) {
          this.contextColor = Lo(i, null);
          break;
        }
        n = n.getParent();
      }
    }
    var s = [];
    return this.children.forEach((function(a) {
      if (a.element.tagName.toLowerCase() === "stop") {
        var o = Le(a.element, t, "color"), l = Lo(Le(a.element, t, "stop-color") || "", o ? { color: Lo(o, null) } : { color: A.contextColor }), u = parseFloat(Le(a.element, t, "stop-opacity") || "1");
        s.push({ offset: e.parseGradientOffset(a.element.getAttribute("offset") || "0"), color: [l.r, l.g, l.b], opacity: u });
      }
    })), this.stops = s;
  }, e.prototype.getBoundingBoxCore = function(t) {
    return wu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.parseGradientOffset = function(t) {
    var A = parseFloat(t);
    return !isNaN(A) && t.indexOf("%") >= 0 ? A / 100 : A;
  }, e;
})(bu), l5 = (function(r) {
  function e(t, A) {
    return r.call(this, "axial", t, A) || this;
  }
  return sr(e, r), e.prototype.getCoordinates = function() {
    return [parseFloat(this.element.getAttribute("x1") || "0"), parseFloat(this.element.getAttribute("y1") || "0"), parseFloat(this.element.getAttribute("x2") || "1"), parseFloat(this.element.getAttribute("y2") || "0")];
  }, e;
})(o5), u5 = (function(r) {
  function e(t, A) {
    return r.call(this, "radial", t, A) || this;
  }
  return sr(e, r), e.prototype.getCoordinates = function() {
    var t = this.element.getAttribute("cx"), A = this.element.getAttribute("cy"), n = this.element.getAttribute("fx"), i = this.element.getAttribute("fy");
    return [parseFloat(n || t || "0.5"), parseFloat(i || A || "0.5"), 0, parseFloat(t || "0.5"), parseFloat(A || "0.5"), parseFloat(this.element.getAttribute("r") || "0.5")];
  }, e;
})(o5), KL = (function() {
  function r(e, t) {
    this.key = e, this.gradient = t;
  }
  return r.prototype.getFillData = function(e, t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i;
      return hr(this, (function(s) {
        switch (s.label) {
          case 0:
            return [4, t.refsHandler.getRendered(this.key, null, (function(a) {
              return a.apply(new Zs(t.pdf, { refsHandler: t.refsHandler, textMeasure: t.textMeasure, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters }));
            }))];
          case 1:
            return s.sent(), this.gradient.element.hasAttribute("gradientUnits") && this.gradient.element.getAttribute("gradientUnits").toLowerCase() !== "objectboundingbox" ? A = t.pdf.unitMatrix : (n = e.getBoundingBox(t), A = t.pdf.Matrix(n[2], 0, 0, n[3], n[0], n[1])), i = Gh(Le(this.gradient.element, t.styleSheets, "gradientTransform", "transform"), t), [2, { key: this.key, matrix: t.pdf.matrixMult(i, A) }];
        }
      }));
    }));
  }, r;
})(), c5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.apply = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!(A = this.element.getAttribute("id"))) return [2];
            n = this.getBoundingBox(t), i = new Ia([n[0], n[1], n[0] + n[2], n[1] + n[3]], n[2], n[3]), t.pdf.beginTilingPattern(i), s = 0, a = this.children, o.label = 1;
          case 1:
            return s < a.length ? [4, a[s].render(new Zs(t.pdf, { attributeState: t.attributeState, refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))] : [3, 4];
          case 2:
            o.sent(), o.label = 3;
          case 3:
            return s++, [3, 1];
          case 4:
            return t.pdf.endTilingPattern(A, i), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return wu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e;
})(bu), jL = (function() {
  function r(e, t) {
    this.key = e, this.pattern = t;
  }
  return r.prototype.getFillData = function(e, t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, c, f, h, g;
      return hr(this, (function(p) {
        switch (p.label) {
          case 0:
            return [4, t.refsHandler.getRendered(this.key, null, (function(v) {
              return v.apply(new Zs(t.pdf, { refsHandler: t.refsHandler, textMeasure: t.textMeasure, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters }));
            }))];
          case 1:
            return p.sent(), A = { key: this.key, boundingBox: void 0, xStep: 0, yStep: 0, matrix: void 0 }, i = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternUnits") && this.pattern.element.getAttribute("patternUnits").toLowerCase() !== "objectboundingbox" || (n = e.getBoundingBox(t), i = t.pdf.Matrix(1, 0, 0, 1, n[0], n[1]), a = this.pattern.getBoundingBox(t), o = a[0] * n[0] || 0, l = a[1] * n[1] || 0, u = a[2] * n[2] || 0, c = a[3] * n[3] || 0, A.boundingBox = [o, l, o + u, l + c], A.xStep = u, A.yStep = c), s = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternContentUnits") && this.pattern.element.getAttribute("patternContentUnits").toLowerCase() === "objectboundingbox" && (n || (n = e.getBoundingBox(t)), s = t.pdf.Matrix(n[2], 0, 0, n[3], 0, 0), a = A.boundingBox || this.pattern.getBoundingBox(t), o = a[0] / n[0] || 0, l = a[1] / n[1] || 0, u = a[2] / n[2] || 0, c = a[3] / n[3] || 0, A.boundingBox = [o, l, o + u, l + c], A.xStep = u, A.yStep = c), f = t.pdf.unitMatrix, (h = Le(this.pattern.element, t.styleSheets, "patternTransform", "transform")) && (f = Gh(h, t)), g = s, g = t.pdf.matrixMult(g, i), g = t.pdf.matrixMult(g, f), g = t.pdf.matrixMult(g, t.transform), A.matrix = g, [2, A];
        }
      }));
    }));
  }, r;
})();
function qL(r, e) {
  var t = dv.exec(r);
  if (t) {
    var A = t[1], n = e.refsHandler.get(A);
    return n && (n instanceof l5 || n instanceof u5) ? (function(s, a, o) {
      var l = a.getStops(o.styleSheets);
      if (l.length === 0) return null;
      if (l.length === 1) {
        var u = l[0].color, c = new ii();
        return c.ok = !0, c.r = u[0], c.g = u[1], c.b = u[2], c.a = l[0].opacity, new UA(c);
      }
      return new KL(s, a);
    })(A, n, e) : n && n instanceof c5 ? new jL(A, n) : new UA(new ii("rgb(0, 0, 0)"));
  }
  var i = Lo(r, e.attributeState);
  return i.ok ? new UA(i) : null;
}
function mv(r, e, t) {
  var A = t || e.element, n = Le(A, r.styleSheets, "color");
  if (n) {
    var i = Lo(n, r.attributeState);
    i.ok ? r.attributeState.color = i : r.attributeState.color = new ii("rgb(0,0,0)");
  }
  var s = Le(A, r.styleSheets, "visibility");
  s && (r.attributeState.visibility = s);
  var a = Le(A, r.styleSheets, "fill");
  a && (r.attributeState.fill = qL(a, r));
  var o = Le(A, r.styleSheets, "fill-opacity");
  o && (r.attributeState.fillOpacity = parseFloat(o));
  var l = Le(A, r.styleSheets, "stroke-opacity");
  l && (r.attributeState.strokeOpacity = parseFloat(l));
  var u = Le(A, r.styleSheets, "opacity");
  u && (r.attributeState.opacity = parseFloat(u));
  var c = Le(A, r.styleSheets, "stroke-width");
  c !== void 0 && c !== "" && (r.attributeState.strokeWidth = Math.abs(parseFloat(c)));
  var f = Le(A, r.styleSheets, "stroke");
  if (f) if (f === "none") r.attributeState.stroke = null;
  else {
    var h = Lo(f, r.attributeState);
    h.ok && (r.attributeState.stroke = new UA(h));
  }
  f && r.attributeState.stroke instanceof UA && (r.attributeState.contextStroke = r.attributeState.stroke.color), a && r.attributeState.fill instanceof UA && (r.attributeState.contextFill = r.attributeState.fill.color);
  var g = Le(A, r.styleSheets, "stroke-linecap");
  g && (r.attributeState.strokeLinecap = g);
  var p = Le(A, r.styleSheets, "stroke-linejoin");
  p && (r.attributeState.strokeLinejoin = p);
  var v = Le(A, r.styleSheets, "stroke-dasharray");
  if (v) {
    var w = parseInt(Le(A, r.styleSheets, "stroke-dashoffset") || "0");
    r.attributeState.strokeDasharray = Mn(v), r.attributeState.strokeDashoffset = w;
  }
  var b = Le(A, r.styleSheets, "stroke-miterlimit");
  b !== void 0 && b !== "" && (r.attributeState.strokeMiterlimit = parseFloat(b));
  var S = A.getAttribute("xml:space");
  S && (r.attributeState.xmlSpace = S);
  var B = Le(A, r.styleSheets, "white-space");
  B && (r.attributeState.whiteSpace = B);
  var x = Le(A, r.styleSheets, "font-weight");
  x && (r.attributeState.fontWeight = x);
  var U = Le(A, r.styleSheets, "font-style");
  U && (r.attributeState.fontStyle = U);
  var Q = Le(A, r.styleSheets, "font-family");
  if (Q) {
    var N = QL.parse(Q);
    r.attributeState.fontFamily = (function($, ne, te) {
      var J = a5($.fontStyle, $.fontWeight), re = te.pdf.getFontList(), le = "";
      return ne.some((function(se) {
        var P = re[se];
        return P && P.indexOf(J) >= 0 ? (le = se, !0) : (se = se.toLowerCase(), !!ns.hasOwnProperty(se) && (le = se, !0));
      })) || (le = "times"), le;
    })(r.attributeState, N, r);
  }
  var _ = Le(A, r.styleSheets, "font-size");
  if (_) {
    var R = r.pdf.getFontSize();
    r.attributeState.fontSize = As(_, R);
  }
  var F = Le(A, r.styleSheets, "vertical-align") || Le(A, r.styleSheets, "alignment-baseline");
  if (F) {
    var O = F.match(/(baseline|text-bottom|alphabetic|ideographic|middle|central|mathematical|text-top|bottom|center|top|hanging)/);
    O && (r.attributeState.alignmentBaseline = O[0]);
  }
  var G = Le(A, r.styleSheets, "text-anchor");
  G && (r.attributeState.textAnchor = G);
  var H = Le(A, r.styleSheets, "fill-rule");
  H && (r.attributeState.fillRule = H);
}
function vv(r, e, t) {
  var A = 1, n = 1;
  A *= r.attributeState.fillOpacity, A *= r.attributeState.opacity, r.attributeState.fill instanceof UA && r.attributeState.fill.color.a !== void 0 && (A *= r.attributeState.fill.color.a), n *= r.attributeState.strokeOpacity, n *= r.attributeState.opacity, r.attributeState.stroke instanceof UA && r.attributeState.stroke.color.a !== void 0 && (n *= r.attributeState.stroke.color.a);
  var i, s, a = A < 1, o = n < 1;
  if (Ws(t, "use") ? (a = !0, o = !0, A *= r.attributeState.fill ? 1 : 0, n *= r.attributeState.stroke ? 1 : 0) : r.withinUse && (r.attributeState.fill !== e.attributeState.fill ? (a = !0, A *= r.attributeState.fill ? 1 : 0) : a && !r.attributeState.fill && (A = 0), r.attributeState.stroke !== e.attributeState.stroke ? (o = !0, n *= r.attributeState.stroke ? 1 : 0) : o && !r.attributeState.stroke && (n = 0)), a || o) {
    var l = {};
    a && (l.opacity = A), o && (l["stroke-opacity"] = n), r.pdf.setGState(new Ga(l));
  }
  if (r.attributeState.fill && r.attributeState.fill !== e.attributeState.fill && r.attributeState.fill instanceof UA && r.attributeState.fill.color.ok && !Ws(t, "text") && r.pdf.setFillColor(r.attributeState.fill.color.r, r.attributeState.fill.color.g, r.attributeState.fill.color.b), r.attributeState.strokeWidth !== e.attributeState.strokeWidth && r.pdf.setLineWidth(r.attributeState.strokeWidth), r.attributeState.stroke !== e.attributeState.stroke && r.attributeState.stroke instanceof UA && r.pdf.setDrawColor(r.attributeState.stroke.color.r, r.attributeState.stroke.color.g, r.attributeState.stroke.color.b), r.attributeState.strokeLinecap !== e.attributeState.strokeLinecap && r.pdf.setLineCap(r.attributeState.strokeLinecap), r.attributeState.strokeLinejoin !== e.attributeState.strokeLinejoin && r.pdf.setLineJoin(r.attributeState.strokeLinejoin), r.attributeState.strokeDasharray === e.attributeState.strokeDasharray && r.attributeState.strokeDashoffset === e.attributeState.strokeDashoffset || !r.attributeState.strokeDasharray || r.pdf.setLineDashPattern(r.attributeState.strokeDasharray, r.attributeState.strokeDashoffset), r.attributeState.strokeMiterlimit !== e.attributeState.strokeMiterlimit && r.pdf.setLineMiterLimit(r.attributeState.strokeMiterlimit), r.attributeState.fontFamily !== e.attributeState.fontFamily && (i = ns.hasOwnProperty(r.attributeState.fontFamily) ? ns[r.attributeState.fontFamily] : r.attributeState.fontFamily), r.attributeState.fill && r.attributeState.fill !== e.attributeState.fill && r.attributeState.fill instanceof UA && r.attributeState.fill.color.ok) {
    var u = r.attributeState.fill.color;
    r.pdf.setTextColor(u.r, u.g, u.b);
  }
  r.attributeState.fontWeight === e.attributeState.fontWeight && r.attributeState.fontStyle === e.attributeState.fontStyle || (s = a5(r.attributeState.fontStyle, r.attributeState.fontWeight)), i === void 0 && s === void 0 || (i === void 0 && (i = ns.hasOwnProperty(r.attributeState.fontFamily) ? ns[r.attributeState.fontFamily] : r.attributeState.fontFamily), r.pdf.setFont(i, s)), r.attributeState.fontSize !== e.attributeState.fontSize && r.pdf.setFontSize(r.attributeState.fontSize * r.pdf.internal.scaleFactor);
}
function h5(r, e, t) {
  var A = dv.exec(r);
  if (A) {
    var n = A[1];
    return t.refsHandler.get(n) || void 0;
  }
}
function f5(r, e, t) {
  return cr(this, void 0, void 0, (function() {
    var A, n;
    return hr(this, (function(i) {
      switch (i.label) {
        case 0:
          return A = t.clone(), e.element.hasAttribute("clipPathUnits") && e.element.getAttribute("clipPathUnits").toLowerCase() === "objectboundingbox" && (n = r.getBoundingBox(t), A.transform = t.pdf.matrixMult(t.pdf.Matrix(n[2], 0, 0, n[3], n[0], n[1]), t.transform)), [4, e.apply(A)];
        case 1:
          return i.sent(), [2];
      }
    }));
  }));
}
var d5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.render = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s;
      return hr(this, (function(a) {
        switch (a.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? ((A = t.clone()).transform = A.pdf.matrixMult(this.computeNodeTransform(A), t.transform), mv(A, this), n = Le(this.element, A.styleSheets, "clip-path"), (i = n && n !== "none") ? (s = h5(n, 0, A)) ? s.isVisible(!0, A) ? (A.pdf.saveGraphicsState(), [4, f5(this, s, A)]) : [3, 2] : [3, 4] : [3, 5]) : [2];
          case 1:
            return a.sent(), [3, 3];
          case 2:
            return [2];
          case 3:
            return [3, 5];
          case 4:
            i = !1, a.label = 5;
          case 5:
            return A.withinClipPath || A.pdf.saveGraphicsState(), vv(A, t, this.element), [4, this.renderCore(A)];
          case 6:
            return a.sent(), A.withinClipPath || A.pdf.restoreGraphicsState(), i && A.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e;
})(pv), Vh = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e;
})(d5), Bu = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, A, n) || this;
    return i.cachedPath = null, i.hasMarkers = t, i;
  }
  return sr(e, r), e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A;
      return hr(this, (function(n) {
        switch (n.label) {
          case 0:
            return (A = this.getCachedPath(t)) === null || A.segments.length === 0 ? [2] : (t.withinClipPath ? A.transform(t.transform) : t.pdf.setCurrentTransformationMatrix(t.transform), A.draw(t), [4, this.fillOrStroke(t)]);
          case 1:
            return n.sent(), this.hasMarkers ? [4, this.drawMarkers(t, A)] : [3, 3];
          case 2:
            n.sent(), n.label = 3;
          case 3:
            return [2];
        }
      }));
    }));
  }, e.prototype.getCachedPath = function(t) {
    return this.cachedPath || (this.cachedPath = this.getPath(t));
  }, e.prototype.drawMarkers = function(t, A) {
    return cr(this, void 0, void 0, (function() {
      return hr(this, (function(n) {
        switch (n.label) {
          case 0:
            return [4, this.getMarkers(A, t).draw(t.clone({ transform: t.pdf.unitMatrix }))];
          case 1:
            return n.sent(), [2];
        }
      }));
    }));
  }, e.prototype.fillOrStroke = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            return t.withinClipPath ? [2] : (A = t.attributeState.fill, n = t.attributeState.stroke && t.attributeState.strokeWidth !== 0, A ? [4, A.getFillData(this, t)] : [3, 2]);
          case 1:
            return s = o.sent(), [3, 3];
          case 2:
            s = void 0, o.label = 3;
          case 3:
            return i = s, a = t.attributeState.fillRule === "evenodd", A && n || t.withinUse ? a ? t.pdf.fillStrokeEvenOdd(i) : t.pdf.fillStroke(i) : A ? a ? t.pdf.fillEvenOdd(i) : t.pdf.fill(i) : n ? t.pdf.stroke() : t.pdf.discardPath(), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    var A = this.getCachedPath(t);
    if (!A || !A.segments.length) return [0, 0, 0, 0];
    for (var n = Number.POSITIVE_INFINITY, i = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY, a = Number.NEGATIVE_INFINITY, o = 0, l = 0, u = 0; u < A.segments.length; u++) {
      var c = A.segments[u];
      (c instanceof wA || c instanceof ks || c instanceof Si) && (o = c.x, l = c.y), c instanceof Si ? (n = Math.min(n, o, c.x1, c.x2, c.x), s = Math.max(s, o, c.x1, c.x2, c.x), i = Math.min(i, l, c.y1, c.y2, c.y), a = Math.max(a, l, c.y1, c.y2, c.y)) : (n = Math.min(n, o), s = Math.max(s, o), i = Math.min(i, l), a = Math.max(a, l));
    }
    return [n, i, s - n, a - i];
  }, e.prototype.getMarkers = function(t, A) {
    var n = Le(this.element, A.styleSheets, "marker-start"), i = Le(this.element, A.styleSheets, "marker-mid"), s = Le(this.element, A.styleSheets, "marker-end"), a = new DL();
    if (n || i || s) {
      s && (s = Nd(s)), n && (n = Nd(n)), i && (i = Nd(i));
      for (var o = t.segments, l = [1, 0], u = void 0, c = !1, f = [1, 0], h = !1, g = function(v) {
        var w = o[v], b = n && (v === 1 || !(o[v] instanceof wA) && o[v - 1] instanceof wA);
        b && o.forEach((function(N, _) {
          if (!h && N instanceof cm && _ > v) {
            var R = o[_ - 1];
            h = (R instanceof wA || R instanceof ks || R instanceof Si) && R;
          }
        }));
        var S = s && (v === o.length - 1 || !(o[v] instanceof wA) && o[v + 1] instanceof wA), B = i && v > 0 && !(v === 1 && o[v - 1] instanceof wA), x = o[v - 1] || null;
        if (x instanceof wA || x instanceof ks || x instanceof Si)
          if (w instanceof Si) b && a.addMarker(new Ns(n, [x.x, x.y], By(h ? [h.x, h.y] : [x.x, x.y], [w.x1, w.y1]), !0)), S && a.addMarker(new Ns(s, [w.x, w.y], By([w.x2, w.y2], [w.x, w.y]))), B && (u = uo([x.x, x.y], [w.x1, w.y1]), u = x instanceof wA ? u : Nl(Ec(l, u)), a.addMarker(new Ns(i, [x.x, x.y], Math.atan2(u[1], u[0])))), l = uo([w.x2, w.y2], [w.x, w.y]);
          else if (w instanceof wA || w instanceof ks) {
            if (u = uo([x.x, x.y], [w.x, w.y]), b) {
              var U = h ? uo([h.x, h.y], [w.x, w.y]) : u;
              a.addMarker(new Ns(n, [x.x, x.y], Math.atan2(U[1], U[0]), !0));
            }
            S && a.addMarker(new Ns(s, [w.x, w.y], Math.atan2(u[1], u[0]))), B && (U = w instanceof wA ? l : x instanceof wA ? u : Nl(Ec(l, u)), a.addMarker(new Ns(i, [x.x, x.y], Math.atan2(U[1], U[0])))), l = u;
          } else w instanceof cm && (u = uo([x.x, x.y], [c.x, c.y]), B && (U = x instanceof wA ? u : Nl(Ec(l, u)), a.addMarker(new Ns(i, [x.x, x.y], Math.atan2(U[1], U[0])))), S && (U = Nl(Ec(u, f)), a.addMarker(new Ns(s, [c.x, c.y], Math.atan2(U[1], U[0])))), l = u);
        else {
          c = w instanceof wA && w;
          var Q = o[v + 1];
          (Q instanceof wA || Q instanceof ks || Q instanceof Si) && (f = uo([c.x, c.y], [Q.x, Q.y]));
        }
      }, p = 0; p < o.length; p++) g(p);
    }
    return a.markers.forEach((function(v) {
      var w = A.refsHandler.get(v.id);
      if (w) {
        var b = Le(w.element, A.styleSheets, "orient");
        b != null && (v.isStartMarker && b === "auto-start-reverse" && (v.angle += Math.PI), isNaN(Number(b)) || (v.angle = parseFloat(b) / 180 * Math.PI));
      }
    })), a;
  }, e;
})(Vh);
function Nd(r) {
  var e = dv.exec(r);
  return e && e[1] || void 0;
}
var zL = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return sr(e, r), e.prototype.getPath = function(t) {
    if (t.withinClipPath || t.attributeState.stroke === null) return null;
    var A = parseFloat(this.element.getAttribute("x1") || "0"), n = parseFloat(this.element.getAttribute("y1") || "0"), i = parseFloat(this.element.getAttribute("x2") || "0"), s = parseFloat(this.element.getAttribute("y2") || "0");
    return A || i || n || s ? new Oo().moveTo(A, n).lineTo(i, s) : null;
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e.prototype.fillOrStroke = function(t) {
    return cr(this, void 0, void 0, (function() {
      return hr(this, (function(A) {
        switch (A.label) {
          case 0:
            return t.attributeState.fill = null, [4, r.prototype.fillOrStroke.call(this, t)];
          case 1:
            return A.sent(), [2];
        }
      }));
    }));
  }, e;
})(Bu), g5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.apply = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? ((A = t.clone()).transform = A.pdf.unitMatrix, mv(A, this), n = Le(this.element, A.styleSheets, "clip-path"), n && n !== "none" && (i = h5(n, 0, A)) ? i.isVisible(!0, A) ? [4, f5(this, i, A)] : [3, 2] : [3, 3]) : [2];
          case 1:
            return o.sent(), [3, 3];
          case 2:
            return [2];
          case 3:
            vv(A, t, this.element), s = 0, a = this.children, o.label = 4;
          case 4:
            return s < a.length ? [4, a[s].render(A)] : [3, 7];
          case 5:
            o.sent(), o.label = 6;
          case 6:
            return s++, [3, 4];
          case 7:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return gv(t, this);
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    var A = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), i = this.element.getAttribute("viewBox");
    if (i) {
      var s = Mn(i), a = parseFloat(Le(this.element, t.styleSheets, "width") || Le(this.element.ownerSVGElement, t.styleSheets, "width") || i[2]), o = parseFloat(Le(this.element, t.styleSheets, "height") || Le(this.element.ownerSVGElement, t.styleSheets, "height") || i[3]);
      return yu(this.element, s, A, n, a, o, t);
    }
    return t.pdf.Matrix(1, 0, 0, 1, A, n);
  }, e;
})(bu), Kh = function(r, e) {
  this.width = r, this.height = e;
}, WL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, c, f, h, g, p;
      return hr(this, (function(v) {
        switch (v.label) {
          case 0:
            return A = parseFloat, (n = this.element.getAttribute("href") || this.element.getAttribute("xlink:href")) ? (i = n.substring(1), s = t.refsHandler.get(i), a = Ws(s.element, "symbol,svg") && s.element.hasAttribute("viewBox"), o = A(Le(this.element, t.styleSheets, "x") || "0"), l = A(Le(this.element, t.styleSheets, "y") || "0"), u = void 0, c = void 0, a ? (u = A(Le(this.element, t.styleSheets, "width") || Le(s.element, t.styleSheets, "width") || "0"), c = A(Le(this.element, t.styleSheets, "height") || Le(s.element, t.styleSheets, "height") || "0"), o += A(Le(s.element, t.styleSheets, "x") || "0"), l += A(Le(s.element, t.styleSheets, "y") || "0"), h = Mn(s.element.getAttribute("viewBox")), f = yu(s.element, h, o, l, u, c, t)) : f = t.pdf.Matrix(1, 0, 0, 1, o, l), g = Po.getContextColors(t, !0), p = new Zs(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, withinUse: !0, viewport: a ? new Kh(u, c) : t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure, attributeState: Object.assign(Po.default(), g) }), [4, t.refsHandler.getRendered(i, g, (function(w) {
              return e.renderReferencedNode(w, i, p);
            }))]) : [2];
          case 1:
            return v.sent(), t.pdf.saveGraphicsState(), t.pdf.setCurrentTransformationMatrix(t.transform), a && Le(s.element, t.styleSheets, "overflow") !== "visible" && (t.pdf.rect(o, l, u, c), t.pdf.clip().discardPath()), t.pdf.doFormObject(t.refsHandler.generateKey(i, g), f), t.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e.renderReferencedNode = function(t, A, n) {
    return cr(this, void 0, void 0, (function() {
      var i;
      return hr(this, (function(s) {
        switch (s.label) {
          case 0:
            return i = [(i = t.getBoundingBox(n))[0] - 0.5 * i[2], i[1] - 0.5 * i[3], 2 * i[2], 2 * i[3]], n.pdf.beginFormObject(i[0], i[1], i[2], i[3], n.pdf.unitMatrix), t instanceof g5 ? [4, t.apply(n)] : [3, 2];
          case 1:
            return s.sent(), [3, 4];
          case 2:
            return [4, t.render(n)];
          case 3:
            s.sent(), s.label = 4;
          case 4:
            return n.pdf.endFormObject(n.refsHandler.generateKey(A, n.attributeState)), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return wu(this.element, t);
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(Vh), XL = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return sr(e, r), e.prototype.getPath = function(t) {
    var A = parseFloat(Le(this.element, t.styleSheets, "width") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "height") || "0");
    if (!isFinite(A) || A <= 0 || !isFinite(n) || n <= 0) return null;
    var i = Le(this.element, t.styleSheets, "rx"), s = Le(this.element, t.styleSheets, "ry"), a = Math.min(parseFloat(i || s || "0"), 0.5 * A), o = Math.min(parseFloat(s || i || "0"), 0.5 * n), l = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), u = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), c = 4 / 3 * (Math.SQRT2 - 1);
    return a === 0 && o === 0 ? new Oo().moveTo(l, u).lineTo(l + A, u).lineTo(l + A, u + n).lineTo(l, u + n).close() : new Oo().moveTo(l += a, u).lineTo(l += A - 2 * a, u).curveTo(l + a * c, u, l + a, u + (o - o * c), l += a, u += o).lineTo(l, u += n - 2 * o).curveTo(l, u + o * c, l - a * c, u + o, l -= a, u += o).lineTo(l += 2 * a - A, u).curveTo(l - a * c, u, l - a, u - o * c, l -= a, u -= o).lineTo(l, u += 2 * o - n).curveTo(l, u - o * c, l + a * c, u - o, l += a, u -= o).close();
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e;
})(Bu), p5 = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return sr(e, r), e.prototype.getPath = function(t) {
    var A = this.getRx(t), n = this.getRy(t);
    if (!isFinite(A) || n <= 0 || !isFinite(n) || n <= 0) return null;
    var i = parseFloat(Le(this.element, t.styleSheets, "cx") || "0"), s = parseFloat(Le(this.element, t.styleSheets, "cy") || "0"), a = 4 / 3 * (Math.SQRT2 - 1) * A, o = 4 / 3 * (Math.SQRT2 - 1) * n;
    return new Oo().moveTo(i + A, s).curveTo(i + A, s - o, i + a, s - n, i, s - n).curveTo(i - a, s - n, i - A, s - o, i - A, s).curveTo(i - A, s + o, i - a, s + n, i, s + n).curveTo(i + a, s + n, i + A, s + o, i + A, s);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e;
})(Bu), YL = (function(r) {
  function e(t, A) {
    return r.call(this, t, A) || this;
  }
  return sr(e, r), e.prototype.getRx = function(t) {
    return parseFloat(Le(this.element, t.styleSheets, "rx") || "0");
  }, e.prototype.getRy = function(t) {
    return parseFloat(Le(this.element, t.styleSheets, "ry") || "0");
  }, e;
})(p5);
function m5(r) {
  var e = "invisible", t = r.stroke && r.strokeWidth !== 0, A = r.fill;
  return A && t ? e = "fillThenStroke" : A ? e = "fill" : t && (e = "stroke"), e;
}
function Ey(r) {
  return r.replace(/[\n\r]/g, "");
}
function Fy(r) {
  return r.replace(/[\t]/g, " ");
}
function _y(r) {
  return r.replace(/ +/g, " ");
}
function Uy(r, e, t) {
  switch (Le(r, t.styleSheets, "text-transform")) {
    case "uppercase":
      return e.toUpperCase();
    case "lowercase":
      return e.toLowerCase();
    default:
      return e;
  }
}
var Td = (function() {
  function r(e, t, A, n) {
    this.textNode = e, this.texts = [], this.textNodes = [], this.contexts = [], this.textAnchor = t, this.originX = A, this.originY = n, this.textMeasures = [];
  }
  return r.prototype.setX = function(e) {
    this.originX = e;
  }, r.prototype.setY = function(e) {
    this.originY = e;
  }, r.prototype.add = function(e, t, A) {
    this.texts.push(t), this.textNodes.push(e), this.contexts.push(A);
  }, r.prototype.rightTrimText = function() {
    for (var e = this.texts.length - 1; e >= 0; e--)
      if (this.contexts[e].attributeState.xmlSpace === "preserve" || this.contexts[e].attributeState.whiteSpace === "pre" || (this.texts[e] = this.texts[e].replace(/\s+$/, "")), this.texts[e].match(/[^\s]/)) return !1;
    return !0;
  }, r.prototype.measureText = function(e) {
    for (var t = 0; t < this.texts.length; t++) this.textMeasures.push({ width: e.textMeasure.measureTextWidth(this.texts[t], this.contexts[t].attributeState), length: this.texts[t].length });
  }, r.prototype.put = function(e, t) {
    var A, n, i, s, a = [], o = [], l = [], u = this.originX, c = this.originY, f = u, h = u;
    for (A = 0; A < this.textNodes.length; A++) {
      n = this.textNodes[A], i = this.contexts[A], s = this.textMeasures[A] || { width: e.textMeasure.measureTextWidth(this.texts[A], this.contexts[A].attributeState), length: this.texts[A].length };
      var g = u, p = c;
      if (n.nodeName !== "#text" && !a.includes(n)) {
        a.push(n);
        var v = r.resolveRelativePositionAttribute(n, "dx");
        v !== null && (g += As(v, i.attributeState.fontSize));
        var w = r.resolveRelativePositionAttribute(n, "dy");
        w !== null && (p += As(w, i.attributeState.fontSize));
      }
      o[A] = g, l[A] = p, u = g + s.width + s.length * t, c = p, f = Math.min(f, g), h = Math.max(h, u);
    }
    var b = 0;
    switch (this.textAnchor) {
      case "start":
        b = 0;
        break;
      case "middle":
        b = (h - f) / 2;
        break;
      case "end":
        b = h - f;
    }
    for (A = 0; A < this.textNodes.length; A++) if (n = this.textNodes[A], i = this.contexts[A], n.nodeName === "#text" || i.attributeState.visibility !== "hidden") {
      e.pdf.saveGraphicsState(), vv(i, e, n);
      var S = i.attributeState.alignmentBaseline, B = m5(i.attributeState);
      e.pdf.text(this.texts[A], o[A] - b, l[A], { baseline: s5(S), angle: e.transform, renderingMode: B === "fill" ? void 0 : B, charSpace: t === 0 ? void 0 : t }), e.pdf.restoreGraphicsState();
    }
    return [u, c];
  }, r.resolveRelativePositionAttribute = function(e, t) {
    for (var A, n = e; n && Ws(n, "tspan"); ) {
      if (n.hasAttribute(t)) return n.getAttribute(t);
      if (((A = e.parentElement) === null || A === void 0 ? void 0 : A.firstChild) !== e) break;
      n = n.parentElement;
    }
    return null;
  }, r;
})(), $L = (function(r) {
  function e() {
    var t = r !== null && r.apply(this, arguments) || this;
    return t.boundingBox = [], t;
  }
  return sr(e, r), e.prototype.processTSpans = function(t, A, n, i, s, a) {
    for (var o = n.pdf.getFontSize(), l = n.attributeState.xmlSpace === "preserve" || n.attributeState.whiteSpace === "pre", u = !0, c = !1, f = 0; f < A.childNodes.length; f++) {
      var h = A.childNodes[f];
      if (h.textContent) {
        var g = h.textContent;
        if (h.nodeName === "#text") {
          var p = Ey(g);
          p = Fy(p), l || (p = _y(p), u && p.match(/^\s/) && (c = !0), p.match(/[^\s]/) && (u = !1), a.prevText.match(/\s$/) && (p = p.replace(/^\s+/, "")));
          var v = Uy(A, p, n);
          s.add(A, v, n), a.prevText = g, a.prevContext = n;
        } else if (!Ws(h, "title")) {
          if (Ws(h, "tspan")) {
            var w = h, b = w.getAttribute("x");
            if (b !== null) {
              var S = As(b, o);
              s = new Td(this, Le(w, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, S, 0), i.push({ type: "y", chunk: s });
            }
            var B = w.getAttribute("y");
            if (B !== null) {
              var x = As(B, o);
              s = new Td(this, Le(w, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, 0, x), i.push({ type: "x", chunk: s });
            }
            var U = n.clone();
            mv(U, t, w), this.processTSpans(t, w, U, i, s, a);
          }
        }
      }
    }
    return c;
  }, e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S, B, x, U, Q, N, _;
      return hr(this, (function(R) {
        if (t.pdf.saveGraphicsState(), A = 0, n = 0, i = 1, s = t.pdf.getFontSize(), a = As(this.element.getAttribute("x"), s), o = As(this.element.getAttribute("y"), s), l = As(this.element.getAttribute("dx"), s), u = As(this.element.getAttribute("dy"), s), c = parseFloat(this.element.getAttribute("textLength") || "0"), f = t.attributeState.visibility, this.element.childElementCount === 0) h = this.element.textContent || "", g = (function(F, O) {
          return F = Fy(F = Ey(F)), O.xmlSpace === "preserve" || O.whiteSpace === "pre" || (F = _y(F = F.trim())), F;
        })(h, t.attributeState), p = Uy(this.element, g, t), A = t.textMeasure.getTextOffset(p, t.attributeState), c > 0 && (v = t.textMeasure.measureTextWidth(p, t.attributeState), !(t.attributeState.xmlSpace === "preserve" || t.attributeState.whiteSpace === "pre") && h.match(/^\s/) && (i = 0), n = (c - v) / (p.length - i) || 0), f === "visible" && (w = t.attributeState.alignmentBaseline, b = m5(t.attributeState), t.pdf.text(p, a + l - A, o + u, { baseline: s5(w), angle: t.transform, renderingMode: b === "fill" ? void 0 : b, charSpace: n === 0 ? void 0 : n }), this.boundingBox = [a + l - A, o + u + 0.1 * s, t.textMeasure.measureTextWidth(p, t.attributeState), s]);
        else {
          for (S = [], B = new Td(this, t.attributeState.textAnchor, a + l, o + u), S.push({ type: "", chunk: B }), x = this.processTSpans(this, this.element, t, S, B, { prevText: " ", prevContext: t }), i = x ? 0 : 1, U = !0, Q = S.length - 1; Q >= 0; Q--) U && (U = S[Q].chunk.rightTrimText());
          c > 0 && (N = 0, _ = 0, S.forEach((function(F) {
            var O = F.chunk;
            O.measureText(t), O.textMeasures.forEach((function(G) {
              var H = G.width, $ = G.length;
              N += H, _ += $;
            }));
          })), n = (c - N) / (_ - i)), S.reduce((function(F, O) {
            var G = O.type, H = O.chunk;
            return G === "x" ? H.setX(F[0]) : G === "y" && H.setY(F[1]), H.put(t, n);
          }), [0, 0]);
        }
        return t.pdf.restoreGraphicsState(), [2];
      }));
    }));
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.prototype.getBoundingBoxCore = function(t) {
    return this.boundingBox.length > 0 ? this.boundingBox : wu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(Vh), JL = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return sr(e, r), e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e.prototype.getPath = function(t) {
    var A, n, i = new kL(Le(this.element, t.styleSheets, "d") || "").unshort().unarc().abs(), s = new Oo();
    return i.iterate((function(a) {
      switch (a[0]) {
        case "M":
          s.moveTo(a[1], a[2]);
          break;
        case "L":
          s.lineTo(a[1], a[2]);
          break;
        case "H":
          s.lineTo(a[1], n);
          break;
        case "V":
          s.lineTo(A, a[1]);
          break;
        case "C":
          s.curveTo(a[1], a[2], a[3], a[4], a[5], a[6]);
          break;
        case "Q":
          var o = Sy([A, n], [a[1], a[2]]), l = Sy([a[3], a[4]], [a[1], a[2]]);
          s.curveTo(o[0], o[1], l[0], l[1], a[3], a[4]);
          break;
        case "Z":
          s.close();
      }
      switch (a[0]) {
        case "M":
        case "L":
          A = a[1], n = a[2];
          break;
        case "H":
          A = a[1];
          break;
        case "V":
          n = a[1];
          break;
        case "C":
          A = a[5], n = a[6];
          break;
        case "Q":
          A = a[3], n = a[4];
      }
    })), s;
  }, e;
})(Bu), ZL = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,((?:.|\s)*)$/i, eN = (function(r) {
  function e(t, A) {
    var n = r.call(this, t, A) || this;
    return n.imageLoadingPromise = null, n.imageUrl = n.element.getAttribute("xlink:href") || n.element.getAttribute("href"), n.imageUrl && (n.imageLoadingPromise = e.fetchImageData(n.imageUrl)), n;
  }
  return sr(e, r), e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S, B;
      return hr(this, (function(x) {
        switch (x.label) {
          case 0:
            return this.imageLoadingPromise ? (t.pdf.setCurrentTransformationMatrix(t.transform), A = parseFloat(Le(this.element, t.styleSheets, "width") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "height") || "0"), i = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), s = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), !isFinite(A) || A <= 0 || !isFinite(n) || n <= 0 ? [2] : [4, this.imageLoadingPromise]) : [2];
          case 1:
            return a = x.sent(), o = a.data, (l = a.format).indexOf("svg") !== 0 ? [3, 3] : (u = new DOMParser(), c = u.parseFromString(o, "image/svg+xml").firstElementChild, (!(f = this.element.getAttribute("preserveAspectRatio")) || f.indexOf("defer") < 0 || !c.getAttribute("preserveAspectRatio")) && c.setAttribute("preserveAspectRatio", f || ""), c.setAttribute("x", String(i)), c.setAttribute("y", String(s)), c.setAttribute("width", String(A)), c.setAttribute("height", String(n)), [4, wv(c, h = {}).render(new Zs(t.pdf, { refsHandler: new i5(h), styleSheets: t.styleSheets, viewport: new Kh(A, n), svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))]);
          case 2:
            return x.sent(), [2];
          case 3:
            g = "data:image/".concat(l, ";base64,").concat(btoa(o)), x.label = 4;
          case 4:
            return x.trys.push([4, 6, , 7]), [4, e.getImageDimensions(g)];
          case 5:
            return p = x.sent(), v = p[0], w = p[1], b = [0, 0, v, w], S = yu(this.element, b, i, s, A, n, t), t.pdf.setCurrentTransformationMatrix(S), t.pdf.addImage(g, "", 0, 0, v, w), [3, 7];
          case 6:
            return B = x.sent(), typeof console == "object" && console.warn && console.warn("Could not load image ".concat(this.imageUrl, `. 
`).concat(B)), [3, 7];
          case 7:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return wu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e.fetchImageData = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!(i = t.match(ZL))) return [3, 1];
            if (s = i[2], (a = s.split("/"))[0] !== "image") throw new Error("Unsupported image URL: ".concat(t));
            return n = a[1], A = i[5], i[4] === "base64" ? (A = A.replace(/\s/g, ""), A = atob(A)) : A = decodeURIComponent(A), [3, 3];
          case 1:
            return [4, e.fetchImage(t)];
          case 2:
            A = o.sent(), n = t.substring(t.lastIndexOf(".") + 1), o.label = 3;
          case 3:
            return [2, { data: A, format: n }];
        }
      }));
    }));
  }, e.fetchImage = function(t) {
    return new Promise((function(A, n) {
      var i = new XMLHttpRequest();
      i.open("GET", t, !0), i.responseType = "arraybuffer", i.onload = function() {
        if (i.status !== 200) throw new Error("Error ".concat(i.status, ": Failed to load image '").concat(t, "'"));
        for (var s = new Uint8Array(i.response), a = "", o = 0; o < s.length; o++) a += String.fromCharCode(s[o]);
        A(a);
      }, i.onerror = n, i.onabort = n, i.send(null);
    }));
  }, e.getMimeType = function(t) {
    switch (t = t.toLowerCase()) {
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      default:
        return "image/".concat(t);
    }
  }, e.getImageDimensions = function(t) {
    return new Promise((function(A, n) {
      var i = new Image();
      i.onload = function() {
        A([i.width, i.height]);
      }, i.onerror = n, i.src = t;
    }));
  }, e;
})(Vh), v5 = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, !0, A, n) || this;
    return i.closed = t, i;
  }
  return sr(e, r), e.prototype.getPath = function(t) {
    if (!this.element.hasAttribute("points") || this.element.getAttribute("points") === "") return null;
    var A = e.parsePointsString(this.element.getAttribute("points")), n = new Oo();
    if (A.length < 1) return n;
    n.moveTo(A[0][0], A[0][1]);
    for (var i = 1; i < A.length; i++) n.lineTo(A[i][0], A[i][1]);
    return this.closed && n.close(), n;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.parsePointsString = function(t) {
    for (var A = Mn(t), n = [], i = 0; i < A.length - 1; i += 2) {
      var s = A[i], a = A[i + 1];
      n.push([s, a]);
    }
    return n;
  }, e;
})(Bu), tN = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return sr(e, r), e;
})(v5), rN = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.render = function(t) {
    return Promise.resolve();
  }, e.prototype.getBoundingBoxCore = function(t) {
    return [0, 0, 0, 0];
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return hs(this, t, A);
  }, e;
})(pv), AN = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.apply = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o;
      return hr(this, (function(l) {
        switch (l.label) {
          case 0:
            A = this.computeNodeTransform(t), n = this.getBoundingBox(t), t.pdf.beginFormObject(n[0], n[1], n[2], n[3], A), i = Po.getContextColors(t), (function(u) {
              var c = u.attributeState, f = u.pdf, h = 1, g = 1;
              h *= c.fillOpacity, h *= c.opacity, c.fill instanceof UA && c.fill.color.a !== void 0 && (h *= c.fill.color.a), g *= c.strokeOpacity, g *= c.opacity, c.stroke instanceof UA && c.stroke.color.a !== void 0 && (g *= c.stroke.color.a);
              var p, v = {};
              if (v.opacity = h, v["stroke-opacity"] = g, f.setGState(new Ga(v)), c.fill && c.fill instanceof UA && c.fill.color.ok ? f.setFillColor(c.fill.color.r, c.fill.color.g, c.fill.color.b) : f.setFillColor(0, 0, 0), f.setLineWidth(c.strokeWidth), c.stroke instanceof UA ? f.setDrawColor(c.stroke.color.r, c.stroke.color.g, c.stroke.color.b) : f.setDrawColor(0, 0, 0), f.setLineCap(c.strokeLinecap), f.setLineJoin(c.strokeLinejoin), c.strokeDasharray ? f.setLineDashPattern(c.strokeDasharray, c.strokeDashoffset) : f.setLineDashPattern([], 0), f.setLineMiterLimit(c.strokeMiterlimit), p = ns.hasOwnProperty(c.fontFamily) ? ns[c.fontFamily] : c.fontFamily, c.fill && c.fill instanceof UA && c.fill.color.ok) {
                var w = c.fill.color;
                f.setTextColor(w.r, w.g, w.b);
              } else f.setTextColor(0, 0, 0);
              var b = "";
              c.fontWeight === "bold" && (b = "bold"), c.fontStyle === "italic" && (b += "italic"), b === "" && (b = "normal"), p !== void 0 || b !== void 0 ? (p === void 0 && (p = ns.hasOwnProperty(c.fontFamily) ? ns[c.fontFamily] : c.fontFamily), f.setFont(p, b)) : f.setFont("helvetica", b), f.setFontSize(c.fontSize * f.internal.scaleFactor);
            })(s = new Zs(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure, attributeState: Object.assign(Po.default(), i) })), a = 0, o = this.children, l.label = 1;
          case 1:
            return a < o.length ? [4, o[a].render(s)] : [3, 4];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return a++, [3, 1];
          case 4:
            return t.pdf.endFormObject(s.refsHandler.generateKey(this.element.getAttribute("id"), i)), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    var A, n = this.element.getAttribute("viewBox");
    return n && (A = Mn(n)), [A && A[0] || 0, A && A[1] || 0, A && A[2] || parseFloat(this.element.getAttribute("markerWidth") || "3"), A && A[3] || parseFloat(this.element.getAttribute("markerHeight") || "3")];
  }, e.prototype.computeNodeTransformCore = function(t) {
    var A, n = parseFloat(this.element.getAttribute("refX") || "0"), i = parseFloat(this.element.getAttribute("refY") || "0"), s = this.element.getAttribute("viewBox");
    if (s) {
      var a = Mn(s);
      A = yu(this.element, a, 0, 0, parseFloat(this.element.getAttribute("markerWidth") || "3"), parseFloat(this.element.getAttribute("markerHeight") || "3"), t, !0), A = t.pdf.matrixMult(t.pdf.Matrix(1, 0, 0, 1, -n, -i), A);
    } else A = t.pdf.Matrix(1, 0, 0, 1, -n, -i);
    return A;
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e;
})(bu), nN = (function(r) {
  function e(t, A) {
    return r.call(this, t, A) || this;
  }
  return sr(e, r), e.prototype.getR = function(t) {
    var A;
    return (A = this.r) !== null && A !== void 0 ? A : this.r = parseFloat(Le(this.element, t.styleSheets, "r") || "0");
  }, e.prototype.getRx = function(t) {
    return this.getR(t);
  }, e.prototype.getRy = function(t) {
    return this.getR(t);
  }, e;
})(p5), iN = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return sr(e, r), e;
})(v5), w5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n;
      return hr(this, (function(i) {
        switch (i.label) {
          case 0:
            A = 0, n = this.children, i.label = 1;
          case 1:
            return A < n.length ? [4, n[A].render(t)] : [3, 4];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return A++, [3, 1];
          case 4:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return gv(t, this);
  }, e;
})(d5), sN = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.prototype.render = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? (A = this.getX(t), n = this.getY(t), i = this.getWidth(t), s = this.getHeight(t), t.pdf.saveGraphicsState(), a = t.transform, this.element.hasAttribute("transform") && (a = t.pdf.matrixMult(Gh(this.element.getAttribute("transform"), t), a)), t.pdf.setCurrentTransformationMatrix(a), t.withinUse || Le(this.element, t.styleSheets, "overflow") === "visible" || t.pdf.rect(A, n, i, s).clip().discardPath(), [4, r.prototype.render.call(this, t.clone({ transform: t.pdf.unitMatrix, viewport: t.withinUse ? t.viewport : new Kh(i, s) }))]) : [2];
          case 1:
            return o.sent(), t.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e.prototype.computeNodeTransform = function(t) {
    return this.computeNodeTransformCore(t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    if (t.withinUse) return t.pdf.unitMatrix;
    var A, n = this.getX(t), i = this.getY(t), s = this.getViewBox();
    if (s) {
      var a = this.getWidth(t), o = this.getHeight(t);
      A = yu(this.element, s, n, i, a, o, t);
    } else A = t.pdf.Matrix(1, 0, 0, 1, n, i);
    return A;
  }, e.prototype.getWidth = function(t) {
    if (this.width !== void 0) return this.width;
    var A, n, i = t.svg2pdfParameters;
    if (this.isOutermostSvg(t)) if (i.width != null) A = i.width;
    else if (n = Le(this.element, t.styleSheets, "width")) A = parseFloat(n);
    else {
      var s = this.getViewBox();
      if (s && (i.height != null || Le(this.element, t.styleSheets, "height"))) {
        var a = s[2] / s[3];
        A = this.getHeight(t) * a;
      } else A = Math.min(300, t.viewport.width, 2 * t.viewport.height);
    }
    else A = (n = Le(this.element, t.styleSheets, "width")) ? parseFloat(n) : t.viewport.width;
    return this.width = A;
  }, e.prototype.getHeight = function(t) {
    if (this.height !== void 0) return this.height;
    var A, n, i = t.svg2pdfParameters;
    if (this.isOutermostSvg(t)) if (i.height != null) A = i.height;
    else if (n = Le(this.element, t.styleSheets, "height")) A = parseFloat(n);
    else {
      var s = this.getViewBox();
      if (s) {
        var a = s[2] / s[3];
        A = this.getWidth(t) / a;
      } else A = Math.min(150, t.viewport.width / 2, t.viewport.height);
    }
    else A = (n = Le(this.element, t.styleSheets, "height")) ? parseFloat(n) : t.viewport.height;
    return this.height = A;
  }, e.prototype.getX = function(t) {
    if (this.x !== void 0) return this.x;
    if (this.isOutermostSvg(t)) return this.x = 0;
    var A = Le(this.element, t.styleSheets, "x");
    return this.x = A ? parseFloat(A) : 0;
  }, e.prototype.getY = function(t) {
    if (this.y !== void 0) return this.y;
    if (this.isOutermostSvg(t)) return this.y = 0;
    var A = Le(this.element, t.styleSheets, "y");
    return this.y = A ? parseFloat(A) : 0;
  }, e.prototype.getViewBox = function() {
    if (this.viewBox !== void 0) return this.viewBox;
    var t = this.element.getAttribute("viewBox");
    return this.viewBox = t ? Mn(t) : void 0;
  }, e.prototype.isOutermostSvg = function(t) {
    return t.svg2pdfParameters.element === this.element;
  }, e;
})(w5), y5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(w5), aN = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.renderCore = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s;
      return hr(this, (function(a) {
        switch (a.label) {
          case 0:
            return [4, r.prototype.renderCore.call(this, t)];
          case 1:
            return a.sent(), (A = Le(this.element, t.styleSheets, "href")) && (n = this.getBoundingBox(t), i = t.pdf.internal.scaleFactor, s = t.pdf.internal.pageSize.getHeight(), t.pdf.link(i * (n[0] * t.transform.sx + t.transform.tx), s - i * (n[1] * t.transform.sy + t.transform.ty), i * n[2], i * n[3], { url: A })), [2];
        }
      }));
    }));
  }, e;
})(y5), oN = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return sr(e, r), e.prototype.apply = function(t) {
    return cr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return hr(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!this.isVisible(!0, t)) return [2];
            A = t.pdf.matrixMult(this.computeNodeTransform(t), t.transform), t.pdf.setCurrentTransformationMatrix(A), n = 0, i = this.children, o.label = 1;
          case 1:
            return n < i.length ? [4, i[n].render(new Zs(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, withinClipPath: !0, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))] : [3, 4];
          case 2:
            o.sent(), o.label = 3;
          case 3:
            return n++, [3, 1];
          case 4:
            return s = this.children.length > 0 && !!Le(this.children[0].element, t.styleSheets, "clip-rule"), a = s ? this.getClipRuleAttr(this.children[0].element, t.styleSheets) : this.getClipRuleAttr(this.element, t.styleSheets), t.pdf.clip(a).discardPath(), t.pdf.setCurrentTransformationMatrix(A.inversed()), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return gv(t, this);
  }, e.prototype.isVisible = function(t, A) {
    return ea(this, t, A);
  }, e.prototype.getClipRuleAttr = function(t, A) {
    return Le(t, A, "clip-rule") === "evenodd" ? "evenodd" : void 0;
  }, e;
})(bu);
function wv(r, e) {
  var t, A = [];
  switch ((function(i, s) {
    for (var a = [], o = 0; o < i.childNodes.length; o++) {
      var l = i.childNodes[o];
      l.nodeName.charAt(0) !== "#" && a.push(l);
    }
    for (o = 0; o < a.length; o++) s(o, a[o]);
  })(r, (function(i, s) {
    return A.push(wv(s, e));
  })), r.tagName.toLowerCase()) {
    case "a":
      t = new aN(r, A);
      break;
    case "g":
      t = new y5(r, A);
      break;
    case "circle":
      t = new nN(r, A);
      break;
    case "clippath":
      t = new oN(r, A);
      break;
    case "ellipse":
      t = new YL(r, A);
      break;
    case "lineargradient":
      t = new l5(r, A);
      break;
    case "image":
      t = new eN(r, A);
      break;
    case "line":
      t = new zL(r, A);
      break;
    case "marker":
      t = new AN(r, A);
      break;
    case "path":
      t = new JL(r, A);
      break;
    case "pattern":
      t = new c5(r, A);
      break;
    case "polygon":
      t = new tN(r, A);
      break;
    case "polyline":
      t = new iN(r, A);
      break;
    case "radialgradient":
      t = new u5(r, A);
      break;
    case "rect":
      t = new XL(r, A);
      break;
    case "svg":
      t = new sN(r, A);
      break;
    case "symbol":
      t = new g5(r, A);
      break;
    case "text":
      t = new $L(r, A);
      break;
    case "use":
      t = new WL(r, A);
      break;
    default:
      t = new rN(r, A);
  }
  if (e != null && t.element.hasAttribute("id")) {
    var n = A5(t.element.id, { isIdentifier: !0 });
    e[n] = e[n] || t;
  }
  return t.children.forEach((function(i) {
    return i.setParent(t);
  })), t;
}
var lN = (function() {
  function r(e, t) {
    this.rootSvg = e, this.loadExternalSheets = t, this.styleSheets = [];
  }
  return r.prototype.load = function() {
    return cr(this, void 0, void 0, (function() {
      var e;
      return hr(this, (function(t) {
        switch (t.label) {
          case 0:
            return [4, this.collectStyleSheetTexts()];
          case 1:
            return e = t.sent(), this.parseCssSheets(e), [2];
        }
      }));
    }));
  }, r.prototype.collectStyleSheetTexts = function() {
    return cr(this, void 0, void 0, (function() {
      var e, t, A, n, i;
      return hr(this, (function(s) {
        switch (s.label) {
          case 0:
            if (e = [], this.loadExternalSheets && this.rootSvg.ownerDocument) for (n = 0; n < this.rootSvg.ownerDocument.childNodes.length; n++) (t = this.rootSvg.ownerDocument.childNodes[n]).nodeName === "xml-stylesheet" && typeof t.data == "string" && e.push(r.loadSheet(t.data.match(/href=["'].*?["']/)[0].split("=")[1].slice(1, -1)));
            for (A = this.rootSvg.querySelectorAll("style,link"), n = 0; n < A.length; n++) Ws(i = A[n], "style") ? e.push(i.textContent) : this.loadExternalSheets && Ws(i, "link") && i.getAttribute("rel") === "stylesheet" && i.hasAttribute("href") && e.push(r.loadSheet(i.getAttribute("href")));
            return [4, Promise.all(e)];
          case 1:
            return [2, s.sent().filter((function(a) {
              return a !== null;
            }))];
        }
      }));
    }));
  }, r.prototype.parseCssSheets = function(e) {
    for (var t = document.implementation.createHTMLDocument(""), A = 0, n = e; A < n.length; A++) {
      var i = n[A], s = t.createElement("style");
      s.textContent = i, t.body.appendChild(s);
      var a = s.sheet;
      if (a instanceof CSSStyleSheet) {
        for (var o = a.cssRules.length - 1; o >= 0; o--) {
          var l = a.cssRules[o];
          if (l instanceof CSSStyleRule) {
            var u = l;
            if (u.selectorText.indexOf(",") >= 0) {
              a.deleteRule(o);
              for (var c = u.cssText.substring(u.selectorText.length), f = r.splitSelectorAtCommas(u.selectorText), h = 0; h < f.length; h++) a.insertRule(f[h] + c, o + h);
            }
          } else a.deleteRule(o);
        }
        this.styleSheets.push(a);
      }
    }
  }, r.splitSelectorAtCommas = function(e) {
    for (var t, A = /,|["']/g, n = /[^\\]["]/g, i = /[^\\][']/g, s = [], a = "initial", o = -1, l = n, u = 0; u < e.length; ) switch (a) {
      case "initial":
        A.lastIndex = u, (t = A.exec(e)) ? (t[0] === "," ? (s.push(e.substring(o + 1, A.lastIndex - 1).trim()), o = A.lastIndex - 1) : (a = "withinQuotes", l = t[0] === '"' ? n : i), u = A.lastIndex) : (s.push(e.substring(o + 1).trim()), u = e.length);
        break;
      case "withinQuotes":
        l.lastIndex = u, (t = l.exec(e)) && (u = l.lastIndex, a = "initial");
    }
    return s;
  }, r.loadSheet = function(e) {
    return new Promise((function(t, A) {
      var n = new XMLHttpRequest();
      n.open("GET", e, !0), n.responseType = "text", n.onload = function() {
        n.status !== 200 && A(new Error("Error ".concat(n.status, ": Failed to load '").concat(e, "'"))), t(n.responseText);
      }, n.onerror = A, n.onabort = A, n.send(null);
    })).catch((function() {
      return null;
    }));
  }, r.prototype.getPropertyValue = function(e, t) {
    for (var A = [], n = 0, i = this.styleSheets; n < i.length; n++) for (var s = i[n], a = 0; a < s.cssRules.length; a++) {
      var o = s.cssRules[a];
      o.style.getPropertyValue(t) && e.matches(o.selectorText) && A.push(o);
    }
    if (A.length !== 0)
      return A.reduce((function(l, u) {
        return f = u, ((h = (c = l).style.getPropertyPriority(t)) !== f.style.getPropertyPriority(t) ? h === "important" ? 1 : -1 : HL(c.selectorText, f.selectorText)) === 1 ? l : u;
        var c, f, h;
      })).style.getPropertyValue(t) || void 0;
  }, r;
})(), uN = (function() {
  function r() {
    this.measureMethods = {};
  }
  return r.prototype.getTextOffset = function(e, t) {
    var A = t.textAnchor;
    if (A === "start") return 0;
    var n = this.measureTextWidth(e, t), i = 0;
    switch (A) {
      case "end":
        i = n;
        break;
      case "middle":
        i = n / 2;
    }
    return i;
  }, r.prototype.measureTextWidth = function(e, t) {
    if (e.length === 0) return 0;
    var A = t.fontFamily;
    return this.getMeasureFunction(A).call(this, e, t.fontFamily, t.fontSize + "px", t.fontStyle, t.fontWeight);
  }, r.prototype.getMeasurementTextNode = function() {
    if (!this.textMeasuringTextElement) {
      this.textMeasuringTextElement = document.createElementNS(xy, "text");
      var e = document.createElementNS(xy, "svg");
      e.appendChild(this.textMeasuringTextElement), e.style.setProperty("position", "absolute"), e.style.setProperty("visibility", "hidden"), document.body.appendChild(e);
    }
    return this.textMeasuringTextElement;
  }, r.prototype.canvasTextMeasure = function(e, t, A, n, i) {
    var s = document.createElement("canvas").getContext("2d");
    return s != null ? (s.font = [n, i, A, t].join(" "), s.measureText(e).width) : 0;
  }, r.prototype.svgTextMeasure = function(e, t, A, n, i, s) {
    s === void 0 && (s = this.getMeasurementTextNode());
    var a = s;
    return a.setAttribute("font-family", t), a.setAttribute("font-size", A), a.setAttribute("font-style", n), a.setAttribute("font-weight", i), a.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), a.textContent = e, a.getBBox().width;
  }, r.prototype.getMeasureFunction = function(e) {
    var t = this.measureMethods[e];
    if (!t) {
      var A = "16px", n = "normal", i = "normal", s = this.canvasTextMeasure(r.testString, e, A, n, i), a = this.svgTextMeasure(r.testString, e, A, n, i);
      t = Math.abs(s - a) < r.epsilon ? this.canvasTextMeasure : this.svgTextMeasure, this.measureMethods[e] = t;
    }
    return t;
  }, r.prototype.cleanupTextMeasuring = function() {
    if (this.textMeasuringTextElement) {
      var e = this.textMeasuringTextElement.parentNode;
      e && document.body.removeChild(e), this.textMeasuringTextElement = void 0;
    }
  }, r.testString = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789!"$%&/()=?'\\+*-_.:,;^}][{#~|<>`, r.epsilon = 0.1, r;
})();
function cN(r, e) {
  return cr(this, arguments, void 0, (function(t, A, n) {
    var i, s, a, o, l, u, c, f, h, g, p, v, w, b;
    return n === void 0 && (n = {}), hr(this, (function(S) {
      switch (S.label) {
        case 0:
          return i = (v = n.x) !== null && v !== void 0 ? v : 0, s = (w = n.y) !== null && w !== void 0 ? w : 0, a = (b = n.loadExternalStyleSheets) !== null && b !== void 0 && b, l = new i5(o = {}), [4, (u = new lN(t, a)).load()];
        case 1:
          return S.sent(), c = new Kh(A.internal.pageSize.getWidth(), A.internal.pageSize.getHeight()), f = xh(xh({}, n), { element: t }), h = new uN(), g = new Zs(A, { refsHandler: l, styleSheets: u, viewport: c, svg2pdfParameters: f, textMeasure: h }), A.advancedAPI(), A.saveGraphicsState(), A.setCurrentTransformationMatrix(A.Matrix(1, 0, 0, 1, i, s)), A.setLineWidth(g.attributeState.strokeWidth), p = g.attributeState.fill.color, A.setFillColor(p.r, p.g, p.b), A.setFont(g.attributeState.fontFamily), A.setFontSize(g.attributeState.fontSize * A.internal.scaleFactor), [4, wv(t, o).render(g)];
        case 2:
          return S.sent(), A.restoreGraphicsState(), A.compatAPI(), g.textMeasure.cleanupTextMeasuring(), [2, A];
      }
    }));
  }));
}
ot.API.svg = function(r, e) {
  return e === void 0 && (e = {}), cN(r, this, e);
};
const {
  InsertElementCommand: hm,
  RemoveElementCommand: hN,
  ChangeElementCommand: fN,
  BatchCommand: b5
} = Va;
let we = null;
const dN = (r) => {
  we = r, we.setSvgString = mN, we.importSvgString = vN, we.uniquifyElems = BN, we.setUseData = CN, we.convertGradients = xN, we.removeUnusedDefElems = SN, we.svgCanvasToString = gN, we.svgToString = pN, we.embedImage = wN, we.rasterExport = yN, we.exportPDF = bN;
}, gN = () => {
  for (; we.removeUnusedDefElems() > 0; )
    ;
  we.pathActions.clear(!0), we.getSvgContent().childNodes.forEach((n, i) => {
    i && n.nodeType === 8 && n.data.includes("Created with") && we.getSvgContent().firstChild.before(n);
  }), we.getCurrentGroup() && ($s(), we.selectOnly([we.getCurrentGroup()]));
  const e = [], t = we.getSvgContent().querySelectorAll("g[data-gsvg]");
  Array.prototype.forEach.call(t, (n) => {
    const i = n.attributes;
    let s = i.length;
    for (let a = 0; a < s; a++)
      (i[a].nodeName === "id" || i[a].nodeName === "style") && s--;
    if (s <= 0) {
      const a = n.firstChild;
      e.push(a), n.replaceWith(a);
    }
  });
  const A = we.svgToString(we.getSvgContent(), 0);
  return e.length && Array.prototype.forEach.call(e, (n) => {
    we.groupSvgElem(n);
  }), A;
}, pN = (r, e) => {
  const t = we.getCurConfig(), A = we.getNsMap(), n = [], i = t.baseUnit, s = new RegExp(`^-?[\\d\\.]+${i}$`);
  if (r) {
    Rh(r);
    const a = [...r.attributes], o = r.childNodes;
    a.sort((l, u) => l.name > u.name ? -1 : 1);
    for (let l = 0; l < e; l++)
      n.push(" ");
    if (n.push("<"), n.push(r.localName), r.id === "svgcontent") {
      const l = we.getResolution();
      let u = "";
      t.dynamicOutput ? (u = r.getAttribute("viewBox"), u || (u = [0, 0, l.w, l.h].join(" ")), n.push(` viewBox="${u}" xmlns="${et.SVG}"`)) : (i !== "px" && (l.w = mh(l.w, i) + i, l.h = mh(l.h, i) + i), n.push(
        ' width="' + l.w + '" height="' + l.h + '" xmlns="' + et.SVG + '"'
      ));
      const c = {}, f = r.querySelectorAll("*"), h = Array.prototype.slice.call(f);
      h.push(r), Array.prototype.forEach.call(h, (v) => {
        const w = v.namespaceURI;
        if (w && !c[w] && A[w] && A[w] !== "xmlns" && A[w] !== "xml" && (c[w] = !0, n.push(` xmlns:${A[w]}="${w}"`)), v.attributes.length > 0)
          for (const [, b] of Object.entries(v.attributes)) {
            const S = b.namespaceURI;
            S && !c[S] && A[S] !== "xmlns" && A[S] !== "xml" && (c[S] = !0, n.push(` xmlns:${A[S]}="${S}"`));
          }
      });
      let g = a.length;
      const p = [
        "width",
        "height",
        "xmlns",
        "x",
        "y",
        "viewBox",
        "id",
        "overflow"
      ];
      for (; g--; ) {
        const v = a[g], w = Gl(v.value);
        v.nodeName.startsWith("xmlns:") || w !== "" && !p.includes(v.localName) && (!v.namespaceURI || A[v.namespaceURI]) && (n.push(" "), n.push(v.nodeName), n.push('="'), n.push(w), n.push('"'));
      }
    } else {
      if (r.nodeName === "defs" && !r.firstChild)
        return "";
      const l = ["-moz-math-font-style", "_moz-math-font-style"];
      for (let u = a.length - 1; u >= 0; u--) {
        const c = a[u];
        let f = Gl(c.value);
        if (!l.includes(c.localName)) {
          if (f === "null") {
            const h = c.localName.replace(
              /-[a-z]/g,
              (g) => g[1].toUpperCase()
            );
            if (Object.prototype.hasOwnProperty.call(r.style, h))
              continue;
          }
          if (f !== "") {
            if (f.startsWith("pointer-events") || c.localName === "class" && f.startsWith("se_"))
              continue;
            if (n.push(" "), c.localName === "d" && (f = we.pathActions.convertPath(r, !0)), isNaN(f) ? s.test(f) && (f = Cn(f) + i) : f = Cn(f), we.getSvgOptionApply() && r.nodeName === "image" && c.localName === "href" && we.getSvgOptionImages() && we.getSvgOptionImages() === "embed") {
              const h = we.getEncodableImages(f);
              h && (f = h);
            }
            (!c.namespaceURI || c.namespaceURI === et.SVG || A[c.namespaceURI]) && (n.push(c.nodeName), n.push('="'), n.push(f), n.push('"'));
          }
        }
      }
    }
    if (r.hasChildNodes()) {
      n.push(">"), e++;
      let l = !1;
      for (let u = 0; u < o.length; u++) {
        const c = o.item(u);
        switch (c.nodeType) {
          case 1:
            n.push(`
`), n.push(we.svgToString(c, e));
            break;
          case 3: {
            const f = c.nodeValue.replace(/^\s+|\s+$/g, "");
            f !== "" && (l = !0, n.push(String(Gl(f))));
            break;
          }
          case 4:
            n.push(`
`), n.push(new Array(e + 1).join(" ")), n.push("<![CDATA["), n.push(c.nodeValue), n.push("]]>");
            break;
          case 8:
            n.push(`
`), n.push(new Array(e + 1).join(" ")), n.push("<!--"), n.push(c.data), n.push("-->");
            break;
        }
      }
      if (e--, !l) {
        n.push(`
`);
        for (let u = 0; u < e; u++)
          n.push(" ");
      }
      n.push("</"), n.push(r.localName), n.push(">");
    } else
      n.push("/>");
  }
  return n.join("");
}, mN = (r, e) => {
  const t = we.getCurConfig(), A = we.getDataStorage();
  try {
    const n = Zm(r);
    if (n.firstElementChild && n.firstElementChild.namespaceURI !== et.SVG)
      return !1;
    we.prepareSvg(n);
    const i = new b5("Change Source"), { nextSibling: s } = we.getSvgContent();
    we.getSvgContent().remove();
    const a = we.getSvgContent();
    i.addSubCommand(
      new hN(a, s, we.getSvgRoot())
    ), we.getDOMDocument().adoptNode ? we.setSvgContent(
      we.getDOMDocument().adoptNode(n.documentElement)
    ) : we.setSvgContent(
      we.getDOMDocument().importNode(n.documentElement, !0)
    ), we.getSvgRoot().append(we.getSvgContent());
    const o = we.getSvgContent();
    we.current_drawing_ = new X0(
      we.getSvgContent(),
      we.getIdPrefix()
    );
    const l = we.getCurrentDrawing().getNonce();
    l ? we.call("setnonce", l) : we.call("unsetnonce");
    const u = o.querySelectorAll("image");
    Array.prototype.forEach.call(u, (x) => {
      ev(x);
      const U = we.getHref(x);
      if (U) {
        if (U.startsWith("data:")) {
          const Q = U.match(/svgedit_url=(.*?);/);
          if (Q) {
            const N = decodeURIComponent(Q[1]), _ = new Image();
            _.addEventListener("load", () => {
              Dn(x, U);
            }), _.src = N;
          }
        }
        we.embedImage(U);
      }
    });
    const c = o.querySelectorAll("[id]"), f = {}, h = c.length;
    for (let x = 0; x < h; x++) {
      const U = c[x].id ? c[x].id : "undefined";
      isNaN(f[U]) && (f[U] = 0), f[U]++;
    }
    Object.entries(f).forEach(([x, U]) => {
      if (U > 1) {
        const Q = o.querySelectorAll(`[id="${x}"]`);
        for (let N = 1; N < Q.length; N++)
          Q[N].setAttribute("id", we.getNextId());
      }
    });
    const g = o.querySelectorAll("svg");
    if (Array.prototype.forEach.call(g, (x) => {
      if (cu(x.parentNode, "defs"))
        return;
      we.uniquifyElems(x);
      const U = x.parentNode;
      U.childNodes.length === 1 && U.nodeName === "g" ? (A.put(U, "gsvg", x), U.id = U.id || we.getNextId()) : we.groupSvgElem(x);
    }), Na()) {
      const x = an(), U = o.querySelectorAll(
        "linearGradient, radialGradient, pattern"
      );
      Array.prototype.forEach.call(U, (Q) => {
        x.appendChild(Q);
      });
    }
    we.setUseData(o), we.convertGradients(o);
    const p = {
      id: "svgcontent",
      overflow: t.show_outside_canvas ? "visible" : "hidden"
    };
    let v = !1;
    if (o.getAttribute("viewBox")) {
      const U = o.getAttribute("viewBox").split(/[ ,]+/), Q = Number(U[2]), N = Number(U[3]);
      Number.isFinite(Q) && (p.width = Q), Number.isFinite(N) && (p.height = N);
    } else
      ["width", "height"].forEach((x) => {
        const U = o.getAttribute(x) || "100%";
        String(U).slice(-1) === "%" ? v = !0 : p[x] = yr(x, U);
      });
    ql();
    const w = o.children;
    if (Array.prototype.forEach.call(w, (x) => {
      const U = x.querySelectorAll(we.getVisElems());
      Array.prototype.forEach.call(U, (Q) => {
        Q.id || (Q.id = we.getNextId());
      });
    }), v) {
      const x = Hn();
      x && typeof x == "object" ? (p.width = x.width + x.x, p.height = x.height + x.y) : ((p.width === null || p.width === void 0) && (p.width = 100), (p.height === null || p.height === void 0) && (p.height = 100));
    }
    (!Number.isFinite(p.width) || p.width <= 0) && (p.width = 100), (!Number.isFinite(p.height) || p.height <= 0) && (p.height = 100);
    for (const [x, U] of Object.entries(p))
      o.setAttribute(x, U);
    we.contentW = p.width, we.contentH = p.height, i.addSubCommand(new hm(we.getSvgContent()));
    const b = o.getAttribute("width"), S = o.getAttribute("height"), B = { width: b, height: S };
    i.addSubCommand(
      new fN(we.getSvgRoot(), B)
    ), we.setZoom(1), we.clearSelection(), tx(), we.getSvgRoot().append(we.selectorManager.selectorParentGroup), e || we.addCommandToHistory(i), we.call("sourcechanged", [we.getSvgContent()]);
  } catch (n) {
    return Ro("Error setting SVG string", n, "svg-exec"), !1;
  }
  return !0;
}, vN = (r, e) => {
  const t = we.getDataStorage();
  let A, n, i;
  try {
    const s = W4(r);
    let a = !1;
    we.getImportIds(s) && we.getImportIds(s).symbol && hu(we.getImportIds(s).symbol, "#svgroot")?.length && (a = !0);
    const o = new b5("Import Image");
    let l;
    if (a)
      l = we.getImportIds(s).symbol, n = we.getImportIds(s).xform;
    else {
      const u = Zm(r);
      we.prepareSvg(u);
      const c = we.getDOMDocument().adoptNode ? we.getDOMDocument().adoptNode(u.documentElement) : we.getDOMDocument().importNode(u.documentElement, !0);
      we.uniquifyElems(c);
      const f = yr("width", c.getAttribute("width")), h = yr("height", c.getAttribute("height")), g = c.getAttribute("viewBox"), p = g ? g.split(/[ ,]+/) : [0, 0, f, h];
      for (A = 0; A < 4; ++A)
        p[A] = Number(p[A]);
      const v = Number(we.getSvgContent().getAttribute("height")), w = Number.isFinite(v) && v > 0 ? v : Number(we.getCurConfig().dimensions?.[1]) || 100, b = p[2], S = p[3], B = Number.isFinite(b) && b > 0 ? b : f > 0 ? f : 100, x = Number.isFinite(S) && S > 0 ? S : h > 0 ? h : 100, U = Number.isFinite(B) && B > 0 ? B : 100, Q = Number.isFinite(x) && x > 0 ? x : 100;
      n = Q > U ? "scale(" + w / 3 / Q + ")" : "scale(" + w / 3 / U + ")", n = `translate(0) ${n} translate(0)`, l = we.getDOMDocument().createElementNS(et.SVG, "symbol");
      const N = an();
      if (Na()) {
        const R = c.querySelectorAll(
          "linearGradient, radialGradient, pattern"
        );
        Array.prototype.forEach.call(R, (F) => {
          N.appendChild(F);
        });
      }
      for (; c.firstChild; ) {
        const R = c.firstChild;
        l.append(R);
      }
      const _ = c.attributes;
      for (const R of _)
        l.setAttribute(R.nodeName, R.value);
      l.id = we.getNextId(), we.setImportIds(s, {
        symbol: l,
        xform: n
      }), an().append(l), o.addSubCommand(new hm(l));
    }
    i = we.getDOMDocument().createElementNS(et.SVG, "use"), i.id = we.getNextId(), we.setHref(i, "#" + l.id), (we.getCurrentGroup() || we.getCurrentDrawing().getCurrentLayer()).append(i), o.addSubCommand(new hm(i)), we.clearSelection(), e || (i.setAttribute("transform", n), On(i)), t.put(i, "symbol", l), t.put(i, "ref", l), we.addToSelection([i]), we.addCommandToHistory(o), we.call("changed", [we.getSvgContent()]);
  } catch (s) {
    return Ro("Error importing SVG string", s, "svg-exec"), null;
  }
  return i;
}, wN = (r) => new Promise((e, t) => {
  const A = new Image();
  A.addEventListener("load", (n) => {
    const i = document.createElement("canvas");
    i.width = n.currentTarget.width, i.height = n.currentTarget.height, i.getContext("2d").drawImage(n.currentTarget, 0, 0);
    try {
      let s = ";svgedit_url=" + encodeURIComponent(r);
      s = i.toDataURL().replace(";base64", s + ";base64"), we.setEncodableImages(r, s);
    } catch {
      we.setEncodableImages(r, !1);
    }
    we.setGoodImage(r), e(we.getEncodableImages(r));
  }), A.addEventListener("error", (n) => {
    t(
      new Error(
        `error loading image: ${n.currentTarget.attributes.src.value}`
      )
    );
  }), A.setAttribute("src", r);
}), B5 = () => {
  const r = we.getUIStrings();
  we.clearSelection();
  const e = [], t = [], A = {
    feGaussianBlur: r.NoBlur,
    foreignObject: r.NoforeignObject,
    "[stroke-dasharray]": r.NoDashArray
  }, n = we.getSvgContent();
  "font" in document.querySelector("CANVAS").getContext("2d") || (A.text = r.NoText);
  for (const [i, s] of Object.entries(A))
    n.querySelectorAll(i).length && (t.push(i), e.push(s));
  return { issues: e, issueCodes: t };
}, C5 = async (r) => {
  const e = r.querySelectorAll("image"), t = Array.from(e).map(async (A) => {
    const n = A.getAttribute("xlink:href") || A.getAttribute("href");
    if (n && !n.startsWith("data:"))
      try {
        const s = await (await fetch(n)).blob(), a = new FileReader();
        return new Promise((o) => {
          a.onload = () => {
            Dn(A, a.result), o();
          }, a.readAsDataURL(s);
        });
      } catch (i) {
        Ro("Failed to fetch image", i, "svg-exec");
      }
  });
  await Promise.all(t);
}, yN = (r = "PNG", e = 1, t = "Exported Image", A = {}) => new Promise((n, i) => {
  const a = `image/${(r === "ICO" ? "BMP" : r).toLowerCase()}`, { issues: o, issueCodes: l } = B5(), c = we.getSvgContent().cloneNode(!0);
  C5(c).then(() => {
    const f = new XMLSerializer().serializeToString(c), h = new Blob([f], {
      type: "image/svg+xml;charset=utf-8"
    }), g = URL.createObjectURL(h), p = document.createElement("canvas"), v = p.getContext("2d");
    if (!v) {
      i(new Error("Canvas 2D context not available"));
      return;
    }
    const w = we.getResolution(), b = w.w, S = w.h;
    p.width = b, p.height = S;
    const B = new Image();
    B.onload = () => {
      v.drawImage(B, 0, 0, b, S), URL.revokeObjectURL(g);
      const x = p.toDataURL(a, e);
      let U;
      const Q = (N) => {
        const _ = {
          datauri: x,
          bloburl: N,
          svg: f,
          issues: o,
          issueCodes: l,
          type: r,
          mimeType: a,
          quality: e,
          windowName: t
        };
        A.avoidEvent || we.call("exported", _), n(_);
      };
      p.toBlob(
        (N) => {
          U = URL.createObjectURL(N), Q(U);
        },
        a,
        e
      );
    }, B.onerror = (x) => {
      console.error("Failed to load SVG into image element:", x), i(x);
    }, B.src = g;
  }).catch(i);
}), bN = (r = "svg.pdf", e = z_() ? "save" : "dataurlstring") => new Promise((t, A) => {
  const n = we.getResolution(), i = n.w > n.h ? "landscape" : "portrait", s = "pt", a = we.getSvgContent().cloneNode(!0);
  C5(a).then(() => {
    const o = new XMLSerializer().serializeToString(a), l = new Blob([o], {
      type: "image/svg+xml;charset=utf-8"
    }), u = URL.createObjectURL(l), c = document.createElement("canvas"), f = c.getContext("2d");
    c.width = n.w, c.height = n.h;
    const h = new Image();
    h.onload = () => {
      f.drawImage(h, 0, 0, n.w, n.h), URL.revokeObjectURL(u);
      const g = c.toDataURL("image/png"), p = new ot({ orientation: i, unit: s, format: [n.w, n.h] }), v = we.getDocumentTitle();
      p.setProperties({ title: v }), p.addImage(g, "PNG", 0, 0, n.w, n.h);
      const { issues: w, issueCodes: b } = B5(), S = { issues: w, issueCodes: b, windowName: r, outputType: e };
      S.output = p.output(
        e,
        e === "save" ? r : void 0
      ), we.call("exportedPDF", S), t(S);
    }, h.onerror = (g) => {
      Ro("Failed to load SVG into image element", g, "svg-exec"), A(g);
    }, h.src = u;
  }).catch(A);
}), BN = (r) => {
  const e = {}, t = [
    "filter",
    "linearGradient",
    "pattern",
    "radialGradient",
    "symbol",
    "textPath",
    "use"
  ];
  os(r, (A) => {
    if (A.nodeType === 1) {
      A.id && (A.id in e || (e[A.id] = { elem: null, attrs: [], hrefs: [] }), e[A.id].elem = A), we.getrefAttrs().forEach((i) => {
        const s = A.getAttributeNode(i);
        if (s) {
          const a = we.getUrlFromAttr(s.value), o = a ? a.substr(1) : null;
          o && (o in e || (e[o] = { elem: null, attrs: [], hrefs: [] }), e[o].attrs.push(s));
        }
      });
      const n = we.getHref(A);
      if (n && t.includes(A.nodeName)) {
        const i = n.substr(1);
        i && (i in e || (e[i] = { elem: null, attrs: [], hrefs: [] }), e[i].hrefs.push(A));
      }
    }
  });
  for (const A in e) {
    if (!A)
      continue;
    const { elem: n } = e[A];
    if (n) {
      const i = we.getNextId();
      n.id = i;
      const { attrs: s } = e[A];
      let a = s.length;
      for (; a--; ) {
        const u = s[a];
        u.ownerElement.setAttribute(u.name, `url(#${i})`);
      }
      const o = e[A].hrefs;
      let l = o.length;
      for (; l--; ) {
        const u = o[l];
        we.setHref(u, "#" + i);
      }
    }
  }
}, CN = (r) => {
  let e = r;
  r.tagName !== "use" && (e = e.querySelectorAll("use")), Array.prototype.forEach.call(e, (t, A) => {
    const n = we.getDataStorage(), i = we.getHref(t);
    if (!i || !i.startsWith("#"))
      return;
    const s = i.substr(1), a = we.getElement(s);
    a && (n.put(t, "ref", a), (a.tagName === "symbol" || a.tagName === "svg") && (n.put(t, "symbol", a), n.put(t, "ref", a)));
  });
}, SN = () => {
  const r = we.getSvgContent().getElementsByTagNameNS(et.SVG, "defs");
  if (!r || !r.length)
    return 0;
  const e = [];
  let t = 0;
  const A = [
    "fill",
    "stroke",
    "filter",
    "marker-start",
    "marker-mid",
    "marker-end"
  ], n = A.length, i = we.getSvgContent().getElementsByTagNameNS(et.SVG, "*"), s = i.length;
  let a, o;
  for (a = 0; a < s; a++) {
    const l = i[a];
    for (o = 0; o < n; o++) {
      const c = we.getUrlFromAttr(l.getAttribute(A[o]));
      c && e.push(c.substr(1));
    }
    const u = Ei(l);
    u && u.startsWith("#") && e.push(u.substr(1));
  }
  return Array.prototype.forEach.call(r, (l, u) => {
    const c = l.querySelectorAll(
      "linearGradient, radialGradient, filter, marker, svg, symbol"
    );
    for (u = c.length; u--; ) {
      const f = c[u], { id: h } = f;
      e.includes(h) || (we.setRemovedElements(h, f), f.remove(), t++);
    }
  }), t;
}, xN = (r) => {
  let e = r.querySelectorAll("linearGradient, radialGradient");
  !e.length && sx() && (e = Array.prototype.filter.call(r.querySelectorAll("*"), (t) => t.tagName.includes("Gradient"))), Array.prototype.forEach.call(e, (t) => {
    if (t.getAttribute("gradientUnits") === "userSpaceOnUse") {
      const A = we.getSvgContent();
      let n = A.querySelectorAll(
        '[fill="url(#' + t.id + ')"],[stroke="url(#' + t.id + ')"]'
      );
      if (!n.length) {
        const s = A.querySelectorAll(
          '[*|href="#' + t.id + '"]'
        );
        if (s.length)
          if ((s[0].tagName === "linearGradient" || s[0].tagName === "radialGradient") && s[0].getAttribute("gradientUnits") === "userSpaceOnUse")
            n = A.querySelectorAll(
              '[fill="url(#' + s[0].id + ')"],[stroke="url(#' + s[0].id + ')"]'
            );
          else
            return;
        else
          return;
      }
      const i = Ir(n[0]);
      if (!i)
        return;
      if (t.tagName === "linearGradient") {
        const s = {
          x1: t.getAttribute("x1"),
          y1: t.getAttribute("y1"),
          x2: t.getAttribute("x2"),
          y2: t.getAttribute("y2")
        }, a = jt(t);
        if (a?.numberOfItems > 0) {
          const o = Ht(a).matrix, l = Rt(s.x1, s.y1, o), u = Rt(s.x2, s.y2, o);
          s.x1 = l.x, s.y1 = l.y, s.x2 = u.x, s.y2 = u.y, t.removeAttribute("gradientTransform");
        }
        t.setAttribute("x1", (s.x1 - i.x) / i.width), t.setAttribute("y1", (s.y1 - i.y) / i.height), t.setAttribute("x2", (s.x2 - i.x) / i.width), t.setAttribute("y2", (s.y2 - i.y) / i.height), t.removeAttribute("gradientUnits");
      } else if (t.tagName === "radialGradient") {
        const s = (h, g) => {
          const p = Number(h);
          return Number.isFinite(p) ? p : g;
        };
        let a = s(t.getAttribute("cx"), 0.5), o = s(t.getAttribute("cy"), 0.5), l = s(t.getAttribute("r"), 0.5), u = s(t.getAttribute("fx"), a), c = s(t.getAttribute("fy"), o);
        const f = jt(t);
        if (f?.numberOfItems > 0) {
          const h = Ht(f).matrix, g = Rt(a, o, h), p = Rt(u, c, h), v = Rt(a + l, o, h);
          a = g.x, o = g.y, u = p.x, c = p.y, l = Math.hypot(v.x - g.x, v.y - g.y), t.removeAttribute("gradientTransform");
        }
        if (!i.width || !i.height)
          return;
        t.setAttribute("cx", (a - i.x) / i.width), t.setAttribute("cy", (o - i.y) / i.height), t.setAttribute("fx", (u - i.x) / i.width), t.setAttribute("fy", (c - i.y) / i.height), t.setAttribute("r", l / Math.max(i.width, i.height)), t.removeAttribute("gradientUnits");
      }
    }
  });
};
let iA;
const Eh = window.ontouchstart ? 10 : 4;
class EN {
  #e = null;
  /**
   * Initialize the select module with canvas
   * @param {Object} canvas - The SVG canvas instance
   * @returns {void}
   */
  init(e) {
    iA = e, this.#e = new FN();
  }
  /**
   * Get the singleton SelectorManager instance
   * @returns {SelectorManager} The SelectorManager instance
   */
  getSelectorManager() {
    return this.#e;
  }
}
class jh {
  /**
  * @param {Integer} id - Internally identify the selector
  * @param {Element} elem - DOM element associated with this selector
  * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for initialization (prevents duplicate `getBBox` call).
  */
  constructor(e, t, A) {
    this.id = e, this.selectedElement = t, this.locked = !0, this.selectorGroup = iA.createSVGElement({
      element: "g",
      attr: { id: `selectorGroup${this.id}` }
    }), this.selectorRect = iA.createSVGElement({
      element: "path",
      attr: {
        id: `selectedBox${this.id}`,
        fill: "none",
        stroke: "#22C",
        "stroke-width": "1",
        "stroke-dasharray": "5,5",
        // need to specify this so that the rect is not selectable
        style: "pointer-events:none"
      }
    }), this.selectorGroup.append(this.selectorRect), this.gripCoords = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null
    }, this.reset(this.selectedElement, A);
  }
  /**
  * Used to reset the id and element that the selector is attached to.
  * @param {Element} e - DOM element associated with this selector
  * @param {module:utilities.BBoxObject} bbox - Optional bbox to use for reset (prevents duplicate getBBox call).
  * @returns {void}
  */
  reset(e, t) {
    this.locked = !0, this.selectedElement = e, this.resize(t), this.selectorGroup.setAttribute("display", "inline");
  }
  /**
  * Show the resize grips of this selector.
  * @param {boolean} show - Indicates whether grips should be shown or not
  * @returns {void}
  */
  showGrips(e) {
    const t = e ? "inline" : "none";
    Fa.getSelectorManager().selectorGripsGroup.setAttribute("display", t);
    const A = this.selectedElement;
    this.hasGrips = e, A && e && (this.selectorGroup.append(Fa.getSelectorManager().selectorGripsGroup), jh.updateGripCursors(bA(A)));
  }
  /**
  * Updates the selector to match the element's size.
  * @param {module:utilities.BBoxObject} [bbox] - BBox to use for resize (prevents duplicate getBBox call).
  * @returns {void}
  */
  resize(e) {
    const t = iA.getDataStorage(), A = this.selectorRect, n = Fa.getSelectorManager(), i = n.selectorGrips, s = this.selectedElement, a = iA.getZoom();
    let o = 1 / a;
    const l = s.getAttribute("stroke-width");
    s.getAttribute("stroke") !== "none" && !isNaN(l) && (o += l / 2);
    const { tagName: u } = s;
    u === "text" && (o += 2 / a);
    let f = document.createElementNS(et.SVG, "svg").createSVGMatrix(), h = s;
    for (; h.parentNode; )
      h.parentNode && h.parentNode.tagName === "g" && h.parentNode.transform && h.parentNode.transform.baseVal.numberOfItems && (f = dA(Ht(jt(h.parentNode)).matrix, f)), h = h.parentNode;
    const g = jt(s), p = f ? dA(f, Ht(g).matrix) : Ht(g).matrix;
    if (p.e *= a, p.f *= a, e || (e = Ir(s)), u === "g" && !t.has(s, "gsvg")) {
      const v = LS([s.childNodes]);
      v && (e = v);
    }
    if (e) {
      const v = e.x, w = e.y, b = e.width, S = e.height;
      o *= a;
      const B = $m(v * a, w * a, b * a, S * a, p), { aabox: x } = B;
      let U = x.x - o, Q = x.y - o, N = x.width + o * 2, _ = x.height + o * 2;
      const R = U + N / 2, F = Q + _ / 2, O = bA(s);
      if (O) {
        const $ = iA.getSvgRoot().createSVGTransform();
        $.setRotate(-O, R, F);
        const ne = $.matrix;
        B.tl = Rt(B.tl.x, B.tl.y, ne), B.tr = Rt(B.tr.x, B.tr.y, ne), B.bl = Rt(B.bl.x, B.bl.y, ne), B.br = Rt(B.br.x, B.br.y, ne);
        const { tl: te } = B;
        let J = te.x, re = te.y, le = te.x, se = te.y;
        const { min: P, max: V } = Math;
        J = P(J, P(B.tr.x, P(B.bl.x, B.br.x))) - o, re = P(re, P(B.tr.y, P(B.bl.y, B.br.y))) - o, le = V(le, V(B.tr.x, V(B.bl.x, B.br.x))) + o, se = V(se, V(B.tr.y, V(B.bl.y, B.br.y))) + o, U = J, Q = re, N = le - J, _ = se - re;
      }
      const G = `M${U},${Q} L${U + N},${Q} ${U + N},${Q + _} ${U},${Q + _}z`, H = O ? "rotate(" + [O, R, F].join(",") + ")" : "";
      this.gripCoords = {
        nw: [U, Q],
        ne: [U + N, Q],
        sw: [U, Q + _],
        se: [U + N, Q + _],
        n: [U + N / 2, Q],
        w: [U, Q + _ / 2],
        e: [U + N, Q + _ / 2],
        s: [U + N / 2, Q + _]
      }, A.setAttribute("d", G), this.selectorGroup.setAttribute("transform", H), Object.entries(this.gripCoords).forEach(([$, ne]) => {
        i[$].setAttribute("cx", ne[0]), i[$].setAttribute("cy", ne[1]);
      }), n.rotateGripConnector.setAttribute("x1", U + N / 2), n.rotateGripConnector.setAttribute("y1", Q), n.rotateGripConnector.setAttribute("x2", U + N / 2), n.rotateGripConnector.setAttribute("y2", Q - Eh * 5), n.rotateGrip.setAttribute("cx", U + N / 2), n.rotateGrip.setAttribute("cy", Q - Eh * 5);
    }
  }
  // STATIC methods
  /**
  * Updates cursors for corner grips on rotation so arrows point the right way.
  * @param {Float} angle - Current rotation angle in degrees
  * @returns {void}
  */
  static updateGripCursors(e) {
    const t = Object.keys(Fa.getSelectorManager().selectorGrips);
    let A = Math.round(e / 45);
    for (A < 0 && (A += 8); A > 0; )
      t.push(t.shift()), A--;
    Object.values(Fa.getSelectorManager().selectorGrips).forEach((n, i) => {
      n.setAttribute("style", `cursor:${t[i]}-resize`);
    });
  }
}
class FN {
  /**
   * Sets up properties and calls `initGroup`.
   */
  constructor() {
    this.selectorParentGroup = null, this.rubberBandBox = null, this.selectors = [], this.selectorMap = {}, this.selectorGrips = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null
    }, this.selectorGripsGroup = null, this.rotateGripConnector = null, this.rotateGrip = null, this.initGroup();
  }
  /**
  * Resets the parent selector group element.
  * @returns {void}
  */
  initGroup() {
    const e = iA.getDataStorage();
    if (this.selectorParentGroup?.parentNode && this.selectorParentGroup.remove(), this.selectorParentGroup = iA.createSVGElement({
      element: "g",
      attr: { id: "selectorParentGroup" }
    }), this.selectorGripsGroup = iA.createSVGElement({
      element: "g",
      attr: { display: "none" }
    }), this.selectorParentGroup.append(this.selectorGripsGroup), iA.getSvgRoot().append(this.selectorParentGroup), this.selectorMap = {}, this.selectors = [], this.rubberBandBox = null, Object.keys(this.selectorGrips).forEach((s) => {
      const a = iA.createSVGElement({
        element: "circle",
        attr: {
          id: `selectorGrip_resize_${s}`,
          fill: "#22C",
          r: Eh,
          style: `cursor:${s}-resize`,
          // This expands the mouse-able area of the grips making them
          // easier to grab with the mouse.
          // This works in Opera and WebKit, but does not work in Firefox
          // see https://bugzilla.mozilla.org/show_bug.cgi?id=500174
          "stroke-width": 2,
          "pointer-events": "all"
        }
      });
      e.put(a, "dir", s), e.put(a, "type", "resize"), this.selectorGrips[s] = a, this.selectorGripsGroup.append(a);
    }), this.rotateGripConnector = iA.createSVGElement({
      element: "line",
      attr: {
        id: "selectorGrip_rotateconnector",
        stroke: "#22C",
        "stroke-width": "1"
      }
    }), this.selectorGripsGroup.append(this.rotateGripConnector), this.rotateGrip = iA.createSVGElement({
      element: "circle",
      attr: {
        id: "selectorGrip_rotate",
        fill: "lime",
        r: Eh,
        stroke: "#22C",
        "stroke-width": 2,
        style: `cursor:url(${iA.curConfig.imgPath}/rotate.svg) 12 12, auto;`
      }
    }), this.selectorGripsGroup.append(this.rotateGrip), e.put(this.rotateGrip, "type", "rotate"), document.getElementById("canvasBackground"))
      return;
    const [t, A] = iA.curConfig.dimensions, n = iA.createSVGElement({
      element: "svg",
      attr: {
        id: "canvasBackground",
        width: t,
        height: A,
        x: 0,
        y: 0,
        overflow: sx() ? "none" : "visible",
        // Chrome 7 has a problem with this when zooming out
        style: "pointer-events:none"
      }
    }), i = iA.createSVGElement({
      element: "rect",
      attr: {
        width: "100%",
        height: "100%",
        x: 0,
        y: 0,
        "stroke-width": 1,
        stroke: "#000",
        fill: "#FFF",
        style: "pointer-events:none"
      }
    });
    n.append(i), iA.getSvgRoot().insertBefore(n, iA.getSvgContent());
  }
  /**
  *
  * @param {Element} elem - DOM element to get the selector for
  * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for reset (prevents duplicate getBBox call).
  * @returns {Selector} The selector based on the given element
  */
  requestSelector(e, t) {
    if (!e)
      return null;
    const A = this.selectors.length;
    if (typeof this.selectorMap[e.id] == "object")
      return this.selectorMap[e.id].locked = !0, this.selectorMap[e.id];
    for (let n = 0; n < A; ++n)
      if (!this.selectors[n]?.locked)
        return this.selectors[n].locked = !0, this.selectors[n].reset(e, t), this.selectorMap[e.id] = this.selectors[n], this.selectors[n];
    return this.selectors[A] = new jh(A, e, t), this.selectorParentGroup.append(this.selectors[A].selectorGroup), this.selectorMap[e.id] = this.selectors[A], this.selectors[A];
  }
  /**
  * Removes the selector of the given element (hides selection box).
  *
  * @param {Element} elem - DOM element to remove the selector for
  * @returns {void}
  */
  releaseSelector(e) {
    if (!e)
      return;
    const t = this.selectors.length, A = this.selectorMap[e.id];
    A?.locked || kA("WARNING! selector was released but was already unlocked", null, "select");
    for (let n = 0; n < t; ++n)
      if (this.selectors[n] && this.selectors[n] === A) {
        delete this.selectorMap[e.id], A.locked = !1, A.selectedElement = null, A.showGrips(!1);
        try {
          A.selectorGroup.setAttribute("display", "none");
        } catch {
        }
        break;
      }
  }
  /**
  * @returns {SVGRectElement} The rubberBandBox DOM element. This is the rectangle drawn by
  * the user for selecting/zooming
  */
  getRubberBandBox() {
    return this.rubberBandBox || (this.rubberBandBox = iA.createSVGElement({
      element: "rect",
      attr: {
        id: "selectorRubberBand",
        fill: "#22C",
        "fill-opacity": 0.15,
        stroke: "#22C",
        "stroke-width": 0.5,
        display: "none",
        style: "pointer-events:none"
      }
    }), this.selectorParentGroup.append(this.rubberBandBox)), this.rubberBandBox;
  }
}
const Fa = new EN(), _N = (r) => {
  Fa.init(r);
}, UN = () => Fa.getSelectorManager();
let Tl = null;
const IN = (r) => {
  Tl = r;
}, QN = () => {
  const r = Tl.getCurConfig(), { dimensions: e } = r, t = Tl.getSvgContent();
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  for (const i of Array.from(t.attributes))
    i.namespaceURI ? t.removeAttributeNS(i.namespaceURI, i.localName) : t.removeAttribute(i.name);
  const A = Tl.getSvgRoot();
  t.setAttribute("id", "svgcontent"), t.setAttribute("width", e[0]), t.setAttribute("height", e[1]), t.setAttribute("x", e[0]), t.setAttribute("y", e[1]), t.setAttribute("overflow", r.show_outside_canvas ? "visible" : "hidden"), t.setAttribute("xmlns", et.SVG), t.setAttribute("xmlns:se", et.SE), t.setAttribute("xmlns:xlink", et.XLINK), t.parentNode !== A && A.appendChild(t);
  const n = Tl.getDOMDocument().createComment(" Created with SVG-edit - https://github.com/SVG-Edit/svgedit");
  t.append(n);
};
const LN = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use", Iy = [
  "clip-path",
  "fill",
  "filter",
  "marker-end",
  "marker-mid",
  "marker-start",
  "mask",
  "stroke"
], NN = 0.8, TN = 10, Yi = "svgedit_clipboard";
class pA {
  /**
   * @param {HTMLElement} container - The container HTML element that should hold the SVG root element
   * @param {module:SVGeditor.configObj.curConfig} config - An object that contains configuration data
   */
  constructor(e, t) {
    this.initializeSvgCanvasMethods(), H4(this);
    const { pathActions: A } = Ax;
    this.saveOptions = { round_digits: 2 }, this.importIds = {}, this.extensions = {}, this.removedElements = {}, this.started = !1, this.startTransform = null, this.currentMode = "select", this.currentResizeMode = "none", this.justSelected = null, this.rubberBox = null, this.curBBoxes = [], this.lastClickPoint = null, this.events = {}, this.rootSctm = null, this.drawnPath = null, this.freehand = {
      // Mouse events
      minx: null,
      miny: null,
      maxx: null,
      maxy: null
    }, this.dAttr = null, this.startX = null, this.startY = null, this.rStartX = null, this.rStartY = null, this.initBbox = {}, this.sumDistance = 0, this.controllPoint2 = { x: 0, y: 0 }, this.controllPoint1 = { x: 0, y: 0 }, this.start = { x: 0, y: 0 }, this.end = { x: 0, y: 0 }, this.bSpline = { x: 0, y: 0 }, this.nextPos = { x: 0, y: 0 }, this.idprefix = "svg_", this.encodableImages = {}, this.curConfig = {
      // Default configuration options
      show_outside_canvas: !0,
      selectNew: !0,
      dimensions: [640, 480]
    }, t && (this.curConfig = pA.mergeDeep(this.curConfig, t)), this.lastGoodImgUrl = `${this.curConfig.imgPath}/logo.svg`;
    const { dimensions: n } = this.curConfig;
    this.svgdoc = window.document, this.container = e, this.svgroot = j_(this.svgdoc, n), e.append(this.svgroot), this.svgContent = this.svgdoc.createElementNS(et.SVG, "svg"), K_(this), IN(this), this.clearSvgContentElement(), this.current_drawing_ = new X0(this.svgContent, this.idprefix), this.zoom = 1, this.currentGroup = null;
    const i = {
      shape: {
        fill: (this.curConfig.initFill.color === "none" ? "" : "#") + this.curConfig.initFill.color,
        fill_paint: null,
        fill_opacity: this.curConfig.initFill.opacity,
        stroke: `#${this.curConfig.initStroke.color}`,
        stroke_paint: null,
        stroke_opacity: this.curConfig.initStroke.opacity,
        stroke_width: this.curConfig.initStroke.width,
        stroke_dasharray: "none",
        stroke_linejoin: "miter",
        stroke_linecap: "butt",
        opacity: this.curConfig.initOpacity
      }
    };
    i.text = pA.mergeDeep({}, i.shape), i.text = pA.mergeDeep(i.text, {
      fill: "#000000",
      stroke_width: this.curConfig.text?.stroke_width,
      font_size: this.curConfig.text?.font_size,
      font_family: this.curConfig.text?.font_family
    }), this.curText = i.text, this.curShape = i.shape, this.curProperties = this.curShape, this.selectedElements = [], xU(this), z4(this), gI(this), pI(this), _N(this), $_(this), tU(this), this.nsMap = SS(), this.selectorManager = UN(), this.pathActions = A, XS(this), this.uiStrings = {}, this.opacAni = document.createElementNS(et.SVG, "animate"), this.opacAni.setAttribute("attributeName", "opacity"), this.opacAni.setAttribute("begin", "indefinite"), this.opacAni.setAttribute("dur", 1), this.opacAni.setAttribute("fill", "freeze"), this.svgroot.appendChild(this.opacAni), mU(this), hU(this), dN(this), __(this), EU(this);
    const s = (o) => (o.preventDefault(), !1);
    e.addEventListener("mousedown", this.mouseDownEvent), e.addEventListener("mousemove", this.mouseMoveEvent), vh(e, s), e.addEventListener("dblclick", this.dblClickEvent), e.addEventListener("mouseup", this.mouseUpEvent), e.addEventListener("mouseleave", this.mouseOutEvent), e.addEventListener("mousewheel", this.DOMMouseScrollEvent), e.addEventListener("DOMMouseScroll", this.DOMMouseScrollEvent), this.linkControlPoints = A.linkControlPoints, this.curCommand = null, this.filter = null, this.filterHidden = !1, NI(this), mI(this);
    const a = (o) => {
      o.newValue && (o.key === `${Yi}_startup` ? (localStorage.removeItem(`${Yi}_startup`), this.flashStorage()) : o.key === Yi && sessionStorage.setItem(Yi, o.newValue));
    };
    window.addEventListener("storage", a, !1), localStorage.setItem(`${Yi}_startup`, Math.random()), G_(this), this.contentW = this.getResolution().w, this.contentH = this.getResolution().h, this.clear(), this.modeChangeEvent();
  }
  // End constructor
  getSvgOption() {
    return this.saveOptions;
  }
  setSvgOption(e, t) {
    this.saveOptions[e] = t;
  }
  getSelectedElements() {
    return this.selectedElements;
  }
  setSelectedElements(e, t) {
    this.selectedElements[e] = t;
  }
  setEmptySelectedElements() {
    this.selectedElements = [];
  }
  getSvgRoot() {
    return this.svgroot;
  }
  getDOMDocument() {
    return this.svgdoc;
  }
  getDOMContainer() {
    return this.container;
  }
  getCurConfig() {
    return this.curConfig;
  }
  setIdPrefix(e) {
    this.idprefix = e;
  }
  getCurrentDrawing() {
    return this.current_drawing_;
  }
  getCurShape() {
    return this.curShape;
  }
  getCurrentGroup() {
    return this.currentGroup;
  }
  getBaseUnit() {
    return this.curConfig.baseUnit;
  }
  getHeight() {
    return this.svgContent.getAttribute("height") / this.zoom;
  }
  getWidth() {
    return this.svgContent.getAttribute("width") / this.zoom;
  }
  getRoundDigits() {
    return this.saveOptions.round_digits;
  }
  getSnappingStep() {
    return this.curConfig.snappingStep;
  }
  getGridSnapping() {
    return this.curConfig.gridSnapping;
  }
  getStartTransform() {
    return this.startTransform;
  }
  setStartTransform(e) {
    this.startTransform = e;
  }
  getZoom() {
    return this.zoom;
  }
  round(e) {
    return Number.parseInt(e * this.zoom) / this.zoom;
  }
  createSVGElement(e) {
    return this.addSVGElementsFromJson(e);
  }
  getContainer() {
    return this.container;
  }
  setStarted(e) {
    this.started = e;
  }
  getRubberBox() {
    return this.rubberBox;
  }
  setRubberBox(e) {
    return this.rubberBox = e, this.rubberBox;
  }
  addPtsToSelection({ closedSubpath: e, grips: t }) {
    this.pathActions.canDeleteNodes = !0, this.pathActions.closed_subpath = e, this.call("pointsAdded", { closedSubpath: e, grips: t }), this.call("selected", t);
  }
  /**
   * @param {PlainObject} changes
   * @param {ChangeElementCommand} changes.cmd
   * @param {SVGPathElement} changes.elem
   * @fires module:svgcanvas.SvgCanvas#event:changed
   * @returns {void}
   */
  endChanges({ cmd: e, elem: t }) {
    this.addCommandToHistory(e), this.call("changed", [t]);
  }
  getCurrentMode() {
    return this.currentMode;
  }
  setCurrentMode(e) {
    return this.currentMode = e, this.currentMode;
  }
  getDrawnPath() {
    return this.drawnPath;
  }
  setDrawnPath(e) {
    return this.drawnPath = e, this.drawnPath;
  }
  setCurrentGroup(e) {
    this.currentGroup = e;
  }
  changeSvgContent() {
    this.call("changed", [this.svgContent]);
  }
  getStarted() {
    return this.started;
  }
  getCanvas() {
    return this;
  }
  getrootSctm() {
    return this.rootSctm;
  }
  getStartX() {
    return this.startX;
  }
  setStartX(e) {
    this.startX = e;
  }
  getStartY() {
    return this.startY;
  }
  setStartY(e) {
    this.startY = e;
  }
  getRStartX() {
    return this.rStartX;
  }
  getRStartY() {
    return this.rStartY;
  }
  getInitBbox() {
    return this.initBbox;
  }
  getCurrentResizeMode() {
    return this.currentResizeMode;
  }
  getJustSelected() {
    return this.justSelected;
  }
  getOpacAni() {
    return this.opacAni;
  }
  getParameter() {
    return this.parameter;
  }
  getNextParameter() {
    return this.nextParameter;
  }
  getStepCount() {
    return TN;
  }
  getThreSholdDist() {
    return NN;
  }
  getSumDistance() {
    return this.sumDistance;
  }
  getStart(e) {
    return this.start[e];
  }
  getEnd(e) {
    return this.end[e];
  }
  getbSpline(e) {
    return this.bSpline[e];
  }
  getNextPos(e) {
    return this.nextPos[e];
  }
  getControllPoint1(e) {
    return this.controllPoint1[e];
  }
  getControllPoint2(e) {
    return this.controllPoint2[e];
  }
  getFreehand(e) {
    return this.freehand[e];
  }
  getDrawing() {
    return this.getCurrentDrawing();
  }
  getDAttr() {
    return this.dAttr;
  }
  getLastGoodImgUrl() {
    return this.lastGoodImgUrl;
  }
  getCurText(e) {
    return this.curText[e];
  }
  setDAttr(e) {
    this.dAttr = e;
  }
  setEnd(e, t) {
    this.end[e] = t;
  }
  setControllPoint1(e, t) {
    this.controllPoint1[e] = t;
  }
  setControllPoint2(e, t) {
    this.controllPoint2[e] = t;
  }
  setJustSelected(e) {
    this.justSelected = e;
  }
  setParameter(e) {
    this.parameter = e;
  }
  setStart(e) {
    this.start = e;
  }
  setRStartX(e) {
    this.rStartX = e;
  }
  setRStartY(e) {
    this.rStartY = e;
  }
  setSumDistance(e) {
    this.sumDistance = e;
  }
  setbSpline(e) {
    this.bSpline = e;
  }
  setNextPos(e) {
    this.nextPos = e;
  }
  setNextParameter(e) {
    this.nextParameter = e;
  }
  setCurText(e, t) {
    this.curText[e] = t;
  }
  setFreehand(e, t) {
    this.freehand[e] = t;
  }
  setCurBBoxes(e) {
    this.curBBoxes = e;
  }
  getCurBBoxes() {
    return this.curBBoxes;
  }
  setInitBbox(e) {
    this.initBbox = e;
  }
  setRootSctm(e) {
    this.rootSctm = e;
  }
  setCurrentResizeMode(e) {
    this.currentResizeMode = e;
  }
  getLastClickPoint(e) {
    return this.lastClickPoint[e];
  }
  setLastClickPoint(e) {
    this.lastClickPoint = e;
  }
  getId() {
    return this.getCurrentDrawing().getId();
  }
  getUIStrings() {
    return this.uiStrings;
  }
  getNsMap() {
    return this.nsMap;
  }
  getSvgOptionApply() {
    return this.saveOptions.apply;
  }
  getSvgOptionImages() {
    return this.saveOptions.images;
  }
  getEncodableImages(e) {
    return this.encodableImages[e];
  }
  setEncodableImages(e, t) {
    this.encodableImages[e] = t;
  }
  getVisElems() {
    return LN;
  }
  getIdPrefix() {
    return this.idprefix;
  }
  getDataStorage() {
    return ts;
  }
  setZoom(e) {
    this.zoom = e;
  }
  getImportIds(e) {
    return this.importIds[e];
  }
  setImportIds(e, t) {
    this.importIds[e] = t;
  }
  setRemovedElements(e, t) {
    this.removedElements[e] = t;
  }
  setSvgContent(e) {
    this.svgContent = e;
  }
  getrefAttrs() {
    return Iy;
  }
  setCanvas(e, t) {
    this[e] = t;
  }
  setCurProperties(e, t) {
    this.curProperties[e] = t;
  }
  getCurProperties(e) {
    return this.curProperties[e];
  }
  setCurShape(e, t) {
    this.curShape[e] = t;
  }
  gettingSelectorManager() {
    return this.selectorManager;
  }
  getContentW() {
    return this.contentW;
  }
  getContentH() {
    return this.contentH;
  }
  getClipboardID() {
    return Yi;
  }
  getSvgContent() {
    return this.svgContent;
  }
  getExtensions() {
    return this.extensions;
  }
  getSelector() {
    return jh;
  }
  getMode() {
    return this.currentMode;
  }
  // The current editor mode string
  getNextId() {
    return this.getCurrentDrawing().getNextId();
  }
  getCurCommand() {
    return this.curCommand;
  }
  setCurCommand(e) {
    this.curCommand = e;
  }
  getFilter() {
    return this.filter;
  }
  setFilter(e) {
    this.filter = e;
  }
  getFilterHidden() {
    return this.filterHidden;
  }
  setFilterHidden(e) {
    this.filterHidden = e;
  }
  /**
   * Sets the editor's mode to the given string.
   * @function module:svgcanvas.SvgCanvas#setMode
   * @param {string} name - String with the new mode to change to
   * @returns {void}
   */
  setMode(e) {
    this.pathActions.clear(!0), this.textActions.clear(), this.curProperties = this.selectedElements[0]?.nodeName === "text" ? this.curText : this.curShape, this.currentMode = e, this.modeEvent && document.dispatchEvent(this.modeEvent);
  }
  /**
   * Clears the current document. This is not an undoable action.
   * @function module:svgcanvas.SvgCanvas#clear
   * @fires module:svgcanvas.SvgCanvas#event:beforeClear|afterClear
   * @returns {void}
   */
  clear() {
    this.call("beforeClear"), this.pathActions.clear(), this.clearSelection(), this.clearSvgContentElement(), this.current_drawing_ = new X0(this.svgContent), this.createLayer(), this.undoMgr.resetUndoStack(), this.selectorManager.initGroup(), this.rubberBox = this.selectorManager.getRubberBandBox(), this.call("afterClear");
  }
  async addExtension(e, t, { importLocale: A }) {
    if (typeof t != "function")
      throw new TypeError(
        "Function argument expected for `svgcanvas.addExtension`"
      );
    if (e in this.extensions)
      throw new Error(
        'Cannot add extension "' + e + '", an extension by that name already exists.'
      );
    const n = {
      importLocale: A,
      svgroot: this.svgroot,
      svgContent: this.svgContent,
      nonce: this.getCurrentDrawing().getNonce(),
      selectorManager: this.selectorManager
    }, i = await t(n);
    return i && (i.name = e), this.extensions[e] = i, this.call("extension_added", i);
  }
  addCommandToHistory(e) {
    this.undoMgr.addCommandToHistory(e);
  }
  restoreRefElements(e) {
    const t = {};
    Iy.forEach((n, i) => {
      t[n] = e.getAttribute(n);
    }), Object.values(t).forEach((n) => {
      if (n?.startsWith("url(")) {
        const i = eu(n).slice(1);
        Jt(i) || (an().append(this.removedElements[i]), delete this.removedElements[i]);
      }
    });
    const A = e.getElementsByTagName("*");
    if (A.length)
      for (let n = 0, i = A.length; n < i; n++)
        this.restoreRefElements(A[n]);
  }
  call(e, t) {
    if (this.events[e])
      return this.events[e](window, t);
  }
  /**
   * Attaches a callback function to an event.
   * @function module:svgcanvas.SvgCanvas#bind
   * @param  {string} ev - String indicating the name of the event
   * @param {module:svgcanvas.EventHandler} f - The callback function to bind to the event
   * @returns {module:svgcanvas.EventHandler} The previous event
   */
  bind(e, t) {
    const A = this.events[e];
    return this.events[e] = t, A;
  }
  /**
   * Flash the clipboard data momentarily on localStorage so all tabs can see.
   * @returns {void}
   */
  flashStorage() {
    const e = sessionStorage.getItem(Yi);
    localStorage.setItem(Yi, e), setTimeout(() => {
      localStorage.removeItem(Yi);
    }, 1);
  }
  /**
   * Selects only the given elements, shortcut for `clearSelection(); addToSelection()`.
   * @function module:svgcanvas.SvgCanvas#selectOnly
   * @param {Element[]} elems - an array of DOM elements to be selected
   * @param {boolean} showGrips - Indicates whether the resize grips should be shown
   * @returns {void}
   */
  selectOnly(e, t) {
    this.clearSelection(!0), this.addToSelection(e, t);
  }
  /**
   * Removes elements from the selection.
   * @function module:svgcanvas.SvgCanvas#removeFromSelection
   * @param {Element[]} elemsToRemove - An array of elements to remove from selection
   * @returns {void}
   */
  removeFromSelection(e) {
    if (!this.selectedElements[0] || !e.length)
      return;
    const t = [], A = this.selectedElements.length;
    for (let n = 0; n < A; ++n) {
      const i = this.selectedElements[n];
      i && (e.includes(i) ? this.selectorManager.releaseSelector(i) : t.push(i));
    }
    this.selectedElements = t;
  }
  /**
   * Clears the selection, then adds all elements in the current layer to the selection.
   * @function module:svgcanvas.SvgCanvas#selectAllInCurrentLayer
   * @returns {void}
   */
  selectAllInCurrentLayer() {
    const e = this.getCurrentDrawing().getCurrentLayer();
    e && (this.currentMode = "select", this.currentGroup ? this.selectOnly(this.currentGroup.children) : this.selectOnly(e.children));
  }
  getOpacity() {
    return this.curShape.opacity;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getSnapToGrid
   * @returns {boolean} The current snap to grid setting
   */
  getSnapToGrid() {
    return this.curConfig.gridSnapping;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getVersion
   * @returns {string} A string which describes the revision number of SvgCanvas.
   */
  getVersion() {
    return "svgcanvas.js ($Rev$)";
  }
  /**
   * Update interface strings with given values.
   * @function module:svgcanvas.SvgCanvas#setUiStrings
   * @param {module:path.uiStrings} strs - Object with strings (see the [locales API]{@link module:locale.LocaleStrings} and the [tutorial]{@tutorial LocaleDocs})
   * @returns {void}
   */
  setUiStrings(e) {
    Object.assign(this.uiStrings, e.notification), qS(e);
  }
  /**
   * Update configuration options with given values.
   * @function module:svgcanvas.SvgCanvas#setConfig
   * @param {module:SVGEditor.Config} opts - Object with options
   * @returns {void}
   */
  setConfig(e) {
    Object.assign(this.curConfig, e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getDocumentTitle
   * @returns {string|void} The current document title or an empty string if not found
   */
  getDocumentTitle() {
    return this.getTitle(this.svgContent);
  }
  getOffset() {
    return {
      x: Number(this.svgContent.getAttribute("x")),
      y: Number(this.svgContent.getAttribute("y"))
    };
  }
  getColor(e) {
    return this.curProperties[e];
  }
  setStrokePaint(e) {
    this.setPaint("stroke", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#setFillPaint
   * @param {module:jGraduate~Paint} paint
   * @returns {void}
   */
  setFillPaint(e) {
    this.setPaint("fill", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStrokeWidth
   * @returns {Float|string} The current stroke-width value
   */
  getStrokeWidth() {
    return this.curProperties.stroke_width;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStyle
   * @returns {module:svgcanvas.StyleOptions} current style options
   */
  getStyle() {
    return this.curShape;
  }
  /**
   * Sets the given opacity on the current selected elements.
   * @function module:svgcanvas.SvgCanvas#setOpacity
   * @param {string} val
   * @returns {void}
   */
  setOpacity(e) {
    this.curShape.opacity = e, this.changeSelectedAttribute("opacity", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getFillOpacity
   * @returns {Float} the current fill opacity
   */
  getFillOpacity() {
    return this.curShape.fill_opacity;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStrokeOpacity
   * @returns {string} the current stroke opacity
   */
  getStrokeOpacity() {
    return this.curShape.stroke_opacity;
  }
  /**
   * Sets the current fill/stroke opacity.
   * @function module:svgcanvas.SvgCanvas#setPaintOpacity
   * @param {string} type - String with "fill" or "stroke"
   * @param {Float} val - Float with the new opacity value
   * @param {boolean} preventUndo - Indicates whether or not this should be an undoable action
   * @returns {void}
   */
  setPaintOpacity(e, t, A) {
    this.curShape[`${e}_opacity`] = t, A ? this.changeSelectedAttributeNoUndo(`${e}-opacity`, t) : this.changeSelectedAttribute(`${e}-opacity`, t);
  }
  /**
   * Gets the current fill/stroke opacity.
   * @function module:svgcanvas.SvgCanvas#getPaintOpacity
   * @param {"fill"|"stroke"} type - String with "fill" or "stroke"
   * @returns {Float} Fill/stroke opacity
   */
  getPaintOpacity(e) {
    return e === "fill" ? this.getFillOpacity() : this.getStrokeOpacity();
  }
  /**
   * Gets the `stdDeviation` blur value of the given element.
   * @function module:svgcanvas.SvgCanvas#getBlur
   * @param {Element} elem - The element to check the blur value for
   * @returns {string} stdDeviation blur attribute value
   */
  getBlur(e) {
    let t = 0;
    if (e) {
      const A = e.getAttribute("filter");
      if (A) {
        const n = Jt(`${e.id}_blur`);
        if (n)
          t = n.firstChild.getAttribute("stdDeviation");
        else {
          const i = qs(A), s = q0(i);
          s !== null && (t = s.getAttribute("stdDeviation"));
        }
      }
    }
    return t;
  }
  /**
   * Sets a given URL to be a "last good image" URL.
   * @function module:svgcanvas.SvgCanvas#setGoodImage
   * @param {string} val
   * @returns {void}
   */
  setGoodImage(e) {
    this.lastGoodImgUrl = e;
  }
  /**
   * Returns the current drawing as raw SVG XML text.
   * @function module:svgcanvas.SvgCanvas#getSvgString
   * @returns {string} The current drawing as raw SVG XML text.
   */
  getSvgString() {
    return this.saveOptions.apply = !1, this.svgCanvasToString();
  }
  /**
   * This function determines whether to use a nonce in the prefix, when
   * generating IDs for future documents in SVG-Edit.
   * If you're controlling SVG-Edit externally, and want randomized IDs, call
   * this BEFORE calling `svgCanvas.setSvgString`.
   * @function module:svgcanvas.SvgCanvas#randomizeIds
   * @param {boolean} [enableRandomization] If true, adds a nonce to the prefix. Thus
   * `svgCanvas.randomizeIds() <==> svgCanvas.randomizeIds(true)`
   * @returns {void}
   */
  randomizeIds(e) {
    arguments.length > 0 && e === !1 ? j1(!1, this.getCurrentDrawing()) : j1(!0, this.getCurrentDrawing());
  }
  /**
   * Convert selected element to a path, or get the BBox of an element-as-path.
   * @function module:svgcanvas.SvgCanvas#convertToPath
   * @todo (codedread): Remove the getBBox argument and split this function into two.
   * @param {Element} elem - The DOM element to be converted
   * @param {boolean} getBBox - Boolean on whether or not to only return the path's BBox
   * @returns {void|DOMRect|false|SVGPathElement|null} If the getBBox flag is true, the resulting path's bounding box object.
   * Otherwise the resulting path element is returned.
   */
  convertToPath(e, t) {
    if (!e) {
      this.selectedElements.forEach((i) => {
        i && this.convertToPath(i);
      });
      return;
    }
    if (t)
      return j0(
        e,
        this.addSVGElementsFromJson,
        this.pathActions
      );
    const A = {
      fill: this.curShape.fill,
      "fill-opacity": this.curShape.fill_opacity,
      stroke: this.curShape.stroke,
      "stroke-width": this.curShape.stroke_width,
      "stroke-dasharray": this.curShape.stroke_dasharray,
      "stroke-linejoin": this.curShape.stroke_linejoin,
      "stroke-linecap": this.curShape.stroke_linecap,
      "stroke-opacity": this.curShape.stroke_opacity,
      opacity: this.curShape.opacity,
      visibility: "hidden"
    };
    return t_(e, A, this);
  }
  /**
   * Removes all selected elements from the DOM and adds the change to the
   * history stack. Remembers removed elements on the clipboard.
   * @function module:svgcanvas.SvgCanvas#cutSelectedElements
   * @returns {void}
   */
  cutSelectedElements() {
    this.copySelectedElements(), this.deleteSelectedElements();
  }
  initializeSvgCanvasMethods() {
    this.getJsonFromSvgElements = ox, this.addSVGElementsFromJson = lx, this.clearSvgContentElement = QN, this.textActions = dU, this.getStrokedBBox = Hn, this.getVisibleElements = fu, this.stringToHTML = TS, this.insertChildAtIndex = A_, this.getClosest = cu, this.getParents = hu, this.isLayer = Sn.isLayer, this.matrixMultiply = dA, this.hasMatrixTransform = Ra, this.transformListToTransform = Ht, this.convertToNum = yr, this.convertUnit = mh, this.findDefs = an, this.getUrlFromAttr = eu, this.getHref = Ei, this.setHref = Dn, this.getBBox = Ir, this.getRotationAngle = bA, this.getElement = Jt, this.getRefElem = qs, this.assignAttributes = Yt, this.cleanupElement = Rh, this.remapElement = Ll, this.recalculateDimensions = On, this.sanitizeSvg = $0, this.pasteElements = V_, this.identifyLayers = ql, this.createLayer = I_, this.cloneLayer = Q_, this.deleteCurrentLayer = L_, this.setCurrentLayer = N_, this.renameCurrentLayer = T_, this.setCurrentLayerPosition = P_, this.indexCurrentLayer = U_, this.setLayerVisibility = O_, this.moveSelectedToLayer = M_, this.mergeLayer = R_, this.mergeAllLayers = k_, this.leaveContext = $s, this.setContext = ix, this.changeSelectedAttributeNoUndo = ax, this.changeSelectedAttribute = Z_, this.setBlurNoUndo = TI, this.setBlurOffsets = PI, this.setBlur = OI, this.smoothControlPoints = JS, this.getTypeMap = Ym, this.history = Va, this.NS = et, this.$id = PS, this.$qq = OS, this.$qa = MS, this.$click = vh, this.encode64 = _S, this.decode64 = US, this.mergeDeep = uu;
  }
  /**
   * Creates modeChange event, adds it as an svgCanvas property
   * **/
  modeChangeEvent() {
    const e = new CustomEvent("modeChange", { detail: { getMode: () => this.getMode() } });
    this.modeEvent = e;
  }
}
pA.$id = PS;
pA.$qq = OS;
pA.$qa = MS;
pA.$click = vh;
pA.encode64 = _S;
pA.decode64 = US;
pA.mergeDeep = uu;
pA.getClosest = cu;
pA.getParents = hu;
pA.blankPageObjectURL = J4;
pA.Paint = ni;
pA.getTypeMap = Ym;
pA.convertToNum = yr;
pA.isValidUnit = G4;
pA.convertUnit = mh;
var fm = function(r, e) {
  return fm = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  }, fm(r, e);
};
function ui(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  fm(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var dm = function() {
  return dm = Object.assign || function(e) {
    for (var t, A = 1, n = arguments.length; A < n; A++) {
      t = arguments[A];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, dm.apply(this, arguments);
};
function WA(r, e, t, A) {
  function n(i) {
    return i instanceof t ? i : new t(function(s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function(i, s) {
    function a(u) {
      try {
        l(A.next(u));
      } catch (c) {
        s(c);
      }
    }
    function o(u) {
      try {
        l(A.throw(u));
      } catch (c) {
        s(c);
      }
    }
    function l(u) {
      u.done ? i(u.value) : n(u.value).then(a, o);
    }
    l((A = A.apply(r, [])).next());
  });
}
function MA(r, e) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, A, n, i, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(l) {
    return function(u) {
      return o([l, u]);
    };
  }
  function o(l) {
    if (A) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (A = 1, n && (i = l[0] & 2 ? n.return : l[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, l[1])).done) return i;
      switch (n = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return t.label++, { value: l[1], done: !1 };
        case 5:
          t.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            t = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            t.label = l[1];
            break;
          }
          if (l[0] === 6 && t.label < i[1]) {
            t.label = i[1], i = l;
            break;
          }
          if (i && t.label < i[2]) {
            t.label = i[2], t.ops.push(l);
            break;
          }
          i[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      l = e.call(r, t);
    } catch (u) {
      l = [6, u], n = 0;
    } finally {
      A = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Fc(r, e, t) {
  if (arguments.length === 2) for (var A = 0, n = e.length, i; A < n; A++)
    (i || !(A in e)) && (i || (i = Array.prototype.slice.call(e, 0, A)), i[A] = e[A]);
  return r.concat(i || e);
}
var ls = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.left = e, this.top = t, this.width = A, this.height = n;
    }
    return r.prototype.add = function(e, t, A, n) {
      return new r(this.left + e, this.top + t, this.width + A, this.height + n);
    }, r.fromClientRect = function(e, t) {
      return new r(t.left + e.windowBounds.left, t.top + e.windowBounds.top, t.width, t.height);
    }, r.fromDOMRectList = function(e, t) {
      var A = Array.from(t).find(function(n) {
        return n.width !== 0;
      });
      return A ? new r(A.left + e.windowBounds.left, A.top + e.windowBounds.top, A.width, A.height) : r.EMPTY;
    }, r.EMPTY = new r(0, 0, 0, 0), r;
  })()
), qh = function(r, e) {
  return ls.fromClientRect(r, e.getBoundingClientRect());
}, PN = function(r) {
  var e = r.body, t = r.documentElement;
  if (!e || !t)
    throw new Error("Unable to get document size");
  var A = Math.max(Math.max(e.scrollWidth, t.scrollWidth), Math.max(e.offsetWidth, t.offsetWidth), Math.max(e.clientWidth, t.clientWidth)), n = Math.max(Math.max(e.scrollHeight, t.scrollHeight), Math.max(e.offsetHeight, t.offsetHeight), Math.max(e.clientHeight, t.clientHeight));
  return new ls(0, 0, A, n);
}, zh = function(r) {
  for (var e = [], t = 0, A = r.length; t < A; ) {
    var n = r.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < A) {
      var i = r.charCodeAt(t++);
      (i & 64512) === 56320 ? e.push(((n & 1023) << 10) + (i & 1023) + 65536) : (e.push(n), t--);
    } else
      e.push(n);
  }
  return e;
}, qr = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, r);
  var t = r.length;
  if (!t)
    return "";
  for (var A = [], n = -1, i = ""; ++n < t; ) {
    var s = r[n];
    s <= 65535 ? A.push(s) : (s -= 65536, A.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || A.length > 16384) && (i += String.fromCharCode.apply(String, A), A.length = 0);
  }
  return i;
}, Qy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ON = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var _c = 0; _c < Qy.length; _c++)
  ON[Qy.charCodeAt(_c)] = _c;
var Ly = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Pl = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Uc = 0; Uc < Ly.length; Uc++)
  Pl[Ly.charCodeAt(Uc)] = Uc;
var MN = function(r) {
  var e = r.length * 0.75, t = r.length, A, n = 0, i, s, a, o;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), u = Array.isArray(l) ? l : new Uint8Array(l);
  for (A = 0; A < t; A += 4)
    i = Pl[r.charCodeAt(A)], s = Pl[r.charCodeAt(A + 1)], a = Pl[r.charCodeAt(A + 2)], o = Pl[r.charCodeAt(A + 3)], u[n++] = i << 2 | s >> 4, u[n++] = (s & 15) << 4 | a >> 2, u[n++] = (a & 3) << 6 | o & 63;
  return l;
}, RN = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 2)
    t.push(r[A + 1] << 8 | r[A]);
  return t;
}, kN = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 4)
    t.push(r[A + 3] << 24 | r[A + 2] << 16 | r[A + 1] << 8 | r[A]);
  return t;
}, Pa = 5, yv = 11, Pd = 2, HN = yv - Pa, S5 = 65536 >> Pa, DN = 1 << Pa, Od = DN - 1, GN = 1024 >> Pa, VN = S5 + GN, KN = VN, jN = 32, qN = KN + jN, zN = 65536 >> yv, WN = 1 << HN, XN = WN - 1, Ny = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint16Array(Array.prototype.slice.call(r, e, t));
}, YN = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint32Array(Array.prototype.slice.call(r, e, t));
}, $N = function(r, e) {
  var t = MN(r), A = Array.isArray(t) ? kN(t) : new Uint32Array(t), n = Array.isArray(t) ? RN(t) : new Uint16Array(t), i = 24, s = Ny(n, i / 2, A[4] / 2), a = A[5] === 2 ? Ny(n, (i + A[4]) / 2) : YN(A, Math.ceil((i + A[4]) / 4));
  return new JN(A[0], A[1], A[2], A[3], s, a);
}, JN = (
  /** @class */
  (function() {
    function r(e, t, A, n, i, s) {
      this.initialValue = e, this.errorValue = t, this.highStart = A, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return r.prototype.get = function(e) {
      var t;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return t = this.index[e >> Pa], t = (t << Pd) + (e & Od), this.data[t];
        if (e <= 65535)
          return t = this.index[S5 + (e - 55296 >> Pa)], t = (t << Pd) + (e & Od), this.data[t];
        if (e < this.highStart)
          return t = qN - zN + (e >> yv), t = this.index[t], t += e >> Pa & XN, t = this.index[t], t = (t << Pd) + (e & Od), this.data[t];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, r;
  })()
), Ty = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ZN = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ic = 0; Ic < Ty.length; Ic++)
  ZN[Ty.charCodeAt(Ic)] = Ic;
var eT = "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", Py = 50, tT = 1, x5 = 2, E5 = 3, rT = 4, AT = 5, Oy = 7, F5 = 8, My = 9, Ds = 10, gm = 11, Ry = 12, pm = 13, nT = 14, Ol = 15, mm = 16, Qc = 17, wl = 18, iT = 19, ky = 20, vm = 21, yl = 22, Md = 23, co = 24, Bn = 25, Ml = 26, Rl = 27, ho = 28, sT = 29, _a = 30, aT = 31, Lc = 32, Nc = 33, wm = 34, ym = 35, bm = 36, su = 37, Bm = 38, uh = 39, ch = 40, Rd = 41, _5 = 42, oT = 43, lT = [9001, 65288], U5 = "!", Mt = "×", Tc = "÷", Cm = $N(eT), $i = [_a, bm], Sm = [tT, x5, E5, AT], I5 = [Ds, F5], Hy = [Rl, Ml], uT = Sm.concat(I5), Dy = [Bm, uh, ch, wm, ym], cT = [Ol, pm], hT = function(r, e) {
  e === void 0 && (e = "strict");
  var t = [], A = [], n = [];
  return r.forEach(function(i, s) {
    var a = Cm.get(i);
    if (a > Py ? (n.push(!0), a -= Py) : n.push(!1), ["normal", "auto", "loose"].indexOf(e) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return A.push(s), t.push(mm);
    if (a === rT || a === gm) {
      if (s === 0)
        return A.push(s), t.push(_a);
      var o = t[s - 1];
      return uT.indexOf(o) === -1 ? (A.push(A[s - 1]), t.push(o)) : (A.push(s), t.push(_a));
    }
    if (A.push(s), a === aT)
      return t.push(e === "strict" ? vm : su);
    if (a === _5 || a === sT)
      return t.push(_a);
    if (a === oT)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? t.push(su) : t.push(_a);
    t.push(a);
  }), [A, t, n];
}, kd = function(r, e, t, A) {
  var n = A[t];
  if (Array.isArray(r) ? r.indexOf(n) !== -1 : r === n)
    for (var i = t; i <= A.length; ) {
      i++;
      var s = A[i];
      if (s === e)
        return !0;
      if (s !== Ds)
        break;
    }
  if (n === Ds)
    for (var i = t; i > 0; ) {
      i--;
      var a = A[i];
      if (Array.isArray(r) ? r.indexOf(a) !== -1 : r === a)
        for (var o = t; o <= A.length; ) {
          o++;
          var s = A[o];
          if (s === e)
            return !0;
          if (s !== Ds)
            break;
        }
      if (a !== Ds)
        break;
    }
  return !1;
}, Gy = function(r, e) {
  for (var t = r; t >= 0; ) {
    var A = e[t];
    if (A === Ds)
      t--;
    else
      return A;
  }
  return 0;
}, fT = function(r, e, t, A, n) {
  if (t[A] === 0)
    return Mt;
  var i = A - 1;
  if (Array.isArray(n) && n[i] === !0)
    return Mt;
  var s = i - 1, a = i + 1, o = e[i], l = s >= 0 ? e[s] : 0, u = e[a];
  if (o === x5 && u === E5)
    return Mt;
  if (Sm.indexOf(o) !== -1)
    return U5;
  if (Sm.indexOf(u) !== -1 || I5.indexOf(u) !== -1)
    return Mt;
  if (Gy(i, e) === F5)
    return Tc;
  if (Cm.get(r[i]) === gm || (o === Lc || o === Nc) && Cm.get(r[a]) === gm || o === Oy || u === Oy || o === My || [Ds, pm, Ol].indexOf(o) === -1 && u === My || [Qc, wl, iT, co, ho].indexOf(u) !== -1 || Gy(i, e) === yl || kd(Md, yl, i, e) || kd([Qc, wl], vm, i, e) || kd(Ry, Ry, i, e))
    return Mt;
  if (o === Ds)
    return Tc;
  if (o === Md || u === Md)
    return Mt;
  if (u === mm || o === mm)
    return Tc;
  if ([pm, Ol, vm].indexOf(u) !== -1 || o === nT || l === bm && cT.indexOf(o) !== -1 || o === ho && u === bm || u === ky || $i.indexOf(u) !== -1 && o === Bn || $i.indexOf(o) !== -1 && u === Bn || o === Rl && [su, Lc, Nc].indexOf(u) !== -1 || [su, Lc, Nc].indexOf(o) !== -1 && u === Ml || $i.indexOf(o) !== -1 && Hy.indexOf(u) !== -1 || Hy.indexOf(o) !== -1 && $i.indexOf(u) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [Rl, Ml].indexOf(o) !== -1 && (u === Bn || [yl, Ol].indexOf(u) !== -1 && e[a + 1] === Bn) || // ( OP | HY ) × NU
  [yl, Ol].indexOf(o) !== -1 && u === Bn || // NU ×	(NU | SY | IS)
  o === Bn && [Bn, ho, co].indexOf(u) !== -1)
    return Mt;
  if ([Bn, ho, co, Qc, wl].indexOf(u) !== -1)
    for (var c = i; c >= 0; ) {
      var f = e[c];
      if (f === Bn)
        return Mt;
      if ([ho, co].indexOf(f) !== -1)
        c--;
      else
        break;
    }
  if ([Rl, Ml].indexOf(u) !== -1)
    for (var c = [Qc, wl].indexOf(o) !== -1 ? s : i; c >= 0; ) {
      var f = e[c];
      if (f === Bn)
        return Mt;
      if ([ho, co].indexOf(f) !== -1)
        c--;
      else
        break;
    }
  if (Bm === o && [Bm, uh, wm, ym].indexOf(u) !== -1 || [uh, wm].indexOf(o) !== -1 && [uh, ch].indexOf(u) !== -1 || [ch, ym].indexOf(o) !== -1 && u === ch || Dy.indexOf(o) !== -1 && [ky, Ml].indexOf(u) !== -1 || Dy.indexOf(u) !== -1 && o === Rl || $i.indexOf(o) !== -1 && $i.indexOf(u) !== -1 || o === co && $i.indexOf(u) !== -1 || $i.concat(Bn).indexOf(o) !== -1 && u === yl && lT.indexOf(r[a]) === -1 || $i.concat(Bn).indexOf(u) !== -1 && o === wl)
    return Mt;
  if (o === Rd && u === Rd) {
    for (var h = t[i], g = 1; h > 0 && (h--, e[h] === Rd); )
      g++;
    if (g % 2 !== 0)
      return Mt;
  }
  return o === Lc && u === Nc ? Mt : Tc;
}, dT = function(r, e) {
  e || (e = { lineBreak: "normal", wordBreak: "normal" });
  var t = hT(r, e.lineBreak), A = t[0], n = t[1], i = t[2];
  (e.wordBreak === "break-all" || e.wordBreak === "break-word") && (n = n.map(function(a) {
    return [Bn, _a, _5].indexOf(a) !== -1 ? su : a;
  }));
  var s = e.wordBreak === "keep-all" ? i.map(function(a, o) {
    return a && r[o] >= 19968 && r[o] <= 40959;
  }) : void 0;
  return [A, n, s];
}, gT = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.codePoints = e, this.required = t === U5, this.start = A, this.end = n;
    }
    return r.prototype.slice = function() {
      return qr.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, r;
  })()
), pT = function(r, e) {
  var t = zh(r), A = dT(t, e), n = A[0], i = A[1], s = A[2], a = t.length, o = 0, l = 0;
  return {
    next: function() {
      if (l >= a)
        return { done: !0, value: null };
      for (var u = Mt; l < a && (u = fT(t, i, n, ++l, s)) === Mt; )
        ;
      if (u !== Mt || l === a) {
        var c = new gT(t, u, o, l);
        return o = l, { value: c, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, mT = 1, vT = 2, Cu = 4, Vy = 8, Fh = 10, Ky = 47, Xl = 92, wT = 9, yT = 32, Pc = 34, bl = 61, bT = 35, BT = 36, CT = 37, Oc = 39, Mc = 40, Bl = 41, ST = 95, nn = 45, xT = 33, ET = 60, FT = 62, _T = 64, UT = 91, IT = 93, QT = 61, LT = 123, Rc = 63, NT = 125, jy = 124, TT = 126, PT = 128, qy = 65533, Hd = 42, Qa = 43, OT = 44, MT = 58, RT = 59, au = 46, kT = 0, HT = 8, DT = 11, GT = 14, VT = 31, KT = 127, bi = -1, Q5 = 48, L5 = 97, N5 = 101, jT = 102, qT = 117, zT = 122, T5 = 65, P5 = 69, O5 = 70, WT = 85, XT = 90, RA = function(r) {
  return r >= Q5 && r <= 57;
}, YT = function(r) {
  return r >= 55296 && r <= 57343;
}, fo = function(r) {
  return RA(r) || r >= T5 && r <= O5 || r >= L5 && r <= jT;
}, $T = function(r) {
  return r >= L5 && r <= zT;
}, JT = function(r) {
  return r >= T5 && r <= XT;
}, ZT = function(r) {
  return $T(r) || JT(r);
}, eP = function(r) {
  return r >= PT;
}, kc = function(r) {
  return r === Fh || r === wT || r === yT;
}, _h = function(r) {
  return ZT(r) || eP(r) || r === ST;
}, zy = function(r) {
  return _h(r) || RA(r) || r === nn;
}, tP = function(r) {
  return r >= kT && r <= HT || r === DT || r >= GT && r <= VT || r === KT;
}, Os = function(r, e) {
  return r !== Xl ? !1 : e !== Fh;
}, Hc = function(r, e, t) {
  return r === nn ? _h(e) || Os(e, t) : _h(r) ? !0 : !!(r === Xl && Os(r, e));
}, Dd = function(r, e, t) {
  return r === Qa || r === nn ? RA(e) ? !0 : e === au && RA(t) : RA(r === au ? e : r);
}, rP = function(r) {
  var e = 0, t = 1;
  (r[e] === Qa || r[e] === nn) && (r[e] === nn && (t = -1), e++);
  for (var A = []; RA(r[e]); )
    A.push(r[e++]);
  var n = A.length ? parseInt(qr.apply(void 0, A), 10) : 0;
  r[e] === au && e++;
  for (var i = []; RA(r[e]); )
    i.push(r[e++]);
  var s = i.length, a = s ? parseInt(qr.apply(void 0, i), 10) : 0;
  (r[e] === P5 || r[e] === N5) && e++;
  var o = 1;
  (r[e] === Qa || r[e] === nn) && (r[e] === nn && (o = -1), e++);
  for (var l = []; RA(r[e]); )
    l.push(r[e++]);
  var u = l.length ? parseInt(qr.apply(void 0, l), 10) : 0;
  return t * (n + a * Math.pow(10, -s)) * Math.pow(10, o * u);
}, AP = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, nP = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, iP = {
  type: 4
  /* COMMA_TOKEN */
}, sP = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, aP = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, oP = {
  type: 21
  /* COLUMN_TOKEN */
}, lP = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, uP = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, cP = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, hP = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, fP = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Dc = {
  type: 23
  /* BAD_URL_TOKEN */
}, dP = {
  type: 1
  /* BAD_STRING_TOKEN */
}, gP = {
  type: 25
  /* CDO_TOKEN */
}, pP = {
  type: 24
  /* CDC_TOKEN */
}, mP = {
  type: 26
  /* COLON_TOKEN */
}, vP = {
  type: 27
  /* SEMICOLON_TOKEN */
}, wP = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, yP = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, bP = {
  type: 31
  /* WHITESPACE_TOKEN */
}, xm = {
  type: 32
  /* EOF_TOKEN */
}, M5 = (
  /** @class */
  (function() {
    function r() {
      this._value = [];
    }
    return r.prototype.write = function(e) {
      this._value = this._value.concat(zh(e));
    }, r.prototype.read = function() {
      for (var e = [], t = this.consumeToken(); t !== xm; )
        e.push(t), t = this.consumeToken();
      return e;
    }, r.prototype.consumeToken = function() {
      var e = this.consumeCodePoint();
      switch (e) {
        case Pc:
          return this.consumeStringToken(Pc);
        case bT:
          var t = this.peekCodePoint(0), A = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (zy(t) || Os(A, n)) {
            var i = Hc(t, A, n) ? vT : mT, s = this.consumeName();
            return { type: 5, value: s, flags: i };
          }
          break;
        case BT:
          if (this.peekCodePoint(0) === bl)
            return this.consumeCodePoint(), sP;
          break;
        case Oc:
          return this.consumeStringToken(Oc);
        case Mc:
          return AP;
        case Bl:
          return nP;
        case Hd:
          if (this.peekCodePoint(0) === bl)
            return this.consumeCodePoint(), fP;
          break;
        case Qa:
          if (Dd(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case OT:
          return iP;
        case nn:
          var a = e, o = this.peekCodePoint(0), l = this.peekCodePoint(1);
          if (Dd(a, o, l))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          if (Hc(a, o, l))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          if (o === nn && l === FT)
            return this.consumeCodePoint(), this.consumeCodePoint(), pP;
          break;
        case au:
          if (Dd(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case Ky:
          if (this.peekCodePoint(0) === Hd)
            for (this.consumeCodePoint(); ; ) {
              var u = this.consumeCodePoint();
              if (u === Hd && (u = this.consumeCodePoint(), u === Ky))
                return this.consumeToken();
              if (u === bi)
                return this.consumeToken();
            }
          break;
        case MT:
          return mP;
        case RT:
          return vP;
        case ET:
          if (this.peekCodePoint(0) === xT && this.peekCodePoint(1) === nn && this.peekCodePoint(2) === nn)
            return this.consumeCodePoint(), this.consumeCodePoint(), gP;
          break;
        case _T:
          var c = this.peekCodePoint(0), f = this.peekCodePoint(1), h = this.peekCodePoint(2);
          if (Hc(c, f, h)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case UT:
          return wP;
        case Xl:
          if (Os(e, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          break;
        case IT:
          return yP;
        case QT:
          if (this.peekCodePoint(0) === bl)
            return this.consumeCodePoint(), aP;
          break;
        case LT:
          return cP;
        case NT:
          return hP;
        case qT:
        case WT:
          var g = this.peekCodePoint(0), p = this.peekCodePoint(1);
          return g === Qa && (fo(p) || p === Rc) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
        case jy:
          if (this.peekCodePoint(0) === bl)
            return this.consumeCodePoint(), lP;
          if (this.peekCodePoint(0) === jy)
            return this.consumeCodePoint(), oP;
          break;
        case TT:
          if (this.peekCodePoint(0) === bl)
            return this.consumeCodePoint(), uP;
          break;
        case bi:
          return xm;
      }
      return kc(e) ? (this.consumeWhiteSpace(), bP) : RA(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : _h(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : { type: 6, value: qr(e) };
    }, r.prototype.consumeCodePoint = function() {
      var e = this._value.shift();
      return typeof e > "u" ? -1 : e;
    }, r.prototype.reconsumeCodePoint = function(e) {
      this._value.unshift(e);
    }, r.prototype.peekCodePoint = function(e) {
      return e >= this._value.length ? -1 : this._value[e];
    }, r.prototype.consumeUnicodeRangeToken = function() {
      for (var e = [], t = this.consumeCodePoint(); fo(t) && e.length < 6; )
        e.push(t), t = this.consumeCodePoint();
      for (var A = !1; t === Rc && e.length < 6; )
        e.push(t), t = this.consumeCodePoint(), A = !0;
      if (A) {
        var n = parseInt(qr.apply(void 0, e.map(function(o) {
          return o === Rc ? Q5 : o;
        })), 16), i = parseInt(qr.apply(void 0, e.map(function(o) {
          return o === Rc ? O5 : o;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var s = parseInt(qr.apply(void 0, e), 16);
      if (this.peekCodePoint(0) === nn && fo(this.peekCodePoint(1))) {
        this.consumeCodePoint(), t = this.consumeCodePoint();
        for (var a = []; fo(t) && a.length < 6; )
          a.push(t), t = this.consumeCodePoint();
        var i = parseInt(qr.apply(void 0, a), 16);
        return { type: 30, start: s, end: i };
      } else
        return { type: 30, start: s, end: s };
    }, r.prototype.consumeIdentLikeToken = function() {
      var e = this.consumeName();
      return e.toLowerCase() === "url" && this.peekCodePoint(0) === Mc ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Mc ? (this.consumeCodePoint(), { type: 19, value: e }) : { type: 20, value: e };
    }, r.prototype.consumeUrlToken = function() {
      var e = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === bi)
        return { type: 22, value: "" };
      var t = this.peekCodePoint(0);
      if (t === Oc || t === Pc) {
        var A = this.consumeStringToken(this.consumeCodePoint());
        return A.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === bi || this.peekCodePoint(0) === Bl) ? (this.consumeCodePoint(), { type: 22, value: A.value }) : (this.consumeBadUrlRemnants(), Dc);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === bi || n === Bl)
          return { type: 22, value: qr.apply(void 0, e) };
        if (kc(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === bi || this.peekCodePoint(0) === Bl ? (this.consumeCodePoint(), { type: 22, value: qr.apply(void 0, e) }) : (this.consumeBadUrlRemnants(), Dc);
        if (n === Pc || n === Oc || n === Mc || tP(n))
          return this.consumeBadUrlRemnants(), Dc;
        if (n === Xl)
          if (Os(n, this.peekCodePoint(0)))
            e.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Dc;
        else
          e.push(n);
      }
    }, r.prototype.consumeWhiteSpace = function() {
      for (; kc(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, r.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var e = this.consumeCodePoint();
        if (e === Bl || e === bi)
          return;
        Os(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, r.prototype.consumeStringSlice = function(e) {
      for (var t = 5e4, A = ""; e > 0; ) {
        var n = Math.min(t, e);
        A += qr.apply(void 0, this._value.splice(0, n)), e -= n;
      }
      return this._value.shift(), A;
    }, r.prototype.consumeStringToken = function(e) {
      var t = "", A = 0;
      do {
        var n = this._value[A];
        if (n === bi || n === void 0 || n === e)
          return t += this.consumeStringSlice(A), { type: 0, value: t };
        if (n === Fh)
          return this._value.splice(0, A), dP;
        if (n === Xl) {
          var i = this._value[A + 1];
          i !== bi && i !== void 0 && (i === Fh ? (t += this.consumeStringSlice(A), A = -1, this._value.shift()) : Os(n, i) && (t += this.consumeStringSlice(A), t += qr(this.consumeEscapedCodePoint()), A = -1));
        }
        A++;
      } while (!0);
    }, r.prototype.consumeNumber = function() {
      var e = [], t = Cu, A = this.peekCodePoint(0);
      for ((A === Qa || A === nn) && e.push(this.consumeCodePoint()); RA(this.peekCodePoint(0)); )
        e.push(this.consumeCodePoint());
      A = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (A === au && RA(n))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Vy; RA(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      A = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((A === P5 || A === N5) && ((n === Qa || n === nn) && RA(i) || RA(n)))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Vy; RA(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      return [rP(e), t];
    }, r.prototype.consumeNumericToken = function() {
      var e = this.consumeNumber(), t = e[0], A = e[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (Hc(n, i, s)) {
        var a = this.consumeName();
        return { type: 15, number: t, flags: A, unit: a };
      }
      return n === CT ? (this.consumeCodePoint(), { type: 16, number: t, flags: A }) : { type: 17, number: t, flags: A };
    }, r.prototype.consumeEscapedCodePoint = function() {
      var e = this.consumeCodePoint();
      if (fo(e)) {
        for (var t = qr(e); fo(this.peekCodePoint(0)) && t.length < 6; )
          t += qr(this.consumeCodePoint());
        kc(this.peekCodePoint(0)) && this.consumeCodePoint();
        var A = parseInt(t, 16);
        return A === 0 || YT(A) || A > 1114111 ? qy : A;
      }
      return e === bi ? qy : e;
    }, r.prototype.consumeName = function() {
      for (var e = ""; ; ) {
        var t = this.consumeCodePoint();
        if (zy(t))
          e += qr(t);
        else if (Os(t, this.peekCodePoint(0)))
          e += qr(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(t), e;
      }
    }, r;
  })()
), R5 = (
  /** @class */
  (function() {
    function r(e) {
      this._tokens = e;
    }
    return r.create = function(e) {
      var t = new M5();
      return t.write(e), new r(t.read());
    }, r.parseValue = function(e) {
      return r.create(e).parseComponentValue();
    }, r.parseValues = function(e) {
      return r.create(e).parseComponentValues();
    }, r.prototype.parseComponentValue = function() {
      for (var e = this.consumeToken(); e.type === 31; )
        e = this.consumeToken();
      if (e.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(e);
      var t = this.consumeComponentValue();
      do
        e = this.consumeToken();
      while (e.type === 31);
      if (e.type === 32)
        return t;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, r.prototype.parseComponentValues = function() {
      for (var e = []; ; ) {
        var t = this.consumeComponentValue();
        if (t.type === 32)
          return e;
        e.push(t), e.push();
      }
    }, r.prototype.consumeComponentValue = function() {
      var e = this.consumeToken();
      switch (e.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(e.type);
        case 19:
          return this.consumeFunction(e);
      }
      return e;
    }, r.prototype.consumeSimpleBlock = function(e) {
      for (var t = { type: e, values: [] }, A = this.consumeToken(); ; ) {
        if (A.type === 32 || CP(A, e))
          return t;
        this.reconsumeToken(A), t.values.push(this.consumeComponentValue()), A = this.consumeToken();
      }
    }, r.prototype.consumeFunction = function(e) {
      for (var t = {
        name: e.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var A = this.consumeToken();
        if (A.type === 32 || A.type === 3)
          return t;
        this.reconsumeToken(A), t.values.push(this.consumeComponentValue());
      }
    }, r.prototype.consumeToken = function() {
      var e = this._tokens.shift();
      return typeof e > "u" ? xm : e;
    }, r.prototype.reconsumeToken = function(e) {
      this._tokens.unshift(e);
    }, r;
  })()
), Su = function(r) {
  return r.type === 15;
}, Go = function(r) {
  return r.type === 17;
}, ir = function(r) {
  return r.type === 20;
}, BP = function(r) {
  return r.type === 0;
}, Em = function(r, e) {
  return ir(r) && r.value === e;
}, k5 = function(r) {
  return r.type !== 31;
}, Mo = function(r) {
  return r.type !== 31 && r.type !== 4;
}, _i = function(r) {
  var e = [], t = [];
  return r.forEach(function(A) {
    if (A.type === 4) {
      if (t.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      e.push(t), t = [];
      return;
    }
    A.type !== 31 && t.push(A);
  }), t.length && e.push(t), e;
}, CP = function(r, e) {
  return e === 11 && r.type === 12 || e === 28 && r.type === 29 ? !0 : e === 2 && r.type === 3;
}, Xs = function(r) {
  return r.type === 17 || r.type === 15;
}, sA = function(r) {
  return r.type === 16 || Xs(r);
}, H5 = function(r) {
  return r.length > 1 ? [r[0], r[1]] : [r[0]];
}, IA = {
  type: 17,
  number: 0,
  flags: Cu
}, bv = {
  type: 16,
  number: 50,
  flags: Cu
}, Gs = {
  type: 16,
  number: 100,
  flags: Cu
}, kl = function(r, e, t) {
  var A = r[0], n = r[1];
  return [pr(A, e), pr(typeof n < "u" ? n : A, t)];
}, pr = function(r, e) {
  if (r.type === 16)
    return r.number / 100 * e;
  if (Su(r))
    switch (r.unit) {
      case "rem":
      case "em":
        return 16 * r.number;
      default:
        return r.number;
    }
  return r.number;
}, D5 = "deg", G5 = "grad", V5 = "rad", K5 = "turn", Wh = {
  name: "angle",
  parse: function(r, e) {
    if (e.type === 15)
      switch (e.unit) {
        case D5:
          return Math.PI * e.number / 180;
        case G5:
          return Math.PI / 200 * e.number;
        case V5:
          return e.number;
        case K5:
          return Math.PI * 2 * e.number;
      }
    throw new Error("Unsupported angle type");
  }
}, j5 = function(r) {
  return r.type === 15 && (r.unit === D5 || r.unit === G5 || r.unit === V5 || r.unit === K5);
}, q5 = function(r) {
  var e = r.filter(ir).map(function(t) {
    return t.value;
  }).join(" ");
  switch (e) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [IA, IA];
    case "to top":
    case "bottom":
      return Rn(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [IA, Gs];
    case "to right":
    case "left":
      return Rn(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [Gs, Gs];
    case "to bottom":
    case "top":
      return Rn(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [Gs, IA];
    case "to left":
    case "right":
      return Rn(270);
  }
  return 0;
}, Rn = function(r) {
  return Math.PI * r / 180;
}, Ks = {
  name: "color",
  parse: function(r, e) {
    if (e.type === 18) {
      var t = SP[e.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
      return t(r, e.values);
    }
    if (e.type === 5) {
      if (e.value.length === 3) {
        var A = e.value.substring(0, 1), n = e.value.substring(1, 2), i = e.value.substring(2, 3);
        return Vs(parseInt(A + A, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (e.value.length === 4) {
        var A = e.value.substring(0, 1), n = e.value.substring(1, 2), i = e.value.substring(2, 3), s = e.value.substring(3, 4);
        return Vs(parseInt(A + A, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(s + s, 16) / 255);
      }
      if (e.value.length === 6) {
        var A = e.value.substring(0, 2), n = e.value.substring(2, 4), i = e.value.substring(4, 6);
        return Vs(parseInt(A, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (e.value.length === 8) {
        var A = e.value.substring(0, 2), n = e.value.substring(2, 4), i = e.value.substring(4, 6), s = e.value.substring(6, 8);
        return Vs(parseInt(A, 16), parseInt(n, 16), parseInt(i, 16), parseInt(s, 16) / 255);
      }
    }
    if (e.type === 20) {
      var a = is[e.value.toUpperCase()];
      if (typeof a < "u")
        return a;
    }
    return is.TRANSPARENT;
  }
}, js = function(r) {
  return (255 & r) === 0;
}, vA = function(r) {
  var e = 255 & r, t = 255 & r >> 8, A = 255 & r >> 16, n = 255 & r >> 24;
  return e < 255 ? "rgba(" + n + "," + A + "," + t + "," + e / 255 + ")" : "rgb(" + n + "," + A + "," + t + ")";
}, Vs = function(r, e, t, A) {
  return (r << 24 | e << 16 | t << 8 | Math.round(A * 255) << 0) >>> 0;
}, Wy = function(r, e) {
  if (r.type === 17)
    return r.number;
  if (r.type === 16) {
    var t = e === 3 ? 1 : 255;
    return e === 3 ? r.number / 100 * t : Math.round(r.number / 100 * t);
  }
  return 0;
}, Xy = function(r, e) {
  var t = e.filter(Mo);
  if (t.length === 3) {
    var A = t.map(Wy), n = A[0], i = A[1], s = A[2];
    return Vs(n, i, s, 1);
  }
  if (t.length === 4) {
    var a = t.map(Wy), n = a[0], i = a[1], s = a[2], o = a[3];
    return Vs(n, i, s, o);
  }
  return 0;
};
function Gd(r, e, t) {
  return t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (e - r) * t * 6 + r : t < 1 / 2 ? e : t < 2 / 3 ? (e - r) * 6 * (2 / 3 - t) + r : r;
}
var Yy = function(r, e) {
  var t = e.filter(Mo), A = t[0], n = t[1], i = t[2], s = t[3], a = (A.type === 17 ? Rn(A.number) : Wh.parse(r, A)) / (Math.PI * 2), o = sA(n) ? n.number / 100 : 0, l = sA(i) ? i.number / 100 : 0, u = typeof s < "u" && sA(s) ? pr(s, 1) : 1;
  if (o === 0)
    return Vs(l * 255, l * 255, l * 255, 1);
  var c = l <= 0.5 ? l * (o + 1) : l + o - l * o, f = l * 2 - c, h = Gd(f, c, a + 1 / 3), g = Gd(f, c, a), p = Gd(f, c, a - 1 / 3);
  return Vs(h * 255, g * 255, p * 255, u);
}, SP = {
  hsl: Yy,
  hsla: Yy,
  rgb: Xy,
  rgba: Xy
}, Yl = function(r, e) {
  return Ks.parse(r, R5.create(e).parseComponentValue());
}, is = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, xP = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.map(function(t) {
      if (ir(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, EP = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Xh = function(r, e) {
  var t = Ks.parse(r, e[0]), A = e[1];
  return A && sA(A) ? { color: t, stop: A } : { color: t, stop: null };
}, $y = function(r, e) {
  var t = r[0], A = r[r.length - 1];
  t.stop === null && (t.stop = IA), A.stop === null && (A.stop = Gs);
  for (var n = [], i = 0, s = 0; s < r.length; s++) {
    var a = r[s].stop;
    if (a !== null) {
      var o = pr(a, e);
      o > i ? n.push(o) : n.push(i), i = o;
    } else
      n.push(null);
  }
  for (var l = null, s = 0; s < n.length; s++) {
    var u = n[s];
    if (u === null)
      l === null && (l = s);
    else if (l !== null) {
      for (var c = s - l, f = n[l - 1], h = (u - f) / (c + 1), g = 1; g <= c; g++)
        n[l + g - 1] = h * g;
      l = null;
    }
  }
  return r.map(function(p, v) {
    var w = p.color;
    return { color: w, stop: Math.max(Math.min(1, n[v] / e), 0) };
  });
}, FP = function(r, e, t) {
  var A = e / 2, n = t / 2, i = pr(r[0], e) - A, s = n - pr(r[1], t);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, _P = function(r, e, t) {
  var A = typeof r == "number" ? r : FP(r, e, t), n = Math.abs(e * Math.sin(A)) + Math.abs(t * Math.cos(A)), i = e / 2, s = t / 2, a = n / 2, o = Math.sin(A - Math.PI / 2) * a, l = Math.cos(A - Math.PI / 2) * a;
  return [n, i - l, i + l, s - o, s + o];
}, ti = function(r, e) {
  return Math.sqrt(r * r + e * e);
}, Jy = function(r, e, t, A, n) {
  var i = [
    [0, 0],
    [0, e],
    [r, 0],
    [r, e]
  ];
  return i.reduce(function(s, a) {
    var o = a[0], l = a[1], u = ti(t - o, A - l);
    return (n ? u < s.optimumDistance : u > s.optimumDistance) ? {
      optimumCorner: a,
      optimumDistance: u
    } : s;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, UP = function(r, e, t, A, n) {
  var i = 0, s = 0;
  switch (r.size) {
    case 0:
      r.shape === 0 ? i = s = Math.min(Math.abs(e), Math.abs(e - A), Math.abs(t), Math.abs(t - n)) : r.shape === 1 && (i = Math.min(Math.abs(e), Math.abs(e - A)), s = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (r.shape === 0)
        i = s = Math.min(ti(e, t), ti(e, t - n), ti(e - A, t), ti(e - A, t - n));
      else if (r.shape === 1) {
        var a = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(e), Math.abs(e - A)), o = Jy(A, n, e, t, !0), l = o[0], u = o[1];
        i = ti(l - e, (u - t) / a), s = a * i;
      }
      break;
    case 1:
      r.shape === 0 ? i = s = Math.max(Math.abs(e), Math.abs(e - A), Math.abs(t), Math.abs(t - n)) : r.shape === 1 && (i = Math.max(Math.abs(e), Math.abs(e - A)), s = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (r.shape === 0)
        i = s = Math.max(ti(e, t), ti(e, t - n), ti(e - A, t), ti(e - A, t - n));
      else if (r.shape === 1) {
        var a = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(e), Math.abs(e - A)), c = Jy(A, n, e, t, !1), l = c[0], u = c[1];
        i = ti(l - e, (u - t) / a), s = a * i;
      }
      break;
  }
  return Array.isArray(r.size) && (i = pr(r.size[0], A), s = r.size.length === 2 ? pr(r.size[1], n) : i), [i, s];
}, IP = function(r, e) {
  var t = Rn(180), A = [];
  return _i(e).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && s.value === "to") {
        t = q5(n);
        return;
      } else if (j5(s)) {
        t = Wh.parse(r, s);
        return;
      }
    }
    var a = Xh(r, n);
    A.push(a);
  }), {
    angle: t,
    stops: A,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Gc = function(r, e) {
  var t = Rn(180), A = [];
  return _i(e).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        t = q5(n);
        return;
      } else if (j5(s)) {
        t = (Wh.parse(r, s) + Rn(270)) % Rn(360);
        return;
      }
    }
    var a = Xh(r, n);
    A.push(a);
  }), {
    angle: t,
    stops: A,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, QP = function(r, e) {
  var t = Rn(180), A = [], n = 1, i = 0, s = 3, a = [];
  return _i(e).forEach(function(o, l) {
    var u = o[0];
    if (l === 0) {
      if (ir(u) && u.value === "linear") {
        n = 1;
        return;
      } else if (ir(u) && u.value === "radial") {
        n = 2;
        return;
      }
    }
    if (u.type === 18) {
      if (u.name === "from") {
        var c = Ks.parse(r, u.values[0]);
        A.push({ stop: IA, color: c });
      } else if (u.name === "to") {
        var c = Ks.parse(r, u.values[0]);
        A.push({ stop: Gs, color: c });
      } else if (u.name === "color-stop") {
        var f = u.values.filter(Mo);
        if (f.length === 2) {
          var c = Ks.parse(r, f[1]), h = f[0];
          Go(h) && A.push({
            stop: { type: 16, number: h.number * 100, flags: h.flags },
            color: c
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + Rn(180)) % Rn(360),
    stops: A,
    type: n
  } : { size: s, shape: i, stops: A, position: a, type: n };
}, z5 = "closest-side", W5 = "farthest-side", X5 = "closest-corner", Y5 = "farthest-corner", $5 = "circle", J5 = "ellipse", Z5 = "cover", eE = "contain", LP = function(r, e) {
  var t = 0, A = 3, n = [], i = [];
  return _i(e).forEach(function(s, a) {
    var o = !0;
    if (a === 0) {
      var l = !1;
      o = s.reduce(function(c, f) {
        if (l)
          if (ir(f))
            switch (f.value) {
              case "center":
                return i.push(bv), c;
              case "top":
              case "left":
                return i.push(IA), c;
              case "right":
              case "bottom":
                return i.push(Gs), c;
            }
          else (sA(f) || Xs(f)) && i.push(f);
        else if (ir(f))
          switch (f.value) {
            case $5:
              return t = 0, !1;
            case J5:
              return t = 1, !1;
            case "at":
              return l = !0, !1;
            case z5:
              return A = 0, !1;
            case Z5:
            case W5:
              return A = 1, !1;
            case eE:
            case X5:
              return A = 2, !1;
            case Y5:
              return A = 3, !1;
          }
        else if (Xs(f) || sA(f))
          return Array.isArray(A) || (A = []), A.push(f), !1;
        return c;
      }, o);
    }
    if (o) {
      var u = Xh(r, s);
      n.push(u);
    }
  }), {
    size: A,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, Vc = function(r, e) {
  var t = 0, A = 3, n = [], i = [];
  return _i(e).forEach(function(s, a) {
    var o = !0;
    if (a === 0 ? o = s.reduce(function(u, c) {
      if (ir(c))
        switch (c.value) {
          case "center":
            return i.push(bv), !1;
          case "top":
          case "left":
            return i.push(IA), !1;
          case "right":
          case "bottom":
            return i.push(Gs), !1;
        }
      else if (sA(c) || Xs(c))
        return i.push(c), !1;
      return u;
    }, o) : a === 1 && (o = s.reduce(function(u, c) {
      if (ir(c))
        switch (c.value) {
          case $5:
            return t = 0, !1;
          case J5:
            return t = 1, !1;
          case eE:
          case z5:
            return A = 0, !1;
          case W5:
            return A = 1, !1;
          case X5:
            return A = 2, !1;
          case Z5:
          case Y5:
            return A = 3, !1;
        }
      else if (Xs(c) || sA(c))
        return Array.isArray(A) || (A = []), A.push(c), !1;
      return u;
    }, o)), o) {
      var l = Xh(r, s);
      n.push(l);
    }
  }), {
    size: A,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, NP = function(r) {
  return r.type === 1;
}, TP = function(r) {
  return r.type === 2;
}, Bv = {
  name: "image",
  parse: function(r, e) {
    if (e.type === 22) {
      var t = {
        url: e.value,
        type: 0
        /* URL */
      };
      return r.cache.addImage(e.value), t;
    }
    if (e.type === 18) {
      var A = tE[e.name];
      if (typeof A > "u")
        throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
      return A(r, e.values);
    }
    throw new Error("Unsupported image type " + e.type);
  }
};
function PP(r) {
  return !(r.type === 20 && r.value === "none") && (r.type !== 18 || !!tE[r.name]);
}
var tE = {
  "linear-gradient": IP,
  "-moz-linear-gradient": Gc,
  "-ms-linear-gradient": Gc,
  "-o-linear-gradient": Gc,
  "-webkit-linear-gradient": Gc,
  "radial-gradient": LP,
  "-moz-radial-gradient": Vc,
  "-ms-radial-gradient": Vc,
  "-o-radial-gradient": Vc,
  "-webkit-radial-gradient": Vc,
  "-webkit-gradient": QP
}, OP = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    var t = e[0];
    return t.type === 20 && t.value === "none" ? [] : e.filter(function(A) {
      return Mo(A) && PP(A);
    }).map(function(A) {
      return Bv.parse(r, A);
    });
  }
}, MP = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.map(function(t) {
      if (ir(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, RP = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return _i(e).map(function(t) {
      return t.filter(sA);
    }).map(H5);
  }
}, kP = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return _i(e).map(function(t) {
      return t.filter(ir).map(function(A) {
        return A.value;
      }).join(" ");
    }).map(HP);
  }
}, HP = function(r) {
  switch (r) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    default:
      return 0;
  }
}, No;
(function(r) {
  r.AUTO = "auto", r.CONTAIN = "contain", r.COVER = "cover";
})(No || (No = {}));
var DP = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return _i(e).map(function(t) {
      return t.filter(GP);
    });
  }
}, GP = function(r) {
  return ir(r) || sA(r);
}, Yh = function(r) {
  return {
    name: "border-" + r + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, VP = Yh("top"), KP = Yh("right"), jP = Yh("bottom"), qP = Yh("left"), $h = function(r) {
  return {
    name: "border-radius-" + r,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(e, t) {
      return H5(t.filter(sA));
    }
  };
}, zP = $h("top-left"), WP = $h("top-right"), XP = $h("bottom-right"), YP = $h("bottom-left"), Jh = function(r) {
  return {
    name: "border-" + r + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(e, t) {
      switch (t) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, $P = Jh("top"), JP = Jh("right"), ZP = Jh("bottom"), eO = Jh("left"), Zh = function(r) {
  return {
    name: "border-" + r + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(e, t) {
      return Su(t) ? t.number : 0;
    }
  };
}, tO = Zh("top"), rO = Zh("right"), AO = Zh("bottom"), nO = Zh("left"), iO = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, sO = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    return e === "rtl" ? 1 : 0;
  }
}, aO = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(ir).reduce(
      function(t, A) {
        return t | oO(A.value);
      },
      0
      /* NONE */
    );
  }
}, oO = function(r) {
  switch (r) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, lO = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, uO = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(r, e) {
    return e.type === 20 && e.value === "normal" ? 0 : e.type === 17 || e.type === 15 ? e.number : 0;
  }
}, Uh;
(function(r) {
  r.NORMAL = "normal", r.STRICT = "strict";
})(Uh || (Uh = {}));
var cO = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    return e === "strict" ? Uh.STRICT : Uh.NORMAL;
  }
}, hO = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Zy = function(r, e) {
  return ir(r) && r.value === "normal" ? 1.2 * e : r.type === 17 ? e * r.number : sA(r) ? pr(r, e) : e;
}, fO = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return e.type === 20 && e.value === "none" ? null : Bv.parse(r, e);
  }
}, dO = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    return e === "inside" ? 0 : 1;
  }
}, Fm = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      default:
        return -1;
    }
  }
}, ef = function(r) {
  return {
    name: "margin-" + r,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, gO = ef("top"), pO = ef("right"), mO = ef("bottom"), vO = ef("left"), wO = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(ir).map(function(t) {
      switch (t.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        default:
          return 0;
      }
    });
  }
}, yO = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    return e === "break-word" ? "break-word" : "normal";
  }
}, tf = function(r) {
  return {
    name: "padding-" + r,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, bO = tf("top"), BO = tf("right"), CO = tf("bottom"), SO = tf("left"), xO = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      default:
        return 0;
    }
  }
}, EO = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, FO = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.length === 1 && Em(e[0], "none") ? [] : _i(e).map(function(t) {
      for (var A = {
        color: is.TRANSPARENT,
        offsetX: IA,
        offsetY: IA,
        blur: IA
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        Xs(s) ? (n === 0 ? A.offsetX = s : n === 1 ? A.offsetY = s : A.blur = s, n++) : A.color = Ks.parse(r, s);
      }
      return A;
    });
  }
}, _O = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, UO = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(r, e) {
    if (e.type === 20 && e.value === "none")
      return null;
    if (e.type === 18) {
      var t = LO[e.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
      return t(e.values);
    }
    return null;
  }
}, IO = function(r) {
  var e = r.filter(function(t) {
    return t.type === 17;
  }).map(function(t) {
    return t.number;
  });
  return e.length === 6 ? e : null;
}, QO = function(r) {
  var e = r.filter(function(o) {
    return o.type === 17;
  }).map(function(o) {
    return o.number;
  }), t = e[0], A = e[1];
  e[2], e[3];
  var n = e[4], i = e[5];
  e[6], e[7], e[8], e[9], e[10], e[11];
  var s = e[12], a = e[13];
  return e[14], e[15], e.length === 16 ? [t, A, n, i, s, a] : null;
}, LO = {
  matrix: IO,
  matrix3d: QO
}, e2 = {
  type: 16,
  number: 50,
  flags: Cu
}, NO = [e2, e2], TO = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    var t = e.filter(sA);
    return t.length !== 2 ? NO : [t[0], t[1]];
  }
}, PO = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      default:
        return 0;
    }
  }
}, $l;
(function(r) {
  r.NORMAL = "normal", r.BREAK_ALL = "break-all", r.KEEP_ALL = "keep-all";
})($l || ($l = {}));
var OO = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "break-all":
        return $l.BREAK_ALL;
      case "keep-all":
        return $l.KEEP_ALL;
      default:
        return $l.NORMAL;
    }
  }
}, MO = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(r, e) {
    if (e.type === 20)
      return { auto: !0, order: 0 };
    if (Go(e))
      return { auto: !1, order: e.number };
    throw new Error("Invalid z-index number parsed");
  }
}, rE = {
  name: "time",
  parse: function(r, e) {
    if (e.type === 15)
      switch (e.unit.toLowerCase()) {
        case "s":
          return 1e3 * e.number;
        case "ms":
          return e.number;
      }
    throw new Error("Unsupported time type");
  }
}, RO = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return Go(e) ? e.number : 1;
  }
}, kO = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, HO = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(ir).map(function(t) {
      switch (t.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(t) {
      return t !== 0;
    });
  }
}, DO = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    var t = [], A = [];
    return e.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          t.push(n.value);
          break;
        case 17:
          t.push(n.number.toString());
          break;
        case 4:
          A.push(t.join(" ")), t.length = 0;
          break;
      }
    }), t.length && A.push(t.join(" ")), A.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, GO = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, VO = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return Go(e) ? e.number : ir(e) && e.value === "bold" ? 700 : 400;
  }
}, KO = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.filter(ir).map(function(t) {
      return t.value;
    });
  }
}, jO = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      default:
        return "normal";
    }
  }
}, gA = function(r, e) {
  return (r & e) !== 0;
}, qO = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    var t = e[0];
    return t.type === 20 && t.value === "none" ? [] : e;
  }
}, zO = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return null;
    var t = e[0];
    if (t.type === 20 && t.value === "none")
      return null;
    for (var A = [], n = e.filter(k5), i = 0; i < n.length; i++) {
      var s = n[i], a = n[i + 1];
      if (s.type === 20) {
        var o = a && Go(a) ? a.number : 1;
        A.push({ counter: s.value, increment: o });
      }
    }
    return A;
  }
}, WO = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    for (var t = [], A = e.filter(k5), n = 0; n < A.length; n++) {
      var i = A[n], s = A[n + 1];
      if (ir(i) && i.value !== "none") {
        var a = s && Go(s) ? s.number : 0;
        t.push({ counter: i.value, reset: a });
      }
    }
    return t;
  }
}, XO = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(Su).map(function(t) {
      return rE.parse(r, t);
    });
  }
}, YO = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return null;
    var t = e[0];
    if (t.type === 20 && t.value === "none")
      return null;
    var A = [], n = e.filter(BP);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var s = n[i].value, a = n[i + 1].value;
      A.push({ open: s, close: a });
    }
    return A;
  }
}, t2 = function(r, e, t) {
  if (!r)
    return "";
  var A = r[Math.min(e, r.length - 1)];
  return A ? t ? A.open : A.close : "";
}, $O = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.length === 1 && Em(e[0], "none") ? [] : _i(e).map(function(t) {
      for (var A = {
        color: 255,
        offsetX: IA,
        offsetY: IA,
        blur: IA,
        spread: IA,
        inset: !1
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        Em(s, "inset") ? A.inset = !0 : Xs(s) ? (n === 0 ? A.offsetX = s : n === 1 ? A.offsetY = s : n === 2 ? A.blur = s : A.spread = s, n++) : A.color = Ks.parse(r, s);
      }
      return A;
    });
  }
}, JO = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    var t = [
      0,
      1,
      2
      /* MARKERS */
    ], A = [];
    return e.filter(ir).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          A.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          A.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          A.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), t.forEach(function(n) {
      A.indexOf(n) === -1 && A.push(n);
    }), A;
  }
}, ZO = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, eM = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return Su(e) ? e.number : 0;
  }
}, tM = (
  /** @class */
  (function() {
    function r(e, t) {
      var A, n;
      this.animationDuration = Ye(e, XO, t.animationDuration), this.backgroundClip = Ye(e, xP, t.backgroundClip), this.backgroundColor = Ye(e, EP, t.backgroundColor), this.backgroundImage = Ye(e, OP, t.backgroundImage), this.backgroundOrigin = Ye(e, MP, t.backgroundOrigin), this.backgroundPosition = Ye(e, RP, t.backgroundPosition), this.backgroundRepeat = Ye(e, kP, t.backgroundRepeat), this.backgroundSize = Ye(e, DP, t.backgroundSize), this.borderTopColor = Ye(e, VP, t.borderTopColor), this.borderRightColor = Ye(e, KP, t.borderRightColor), this.borderBottomColor = Ye(e, jP, t.borderBottomColor), this.borderLeftColor = Ye(e, qP, t.borderLeftColor), this.borderTopLeftRadius = Ye(e, zP, t.borderTopLeftRadius), this.borderTopRightRadius = Ye(e, WP, t.borderTopRightRadius), this.borderBottomRightRadius = Ye(e, XP, t.borderBottomRightRadius), this.borderBottomLeftRadius = Ye(e, YP, t.borderBottomLeftRadius), this.borderTopStyle = Ye(e, $P, t.borderTopStyle), this.borderRightStyle = Ye(e, JP, t.borderRightStyle), this.borderBottomStyle = Ye(e, ZP, t.borderBottomStyle), this.borderLeftStyle = Ye(e, eO, t.borderLeftStyle), this.borderTopWidth = Ye(e, tO, t.borderTopWidth), this.borderRightWidth = Ye(e, rO, t.borderRightWidth), this.borderBottomWidth = Ye(e, AO, t.borderBottomWidth), this.borderLeftWidth = Ye(e, nO, t.borderLeftWidth), this.boxShadow = Ye(e, $O, t.boxShadow), this.color = Ye(e, iO, t.color), this.direction = Ye(e, sO, t.direction), this.display = Ye(e, aO, t.display), this.float = Ye(e, lO, t.cssFloat), this.fontFamily = Ye(e, DO, t.fontFamily), this.fontSize = Ye(e, GO, t.fontSize), this.fontStyle = Ye(e, jO, t.fontStyle), this.fontVariant = Ye(e, KO, t.fontVariant), this.fontWeight = Ye(e, VO, t.fontWeight), this.letterSpacing = Ye(e, uO, t.letterSpacing), this.lineBreak = Ye(e, cO, t.lineBreak), this.lineHeight = Ye(e, hO, t.lineHeight), this.listStyleImage = Ye(e, fO, t.listStyleImage), this.listStylePosition = Ye(e, dO, t.listStylePosition), this.listStyleType = Ye(e, Fm, t.listStyleType), this.marginTop = Ye(e, gO, t.marginTop), this.marginRight = Ye(e, pO, t.marginRight), this.marginBottom = Ye(e, mO, t.marginBottom), this.marginLeft = Ye(e, vO, t.marginLeft), this.opacity = Ye(e, RO, t.opacity);
      var i = Ye(e, wO, t.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = Ye(e, yO, t.overflowWrap), this.paddingTop = Ye(e, bO, t.paddingTop), this.paddingRight = Ye(e, BO, t.paddingRight), this.paddingBottom = Ye(e, CO, t.paddingBottom), this.paddingLeft = Ye(e, SO, t.paddingLeft), this.paintOrder = Ye(e, JO, t.paintOrder), this.position = Ye(e, EO, t.position), this.textAlign = Ye(e, xO, t.textAlign), this.textDecorationColor = Ye(e, kO, (A = t.textDecorationColor) !== null && A !== void 0 ? A : t.color), this.textDecorationLine = Ye(e, HO, (n = t.textDecorationLine) !== null && n !== void 0 ? n : t.textDecoration), this.textShadow = Ye(e, FO, t.textShadow), this.textTransform = Ye(e, _O, t.textTransform), this.transform = Ye(e, UO, t.transform), this.transformOrigin = Ye(e, TO, t.transformOrigin), this.visibility = Ye(e, PO, t.visibility), this.webkitTextStrokeColor = Ye(e, ZO, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = Ye(e, eM, t.webkitTextStrokeWidth), this.wordBreak = Ye(e, OO, t.wordBreak), this.zIndex = Ye(e, MO, t.zIndex);
    }
    return r.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, r.prototype.isTransparent = function() {
      return js(this.backgroundColor);
    }, r.prototype.isTransformed = function() {
      return this.transform !== null;
    }, r.prototype.isPositioned = function() {
      return this.position !== 0;
    }, r.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, r.prototype.isFloating = function() {
      return this.float !== 0;
    }, r.prototype.isInlineLevel = function() {
      return gA(
        this.display,
        4
        /* INLINE */
      ) || gA(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || gA(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || gA(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || gA(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || gA(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, r;
  })()
), rM = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.content = Ye(e, qO, t.content), this.quotes = Ye(e, YO, t.quotes);
    }
    return r;
  })()
), r2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.counterIncrement = Ye(e, zO, t.counterIncrement), this.counterReset = Ye(e, WO, t.counterReset);
    }
    return r;
  })()
), Ye = function(r, e, t) {
  var A = new M5(), n = t !== null && typeof t < "u" ? t.toString() : e.initialValue;
  A.write(n);
  var i = new R5(A.read());
  switch (e.type) {
    case 2:
      var s = i.parseComponentValue();
      return e.parse(r, ir(s) ? s.value : e.initialValue);
    case 0:
      return e.parse(r, i.parseComponentValue());
    case 1:
      return e.parse(r, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (e.format) {
        case "angle":
          return Wh.parse(r, i.parseComponentValue());
        case "color":
          return Ks.parse(r, i.parseComponentValue());
        case "image":
          return Bv.parse(r, i.parseComponentValue());
        case "length":
          var a = i.parseComponentValue();
          return Xs(a) ? a : IA;
        case "length-percentage":
          var o = i.parseComponentValue();
          return sA(o) ? o : IA;
        case "time":
          return rE.parse(r, i.parseComponentValue());
      }
      break;
  }
}, AM = "data-html2canvas-debug", nM = function(r) {
  var e = r.getAttribute(AM);
  switch (e) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, _m = function(r, e) {
  var t = nM(r);
  return t === 1 || e === t;
}, Ui = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      if (this.context = e, this.textNodes = [], this.elements = [], this.flags = 0, _m(
        t,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new tM(e, window.getComputedStyle(t, null)), Qm(t) && (this.styles.animationDuration.some(function(A) {
        return A > 0;
      }) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = qh(this.context, t), _m(
        t,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return r;
  })()
), iM = "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", A2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Hl = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Kc = 0; Kc < A2.length; Kc++)
  Hl[A2.charCodeAt(Kc)] = Kc;
var sM = function(r) {
  var e = r.length * 0.75, t = r.length, A, n = 0, i, s, a, o;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), u = Array.isArray(l) ? l : new Uint8Array(l);
  for (A = 0; A < t; A += 4)
    i = Hl[r.charCodeAt(A)], s = Hl[r.charCodeAt(A + 1)], a = Hl[r.charCodeAt(A + 2)], o = Hl[r.charCodeAt(A + 3)], u[n++] = i << 2 | s >> 4, u[n++] = (s & 15) << 4 | a >> 2, u[n++] = (a & 3) << 6 | o & 63;
  return l;
}, aM = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 2)
    t.push(r[A + 1] << 8 | r[A]);
  return t;
}, oM = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 4)
    t.push(r[A + 3] << 24 | r[A + 2] << 16 | r[A + 1] << 8 | r[A]);
  return t;
}, Oa = 5, Cv = 11, Vd = 2, lM = Cv - Oa, AE = 65536 >> Oa, uM = 1 << Oa, Kd = uM - 1, cM = 1024 >> Oa, hM = AE + cM, fM = hM, dM = 32, gM = fM + dM, pM = 65536 >> Cv, mM = 1 << lM, vM = mM - 1, n2 = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint16Array(Array.prototype.slice.call(r, e, t));
}, wM = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint32Array(Array.prototype.slice.call(r, e, t));
}, yM = function(r, e) {
  var t = sM(r), A = Array.isArray(t) ? oM(t) : new Uint32Array(t), n = Array.isArray(t) ? aM(t) : new Uint16Array(t), i = 24, s = n2(n, i / 2, A[4] / 2), a = A[5] === 2 ? n2(n, (i + A[4]) / 2) : wM(A, Math.ceil((i + A[4]) / 4));
  return new bM(A[0], A[1], A[2], A[3], s, a);
}, bM = (
  /** @class */
  (function() {
    function r(e, t, A, n, i, s) {
      this.initialValue = e, this.errorValue = t, this.highStart = A, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return r.prototype.get = function(e) {
      var t;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return t = this.index[e >> Oa], t = (t << Vd) + (e & Kd), this.data[t];
        if (e <= 65535)
          return t = this.index[AE + (e - 55296 >> Oa)], t = (t << Vd) + (e & Kd), this.data[t];
        if (e < this.highStart)
          return t = gM - pM + (e >> Cv), t = this.index[t], t += e >> Oa & vM, t = this.index[t], t = (t << Vd) + (e & Kd), this.data[t];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, r;
  })()
), i2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", BM = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var jc = 0; jc < i2.length; jc++)
  BM[i2.charCodeAt(jc)] = jc;
var CM = 1, jd = 2, qd = 3, s2 = 4, a2 = 5, SM = 7, o2 = 8, zd = 9, Wd = 10, l2 = 11, u2 = 12, c2 = 13, h2 = 14, Xd = 15, xM = function(r) {
  for (var e = [], t = 0, A = r.length; t < A; ) {
    var n = r.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < A) {
      var i = r.charCodeAt(t++);
      (i & 64512) === 56320 ? e.push(((n & 1023) << 10) + (i & 1023) + 65536) : (e.push(n), t--);
    } else
      e.push(n);
  }
  return e;
}, EM = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, r);
  var t = r.length;
  if (!t)
    return "";
  for (var A = [], n = -1, i = ""; ++n < t; ) {
    var s = r[n];
    s <= 65535 ? A.push(s) : (s -= 65536, A.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || A.length > 16384) && (i += String.fromCharCode.apply(String, A), A.length = 0);
  }
  return i;
}, FM = yM(iM), Tn = "×", Yd = "÷", _M = function(r) {
  return FM.get(r);
}, UM = function(r, e, t) {
  var A = t - 2, n = e[A], i = e[t - 1], s = e[t];
  if (i === jd && s === qd)
    return Tn;
  if (i === jd || i === qd || i === s2 || s === jd || s === qd || s === s2)
    return Yd;
  if (i === o2 && [o2, zd, l2, u2].indexOf(s) !== -1 || (i === l2 || i === zd) && (s === zd || s === Wd) || (i === u2 || i === Wd) && s === Wd || s === c2 || s === a2 || s === SM || i === CM)
    return Tn;
  if (i === c2 && s === h2) {
    for (; n === a2; )
      n = e[--A];
    if (n === h2)
      return Tn;
  }
  if (i === Xd && s === Xd) {
    for (var a = 0; n === Xd; )
      a++, n = e[--A];
    if (a % 2 === 0)
      return Tn;
  }
  return Yd;
}, IM = function(r) {
  var e = xM(r), t = e.length, A = 0, n = 0, i = e.map(_M);
  return {
    next: function() {
      if (A >= t)
        return { done: !0, value: null };
      for (var s = Tn; A < t && (s = UM(e, i, ++A)) === Tn; )
        ;
      if (s !== Tn || A === t) {
        var a = EM.apply(null, e.slice(n, A));
        return n = A, { value: a, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, QM = function(r) {
  for (var e = IM(r), t = [], A; !(A = e.next()).done; )
    A.value && t.push(A.value.slice());
  return t;
}, LM = function(r) {
  var e = 123;
  if (r.createRange) {
    var t = r.createRange();
    if (t.getBoundingClientRect) {
      var A = r.createElement("boundtest");
      A.style.height = e + "px", A.style.display = "block", r.body.appendChild(A), t.selectNode(A);
      var n = t.getBoundingClientRect(), i = Math.round(n.height);
      if (r.body.removeChild(A), i === e)
        return !0;
    }
  }
  return !1;
}, NM = function(r) {
  var e = r.createElement("boundtest");
  e.style.width = "50px", e.style.display = "block", e.style.fontSize = "12px", e.style.letterSpacing = "0px", e.style.wordSpacing = "0px", r.body.appendChild(e);
  var t = r.createRange();
  e.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var A = e.firstChild, n = zh(A.data).map(function(o) {
    return qr(o);
  }), i = 0, s = {}, a = n.every(function(o, l) {
    t.setStart(A, i), t.setEnd(A, i + o.length);
    var u = t.getBoundingClientRect();
    i += o.length;
    var c = u.x > s.x || u.y > s.y;
    return s = u, l === 0 ? !0 : c;
  });
  return r.body.removeChild(e), a;
}, TM = function() {
  return typeof new Image().crossOrigin < "u";
}, PM = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, OM = function(r) {
  var e = new Image(), t = r.createElement("canvas"), A = t.getContext("2d");
  if (!A)
    return !1;
  e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    A.drawImage(e, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, f2 = function(r) {
  return r[0] === 0 && r[1] === 255 && r[2] === 0 && r[3] === 255;
}, MM = function(r) {
  var e = r.createElement("canvas"), t = 100;
  e.width = t, e.height = t;
  var A = e.getContext("2d");
  if (!A)
    return Promise.reject(!1);
  A.fillStyle = "rgb(0, 255, 0)", A.fillRect(0, 0, t, t);
  var n = new Image(), i = e.toDataURL();
  n.src = i;
  var s = Um(t, t, 0, 0, n);
  return A.fillStyle = "red", A.fillRect(0, 0, t, t), d2(s).then(function(a) {
    A.drawImage(a, 0, 0);
    var o = A.getImageData(0, 0, t, t).data;
    A.fillStyle = "red", A.fillRect(0, 0, t, t);
    var l = r.createElement("div");
    return l.style.backgroundImage = "url(" + i + ")", l.style.height = t + "px", f2(o) ? d2(Um(t, t, 0, 0, l)) : Promise.reject(!1);
  }).then(function(a) {
    return A.drawImage(a, 0, 0), f2(A.getImageData(0, 0, t, t).data);
  }).catch(function() {
    return !1;
  });
}, Um = function(r, e, t, A, n) {
  var i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", r.toString()), s.setAttributeNS(null, "height", e.toString()), a.setAttributeNS(null, "width", "100%"), a.setAttributeNS(null, "height", "100%"), a.setAttributeNS(null, "x", t.toString()), a.setAttributeNS(null, "y", A.toString()), a.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(a), a.appendChild(n), s;
}, d2 = function(r) {
  return new Promise(function(e, t) {
    var A = new Image();
    A.onload = function() {
      return e(A);
    }, A.onerror = t, A.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(r));
  });
}, _A = {
  get SUPPORT_RANGE_BOUNDS() {
    var r = LM(document);
    return Object.defineProperty(_A, "SUPPORT_RANGE_BOUNDS", { value: r }), r;
  },
  get SUPPORT_WORD_BREAKING() {
    var r = _A.SUPPORT_RANGE_BOUNDS && NM(document);
    return Object.defineProperty(_A, "SUPPORT_WORD_BREAKING", { value: r }), r;
  },
  get SUPPORT_SVG_DRAWING() {
    var r = OM(document);
    return Object.defineProperty(_A, "SUPPORT_SVG_DRAWING", { value: r }), r;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var r = typeof Array.from == "function" && typeof window.fetch == "function" ? MM(document) : Promise.resolve(!1);
    return Object.defineProperty(_A, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: r }), r;
  },
  get SUPPORT_CORS_IMAGES() {
    var r = TM();
    return Object.defineProperty(_A, "SUPPORT_CORS_IMAGES", { value: r }), r;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var r = PM();
    return Object.defineProperty(_A, "SUPPORT_RESPONSE_TYPE", { value: r }), r;
  },
  get SUPPORT_CORS_XHR() {
    var r = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(_A, "SUPPORT_CORS_XHR", { value: r }), r;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var r = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(_A, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: r }), r;
  }
}, Jl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.text = e, this.bounds = t;
    }
    return r;
  })()
), RM = function(r, e, t, A) {
  var n = DM(e, t), i = [], s = 0;
  return n.forEach(function(a) {
    if (t.textDecorationLine.length || a.trim().length > 0)
      if (_A.SUPPORT_RANGE_BOUNDS) {
        var o = g2(A, s, a.length).getClientRects();
        if (o.length > 1) {
          var l = Sv(a), u = 0;
          l.forEach(function(f) {
            i.push(new Jl(f, ls.fromDOMRectList(r, g2(A, u + s, f.length).getClientRects()))), u += f.length;
          });
        } else
          i.push(new Jl(a, ls.fromDOMRectList(r, o)));
      } else {
        var c = A.splitText(a.length);
        i.push(new Jl(a, kM(r, A))), A = c;
      }
    else _A.SUPPORT_RANGE_BOUNDS || (A = A.splitText(a.length));
    s += a.length;
  }), i;
}, kM = function(r, e) {
  var t = e.ownerDocument;
  if (t) {
    var A = t.createElement("html2canvaswrapper");
    A.appendChild(e.cloneNode(!0));
    var n = e.parentNode;
    if (n) {
      n.replaceChild(A, e);
      var i = qh(r, A);
      return A.firstChild && n.replaceChild(A.firstChild, A), i;
    }
  }
  return ls.EMPTY;
}, g2 = function(r, e, t) {
  var A = r.ownerDocument;
  if (!A)
    throw new Error("Node has no owner document");
  var n = A.createRange();
  return n.setStart(r, e), n.setEnd(r, e + t), n;
}, Sv = function(r) {
  if (_A.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(e.segment(r)).map(function(t) {
      return t.segment;
    });
  }
  return QM(r);
}, HM = function(r, e) {
  if (_A.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var t = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(t.segment(r)).map(function(A) {
      return A.segment;
    });
  }
  return VM(r, e);
}, DM = function(r, e) {
  return e.letterSpacing !== 0 ? Sv(r) : HM(r, e);
}, GM = [32, 160, 4961, 65792, 65793, 4153, 4241], VM = function(r, e) {
  for (var t = pT(r, {
    lineBreak: e.lineBreak,
    wordBreak: e.overflowWrap === "break-word" ? "break-word" : e.wordBreak
  }), A = [], n, i = function() {
    if (n.value) {
      var s = n.value.slice(), a = zh(s), o = "";
      a.forEach(function(l) {
        GM.indexOf(l) === -1 ? o += qr(l) : (o.length && A.push(o), A.push(qr(l)), o = "");
      }), o.length && A.push(o);
    }
  }; !(n = t.next()).done; )
    i();
  return A;
}, KM = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t, A) {
      this.text = jM(t.data, A.textTransform), this.textBounds = RM(e, this.text, A, t);
    }
    return r;
  })()
), jM = function(r, e) {
  switch (e) {
    case 1:
      return r.toLowerCase();
    case 3:
      return r.replace(qM, zM);
    case 2:
      return r.toUpperCase();
    default:
      return r;
  }
}, qM = /(^|\s|:|-|\(|\))([a-z])/g, zM = function(r, e, t) {
  return r.length > 0 ? e + t.toUpperCase() : r;
}, nE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.src = A.currentSrc || A.src, n.intrinsicWidth = A.naturalWidth, n.intrinsicHeight = A.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return e;
  })(Ui)
), iE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.canvas = A, n.intrinsicWidth = A.width, n.intrinsicHeight = A.height, n;
    }
    return e;
  })(Ui)
), sE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this, i = new XMLSerializer(), s = qh(t, A);
      return A.setAttribute("width", s.width + "px"), A.setAttribute("height", s.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(A)), n.intrinsicWidth = A.width.baseVal.value, n.intrinsicHeight = A.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return e;
  })(Ui)
), aE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.value = A.value, n;
    }
    return e;
  })(Ui)
), Im = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.start = A.start, n.reversed = typeof A.reversed == "boolean" && A.reversed === !0, n;
    }
    return e;
  })(Ui)
), WM = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], XM = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], YM = function(r) {
  return r.width > r.height ? new ls(r.left + (r.width - r.height) / 2, r.top, r.height, r.height) : r.width < r.height ? new ls(r.left, r.top + (r.height - r.width) / 2, r.width, r.width) : r;
}, $M = function(r) {
  var e = r.type === JM ? new Array(r.value.length + 1).join("•") : r.value;
  return e.length === 0 ? r.placeholder || "" : e;
}, Ih = "checkbox", Qh = "radio", JM = "password", p2 = 707406591, xv = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      switch (n.type = A.type.toLowerCase(), n.checked = A.checked, n.value = $M(A), (n.type === Ih || n.type === Qh) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = YM(n.bounds)), n.type) {
        case Ih:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = WM;
          break;
        case Qh:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = XM;
          break;
      }
      return n;
    }
    return e;
  })(Ui)
), oE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this, i = A.options[A.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return e;
  })(Ui)
), lE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.value = A.value, n;
    }
    return e;
  })(Ui)
), uE = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      n.src = A.src, n.width = parseInt(A.width, 10) || 0, n.height = parseInt(A.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (A.contentWindow && A.contentWindow.document && A.contentWindow.document.documentElement) {
          n.tree = hE(t, A.contentWindow.document.documentElement);
          var i = A.contentWindow.document.documentElement ? Yl(t, getComputedStyle(A.contentWindow.document.documentElement).backgroundColor) : is.TRANSPARENT, s = A.contentWindow.document.body ? Yl(t, getComputedStyle(A.contentWindow.document.body).backgroundColor) : is.TRANSPARENT;
          n.backgroundColor = js(i) ? js(s) ? n.styles.backgroundColor : s : i;
        }
      } catch {
      }
      return n;
    }
    return e;
  })(Ui)
), ZM = ["OL", "UL", "MENU"], hh = function(r, e, t, A) {
  for (var n = e.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, fE(n) && n.data.trim().length > 0)
      t.textNodes.push(new KM(r, n, t.styles));
    else if (Fo(n))
      if (mE(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(a) {
          return hh(r, a, t, A);
        });
      else {
        var s = cE(r, n);
        s.styles.isVisible() && (eR(n, s, A) ? s.flags |= 4 : tR(s.styles) && (s.flags |= 2), ZM.indexOf(n.tagName) !== -1 && (s.flags |= 8), t.elements.push(s), n.slot, n.shadowRoot ? hh(r, n.shadowRoot, s, A) : !Lh(n) && !dE(n) && !Nh(n) && hh(r, n, s, A));
      }
}, cE = function(r, e) {
  return Lm(e) ? new nE(r, e) : gE(e) ? new iE(r, e) : dE(e) ? new sE(r, e) : rR(e) ? new aE(r, e) : AR(e) ? new Im(r, e) : nR(e) ? new xv(r, e) : Nh(e) ? new oE(r, e) : Lh(e) ? new lE(r, e) : pE(e) ? new uE(r, e) : new Ui(r, e);
}, hE = function(r, e) {
  var t = cE(r, e);
  return t.flags |= 4, hh(r, e, t, t), t;
}, eR = function(r, e, t) {
  return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || Ev(r) && t.styles.isTransparent();
}, tR = function(r) {
  return r.isPositioned() || r.isFloating();
}, fE = function(r) {
  return r.nodeType === Node.TEXT_NODE;
}, Fo = function(r) {
  return r.nodeType === Node.ELEMENT_NODE;
}, Qm = function(r) {
  return Fo(r) && typeof r.style < "u" && !fh(r);
}, fh = function(r) {
  return typeof r.className == "object";
}, rR = function(r) {
  return r.tagName === "LI";
}, AR = function(r) {
  return r.tagName === "OL";
}, nR = function(r) {
  return r.tagName === "INPUT";
}, iR = function(r) {
  return r.tagName === "HTML";
}, dE = function(r) {
  return r.tagName === "svg";
}, Ev = function(r) {
  return r.tagName === "BODY";
}, gE = function(r) {
  return r.tagName === "CANVAS";
}, m2 = function(r) {
  return r.tagName === "VIDEO";
}, Lm = function(r) {
  return r.tagName === "IMG";
}, pE = function(r) {
  return r.tagName === "IFRAME";
}, v2 = function(r) {
  return r.tagName === "STYLE";
}, sR = function(r) {
  return r.tagName === "SCRIPT";
}, Lh = function(r) {
  return r.tagName === "TEXTAREA";
}, Nh = function(r) {
  return r.tagName === "SELECT";
}, mE = function(r) {
  return r.tagName === "SLOT";
}, w2 = function(r) {
  return r.tagName.indexOf("-") > 0;
}, aR = (
  /** @class */
  (function() {
    function r() {
      this.counters = {};
    }
    return r.prototype.getCounterValue = function(e) {
      var t = this.counters[e];
      return t && t.length ? t[t.length - 1] : 1;
    }, r.prototype.getCounterValues = function(e) {
      var t = this.counters[e];
      return t || [];
    }, r.prototype.pop = function(e) {
      var t = this;
      e.forEach(function(A) {
        return t.counters[A].pop();
      });
    }, r.prototype.parse = function(e) {
      var t = this, A = e.counterIncrement, n = e.counterReset, i = !0;
      A !== null && A.forEach(function(a) {
        var o = t.counters[a.counter];
        o && a.increment !== 0 && (i = !1, o.length || o.push(1), o[Math.max(0, o.length - 1)] += a.increment);
      });
      var s = [];
      return i && n.forEach(function(a) {
        var o = t.counters[a.counter];
        s.push(a.counter), o || (o = t.counters[a.counter] = []), o.push(a.reset);
      }), s;
    }, r;
  })()
), y2 = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, b2 = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, oR = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, lR = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, go = function(r, e, t, A, n, i) {
  return r < e || r > t ? ou(r, n, i.length > 0) : A.integers.reduce(function(s, a, o) {
    for (; r >= a; )
      r -= a, s += A.values[o];
    return s;
  }, "") + i;
}, vE = function(r, e, t, A) {
  var n = "";
  do
    t || r--, n = A(r) + n, r /= e;
  while (r * e >= e);
  return n;
}, Kr = function(r, e, t, A, n) {
  var i = t - e + 1;
  return (r < 0 ? "-" : "") + (vE(Math.abs(r), i, A, function(s) {
    return qr(Math.floor(s % i) + e);
  }) + n);
}, ya = function(r, e, t) {
  t === void 0 && (t = ". ");
  var A = e.length;
  return vE(Math.abs(r), A, !1, function(n) {
    return e[Math.floor(n % A)];
  }) + t;
}, Bo = 1, Ts = 2, Ps = 4, Dl = 8, Ji = function(r, e, t, A, n, i) {
  if (r < -9999 || r > 9999)
    return ou(r, 4, n.length > 0);
  var s = Math.abs(r), a = n;
  if (s === 0)
    return e[0] + a;
  for (var o = 0; s > 0 && o <= 4; o++) {
    var l = s % 10;
    l === 0 && gA(i, Bo) && a !== "" ? a = e[l] + a : l > 1 || l === 1 && o === 0 || l === 1 && o === 1 && gA(i, Ts) || l === 1 && o === 1 && gA(i, Ps) && r > 100 || l === 1 && o > 1 && gA(i, Dl) ? a = e[l] + (o > 0 ? t[o - 1] : "") + a : l === 1 && o > 0 && (a = t[o - 1] + a), s = Math.floor(s / 10);
  }
  return (r < 0 ? A : "") + a;
}, B2 = "十百千萬", C2 = "拾佰仟萬", S2 = "マイナス", $d = "마이너스", ou = function(r, e, t) {
  var A = t ? ". " : "", n = t ? "、" : "", i = t ? ", " : "", s = t ? " " : "";
  switch (e) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var a = Kr(r, 48, 57, !0, A);
      return a.length < 4 ? "0" + a : a;
    case 4:
      return ya(r, "〇一二三四五六七八九", n);
    case 6:
      return go(r, 1, 3999, y2, 3, A).toLowerCase();
    case 7:
      return go(r, 1, 3999, y2, 3, A);
    case 8:
      return Kr(r, 945, 969, !1, A);
    case 9:
      return Kr(r, 97, 122, !1, A);
    case 10:
      return Kr(r, 65, 90, !1, A);
    case 11:
      return Kr(r, 1632, 1641, !0, A);
    case 12:
    case 49:
      return go(r, 1, 9999, b2, 3, A);
    case 35:
      return go(r, 1, 9999, b2, 3, A).toLowerCase();
    case 13:
      return Kr(r, 2534, 2543, !0, A);
    case 14:
    case 30:
      return Kr(r, 6112, 6121, !0, A);
    case 15:
      return ya(r, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return ya(r, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return Ji(r, "零一二三四五六七八九", B2, "負", n, Ts | Ps | Dl);
    case 47:
      return Ji(r, "零壹貳參肆伍陸柒捌玖", C2, "負", n, Bo | Ts | Ps | Dl);
    case 42:
      return Ji(r, "零一二三四五六七八九", B2, "负", n, Ts | Ps | Dl);
    case 41:
      return Ji(r, "零壹贰叁肆伍陆柒捌玖", C2, "负", n, Bo | Ts | Ps | Dl);
    case 26:
      return Ji(r, "〇一二三四五六七八九", "十百千万", S2, n, 0);
    case 25:
      return Ji(r, "零壱弐参四伍六七八九", "拾百千万", S2, n, Bo | Ts | Ps);
    case 31:
      return Ji(r, "영일이삼사오육칠팔구", "십백천만", $d, i, Bo | Ts | Ps);
    case 33:
      return Ji(r, "零一二三四五六七八九", "十百千萬", $d, i, 0);
    case 32:
      return Ji(r, "零壹貳參四五六七八九", "拾百千", $d, i, Bo | Ts | Ps);
    case 18:
      return Kr(r, 2406, 2415, !0, A);
    case 20:
      return go(r, 1, 19999, lR, 3, A);
    case 21:
      return Kr(r, 2790, 2799, !0, A);
    case 22:
      return Kr(r, 2662, 2671, !0, A);
    case 22:
      return go(r, 1, 10999, oR, 3, A);
    case 23:
      return ya(r, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return ya(r, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Kr(r, 3302, 3311, !0, A);
    case 28:
      return ya(r, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return ya(r, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return Kr(r, 3792, 3801, !0, A);
    case 37:
      return Kr(r, 6160, 6169, !0, A);
    case 38:
      return Kr(r, 4160, 4169, !0, A);
    case 39:
      return Kr(r, 2918, 2927, !0, A);
    case 40:
      return Kr(r, 1776, 1785, !0, A);
    case 43:
      return Kr(r, 3046, 3055, !0, A);
    case 44:
      return Kr(r, 3174, 3183, !0, A);
    case 45:
      return Kr(r, 3664, 3673, !0, A);
    case 46:
      return Kr(r, 3872, 3881, !0, A);
    default:
      return Kr(r, 48, 57, !0, A);
  }
}, wE = "data-html2canvas-ignore", x2 = (
  /** @class */
  (function() {
    function r(e, t, A) {
      if (this.context = e, this.options = A, this.scrolledElements = [], this.referenceElement = t, this.counters = new aR(), this.quoteDepth = 0, !t.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
    }
    return r.prototype.toIFrame = function(e, t) {
      var A = this, n = uR(e, t);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = e.defaultView.pageXOffset, s = e.defaultView.pageYOffset, a = n.contentWindow, o = a.document, l = fR(n).then(function() {
        return WA(A, void 0, void 0, function() {
          var u, c;
          return MA(this, function(f) {
            switch (f.label) {
              case 0:
                return this.scrolledElements.forEach(mR), a && (a.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (a.scrollY !== t.top || a.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(a.scrollX - t.left, a.scrollY - t.top, 0, 0))), u = this.options.onclone, c = this.clonedReferenceElement, typeof c > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, hR(o)] : [3, 4];
              case 3:
                f.sent(), f.label = 4;
              case 4:
                return typeof u == "function" ? [2, Promise.resolve().then(function() {
                  return u(o, c);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return o.open(), o.write(gR(document.doctype) + "<html></html>"), pR(this.referenceElement.ownerDocument, i, s), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), l;
    }, r.prototype.createElementClone = function(e) {
      if (_m(
        e,
        2
        /* CLONE */
      ))
        debugger;
      if (gE(e))
        return this.createCanvasClone(e);
      if (m2(e))
        return this.createVideoClone(e);
      if (v2(e))
        return this.createStyleClone(e);
      var t = e.cloneNode(!1);
      return Lm(t) && (Lm(e) && e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), w2(t) ? this.createCustomElementClone(t) : t;
    }, r.prototype.createCustomElementClone = function(e) {
      var t = document.createElement("html2canvascustomelement");
      return Jd(e.style, t), t;
    }, r.prototype.createStyleClone = function(e) {
      try {
        var t = e.sheet;
        if (t && t.cssRules) {
          var A = [].slice.call(t.cssRules, 0).reduce(function(i, s) {
            return s && typeof s.cssText == "string" ? i + s.cssText : i;
          }, ""), n = e.cloneNode(!1);
          return n.textContent = A, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return e.cloneNode(!1);
    }, r.prototype.createCanvasClone = function(e) {
      var t;
      if (this.options.inlineImages && e.ownerDocument) {
        var A = e.ownerDocument.createElement("img");
        try {
          return A.src = e.toDataURL(), A;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
        }
      }
      var n = e.cloneNode(!1);
      try {
        n.width = e.width, n.height = e.height;
        var i = e.getContext("2d"), s = n.getContext("2d");
        if (s)
          if (!this.options.allowTaint && i)
            s.putImageData(i.getImageData(0, 0, e.width, e.height), 0, 0);
          else {
            var a = (t = e.getContext("webgl2")) !== null && t !== void 0 ? t : e.getContext("webgl");
            if (a) {
              var o = a.getContextAttributes();
              o?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e);
            }
            s.drawImage(e, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", e);
      }
      return n;
    }, r.prototype.createVideoClone = function(e) {
      var t = e.ownerDocument.createElement("canvas");
      t.width = e.offsetWidth, t.height = e.offsetHeight;
      var A = t.getContext("2d");
      try {
        return A && (A.drawImage(e, 0, 0, t.width, t.height), this.options.allowTaint || A.getImageData(0, 0, t.width, t.height)), t;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", e);
      }
      var n = e.ownerDocument.createElement("canvas");
      return n.width = e.offsetWidth, n.height = e.offsetHeight, n;
    }, r.prototype.appendChildNode = function(e, t, A) {
      (!Fo(t) || !sR(t) && !t.hasAttribute(wE) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !Fo(t) || !v2(t)) && e.appendChild(this.cloneNode(t, A));
    }, r.prototype.cloneChildNodes = function(e, t, A) {
      for (var n = this, i = e.shadowRoot ? e.shadowRoot.firstChild : e.firstChild; i; i = i.nextSibling)
        if (Fo(i) && mE(i) && typeof i.assignedNodes == "function") {
          var s = i.assignedNodes();
          s.length && s.forEach(function(a) {
            return n.appendChildNode(t, a, A);
          });
        } else
          this.appendChildNode(t, i, A);
    }, r.prototype.cloneNode = function(e, t) {
      if (fE(e))
        return document.createTextNode(e.data);
      if (!e.ownerDocument)
        return e.cloneNode(!1);
      var A = e.ownerDocument.defaultView;
      if (A && Fo(e) && (Qm(e) || fh(e))) {
        var n = this.createElementClone(e);
        n.style.transitionProperty = "none";
        var i = A.getComputedStyle(e), s = A.getComputedStyle(e, ":before"), a = A.getComputedStyle(e, ":after");
        this.referenceElement === e && Qm(n) && (this.clonedReferenceElement = n), Ev(n) && yR(n);
        var o = this.counters.parse(new r2(this.context, i)), l = this.resolvePseudoContent(e, n, s, Zl.BEFORE);
        w2(e) && (t = !0), m2(e) || this.cloneChildNodes(e, n, t), l && n.insertBefore(l, n.firstChild);
        var u = this.resolvePseudoContent(e, n, a, Zl.AFTER);
        return u && n.appendChild(u), this.counters.pop(o), (i && (this.options.copyStyles || fh(e)) && !pE(e) || t) && Jd(i, n), (e.scrollTop !== 0 || e.scrollLeft !== 0) && this.scrolledElements.push([n, e.scrollLeft, e.scrollTop]), (Lh(e) || Nh(e)) && (Lh(n) || Nh(n)) && (n.value = e.value), n;
      }
      return e.cloneNode(!1);
    }, r.prototype.resolvePseudoContent = function(e, t, A, n) {
      var i = this;
      if (A) {
        var s = A.content, a = t.ownerDocument;
        if (!(!a || !s || s === "none" || s === "-moz-alt-content" || A.display === "none")) {
          this.counters.parse(new r2(this.context, A));
          var o = new rM(this.context, A), l = a.createElement("html2canvaspseudoelement");
          Jd(A, l), o.content.forEach(function(c) {
            if (c.type === 0)
              l.appendChild(a.createTextNode(c.value));
            else if (c.type === 22) {
              var f = a.createElement("img");
              f.src = c.value, f.style.opacity = "1", l.appendChild(f);
            } else if (c.type === 18) {
              if (c.name === "attr") {
                var h = c.values.filter(ir);
                h.length && l.appendChild(a.createTextNode(e.getAttribute(h[0].value) || ""));
              } else if (c.name === "counter") {
                var g = c.values.filter(Mo), p = g[0], v = g[1];
                if (p && ir(p)) {
                  var w = i.counters.getCounterValue(p.value), b = v && ir(v) ? Fm.parse(i.context, v.value) : 3;
                  l.appendChild(a.createTextNode(ou(w, b, !1)));
                }
              } else if (c.name === "counters") {
                var S = c.values.filter(Mo), p = S[0], B = S[1], v = S[2];
                if (p && ir(p)) {
                  var x = i.counters.getCounterValues(p.value), U = v && ir(v) ? Fm.parse(i.context, v.value) : 3, Q = B && B.type === 0 ? B.value : "", N = x.map(function(F) {
                    return ou(F, U, !1);
                  }).join(Q);
                  l.appendChild(a.createTextNode(N));
                }
              }
            } else if (c.type === 20)
              switch (c.value) {
                case "open-quote":
                  l.appendChild(a.createTextNode(t2(o.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  l.appendChild(a.createTextNode(t2(o.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  l.appendChild(a.createTextNode(c.value));
              }
          }), l.className = Nm + " " + Tm;
          var u = n === Zl.BEFORE ? " " + Nm : " " + Tm;
          return fh(t) ? t.className.baseValue += u : t.className += u, l;
        }
      }
    }, r.destroy = function(e) {
      return e.parentNode ? (e.parentNode.removeChild(e), !0) : !1;
    }, r;
  })()
), Zl;
(function(r) {
  r[r.BEFORE = 0] = "BEFORE", r[r.AFTER = 1] = "AFTER";
})(Zl || (Zl = {}));
var uR = function(r, e) {
  var t = r.createElement("iframe");
  return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = e.width.toString(), t.height = e.height.toString(), t.scrolling = "no", t.setAttribute(wE, "true"), r.body.appendChild(t), t;
}, cR = function(r) {
  return new Promise(function(e) {
    if (r.complete) {
      e();
      return;
    }
    if (!r.src) {
      e();
      return;
    }
    r.onload = e, r.onerror = e;
  });
}, hR = function(r) {
  return Promise.all([].slice.call(r.images, 0).map(cR));
}, fR = function(r) {
  return new Promise(function(e, t) {
    var A = r.contentWindow;
    if (!A)
      return t("No window assigned for iframe");
    var n = A.document;
    A.onload = r.onload = function() {
      A.onload = r.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), e(r));
      }, 50);
    };
  });
}, dR = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Jd = function(r, e) {
  for (var t = r.length - 1; t >= 0; t--) {
    var A = r.item(t);
    dR.indexOf(A) === -1 && e.style.setProperty(A, r.getPropertyValue(A));
  }
  return e;
}, gR = function(r) {
  var e = "";
  return r && (e += "<!DOCTYPE ", r.name && (e += r.name), r.internalSubset && (e += r.internalSubset), r.publicId && (e += '"' + r.publicId + '"'), r.systemId && (e += '"' + r.systemId + '"'), e += ">"), e;
}, pR = function(r, e, t) {
  r && r.defaultView && (e !== r.defaultView.pageXOffset || t !== r.defaultView.pageYOffset) && r.defaultView.scrollTo(e, t);
}, mR = function(r) {
  var e = r[0], t = r[1], A = r[2];
  e.scrollLeft = t, e.scrollTop = A;
}, vR = ":before", wR = ":after", Nm = "___html2canvas___pseudoelement_before", Tm = "___html2canvas___pseudoelement_after", E2 = `{
    content: "" !important;
    display: none !important;
}`, yR = function(r) {
  bR(r, "." + Nm + vR + E2 + `
         .` + Tm + wR + E2);
}, bR = function(r, e) {
  var t = r.ownerDocument;
  if (t) {
    var A = t.createElement("style");
    A.textContent = e, r.appendChild(A);
  }
}, yE = (
  /** @class */
  (function() {
    function r() {
    }
    return r.getOrigin = function(e) {
      var t = r._link;
      return t ? (t.href = e, t.href = t.href, t.protocol + t.hostname + t.port) : "about:blank";
    }, r.isSameOrigin = function(e) {
      return r.getOrigin(e) === r._origin;
    }, r.setContext = function(e) {
      r._link = e.document.createElement("a"), r._origin = r.getOrigin(e.location.href);
    }, r._origin = "about:blank", r;
  })()
), BR = (
  /** @class */
  (function() {
    function r(e, t) {
      this.context = e, this._options = t, this._cache = {};
    }
    return r.prototype.addImage = function(e) {
      var t = Promise.resolve();
      return this.has(e) || (eg(e) || ER(e)) && (this._cache[e] = this.loadImage(e)).catch(function() {
      }), t;
    }, r.prototype.match = function(e) {
      return this._cache[e];
    }, r.prototype.loadImage = function(e) {
      return WA(this, void 0, void 0, function() {
        var t, A, n, i, s = this;
        return MA(this, function(a) {
          switch (a.label) {
            case 0:
              return t = yE.isSameOrigin(e), A = !Zd(e) && this._options.useCORS === !0 && _A.SUPPORT_CORS_IMAGES && !t, n = !Zd(e) && !t && !eg(e) && typeof this._options.proxy == "string" && _A.SUPPORT_CORS_XHR && !A, !t && this._options.allowTaint === !1 && !Zd(e) && !eg(e) && !n && !A ? [
                2
                /*return*/
              ] : (i = e, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + e.substring(0, 256)), [4, new Promise(function(o, l) {
                var u = new Image();
                u.onload = function() {
                  return o(u);
                }, u.onerror = l, (FR(i) || A) && (u.crossOrigin = "anonymous"), u.src = i, u.complete === !0 && setTimeout(function() {
                  return o(u);
                }, 500), s._options.imageTimeout > 0 && setTimeout(function() {
                  return l("Timed out (" + s._options.imageTimeout + "ms) loading image");
                }, s._options.imageTimeout);
              })];
            case 3:
              return [2, a.sent()];
          }
        });
      });
    }, r.prototype.has = function(e) {
      return typeof this._cache[e] < "u";
    }, r.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, r.prototype.proxy = function(e) {
      var t = this, A = this._options.proxy;
      if (!A)
        throw new Error("No proxy defined");
      var n = e.substring(0, 256);
      return new Promise(function(i, s) {
        var a = _A.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = new XMLHttpRequest();
        o.onload = function() {
          if (o.status === 200)
            if (a === "text")
              i(o.response);
            else {
              var c = new FileReader();
              c.addEventListener("load", function() {
                return i(c.result);
              }, !1), c.addEventListener("error", function(f) {
                return s(f);
              }, !1), c.readAsDataURL(o.response);
            }
          else
            s("Failed to proxy resource " + n + " with status code " + o.status);
        }, o.onerror = s;
        var l = A.indexOf("?") > -1 ? "&" : "?";
        if (o.open("GET", "" + A + l + "url=" + encodeURIComponent(e) + "&responseType=" + a), a !== "text" && o instanceof XMLHttpRequest && (o.responseType = a), t._options.imageTimeout) {
          var u = t._options.imageTimeout;
          o.timeout = u, o.ontimeout = function() {
            return s("Timed out (" + u + "ms) proxying " + n);
          };
        }
        o.send();
      });
    }, r;
  })()
), CR = /^data:image\/svg\+xml/i, SR = /^data:image\/.*;base64,/i, xR = /^data:image\/.*/i, ER = function(r) {
  return _A.SUPPORT_SVG_DRAWING || !_R(r);
}, Zd = function(r) {
  return xR.test(r);
}, FR = function(r) {
  return SR.test(r);
}, eg = function(r) {
  return r.substr(0, 4) === "blob";
}, _R = function(r) {
  return r.substr(-3).toLowerCase() === "svg" || CR.test(r);
}, qe = (
  /** @class */
  (function() {
    function r(e, t) {
      this.type = 0, this.x = e, this.y = t;
    }
    return r.prototype.add = function(e, t) {
      return new r(this.x + e, this.y + t);
    }, r;
  })()
), po = function(r, e, t) {
  return new qe(r.x + (e.x - r.x) * t, r.y + (e.y - r.y) * t);
}, qc = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.type = 1, this.start = e, this.startControl = t, this.endControl = A, this.end = n;
    }
    return r.prototype.subdivide = function(e, t) {
      var A = po(this.start, this.startControl, e), n = po(this.startControl, this.endControl, e), i = po(this.endControl, this.end, e), s = po(A, n, e), a = po(n, i, e), o = po(s, a, e);
      return t ? new r(this.start, A, s, o) : new r(o, a, i, this.end);
    }, r.prototype.add = function(e, t) {
      return new r(this.start.add(e, t), this.startControl.add(e, t), this.endControl.add(e, t), this.end.add(e, t));
    }, r.prototype.reverse = function() {
      return new r(this.end, this.endControl, this.startControl, this.start);
    }, r;
  })()
), Pn = function(r) {
  return r.type === 1;
}, UR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      var t = e.styles, A = e.bounds, n = kl(t.borderTopLeftRadius, A.width, A.height), i = n[0], s = n[1], a = kl(t.borderTopRightRadius, A.width, A.height), o = a[0], l = a[1], u = kl(t.borderBottomRightRadius, A.width, A.height), c = u[0], f = u[1], h = kl(t.borderBottomLeftRadius, A.width, A.height), g = h[0], p = h[1], v = [];
      v.push((i + o) / A.width), v.push((g + c) / A.width), v.push((s + p) / A.height), v.push((l + f) / A.height);
      var w = Math.max.apply(Math, v);
      w > 1 && (i /= w, s /= w, o /= w, l /= w, c /= w, f /= w, g /= w, p /= w);
      var b = A.width - o, S = A.height - f, B = A.width - c, x = A.height - p, U = t.borderTopWidth, Q = t.borderRightWidth, N = t.borderBottomWidth, _ = t.borderLeftWidth, R = pr(t.paddingTop, e.bounds.width), F = pr(t.paddingRight, e.bounds.width), O = pr(t.paddingBottom, e.bounds.width), G = pr(t.paddingLeft, e.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || s > 0 ? Cr(A.left + _ / 3, A.top + U / 3, i - _ / 3, s - U / 3, tr.TOP_LEFT) : new qe(A.left + _ / 3, A.top + U / 3), this.topRightBorderDoubleOuterBox = i > 0 || s > 0 ? Cr(A.left + b, A.top + U / 3, o - Q / 3, l - U / 3, tr.TOP_RIGHT) : new qe(A.left + A.width - Q / 3, A.top + U / 3), this.bottomRightBorderDoubleOuterBox = c > 0 || f > 0 ? Cr(A.left + B, A.top + S, c - Q / 3, f - N / 3, tr.BOTTOM_RIGHT) : new qe(A.left + A.width - Q / 3, A.top + A.height - N / 3), this.bottomLeftBorderDoubleOuterBox = g > 0 || p > 0 ? Cr(A.left + _ / 3, A.top + x, g - _ / 3, p - N / 3, tr.BOTTOM_LEFT) : new qe(A.left + _ / 3, A.top + A.height - N / 3), this.topLeftBorderDoubleInnerBox = i > 0 || s > 0 ? Cr(A.left + _ * 2 / 3, A.top + U * 2 / 3, i - _ * 2 / 3, s - U * 2 / 3, tr.TOP_LEFT) : new qe(A.left + _ * 2 / 3, A.top + U * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || s > 0 ? Cr(A.left + b, A.top + U * 2 / 3, o - Q * 2 / 3, l - U * 2 / 3, tr.TOP_RIGHT) : new qe(A.left + A.width - Q * 2 / 3, A.top + U * 2 / 3), this.bottomRightBorderDoubleInnerBox = c > 0 || f > 0 ? Cr(A.left + B, A.top + S, c - Q * 2 / 3, f - N * 2 / 3, tr.BOTTOM_RIGHT) : new qe(A.left + A.width - Q * 2 / 3, A.top + A.height - N * 2 / 3), this.bottomLeftBorderDoubleInnerBox = g > 0 || p > 0 ? Cr(A.left + _ * 2 / 3, A.top + x, g - _ * 2 / 3, p - N * 2 / 3, tr.BOTTOM_LEFT) : new qe(A.left + _ * 2 / 3, A.top + A.height - N * 2 / 3), this.topLeftBorderStroke = i > 0 || s > 0 ? Cr(A.left + _ / 2, A.top + U / 2, i - _ / 2, s - U / 2, tr.TOP_LEFT) : new qe(A.left + _ / 2, A.top + U / 2), this.topRightBorderStroke = i > 0 || s > 0 ? Cr(A.left + b, A.top + U / 2, o - Q / 2, l - U / 2, tr.TOP_RIGHT) : new qe(A.left + A.width - Q / 2, A.top + U / 2), this.bottomRightBorderStroke = c > 0 || f > 0 ? Cr(A.left + B, A.top + S, c - Q / 2, f - N / 2, tr.BOTTOM_RIGHT) : new qe(A.left + A.width - Q / 2, A.top + A.height - N / 2), this.bottomLeftBorderStroke = g > 0 || p > 0 ? Cr(A.left + _ / 2, A.top + x, g - _ / 2, p - N / 2, tr.BOTTOM_LEFT) : new qe(A.left + _ / 2, A.top + A.height - N / 2), this.topLeftBorderBox = i > 0 || s > 0 ? Cr(A.left, A.top, i, s, tr.TOP_LEFT) : new qe(A.left, A.top), this.topRightBorderBox = o > 0 || l > 0 ? Cr(A.left + b, A.top, o, l, tr.TOP_RIGHT) : new qe(A.left + A.width, A.top), this.bottomRightBorderBox = c > 0 || f > 0 ? Cr(A.left + B, A.top + S, c, f, tr.BOTTOM_RIGHT) : new qe(A.left + A.width, A.top + A.height), this.bottomLeftBorderBox = g > 0 || p > 0 ? Cr(A.left, A.top + x, g, p, tr.BOTTOM_LEFT) : new qe(A.left, A.top + A.height), this.topLeftPaddingBox = i > 0 || s > 0 ? Cr(A.left + _, A.top + U, Math.max(0, i - _), Math.max(0, s - U), tr.TOP_LEFT) : new qe(A.left + _, A.top + U), this.topRightPaddingBox = o > 0 || l > 0 ? Cr(A.left + Math.min(b, A.width - Q), A.top + U, b > A.width + Q ? 0 : Math.max(0, o - Q), Math.max(0, l - U), tr.TOP_RIGHT) : new qe(A.left + A.width - Q, A.top + U), this.bottomRightPaddingBox = c > 0 || f > 0 ? Cr(A.left + Math.min(B, A.width - _), A.top + Math.min(S, A.height - N), Math.max(0, c - Q), Math.max(0, f - N), tr.BOTTOM_RIGHT) : new qe(A.left + A.width - Q, A.top + A.height - N), this.bottomLeftPaddingBox = g > 0 || p > 0 ? Cr(A.left + _, A.top + Math.min(x, A.height - N), Math.max(0, g - _), Math.max(0, p - N), tr.BOTTOM_LEFT) : new qe(A.left + _, A.top + A.height - N), this.topLeftContentBox = i > 0 || s > 0 ? Cr(A.left + _ + G, A.top + U + R, Math.max(0, i - (_ + G)), Math.max(0, s - (U + R)), tr.TOP_LEFT) : new qe(A.left + _ + G, A.top + U + R), this.topRightContentBox = o > 0 || l > 0 ? Cr(A.left + Math.min(b, A.width + _ + G), A.top + U + R, b > A.width + _ + G ? 0 : o - _ + G, l - (U + R), tr.TOP_RIGHT) : new qe(A.left + A.width - (Q + F), A.top + U + R), this.bottomRightContentBox = c > 0 || f > 0 ? Cr(A.left + Math.min(B, A.width - (_ + G)), A.top + Math.min(S, A.height + U + R), Math.max(0, c - (Q + F)), f - (N + O), tr.BOTTOM_RIGHT) : new qe(A.left + A.width - (Q + F), A.top + A.height - (N + O)), this.bottomLeftContentBox = g > 0 || p > 0 ? Cr(A.left + _ + G, A.top + x, Math.max(0, g - (_ + G)), p - (N + O), tr.BOTTOM_LEFT) : new qe(A.left + _ + G, A.top + A.height - (N + O));
    }
    return r;
  })()
), tr;
(function(r) {
  r[r.TOP_LEFT = 0] = "TOP_LEFT", r[r.TOP_RIGHT = 1] = "TOP_RIGHT", r[r.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", r[r.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(tr || (tr = {}));
var Cr = function(r, e, t, A, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), s = t * i, a = A * i, o = r + t, l = e + A;
  switch (n) {
    case tr.TOP_LEFT:
      return new qc(new qe(r, l), new qe(r, l - a), new qe(o - s, e), new qe(o, e));
    case tr.TOP_RIGHT:
      return new qc(new qe(r, e), new qe(r + s, e), new qe(o, l - a), new qe(o, l));
    case tr.BOTTOM_RIGHT:
      return new qc(new qe(o, e), new qe(o, e + a), new qe(r + s, l), new qe(r, l));
    case tr.BOTTOM_LEFT:
    default:
      return new qc(new qe(o, l), new qe(o - s, l), new qe(r, e + a), new qe(r, e));
  }
}, Th = function(r) {
  return [r.topLeftBorderBox, r.topRightBorderBox, r.bottomRightBorderBox, r.bottomLeftBorderBox];
}, IR = function(r) {
  return [
    r.topLeftContentBox,
    r.topRightContentBox,
    r.bottomRightContentBox,
    r.bottomLeftContentBox
  ];
}, Ph = function(r) {
  return [
    r.topLeftPaddingBox,
    r.topRightPaddingBox,
    r.bottomRightPaddingBox,
    r.bottomLeftPaddingBox
  ];
}, QR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t, A) {
      this.offsetX = e, this.offsetY = t, this.matrix = A, this.type = 0, this.target = 6;
    }
    return r;
  })()
), zc = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.path = e, this.target = t, this.type = 1;
    }
    return r;
  })()
), LR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      this.opacity = e, this.type = 2, this.target = 6;
    }
    return r;
  })()
), NR = function(r) {
  return r.type === 0;
}, bE = function(r) {
  return r.type === 1;
}, TR = function(r) {
  return r.type === 2;
}, F2 = function(r, e) {
  return r.length === e.length ? r.some(function(t, A) {
    return t === e[A];
  }) : !1;
}, PR = function(r, e, t, A, n) {
  return r.map(function(i, s) {
    switch (s) {
      case 0:
        return i.add(e, t);
      case 1:
        return i.add(e + A, t);
      case 2:
        return i.add(e + A, t + n);
      case 3:
        return i.add(e, t + n);
    }
    return i;
  });
}, BE = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      this.element = e, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return r;
  })()
), CE = (
  /** @class */
  (function() {
    function r(e, t) {
      if (this.container = e, this.parent = t, this.effects = [], this.curves = new UR(this.container), this.container.styles.opacity < 1 && this.effects.push(new LR(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var A = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new QR(A, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = Th(this.curves), a = Ph(this.curves);
        F2(s, a) ? this.effects.push(new zc(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new zc(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new zc(
          a,
          4
          /* CONTENT */
        )));
      }
    }
    return r.prototype.getEffects = function(e) {
      for (var t = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, A = this.parent, n = this.effects.slice(0); A; ) {
        var i = A.effects.filter(function(o) {
          return !bE(o);
        });
        if (t || A.container.styles.position !== 0 || !A.parent) {
          if (n.unshift.apply(n, i), t = [
            2,
            3
            /* FIXED */
          ].indexOf(A.container.styles.position) === -1, A.container.styles.overflowX !== 0) {
            var s = Th(A.curves), a = Ph(A.curves);
            F2(s, a) || n.unshift(new zc(
              a,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        A = A.parent;
      }
      return n.filter(function(o) {
        return gA(o.target, e);
      });
    }, r;
  })()
), Pm = function(r, e, t, A) {
  r.container.elements.forEach(function(n) {
    var i = gA(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = gA(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), a = new CE(n, r);
    gA(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && A.push(a);
    var o = gA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : A;
    if (i || s) {
      var l = i || n.styles.isPositioned() ? t : e, u = new BE(a);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var c = n.styles.zIndex.order;
        if (c < 0) {
          var f = 0;
          l.negativeZIndex.some(function(g, p) {
            return c > g.element.container.styles.zIndex.order ? (f = p, !1) : f > 0;
          }), l.negativeZIndex.splice(f, 0, u);
        } else if (c > 0) {
          var h = 0;
          l.positiveZIndex.some(function(g, p) {
            return c >= g.element.container.styles.zIndex.order ? (h = p + 1, !1) : h > 0;
          }), l.positiveZIndex.splice(h, 0, u);
        } else
          l.zeroOrAutoZIndexOrTransformedOrOpacity.push(u);
      } else
        n.styles.isFloating() ? l.nonPositionedFloats.push(u) : l.nonPositionedInlineLevel.push(u);
      Pm(a, u, i ? u : t, o);
    } else
      n.styles.isInlineLevel() ? e.inlineLevel.push(a) : e.nonInlineLevel.push(a), Pm(a, e, t, o);
    gA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && SE(n, o);
  });
}, SE = function(r, e) {
  for (var t = r instanceof Im ? r.start : 1, A = r instanceof Im ? r.reversed : !1, n = 0; n < e.length; n++) {
    var i = e[n];
    i.container instanceof aE && typeof i.container.value == "number" && i.container.value !== 0 && (t = i.container.value), i.listValue = ou(t, i.container.styles.listStyleType, !0), t += A ? -1 : 1;
  }
}, OR = function(r) {
  var e = new CE(r, null), t = new BE(e), A = [];
  return Pm(e, t, t, A), SE(e.container, A), t;
}, _2 = function(r, e) {
  switch (e) {
    case 0:
      return kn(r.topLeftBorderBox, r.topLeftPaddingBox, r.topRightBorderBox, r.topRightPaddingBox);
    case 1:
      return kn(r.topRightBorderBox, r.topRightPaddingBox, r.bottomRightBorderBox, r.bottomRightPaddingBox);
    case 2:
      return kn(r.bottomRightBorderBox, r.bottomRightPaddingBox, r.bottomLeftBorderBox, r.bottomLeftPaddingBox);
    default:
      return kn(r.bottomLeftBorderBox, r.bottomLeftPaddingBox, r.topLeftBorderBox, r.topLeftPaddingBox);
  }
}, MR = function(r, e) {
  switch (e) {
    case 0:
      return kn(r.topLeftBorderBox, r.topLeftBorderDoubleOuterBox, r.topRightBorderBox, r.topRightBorderDoubleOuterBox);
    case 1:
      return kn(r.topRightBorderBox, r.topRightBorderDoubleOuterBox, r.bottomRightBorderBox, r.bottomRightBorderDoubleOuterBox);
    case 2:
      return kn(r.bottomRightBorderBox, r.bottomRightBorderDoubleOuterBox, r.bottomLeftBorderBox, r.bottomLeftBorderDoubleOuterBox);
    default:
      return kn(r.bottomLeftBorderBox, r.bottomLeftBorderDoubleOuterBox, r.topLeftBorderBox, r.topLeftBorderDoubleOuterBox);
  }
}, RR = function(r, e) {
  switch (e) {
    case 0:
      return kn(r.topLeftBorderDoubleInnerBox, r.topLeftPaddingBox, r.topRightBorderDoubleInnerBox, r.topRightPaddingBox);
    case 1:
      return kn(r.topRightBorderDoubleInnerBox, r.topRightPaddingBox, r.bottomRightBorderDoubleInnerBox, r.bottomRightPaddingBox);
    case 2:
      return kn(r.bottomRightBorderDoubleInnerBox, r.bottomRightPaddingBox, r.bottomLeftBorderDoubleInnerBox, r.bottomLeftPaddingBox);
    default:
      return kn(r.bottomLeftBorderDoubleInnerBox, r.bottomLeftPaddingBox, r.topLeftBorderDoubleInnerBox, r.topLeftPaddingBox);
  }
}, kR = function(r, e) {
  switch (e) {
    case 0:
      return Wc(r.topLeftBorderStroke, r.topRightBorderStroke);
    case 1:
      return Wc(r.topRightBorderStroke, r.bottomRightBorderStroke);
    case 2:
      return Wc(r.bottomRightBorderStroke, r.bottomLeftBorderStroke);
    default:
      return Wc(r.bottomLeftBorderStroke, r.topLeftBorderStroke);
  }
}, Wc = function(r, e) {
  var t = [];
  return Pn(r) ? t.push(r.subdivide(0.5, !1)) : t.push(r), Pn(e) ? t.push(e.subdivide(0.5, !0)) : t.push(e), t;
}, kn = function(r, e, t, A) {
  var n = [];
  return Pn(r) ? n.push(r.subdivide(0.5, !1)) : n.push(r), Pn(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), Pn(A) ? n.push(A.subdivide(0.5, !0).reverse()) : n.push(A), Pn(e) ? n.push(e.subdivide(0.5, !1).reverse()) : n.push(e), n;
}, xE = function(r) {
  var e = r.bounds, t = r.styles;
  return e.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, Oh = function(r) {
  var e = r.styles, t = r.bounds, A = pr(e.paddingLeft, t.width), n = pr(e.paddingRight, t.width), i = pr(e.paddingTop, t.width), s = pr(e.paddingBottom, t.width);
  return t.add(A + e.borderLeftWidth, i + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + A + n), -(e.borderTopWidth + e.borderBottomWidth + i + s));
}, HR = function(r, e) {
  return r === 0 ? e.bounds : r === 2 ? Oh(e) : xE(e);
}, DR = function(r, e) {
  return r === 0 ? e.bounds : r === 2 ? Oh(e) : xE(e);
}, tg = function(r, e, t) {
  var A = HR(Co(r.styles.backgroundOrigin, e), r), n = DR(Co(r.styles.backgroundClip, e), r), i = GR(Co(r.styles.backgroundSize, e), t, A), s = i[0], a = i[1], o = kl(Co(r.styles.backgroundPosition, e), A.width - s, A.height - a), l = VR(Co(r.styles.backgroundRepeat, e), o, i, A, n), u = Math.round(A.left + o[0]), c = Math.round(A.top + o[1]);
  return [l, u, c, s, a];
}, mo = function(r) {
  return ir(r) && r.value === No.AUTO;
}, Xc = function(r) {
  return typeof r == "number";
}, GR = function(r, e, t) {
  var A = e[0], n = e[1], i = e[2], s = r[0], a = r[1];
  if (!s)
    return [0, 0];
  if (sA(s) && a && sA(a))
    return [pr(s, t.width), pr(a, t.height)];
  var o = Xc(i);
  if (ir(s) && (s.value === No.CONTAIN || s.value === No.COVER)) {
    if (Xc(i)) {
      var l = t.width / t.height;
      return l < i != (s.value === No.COVER) ? [t.width, t.width / i] : [t.height * i, t.height];
    }
    return [t.width, t.height];
  }
  var u = Xc(A), c = Xc(n), f = u || c;
  if (mo(s) && (!a || mo(a))) {
    if (u && c)
      return [A, n];
    if (!o && !f)
      return [t.width, t.height];
    if (f && o) {
      var h = u ? A : n * i, g = c ? n : A / i;
      return [h, g];
    }
    var p = u ? A : t.width, v = c ? n : t.height;
    return [p, v];
  }
  if (o) {
    var w = 0, b = 0;
    return sA(s) ? w = pr(s, t.width) : sA(a) && (b = pr(a, t.height)), mo(s) ? w = b * i : (!a || mo(a)) && (b = w / i), [w, b];
  }
  var S = null, B = null;
  if (sA(s) ? S = pr(s, t.width) : a && sA(a) && (B = pr(a, t.height)), S !== null && (!a || mo(a)) && (B = u && c ? S / A * n : t.height), B !== null && mo(s) && (S = u && c ? B / n * A : t.width), S !== null && B !== null)
    return [S, B];
  throw new Error("Unable to calculate background-size for element");
}, Co = function(r, e) {
  var t = r[e];
  return typeof t > "u" ? r[0] : t;
}, VR = function(r, e, t, A, n) {
  var i = e[0], s = e[1], a = t[0], o = t[1];
  switch (r) {
    case 2:
      return [
        new qe(Math.round(A.left), Math.round(A.top + s)),
        new qe(Math.round(A.left + A.width), Math.round(A.top + s)),
        new qe(Math.round(A.left + A.width), Math.round(o + A.top + s)),
        new qe(Math.round(A.left), Math.round(o + A.top + s))
      ];
    case 3:
      return [
        new qe(Math.round(A.left + i), Math.round(A.top)),
        new qe(Math.round(A.left + i + a), Math.round(A.top)),
        new qe(Math.round(A.left + i + a), Math.round(A.height + A.top)),
        new qe(Math.round(A.left + i), Math.round(A.height + A.top))
      ];
    case 1:
      return [
        new qe(Math.round(A.left + i), Math.round(A.top + s)),
        new qe(Math.round(A.left + i + a), Math.round(A.top + s)),
        new qe(Math.round(A.left + i + a), Math.round(A.top + s + o)),
        new qe(Math.round(A.left + i), Math.round(A.top + s + o))
      ];
    default:
      return [
        new qe(Math.round(n.left), Math.round(n.top)),
        new qe(Math.round(n.left + n.width), Math.round(n.top)),
        new qe(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new qe(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, KR = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", U2 = "Hidden Text", jR = (
  /** @class */
  (function() {
    function r(e) {
      this._data = {}, this._document = e;
    }
    return r.prototype.parseMetrics = function(e, t) {
      var A = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), s = this._document.body;
      A.style.visibility = "hidden", A.style.fontFamily = e, A.style.fontSize = t, A.style.margin = "0", A.style.padding = "0", A.style.whiteSpace = "nowrap", s.appendChild(A), n.src = KR, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = e, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(U2)), A.appendChild(i), A.appendChild(n);
      var a = n.offsetTop - i.offsetTop + 2;
      A.removeChild(i), A.appendChild(this._document.createTextNode(U2)), A.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var o = n.offsetTop - A.offsetTop + 2;
      return s.removeChild(A), { baseline: a, middle: o };
    }, r.prototype.getMetrics = function(e, t) {
      var A = e + " " + t;
      return typeof this._data[A] > "u" && (this._data[A] = this.parseMetrics(e, t)), this._data[A];
    }, r;
  })()
), EE = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.context = e, this.options = t;
    }
    return r;
  })()
), qR = 1e4, zR = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n._activeEffects = [], n.canvas = A.canvas ? A.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), A.canvas || (n.canvas.width = Math.floor(A.width * A.scale), n.canvas.height = Math.floor(A.height * A.scale), n.canvas.style.width = A.width + "px", n.canvas.style.height = A.height + "px"), n.fontMetrics = new jR(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-A.x, -A.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + A.width + "x" + A.height + ") with scale " + A.scale), n;
    }
    return e.prototype.applyEffects = function(t) {
      for (var A = this; this._activeEffects.length; )
        this.popEffect();
      t.forEach(function(n) {
        return A.applyEffect(n);
      });
    }, e.prototype.applyEffect = function(t) {
      this.ctx.save(), TR(t) && (this.ctx.globalAlpha = t.opacity), NR(t) && (this.ctx.translate(t.offsetX, t.offsetY), this.ctx.transform(t.matrix[0], t.matrix[1], t.matrix[2], t.matrix[3], t.matrix[4], t.matrix[5]), this.ctx.translate(-t.offsetX, -t.offsetY)), bE(t) && (this.path(t.path), this.ctx.clip()), this._activeEffects.push(t);
    }, e.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, e.prototype.renderStack = function(t) {
      return WA(this, void 0, void 0, function() {
        var A;
        return MA(this, function(n) {
          switch (n.label) {
            case 0:
              return A = t.element.container.styles, A.isVisible() ? [4, this.renderStackContent(t)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderNode = function(t) {
      return WA(this, void 0, void 0, function() {
        return MA(this, function(A) {
          switch (A.label) {
            case 0:
              if (gA(
                t.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return t.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(t)] : [3, 3];
            case 1:
              return A.sent(), [4, this.renderNodeContent(t)];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderTextWithLetterSpacing = function(t, A, n) {
      var i = this;
      if (A === 0)
        this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n);
      else {
        var s = Sv(t.text);
        s.reduce(function(a, o) {
          return i.ctx.fillText(o, a, t.bounds.top + n), a + i.ctx.measureText(o).width;
        }, t.bounds.left);
      }
    }, e.prototype.createFontStyle = function(t) {
      var A = t.fontVariant.filter(function(s) {
        return s === "normal" || s === "small-caps";
      }).join(""), n = JR(t.fontFamily).join(", "), i = Su(t.fontSize) ? "" + t.fontSize.number + t.fontSize.unit : t.fontSize.number + "px";
      return [
        [t.fontStyle, A, t.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, e.prototype.renderTextNode = function(t, A) {
      return WA(this, void 0, void 0, function() {
        var n, i, s, a, o, l, u, c, f = this;
        return MA(this, function(h) {
          return n = this.createFontStyle(A), i = n[0], s = n[1], a = n[2], this.ctx.font = i, this.ctx.direction = A.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", o = this.fontMetrics.getMetrics(s, a), l = o.baseline, u = o.middle, c = A.paintOrder, t.textBounds.forEach(function(g) {
            c.forEach(function(p) {
              switch (p) {
                case 0:
                  f.ctx.fillStyle = vA(A.color), f.renderTextWithLetterSpacing(g, A.letterSpacing, l);
                  var v = A.textShadow;
                  v.length && g.text.trim().length && (v.slice(0).reverse().forEach(function(w) {
                    f.ctx.shadowColor = vA(w.color), f.ctx.shadowOffsetX = w.offsetX.number * f.options.scale, f.ctx.shadowOffsetY = w.offsetY.number * f.options.scale, f.ctx.shadowBlur = w.blur.number, f.renderTextWithLetterSpacing(g, A.letterSpacing, l);
                  }), f.ctx.shadowColor = "", f.ctx.shadowOffsetX = 0, f.ctx.shadowOffsetY = 0, f.ctx.shadowBlur = 0), A.textDecorationLine.length && (f.ctx.fillStyle = vA(A.textDecorationColor || A.color), A.textDecorationLine.forEach(function(w) {
                    switch (w) {
                      case 1:
                        f.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top + l), g.bounds.width, 1);
                        break;
                      case 2:
                        f.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top), g.bounds.width, 1);
                        break;
                      case 3:
                        f.ctx.fillRect(g.bounds.left, Math.ceil(g.bounds.top + u), g.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  A.webkitTextStrokeWidth && g.text.trim().length && (f.ctx.strokeStyle = vA(A.webkitTextStrokeColor), f.ctx.lineWidth = A.webkitTextStrokeWidth, f.ctx.lineJoin = window.chrome ? "miter" : "round", f.ctx.strokeText(g.text, g.bounds.left, g.bounds.top + l)), f.ctx.strokeStyle = "", f.ctx.lineWidth = 0, f.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.renderReplacedElement = function(t, A, n) {
      if (n && t.intrinsicWidth > 0 && t.intrinsicHeight > 0) {
        var i = Oh(t), s = Ph(A);
        this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, t.intrinsicWidth, t.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, e.prototype.renderNodeContent = function(t) {
      return WA(this, void 0, void 0, function() {
        var A, n, i, s, a, o, b, b, l, u, c, f, B, h, g, x, p, v, w, b, S, B, x;
        return MA(this, function(U) {
          switch (U.label) {
            case 0:
              this.applyEffects(t.getEffects(
                4
                /* CONTENT */
              )), A = t.container, n = t.curves, i = A.styles, s = 0, a = A.textNodes, U.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [4, this.renderTextNode(o, i)]) : [3, 4];
            case 2:
              U.sent(), U.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              if (!(A instanceof nE)) return [3, 8];
              U.label = 5;
            case 5:
              return U.trys.push([5, 7, , 8]), [4, this.context.cache.match(A.src)];
            case 6:
              return b = U.sent(), this.renderReplacedElement(A, n, b), [3, 8];
            case 7:
              return U.sent(), this.context.logger.error("Error loading image " + A.src), [3, 8];
            case 8:
              if (A instanceof iE && this.renderReplacedElement(A, n, A.canvas), !(A instanceof sE)) return [3, 12];
              U.label = 9;
            case 9:
              return U.trys.push([9, 11, , 12]), [4, this.context.cache.match(A.svg)];
            case 10:
              return b = U.sent(), this.renderReplacedElement(A, n, b), [3, 12];
            case 11:
              return U.sent(), this.context.logger.error("Error loading svg " + A.svg.substring(0, 255)), [3, 12];
            case 12:
              return A instanceof uE && A.tree ? (l = new e(this.context, {
                scale: this.options.scale,
                backgroundColor: A.backgroundColor,
                x: 0,
                y: 0,
                width: A.width,
                height: A.height
              }), [4, l.render(A.tree)]) : [3, 14];
            case 13:
              u = U.sent(), A.width && A.height && this.ctx.drawImage(u, 0, 0, A.width, A.height, A.bounds.left, A.bounds.top, A.bounds.width, A.bounds.height), U.label = 14;
            case 14:
              if (A instanceof xv && (c = Math.min(A.bounds.width, A.bounds.height), A.type === Ih ? A.checked && (this.ctx.save(), this.path([
                new qe(A.bounds.left + c * 0.39363, A.bounds.top + c * 0.79),
                new qe(A.bounds.left + c * 0.16, A.bounds.top + c * 0.5549),
                new qe(A.bounds.left + c * 0.27347, A.bounds.top + c * 0.44071),
                new qe(A.bounds.left + c * 0.39694, A.bounds.top + c * 0.5649),
                new qe(A.bounds.left + c * 0.72983, A.bounds.top + c * 0.23),
                new qe(A.bounds.left + c * 0.84, A.bounds.top + c * 0.34085),
                new qe(A.bounds.left + c * 0.39363, A.bounds.top + c * 0.79)
              ]), this.ctx.fillStyle = vA(p2), this.ctx.fill(), this.ctx.restore()) : A.type === Qh && A.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(A.bounds.left + c / 2, A.bounds.top + c / 2, c / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = vA(p2), this.ctx.fill(), this.ctx.restore())), WR(A) && A.value.length) {
                switch (f = this.createFontStyle(i), B = f[0], h = f[1], g = this.fontMetrics.getMetrics(B, h).baseline, this.ctx.font = B, this.ctx.fillStyle = vA(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = YR(A.styles.textAlign), x = Oh(A), p = 0, A.styles.textAlign) {
                  case 1:
                    p += x.width / 2;
                    break;
                  case 2:
                    p += x.width;
                    break;
                }
                v = x.add(p, 0, 0, -x.height / 2 + 1), this.ctx.save(), this.path([
                  new qe(x.left, x.top),
                  new qe(x.left + x.width, x.top),
                  new qe(x.left + x.width, x.top + x.height),
                  new qe(x.left, x.top + x.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Jl(A.value, v), i.letterSpacing, g), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!gA(
                A.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (A.styles.listStyleImage === null) return [3, 19];
              if (w = A.styles.listStyleImage, w.type !== 0) return [3, 18];
              b = void 0, S = w.url, U.label = 15;
            case 15:
              return U.trys.push([15, 17, , 18]), [4, this.context.cache.match(S)];
            case 16:
              return b = U.sent(), this.ctx.drawImage(b, A.bounds.left - (b.width + 10), A.bounds.top), [3, 18];
            case 17:
              return U.sent(), this.context.logger.error("Error loading list-style-image " + S), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              t.listValue && A.styles.listStyleType !== -1 && (B = this.createFontStyle(i)[0], this.ctx.font = B, this.ctx.fillStyle = vA(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", x = new ls(A.bounds.left, A.bounds.top + pr(A.styles.paddingTop, A.bounds.width), A.bounds.width, Zy(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Jl(t.listValue, x), i.letterSpacing, Zy(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), U.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderStackContent = function(t) {
      return WA(this, void 0, void 0, function() {
        var A, n, w, i, s, w, a, o, w, l, u, w, c, f, w, h, g, w, p, v, w;
        return MA(this, function(b) {
          switch (b.label) {
            case 0:
              if (gA(
                t.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(t.element)];
            case 1:
              b.sent(), A = 0, n = t.negativeZIndex, b.label = 2;
            case 2:
              return A < n.length ? (w = n[A], [4, this.renderStack(w)]) : [3, 5];
            case 3:
              b.sent(), b.label = 4;
            case 4:
              return A++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(t.element)];
            case 6:
              b.sent(), i = 0, s = t.nonInlineLevel, b.label = 7;
            case 7:
              return i < s.length ? (w = s[i], [4, this.renderNode(w)]) : [3, 10];
            case 8:
              b.sent(), b.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              a = 0, o = t.nonPositionedFloats, b.label = 11;
            case 11:
              return a < o.length ? (w = o[a], [4, this.renderStack(w)]) : [3, 14];
            case 12:
              b.sent(), b.label = 13;
            case 13:
              return a++, [3, 11];
            case 14:
              l = 0, u = t.nonPositionedInlineLevel, b.label = 15;
            case 15:
              return l < u.length ? (w = u[l], [4, this.renderStack(w)]) : [3, 18];
            case 16:
              b.sent(), b.label = 17;
            case 17:
              return l++, [3, 15];
            case 18:
              c = 0, f = t.inlineLevel, b.label = 19;
            case 19:
              return c < f.length ? (w = f[c], [4, this.renderNode(w)]) : [3, 22];
            case 20:
              b.sent(), b.label = 21;
            case 21:
              return c++, [3, 19];
            case 22:
              h = 0, g = t.zeroOrAutoZIndexOrTransformedOrOpacity, b.label = 23;
            case 23:
              return h < g.length ? (w = g[h], [4, this.renderStack(w)]) : [3, 26];
            case 24:
              b.sent(), b.label = 25;
            case 25:
              return h++, [3, 23];
            case 26:
              p = 0, v = t.positiveZIndex, b.label = 27;
            case 27:
              return p < v.length ? (w = v[p], [4, this.renderStack(w)]) : [3, 30];
            case 28:
              b.sent(), b.label = 29;
            case 29:
              return p++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.mask = function(t) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(t.slice(0).reverse()), this.ctx.closePath();
    }, e.prototype.path = function(t) {
      this.ctx.beginPath(), this.formatPath(t), this.ctx.closePath();
    }, e.prototype.formatPath = function(t) {
      var A = this;
      t.forEach(function(n, i) {
        var s = Pn(n) ? n.start : n;
        i === 0 ? A.ctx.moveTo(s.x, s.y) : A.ctx.lineTo(s.x, s.y), Pn(n) && A.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, e.prototype.renderRepeat = function(t, A, n, i) {
      this.path(t), this.ctx.fillStyle = A, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, e.prototype.resizeImage = function(t, A, n) {
      var i;
      if (t.width === A && t.height === n)
        return t;
      var s = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, a = s.createElement("canvas");
      a.width = Math.max(1, A), a.height = Math.max(1, n);
      var o = a.getContext("2d");
      return o.drawImage(t, 0, 0, t.width, t.height, 0, 0, A, n), a;
    }, e.prototype.renderBackgroundImage = function(t) {
      return WA(this, void 0, void 0, function() {
        var A, n, i, s, a, o;
        return MA(this, function(l) {
          switch (l.label) {
            case 0:
              A = t.styles.backgroundImage.length - 1, n = function(u) {
                var c, f, h, R, ne, te, G, H, N, g, R, ne, te, G, H, p, v, w, b, S, B, x, U, Q, N, _, R, F, O, G, H, $, ne, te, J, re, le, se, P, V, X, Y;
                return MA(this, function(ee) {
                  switch (ee.label) {
                    case 0:
                      if (u.type !== 0) return [3, 5];
                      c = void 0, f = u.url, ee.label = 1;
                    case 1:
                      return ee.trys.push([1, 3, , 4]), [4, i.context.cache.match(f)];
                    case 2:
                      return c = ee.sent(), [3, 4];
                    case 3:
                      return ee.sent(), i.context.logger.error("Error loading background-image " + f), [3, 4];
                    case 4:
                      return c && (h = tg(t, A, [
                        c.width,
                        c.height,
                        c.width / c.height
                      ]), R = h[0], ne = h[1], te = h[2], G = h[3], H = h[4], N = i.ctx.createPattern(i.resizeImage(c, G, H), "repeat"), i.renderRepeat(R, N, ne, te)), [3, 6];
                    case 5:
                      NP(u) ? (g = tg(t, A, [null, null, null]), R = g[0], ne = g[1], te = g[2], G = g[3], H = g[4], p = _P(u.angle, G, H), v = p[0], w = p[1], b = p[2], S = p[3], B = p[4], x = document.createElement("canvas"), x.width = G, x.height = H, U = x.getContext("2d"), Q = U.createLinearGradient(w, S, b, B), $y(u.stops, v).forEach(function(oe) {
                        return Q.addColorStop(oe.stop, vA(oe.color));
                      }), U.fillStyle = Q, U.fillRect(0, 0, G, H), G > 0 && H > 0 && (N = i.ctx.createPattern(x, "repeat"), i.renderRepeat(R, N, ne, te))) : TP(u) && (_ = tg(t, A, [
                        null,
                        null,
                        null
                      ]), R = _[0], F = _[1], O = _[2], G = _[3], H = _[4], $ = u.position.length === 0 ? [bv] : u.position, ne = pr($[0], G), te = pr($[$.length - 1], H), J = UP(u, ne, te, G, H), re = J[0], le = J[1], re > 0 && le > 0 && (se = i.ctx.createRadialGradient(F + ne, O + te, 0, F + ne, O + te, re), $y(u.stops, re * 2).forEach(function(oe) {
                        return se.addColorStop(oe.stop, vA(oe.color));
                      }), i.path(R), i.ctx.fillStyle = se, re !== le ? (P = t.bounds.left + 0.5 * t.bounds.width, V = t.bounds.top + 0.5 * t.bounds.height, X = le / re, Y = 1 / X, i.ctx.save(), i.ctx.translate(P, V), i.ctx.transform(1, 0, 0, X, 0, 0), i.ctx.translate(-P, -V), i.ctx.fillRect(F, Y * (O - V) + V, G, H * Y), i.ctx.restore()) : i.ctx.fill())), ee.label = 6;
                    case 6:
                      return A--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, s = 0, a = t.styles.backgroundImage.slice(0).reverse(), l.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [5, n(o)]) : [3, 4];
            case 2:
              l.sent(), l.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderSolidBorder = function(t, A, n) {
      return WA(this, void 0, void 0, function() {
        return MA(this, function(i) {
          return this.path(_2(n, A)), this.ctx.fillStyle = vA(t), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.renderDoubleBorder = function(t, A, n, i) {
      return WA(this, void 0, void 0, function() {
        var s, a;
        return MA(this, function(o) {
          switch (o.label) {
            case 0:
              return A < 3 ? [4, this.renderSolidBorder(t, n, i)] : [3, 2];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
            case 2:
              return s = MR(i, n), this.path(s), this.ctx.fillStyle = vA(t), this.ctx.fill(), a = RR(i, n), this.path(a), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderNodeBackgroundAndBorders = function(t) {
      return WA(this, void 0, void 0, function() {
        var A, n, i, s, a, o, l, u, c = this;
        return MA(this, function(f) {
          switch (f.label) {
            case 0:
              return this.applyEffects(t.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), A = t.container.styles, n = !js(A.backgroundColor) || A.backgroundImage.length, i = [
                { style: A.borderTopStyle, color: A.borderTopColor, width: A.borderTopWidth },
                { style: A.borderRightStyle, color: A.borderRightColor, width: A.borderRightWidth },
                { style: A.borderBottomStyle, color: A.borderBottomColor, width: A.borderBottomWidth },
                { style: A.borderLeftStyle, color: A.borderLeftColor, width: A.borderLeftWidth }
              ], s = XR(Co(A.backgroundClip, 0), t.curves), n || A.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), js(A.backgroundColor) || (this.ctx.fillStyle = vA(A.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(t.container)]) : [3, 2];
            case 1:
              f.sent(), this.ctx.restore(), A.boxShadow.slice(0).reverse().forEach(function(h) {
                c.ctx.save();
                var g = Th(t.curves), p = h.inset ? 0 : qR, v = PR(g, -p + (h.inset ? 1 : -1) * h.spread.number, (h.inset ? 1 : -1) * h.spread.number, h.spread.number * (h.inset ? -2 : 2), h.spread.number * (h.inset ? -2 : 2));
                h.inset ? (c.path(g), c.ctx.clip(), c.mask(v)) : (c.mask(g), c.ctx.clip(), c.path(v)), c.ctx.shadowOffsetX = h.offsetX.number + p, c.ctx.shadowOffsetY = h.offsetY.number, c.ctx.shadowColor = vA(h.color), c.ctx.shadowBlur = h.blur.number, c.ctx.fillStyle = h.inset ? vA(h.color) : "rgba(0,0,0,1)", c.ctx.fill(), c.ctx.restore();
              }), f.label = 2;
            case 2:
              a = 0, o = 0, l = i, f.label = 3;
            case 3:
              return o < l.length ? (u = l[o], u.style !== 0 && !js(u.color) && u.width > 0 ? u.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                u.color,
                u.width,
                a,
                t.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return f.sent(), [3, 11];
            case 5:
              return u.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                u.color,
                u.width,
                a,
                t.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return f.sent(), [3, 11];
            case 7:
              return u.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(u.color, u.width, a, t.curves)];
            case 8:
              return f.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(u.color, a, t.curves)];
            case 10:
              f.sent(), f.label = 11;
            case 11:
              a++, f.label = 12;
            case 12:
              return o++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderDashedDottedBorder = function(t, A, n, i, s) {
      return WA(this, void 0, void 0, function() {
        var a, o, l, u, c, f, h, g, p, v, w, b, S, B, x, U, x, U;
        return MA(this, function(Q) {
          return this.ctx.save(), a = kR(i, n), o = _2(i, n), s === 2 && (this.path(o), this.ctx.clip()), Pn(o[0]) ? (l = o[0].start.x, u = o[0].start.y) : (l = o[0].x, u = o[0].y), Pn(o[1]) ? (c = o[1].end.x, f = o[1].end.y) : (c = o[1].x, f = o[1].y), n === 0 || n === 2 ? h = Math.abs(l - c) : h = Math.abs(u - f), this.ctx.beginPath(), s === 3 ? this.formatPath(a) : this.formatPath(o.slice(0, 2)), g = A < 3 ? A * 3 : A * 2, p = A < 3 ? A * 2 : A, s === 3 && (g = A, p = A), v = !0, h <= g * 2 ? v = !1 : h <= g * 2 + p ? (w = h / (2 * g + p), g *= w, p *= w) : (b = Math.floor((h + p) / (g + p)), S = (h - b * g) / (b - 1), B = (h - (b + 1) * g) / b, p = B <= 0 || Math.abs(p - S) < Math.abs(p - B) ? S : B), v && (s === 3 ? this.ctx.setLineDash([0, g + p]) : this.ctx.setLineDash([g, p])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = A) : this.ctx.lineWidth = A * 2 + 1.1, this.ctx.strokeStyle = vA(t), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (Pn(o[0]) && (x = o[3], U = o[0], this.ctx.beginPath(), this.formatPath([new qe(x.end.x, x.end.y), new qe(U.start.x, U.start.y)]), this.ctx.stroke()), Pn(o[1]) && (x = o[1], U = o[2], this.ctx.beginPath(), this.formatPath([new qe(x.end.x, x.end.y), new qe(U.start.x, U.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.render = function(t) {
      return WA(this, void 0, void 0, function() {
        var A;
        return MA(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = vA(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), A = OR(t), [4, this.renderStack(A)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, e;
  })(EE)
), WR = function(r) {
  return r instanceof lE || r instanceof oE ? !0 : r instanceof xv && r.type !== Qh && r.type !== Ih;
}, XR = function(r, e) {
  switch (r) {
    case 0:
      return Th(e);
    case 2:
      return IR(e);
    default:
      return Ph(e);
  }
}, YR = function(r) {
  switch (r) {
    case 1:
      return "center";
    case 2:
      return "right";
    default:
      return "left";
  }
}, $R = ["-apple-system", "system-ui"], JR = function(r) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? r.filter(function(e) {
    return $R.indexOf(e) === -1;
  }) : r;
}, ZR = (
  /** @class */
  (function(r) {
    ui(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.canvas = A.canvas ? A.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = A, n.canvas.width = Math.floor(A.width * A.scale), n.canvas.height = Math.floor(A.height * A.scale), n.canvas.style.width = A.width + "px", n.canvas.style.height = A.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-A.x, -A.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + A.width + "x" + A.height + " at " + A.x + "," + A.y + ") with scale " + A.scale), n;
    }
    return e.prototype.render = function(t) {
      return WA(this, void 0, void 0, function() {
        var A, n;
        return MA(this, function(i) {
          switch (i.label) {
            case 0:
              return A = Um(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, ek(A)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = vA(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, e;
  })(EE)
), ek = function(r) {
  return new Promise(function(e, t) {
    var A = new Image();
    A.onload = function() {
      e(A);
    }, A.onerror = t, A.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(r));
  });
}, tk = (
  /** @class */
  (function() {
    function r(e) {
      var t = e.id, A = e.enabled;
      this.id = t, this.enabled = A, this.start = Date.now();
    }
    return r.prototype.debug = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, Fc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.prototype.getTime = function() {
      return Date.now() - this.start;
    }, r.prototype.info = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, Fc([this.id, this.getTime() + "ms"], e));
    }, r.prototype.warn = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, Fc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.prototype.error = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, Fc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.instances = {}, r;
  })()
), rk = (
  /** @class */
  (function() {
    function r(e, t) {
      var A;
      this.windowBounds = t, this.instanceName = "#" + r.instanceCount++, this.logger = new tk({ id: this.instanceName, enabled: e.logging }), this.cache = (A = e.cache) !== null && A !== void 0 ? A : new BR(this, e);
    }
    return r.instanceCount = 1, r;
  })()
), Ak = function(r, e) {
  return e === void 0 && (e = {}), nk(r, e);
};
typeof window < "u" && yE.setContext(window);
var nk = function(r, e) {
  return WA(void 0, void 0, void 0, function() {
    var t, A, n, i, s, a, o, l, u, c, f, h, g, p, v, w, b, S, B, x, Q, U, Q, N, _, R, F, O, G, H, $, ne, te, J, re, le, se, P, V, X;
    return MA(this, function(Y) {
      switch (Y.label) {
        case 0:
          if (!r || typeof r != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (t = r.ownerDocument, !t)
            throw new Error("Element is not attached to a Document");
          if (A = t.defaultView, !A)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (N = e.allowTaint) !== null && N !== void 0 ? N : !1,
            imageTimeout: (_ = e.imageTimeout) !== null && _ !== void 0 ? _ : 15e3,
            proxy: e.proxy,
            useCORS: (R = e.useCORS) !== null && R !== void 0 ? R : !1
          }, i = dm({ logging: (F = e.logging) !== null && F !== void 0 ? F : !0, cache: e.cache }, n), s = {
            windowWidth: (O = e.windowWidth) !== null && O !== void 0 ? O : A.innerWidth,
            windowHeight: (G = e.windowHeight) !== null && G !== void 0 ? G : A.innerHeight,
            scrollX: (H = e.scrollX) !== null && H !== void 0 ? H : A.pageXOffset,
            scrollY: ($ = e.scrollY) !== null && $ !== void 0 ? $ : A.pageYOffset
          }, a = new ls(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), o = new rk(i, a), l = (ne = e.foreignObjectRendering) !== null && ne !== void 0 ? ne : !1, u = {
            allowTaint: (te = e.allowTaint) !== null && te !== void 0 ? te : !1,
            onclone: e.onclone,
            ignoreElements: e.ignoreElements,
            inlineImages: l,
            copyStyles: l
          }, o.logger.debug("Starting document clone with size " + a.width + "x" + a.height + " scrolled to " + -a.left + "," + -a.top), c = new x2(o, r, u), f = c.clonedReferenceElement, f ? [4, c.toIFrame(t, a)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return h = Y.sent(), g = Ev(f) || iR(f) ? PN(f.ownerDocument) : qh(o, f), p = g.width, v = g.height, w = g.left, b = g.top, S = ik(o, f, e.backgroundColor), B = {
            canvas: e.canvas,
            backgroundColor: S,
            scale: (re = (J = e.scale) !== null && J !== void 0 ? J : A.devicePixelRatio) !== null && re !== void 0 ? re : 1,
            x: ((le = e.x) !== null && le !== void 0 ? le : 0) + w,
            y: ((se = e.y) !== null && se !== void 0 ? se : 0) + b,
            width: (P = e.width) !== null && P !== void 0 ? P : Math.ceil(p),
            height: (V = e.height) !== null && V !== void 0 ? V : Math.ceil(v)
          }, l ? (o.logger.debug("Document cloned, using foreign object rendering"), Q = new ZR(o, B), [4, Q.render(f)]) : [3, 3];
        case 2:
          return x = Y.sent(), [3, 5];
        case 3:
          return o.logger.debug("Document cloned, element located at " + w + "," + b + " with size " + p + "x" + v + " using computed rendering"), o.logger.debug("Starting DOM parsing"), U = hE(o, f), S === U.styles.backgroundColor && (U.styles.backgroundColor = is.TRANSPARENT), o.logger.debug("Starting renderer for element at " + B.x + "," + B.y + " with size " + B.width + "x" + B.height), Q = new zR(o, B), [4, Q.render(U)];
        case 4:
          x = Y.sent(), Y.label = 5;
        case 5:
          return (!((X = e.removeContainer) !== null && X !== void 0) || X) && (x2.destroy(h) || o.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), o.logger.debug("Finished rendering"), [2, x];
      }
    });
  });
}, ik = function(r, e, t) {
  var A = e.ownerDocument, n = A.documentElement ? Yl(r, getComputedStyle(A.documentElement).backgroundColor) : is.TRANSPARENT, i = A.body ? Yl(r, getComputedStyle(A.body).backgroundColor) : is.TRANSPARENT, s = typeof t == "string" ? Yl(r, t) : t === null ? is.TRANSPARENT : 4294967295;
  return e === A.documentElement ? js(n) ? js(i) ? s : i : n : s;
};
const sk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ak
}, Symbol.toStringTag, { value: "Module" }));
const {
  entries: FE,
  setPrototypeOf: I2,
  isFrozen: ak,
  getPrototypeOf: ok,
  getOwnPropertyDescriptor: lk
} = Object;
let {
  freeze: XA,
  seal: Vn,
  create: _E
} = Object, {
  apply: Om,
  construct: Mm
} = typeof Reflect < "u" && Reflect;
XA || (XA = function(e) {
  return e;
});
Vn || (Vn = function(e) {
  return e;
});
Om || (Om = function(e, t, A) {
  return e.apply(t, A);
});
Mm || (Mm = function(e, t) {
  return new e(...t);
});
const Yc = YA(Array.prototype.forEach), uk = YA(Array.prototype.lastIndexOf), Q2 = YA(Array.prototype.pop), Cl = YA(Array.prototype.push), ck = YA(Array.prototype.splice), dh = YA(String.prototype.toLowerCase), rg = YA(String.prototype.toString), L2 = YA(String.prototype.match), Sl = YA(String.prototype.replace), hk = YA(String.prototype.indexOf), fk = YA(String.prototype.trim), Ai = YA(Object.prototype.hasOwnProperty), zA = YA(RegExp.prototype.test), xl = dk(TypeError);
function YA(r) {
  return function(e) {
    for (var t = arguments.length, A = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      A[n - 1] = arguments[n];
    return Om(r, e, A);
  };
}
function dk(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), A = 0; A < e; A++)
      t[A] = arguments[A];
    return Mm(r, t);
  };
}
function Pt(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : dh;
  I2 && I2(r, null);
  let A = e.length;
  for (; A--; ) {
    let n = e[A];
    if (typeof n == "string") {
      const i = t(n);
      i !== n && (ak(e) || (e[A] = i), n = i);
    }
    r[n] = !0;
  }
  return r;
}
function gk(r) {
  for (let e = 0; e < r.length; e++)
    Ai(r, e) || (r[e] = null);
  return r;
}
function xa(r) {
  const e = _E(null);
  for (const [t, A] of FE(r))
    Ai(r, t) && (Array.isArray(A) ? e[t] = gk(A) : A && typeof A == "object" && A.constructor === Object ? e[t] = xa(A) : e[t] = A);
  return e;
}
function El(r, e) {
  for (; r !== null; ) {
    const A = lk(r, e);
    if (A) {
      if (A.get)
        return YA(A.get);
      if (typeof A.value == "function")
        return YA(A.value);
    }
    r = ok(r);
  }
  function t() {
    return null;
  }
  return t;
}
const N2 = XA(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ag = XA(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ng = XA(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), pk = XA(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ig = XA(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), mk = XA(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), T2 = XA(["#text"]), P2 = XA(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), sg = XA(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), O2 = XA(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), $c = XA(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), vk = Vn(/\{\{[\w\W]*|[\w\W]*\}\}/gm), wk = Vn(/<%[\w\W]*|[\w\W]*%>/gm), yk = Vn(/\$\{[\w\W]*/gm), bk = Vn(/^data-[\-\w.\u00B7-\uFFFF]+$/), Bk = Vn(/^aria-[\-\w]+$/), UE = Vn(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Ck = Vn(/^(?:\w+script|data):/i), Sk = Vn(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), IE = Vn(/^html$/i), xk = Vn(/^[a-z][.\w]*(-[.\w]+)+$/i);
var M2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Bk,
  ATTR_WHITESPACE: Sk,
  CUSTOM_ELEMENT: xk,
  DATA_ATTR: bk,
  DOCTYPE_NAME: IE,
  ERB_EXPR: wk,
  IS_ALLOWED_URI: UE,
  IS_SCRIPT_OR_DATA: Ck,
  MUSTACHE_EXPR: vk,
  TMPLIT_EXPR: yk
});
const Fl = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Ek = function() {
  return typeof window > "u" ? null : window;
}, Fk = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let A = null;
  const n = "data-tt-policy-suffix";
  t && t.hasAttribute(n) && (A = t.getAttribute(n));
  const i = "dompurify" + (A ? "#" + A : "");
  try {
    return e.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, R2 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function QE() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ek();
  const e = (Je) => QE(Je);
  if (e.version = "3.2.4", e.removed = [], !r || !r.document || r.document.nodeType !== Fl.document || !r.Element)
    return e.isSupported = !1, e;
  let {
    document: t
  } = r;
  const A = t, n = A.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: s,
    Node: a,
    Element: o,
    NodeFilter: l,
    NamedNodeMap: u = r.NamedNodeMap || r.MozNamedAttrMap,
    HTMLFormElement: c,
    DOMParser: f,
    trustedTypes: h
  } = r, g = o.prototype, p = El(g, "cloneNode"), v = El(g, "remove"), w = El(g, "nextSibling"), b = El(g, "childNodes"), S = El(g, "parentNode");
  if (typeof s == "function") {
    const Je = t.createElement("template");
    Je.content && Je.content.ownerDocument && (t = Je.content.ownerDocument);
  }
  let B, x = "";
  const {
    implementation: U,
    createNodeIterator: Q,
    createDocumentFragment: N,
    getElementsByTagName: _
  } = t, {
    importNode: R
  } = A;
  let F = R2();
  e.isSupported = typeof FE == "function" && typeof S == "function" && U && U.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: O,
    ERB_EXPR: G,
    TMPLIT_EXPR: H,
    DATA_ATTR: $,
    ARIA_ATTR: ne,
    IS_SCRIPT_OR_DATA: te,
    ATTR_WHITESPACE: J,
    CUSTOM_ELEMENT: re
  } = M2;
  let {
    IS_ALLOWED_URI: le
  } = M2, se = null;
  const P = Pt({}, [...N2, ...Ag, ...ng, ...ig, ...T2]);
  let V = null;
  const X = Pt({}, [...P2, ...sg, ...O2, ...$c]);
  let Y = Object.seal(_E(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ee = null, oe = null, ge = !0, pe = !0, me = !1, Ee = !0, Ne = !1, Te = !0, Ge = !1, j = !1, Pe = !1, ft = !1, tt = !1, xe = !1, At = !0, ke = !1;
  const We = "user-content-";
  let ze = !0, Ce = !1, Oe = {}, Re = null;
  const Ke = Pt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Xe = null;
  const Ve = Pt({}, ["audio", "video", "img", "source", "image", "track"]);
  let dt = null;
  const je = Pt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Tt = "http://www.w3.org/1998/Math/MathML", Et = "http://www.w3.org/2000/svg", mt = "http://www.w3.org/1999/xhtml";
  let yt = mt, qt = !1, it = null;
  const zt = Pt({}, [Tt, Et, mt], rg);
  let lt = Pt({}, ["mi", "mo", "mn", "ms", "mtext"]), wt = Pt({}, ["annotation-xml"]);
  const Zt = Pt({}, ["title", "style", "font", "a", "script"]);
  let ut = null;
  const bt = ["application/xhtml+xml", "text/html"], Wt = "text/html";
  let fr = null, Er = null;
  const jn = t.createElement("form"), cn = function(ie) {
    return ie instanceof RegExp || ie instanceof Function;
  }, vt = function() {
    let ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Er && Er === ie)) {
      if ((!ie || typeof ie != "object") && (ie = {}), ie = xa(ie), ut = // eslint-disable-next-line unicorn/prefer-includes
      bt.indexOf(ie.PARSER_MEDIA_TYPE) === -1 ? Wt : ie.PARSER_MEDIA_TYPE, fr = ut === "application/xhtml+xml" ? rg : dh, se = Ai(ie, "ALLOWED_TAGS") ? Pt({}, ie.ALLOWED_TAGS, fr) : P, V = Ai(ie, "ALLOWED_ATTR") ? Pt({}, ie.ALLOWED_ATTR, fr) : X, it = Ai(ie, "ALLOWED_NAMESPACES") ? Pt({}, ie.ALLOWED_NAMESPACES, rg) : zt, dt = Ai(ie, "ADD_URI_SAFE_ATTR") ? Pt(xa(je), ie.ADD_URI_SAFE_ATTR, fr) : je, Xe = Ai(ie, "ADD_DATA_URI_TAGS") ? Pt(xa(Ve), ie.ADD_DATA_URI_TAGS, fr) : Ve, Re = Ai(ie, "FORBID_CONTENTS") ? Pt({}, ie.FORBID_CONTENTS, fr) : Ke, ee = Ai(ie, "FORBID_TAGS") ? Pt({}, ie.FORBID_TAGS, fr) : {}, oe = Ai(ie, "FORBID_ATTR") ? Pt({}, ie.FORBID_ATTR, fr) : {}, Oe = Ai(ie, "USE_PROFILES") ? ie.USE_PROFILES : !1, ge = ie.ALLOW_ARIA_ATTR !== !1, pe = ie.ALLOW_DATA_ATTR !== !1, me = ie.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = ie.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ne = ie.SAFE_FOR_TEMPLATES || !1, Te = ie.SAFE_FOR_XML !== !1, Ge = ie.WHOLE_DOCUMENT || !1, ft = ie.RETURN_DOM || !1, tt = ie.RETURN_DOM_FRAGMENT || !1, xe = ie.RETURN_TRUSTED_TYPE || !1, Pe = ie.FORCE_BODY || !1, At = ie.SANITIZE_DOM !== !1, ke = ie.SANITIZE_NAMED_PROPS || !1, ze = ie.KEEP_CONTENT !== !1, Ce = ie.IN_PLACE || !1, le = ie.ALLOWED_URI_REGEXP || UE, yt = ie.NAMESPACE || mt, lt = ie.MATHML_TEXT_INTEGRATION_POINTS || lt, wt = ie.HTML_INTEGRATION_POINTS || wt, Y = ie.CUSTOM_ELEMENT_HANDLING || {}, ie.CUSTOM_ELEMENT_HANDLING && cn(ie.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Y.tagNameCheck = ie.CUSTOM_ELEMENT_HANDLING.tagNameCheck), ie.CUSTOM_ELEMENT_HANDLING && cn(ie.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Y.attributeNameCheck = ie.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), ie.CUSTOM_ELEMENT_HANDLING && typeof ie.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Y.allowCustomizedBuiltInElements = ie.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ne && (pe = !1), tt && (ft = !0), Oe && (se = Pt({}, T2), V = [], Oe.html === !0 && (Pt(se, N2), Pt(V, P2)), Oe.svg === !0 && (Pt(se, Ag), Pt(V, sg), Pt(V, $c)), Oe.svgFilters === !0 && (Pt(se, ng), Pt(V, sg), Pt(V, $c)), Oe.mathMl === !0 && (Pt(se, ig), Pt(V, O2), Pt(V, $c))), ie.ADD_TAGS && (se === P && (se = xa(se)), Pt(se, ie.ADD_TAGS, fr)), ie.ADD_ATTR && (V === X && (V = xa(V)), Pt(V, ie.ADD_ATTR, fr)), ie.ADD_URI_SAFE_ATTR && Pt(dt, ie.ADD_URI_SAFE_ATTR, fr), ie.FORBID_CONTENTS && (Re === Ke && (Re = xa(Re)), Pt(Re, ie.FORBID_CONTENTS, fr)), ze && (se["#text"] = !0), Ge && Pt(se, ["html", "head", "body"]), se.table && (Pt(se, ["tbody"]), delete ee.tbody), ie.TRUSTED_TYPES_POLICY) {
        if (typeof ie.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw xl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof ie.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw xl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        B = ie.TRUSTED_TYPES_POLICY, x = B.createHTML("");
      } else
        B === void 0 && (B = Fk(h, n)), B !== null && typeof x == "string" && (x = B.createHTML(""));
      XA && XA(ie), Er = ie;
    }
  }, En = Pt({}, [...Ag, ...ng, ...pk]), Fn = Pt({}, [...ig, ...mk]), ZA = function(ie) {
    let Qe = S(ie);
    (!Qe || !Qe.tagName) && (Qe = {
      namespaceURI: yt,
      tagName: "template"
    });
    const $e = dh(ie.tagName), $t = dh(Qe.tagName);
    return it[ie.namespaceURI] ? ie.namespaceURI === Et ? Qe.namespaceURI === mt ? $e === "svg" : Qe.namespaceURI === Tt ? $e === "svg" && ($t === "annotation-xml" || lt[$t]) : !!En[$e] : ie.namespaceURI === Tt ? Qe.namespaceURI === mt ? $e === "math" : Qe.namespaceURI === Et ? $e === "math" && wt[$t] : !!Fn[$e] : ie.namespaceURI === mt ? Qe.namespaceURI === Et && !wt[$t] || Qe.namespaceURI === Tt && !lt[$t] ? !1 : !Fn[$e] && (Zt[$e] || !En[$e]) : !!(ut === "application/xhtml+xml" && it[ie.namespaceURI]) : !1;
  }, Fr = function(ie) {
    Cl(e.removed, {
      element: ie
    });
    try {
      S(ie).removeChild(ie);
    } catch {
      v(ie);
    }
  }, ar = function(ie, Qe) {
    try {
      Cl(e.removed, {
        attribute: Qe.getAttributeNode(ie),
        from: Qe
      });
    } catch {
      Cl(e.removed, {
        attribute: null,
        from: Qe
      });
    }
    if (Qe.removeAttribute(ie), ie === "is")
      if (ft || tt)
        try {
          Fr(Qe);
        } catch {
        }
      else
        try {
          Qe.setAttribute(ie, "");
        } catch {
        }
  }, Mr = function(ie) {
    let Qe = null, $e = null;
    if (Pe)
      ie = "<remove></remove>" + ie;
    else {
      const _r = L2(ie, /^[\r\n\t ]+/);
      $e = _r && _r[0];
    }
    ut === "application/xhtml+xml" && yt === mt && (ie = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ie + "</body></html>");
    const $t = B ? B.createHTML(ie) : ie;
    if (yt === mt)
      try {
        Qe = new f().parseFromString($t, ut);
      } catch {
      }
    if (!Qe || !Qe.documentElement) {
      Qe = U.createDocument(yt, "template", null);
      try {
        Qe.documentElement.innerHTML = qt ? x : $t;
      } catch {
      }
    }
    const Zr = Qe.body || Qe.documentElement;
    return ie && $e && Zr.insertBefore(t.createTextNode($e), Zr.childNodes[0] || null), yt === mt ? _.call(Qe, Ge ? "html" : "body")[0] : Ge ? Qe.documentElement : Zr;
  }, Jr = function(ie) {
    return Q.call(
      ie.ownerDocument || ie,
      ie,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, qn = function(ie) {
    return ie instanceof c && (typeof ie.nodeName != "string" || typeof ie.textContent != "string" || typeof ie.removeChild != "function" || !(ie.attributes instanceof u) || typeof ie.removeAttribute != "function" || typeof ie.setAttribute != "function" || typeof ie.namespaceURI != "string" || typeof ie.insertBefore != "function" || typeof ie.hasChildNodes != "function");
  }, zn = function(ie) {
    return typeof a == "function" && ie instanceof a;
  };
  function Rr(Je, ie, Qe) {
    Yc(Je, ($e) => {
      $e.call(e, ie, Qe, Er);
    });
  }
  const hn = function(ie) {
    let Qe = null;
    if (Rr(F.beforeSanitizeElements, ie, null), qn(ie))
      return Fr(ie), !0;
    const $e = fr(ie.nodeName);
    if (Rr(F.uponSanitizeElement, ie, {
      tagName: $e,
      allowedTags: se
    }), ie.hasChildNodes() && !zn(ie.firstElementChild) && zA(/<[/\w]/g, ie.innerHTML) && zA(/<[/\w]/g, ie.textContent) || ie.nodeType === Fl.progressingInstruction || Te && ie.nodeType === Fl.comment && zA(/<[/\w]/g, ie.data))
      return Fr(ie), !0;
    if (!se[$e] || ee[$e]) {
      if (!ee[$e] && tn($e) && (Y.tagNameCheck instanceof RegExp && zA(Y.tagNameCheck, $e) || Y.tagNameCheck instanceof Function && Y.tagNameCheck($e)))
        return !1;
      if (ze && !Re[$e]) {
        const $t = S(ie) || ie.parentNode, Zr = b(ie) || ie.childNodes;
        if (Zr && $t) {
          const _r = Zr.length;
          for (let aA = _r - 1; aA >= 0; --aA) {
            const GA = p(Zr[aA], !0);
            GA.__removalCount = (ie.__removalCount || 0) + 1, $t.insertBefore(GA, w(ie));
          }
        }
      }
      return Fr(ie), !0;
    }
    return ie instanceof o && !ZA(ie) || ($e === "noscript" || $e === "noembed" || $e === "noframes") && zA(/<\/no(script|embed|frames)/i, ie.innerHTML) ? (Fr(ie), !0) : (Ne && ie.nodeType === Fl.text && (Qe = ie.textContent, Yc([O, G, H], ($t) => {
      Qe = Sl(Qe, $t, " ");
    }), ie.textContent !== Qe && (Cl(e.removed, {
      element: ie.cloneNode()
    }), ie.textContent = Qe)), Rr(F.afterSanitizeElements, ie, null), !1);
  }, en = function(ie, Qe, $e) {
    if (At && (Qe === "id" || Qe === "name") && ($e in t || $e in jn))
      return !1;
    if (!(pe && !oe[Qe] && zA($, Qe))) {
      if (!(ge && zA(ne, Qe))) {
        if (!V[Qe] || oe[Qe]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(tn(ie) && (Y.tagNameCheck instanceof RegExp && zA(Y.tagNameCheck, ie) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(ie)) && (Y.attributeNameCheck instanceof RegExp && zA(Y.attributeNameCheck, Qe) || Y.attributeNameCheck instanceof Function && Y.attributeNameCheck(Qe)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Qe === "is" && Y.allowCustomizedBuiltInElements && (Y.tagNameCheck instanceof RegExp && zA(Y.tagNameCheck, $e) || Y.tagNameCheck instanceof Function && Y.tagNameCheck($e)))
          ) return !1;
        } else if (!dt[Qe]) {
          if (!zA(le, Sl($e, J, ""))) {
            if (!((Qe === "src" || Qe === "xlink:href" || Qe === "href") && ie !== "script" && hk($e, "data:") === 0 && Xe[ie])) {
              if (!(me && !zA(te, Sl($e, J, "")))) {
                if ($e)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, tn = function(ie) {
    return ie !== "annotation-xml" && L2(ie, re);
  }, DA = function(ie) {
    Rr(F.beforeSanitizeAttributes, ie, null);
    const {
      attributes: Qe
    } = ie;
    if (!Qe || qn(ie))
      return;
    const $e = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: V,
      forceKeepAttr: void 0
    };
    let $t = Qe.length;
    for (; $t--; ) {
      const Zr = Qe[$t], {
        name: _r,
        namespaceURI: aA,
        value: GA
      } = Zr, mA = fr(_r);
      let kr = _r === "value" ? GA : fk(GA);
      if ($e.attrName = mA, $e.attrValue = kr, $e.keepAttr = !0, $e.forceKeepAttr = void 0, Rr(F.uponSanitizeAttribute, ie, $e), kr = $e.attrValue, ke && (mA === "id" || mA === "name") && (ar(_r, ie), kr = We + kr), Te && zA(/((--!?|])>)|<\/(style|title)/i, kr)) {
        ar(_r, ie);
        continue;
      }
      if ($e.forceKeepAttr || (ar(_r, ie), !$e.keepAttr))
        continue;
      if (!Ee && zA(/\/>/i, kr)) {
        ar(_r, ie);
        continue;
      }
      Ne && Yc([O, G, H], (ds) => {
        kr = Sl(kr, ds, " ");
      });
      const Aa = fr(ie.nodeName);
      if (en(Aa, mA, kr)) {
        if (B && typeof h == "object" && typeof h.getAttributeType == "function" && !aA)
          switch (h.getAttributeType(Aa, mA)) {
            case "TrustedHTML": {
              kr = B.createHTML(kr);
              break;
            }
            case "TrustedScriptURL": {
              kr = B.createScriptURL(kr);
              break;
            }
          }
        try {
          aA ? ie.setAttributeNS(aA, _r, kr) : ie.setAttribute(_r, kr), qn(ie) ? Fr(ie) : Q2(e.removed);
        } catch {
        }
      }
    }
    Rr(F.afterSanitizeAttributes, ie, null);
  }, Li = function Je(ie) {
    let Qe = null;
    const $e = Jr(ie);
    for (Rr(F.beforeSanitizeShadowDOM, ie, null); Qe = $e.nextNode(); )
      Rr(F.uponSanitizeShadowNode, Qe, null), hn(Qe), DA(Qe), Qe.content instanceof i && Je(Qe.content);
    Rr(F.afterSanitizeShadowDOM, ie, null);
  };
  return e.sanitize = function(Je) {
    let ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Qe = null, $e = null, $t = null, Zr = null;
    if (qt = !Je, qt && (Je = "<!-->"), typeof Je != "string" && !zn(Je))
      if (typeof Je.toString == "function") {
        if (Je = Je.toString(), typeof Je != "string")
          throw xl("dirty is not a string, aborting");
      } else
        throw xl("toString is not a function");
    if (!e.isSupported)
      return Je;
    if (j || vt(ie), e.removed = [], typeof Je == "string" && (Ce = !1), Ce) {
      if (Je.nodeName) {
        const GA = fr(Je.nodeName);
        if (!se[GA] || ee[GA])
          throw xl("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Je instanceof a)
      Qe = Mr("<!---->"), $e = Qe.ownerDocument.importNode(Je, !0), $e.nodeType === Fl.element && $e.nodeName === "BODY" || $e.nodeName === "HTML" ? Qe = $e : Qe.appendChild($e);
    else {
      if (!ft && !Ne && !Ge && // eslint-disable-next-line unicorn/prefer-includes
      Je.indexOf("<") === -1)
        return B && xe ? B.createHTML(Je) : Je;
      if (Qe = Mr(Je), !Qe)
        return ft ? null : xe ? x : "";
    }
    Qe && Pe && Fr(Qe.firstChild);
    const _r = Jr(Ce ? Je : Qe);
    for (; $t = _r.nextNode(); )
      hn($t), DA($t), $t.content instanceof i && Li($t.content);
    if (Ce)
      return Je;
    if (ft) {
      if (tt)
        for (Zr = N.call(Qe.ownerDocument); Qe.firstChild; )
          Zr.appendChild(Qe.firstChild);
      else
        Zr = Qe;
      return (V.shadowroot || V.shadowrootmode) && (Zr = R.call(A, Zr, !0)), Zr;
    }
    let aA = Ge ? Qe.outerHTML : Qe.innerHTML;
    return Ge && se["!doctype"] && Qe.ownerDocument && Qe.ownerDocument.doctype && Qe.ownerDocument.doctype.name && zA(IE, Qe.ownerDocument.doctype.name) && (aA = "<!DOCTYPE " + Qe.ownerDocument.doctype.name + `>
` + aA), Ne && Yc([O, G, H], (GA) => {
      aA = Sl(aA, GA, " ");
    }), B && xe ? B.createHTML(aA) : aA;
  }, e.setConfig = function() {
    let Je = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    vt(Je), j = !0;
  }, e.clearConfig = function() {
    Er = null, j = !1;
  }, e.isValidAttribute = function(Je, ie, Qe) {
    Er || vt({});
    const $e = fr(Je), $t = fr(ie);
    return en($e, $t, Qe);
  }, e.addHook = function(Je, ie) {
    typeof ie == "function" && Cl(F[Je], ie);
  }, e.removeHook = function(Je, ie) {
    if (ie !== void 0) {
      const Qe = uk(F[Je], ie);
      return Qe === -1 ? void 0 : ck(F[Je], Qe, 1)[0];
    }
    return Q2(F[Je]);
  }, e.removeHooks = function(Je) {
    F[Je] = [];
  }, e.removeAllHooks = function() {
    F = R2();
  }, e;
}
var _k = QE();
const Uk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _k
}, Symbol.toStringTag, { value: "Module" }));
var k2 = {}, H2 = {}, _l, D2;
function xr() {
  if (D2) return _l;
  D2 = 1;
  var r = function(e) {
    return e && e.Math === Math && e;
  };
  return _l = // eslint-disable-next-line es/no-global-this -- safe
  r(typeof globalThis == "object" && globalThis) || r(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  r(typeof self == "object" && self) || r(typeof lm == "object" && lm) || r(typeof _l == "object" && _l) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || Function("return this")(), _l;
}
var ag = {}, og, G2;
function Pr() {
  return G2 || (G2 = 1, og = function(r) {
    try {
      return !!r();
    } catch {
      return !0;
    }
  }), og;
}
var lg, V2;
function ci() {
  if (V2) return lg;
  V2 = 1;
  var r = Pr();
  return lg = !r(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), lg;
}
var ug, K2;
function rf() {
  if (K2) return ug;
  K2 = 1;
  var r = Pr();
  return ug = !r(function() {
    var e = (function() {
    }).bind();
    return typeof e != "function" || e.hasOwnProperty("prototype");
  }), ug;
}
var cg, j2;
function QA() {
  if (j2) return cg;
  j2 = 1;
  var r = rf(), e = Function.prototype.call;
  return cg = r ? e.bind(e) : function() {
    return e.apply(e, arguments);
  }, cg;
}
var hg = {}, q2;
function Ik() {
  if (q2) return hg;
  q2 = 1;
  var r = {}.propertyIsEnumerable, e = Object.getOwnPropertyDescriptor, t = e && !r.call({ 1: 2 }, 1);
  return hg.f = t ? function(n) {
    var i = e(this, n);
    return !!i && i.enumerable;
  } : r, hg;
}
var fg, z2;
function Fv() {
  return z2 || (z2 = 1, fg = function(r, e) {
    return {
      enumerable: !(r & 1),
      configurable: !(r & 2),
      writable: !(r & 4),
      value: e
    };
  }), fg;
}
var dg, W2;
function Or() {
  if (W2) return dg;
  W2 = 1;
  var r = rf(), e = Function.prototype, t = e.call, A = r && e.bind.bind(t, t);
  return dg = r ? A : function(n) {
    return function() {
      return t.apply(n, arguments);
    };
  }, dg;
}
var gg, X2;
function za() {
  if (X2) return gg;
  X2 = 1;
  var r = Or(), e = r({}.toString), t = r("".slice);
  return gg = function(A) {
    return t(e(A), 8, -1);
  }, gg;
}
var pg, Y2;
function LE() {
  if (Y2) return pg;
  Y2 = 1;
  var r = Or(), e = Pr(), t = za(), A = Object, n = r("".split);
  return pg = e(function() {
    return !A("z").propertyIsEnumerable(0);
  }) ? function(i) {
    return t(i) === "String" ? n(i, "") : A(i);
  } : A, pg;
}
var mg, $2;
function Af() {
  return $2 || ($2 = 1, mg = function(r) {
    return r == null;
  }), mg;
}
var vg, J2;
function hi() {
  if (J2) return vg;
  J2 = 1;
  var r = Af(), e = TypeError;
  return vg = function(t) {
    if (r(t)) throw new e("Can't call method on " + t);
    return t;
  }, vg;
}
var wg, Z2;
function xu() {
  if (Z2) return wg;
  Z2 = 1;
  var r = LE(), e = hi();
  return wg = function(t) {
    return r(e(t));
  }, wg;
}
var yg, eb;
function $r() {
  if (eb) return yg;
  eb = 1;
  var r = typeof document == "object" && document.all;
  return yg = typeof r > "u" && r !== void 0 ? function(e) {
    return typeof e == "function" || e === r;
  } : function(e) {
    return typeof e == "function";
  }, yg;
}
var bg, tb;
function un() {
  if (tb) return bg;
  tb = 1;
  var r = $r();
  return bg = function(e) {
    return typeof e == "object" ? e !== null : r(e);
  }, bg;
}
var Bg, rb;
function Wa() {
  if (rb) return Bg;
  rb = 1;
  var r = xr(), e = $r(), t = function(A) {
    return e(A) ? A : void 0;
  };
  return Bg = function(A, n) {
    return arguments.length < 2 ? t(r[A]) : r[A] && r[A][n];
  }, Bg;
}
var Cg, Ab;
function nf() {
  if (Ab) return Cg;
  Ab = 1;
  var r = Or();
  return Cg = r({}.isPrototypeOf), Cg;
}
var Sg, nb;
function Eu() {
  if (nb) return Sg;
  nb = 1;
  var r = xr(), e = r.navigator, t = e && e.userAgent;
  return Sg = t ? String(t) : "", Sg;
}
var xg, ib;
function _v() {
  if (ib) return xg;
  ib = 1;
  var r = xr(), e = Eu(), t = r.process, A = r.Deno, n = t && t.versions || A && A.version, i = n && n.v8, s, a;
  return i && (s = i.split("."), a = s[0] > 0 && s[0] < 4 ? 1 : +(s[0] + s[1])), !a && e && (s = e.match(/Edge\/(\d+)/), (!s || s[1] >= 74) && (s = e.match(/Chrome\/(\d+)/), s && (a = +s[1]))), xg = a, xg;
}
var Eg, sb;
function NE() {
  if (sb) return Eg;
  sb = 1;
  var r = _v(), e = Pr(), t = xr(), A = t.String;
  return Eg = !!Object.getOwnPropertySymbols && !e(function() {
    var n = /* @__PURE__ */ Symbol("symbol detection");
    return !A(n) || !(Object(n) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && r && r < 41;
  }), Eg;
}
var Fg, ab;
function TE() {
  if (ab) return Fg;
  ab = 1;
  var r = NE();
  return Fg = r && !Symbol.sham && typeof Symbol.iterator == "symbol", Fg;
}
var _g, ob;
function PE() {
  if (ob) return _g;
  ob = 1;
  var r = Wa(), e = $r(), t = nf(), A = TE(), n = Object;
  return _g = A ? function(i) {
    return typeof i == "symbol";
  } : function(i) {
    var s = r("Symbol");
    return e(s) && t(s.prototype, n(i));
  }, _g;
}
var Ug, lb;
function sf() {
  if (lb) return Ug;
  lb = 1;
  var r = String;
  return Ug = function(e) {
    try {
      return r(e);
    } catch {
      return "Object";
    }
  }, Ug;
}
var Ig, ub;
function fs() {
  if (ub) return Ig;
  ub = 1;
  var r = $r(), e = sf(), t = TypeError;
  return Ig = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not a function");
  }, Ig;
}
var Qg, cb;
function Vo() {
  if (cb) return Qg;
  cb = 1;
  var r = fs(), e = Af();
  return Qg = function(t, A) {
    var n = t[A];
    return e(n) ? void 0 : r(n);
  }, Qg;
}
var Lg, hb;
function Qk() {
  if (hb) return Lg;
  hb = 1;
  var r = QA(), e = $r(), t = un(), A = TypeError;
  return Lg = function(n, i) {
    var s, a;
    if (i === "string" && e(s = n.toString) && !t(a = r(s, n)) || e(s = n.valueOf) && !t(a = r(s, n)) || i !== "string" && e(s = n.toString) && !t(a = r(s, n))) return a;
    throw new A("Can't convert object to primitive value");
  }, Lg;
}
var Ng = { exports: {} }, Tg, fb;
function Ii() {
  return fb || (fb = 1, Tg = !1), Tg;
}
var Pg, db;
function Uv() {
  if (db) return Pg;
  db = 1;
  var r = xr(), e = Object.defineProperty;
  return Pg = function(t, A) {
    try {
      e(r, t, { value: A, configurable: !0, writable: !0 });
    } catch {
      r[t] = A;
    }
    return A;
  }, Pg;
}
var gb;
function Iv() {
  if (gb) return Ng.exports;
  gb = 1;
  var r = Ii(), e = xr(), t = Uv(), A = "__core-js_shared__", n = Ng.exports = e[A] || t(A, {});
  return (n.versions || (n.versions = [])).push({
    version: "3.47.0",
    mode: r ? "pure" : "global",
    copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), Ng.exports;
}
var Og, pb;
function Qv() {
  if (pb) return Og;
  pb = 1;
  var r = Iv();
  return Og = function(e, t) {
    return r[e] || (r[e] = t || {});
  }, Og;
}
var Mg, mb;
function af() {
  if (mb) return Mg;
  mb = 1;
  var r = hi(), e = Object;
  return Mg = function(t) {
    return e(r(t));
  }, Mg;
}
var Rg, vb;
function fi() {
  if (vb) return Rg;
  vb = 1;
  var r = Or(), e = af(), t = r({}.hasOwnProperty);
  return Rg = Object.hasOwn || function(n, i) {
    return t(e(n), i);
  }, Rg;
}
var kg, wb;
function OE() {
  if (wb) return kg;
  wb = 1;
  var r = Or(), e = 0, t = Math.random(), A = r(1.1.toString);
  return kg = function(n) {
    return "Symbol(" + (n === void 0 ? "" : n) + ")_" + A(++e + t, 36);
  }, kg;
}
var Hg, yb;
function BA() {
  if (yb) return Hg;
  yb = 1;
  var r = xr(), e = Qv(), t = fi(), A = OE(), n = NE(), i = TE(), s = r.Symbol, a = e("wks"), o = i ? s.for || s : s && s.withoutSetter || A;
  return Hg = function(l) {
    return t(a, l) || (a[l] = n && t(s, l) ? s[l] : o("Symbol." + l)), a[l];
  }, Hg;
}
var Dg, bb;
function Lk() {
  if (bb) return Dg;
  bb = 1;
  var r = QA(), e = un(), t = PE(), A = Vo(), n = Qk(), i = BA(), s = TypeError, a = i("toPrimitive");
  return Dg = function(o, l) {
    if (!e(o) || t(o)) return o;
    var u = A(o, a), c;
    if (u) {
      if (l === void 0 && (l = "default"), c = r(u, o, l), !e(c) || t(c)) return c;
      throw new s("Can't convert object to primitive value");
    }
    return l === void 0 && (l = "number"), n(o, l);
  }, Dg;
}
var Gg, Bb;
function ME() {
  if (Bb) return Gg;
  Bb = 1;
  var r = Lk(), e = PE();
  return Gg = function(t) {
    var A = r(t, "string");
    return e(A) ? A : A + "";
  }, Gg;
}
var Vg, Cb;
function of() {
  if (Cb) return Vg;
  Cb = 1;
  var r = xr(), e = un(), t = r.document, A = e(t) && e(t.createElement);
  return Vg = function(n) {
    return A ? t.createElement(n) : {};
  }, Vg;
}
var Kg, Sb;
function RE() {
  if (Sb) return Kg;
  Sb = 1;
  var r = ci(), e = Pr(), t = of();
  return Kg = !r && !e(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), Kg;
}
var xb;
function lf() {
  if (xb) return ag;
  xb = 1;
  var r = ci(), e = QA(), t = Ik(), A = Fv(), n = xu(), i = ME(), s = fi(), a = RE(), o = Object.getOwnPropertyDescriptor;
  return ag.f = r ? o : function(u, c) {
    if (u = n(u), c = i(c), a) try {
      return o(u, c);
    } catch {
    }
    if (s(u, c)) return A(!e(t.f, u, c), u[c]);
  }, ag;
}
var jg = {}, qg, Eb;
function kE() {
  if (Eb) return qg;
  Eb = 1;
  var r = ci(), e = Pr();
  return qg = r && e(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), qg;
}
var zg, Fb;
function $A() {
  if (Fb) return zg;
  Fb = 1;
  var r = un(), e = String, t = TypeError;
  return zg = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not an object");
  }, zg;
}
var _b;
function ta() {
  if (_b) return jg;
  _b = 1;
  var r = ci(), e = RE(), t = kE(), A = $A(), n = ME(), i = TypeError, s = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = "enumerable", l = "configurable", u = "writable";
  return jg.f = r ? t ? function(f, h, g) {
    if (A(f), h = n(h), A(g), typeof f == "function" && h === "prototype" && "value" in g && u in g && !g[u]) {
      var p = a(f, h);
      p && p[u] && (f[h] = g.value, g = {
        configurable: l in g ? g[l] : p[l],
        enumerable: o in g ? g[o] : p[o],
        writable: !1
      });
    }
    return s(f, h, g);
  } : s : function(f, h, g) {
    if (A(f), h = n(h), A(g), e) try {
      return s(f, h, g);
    } catch {
    }
    if ("get" in g || "set" in g) throw new i("Accessors not supported");
    return "value" in g && (f[h] = g.value), f;
  }, jg;
}
var Wg, Ub;
function Fu() {
  if (Ub) return Wg;
  Ub = 1;
  var r = ci(), e = ta(), t = Fv();
  return Wg = r ? function(A, n, i) {
    return e.f(A, n, t(1, i));
  } : function(A, n, i) {
    return A[n] = i, A;
  }, Wg;
}
var Xg = { exports: {} }, Yg, Ib;
function uf() {
  if (Ib) return Yg;
  Ib = 1;
  var r = ci(), e = fi(), t = Function.prototype, A = r && Object.getOwnPropertyDescriptor, n = e(t, "name"), i = n && (function() {
  }).name === "something", s = n && (!r || r && A(t, "name").configurable);
  return Yg = {
    EXISTS: n,
    PROPER: i,
    CONFIGURABLE: s
  }, Yg;
}
var $g, Qb;
function Lv() {
  if (Qb) return $g;
  Qb = 1;
  var r = Or(), e = $r(), t = Iv(), A = r(Function.toString);
  return e(t.inspectSource) || (t.inspectSource = function(n) {
    return A(n);
  }), $g = t.inspectSource, $g;
}
var Jg, Lb;
function Nk() {
  if (Lb) return Jg;
  Lb = 1;
  var r = xr(), e = $r(), t = r.WeakMap;
  return Jg = e(t) && /native code/.test(String(t)), Jg;
}
var Zg, Nb;
function Nv() {
  if (Nb) return Zg;
  Nb = 1;
  var r = Qv(), e = OE(), t = r("keys");
  return Zg = function(A) {
    return t[A] || (t[A] = e(A));
  }, Zg;
}
var ep, Tb;
function Tv() {
  return Tb || (Tb = 1, ep = {}), ep;
}
var tp, Pb;
function cf() {
  if (Pb) return tp;
  Pb = 1;
  var r = Nk(), e = xr(), t = un(), A = Fu(), n = fi(), i = Iv(), s = Nv(), a = Tv(), o = "Object already initialized", l = e.TypeError, u = e.WeakMap, c, f, h, g = function(b) {
    return h(b) ? f(b) : c(b, {});
  }, p = function(b) {
    return function(S) {
      var B;
      if (!t(S) || (B = f(S)).type !== b)
        throw new l("Incompatible receiver, " + b + " required");
      return B;
    };
  };
  if (r || i.state) {
    var v = i.state || (i.state = new u());
    v.get = v.get, v.has = v.has, v.set = v.set, c = function(b, S) {
      if (v.has(b)) throw new l(o);
      return S.facade = b, v.set(b, S), S;
    }, f = function(b) {
      return v.get(b) || {};
    }, h = function(b) {
      return v.has(b);
    };
  } else {
    var w = s("state");
    a[w] = !0, c = function(b, S) {
      if (n(b, w)) throw new l(o);
      return S.facade = b, A(b, w, S), S;
    }, f = function(b) {
      return n(b, w) ? b[w] : {};
    }, h = function(b) {
      return n(b, w);
    };
  }
  return tp = {
    set: c,
    get: f,
    has: h,
    enforce: g,
    getterFor: p
  }, tp;
}
var Ob;
function HE() {
  if (Ob) return Xg.exports;
  Ob = 1;
  var r = Or(), e = Pr(), t = $r(), A = fi(), n = ci(), i = uf().CONFIGURABLE, s = Lv(), a = cf(), o = a.enforce, l = a.get, u = String, c = Object.defineProperty, f = r("".slice), h = r("".replace), g = r([].join), p = n && !e(function() {
    return c(function() {
    }, "length", { value: 8 }).length !== 8;
  }), v = String(String).split("String"), w = Xg.exports = function(b, S, B) {
    f(u(S), 0, 7) === "Symbol(" && (S = "[" + h(u(S), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), B && B.getter && (S = "get " + S), B && B.setter && (S = "set " + S), (!A(b, "name") || i && b.name !== S) && (n ? c(b, "name", { value: S, configurable: !0 }) : b.name = S), p && B && A(B, "arity") && b.length !== B.arity && c(b, "length", { value: B.arity });
    try {
      B && A(B, "constructor") && B.constructor ? n && c(b, "prototype", { writable: !1 }) : b.prototype && (b.prototype = void 0);
    } catch {
    }
    var x = o(b);
    return A(x, "source") || (x.source = g(v, typeof S == "string" ? S : "")), b;
  };
  return Function.prototype.toString = w(function() {
    return t(this) && l(this).source || s(this);
  }, "toString"), Xg.exports;
}
var rp, Mb;
function Xa() {
  if (Mb) return rp;
  Mb = 1;
  var r = $r(), e = ta(), t = HE(), A = Uv();
  return rp = function(n, i, s, a) {
    a || (a = {});
    var o = a.enumerable, l = a.name !== void 0 ? a.name : i;
    if (r(s) && t(s, l, a), a.global)
      o ? n[i] = s : A(i, s);
    else {
      try {
        a.unsafe ? n[i] && (o = !0) : delete n[i];
      } catch {
      }
      o ? n[i] = s : e.f(n, i, {
        value: s,
        enumerable: !1,
        configurable: !a.nonConfigurable,
        writable: !a.nonWritable
      });
    }
    return n;
  }, rp;
}
var Ap = {}, np, Rb;
function Tk() {
  if (Rb) return np;
  Rb = 1;
  var r = Math.ceil, e = Math.floor;
  return np = Math.trunc || function(A) {
    var n = +A;
    return (n > 0 ? e : r)(n);
  }, np;
}
var ip, kb;
function hf() {
  if (kb) return ip;
  kb = 1;
  var r = Tk();
  return ip = function(e) {
    var t = +e;
    return t !== t || t === 0 ? 0 : r(t);
  }, ip;
}
var sp, Hb;
function Pk() {
  if (Hb) return sp;
  Hb = 1;
  var r = hf(), e = Math.max, t = Math.min;
  return sp = function(A, n) {
    var i = r(A);
    return i < 0 ? e(i + n, 0) : t(i, n);
  }, sp;
}
var ap, Db;
function Ko() {
  if (Db) return ap;
  Db = 1;
  var r = hf(), e = Math.min;
  return ap = function(t) {
    var A = r(t);
    return A > 0 ? e(A, 9007199254740991) : 0;
  }, ap;
}
var op, Gb;
function Pv() {
  if (Gb) return op;
  Gb = 1;
  var r = Ko();
  return op = function(e) {
    return r(e.length);
  }, op;
}
var lp, Vb;
function DE() {
  if (Vb) return lp;
  Vb = 1;
  var r = xu(), e = Pk(), t = Pv(), A = function(n) {
    return function(i, s, a) {
      var o = r(i), l = t(o);
      if (l === 0) return !n && -1;
      var u = e(a, l), c;
      if (n && s !== s) {
        for (; l > u; )
          if (c = o[u++], c !== c) return !0;
      } else for (; l > u; u++)
        if ((n || u in o) && o[u] === s) return n || u || 0;
      return !n && -1;
    };
  };
  return lp = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: A(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: A(!1)
  }, lp;
}
var up, Kb;
function GE() {
  if (Kb) return up;
  Kb = 1;
  var r = Or(), e = fi(), t = xu(), A = DE().indexOf, n = Tv(), i = r([].push);
  return up = function(s, a) {
    var o = t(s), l = 0, u = [], c;
    for (c in o) !e(n, c) && e(o, c) && i(u, c);
    for (; a.length > l; ) e(o, c = a[l++]) && (~A(u, c) || i(u, c));
    return u;
  }, up;
}
var cp, jb;
function Ov() {
  return jb || (jb = 1, cp = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), cp;
}
var qb;
function Ok() {
  if (qb) return Ap;
  qb = 1;
  var r = GE(), e = Ov(), t = e.concat("length", "prototype");
  return Ap.f = Object.getOwnPropertyNames || function(n) {
    return r(n, t);
  }, Ap;
}
var hp = {}, zb;
function Mk() {
  return zb || (zb = 1, hp.f = Object.getOwnPropertySymbols), hp;
}
var fp, Wb;
function Rk() {
  if (Wb) return fp;
  Wb = 1;
  var r = Wa(), e = Or(), t = Ok(), A = Mk(), n = $A(), i = e([].concat);
  return fp = r("Reflect", "ownKeys") || function(a) {
    var o = t.f(n(a)), l = A.f;
    return l ? i(o, l(a)) : o;
  }, fp;
}
var dp, Xb;
function kk() {
  if (Xb) return dp;
  Xb = 1;
  var r = fi(), e = Rk(), t = lf(), A = ta();
  return dp = function(n, i, s) {
    for (var a = e(i), o = A.f, l = t.f, u = 0; u < a.length; u++) {
      var c = a[u];
      !r(n, c) && !(s && r(s, c)) && o(n, c, l(i, c));
    }
  }, dp;
}
var gp, Yb;
function VE() {
  if (Yb) return gp;
  Yb = 1;
  var r = Pr(), e = $r(), t = /#|\.prototype\./, A = function(o, l) {
    var u = i[n(o)];
    return u === a ? !0 : u === s ? !1 : e(l) ? r(l) : !!l;
  }, n = A.normalize = function(o) {
    return String(o).replace(t, ".").toLowerCase();
  }, i = A.data = {}, s = A.NATIVE = "N", a = A.POLYFILL = "P";
  return gp = A, gp;
}
var pp, $b;
function JA() {
  if ($b) return pp;
  $b = 1;
  var r = xr(), e = lf().f, t = Fu(), A = Xa(), n = Uv(), i = kk(), s = VE();
  return pp = function(a, o) {
    var l = a.target, u = a.global, c = a.stat, f, h, g, p, v, w;
    if (u ? h = r : c ? h = r[l] || n(l, {}) : h = r[l] && r[l].prototype, h) for (g in o) {
      if (v = o[g], a.dontCallGetSet ? (w = e(h, g), p = w && w.value) : p = h[g], f = s(u ? g : l + (c ? "." : "#") + g, a.forced), !f && p !== void 0) {
        if (typeof v == typeof p) continue;
        i(v, p);
      }
      (a.sham || p && p.sham) && t(v, "sham", !0), A(h, g, v, a);
    }
  }, pp;
}
var mp, Jb;
function KE() {
  if (Jb) return mp;
  Jb = 1;
  var r = xr(), e = Eu(), t = za(), A = function(n) {
    return e.slice(0, n.length) === n;
  };
  return mp = (function() {
    return A("Bun/") ? "BUN" : A("Cloudflare-Workers") ? "CLOUDFLARE" : A("Deno/") ? "DENO" : A("Node.js/") ? "NODE" : r.Bun && typeof Bun.version == "string" ? "BUN" : r.Deno && typeof Deno.version == "object" ? "DENO" : t(r.process) === "process" ? "NODE" : r.window && r.document ? "BROWSER" : "REST";
  })(), mp;
}
var vp, Zb;
function ff() {
  if (Zb) return vp;
  Zb = 1;
  var r = KE();
  return vp = r === "NODE", vp;
}
var wp, eB;
function Hk() {
  if (eB) return wp;
  eB = 1;
  var r = xr();
  return wp = r, wp;
}
var yp, tB;
function Dk() {
  if (tB) return yp;
  tB = 1;
  var r = Or(), e = fs();
  return yp = function(t, A, n) {
    try {
      return r(e(Object.getOwnPropertyDescriptor(t, A)[n]));
    } catch {
    }
  }, yp;
}
var bp, rB;
function Gk() {
  if (rB) return bp;
  rB = 1;
  var r = un();
  return bp = function(e) {
    return r(e) || e === null;
  }, bp;
}
var Bp, AB;
function Vk() {
  if (AB) return Bp;
  AB = 1;
  var r = Gk(), e = String, t = TypeError;
  return Bp = function(A) {
    if (r(A)) return A;
    throw new t("Can't set " + e(A) + " as a prototype");
  }, Bp;
}
var Cp, nB;
function jE() {
  if (nB) return Cp;
  nB = 1;
  var r = Dk(), e = un(), t = hi(), A = Vk();
  return Cp = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
    var n = !1, i = {}, s;
    try {
      s = r(Object.prototype, "__proto__", "set"), s(i, []), n = i instanceof Array;
    } catch {
    }
    return function(o, l) {
      return t(o), A(l), e(o) && (n ? s(o, l) : o.__proto__ = l), o;
    };
  })() : void 0), Cp;
}
var Sp, iB;
function df() {
  if (iB) return Sp;
  iB = 1;
  var r = ta().f, e = fi(), t = BA(), A = t("toStringTag");
  return Sp = function(n, i, s) {
    n && !s && (n = n.prototype), n && !e(n, A) && r(n, A, { configurable: !0, value: i });
  }, Sp;
}
var xp, sB;
function Kk() {
  if (sB) return xp;
  sB = 1;
  var r = HE(), e = ta();
  return xp = function(t, A, n) {
    return n.get && r(n.get, A, { getter: !0 }), n.set && r(n.set, A, { setter: !0 }), e.f(t, A, n);
  }, xp;
}
var Ep, aB;
function jk() {
  if (aB) return Ep;
  aB = 1;
  var r = Wa(), e = Kk(), t = BA(), A = ci(), n = t("species");
  return Ep = function(i) {
    var s = r(i);
    A && s && !s[n] && e(s, n, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, Ep;
}
var Fp, oB;
function qk() {
  if (oB) return Fp;
  oB = 1;
  var r = nf(), e = TypeError;
  return Fp = function(t, A) {
    if (r(A, t)) return t;
    throw new e("Incorrect invocation");
  }, Fp;
}
var _p, lB;
function zk() {
  if (lB) return _p;
  lB = 1;
  var r = BA(), e = r("toStringTag"), t = {};
  return t[e] = "z", _p = String(t) === "[object z]", _p;
}
var Up, uB;
function Mv() {
  if (uB) return Up;
  uB = 1;
  var r = zk(), e = $r(), t = za(), A = BA(), n = A("toStringTag"), i = Object, s = t(/* @__PURE__ */ (function() {
    return arguments;
  })()) === "Arguments", a = function(o, l) {
    try {
      return o[l];
    } catch {
    }
  };
  return Up = r ? t : function(o) {
    var l, u, c;
    return o === void 0 ? "Undefined" : o === null ? "Null" : typeof (u = a(l = i(o), n)) == "string" ? u : s ? t(l) : (c = t(l)) === "Object" && e(l.callee) ? "Arguments" : c;
  }, Up;
}
var Ip, cB;
function Wk() {
  if (cB) return Ip;
  cB = 1;
  var r = Or(), e = Pr(), t = $r(), A = Mv(), n = Wa(), i = Lv(), s = function() {
  }, a = n("Reflect", "construct"), o = /^\s*(?:class|function)\b/, l = r(o.exec), u = !o.test(s), c = function(g) {
    if (!t(g)) return !1;
    try {
      return a(s, [], g), !0;
    } catch {
      return !1;
    }
  }, f = function(g) {
    if (!t(g)) return !1;
    switch (A(g)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return u || !!l(o, i(g));
    } catch {
      return !0;
    }
  };
  return f.sham = !0, Ip = !a || e(function() {
    var h;
    return c(c.call) || !c(Object) || !c(function() {
      h = !0;
    }) || h;
  }) ? f : c, Ip;
}
var Qp, hB;
function Xk() {
  if (hB) return Qp;
  hB = 1;
  var r = Wk(), e = sf(), t = TypeError;
  return Qp = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not a constructor");
  }, Qp;
}
var Lp, fB;
function qE() {
  if (fB) return Lp;
  fB = 1;
  var r = $A(), e = Xk(), t = Af(), A = BA(), n = A("species");
  return Lp = function(i, s) {
    var a = r(i).constructor, o;
    return a === void 0 || t(o = r(a)[n]) ? s : e(o);
  }, Lp;
}
var Np, dB;
function zE() {
  if (dB) return Np;
  dB = 1;
  var r = rf(), e = Function.prototype, t = e.apply, A = e.call;
  return Np = typeof Reflect == "object" && Reflect.apply || (r ? A.bind(t) : function() {
    return A.apply(t, arguments);
  }), Np;
}
var Tp, gB;
function gf() {
  if (gB) return Tp;
  gB = 1;
  var r = za(), e = Or();
  return Tp = function(t) {
    if (r(t) === "Function") return e(t);
  }, Tp;
}
var Pp, pB;
function Rv() {
  if (pB) return Pp;
  pB = 1;
  var r = gf(), e = fs(), t = rf(), A = r(r.bind);
  return Pp = function(n, i) {
    return e(n), i === void 0 ? n : t ? A(n, i) : function() {
      return n.apply(i, arguments);
    };
  }, Pp;
}
var Op, mB;
function WE() {
  if (mB) return Op;
  mB = 1;
  var r = Wa();
  return Op = r("document", "documentElement"), Op;
}
var Mp, vB;
function Yk() {
  if (vB) return Mp;
  vB = 1;
  var r = Or();
  return Mp = r([].slice), Mp;
}
var Rp, wB;
function $k() {
  if (wB) return Rp;
  wB = 1;
  var r = TypeError;
  return Rp = function(e, t) {
    if (e < t) throw new r("Not enough arguments");
    return e;
  }, Rp;
}
var kp, yB;
function XE() {
  if (yB) return kp;
  yB = 1;
  var r = Eu();
  return kp = /(?:ipad|iphone|ipod).*applewebkit/i.test(r), kp;
}
var Hp, bB;
function YE() {
  if (bB) return Hp;
  bB = 1;
  var r = xr(), e = zE(), t = Rv(), A = $r(), n = fi(), i = Pr(), s = WE(), a = Yk(), o = of(), l = $k(), u = XE(), c = ff(), f = r.setImmediate, h = r.clearImmediate, g = r.process, p = r.Dispatch, v = r.Function, w = r.MessageChannel, b = r.String, S = 0, B = {}, x = "onreadystatechange", U, Q, N, _;
  i(function() {
    U = r.location;
  });
  var R = function(H) {
    if (n(B, H)) {
      var $ = B[H];
      delete B[H], $();
    }
  }, F = function(H) {
    return function() {
      R(H);
    };
  }, O = function(H) {
    R(H.data);
  }, G = function(H) {
    r.postMessage(b(H), U.protocol + "//" + U.host);
  };
  return (!f || !h) && (f = function($) {
    l(arguments.length, 1);
    var ne = A($) ? $ : v($), te = a(arguments, 1);
    return B[++S] = function() {
      e(ne, void 0, te);
    }, Q(S), S;
  }, h = function($) {
    delete B[$];
  }, c ? Q = function(H) {
    g.nextTick(F(H));
  } : p && p.now ? Q = function(H) {
    p.now(F(H));
  } : w && !u ? (N = new w(), _ = N.port2, N.port1.onmessage = O, Q = t(_.postMessage, _)) : r.addEventListener && A(r.postMessage) && !r.importScripts && U && U.protocol !== "file:" && !i(G) ? (Q = G, r.addEventListener("message", O, !1)) : x in o("script") ? Q = function(H) {
    s.appendChild(o("script"))[x] = function() {
      s.removeChild(this), R(H);
    };
  } : Q = function(H) {
    setTimeout(F(H), 0);
  }), Hp = {
    set: f,
    clear: h
  }, Hp;
}
var Dp, BB;
function Jk() {
  if (BB) return Dp;
  BB = 1;
  var r = xr(), e = ci(), t = Object.getOwnPropertyDescriptor;
  return Dp = function(A) {
    if (!e) return r[A];
    var n = t(r, A);
    return n && n.value;
  }, Dp;
}
var Gp, CB;
function $E() {
  if (CB) return Gp;
  CB = 1;
  var r = function() {
    this.head = null, this.tail = null;
  };
  return r.prototype = {
    add: function(e) {
      var t = { item: e, next: null }, A = this.tail;
      A ? A.next = t : this.head = t, this.tail = t;
    },
    get: function() {
      var e = this.head;
      if (e) {
        var t = this.head = e.next;
        return t === null && (this.tail = null), e.item;
      }
    }
  }, Gp = r, Gp;
}
var Vp, SB;
function Zk() {
  if (SB) return Vp;
  SB = 1;
  var r = Eu();
  return Vp = /ipad|iphone|ipod/i.test(r) && typeof Pebble < "u", Vp;
}
var Kp, xB;
function e6() {
  if (xB) return Kp;
  xB = 1;
  var r = Eu();
  return Kp = /web0s(?!.*chrome)/i.test(r), Kp;
}
var jp, EB;
function t6() {
  if (EB) return jp;
  EB = 1;
  var r = xr(), e = Jk(), t = Rv(), A = YE().set, n = $E(), i = XE(), s = Zk(), a = e6(), o = ff(), l = r.MutationObserver || r.WebKitMutationObserver, u = r.document, c = r.process, f = r.Promise, h = e("queueMicrotask"), g, p, v, w, b;
  if (!h) {
    var S = new n(), B = function() {
      var x, U;
      for (o && (x = c.domain) && x.exit(); U = S.get(); ) try {
        U();
      } catch (Q) {
        throw S.head && g(), Q;
      }
      x && x.enter();
    };
    !i && !o && !a && l && u ? (p = !0, v = u.createTextNode(""), new l(B).observe(v, { characterData: !0 }), g = function() {
      v.data = p = !p;
    }) : !s && f && f.resolve ? (w = f.resolve(void 0), w.constructor = f, b = t(w.then, w), g = function() {
      b(B);
    }) : o ? g = function() {
      c.nextTick(B);
    } : (A = t(A, r), g = function() {
      A(B);
    }), h = function(x) {
      S.head || g(), S.add(x);
    };
  }
  return jp = h, jp;
}
var qp, FB;
function r6() {
  return FB || (FB = 1, qp = function(r, e) {
    try {
      arguments.length === 1 ? console.error(r) : console.error(r, e);
    } catch {
    }
  }), qp;
}
var zp, _B;
function kv() {
  return _B || (_B = 1, zp = function(r) {
    try {
      return { error: !1, value: r() };
    } catch (e) {
      return { error: !0, value: e };
    }
  }), zp;
}
var Wp, UB;
function _u() {
  if (UB) return Wp;
  UB = 1;
  var r = xr();
  return Wp = r.Promise, Wp;
}
var Xp, IB;
function Uu() {
  if (IB) return Xp;
  IB = 1;
  var r = xr(), e = _u(), t = $r(), A = VE(), n = Lv(), i = BA(), s = KE(), a = Ii(), o = _v(), l = e && e.prototype, u = i("species"), c = !1, f = t(r.PromiseRejectionEvent), h = A("Promise", function() {
    var g = n(e), p = g !== String(e);
    if (!p && o === 66 || a && !(l.catch && l.finally)) return !0;
    if (!o || o < 51 || !/native code/.test(g)) {
      var v = new e(function(S) {
        S(1);
      }), w = function(S) {
        S(function() {
        }, function() {
        });
      }, b = v.constructor = {};
      if (b[u] = w, c = v.then(function() {
      }) instanceof w, !c) return !0;
    }
    return !p && (s === "BROWSER" || s === "DENO") && !f;
  });
  return Xp = {
    CONSTRUCTOR: h,
    REJECTION_EVENT: f,
    SUBCLASSING: c
  }, Xp;
}
var Yp = {}, QB;
function Iu() {
  if (QB) return Yp;
  QB = 1;
  var r = fs(), e = TypeError, t = function(A) {
    var n, i;
    this.promise = new A(function(s, a) {
      if (n !== void 0 || i !== void 0) throw new e("Bad Promise constructor");
      n = s, i = a;
    }), this.resolve = r(n), this.reject = r(i);
  };
  return Yp.f = function(A) {
    return new t(A);
  }, Yp;
}
var LB;
function A6() {
  if (LB) return H2;
  LB = 1;
  var r = JA(), e = Ii(), t = ff(), A = xr(), n = Hk(), i = QA(), s = Xa(), a = jE(), o = df(), l = jk(), u = fs(), c = $r(), f = un(), h = qk(), g = qE(), p = YE().set, v = t6(), w = r6(), b = kv(), S = $E(), B = cf(), x = _u(), U = Uu(), Q = Iu(), N = "Promise", _ = U.CONSTRUCTOR, R = U.REJECTION_EVENT, F = U.SUBCLASSING, O = B.getterFor(N), G = B.set, H = x && x.prototype, $ = x, ne = H, te = A.TypeError, J = A.document, re = A.process, le = Q.f, se = le, P = !!(J && J.createEvent && A.dispatchEvent), V = "unhandledrejection", X = "rejectionhandled", Y = 0, ee = 1, oe = 2, ge = 1, pe = 2, me, Ee, Ne, Te, Ge = function(Ce) {
    var Oe;
    return f(Ce) && c(Oe = Ce.then) ? Oe : !1;
  }, j = function(Ce, Oe) {
    var Re = Oe.value, Ke = Oe.state === ee, Xe = Ke ? Ce.ok : Ce.fail, Ve = Ce.resolve, dt = Ce.reject, je = Ce.domain, Tt, Et, mt;
    try {
      Xe ? (Ke || (Oe.rejection === pe && At(Oe), Oe.rejection = ge), Xe === !0 ? Tt = Re : (je && je.enter(), Tt = Xe(Re), je && (je.exit(), mt = !0)), Tt === Ce.promise ? dt(new te("Promise-chain cycle")) : (Et = Ge(Tt)) ? i(Et, Tt, Ve, dt) : Ve(Tt)) : dt(Re);
    } catch (yt) {
      je && !mt && je.exit(), dt(yt);
    }
  }, Pe = function(Ce, Oe) {
    Ce.notified || (Ce.notified = !0, v(function() {
      for (var Re = Ce.reactions, Ke; Ke = Re.get(); )
        j(Ke, Ce);
      Ce.notified = !1, Oe && !Ce.rejection && tt(Ce);
    }));
  }, ft = function(Ce, Oe, Re) {
    var Ke, Xe;
    P ? (Ke = J.createEvent("Event"), Ke.promise = Oe, Ke.reason = Re, Ke.initEvent(Ce, !1, !0), A.dispatchEvent(Ke)) : Ke = { promise: Oe, reason: Re }, !R && (Xe = A["on" + Ce]) ? Xe(Ke) : Ce === V && w("Unhandled promise rejection", Re);
  }, tt = function(Ce) {
    i(p, A, function() {
      var Oe = Ce.facade, Re = Ce.value, Ke = xe(Ce), Xe;
      if (Ke && (Xe = b(function() {
        t ? re.emit("unhandledRejection", Re, Oe) : ft(V, Oe, Re);
      }), Ce.rejection = t || xe(Ce) ? pe : ge, Xe.error))
        throw Xe.value;
    });
  }, xe = function(Ce) {
    return Ce.rejection !== ge && !Ce.parent;
  }, At = function(Ce) {
    i(p, A, function() {
      var Oe = Ce.facade;
      t ? re.emit("rejectionHandled", Oe) : ft(X, Oe, Ce.value);
    });
  }, ke = function(Ce, Oe, Re) {
    return function(Ke) {
      Ce(Oe, Ke, Re);
    };
  }, We = function(Ce, Oe, Re) {
    Ce.done || (Ce.done = !0, Re && (Ce = Re), Ce.value = Oe, Ce.state = oe, Pe(Ce, !0));
  }, ze = function(Ce, Oe, Re) {
    if (!Ce.done) {
      Ce.done = !0, Re && (Ce = Re);
      try {
        if (Ce.facade === Oe) throw new te("Promise can't be resolved itself");
        var Ke = Ge(Oe);
        Ke ? v(function() {
          var Xe = { done: !1 };
          try {
            i(
              Ke,
              Oe,
              ke(ze, Xe, Ce),
              ke(We, Xe, Ce)
            );
          } catch (Ve) {
            We(Xe, Ve, Ce);
          }
        }) : (Ce.value = Oe, Ce.state = ee, Pe(Ce, !1));
      } catch (Xe) {
        We({ done: !1 }, Xe, Ce);
      }
    }
  };
  if (_ && ($ = function(Oe) {
    h(this, ne), u(Oe), i(me, this);
    var Re = O(this);
    try {
      Oe(ke(ze, Re), ke(We, Re));
    } catch (Ke) {
      We(Re, Ke);
    }
  }, ne = $.prototype, me = function(Oe) {
    G(this, {
      type: N,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new S(),
      rejection: !1,
      state: Y,
      value: null
    });
  }, me.prototype = s(ne, "then", function(Oe, Re) {
    var Ke = O(this), Xe = le(g(this, $));
    return Ke.parent = !0, Xe.ok = c(Oe) ? Oe : !0, Xe.fail = c(Re) && Re, Xe.domain = t ? re.domain : void 0, Ke.state === Y ? Ke.reactions.add(Xe) : v(function() {
      j(Xe, Ke);
    }), Xe.promise;
  }), Ee = function() {
    var Ce = new me(), Oe = O(Ce);
    this.promise = Ce, this.resolve = ke(ze, Oe), this.reject = ke(We, Oe);
  }, Q.f = le = function(Ce) {
    return Ce === $ || Ce === Ne ? new Ee(Ce) : se(Ce);
  }, !e && c(x) && H !== Object.prototype)) {
    Te = H.then, F || s(H, "then", function(Oe, Re) {
      var Ke = this;
      return new $(function(Xe, Ve) {
        i(Te, Ke, Xe, Ve);
      }).then(Oe, Re);
    }, { unsafe: !0 });
    try {
      delete H.constructor;
    } catch {
    }
    a && a(H, ne);
  }
  return r({ global: !0, constructor: !0, wrap: !0, forced: _ }, {
    Promise: $
  }), Ne = n.Promise, o($, N, !1, !0), l(N), H2;
}
var NB = {}, $p, TB;
function Qu() {
  return TB || (TB = 1, $p = {}), $p;
}
var Jp, PB;
function n6() {
  if (PB) return Jp;
  PB = 1;
  var r = BA(), e = Qu(), t = r("iterator"), A = Array.prototype;
  return Jp = function(n) {
    return n !== void 0 && (e.Array === n || A[t] === n);
  }, Jp;
}
var Zp, OB;
function JE() {
  if (OB) return Zp;
  OB = 1;
  var r = Mv(), e = Vo(), t = Af(), A = Qu(), n = BA(), i = n("iterator");
  return Zp = function(s) {
    if (!t(s)) return e(s, i) || e(s, "@@iterator") || A[r(s)];
  }, Zp;
}
var e0, MB;
function i6() {
  if (MB) return e0;
  MB = 1;
  var r = QA(), e = fs(), t = $A(), A = sf(), n = JE(), i = TypeError;
  return e0 = function(s, a) {
    var o = arguments.length < 2 ? n(s) : a;
    if (e(o)) return t(r(o, s));
    throw new i(A(s) + " is not iterable");
  }, e0;
}
var t0, RB;
function s6() {
  if (RB) return t0;
  RB = 1;
  var r = QA(), e = $A(), t = Vo();
  return t0 = function(A, n, i) {
    var s, a;
    e(A);
    try {
      if (s = t(A, "return"), !s) {
        if (n === "throw") throw i;
        return i;
      }
      s = r(s, A);
    } catch (o) {
      a = !0, s = o;
    }
    if (n === "throw") throw i;
    if (a) throw s;
    return e(s), i;
  }, t0;
}
var r0, kB;
function ZE() {
  if (kB) return r0;
  kB = 1;
  var r = Rv(), e = QA(), t = $A(), A = sf(), n = n6(), i = Pv(), s = nf(), a = i6(), o = JE(), l = s6(), u = TypeError, c = function(h, g) {
    this.stopped = h, this.result = g;
  }, f = c.prototype;
  return r0 = function(h, g, p) {
    var v = p && p.that, w = !!(p && p.AS_ENTRIES), b = !!(p && p.IS_RECORD), S = !!(p && p.IS_ITERATOR), B = !!(p && p.INTERRUPTED), x = r(g, v), U, Q, N, _, R, F, O, G = function($) {
      return U && l(U, "normal"), new c(!0, $);
    }, H = function($) {
      return w ? (t($), B ? x($[0], $[1], G) : x($[0], $[1])) : B ? x($, G) : x($);
    };
    if (b)
      U = h.iterator;
    else if (S)
      U = h;
    else {
      if (Q = o(h), !Q) throw new u(A(h) + " is not iterable");
      if (n(Q)) {
        for (N = 0, _ = i(h); _ > N; N++)
          if (R = H(h[N]), R && s(f, R)) return R;
        return new c(!1);
      }
      U = a(h, Q);
    }
    for (F = b ? h.next : U.next; !(O = e(F, U)).done; ) {
      try {
        R = H(O.value);
      } catch ($) {
        l(U, "throw", $);
      }
      if (typeof R == "object" && R && s(f, R)) return R;
    }
    return new c(!1);
  }, r0;
}
var A0, HB;
function a6() {
  if (HB) return A0;
  HB = 1;
  var r = BA(), e = r("iterator"), t = !1;
  try {
    var A = 0, n = {
      next: function() {
        return { done: !!A++ };
      },
      return: function() {
        t = !0;
      }
    };
    n[e] = function() {
      return this;
    }, Array.from(n, function() {
      throw 2;
    });
  } catch {
  }
  return A0 = function(i, s) {
    try {
      if (!s && !t) return !1;
    } catch {
      return !1;
    }
    var a = !1;
    try {
      var o = {};
      o[e] = function() {
        return {
          next: function() {
            return { done: a = !0 };
          }
        };
      }, i(o);
    } catch {
    }
    return a;
  }, A0;
}
var n0, DB;
function eF() {
  if (DB) return n0;
  DB = 1;
  var r = _u(), e = a6(), t = Uu().CONSTRUCTOR;
  return n0 = t || !e(function(A) {
    r.all(A).then(void 0, function() {
    });
  }), n0;
}
var GB;
function o6() {
  if (GB) return NB;
  GB = 1;
  var r = JA(), e = QA(), t = fs(), A = Iu(), n = kv(), i = ZE(), s = eF();
  return r({ target: "Promise", stat: !0, forced: s }, {
    all: function(o) {
      var l = this, u = A.f(l), c = u.resolve, f = u.reject, h = n(function() {
        var g = t(l.resolve), p = [], v = 0, w = 1;
        i(o, function(b) {
          var S = v++, B = !1;
          w++, e(g, l, b).then(function(x) {
            B || (B = !0, p[S] = x, --w || c(p));
          }, f);
        }), --w || c(p);
      });
      return h.error && f(h.value), u.promise;
    }
  }), NB;
}
var VB = {}, KB;
function l6() {
  if (KB) return VB;
  KB = 1;
  var r = JA(), e = Ii(), t = Uu().CONSTRUCTOR, A = _u(), n = Wa(), i = $r(), s = Xa(), a = A && A.prototype;
  if (r({ target: "Promise", proto: !0, forced: t, real: !0 }, {
    catch: function(l) {
      return this.then(void 0, l);
    }
  }), !e && i(A)) {
    var o = n("Promise").prototype.catch;
    a.catch !== o && s(a, "catch", o, { unsafe: !0 });
  }
  return VB;
}
var jB = {}, qB;
function u6() {
  if (qB) return jB;
  qB = 1;
  var r = JA(), e = QA(), t = fs(), A = Iu(), n = kv(), i = ZE(), s = eF();
  return r({ target: "Promise", stat: !0, forced: s }, {
    race: function(o) {
      var l = this, u = A.f(l), c = u.reject, f = n(function() {
        var h = t(l.resolve);
        i(o, function(g) {
          e(h, l, g).then(u.resolve, c);
        });
      });
      return f.error && c(f.value), u.promise;
    }
  }), jB;
}
var zB = {}, WB;
function c6() {
  if (WB) return zB;
  WB = 1;
  var r = JA(), e = Iu(), t = Uu().CONSTRUCTOR;
  return r({ target: "Promise", stat: !0, forced: t }, {
    reject: function(n) {
      var i = e.f(this), s = i.reject;
      return s(n), i.promise;
    }
  }), zB;
}
var XB = {}, i0, YB;
function h6() {
  if (YB) return i0;
  YB = 1;
  var r = $A(), e = un(), t = Iu();
  return i0 = function(A, n) {
    if (r(A), e(n) && n.constructor === A) return n;
    var i = t.f(A), s = i.resolve;
    return s(n), i.promise;
  }, i0;
}
var $B;
function f6() {
  if ($B) return XB;
  $B = 1;
  var r = JA(), e = Wa(), t = Ii(), A = _u(), n = Uu().CONSTRUCTOR, i = h6(), s = e("Promise"), a = t && !n;
  return r({ target: "Promise", stat: !0, forced: t || n }, {
    resolve: function(l) {
      return i(a && this === s ? A : this, l);
    }
  }), XB;
}
var JB;
function d6() {
  return JB || (JB = 1, A6(), o6(), l6(), u6(), c6(), f6()), k2;
}
d6();
function ZB(r, e, t, A, n, i, s) {
  try {
    var a = r[i](s), o = a.value;
  } catch (l) {
    return void t(l);
  }
  a.done ? e(o) : Promise.resolve(o).then(A, n);
}
function us(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(A, n) {
      var i = r.apply(e, t);
      function s(o) {
        ZB(i, A, n, s, a, "next", o);
      }
      function a(o) {
        ZB(i, A, n, s, a, "throw", o);
      }
      s(void 0);
    });
  };
}
var eC = {}, tC = {}, s0, rC;
function Qi() {
  if (rC) return s0;
  rC = 1;
  var r = Mv(), e = String;
  return s0 = function(t) {
    if (r(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return e(t);
  }, s0;
}
var a0, AC;
function tF() {
  if (AC) return a0;
  AC = 1;
  var r = $A();
  return a0 = function() {
    var e = r(this), t = "";
    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
  }, a0;
}
var o0, nC;
function rF() {
  if (nC) return o0;
  nC = 1;
  var r = Pr(), e = xr(), t = e.RegExp, A = r(function() {
    var s = t("a", "y");
    return s.lastIndex = 2, s.exec("abcd") !== null;
  }), n = A || r(function() {
    return !t("a", "y").sticky;
  }), i = A || r(function() {
    var s = t("^r", "gy");
    return s.lastIndex = 2, s.exec("str") !== null;
  });
  return o0 = {
    BROKEN_CARET: i,
    MISSED_STICKY: n,
    UNSUPPORTED_Y: A
  }, o0;
}
var l0 = {}, u0, iC;
function g6() {
  if (iC) return u0;
  iC = 1;
  var r = GE(), e = Ov();
  return u0 = Object.keys || function(A) {
    return r(A, e);
  }, u0;
}
var sC;
function p6() {
  if (sC) return l0;
  sC = 1;
  var r = ci(), e = kE(), t = ta(), A = $A(), n = xu(), i = g6();
  return l0.f = r && !e ? Object.defineProperties : function(a, o) {
    A(a);
    for (var l = n(o), u = i(o), c = u.length, f = 0, h; c > f; ) t.f(a, h = u[f++], l[h]);
    return a;
  }, l0;
}
var c0, aC;
function pf() {
  if (aC) return c0;
  aC = 1;
  var r = $A(), e = p6(), t = Ov(), A = Tv(), n = WE(), i = of(), s = Nv(), a = ">", o = "<", l = "prototype", u = "script", c = s("IE_PROTO"), f = function() {
  }, h = function(b) {
    return o + u + a + b + o + "/" + u + a;
  }, g = function(b) {
    b.write(h("")), b.close();
    var S = b.parentWindow.Object;
    return b = null, S;
  }, p = function() {
    var b = i("iframe"), S = "java" + u + ":", B;
    return b.style.display = "none", n.appendChild(b), b.src = String(S), B = b.contentWindow.document, B.open(), B.write(h("document.F=Object")), B.close(), B.F;
  }, v, w = function() {
    try {
      v = new ActiveXObject("htmlfile");
    } catch {
    }
    w = typeof document < "u" ? document.domain && v ? g(v) : p() : g(v);
    for (var b = t.length; b--; ) delete w[l][t[b]];
    return w();
  };
  return A[c] = !0, c0 = Object.create || function(S, B) {
    var x;
    return S !== null ? (f[l] = r(S), x = new f(), f[l] = null, x[c] = S) : x = w(), B === void 0 ? x : e.f(x, B);
  }, c0;
}
var h0, oC;
function m6() {
  if (oC) return h0;
  oC = 1;
  var r = Pr(), e = xr(), t = e.RegExp;
  return h0 = r(function() {
    var A = t(".", "s");
    return !(A.dotAll && A.test(`
`) && A.flags === "s");
  }), h0;
}
var f0, lC;
function v6() {
  if (lC) return f0;
  lC = 1;
  var r = Pr(), e = xr(), t = e.RegExp;
  return f0 = r(function() {
    var A = t("(?<a>b)", "g");
    return A.exec("b").groups.a !== "b" || "b".replace(A, "$<a>c") !== "bc";
  }), f0;
}
var d0, uC;
function Hv() {
  if (uC) return d0;
  uC = 1;
  var r = QA(), e = Or(), t = Qi(), A = tF(), n = rF(), i = Qv(), s = pf(), a = cf().get, o = m6(), l = v6(), u = i("native-string-replace", String.prototype.replace), c = RegExp.prototype.exec, f = c, h = e("".charAt), g = e("".indexOf), p = e("".replace), v = e("".slice), w = (function() {
    var x = /a/, U = /b*/g;
    return r(c, x, "a"), r(c, U, "a"), x.lastIndex !== 0 || U.lastIndex !== 0;
  })(), b = n.BROKEN_CARET, S = /()??/.exec("")[1] !== void 0, B = w || S || b || o || l;
  return B && (f = function(U) {
    var Q = this, N = a(Q), _ = t(U), R = N.raw, F, O, G, H, $, ne, te;
    if (R)
      return R.lastIndex = Q.lastIndex, F = r(f, R, _), Q.lastIndex = R.lastIndex, F;
    var J = N.groups, re = b && Q.sticky, le = r(A, Q), se = Q.source, P = 0, V = _;
    if (re && (le = p(le, "y", ""), g(le, "g") === -1 && (le += "g"), V = v(_, Q.lastIndex), Q.lastIndex > 0 && (!Q.multiline || Q.multiline && h(_, Q.lastIndex - 1) !== `
`) && (se = "(?: " + se + ")", V = " " + V, P++), O = new RegExp("^(?:" + se + ")", le)), S && (O = new RegExp("^" + se + "$(?!\\s)", le)), w && (G = Q.lastIndex), H = r(c, re ? O : Q, V), re ? H ? (H.input = v(H.input, P), H[0] = v(H[0], P), H.index = Q.lastIndex, Q.lastIndex += H[0].length) : Q.lastIndex = 0 : w && H && (Q.lastIndex = Q.global ? H.index + H[0].length : G), S && H && H.length > 1 && r(u, H[0], O, function() {
      for ($ = 1; $ < arguments.length - 2; $++)
        arguments[$] === void 0 && (H[$] = void 0);
    }), H && J)
      for (H.groups = ne = s(null), $ = 0; $ < J.length; $++)
        te = J[$], ne[te[0]] = H[te[1]];
    return H;
  }), d0 = f, d0;
}
var cC;
function w6() {
  if (cC) return tC;
  cC = 1;
  var r = JA(), e = Hv();
  return r({ target: "RegExp", proto: !0, forced: /./.exec !== e }, {
    exec: e
  }), tC;
}
var g0, hC;
function Dv() {
  if (hC) return g0;
  hC = 1, w6();
  var r = QA(), e = Xa(), t = Hv(), A = Pr(), n = BA(), i = Fu(), s = n("species"), a = RegExp.prototype;
  return g0 = function(o, l, u, c) {
    var f = n(o), h = !A(function() {
      var w = {};
      return w[f] = function() {
        return 7;
      }, ""[o](w) !== 7;
    }), g = h && !A(function() {
      var w = !1, b = /a/;
      if (o === "split") {
        var S = {};
        S[s] = function() {
          return b;
        }, b = { constructor: S, flags: "" }, b[f] = /./[f];
      }
      return b.exec = function() {
        return w = !0, null;
      }, b[f](""), !w;
    });
    if (!h || !g || u) {
      var p = /./[f], v = l(f, ""[o], function(w, b, S, B, x) {
        var U = b.exec;
        return U === t || U === a.exec ? h && !x ? { done: !0, value: r(p, b, S, B) } : { done: !0, value: r(w, S, b, B) } : { done: !1 };
      });
      e(String.prototype, o, v[0]), e(a, f, v[1]);
    }
    c && i(a[f], "sham", !0);
  }, g0;
}
var p0, fC;
function y6() {
  if (fC) return p0;
  fC = 1;
  var r = Or(), e = hf(), t = Qi(), A = hi(), n = r("".charAt), i = r("".charCodeAt), s = r("".slice), a = function(o) {
    return function(l, u) {
      var c = t(A(l)), f = e(u), h = c.length, g, p;
      return f < 0 || f >= h ? o ? "" : void 0 : (g = i(c, f), g < 55296 || g > 56319 || f + 1 === h || (p = i(c, f + 1)) < 56320 || p > 57343 ? o ? n(c, f) : g : o ? s(c, f, f + 2) : (g - 55296 << 10) + (p - 56320) + 65536);
    };
  };
  return p0 = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: a(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: a(!0)
  }, p0;
}
var m0, dC;
function Gv() {
  if (dC) return m0;
  dC = 1;
  var r = y6().charAt;
  return m0 = function(e, t, A) {
    return t + (A ? r(e, t).length : 1);
  }, m0;
}
var v0, gC;
function b6() {
  if (gC) return v0;
  gC = 1;
  var r = xr(), e = Pr(), t = r.RegExp, A = !e(function() {
    var n = !0;
    try {
      t(".", "d");
    } catch {
      n = !1;
    }
    var i = {}, s = "", a = n ? "dgimsy" : "gimsy", o = function(f, h) {
      Object.defineProperty(i, f, { get: function() {
        return s += h, !0;
      } });
    }, l = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
    n && (l.hasIndices = "d");
    for (var u in l) o(u, l[u]);
    var c = Object.getOwnPropertyDescriptor(t.prototype, "flags").get.call(i);
    return c !== a || s !== a;
  });
  return v0 = { correct: A }, v0;
}
var w0, pC;
function Vv() {
  if (pC) return w0;
  pC = 1;
  var r = QA(), e = fi(), t = nf(), A = b6(), n = tF(), i = RegExp.prototype;
  return w0 = A.correct ? function(s) {
    return s.flags;
  } : function(s) {
    return !A.correct && t(i, s) && !e(s, "flags") ? r(n, s) : s.flags;
  }, w0;
}
var y0, mC;
function Kv() {
  if (mC) return y0;
  mC = 1;
  var r = QA(), e = $A(), t = $r(), A = za(), n = Hv(), i = TypeError;
  return y0 = function(s, a) {
    var o = s.exec;
    if (t(o)) {
      var l = r(o, s, a);
      return l !== null && e(l), l;
    }
    if (A(s) === "RegExp") return r(n, s, a);
    throw new i("RegExp#exec called on incompatible receiver");
  }, y0;
}
var vC;
function B6() {
  if (vC) return eC;
  vC = 1;
  var r = QA(), e = Or(), t = Dv(), A = $A(), n = un(), i = Ko(), s = Qi(), a = hi(), o = Vo(), l = Gv(), u = Vv(), c = Kv(), f = e("".indexOf);
  return t("match", function(h, g, p) {
    return [
      // `String.prototype.match` method
      // https://tc39.es/ecma262/#sec-string.prototype.match
      function(w) {
        var b = a(this), S = n(w) ? o(w, h) : void 0;
        return S ? r(S, w, b) : new RegExp(w)[h](s(b));
      },
      // `RegExp.prototype[@@match]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
      function(v) {
        var w = A(this), b = s(v), S = p(g, w, b);
        if (S.done) return S.value;
        var B = s(u(w));
        if (f(B, "g") === -1) return c(w, b);
        var x = f(B, "u") !== -1;
        w.lastIndex = 0;
        for (var U = [], Q = 0, N; (N = c(w, b)) !== null; ) {
          var _ = s(N[0]);
          U[Q] = _, _ === "" && (w.lastIndex = l(b, i(w.lastIndex), x)), Q++;
        }
        return Q === 0 ? null : U;
      }
    ];
  }), eC;
}
B6();
var wC = {}, b0, yC;
function C6() {
  if (yC) return b0;
  yC = 1;
  var r = Or(), e = af(), t = Math.floor, A = r("".charAt), n = r("".replace), i = r("".slice), s = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, a = /\$([$&'`]|\d{1,2})/g;
  return b0 = function(o, l, u, c, f, h) {
    var g = u + o.length, p = c.length, v = a;
    return f !== void 0 && (f = e(f), v = s), n(h, v, function(w, b) {
      var S;
      switch (A(b, 0)) {
        case "$":
          return "$";
        case "&":
          return o;
        case "`":
          return i(l, 0, u);
        case "'":
          return i(l, g);
        case "<":
          S = f[i(b, 1, -1)];
          break;
        default:
          var B = +b;
          if (B === 0) return w;
          if (B > p) {
            var x = t(B / 10);
            return x === 0 ? w : x <= p ? c[x - 1] === void 0 ? A(b, 1) : c[x - 1] + A(b, 1) : w;
          }
          S = c[B - 1];
      }
      return S === void 0 ? "" : S;
    });
  }, b0;
}
var bC;
function S6() {
  if (bC) return wC;
  bC = 1;
  var r = zE(), e = QA(), t = Or(), A = Dv(), n = Pr(), i = $A(), s = $r(), a = un(), o = hf(), l = Ko(), u = Qi(), c = hi(), f = Gv(), h = Vo(), g = C6(), p = Vv(), v = Kv(), w = BA(), b = w("replace"), S = Math.max, B = Math.min, x = t([].concat), U = t([].push), Q = t("".indexOf), N = t("".slice), _ = function(G) {
    return G === void 0 ? G : String(G);
  }, R = (function() {
    return "a".replace(/./, "$0") === "$0";
  })(), F = (function() {
    return /./[b] ? /./[b]("a", "$0") === "" : !1;
  })(), O = !n(function() {
    var G = /./;
    return G.exec = function() {
      var H = [];
      return H.groups = { a: "7" }, H;
    }, "".replace(G, "$<a>") !== "7";
  });
  return A("replace", function(G, H, $) {
    var ne = F ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(J, re) {
        var le = c(this), se = a(J) ? h(J, b) : void 0;
        return se ? e(se, J, le, re) : e(H, u(le), J, re);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(te, J) {
        var re = i(this), le = u(te);
        if (typeof J == "string" && Q(J, ne) === -1 && Q(J, "$<") === -1) {
          var se = $(H, re, le, J);
          if (se.done) return se.value;
        }
        var P = s(J);
        P || (J = u(J));
        var V = u(p(re)), X = Q(V, "g") !== -1, Y;
        X && (Y = Q(V, "u") !== -1, re.lastIndex = 0);
        for (var ee = [], oe; oe = v(re, le), !(oe === null || (U(ee, oe), !X)); ) {
          var ge = u(oe[0]);
          ge === "" && (re.lastIndex = f(le, l(re.lastIndex), Y));
        }
        for (var pe = "", me = 0, Ee = 0; Ee < ee.length; Ee++) {
          oe = ee[Ee];
          for (var Ne = u(oe[0]), Te = S(B(o(oe.index), le.length), 0), Ge = [], j, Pe = 1; Pe < oe.length; Pe++) U(Ge, _(oe[Pe]));
          var ft = oe.groups;
          if (P) {
            var tt = x([Ne], Ge, Te, le);
            ft !== void 0 && U(tt, ft), j = u(r(J, void 0, tt));
          } else
            j = g(Ne, le, Te, Ge, ft, J);
          Te >= me && (pe += N(le, me, Te) + j, me = Te + Ne.length);
        }
        return pe + N(le, me);
      }
    ];
  }, !O || !R || F), wC;
}
S6();
var BC = {}, B0, CC;
function x6() {
  if (CC) return B0;
  CC = 1;
  var r = un(), e = za(), t = BA(), A = t("match");
  return B0 = function(n) {
    var i;
    return r(n) && ((i = n[A]) !== void 0 ? !!i : e(n) === "RegExp");
  }, B0;
}
var C0, SC;
function jv() {
  if (SC) return C0;
  SC = 1;
  var r = x6(), e = TypeError;
  return C0 = function(t) {
    if (r(t))
      throw new e("The method doesn't accept regular expressions");
    return t;
  }, C0;
}
var S0, xC;
function qv() {
  if (xC) return S0;
  xC = 1;
  var r = BA(), e = r("match");
  return S0 = function(t) {
    var A = /./;
    try {
      "/./"[t](A);
    } catch {
      try {
        return A[e] = !1, "/./"[t](A);
      } catch {
      }
    }
    return !1;
  }, S0;
}
var EC;
function E6() {
  if (EC) return BC;
  EC = 1;
  var r = JA(), e = gf(), t = lf().f, A = Ko(), n = Qi(), i = jv(), s = hi(), a = qv(), o = Ii(), l = e("".slice), u = Math.min, c = a("startsWith"), f = !o && !c && !!(function() {
    var h = t(String.prototype, "startsWith");
    return h && !h.writable;
  })();
  return r({ target: "String", proto: !0, forced: !f && !c }, {
    startsWith: function(g) {
      var p = n(s(this));
      i(g);
      var v = A(u(arguments.length > 1 ? arguments[1] : void 0, p.length)), w = n(g);
      return l(p, v, v + w.length) === w;
    }
  }), BC;
}
E6();
var x0, FC;
function F6() {
  if (FC) return x0;
  FC = 1;
  var r = BA(), e = pf(), t = ta().f, A = r("unscopables"), n = Array.prototype;
  return n[A] === void 0 && t(n, A, {
    configurable: !0,
    value: e(null)
  }), x0 = function(i) {
    n[A][i] = !0;
  }, x0;
}
var E0, _C;
function _6() {
  if (_C) return E0;
  _C = 1;
  var r = Pr();
  return E0 = !r(function() {
    function e() {
    }
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }), E0;
}
var F0, UC;
function AF() {
  if (UC) return F0;
  UC = 1;
  var r = fi(), e = $r(), t = af(), A = Nv(), n = _6(), i = A("IE_PROTO"), s = Object, a = s.prototype;
  return F0 = n ? s.getPrototypeOf : function(o) {
    var l = t(o);
    if (r(l, i)) return l[i];
    var u = l.constructor;
    return e(u) && l instanceof u ? u.prototype : l instanceof s ? a : null;
  }, F0;
}
var _0, IC;
function nF() {
  if (IC) return _0;
  IC = 1;
  var r = Pr(), e = $r(), t = un(), A = pf(), n = AF(), i = Xa(), s = BA(), a = Ii(), o = s("iterator"), l = !1, u, c, f;
  [].keys && (f = [].keys(), "next" in f ? (c = n(n(f)), c !== Object.prototype && (u = c)) : l = !0);
  var h = !t(u) || r(function() {
    var g = {};
    return u[o].call(g) !== g;
  });
  return h ? u = {} : a && (u = A(u)), e(u[o]) || i(u, o, function() {
    return this;
  }), _0 = {
    IteratorPrototype: u,
    BUGGY_SAFARI_ITERATORS: l
  }, _0;
}
var U0, QC;
function U6() {
  if (QC) return U0;
  QC = 1;
  var r = nF().IteratorPrototype, e = pf(), t = Fv(), A = df(), n = Qu(), i = function() {
    return this;
  };
  return U0 = function(s, a, o, l) {
    var u = a + " Iterator";
    return s.prototype = e(r, { next: t(+!l, o) }), A(s, u, !1, !0), n[u] = i, s;
  }, U0;
}
var I0, LC;
function I6() {
  if (LC) return I0;
  LC = 1;
  var r = JA(), e = QA(), t = Ii(), A = uf(), n = $r(), i = U6(), s = AF(), a = jE(), o = df(), l = Fu(), u = Xa(), c = BA(), f = Qu(), h = nF(), g = A.PROPER, p = A.CONFIGURABLE, v = h.IteratorPrototype, w = h.BUGGY_SAFARI_ITERATORS, b = c("iterator"), S = "keys", B = "values", x = "entries", U = function() {
    return this;
  };
  return I0 = function(Q, N, _, R, F, O, G) {
    i(_, N, R);
    var H = function(X) {
      if (X === F && re) return re;
      if (!w && X && X in te) return te[X];
      switch (X) {
        case S:
          return function() {
            return new _(this, X);
          };
        case B:
          return function() {
            return new _(this, X);
          };
        case x:
          return function() {
            return new _(this, X);
          };
      }
      return function() {
        return new _(this);
      };
    }, $ = N + " Iterator", ne = !1, te = Q.prototype, J = te[b] || te["@@iterator"] || F && te[F], re = !w && J || H(F), le = N === "Array" && te.entries || J, se, P, V;
    if (le && (se = s(le.call(new Q())), se !== Object.prototype && se.next && (!t && s(se) !== v && (a ? a(se, v) : n(se[b]) || u(se, b, U)), o(se, $, !0, !0), t && (f[$] = U))), g && F === B && J && J.name !== B && (!t && p ? l(te, "name", B) : (ne = !0, re = function() {
      return e(J, this);
    })), F)
      if (P = {
        values: H(B),
        keys: O ? re : H(S),
        entries: H(x)
      }, G) for (V in P)
        (w || ne || !(V in te)) && u(te, V, P[V]);
      else r({ target: N, proto: !0, forced: w || ne }, P);
    return (!t || G) && te[b] !== re && u(te, b, re, { name: F }), f[N] = re, P;
  }, I0;
}
var Q0, NC;
function Q6() {
  return NC || (NC = 1, Q0 = function(r, e) {
    return { value: r, done: e };
  }), Q0;
}
var L0, TC;
function iF() {
  if (TC) return L0;
  TC = 1;
  var r = xu(), e = F6(), t = Qu(), A = cf(), n = ta().f, i = I6(), s = Q6(), a = Ii(), o = ci(), l = "Array Iterator", u = A.set, c = A.getterFor(l);
  L0 = i(Array, "Array", function(h, g) {
    u(this, {
      type: l,
      target: r(h),
      // target
      index: 0,
      // next index
      kind: g
      // kind
    });
  }, function() {
    var h = c(this), g = h.target, p = h.index++;
    if (!g || p >= g.length)
      return h.target = null, s(void 0, !0);
    switch (h.kind) {
      case "keys":
        return s(p, !1);
      case "values":
        return s(g[p], !1);
    }
    return s([p, g[p]], !1);
  }, "values");
  var f = t.Arguments = t.Array;
  if (e("keys"), e("values"), e("entries"), !a && o && f.name !== "values") try {
    n(f, "name", { value: "values" });
  } catch {
  }
  return L0;
}
iF();
var PC = {}, N0, OC;
function L6() {
  return OC || (OC = 1, N0 = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), N0;
}
var T0, MC;
function N6() {
  if (MC) return T0;
  MC = 1;
  var r = of(), e = r("span").classList, t = e && e.constructor && e.constructor.prototype;
  return T0 = t === Object.prototype ? void 0 : t, T0;
}
var RC;
function T6() {
  if (RC) return PC;
  RC = 1;
  var r = xr(), e = L6(), t = N6(), A = iF(), n = Fu(), i = df(), s = BA(), a = s("iterator"), o = A.values, l = function(c, f) {
    if (c) {
      if (c[a] !== o) try {
        n(c, a, o);
      } catch {
        c[a] = o;
      }
      if (i(c, f, !0), e[f]) {
        for (var h in A)
          if (c[h] !== A[h]) try {
            n(c, h, A[h]);
          } catch {
            c[h] = A[h];
          }
      }
    }
  };
  for (var u in e)
    l(r[u] && r[u].prototype, u);
  return l(t, "DOMTokenList"), PC;
}
T6();
function P6(r, e) {
  if (Xt(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var A = t.call(r, e);
    if (Xt(A) != "object") return A;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function O6(r) {
  var e = P6(r, "string");
  return Xt(e) == "symbol" ? e : e + "";
}
function zv(r, e, t) {
  return (e = O6(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
var kC = {}, P0, HC;
function M6() {
  if (HC) return P0;
  HC = 1;
  var r = fs(), e = af(), t = LE(), A = Pv(), n = TypeError, i = "Reduce of empty array with no initial value", s = function(a) {
    return function(o, l, u, c) {
      var f = e(o), h = t(f), g = A(f);
      if (r(l), g === 0 && u < 2) throw new n(i);
      var p = a ? g - 1 : 0, v = a ? -1 : 1;
      if (u < 2) for (; ; ) {
        if (p in h) {
          c = h[p], p += v;
          break;
        }
        if (p += v, a ? p < 0 : g <= p)
          throw new n(i);
      }
      for (; a ? p >= 0 : g > p; p += v) p in h && (c = l(c, h[p], p, f));
      return c;
    };
  };
  return P0 = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: s(!1),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: s(!0)
  }, P0;
}
var O0, DC;
function sF() {
  if (DC) return O0;
  DC = 1;
  var r = Pr();
  return O0 = function(e, t) {
    var A = [][e];
    return !!A && r(function() {
      A.call(null, t || function() {
        return 1;
      }, 1);
    });
  }, O0;
}
var GC;
function R6() {
  if (GC) return kC;
  GC = 1;
  var r = JA(), e = M6().left, t = sF(), A = _v(), n = ff(), i = !n && A > 79 && A < 83, s = i || !t("reduce");
  return r({ target: "Array", proto: !0, forced: s }, {
    reduce: function(o) {
      var l = arguments.length;
      return e(this, o, l, l > 1 ? arguments[1] : void 0);
    }
  }), kC;
}
R6();
var VC = {}, KC;
function k6() {
  if (KC) return VC;
  KC = 1;
  var r = JA(), e = gf(), t = lf().f, A = Ko(), n = Qi(), i = jv(), s = hi(), a = qv(), o = Ii(), l = e("".slice), u = Math.min, c = a("endsWith"), f = !o && !c && !!(function() {
    var h = t(String.prototype, "endsWith");
    return h && !h.writable;
  })();
  return r({ target: "String", proto: !0, forced: !f && !c }, {
    endsWith: function(g) {
      var p = n(s(this));
      i(g);
      var v = arguments.length > 1 ? arguments[1] : void 0, w = p.length, b = v === void 0 ? w : u(A(v), w), S = n(g);
      return l(p, b - S.length, b) === S;
    }
  }), VC;
}
k6();
var jC = {}, qC;
function H6() {
  if (qC) return jC;
  qC = 1;
  var r = QA(), e = Or(), t = Dv(), A = $A(), n = un(), i = hi(), s = qE(), a = Gv(), o = Ko(), l = Qi(), u = Vo(), c = Kv(), f = rF(), h = Pr(), g = f.UNSUPPORTED_Y, p = 4294967295, v = Math.min, w = e([].push), b = e("".slice), S = !h(function() {
    var x = /(?:)/, U = x.exec;
    x.exec = function() {
      return U.apply(this, arguments);
    };
    var Q = "ab".split(x);
    return Q.length !== 2 || Q[0] !== "a" || Q[1] !== "b";
  }), B = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length;
  return t("split", function(x, U, Q) {
    var N = "0".split(void 0, 0).length ? function(_, R) {
      return _ === void 0 && R === 0 ? [] : r(U, this, _, R);
    } : U;
    return [
      // `String.prototype.split` method
      // https://tc39.es/ecma262/#sec-string.prototype.split
      function(R, F) {
        var O = i(this), G = n(R) ? u(R, x) : void 0;
        return G ? r(G, R, O, F) : r(N, l(O), R, F);
      },
      // `RegExp.prototype[@@split]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
      //
      // NOTE: This cannot be properly polyfilled in engines that don't support
      // the 'y' flag.
      function(_, R) {
        var F = A(this), O = l(_);
        if (!B) {
          var G = Q(N, F, O, R, N !== U);
          if (G.done) return G.value;
        }
        var H = s(F, RegExp), $ = F.unicode, ne = (F.ignoreCase ? "i" : "") + (F.multiline ? "m" : "") + (F.unicode ? "u" : "") + (g ? "g" : "y"), te = new H(g ? "^(?:" + F.source + ")" : F, ne), J = R === void 0 ? p : R >>> 0;
        if (J === 0) return [];
        if (O.length === 0) return c(te, O) === null ? [O] : [];
        for (var re = 0, le = 0, se = []; le < O.length; ) {
          te.lastIndex = g ? 0 : le;
          var P = c(te, g ? b(O, le) : O), V;
          if (P === null || (V = v(o(te.lastIndex + (g ? le : 0)), O.length)) === re)
            le = a(O, le, $);
          else {
            if (w(se, b(O, re, le)), se.length === J) return se;
            for (var X = 1; X <= P.length - 1; X++)
              if (w(se, P[X]), se.length === J) return se;
            le = re = V;
          }
        }
        return w(se, b(O, re)), se;
      }
    ];
  }, B || !S, g), jC;
}
H6();
var Ul = { exports: {} }, Ea = { exports: {} }, D6 = Ea.exports, zC;
function G6() {
  return zC || (zC = 1, (function() {
    var r, e, t, A, n, i;
    typeof performance < "u" && performance !== null && performance.now ? Ea.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (Ea.exports = function() {
      return (r() - n) / 1e6;
    }, e = process.hrtime, r = function() {
      var s;
      return s = e(), s[0] * 1e9 + s[1];
    }, A = r(), i = process.uptime() * 1e9, n = A - i) : Date.now ? (Ea.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (Ea.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }).call(D6)), Ea.exports;
}
var WC;
function V6() {
  if (WC) return Ul.exports;
  WC = 1;
  for (var r = G6(), e = typeof window > "u" ? lm : window, t = ["moz", "webkit"], A = "AnimationFrame", n = e["request" + A], i = e["cancel" + A] || e["cancelRequest" + A], s = 0; !n && s < t.length; s++)
    n = e[t[s] + "Request" + A], i = e[t[s] + "Cancel" + A] || e[t[s] + "CancelRequest" + A];
  if (!n || !i) {
    var a = 0, o = 0, l = [], u = 1e3 / 60;
    n = function(c) {
      if (l.length === 0) {
        var f = r(), h = Math.max(0, u - (f - a));
        a = h + f, setTimeout(function() {
          var g = l.slice(0);
          l.length = 0;
          for (var p = 0; p < g.length; p++)
            if (!g[p].cancelled)
              try {
                g[p].callback(a);
              } catch (v) {
                setTimeout(function() {
                  throw v;
                }, 0);
              }
        }, Math.round(h));
      }
      return l.push({
        handle: ++o,
        callback: c,
        cancelled: !1
      }), o;
    }, i = function(c) {
      for (var f = 0; f < l.length; f++)
        l[f].handle === c && (l[f].cancelled = !0);
    };
  }
  return Ul.exports = function(c) {
    return n.call(e, c);
  }, Ul.exports.cancel = function() {
    i.apply(e, arguments);
  }, Ul.exports.polyfill = function(c) {
    c || (c = e), c.requestAnimationFrame = n, c.cancelAnimationFrame = i;
  }, Ul.exports;
}
var K6 = V6();
const M0 = /* @__PURE__ */ vu(K6);
var XC = {}, R0, YC;
function aF() {
  return YC || (YC = 1, R0 = `	
\v\f\r                　\u2028\u2029\uFEFF`), R0;
}
var k0, $C;
function j6() {
  if ($C) return k0;
  $C = 1;
  var r = Or(), e = hi(), t = Qi(), A = aF(), n = r("".replace), i = RegExp("^[" + A + "]+"), s = RegExp("(^|[^" + A + "])[" + A + "]+$"), a = function(o) {
    return function(l) {
      var u = t(e(l));
      return o & 1 && (u = n(u, i, "")), o & 2 && (u = n(u, s, "$1")), u;
    };
  };
  return k0 = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: a(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: a(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: a(3)
  }, k0;
}
var H0, JC;
function q6() {
  if (JC) return H0;
  JC = 1;
  var r = uf().PROPER, e = Pr(), t = aF(), A = "​᠎";
  return H0 = function(n) {
    return e(function() {
      return !!t[n]() || A[n]() !== A || r && t[n].name !== n;
    });
  }, H0;
}
var ZC;
function z6() {
  if (ZC) return XC;
  ZC = 1;
  var r = JA(), e = j6().trim, t = q6();
  return r({ target: "String", proto: !0, forced: t("trim") }, {
    trim: function() {
      return e(this);
    }
  }), XC;
}
z6();
var D0, eS;
function W6() {
  return eS || (eS = 1, D0 = function(r) {
    this.ok = !1, this.alpha = 1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = r.replace(/ /g, ""), r = r.toLowerCase();
    var e = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    };
    r = e[r] || r;
    for (var t = [
      {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3]),
            parseFloat(o[4])
          ];
        }
      },
      {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3])
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function(o) {
          return [
            parseInt(o[1], 16),
            parseInt(o[2], 16),
            parseInt(o[3], 16)
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function(o) {
          return [
            parseInt(o[1] + o[1], 16),
            parseInt(o[2] + o[2], 16),
            parseInt(o[3] + o[3], 16)
          ];
        }
      }
    ], A = 0; A < t.length; A++) {
      var n = t[A].re, i = t[A].process, s = n.exec(r);
      if (s) {
        var a = i(s);
        this.r = a[0], this.g = a[1], this.b = a[2], a.length > 3 && (this.alpha = a[3]), this.ok = !0;
      }
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toRGBA = function() {
      return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
    }, this.toHex = function() {
      var o = this.r.toString(16), l = this.g.toString(16), u = this.b.toString(16);
      return o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), u.length == 1 && (u = "0" + u), "#" + o + l + u;
    }, this.getHelpXML = function() {
      for (var o = new Array(), l = 0; l < t.length; l++)
        for (var u = t[l].example, c = 0; c < u.length; c++)
          o[o.length] = u[c];
      for (var f in e)
        o[o.length] = f;
      var h = document.createElement("ul");
      h.setAttribute("id", "rgbcolor-examples");
      for (var l = 0; l < o.length; l++)
        try {
          var g = document.createElement("li"), p = new RGBColor(o[l]), v = document.createElement("div");
          v.style.cssText = "margin: 3px; border: 1px solid black; background:" + p.toHex() + "; color:" + p.toHex(), v.appendChild(document.createTextNode("test"));
          var w = document.createTextNode(
            " " + o[l] + " -> " + p.toRGB() + " -> " + p.toHex()
          );
          g.appendChild(v), g.appendChild(w), h.appendChild(g);
        } catch {
        }
      return h;
    };
  }), D0;
}
var X6 = W6();
const Rm = /* @__PURE__ */ vu(X6);
var tS = {}, rS;
function Y6() {
  if (rS) return tS;
  rS = 1;
  var r = JA(), e = gf(), t = DE().indexOf, A = sF(), n = e([].indexOf), i = !!n && 1 / n([1], 1, -0) < 0, s = i || !A("indexOf");
  return r({ target: "Array", proto: !0, forced: s }, {
    indexOf: function(o) {
      var l = arguments.length > 1 ? arguments[1] : void 0;
      return i ? n(this, o, l) || 0 : t(this, o, l);
    }
  }), tS;
}
Y6();
var AS = {}, nS;
function $6() {
  if (nS) return AS;
  nS = 1;
  var r = JA(), e = Or(), t = jv(), A = hi(), n = Qi(), i = qv(), s = e("".indexOf);
  return r({ target: "String", proto: !0, forced: !i("includes") }, {
    includes: function(o) {
      return !!~s(
        n(A(this)),
        n(t(o)),
        arguments.length > 1 ? arguments[1] : void 0
      );
    }
  }), AS;
}
$6();
var iS = {}, G0, sS;
function J6() {
  if (sS) return G0;
  sS = 1;
  var r = za();
  return G0 = Array.isArray || function(t) {
    return r(t) === "Array";
  }, G0;
}
var aS;
function Z6() {
  if (aS) return iS;
  aS = 1;
  var r = JA(), e = Or(), t = J6(), A = e([].reverse), n = [1, 2];
  return r({ target: "Array", proto: !0, forced: String(n) === String(n.reverse()) }, {
    reverse: function() {
      return t(this) && (this.length = this.length), A(this);
    }
  }), iS;
}
Z6();
var oF = function(r, e) {
  return (oF = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  })(r, e);
};
function lF(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  oF(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function e8(r) {
  var e = "";
  Array.isArray(r) || (r = [r]);
  for (var t = 0; t < r.length; t++) {
    var A = r[t];
    if (A.type === Ue.CLOSE_PATH) e += "z";
    else if (A.type === Ue.HORIZ_LINE_TO) e += (A.relative ? "h" : "H") + A.x;
    else if (A.type === Ue.VERT_LINE_TO) e += (A.relative ? "v" : "V") + A.y;
    else if (A.type === Ue.MOVE_TO) e += (A.relative ? "m" : "M") + A.x + " " + A.y;
    else if (A.type === Ue.LINE_TO) e += (A.relative ? "l" : "L") + A.x + " " + A.y;
    else if (A.type === Ue.CURVE_TO) e += (A.relative ? "c" : "C") + A.x1 + " " + A.y1 + " " + A.x2 + " " + A.y2 + " " + A.x + " " + A.y;
    else if (A.type === Ue.SMOOTH_CURVE_TO) e += (A.relative ? "s" : "S") + A.x2 + " " + A.y2 + " " + A.x + " " + A.y;
    else if (A.type === Ue.QUAD_TO) e += (A.relative ? "q" : "Q") + A.x1 + " " + A.y1 + " " + A.x + " " + A.y;
    else if (A.type === Ue.SMOOTH_QUAD_TO) e += (A.relative ? "t" : "T") + A.x + " " + A.y;
    else {
      if (A.type !== Ue.ARC) throw new Error('Unexpected command type "' + A.type + '" at index ' + t + ".");
      e += (A.relative ? "a" : "A") + A.rX + " " + A.rY + " " + A.xRot + " " + +A.lArcFlag + " " + +A.sweepFlag + " " + A.x + " " + A.y;
    }
  }
  return e;
}
function km(r, e) {
  var t = r[0], A = r[1];
  return [t * Math.cos(e) - A * Math.sin(e), t * Math.sin(e) + A * Math.cos(e)];
}
function ri() {
  for (var r = [], e = 0; e < arguments.length; e++) r[e] = arguments[e];
  for (var t = 0; t < r.length; t++) if (typeof r[t] != "number") throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof r[t] + " == typeof " + r[t]);
  return !0;
}
var Ms = Math.PI;
function V0(r, e, t) {
  r.lArcFlag = r.lArcFlag === 0 ? 0 : 1, r.sweepFlag = r.sweepFlag === 0 ? 0 : 1;
  var A = r.rX, n = r.rY, i = r.x, s = r.y;
  A = Math.abs(r.rX), n = Math.abs(r.rY);
  var a = km([(e - i) / 2, (t - s) / 2], -r.xRot / 180 * Ms), o = a[0], l = a[1], u = Math.pow(o, 2) / Math.pow(A, 2) + Math.pow(l, 2) / Math.pow(n, 2);
  1 < u && (A *= Math.sqrt(u), n *= Math.sqrt(u)), r.rX = A, r.rY = n;
  var c = Math.pow(A, 2) * Math.pow(l, 2) + Math.pow(n, 2) * Math.pow(o, 2), f = (r.lArcFlag !== r.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(A, 2) * Math.pow(n, 2) - c) / c)), h = A * l / n * f, g = -n * o / A * f, p = km([h, g], r.xRot / 180 * Ms);
  r.cX = p[0] + (e + i) / 2, r.cY = p[1] + (t + s) / 2, r.phi1 = Math.atan2((l - g) / n, (o - h) / A), r.phi2 = Math.atan2((-l - g) / n, (-o - h) / A), r.sweepFlag === 0 && r.phi2 > r.phi1 && (r.phi2 -= 2 * Ms), r.sweepFlag === 1 && r.phi2 < r.phi1 && (r.phi2 += 2 * Ms), r.phi1 *= 180 / Ms, r.phi2 *= 180 / Ms;
}
function oS(r, e, t) {
  ri(r, e, t);
  var A = r * r + e * e - t * t;
  if (0 > A) return [];
  if (A === 0) return [[r * t / (r * r + e * e), e * t / (r * r + e * e)]];
  var n = Math.sqrt(A);
  return [[(r * t + e * n) / (r * r + e * e), (e * t - r * n) / (r * r + e * e)], [(r * t - e * n) / (r * r + e * e), (e * t + r * n) / (r * r + e * e)]];
}
var nA, Zi = Math.PI / 180;
function lS(r, e, t) {
  return (1 - t) * r + t * e;
}
function uS(r, e, t, A) {
  return r + Math.cos(A / 180 * Ms) * e + Math.sin(A / 180 * Ms) * t;
}
function cS(r, e, t, A) {
  var n = 1e-6, i = e - r, s = t - e, a = 3 * i + 3 * (A - t) - 6 * s, o = 6 * (s - i), l = 3 * i;
  return Math.abs(a) < n ? [-l / o] : (function(u, c, f) {
    var h = u * u / 4 - c;
    if (h < -f) return [];
    if (h <= f) return [-u / 2];
    var g = Math.sqrt(h);
    return [-u / 2 - g, -u / 2 + g];
  })(o / a, l / a, n);
}
function hS(r, e, t, A, n) {
  var i = 1 - n;
  return r * (i * i * i) + e * (3 * i * i * n) + t * (3 * i * n * n) + A * (n * n * n);
}
(function(r) {
  function e() {
    return n((function(a, o, l) {
      return a.relative && (a.x1 !== void 0 && (a.x1 += o), a.y1 !== void 0 && (a.y1 += l), a.x2 !== void 0 && (a.x2 += o), a.y2 !== void 0 && (a.y2 += l), a.x !== void 0 && (a.x += o), a.y !== void 0 && (a.y += l), a.relative = !1), a;
    }));
  }
  function t() {
    var a = NaN, o = NaN, l = NaN, u = NaN;
    return n((function(c, f, h) {
      return c.type & Ue.SMOOTH_CURVE_TO && (c.type = Ue.CURVE_TO, a = isNaN(a) ? f : a, o = isNaN(o) ? h : o, c.x1 = c.relative ? f - a : 2 * f - a, c.y1 = c.relative ? h - o : 2 * h - o), c.type & Ue.CURVE_TO ? (a = c.relative ? f + c.x2 : c.x2, o = c.relative ? h + c.y2 : c.y2) : (a = NaN, o = NaN), c.type & Ue.SMOOTH_QUAD_TO && (c.type = Ue.QUAD_TO, l = isNaN(l) ? f : l, u = isNaN(u) ? h : u, c.x1 = c.relative ? f - l : 2 * f - l, c.y1 = c.relative ? h - u : 2 * h - u), c.type & Ue.QUAD_TO ? (l = c.relative ? f + c.x1 : c.x1, u = c.relative ? h + c.y1 : c.y1) : (l = NaN, u = NaN), c;
    }));
  }
  function A() {
    var a = NaN, o = NaN;
    return n((function(l, u, c) {
      if (l.type & Ue.SMOOTH_QUAD_TO && (l.type = Ue.QUAD_TO, a = isNaN(a) ? u : a, o = isNaN(o) ? c : o, l.x1 = l.relative ? u - a : 2 * u - a, l.y1 = l.relative ? c - o : 2 * c - o), l.type & Ue.QUAD_TO) {
        a = l.relative ? u + l.x1 : l.x1, o = l.relative ? c + l.y1 : l.y1;
        var f = l.x1, h = l.y1;
        l.type = Ue.CURVE_TO, l.x1 = ((l.relative ? 0 : u) + 2 * f) / 3, l.y1 = ((l.relative ? 0 : c) + 2 * h) / 3, l.x2 = (l.x + 2 * f) / 3, l.y2 = (l.y + 2 * h) / 3;
      } else a = NaN, o = NaN;
      return l;
    }));
  }
  function n(a) {
    var o = 0, l = 0, u = NaN, c = NaN;
    return function(f) {
      if (isNaN(u) && !(f.type & Ue.MOVE_TO)) throw new Error("path must start with moveto");
      var h = a(f, o, l, u, c);
      return f.type & Ue.CLOSE_PATH && (o = u, l = c), f.x !== void 0 && (o = f.relative ? o + f.x : f.x), f.y !== void 0 && (l = f.relative ? l + f.y : f.y), f.type & Ue.MOVE_TO && (u = o, c = l), h;
    };
  }
  function i(a, o, l, u, c, f) {
    return ri(a, o, l, u, c, f), n((function(h, g, p, v) {
      var w = h.x1, b = h.x2, S = h.relative && !isNaN(v), B = h.x !== void 0 ? h.x : S ? 0 : g, x = h.y !== void 0 ? h.y : S ? 0 : p;
      function U(P) {
        return P * P;
      }
      h.type & Ue.HORIZ_LINE_TO && o !== 0 && (h.type = Ue.LINE_TO, h.y = h.relative ? 0 : p), h.type & Ue.VERT_LINE_TO && l !== 0 && (h.type = Ue.LINE_TO, h.x = h.relative ? 0 : g), h.x !== void 0 && (h.x = h.x * a + x * l + (S ? 0 : c)), h.y !== void 0 && (h.y = B * o + h.y * u + (S ? 0 : f)), h.x1 !== void 0 && (h.x1 = h.x1 * a + h.y1 * l + (S ? 0 : c)), h.y1 !== void 0 && (h.y1 = w * o + h.y1 * u + (S ? 0 : f)), h.x2 !== void 0 && (h.x2 = h.x2 * a + h.y2 * l + (S ? 0 : c)), h.y2 !== void 0 && (h.y2 = b * o + h.y2 * u + (S ? 0 : f));
      var Q = a * u - o * l;
      if (h.xRot !== void 0 && (a !== 1 || o !== 0 || l !== 0 || u !== 1)) if (Q === 0) delete h.rX, delete h.rY, delete h.xRot, delete h.lArcFlag, delete h.sweepFlag, h.type = Ue.LINE_TO;
      else {
        var N = h.xRot * Math.PI / 180, _ = Math.sin(N), R = Math.cos(N), F = 1 / U(h.rX), O = 1 / U(h.rY), G = U(R) * F + U(_) * O, H = 2 * _ * R * (F - O), $ = U(_) * F + U(R) * O, ne = G * u * u - H * o * u + $ * o * o, te = H * (a * u + o * l) - 2 * (G * l * u + $ * a * o), J = G * l * l - H * a * l + $ * a * a, re = (Math.atan2(te, ne - J) + Math.PI) % Math.PI / 2, le = Math.sin(re), se = Math.cos(re);
        h.rX = Math.abs(Q) / Math.sqrt(ne * U(se) + te * le * se + J * U(le)), h.rY = Math.abs(Q) / Math.sqrt(ne * U(le) - te * le * se + J * U(se)), h.xRot = 180 * re / Math.PI;
      }
      return h.sweepFlag !== void 0 && 0 > Q && (h.sweepFlag = +!h.sweepFlag), h;
    }));
  }
  function s() {
    return function(a) {
      var o = {};
      for (var l in a) o[l] = a[l];
      return o;
    };
  }
  r.ROUND = function(a) {
    function o(l) {
      return Math.round(l * a) / a;
    }
    return a === void 0 && (a = 1e13), ri(a), function(l) {
      return l.x1 !== void 0 && (l.x1 = o(l.x1)), l.y1 !== void 0 && (l.y1 = o(l.y1)), l.x2 !== void 0 && (l.x2 = o(l.x2)), l.y2 !== void 0 && (l.y2 = o(l.y2)), l.x !== void 0 && (l.x = o(l.x)), l.y !== void 0 && (l.y = o(l.y)), l.rX !== void 0 && (l.rX = o(l.rX)), l.rY !== void 0 && (l.rY = o(l.rY)), l;
    };
  }, r.TO_ABS = e, r.TO_REL = function() {
    return n((function(a, o, l) {
      return a.relative || (a.x1 !== void 0 && (a.x1 -= o), a.y1 !== void 0 && (a.y1 -= l), a.x2 !== void 0 && (a.x2 -= o), a.y2 !== void 0 && (a.y2 -= l), a.x !== void 0 && (a.x -= o), a.y !== void 0 && (a.y -= l), a.relative = !0), a;
    }));
  }, r.NORMALIZE_HVZ = function(a, o, l) {
    return a === void 0 && (a = !0), o === void 0 && (o = !0), l === void 0 && (l = !0), n((function(u, c, f, h, g) {
      if (isNaN(h) && !(u.type & Ue.MOVE_TO)) throw new Error("path must start with moveto");
      return o && u.type & Ue.HORIZ_LINE_TO && (u.type = Ue.LINE_TO, u.y = u.relative ? 0 : f), l && u.type & Ue.VERT_LINE_TO && (u.type = Ue.LINE_TO, u.x = u.relative ? 0 : c), a && u.type & Ue.CLOSE_PATH && (u.type = Ue.LINE_TO, u.x = u.relative ? h - c : h, u.y = u.relative ? g - f : g), u.type & Ue.ARC && (u.rX === 0 || u.rY === 0) && (u.type = Ue.LINE_TO, delete u.rX, delete u.rY, delete u.xRot, delete u.lArcFlag, delete u.sweepFlag), u;
    }));
  }, r.NORMALIZE_ST = t, r.QT_TO_C = A, r.INFO = n, r.SANITIZE = function(a) {
    a === void 0 && (a = 0), ri(a);
    var o = NaN, l = NaN, u = NaN, c = NaN;
    return n((function(f, h, g, p, v) {
      var w = Math.abs, b = !1, S = 0, B = 0;
      if (f.type & Ue.SMOOTH_CURVE_TO && (S = isNaN(o) ? 0 : h - o, B = isNaN(l) ? 0 : g - l), f.type & (Ue.CURVE_TO | Ue.SMOOTH_CURVE_TO) ? (o = f.relative ? h + f.x2 : f.x2, l = f.relative ? g + f.y2 : f.y2) : (o = NaN, l = NaN), f.type & Ue.SMOOTH_QUAD_TO ? (u = isNaN(u) ? h : 2 * h - u, c = isNaN(c) ? g : 2 * g - c) : f.type & Ue.QUAD_TO ? (u = f.relative ? h + f.x1 : f.x1, c = f.relative ? g + f.y1 : f.y2) : (u = NaN, c = NaN), f.type & Ue.LINE_COMMANDS || f.type & Ue.ARC && (f.rX === 0 || f.rY === 0 || !f.lArcFlag) || f.type & Ue.CURVE_TO || f.type & Ue.SMOOTH_CURVE_TO || f.type & Ue.QUAD_TO || f.type & Ue.SMOOTH_QUAD_TO) {
        var x = f.x === void 0 ? 0 : f.relative ? f.x : f.x - h, U = f.y === void 0 ? 0 : f.relative ? f.y : f.y - g;
        S = isNaN(u) ? f.x1 === void 0 ? S : f.relative ? f.x : f.x1 - h : u - h, B = isNaN(c) ? f.y1 === void 0 ? B : f.relative ? f.y : f.y1 - g : c - g;
        var Q = f.x2 === void 0 ? 0 : f.relative ? f.x : f.x2 - h, N = f.y2 === void 0 ? 0 : f.relative ? f.y : f.y2 - g;
        w(x) <= a && w(U) <= a && w(S) <= a && w(B) <= a && w(Q) <= a && w(N) <= a && (b = !0);
      }
      return f.type & Ue.CLOSE_PATH && w(h - p) <= a && w(g - v) <= a && (b = !0), b ? [] : f;
    }));
  }, r.MATRIX = i, r.ROTATE = function(a, o, l) {
    o === void 0 && (o = 0), l === void 0 && (l = 0), ri(a, o, l);
    var u = Math.sin(a), c = Math.cos(a);
    return i(c, u, -u, c, o - o * c + l * u, l - o * u - l * c);
  }, r.TRANSLATE = function(a, o) {
    return o === void 0 && (o = 0), ri(a, o), i(1, 0, 0, 1, a, o);
  }, r.SCALE = function(a, o) {
    return o === void 0 && (o = a), ri(a, o), i(a, 0, 0, o, 0, 0);
  }, r.SKEW_X = function(a) {
    return ri(a), i(1, 0, Math.atan(a), 1, 0, 0);
  }, r.SKEW_Y = function(a) {
    return ri(a), i(1, Math.atan(a), 0, 1, 0, 0);
  }, r.X_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), ri(a), i(-1, 0, 0, 1, a, 0);
  }, r.Y_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), ri(a), i(1, 0, 0, -1, 0, a);
  }, r.A_TO_C = function() {
    return n((function(a, o, l) {
      return Ue.ARC === a.type ? (function(u, c, f) {
        var h, g, p, v;
        u.cX || V0(u, c, f);
        for (var w = Math.min(u.phi1, u.phi2), b = Math.max(u.phi1, u.phi2) - w, S = Math.ceil(b / 90), B = new Array(S), x = c, U = f, Q = 0; Q < S; Q++) {
          var N = lS(u.phi1, u.phi2, Q / S), _ = lS(u.phi1, u.phi2, (Q + 1) / S), R = _ - N, F = 4 / 3 * Math.tan(R * Zi / 4), O = [Math.cos(N * Zi) - F * Math.sin(N * Zi), Math.sin(N * Zi) + F * Math.cos(N * Zi)], G = O[0], H = O[1], $ = [Math.cos(_ * Zi), Math.sin(_ * Zi)], ne = $[0], te = $[1], J = [ne + F * Math.sin(_ * Zi), te - F * Math.cos(_ * Zi)], re = J[0], le = J[1];
          B[Q] = { relative: u.relative, type: Ue.CURVE_TO };
          var se = function(P, V) {
            var X = km([P * u.rX, V * u.rY], u.xRot), Y = X[0], ee = X[1];
            return [u.cX + Y, u.cY + ee];
          };
          h = se(G, H), B[Q].x1 = h[0], B[Q].y1 = h[1], g = se(re, le), B[Q].x2 = g[0], B[Q].y2 = g[1], p = se(ne, te), B[Q].x = p[0], B[Q].y = p[1], u.relative && (B[Q].x1 -= x, B[Q].y1 -= U, B[Q].x2 -= x, B[Q].y2 -= U, B[Q].x -= x, B[Q].y -= U), x = (v = [B[Q].x, B[Q].y])[0], U = v[1];
        }
        return B;
      })(a, a.relative ? 0 : o, a.relative ? 0 : l) : a;
    }));
  }, r.ANNOTATE_ARCS = function() {
    return n((function(a, o, l) {
      return a.relative && (o = 0, l = 0), Ue.ARC === a.type && V0(a, o, l), a;
    }));
  }, r.CLONE = s, r.CALCULATE_BOUNDS = function() {
    var a = function(f) {
      var h = {};
      for (var g in f) h[g] = f[g];
      return h;
    }, o = e(), l = A(), u = t(), c = n((function(f, h, g) {
      var p = u(l(o(a(f))));
      function v(le) {
        le > c.maxX && (c.maxX = le), le < c.minX && (c.minX = le);
      }
      function w(le) {
        le > c.maxY && (c.maxY = le), le < c.minY && (c.minY = le);
      }
      if (p.type & Ue.DRAWING_COMMANDS && (v(h), w(g)), p.type & Ue.HORIZ_LINE_TO && v(p.x), p.type & Ue.VERT_LINE_TO && w(p.y), p.type & Ue.LINE_TO && (v(p.x), w(p.y)), p.type & Ue.CURVE_TO) {
        v(p.x), w(p.y);
        for (var b = 0, S = cS(h, p.x1, p.x2, p.x); b < S.length; b++)
          0 < (re = S[b]) && 1 > re && v(hS(h, p.x1, p.x2, p.x, re));
        for (var B = 0, x = cS(g, p.y1, p.y2, p.y); B < x.length; B++)
          0 < (re = x[B]) && 1 > re && w(hS(g, p.y1, p.y2, p.y, re));
      }
      if (p.type & Ue.ARC) {
        v(p.x), w(p.y), V0(p, h, g);
        for (var U = p.xRot / 180 * Math.PI, Q = Math.cos(U) * p.rX, N = Math.sin(U) * p.rX, _ = -Math.sin(U) * p.rY, R = Math.cos(U) * p.rY, F = p.phi1 < p.phi2 ? [p.phi1, p.phi2] : -180 > p.phi2 ? [p.phi2 + 360, p.phi1 + 360] : [p.phi2, p.phi1], O = F[0], G = F[1], H = function(le) {
          var se = le[0], P = le[1], V = 180 * Math.atan2(P, se) / Math.PI;
          return V < O ? V + 360 : V;
        }, $ = 0, ne = oS(_, -Q, 0).map(H); $ < ne.length; $++)
          (re = ne[$]) > O && re < G && v(uS(p.cX, Q, _, re));
        for (var te = 0, J = oS(R, -N, 0).map(H); te < J.length; te++) {
          var re;
          (re = J[te]) > O && re < G && w(uS(p.cY, N, R, re));
        }
      }
      return f;
    }));
    return c.minX = 1 / 0, c.maxX = -1 / 0, c.minY = 1 / 0, c.maxY = -1 / 0, c;
  };
})(nA || (nA = {}));
var ei, uF = (function() {
  function r() {
  }
  return r.prototype.round = function(e) {
    return this.transform(nA.ROUND(e));
  }, r.prototype.toAbs = function() {
    return this.transform(nA.TO_ABS());
  }, r.prototype.toRel = function() {
    return this.transform(nA.TO_REL());
  }, r.prototype.normalizeHVZ = function(e, t, A) {
    return this.transform(nA.NORMALIZE_HVZ(e, t, A));
  }, r.prototype.normalizeST = function() {
    return this.transform(nA.NORMALIZE_ST());
  }, r.prototype.qtToC = function() {
    return this.transform(nA.QT_TO_C());
  }, r.prototype.aToC = function() {
    return this.transform(nA.A_TO_C());
  }, r.prototype.sanitize = function(e) {
    return this.transform(nA.SANITIZE(e));
  }, r.prototype.translate = function(e, t) {
    return this.transform(nA.TRANSLATE(e, t));
  }, r.prototype.scale = function(e, t) {
    return this.transform(nA.SCALE(e, t));
  }, r.prototype.rotate = function(e, t, A) {
    return this.transform(nA.ROTATE(e, t, A));
  }, r.prototype.matrix = function(e, t, A, n, i, s) {
    return this.transform(nA.MATRIX(e, t, A, n, i, s));
  }, r.prototype.skewX = function(e) {
    return this.transform(nA.SKEW_X(e));
  }, r.prototype.skewY = function(e) {
    return this.transform(nA.SKEW_Y(e));
  }, r.prototype.xSymmetry = function(e) {
    return this.transform(nA.X_AXIS_SYMMETRY(e));
  }, r.prototype.ySymmetry = function(e) {
    return this.transform(nA.Y_AXIS_SYMMETRY(e));
  }, r.prototype.annotateArcs = function() {
    return this.transform(nA.ANNOTATE_ARCS());
  }, r;
})(), t8 = function(r) {
  return r === " " || r === "	" || r === "\r" || r === `
`;
}, fS = function(r) {
  return 48 <= r.charCodeAt(0) && r.charCodeAt(0) <= 57;
}, r8 = (function(r) {
  function e() {
    var t = r.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return lF(e, r), e.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, e.prototype.parse = function(t, A) {
    var n = this;
    A === void 0 && (A = []);
    for (var i = function(c) {
      A.push(c), n.curArgs.length = 0, n.canParseCommandOrComma = !0;
    }, s = 0; s < t.length; s++) {
      var a = t[s], o = !(this.curCommandType !== Ue.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), l = fS(a) && (this.curNumber === "0" && a === "0" || o);
      if (!fS(a) || l) if (a !== "e" && a !== "E") if (a !== "-" && a !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (a !== "." || this.curNumberHasExp || this.curNumberHasDecimal || o) {
        if (this.curNumber && this.curCommandType !== -1) {
          var u = Number(this.curNumber);
          if (isNaN(u)) throw new SyntaxError("Invalid number ending at " + s);
          if (this.curCommandType === Ue.ARC) {
            if (this.curArgs.length === 0 || this.curArgs.length === 1) {
              if (0 > u) throw new SyntaxError('Expected positive number, got "' + u + '" at index "' + s + '"');
            } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
          }
          this.curArgs.push(u), this.curArgs.length === A8[this.curCommandType] && (Ue.HORIZ_LINE_TO === this.curCommandType ? i({ type: Ue.HORIZ_LINE_TO, relative: this.curCommandRelative, x: u }) : Ue.VERT_LINE_TO === this.curCommandType ? i({ type: Ue.VERT_LINE_TO, relative: this.curCommandRelative, y: u }) : this.curCommandType === Ue.MOVE_TO || this.curCommandType === Ue.LINE_TO || this.curCommandType === Ue.SMOOTH_QUAD_TO ? (i({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), Ue.MOVE_TO === this.curCommandType && (this.curCommandType = Ue.LINE_TO)) : this.curCommandType === Ue.CURVE_TO ? i({ type: Ue.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === Ue.SMOOTH_CURVE_TO ? i({ type: Ue.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.QUAD_TO ? i({ type: Ue.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.ARC && i({ type: Ue.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
        }
        if (!t8(a)) if (a === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
        else if (a !== "+" && a !== "-" && a !== ".") if (l) this.curNumber = a, this.curNumberHasDecimal = !1;
        else {
          if (this.curArgs.length !== 0) throw new SyntaxError("Unterminated command at index " + s + ".");
          if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ". Command cannot follow comma");
          if (this.canParseCommandOrComma = !1, a !== "z" && a !== "Z") if (a === "h" || a === "H") this.curCommandType = Ue.HORIZ_LINE_TO, this.curCommandRelative = a === "h";
          else if (a === "v" || a === "V") this.curCommandType = Ue.VERT_LINE_TO, this.curCommandRelative = a === "v";
          else if (a === "m" || a === "M") this.curCommandType = Ue.MOVE_TO, this.curCommandRelative = a === "m";
          else if (a === "l" || a === "L") this.curCommandType = Ue.LINE_TO, this.curCommandRelative = a === "l";
          else if (a === "c" || a === "C") this.curCommandType = Ue.CURVE_TO, this.curCommandRelative = a === "c";
          else if (a === "s" || a === "S") this.curCommandType = Ue.SMOOTH_CURVE_TO, this.curCommandRelative = a === "s";
          else if (a === "q" || a === "Q") this.curCommandType = Ue.QUAD_TO, this.curCommandRelative = a === "q";
          else if (a === "t" || a === "T") this.curCommandType = Ue.SMOOTH_QUAD_TO, this.curCommandRelative = a === "t";
          else {
            if (a !== "a" && a !== "A") throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ".");
            this.curCommandType = Ue.ARC, this.curCommandRelative = a === "a";
          }
          else A.push({ type: Ue.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
        }
        else this.curNumber = a, this.curNumberHasDecimal = a === ".";
      } else this.curNumber += a, this.curNumberHasDecimal = !0;
      else this.curNumber += a;
      else this.curNumber += a, this.curNumberHasExp = !0;
      else this.curNumber += a, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return A;
  }, e.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(A, n) {
      n === void 0 && (n = []);
      for (var i = 0, s = Object.getPrototypeOf(this).parse.call(this, A); i < s.length; i++) {
        var a = s[i], o = t(a);
        Array.isArray(o) ? n.push.apply(n, o) : n.push(o);
      }
      return n;
    } } });
  }, e;
})(uF), Ue = (function(r) {
  function e(t) {
    var A = r.call(this) || this;
    return A.commands = typeof t == "string" ? e.parse(t) : t, A;
  }
  return lF(e, r), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var t = nA.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, e.prototype.transform = function(t) {
    for (var A = [], n = 0, i = this.commands; n < i.length; n++) {
      var s = t(i[n]);
      Array.isArray(s) ? A.push.apply(A, s) : A.push(s);
    }
    return this.commands = A, this;
  }, e.encode = function(t) {
    return e8(t);
  }, e.parse = function(t) {
    var A = new r8(), n = [];
    return A.parse(t, n), A.finish(n), n;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
})(uF), A8 = ((ei = {})[Ue.MOVE_TO] = 2, ei[Ue.LINE_TO] = 2, ei[Ue.HORIZ_LINE_TO] = 1, ei[Ue.VERT_LINE_TO] = 1, ei[Ue.CLOSE_PATH] = 0, ei[Ue.QUAD_TO] = 4, ei[Ue.SMOOTH_QUAD_TO] = 2, ei[Ue.CURVE_TO] = 6, ei[Ue.SMOOTH_CURVE_TO] = 4, ei[Ue.ARC] = 7, ei), dS = {}, gS;
function n8() {
  if (gS) return dS;
  gS = 1;
  var r = uf().PROPER, e = Xa(), t = $A(), A = Qi(), n = Pr(), i = Vv(), s = "toString", a = RegExp.prototype, o = a[s], l = n(function() {
    return o.call({ source: "a", flags: "b" }) !== "/a/b";
  }), u = r && o.name !== s;
  return (l || u) && e(a, s, function() {
    var f = t(this), h = A(f.source), g = A(i(f));
    return "/" + h + "/" + g;
  }, { unsafe: !0 }), dS;
}
n8();
function gh(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gh = function(e) {
    return typeof e;
  } : gh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, gh(r);
}
function i8(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var s8 = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], a8 = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function o8(r, e, t, A, n) {
  if (typeof r == "string" && (r = document.getElementById(r)), !r || gh(r) !== "object" || !("getContext" in r))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var i = r.getContext("2d");
  try {
    return i.getImageData(e, t, A, n);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function l8(r, e, t, A, n, i) {
  if (!(isNaN(i) || i < 1)) {
    i |= 0;
    var s = o8(r, e, t, A, n);
    s = u8(s, e, t, A, n, i), r.getContext("2d").putImageData(s, e, t);
  }
}
function u8(r, e, t, A, n, i) {
  for (var s = r.data, a = 2 * i + 1, o = A - 1, l = n - 1, u = i + 1, c = u * (u + 1) / 2, f = new pS(), h = f, g, p = 1; p < a; p++)
    h = h.next = new pS(), p === u && (g = h);
  h.next = f;
  for (var v = null, w = null, b = 0, S = 0, B = s8[i], x = a8[i], U = 0; U < n; U++) {
    h = f;
    for (var Q = s[S], N = s[S + 1], _ = s[S + 2], R = s[S + 3], F = 0; F < u; F++)
      h.r = Q, h.g = N, h.b = _, h.a = R, h = h.next;
    for (var O = 0, G = 0, H = 0, $ = 0, ne = u * Q, te = u * N, J = u * _, re = u * R, le = c * Q, se = c * N, P = c * _, V = c * R, X = 1; X < u; X++) {
      var Y = S + ((o < X ? o : X) << 2), ee = s[Y], oe = s[Y + 1], ge = s[Y + 2], pe = s[Y + 3], me = u - X;
      le += (h.r = ee) * me, se += (h.g = oe) * me, P += (h.b = ge) * me, V += (h.a = pe) * me, O += ee, G += oe, H += ge, $ += pe, h = h.next;
    }
    v = f, w = g;
    for (var Ee = 0; Ee < A; Ee++) {
      var Ne = V * B >>> x;
      if (s[S + 3] = Ne, Ne !== 0) {
        var Te = 255 / Ne;
        s[S] = (le * B >>> x) * Te, s[S + 1] = (se * B >>> x) * Te, s[S + 2] = (P * B >>> x) * Te;
      } else
        s[S] = s[S + 1] = s[S + 2] = 0;
      le -= ne, se -= te, P -= J, V -= re, ne -= v.r, te -= v.g, J -= v.b, re -= v.a;
      var Ge = Ee + i + 1;
      Ge = b + (Ge < o ? Ge : o) << 2, O += v.r = s[Ge], G += v.g = s[Ge + 1], H += v.b = s[Ge + 2], $ += v.a = s[Ge + 3], le += O, se += G, P += H, V += $, v = v.next;
      var j = w, Pe = j.r, ft = j.g, tt = j.b, xe = j.a;
      ne += Pe, te += ft, J += tt, re += xe, O -= Pe, G -= ft, H -= tt, $ -= xe, w = w.next, S += 4;
    }
    b += A;
  }
  for (var At = 0; At < A; At++) {
    S = At << 2;
    var ke = s[S], We = s[S + 1], ze = s[S + 2], Ce = s[S + 3], Oe = u * ke, Re = u * We, Ke = u * ze, Xe = u * Ce, Ve = c * ke, dt = c * We, je = c * ze, Tt = c * Ce;
    h = f;
    for (var Et = 0; Et < u; Et++)
      h.r = ke, h.g = We, h.b = ze, h.a = Ce, h = h.next;
    for (var mt = A, yt = 0, qt = 0, it = 0, zt = 0, lt = 1; lt <= i; lt++) {
      S = mt + At << 2;
      var wt = u - lt;
      Ve += (h.r = ke = s[S]) * wt, dt += (h.g = We = s[S + 1]) * wt, je += (h.b = ze = s[S + 2]) * wt, Tt += (h.a = Ce = s[S + 3]) * wt, zt += ke, yt += We, qt += ze, it += Ce, h = h.next, lt < l && (mt += A);
    }
    S = At, v = f, w = g;
    for (var Zt = 0; Zt < n; Zt++) {
      var ut = S << 2;
      s[ut + 3] = Ce = Tt * B >>> x, Ce > 0 ? (Ce = 255 / Ce, s[ut] = (Ve * B >>> x) * Ce, s[ut + 1] = (dt * B >>> x) * Ce, s[ut + 2] = (je * B >>> x) * Ce) : s[ut] = s[ut + 1] = s[ut + 2] = 0, Ve -= Oe, dt -= Re, je -= Ke, Tt -= Xe, Oe -= v.r, Re -= v.g, Ke -= v.b, Xe -= v.a, ut = At + ((ut = Zt + u) < l ? ut : l) * A << 2, Ve += zt += v.r = s[ut], dt += yt += v.g = s[ut + 1], je += qt += v.b = s[ut + 2], Tt += it += v.a = s[ut + 3], v = v.next, Oe += ke = w.r, Re += We = w.g, Ke += ze = w.b, Xe += Ce = w.a, zt -= ke, yt -= We, qt -= ze, it -= Ce, w = w.next, S += A;
    }
  }
  return r;
}
var pS = (
  /**
   * Set properties.
   */
  function r() {
    i8(this, r), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function c8() {
  var {
    DOMParser: r
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: r,
    createCanvas(t, A) {
      return new OffscreenCanvas(t, A);
    },
    createImage(t) {
      return us(function* () {
        var A = yield fetch(t), n = yield A.blob(), i = yield createImageBitmap(n);
        return i;
      })();
    }
  };
  return (typeof DOMParser < "u" || typeof r > "u") && Reflect.deleteProperty(e, "DOMParser"), e;
}
function h8(r) {
  var {
    DOMParser: e,
    canvas: t,
    fetch: A
  } = r;
  return {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: e,
    fetch: A,
    createCanvas: t.createCanvas,
    createImage: t.loadImage
  };
}
var f8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  offscreen: c8,
  node: h8
});
function Ya(r) {
  return r.replace(/(?!\u3000)\s+/gm, " ");
}
function cF(r) {
  return r.replace(/^[\n \t]+/, "");
}
function hF(r) {
  return r.replace(/[\n \t]+$/, "");
}
function on(r) {
  var e = (r || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return e.map(parseFloat);
}
var d8 = /^[A-Z-]+$/;
function fF(r) {
  return d8.test(r) ? r.toLowerCase() : r;
}
function Wv(r) {
  var e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(r) || [];
  return e[2] || e[3] || e[4];
}
function dF(r) {
  if (!r.startsWith("rgb"))
    return r;
  var e = 3, t = r.replace(/\d+(\.\d+)?/g, (A, n) => e-- && n ? String(Math.round(parseFloat(A))) : A);
  return t;
}
var g8 = /(\[[^\]]+\])/g, p8 = /(#[^\s+>~.[:]+)/g, m8 = /(\.[^\s+>~.[:]+)/g, v8 = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, w8 = /(:[\w-]+\([^)]*\))/gi, y8 = /(:[^\s+>~.[:]+)/g, b8 = /([^\s+>~.[:]+)/g;
function ba(r, e) {
  var t = e.exec(r);
  return t ? [r.replace(e, " "), t.length] : [r, 0];
}
function gF(r) {
  var e = [0, 0, 0], t = r.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), A = 0;
  return [t, A] = ba(t, g8), e[1] += A, [t, A] = ba(t, p8), e[0] += A, [t, A] = ba(t, m8), e[1] += A, [t, A] = ba(t, v8), e[2] += A, [t, A] = ba(t, w8), e[1] += A, [t, A] = ba(t, y8), e[1] += A, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, A] = ba(t, b8), e[2] += A, e.join("");
}
var Ma = 1e-8;
function Hm(r) {
  return Math.sqrt(Math.pow(r[0], 2) + Math.pow(r[1], 2));
}
function Mh(r, e) {
  return (r[0] * e[0] + r[1] * e[1]) / (Hm(r) * Hm(e));
}
function Dm(r, e) {
  return (r[0] * e[1] < r[1] * e[0] ? -1 : 1) * Math.acos(Mh(r, e));
}
function Gm(r) {
  return r * r * r;
}
function Vm(r) {
  return 3 * r * r * (1 - r);
}
function Km(r) {
  return 3 * r * (1 - r) * (1 - r);
}
function jm(r) {
  return (1 - r) * (1 - r) * (1 - r);
}
function qm(r) {
  return r * r;
}
function zm(r) {
  return 2 * r * (1 - r);
}
function Wm(r) {
  return (1 - r) * (1 - r);
}
class pt {
  constructor(e, t, A) {
    this.document = e, this.name = t, this.value = A, this.isNormalizedColor = !1;
  }
  static empty(e) {
    return new pt(e, "EMPTY", "");
  }
  split() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", {
      document: t,
      name: A
    } = this;
    return Ya(this.getString()).trim().split(e).map((n) => new pt(t, A, n));
  }
  hasValue(e) {
    var {
      value: t
    } = this;
    return t !== null && t !== "" && (e || t !== 0) && typeof t < "u";
  }
  isString(e) {
    var {
      value: t
    } = this, A = typeof t == "string";
    return !A || !e ? A : e.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    var e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    var {
      value: t
    } = this, A = parseFloat(t);
    return this.isString(/%$/) && (A /= 100), A;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    var t = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = dF(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    var [A, n] = typeof e == "boolean" ? [void 0, e] : [e], {
      viewPort: i
    } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * i.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * i.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && n):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * i.computeSize(A);
      default: {
        var s = this.getNumber();
        return t && s < 1 ? s * i.computeSize(A) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    var e = this.getString(), t = /#([^)'"]+)/.exec(e);
    return t && (t = t[1]), t || (t = e), this.document.definitions[t];
  }
  getFillStyleDefinition(e, t) {
    var A = this.getDefinition();
    if (!A)
      return null;
    if (typeof A.createGradient == "function")
      return A.createGradient(this.document.ctx, e, t);
    if (typeof A.createPattern == "function") {
      if (A.getHrefAttribute().hasValue()) {
        var n = A.getAttribute("patternTransform");
        A = A.getHrefAttribute().getDefinition(), n.hasValue() && A.getAttribute("patternTransform", !0).setValue(n.value);
      }
      return A.createPattern(this.document.ctx, e, t);
    }
    return null;
  }
  getTextBaseline() {
    return this.hasValue() ? pt.textBaselineMapping[this.getString()] : null;
  }
  addOpacity(e) {
    for (var t = this.getColor(), A = t.length, n = 0, i = 0; i < A && (t[i] === "," && n++, n !== 3); i++)
      ;
    if (e.hasValue() && this.isString() && n !== 3) {
      var s = new Rm(t);
      s.ok && (s.alpha = e.getNumber(), t = s.toRGBA());
    }
    return new pt(this.document, this.name, t);
  }
}
pt.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class pF {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, t) {
    this.viewPorts.push({
      width: e,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getCurrent() {
    var {
      viewPorts: e
    } = this;
    return e[e.length - 1];
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
class Tr {
  constructor(e, t) {
    this.x = e, this.y = t;
  }
  static parse(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [A = t, n = t] = on(e);
    return new Tr(A, n);
  }
  static parseScale(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [A = t, n = A] = on(e);
    return new Tr(A, n);
  }
  static parsePath(e) {
    for (var t = on(e), A = t.length, n = [], i = 0; i < A; i += 2)
      n.push(new Tr(t[i], t[i + 1]));
    return n;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    var {
      x: t,
      y: A
    } = this, n = t * e[0] + A * e[2] + e[4], i = t * e[1] + A * e[3] + e[5];
    this.x = n, this.y = i;
  }
}
class mF {
  constructor(e) {
    this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (!this.working) {
      var {
        screen: e,
        onClick: t,
        onMouseMove: A
      } = this, n = e.ctx.canvas;
      n.onclick = t, n.onmousemove = A, this.working = !0;
    }
  }
  stop() {
    if (this.working) {
      var e = this.screen.ctx.canvas;
      this.working = !1, e.onclick = null, e.onmousemove = null;
    }
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (this.working) {
      var {
        screen: e,
        events: t,
        eventElements: A
      } = this, {
        style: n
      } = e.ctx.canvas;
      n && (n.cursor = ""), t.forEach((i, s) => {
        for (var {
          run: a
        } = i, o = A[s]; o; )
          a(o), o = o.parent;
      }), this.events = [], this.eventElements = [];
    }
  }
  checkPath(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: A,
        eventElements: n
      } = this;
      A.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInPath && t.isPointInPath(a, o) && (n[s] = e);
      });
    }
  }
  checkBoundingBox(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: A,
        eventElements: n
      } = this;
      A.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInBox(a, o) && (n[s] = e);
      });
    }
  }
  mapXY(e, t) {
    for (var {
      window: A,
      ctx: n
    } = this.screen, i = new Tr(e, t), s = n.canvas; s; )
      i.x -= s.offsetLeft, i.y -= s.offsetTop, s = s.offsetParent;
    return A.scrollX && (i.x += A.scrollX), A.scrollY && (i.y += A.scrollY), i;
  }
  onClick(e) {
    var {
      x: t,
      y: A
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: A,
      run(n) {
        n.onClick && n.onClick();
      }
    });
  }
  onMouseMove(e) {
    var {
      x: t,
      y: A
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: A,
      run(n) {
        n.onMouseMove && n.onMouseMove();
      }
    });
  }
}
var vF = typeof window < "u" ? window : null, wF = typeof fetch < "u" ? fetch.bind(void 0) : null;
class Lu {
  constructor(e) {
    var {
      fetch: t = wF,
      window: A = vF
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.ctx = e, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new pF(), this.mouse = new mF(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = A, this.fetch = t;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    var e = this.waits.every((t) => t());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox(e) {
    var {
      document: t,
      ctx: A,
      aspectRatio: n,
      width: i,
      desiredWidth: s,
      height: a,
      desiredHeight: o,
      minX: l = 0,
      minY: u = 0,
      refX: c,
      refY: f,
      clip: h = !1,
      clipX: g = 0,
      clipY: p = 0
    } = e, v = Ya(n).replace(/^defer\s/, ""), [w, b] = v.split(" "), S = w || "xMidYMid", B = b || "meet", x = i / s, U = a / o, Q = Math.min(x, U), N = Math.max(x, U), _ = s, R = o;
    B === "meet" && (_ *= Q, R *= Q), B === "slice" && (_ *= N, R *= N);
    var F = new pt(t, "refX", c), O = new pt(t, "refY", f), G = F.hasValue() && O.hasValue();
    if (G && A.translate(-Q * F.getPixels("x"), -Q * O.getPixels("y")), h) {
      var H = Q * g, $ = Q * p;
      A.beginPath(), A.moveTo(H, $), A.lineTo(i, $), A.lineTo(i, a), A.lineTo(H, a), A.closePath(), A.clip();
    }
    if (!G) {
      var ne = B === "meet" && Q === U, te = B === "slice" && N === U, J = B === "meet" && Q === x, re = B === "slice" && N === x;
      S.startsWith("xMid") && (ne || te) && A.translate(i / 2 - _ / 2, 0), S.endsWith("YMid") && (J || re) && A.translate(0, a / 2 - R / 2), S.startsWith("xMax") && (ne || te) && A.translate(i - _, 0), S.endsWith("YMax") && (J || re) && A.translate(0, a - R);
    }
    switch (!0) {
      case S === "none":
        A.scale(x, U);
        break;
      case B === "meet":
        A.scale(Q, Q);
        break;
      case B === "slice":
        A.scale(N, N);
        break;
    }
    A.translate(-l, -u);
  }
  start(e) {
    var {
      enableRedraw: t = !1,
      ignoreMouse: A = !1,
      ignoreAnimation: n = !1,
      ignoreDimensions: i = !1,
      ignoreClear: s = !1,
      forceRedraw: a,
      scaleWidth: o,
      scaleHeight: l,
      offsetX: u,
      offsetY: c
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      FRAMERATE: f,
      mouse: h
    } = this, g = 1e3 / f;
    if (this.frameDuration = g, this.readyPromise = new Promise((S) => {
      this.resolveReady = S;
    }), this.isReady() && this.render(e, i, s, o, l, u, c), !!t) {
      var p = Date.now(), v = p, w = 0, b = () => {
        p = Date.now(), w = p - v, w >= g && (v = p - w % g, this.shouldUpdate(n, a) && (this.render(e, i, s, o, l, u, c), h.runEvents())), this.intervalId = M0(b);
      };
      A || h.start(), this.intervalId = M0(b);
    }
  }
  stop() {
    this.intervalId && (M0.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, t) {
    if (!e) {
      var {
        frameDuration: A
      } = this, n = this.animations.reduce((i, s) => s.update(A) || i, !1);
      if (n)
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, t, A, n, i, s, a) {
    var {
      CLIENT_WIDTH: o,
      CLIENT_HEIGHT: l,
      viewPort: u,
      ctx: c,
      isFirstRender: f
    } = this, h = c.canvas;
    u.clear(), h.width && h.height ? u.setCurrent(h.width, h.height) : u.setCurrent(o, l);
    var g = e.getStyle("width"), p = e.getStyle("height");
    !t && (f || typeof n != "number" && typeof i != "number") && (g.hasValue() && (h.width = g.getPixels("x"), h.style && (h.style.width = "".concat(h.width, "px"))), p.hasValue() && (h.height = p.getPixels("y"), h.style && (h.style.height = "".concat(h.height, "px"))));
    var v = h.clientWidth || h.width, w = h.clientHeight || h.height;
    if (t && g.hasValue() && p.hasValue() && (v = g.getPixels("x"), w = p.getPixels("y")), u.setCurrent(v, w), typeof s == "number" && e.getAttribute("x", !0).setValue(s), typeof a == "number" && e.getAttribute("y", !0).setValue(a), typeof n == "number" || typeof i == "number") {
      var b = on(e.getAttribute("viewBox").getString()), S = 0, B = 0;
      if (typeof n == "number") {
        var x = e.getStyle("width");
        x.hasValue() ? S = x.getPixels("x") / n : isNaN(b[2]) || (S = b[2] / n);
      }
      if (typeof i == "number") {
        var U = e.getStyle("height");
        U.hasValue() ? B = U.getPixels("y") / i : isNaN(b[3]) || (B = b[3] / i);
      }
      S || (S = B), B || (B = S), e.getAttribute("width", !0).setValue(n), e.getAttribute("height", !0).setValue(i);
      var Q = e.getStyle("transform", !0, !0);
      Q.setValue("".concat(Q.getString(), " scale(").concat(1 / S, ", ").concat(1 / B, ")"));
    }
    A || c.clearRect(0, 0, v, w), e.render(c), f && (this.isFirstRender = !1);
  }
}
Lu.defaultWindow = vF;
Lu.defaultFetch = wF;
var {
  defaultFetch: B8
} = Lu, C8 = typeof DOMParser < "u" ? DOMParser : null;
class ph {
  constructor() {
    var {
      fetch: e = B8,
      DOMParser: t = C8
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fetch = e, this.DOMParser = t;
  }
  parse(e) {
    var t = this;
    return us(function* () {
      return e.startsWith("<") ? t.parseFromString(e) : t.load(e);
    })();
  }
  parseFromString(e) {
    var t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    var t = e.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent);
    return e;
  }
  load(e) {
    var t = this;
    return us(function* () {
      var A = yield t.fetch(e), n = yield A.text();
      return t.parseFromString(n);
    })();
  }
}
class yF {
  constructor(e, t) {
    this.type = "translate", this.point = null, this.point = Tr.parse(t);
  }
  apply(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.translate(t || 0, A || 0);
  }
  unapply(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.translate(-1 * t || 0, -1 * A || 0);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.applyTransform([1, 0, 0, 1, t || 0, A || 0]);
  }
}
class bF {
  constructor(e, t, A) {
    this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
    var n = on(t);
    this.angle = new pt(e, "angle", n[0]), this.originX = A[0], this.originY = A[1], this.cx = n[1] || 0, this.cy = n[2] || 0;
  }
  apply(e) {
    var {
      cx: t,
      cy: A,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = A + i.getPixels("y");
    e.translate(a, o), e.rotate(s.getRadians()), e.translate(-a, -o);
  }
  unapply(e) {
    var {
      cx: t,
      cy: A,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = A + i.getPixels("y");
    e.translate(a, o), e.rotate(-1 * s.getRadians()), e.translate(-a, -o);
  }
  applyToPoint(e) {
    var {
      cx: t,
      cy: A,
      angle: n
    } = this, i = n.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      A || 0
      // this.p.y
    ]), e.applyTransform([Math.cos(i), Math.sin(i), -Math.sin(i), Math.cos(i), 0, 0]), e.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      -A || 0
      // -this.p.y
    ]);
  }
}
class BF {
  constructor(e, t, A) {
    this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
    var n = Tr.parseScale(t);
    (n.x === 0 || n.y === 0) && (n.x = Ma, n.y = Ma), this.scale = n, this.originX = A[0], this.originY = A[1];
  }
  apply(e) {
    var {
      scale: {
        x: t,
        y: A
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    e.translate(s, a), e.scale(t, A || t), e.translate(-s, -a);
  }
  unapply(e) {
    var {
      scale: {
        x: t,
        y: A
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    e.translate(s, a), e.scale(1 / t, 1 / A || t), e.translate(-s, -a);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: A
    } = this.scale;
    e.applyTransform([t || 0, 0, 0, A || 0, 0, 0]);
  }
}
class Xv {
  constructor(e, t, A) {
    this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = on(t), this.originX = A[0], this.originY = A[1];
  }
  apply(e) {
    var {
      originX: t,
      originY: A,
      matrix: n
    } = this, i = t.getPixels("x"), s = A.getPixels("y");
    e.translate(i, s), e.transform(n[0], n[1], n[2], n[3], n[4], n[5]), e.translate(-i, -s);
  }
  unapply(e) {
    var {
      originX: t,
      originY: A,
      matrix: n
    } = this, i = n[0], s = n[2], a = n[4], o = n[1], l = n[3], u = n[5], c = 0, f = 0, h = 1, g = 1 / (i * (l * h - u * f) - s * (o * h - u * c) + a * (o * f - l * c)), p = t.getPixels("x"), v = A.getPixels("y");
    e.translate(p, v), e.transform(g * (l * h - u * f), g * (u * c - o * h), g * (a * f - s * h), g * (i * h - a * c), g * (s * u - a * l), g * (a * o - i * u)), e.translate(-p, -v);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class Yv extends Xv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skew", this.angle = null, this.angle = new pt(e, "angle", t);
  }
}
class CF extends Yv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class SF extends Yv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function S8(r) {
  return Ya(r).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function x8(r) {
  var [e, t] = r.split("(");
  return [e.trim(), t.trim().replace(")", "")];
}
class Ys {
  constructor(e, t, A) {
    this.document = e, this.transforms = [];
    var n = S8(t);
    n.forEach((i) => {
      if (i !== "none") {
        var [s, a] = x8(i), o = Ys.transformTypes[s];
        typeof o < "u" && this.transforms.push(new o(this.document, a, A));
      }
    });
  }
  static fromElement(e, t) {
    var A = t.getStyle("transform", !1, !0), [n, i = n] = t.getStyle("transform-origin", !1, !0).split(), s = [n, i];
    return A.hasValue() ? new Ys(e, A.getString(), s) : null;
  }
  apply(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = 0; n < A; n++)
      t[n].apply(e);
  }
  unapply(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = A - 1; n >= 0; n--)
      t[n].unapply(e);
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = 0; n < A; n++)
      t[n].applyToPoint(e);
  }
}
Ys.transformTypes = {
  translate: yF,
  rotate: bF,
  scale: BF,
  matrix: Xv,
  skewX: CF,
  skewY: SF
};
class mr {
  constructor(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (this.document = e, this.node = t, this.captureTextNodes = A, this.attributes = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!t || t.nodeType !== 1)) {
      if (Array.from(t.attributes).forEach((a) => {
        var o = fF(a.nodeName);
        this.attributes[o] = new pt(e, o, a.value);
      }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue()) {
        var n = this.getAttribute("style").getString().split(";").map((a) => a.trim());
        n.forEach((a) => {
          if (a) {
            var [o, l] = a.split(":").map((u) => u.trim());
            this.styles[o] = new pt(e, o, l);
          }
        });
      }
      var {
        definitions: i
      } = e, s = this.getAttribute("id");
      s.hasValue() && (i[s.getString()] || (i[s.getString()] = this)), Array.from(t.childNodes).forEach((a) => {
        if (a.nodeType === 1)
          this.addChild(a);
        else if (A && (a.nodeType === 3 || a.nodeType === 4)) {
          var o = e.createTextNode(a);
          o.getText().length > 0 && this.addChild(o);
        }
      });
    }
  }
  getAttribute(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = this.attributes[e];
    if (!A && t) {
      var n = new pt(this.document, e, "");
      return this.attributes[e] = n, n;
    }
    return A || pt.empty(this.document);
  }
  getHrefAttribute() {
    for (var e in this.attributes)
      if (e === "href" || e.endsWith(":href"))
        return this.attributes[e];
    return pt.empty(this.document);
  }
  getStyle(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.styles[e];
    if (n)
      return n;
    var i = this.getAttribute(e);
    if (i != null && i.hasValue())
      return this.styles[e] = i, i;
    if (!A) {
      var {
        parent: s
      } = this;
      if (s) {
        var a = s.getStyle(e);
        if (a != null && a.hasValue())
          return a;
      }
    }
    if (t) {
      var o = new pt(this.document, e, "");
      return this.styles[e] = o, o;
    }
    return n || pt.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        var t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        var A = this.getStyle("filter").getDefinition();
        A && (this.applyEffects(e), A.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    var t = Ys.fromElement(this.document, this);
    t && t.apply(e);
    var A = this.getStyle("clip-path", !1, !0);
    if (A.hasValue()) {
      var n = A.getDefinition();
      n && n.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((t) => {
      t.render(e);
    });
  }
  addChild(e) {
    var t = e instanceof mr ? e : this.document.createElement(e);
    t.parent = this, mr.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(e) {
    var t, {
      node: A
    } = this;
    if (typeof A.matches == "function")
      return A.matches(e);
    var n = (t = A.getAttribute) === null || t === void 0 ? void 0 : t.call(A, "class");
    return !n || n === "" ? !1 : n.split(" ").some((i) => ".".concat(i) === e);
  }
  addStylesFromStyleDefinition() {
    var {
      styles: e,
      stylesSpecificity: t
    } = this.document;
    for (var A in e)
      if (!A.startsWith("@") && this.matchesSelector(A)) {
        var n = e[A], i = t[A];
        if (n)
          for (var s in n) {
            var a = this.stylesSpecificity[s];
            typeof a > "u" && (a = "000"), i >= a && (this.styles[s] = n[s], this.stylesSpecificity[s] = i);
          }
      }
  }
  removeStyles(e, t) {
    var A = t.reduce((n, i) => {
      var s = e.getStyle(i);
      if (!s.hasValue())
        return n;
      var a = s.getString();
      return s.setValue(""), [...n, [i, a]];
    }, []);
    return A;
  }
  restoreStyles(e, t) {
    t.forEach((A) => {
      var [n, i] = A;
      e.getStyle(n, !0).setValue(i);
    });
  }
  isFirstChild() {
    var e;
    return ((e = this.parent) === null || e === void 0 ? void 0 : e.children.indexOf(this)) === 0;
  }
}
mr.ignoreChildTypes = ["title"];
class xF extends mr {
  constructor(e, t, A) {
    super(e, t, A);
  }
}
function E8(r) {
  var e = r.trim();
  return /^('|")/.test(e) ? e : '"'.concat(e, '"');
}
function F8(r) {
  return typeof process > "u" ? r : r.trim().split(",").map(E8).join(",");
}
function _8(r) {
  if (!r)
    return "";
  var e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function U8(r) {
  if (!r)
    return "";
  var e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
class HA {
  constructor(e, t, A, n, i, s) {
    var a = s ? typeof s == "string" ? HA.parse(s) : s : {};
    this.fontFamily = i || a.fontFamily, this.fontSize = n || a.fontSize, this.fontStyle = e || a.fontStyle, this.fontWeight = A || a.fontWeight, this.fontVariant = t || a.fontVariant;
  }
  static parse() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, A = "", n = "", i = "", s = "", a = "", o = Ya(e).trim().split(" "), l = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return o.forEach((u) => {
      switch (!0) {
        case (!l.fontStyle && HA.styles.includes(u)):
          u !== "inherit" && (A = u), l.fontStyle = !0;
          break;
        case (!l.fontVariant && HA.variants.includes(u)):
          u !== "inherit" && (n = u), l.fontStyle = !0, l.fontVariant = !0;
          break;
        case (!l.fontWeight && HA.weights.includes(u)):
          u !== "inherit" && (i = u), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0;
          break;
        case !l.fontSize:
          u !== "inherit" && ([s] = u.split("/")), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0, l.fontSize = !0;
          break;
        default:
          u !== "inherit" && (a += u);
      }
    }), new HA(A, n, i, s, a, t);
  }
  toString() {
    return [
      _8(this.fontStyle),
      this.fontVariant,
      U8(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      F8(this.fontFamily)
    ].join(" ").trim();
  }
}
HA.styles = "normal|italic|oblique|inherit";
HA.variants = "normal|small-caps|inherit";
HA.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class Kn {
  constructor() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
    this.x1 = e, this.y1 = t, this.x2 = A, this.y2 = n, this.addPoint(e, t), this.addPoint(A, n);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, t) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(e) {
    this.addPoint(e, null);
  }
  addY(e) {
    this.addPoint(null, e);
  }
  addBoundingBox(e) {
    if (e) {
      var {
        x1: t,
        y1: A,
        x2: n,
        y2: i
      } = e;
      this.addPoint(t, A), this.addPoint(n, i);
    }
  }
  sumCubic(e, t, A, n, i) {
    return Math.pow(1 - e, 3) * t + 3 * Math.pow(1 - e, 2) * e * A + 3 * (1 - e) * Math.pow(e, 2) * n + Math.pow(e, 3) * i;
  }
  bezierCurveAdd(e, t, A, n, i) {
    var s = 6 * t - 12 * A + 6 * n, a = -3 * t + 9 * A - 9 * n + 3 * i, o = 3 * A - 3 * t;
    if (a === 0) {
      if (s === 0)
        return;
      var l = -o / s;
      0 < l && l < 1 && (e ? this.addX(this.sumCubic(l, t, A, n, i)) : this.addY(this.sumCubic(l, t, A, n, i)));
      return;
    }
    var u = Math.pow(s, 2) - 4 * o * a;
    if (!(u < 0)) {
      var c = (-s + Math.sqrt(u)) / (2 * a);
      0 < c && c < 1 && (e ? this.addX(this.sumCubic(c, t, A, n, i)) : this.addY(this.sumCubic(c, t, A, n, i)));
      var f = (-s - Math.sqrt(u)) / (2 * a);
      0 < f && f < 1 && (e ? this.addX(this.sumCubic(f, t, A, n, i)) : this.addY(this.sumCubic(f, t, A, n, i)));
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, t, A, n, i, s, a, o) {
    this.addPoint(e, t), this.addPoint(a, o), this.bezierCurveAdd(!0, e, A, i, a), this.bezierCurveAdd(!1, t, n, s, o);
  }
  addQuadraticCurve(e, t, A, n, i, s) {
    var a = e + 0.6666666666666666 * (A - e), o = t + 2 / 3 * (n - t), l = a + 1 / 3 * (i - e), u = o + 1 / 3 * (s - t);
    this.addBezierCurve(e, t, a, l, o, u, i, s);
  }
  isPointInBox(e, t) {
    var {
      x1: A,
      y1: n,
      x2: i,
      y2: s
    } = this;
    return A <= e && e <= i && n <= t && t <= s;
  }
}
class Ut extends Ue {
  constructor(e) {
    super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new Tr(0, 0), this.control = new Tr(0, 0), this.current = new Tr(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    var {
      i: e,
      commands: t
    } = this;
    return e >= t.length - 1;
  }
  next() {
    var e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", A = new Tr(this.command[e], this.command[t]);
    return this.makeAbsolute(A);
  }
  getAsControlPoint(e, t) {
    var A = this.getPoint(e, t);
    return this.control = A, A;
  }
  getAsCurrentPoint(e, t) {
    var A = this.getPoint(e, t);
    return this.current = A, A;
  }
  getReflectedControlPoint() {
    var e = this.previousCommand.type;
    if (e !== Ue.CURVE_TO && e !== Ue.SMOOTH_CURVE_TO && e !== Ue.QUAD_TO && e !== Ue.SMOOTH_QUAD_TO)
      return this.current;
    var {
      current: {
        x: t,
        y: A
      },
      control: {
        x: n,
        y: i
      }
    } = this, s = new Tr(2 * t - n, 2 * A - i);
    return s;
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      var {
        x: t,
        y: A
      } = this.current;
      e.x += t, e.y += A;
    }
    return e;
  }
  addMarker(e, t, A) {
    var {
      points: n,
      angles: i
    } = this;
    A && i.length > 0 && !i[i.length - 1] && (i[i.length - 1] = n[n.length - 1].angleTo(A)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
  }
  addMarkerAngle(e, t) {
    this.points.push(e), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    for (var {
      angles: e
    } = this, t = e.length, A = 0; A < t; A++)
      if (!e[A]) {
        for (var n = A + 1; n < t; n++)
          if (e[n]) {
            e[A] = e[n];
            break;
          }
      }
    return e;
  }
}
class ra extends mr {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    for (var e = 1, t = this; t; ) {
      var A = t.getStyle("opacity", !1, !0);
      A.hasValue(!0) && (e *= A.getNumber()), t = t.parent;
    }
    return e;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!t) {
      var A = this.getStyle("fill"), n = this.getStyle("fill-opacity"), i = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (A.isUrlDefinition()) {
        var a = A.getFillStyleDefinition(this, n);
        a && (e.fillStyle = a);
      } else if (A.hasValue()) {
        A.getString() === "currentColor" && A.setValue(this.getStyle("color").getColor());
        var o = A.getColor();
        o !== "inherit" && (e.fillStyle = o === "none" ? "rgba(0,0,0,0)" : o);
      }
      if (n.hasValue()) {
        var l = new pt(this.document, "fill", e.fillStyle).addOpacity(n).getColor();
        e.fillStyle = l;
      }
      if (i.isUrlDefinition()) {
        var u = i.getFillStyleDefinition(this, s);
        u && (e.strokeStyle = u);
      } else if (i.hasValue()) {
        i.getString() === "currentColor" && i.setValue(this.getStyle("color").getColor());
        var c = i.getString();
        c !== "inherit" && (e.strokeStyle = c === "none" ? "rgba(0,0,0,0)" : c);
      }
      if (s.hasValue()) {
        var f = new pt(this.document, "stroke", e.strokeStyle).addOpacity(s).getString();
        e.strokeStyle = f;
      }
      var h = this.getStyle("stroke-width");
      if (h.hasValue()) {
        var g = h.getPixels();
        e.lineWidth = g || Ma;
      }
      var p = this.getStyle("stroke-linecap"), v = this.getStyle("stroke-linejoin"), w = this.getStyle("stroke-miterlimit"), b = this.getStyle("stroke-dasharray"), S = this.getStyle("stroke-dashoffset");
      if (p.hasValue() && (e.lineCap = p.getString()), v.hasValue() && (e.lineJoin = v.getString()), w.hasValue() && (e.miterLimit = w.getNumber()), b.hasValue() && b.getString() !== "none") {
        var B = on(b.getString());
        typeof e.setLineDash < "u" ? e.setLineDash(B) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = B : typeof e.mozDash < "u" && !(B.length === 1 && B[0] === 0) && (e.mozDash = B);
        var x = S.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = x : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = x : typeof e.mozDashOffset < "u" && (e.mozDashOffset = x);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      var U = this.getStyle("font"), Q = this.getStyle("font-style"), N = this.getStyle("font-variant"), _ = this.getStyle("font-weight"), R = this.getStyle("font-size"), F = this.getStyle("font-family"), O = new HA(Q.getString(), N.getString(), _.getString(), R.hasValue() ? "".concat(R.getPixels(!0), "px") : "", F.getString(), HA.parse(U.getString(), e.font));
      Q.setValue(O.fontStyle), N.setValue(O.fontVariant), _.setValue(O.fontWeight), R.setValue(O.fontSize), F.setValue(O.fontFamily), e.font = O.toString(), R.isPixels() && (this.document.emSize = R.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class rr extends ra {
  constructor(e, t, A) {
    super(e, t, A), this.type = "path", this.pathParser = null, this.pathParser = new Ut(this.getAttribute("d").getString());
  }
  path(e) {
    var {
      pathParser: t
    } = this, A = new Kn();
    for (t.reset(), e && e.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case Ut.MOVE_TO:
          this.pathM(e, A);
          break;
        case Ut.LINE_TO:
          this.pathL(e, A);
          break;
        case Ut.HORIZ_LINE_TO:
          this.pathH(e, A);
          break;
        case Ut.VERT_LINE_TO:
          this.pathV(e, A);
          break;
        case Ut.CURVE_TO:
          this.pathC(e, A);
          break;
        case Ut.SMOOTH_CURVE_TO:
          this.pathS(e, A);
          break;
        case Ut.QUAD_TO:
          this.pathQ(e, A);
          break;
        case Ut.SMOOTH_QUAD_TO:
          this.pathT(e, A);
          break;
        case Ut.ARC:
          this.pathA(e, A);
          break;
        case Ut.CLOSE_PATH:
          this.pathZ(e, A);
          break;
      }
    return A;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    var {
      pathParser: e
    } = this, t = e.getMarkerPoints(), A = e.getMarkerAngles(), n = t.map((i, s) => [i, A[s]]);
    return n;
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    var t = this.getStyle("fill-rule");
    e.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? e.fill(t.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    var A = this.getMarkers();
    if (A) {
      var n = A.length - 1, i = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), a = this.getStyle("marker-end");
      if (i.isUrlDefinition()) {
        var o = i.getDefinition(), [l, u] = A[0];
        o.render(e, l, u);
      }
      if (s.isUrlDefinition())
        for (var c = s.getDefinition(), f = 1; f < n; f++) {
          var [h, g] = A[f];
          c.render(e, h, g);
        }
      if (a.isUrlDefinition()) {
        var p = a.getDefinition(), [v, w] = A[n];
        p.render(e, v, w);
      }
    }
  }
  static pathM(e) {
    var t = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: t
    };
  }
  pathM(e, t) {
    var {
      pathParser: A
    } = this, {
      point: n
    } = rr.pathM(A), {
      x: i,
      y: s
    } = n;
    A.addMarker(n), t.addPoint(i, s), e && e.moveTo(i, s);
  }
  static pathL(e) {
    var {
      current: t
    } = e, A = e.getAsCurrentPoint();
    return {
      current: t,
      point: A
    };
  }
  pathL(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = rr.pathL(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathH(e) {
    var {
      current: t,
      command: A
    } = e, n = new Tr((A.relative ? t.x : 0) + A.x, t.y);
    return e.current = n, {
      current: t,
      point: n
    };
  }
  pathH(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = rr.pathH(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathV(e) {
    var {
      current: t,
      command: A
    } = e, n = new Tr(t.x, (A.relative ? t.y : 0) + A.y);
    return e.current = n, {
      current: t,
      point: n
    };
  }
  pathV(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = rr.pathV(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathC(e) {
    var {
      current: t
    } = e, A = e.getPoint("x1", "y1"), n = e.getAsControlPoint("x2", "y2"), i = e.getAsCurrentPoint();
    return {
      current: t,
      point: A,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathC(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = rr.pathC(A);
    A.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), e && e.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathS(e) {
    var {
      current: t
    } = e, A = e.getReflectedControlPoint(), n = e.getAsControlPoint("x2", "y2"), i = e.getAsCurrentPoint();
    return {
      current: t,
      point: A,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathS(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = rr.pathS(A);
    A.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), e && e.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathQ(e) {
    var {
      current: t
    } = e, A = e.getAsControlPoint("x1", "y1"), n = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: A,
      currentPoint: n
    };
  }
  pathQ(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = rr.pathQ(A);
    A.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), e && e.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathT(e) {
    var {
      current: t
    } = e, A = e.getReflectedControlPoint();
    e.control = A;
    var n = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: A,
      currentPoint: n
    };
  }
  pathT(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = rr.pathT(A);
    A.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), e && e.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathA(e) {
    var {
      current: t,
      command: A
    } = e, {
      rX: n,
      rY: i,
      xRot: s,
      lArcFlag: a,
      sweepFlag: o
    } = A, l = s * (Math.PI / 180), u = e.getAsCurrentPoint(), c = new Tr(Math.cos(l) * (t.x - u.x) / 2 + Math.sin(l) * (t.y - u.y) / 2, -Math.sin(l) * (t.x - u.x) / 2 + Math.cos(l) * (t.y - u.y) / 2), f = Math.pow(c.x, 2) / Math.pow(n, 2) + Math.pow(c.y, 2) / Math.pow(i, 2);
    f > 1 && (n *= Math.sqrt(f), i *= Math.sqrt(f));
    var h = (a === o ? -1 : 1) * Math.sqrt((Math.pow(n, 2) * Math.pow(i, 2) - Math.pow(n, 2) * Math.pow(c.y, 2) - Math.pow(i, 2) * Math.pow(c.x, 2)) / (Math.pow(n, 2) * Math.pow(c.y, 2) + Math.pow(i, 2) * Math.pow(c.x, 2)));
    isNaN(h) && (h = 0);
    var g = new Tr(h * n * c.y / i, h * -i * c.x / n), p = new Tr((t.x + u.x) / 2 + Math.cos(l) * g.x - Math.sin(l) * g.y, (t.y + u.y) / 2 + Math.sin(l) * g.x + Math.cos(l) * g.y), v = Dm([1, 0], [(c.x - g.x) / n, (c.y - g.y) / i]), w = [(c.x - g.x) / n, (c.y - g.y) / i], b = [(-c.x - g.x) / n, (-c.y - g.y) / i], S = Dm(w, b);
    return Mh(w, b) <= -1 && (S = Math.PI), Mh(w, b) >= 1 && (S = 0), {
      currentPoint: u,
      rX: n,
      rY: i,
      sweepFlag: o,
      xAxisRotation: l,
      centp: p,
      a1: v,
      ad: S
    };
  }
  pathA(e, t) {
    var {
      pathParser: A
    } = this, {
      currentPoint: n,
      rX: i,
      rY: s,
      sweepFlag: a,
      xAxisRotation: o,
      centp: l,
      a1: u,
      ad: c
    } = rr.pathA(A), f = 1 - a ? 1 : -1, h = u + f * (c / 2), g = new Tr(l.x + i * Math.cos(h), l.y + s * Math.sin(h));
    if (A.addMarkerAngle(g, h - f * Math.PI / 2), A.addMarkerAngle(n, h - f * Math.PI), t.addPoint(n.x, n.y), e && !isNaN(u) && !isNaN(c)) {
      var p = i > s ? i : s, v = i > s ? 1 : i / s, w = i > s ? s / i : 1;
      e.translate(l.x, l.y), e.rotate(o), e.scale(v, w), e.arc(0, 0, p, u, u + c, !!(1 - a)), e.scale(1 / v, 1 / w), e.rotate(-o), e.translate(-l.x, -l.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, t) {
    rr.pathZ(this.pathParser), e && t.x1 !== t.x2 && t.y1 !== t.y2 && e.closePath();
  }
}
class $v extends rr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class cs extends ra {
  constructor(e, t, A) {
    super(e, t, new.target === cs ? !0 : A), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(e, t);
    var A = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    A && (e.textBaseline = A);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
    var t = null;
    return this.children.forEach((A, n) => {
      var i = this.getChildBoundingBox(e, this, this, n);
      t ? t.addBoundingBox(i) : t = i;
    }), t;
  }
  getFontSize() {
    var {
      document: e,
      parent: t
    } = this, A = HA.parse(e.ctx.font).fontSize, n = t.getStyle("font-size").getNumber(A);
    return n;
  }
  getTElementBoundingBox(e) {
    var t = this.getFontSize();
    return new Kn(this.x, this.y - t, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, t, A) {
    var n = t[A], i = null;
    if (e.isArabic) {
      var s = t.length, a = t[A - 1], o = t[A + 1], l = "isolated";
      if ((A === 0 || a === " ") && A < s - 1 && o !== " " && (l = "terminal"), A > 0 && a !== " " && A < s - 1 && o !== " " && (l = "medial"), A > 0 && a !== " " && (A === s - 1 || o === " ") && (l = "initial"), typeof e.glyphs[n] < "u") {
        var u = e.glyphs[n];
        i = u instanceof $v ? u : u[l];
      }
    } else
      i = e.glyphs[n];
    return i || (i = e.missingGlyph), i;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    var t = e || this.node, A = Array.from(t.parentNode.childNodes), n = A.indexOf(t), i = A.length - 1, s = Ya(
      // textNode.value
      // || textNode.text
      t.textContent || ""
    );
    return n === 0 && (s = cF(s)), n === i && (s = hF(s)), s;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((A, n) => {
      this.renderChild(e, this, this, n);
    });
    var {
      mouse: t
    } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    var {
      document: t,
      parent: A
    } = this, n = this.getText(), i = A.getStyle("font-family").getDefinition();
    if (i) {
      for (var {
        unitsPerEm: s
      } = i.fontFace, a = HA.parse(t.ctx.font), o = A.getStyle("font-size").getNumber(a.fontSize), l = A.getStyle("font-style").getString(a.fontStyle), u = o / s, c = i.isRTL ? n.split("").reverse().join("") : n, f = on(A.getAttribute("dx").getString()), h = c.length, g = 0; g < h; g++) {
        var p = this.getGlyph(i, c, g);
        e.translate(this.x, this.y), e.scale(u, -u);
        var v = e.lineWidth;
        e.lineWidth = e.lineWidth * s / o, l === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), p.render(e), l === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = v, e.scale(1 / u, -1 / u), e.translate(-this.x, -this.y), this.x += o * (p.horizAdvX || i.horizAdvX) / s, typeof f[g] < "u" && !isNaN(f[g]) && (this.x += f[g]);
      }
      return;
    }
    var {
      x: w,
      y: b
    } = this;
    e.fillStyle && e.fillText(n, w, b), e.strokeStyle && e.strokeText(n, w, b);
  }
  applyAnchoring() {
    if (!(this.textChunkStart >= this.leafTexts.length)) {
      var e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), A = !1, n = 0;
      t === "start" && !A || t === "end" && A ? n = e.x - this.minX : t === "end" && !A || t === "start" && A ? n = e.x - this.maxX : n = e.x - (this.minX + this.maxX) / 2;
      for (var i = this.textChunkStart; i < this.leafTexts.length; i++)
        this.leafTexts[i].x += n;
      this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
    }
  }
  adjustChildCoordinatesRecursive(e) {
    this.children.forEach((t, A) => {
      this.adjustChildCoordinatesRecursiveCore(e, this, this, A);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(e, t, A, n) {
    var i = A.children[n];
    i.children.length > 0 ? i.children.forEach((s, a) => {
      t.adjustChildCoordinatesRecursiveCore(e, t, i, a);
    }) : this.adjustChildCoordinates(e, t, A, n);
  }
  adjustChildCoordinates(e, t, A, n) {
    var i = A.children[n];
    if (typeof i.measureText != "function")
      return i;
    e.save(), i.setContext(e, !0);
    var s = i.getAttribute("x"), a = i.getAttribute("y"), o = i.getAttribute("dx"), l = i.getAttribute("dy"), u = i.getStyle("font-family").getDefinition(), c = !!u && u.isRTL;
    n === 0 && (s.hasValue() || s.setValue(i.getInheritedAttribute("x")), a.hasValue() || a.setValue(i.getInheritedAttribute("y")), o.hasValue() || o.setValue(i.getInheritedAttribute("dx")), l.hasValue() || l.setValue(i.getInheritedAttribute("dy")));
    var f = i.measureText(e);
    return c && (t.x -= f), s.hasValue() ? (t.applyAnchoring(), i.x = s.getPixels("x"), o.hasValue() && (i.x += o.getPixels("x"))) : (o.hasValue() && (t.x += o.getPixels("x")), i.x = t.x), t.x = i.x, c || (t.x += f), a.hasValue() ? (i.y = a.getPixels("y"), l.hasValue() && (i.y += l.getPixels("y"))) : (l.hasValue() && (t.y += l.getPixels("y")), i.y = t.y), t.y = i.y, t.leafTexts.push(i), t.minX = Math.min(t.minX, i.x, i.x + f), t.maxX = Math.max(t.maxX, i.x, i.x + f), i.clearContext(e), e.restore(), i;
  }
  getChildBoundingBox(e, t, A, n) {
    var i = A.children[n];
    if (typeof i.getBoundingBox != "function")
      return null;
    var s = i.getBoundingBox(e);
    return s ? (i.children.forEach((a, o) => {
      var l = t.getChildBoundingBox(e, t, i, o);
      s.addBoundingBox(l);
    }), s) : null;
  }
  renderChild(e, t, A, n) {
    var i = A.children[n];
    i.render(e), i.children.forEach((s, a) => {
      t.renderChild(e, t, i, a);
    });
  }
  measureText(e) {
    var {
      measureCache: t
    } = this;
    if (~t)
      return t;
    var A = this.getText(), n = this.measureTargetText(e, A);
    return this.measureCache = n, n;
  }
  measureTargetText(e, t) {
    if (!t.length)
      return 0;
    var {
      parent: A
    } = this, n = A.getStyle("font-family").getDefinition();
    if (n) {
      for (var i = this.getFontSize(), s = n.isRTL ? t.split("").reverse().join("") : t, a = on(A.getAttribute("dx").getString()), o = s.length, l = 0, u = 0; u < o; u++) {
        var c = this.getGlyph(n, s, u);
        l += (c.horizAdvX || n.horizAdvX) * i / n.fontFace.unitsPerEm, typeof a[u] < "u" && !isNaN(a[u]) && (l += a[u]);
      }
      return l;
    }
    if (!e.measureText)
      return t.length * 10;
    e.save(), this.setContext(e, !0);
    var {
      width: f
    } = e.measureText(t);
    return this.clearContext(e), e.restore(), f;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(e) {
    for (var t = this; t instanceof cs && t.isFirstChild(); ) {
      var A = t.parent.getAttribute(e);
      if (A.hasValue(!0))
        return A.getValue("0");
      t = t.parent;
    }
    return null;
  }
}
class Nu extends cs {
  constructor(e, t, A) {
    super(e, t, new.target === Nu ? !0 : A), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class I8 extends Nu {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
class jo extends ra {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(e) {
    var t, {
      document: A
    } = this, {
      screen: n,
      window: i
    } = A, s = e.canvas;
    if (n.setDefaults(e), s.style && typeof e.font < "u" && i && typeof i.getComputedStyle < "u") {
      e.font = i.getComputedStyle(s).getPropertyValue("font");
      var a = new pt(A, "fontSize", HA.parse(e.font).fontSize);
      a.hasValue() && (A.rootEmSize = a.getPixels("y"), A.emSize = A.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    var {
      width: o,
      height: l
    } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    var u = this.getAttribute("refX"), c = this.getAttribute("refY"), f = this.getAttribute("viewBox"), h = f.hasValue() ? on(f.getString()) : null, g = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", p = 0, v = 0, w = 0, b = 0;
    h && (p = h[0], v = h[1]), this.root || (o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y"), this.type === "marker" && (w = p, b = v, p = 0, v = 0)), n.viewPort.setCurrent(o, l), this.node && (!this.parent || ((t = this.node.parentNode) === null || t === void 0 ? void 0 : t.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), h && (o = h[2], l = h[3]), A.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: o,
      height: n.viewPort.height,
      desiredHeight: l,
      minX: p,
      minY: v,
      refX: u.getValue(),
      refY: c.getValue(),
      clip: g,
      clipX: w,
      clipY: b
    }), h && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(o, l));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.getAttribute("width", !0), i = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), a = this.getAttribute("style"), o = n.getNumber(0), l = i.getNumber(0);
    if (A)
      if (typeof A == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(A);
      else {
        var u = this.getAttribute("preserveAspectRatio");
        u.hasValue() && u.setValue(u.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (n.setValue(e), i.setValue(t), s.hasValue() || s.setValue("0 0 ".concat(o || e, " ").concat(l || t)), a.hasValue()) {
      var c = this.getStyle("width"), f = this.getStyle("height");
      c.hasValue() && c.setValue("".concat(e, "px")), f.hasValue() && f.setValue("".concat(t, "px"));
    }
  }
}
class Jv extends rr {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(e) {
    var t = this.getAttribute("x").getPixels("x"), A = this.getAttribute("y").getPixels("y"), n = this.getStyle("width", !1, !0).getPixels("x"), i = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), a = this.getAttribute("ry"), o = s.getPixels("x"), l = a.getPixels("y");
    if (s.hasValue() && !a.hasValue() && (l = o), a.hasValue() && !s.hasValue() && (o = l), o = Math.min(o, n / 2), l = Math.min(l, i / 2), e) {
      var u = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), i > 0 && n > 0 && (e.moveTo(t + o, A), e.lineTo(t + n - o, A), e.bezierCurveTo(t + n - o + u * o, A, t + n, A + l - u * l, t + n, A + l), e.lineTo(t + n, A + i - l), e.bezierCurveTo(t + n, A + i - l + u * l, t + n - o + u * o, A + i, t + n - o, A + i), e.lineTo(t + o, A + i), e.bezierCurveTo(t + o - u * o, A + i, t, A + i - l + u * l, t, A + i - l), e.lineTo(t, A + l), e.bezierCurveTo(t, A + l - u * l, t + o - u * o, A, t + o, A), e.closePath());
    }
    return new Kn(t, A, t + n, A + i);
  }
  getMarkers() {
    return null;
  }
}
class EF extends rr {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(e) {
    var t = this.getAttribute("cx").getPixels("x"), A = this.getAttribute("cy").getPixels("y"), n = this.getAttribute("r").getPixels();
    return e && n > 0 && (e.beginPath(), e.arc(t, A, n, 0, Math.PI * 2, !1), e.closePath()), new Kn(t - n, A - n, t + n, A + n);
  }
  getMarkers() {
    return null;
  }
}
class FF extends rr {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(e) {
    var t = 4 * ((Math.sqrt(2) - 1) / 3), A = this.getAttribute("rx").getPixels("x"), n = this.getAttribute("ry").getPixels("y"), i = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return e && A > 0 && n > 0 && (e.beginPath(), e.moveTo(i + A, s), e.bezierCurveTo(i + A, s + t * n, i + t * A, s + n, i, s + n), e.bezierCurveTo(i - t * A, s + n, i - A, s + t * n, i - A, s), e.bezierCurveTo(i - A, s - t * n, i - t * A, s - n, i, s - n), e.bezierCurveTo(i + t * A, s - n, i + A, s - t * n, i + A, s), e.closePath()), new Kn(i - A, s - n, i + A, s + n);
  }
  getMarkers() {
    return null;
  }
}
class _F extends rr {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [new Tr(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new Tr(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
  }
  path(e) {
    var [{
      x: t,
      y: A
    }, {
      x: n,
      y: i
    }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(t, A), e.lineTo(n, i)), new Kn(t, A, n, i);
  }
  getMarkers() {
    var [e, t] = this.getPoints(), A = e.angleTo(t);
    return [[e, A], [t, A]];
  }
}
class Zv extends rr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "polyline", this.points = [], this.points = Tr.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    var {
      points: t
    } = this, [{
      x: A,
      y: n
    }] = t, i = new Kn(A, n);
    return e && (e.beginPath(), e.moveTo(A, n)), t.forEach((s) => {
      var {
        x: a,
        y: o
      } = s;
      i.addPoint(a, o), e && e.lineTo(a, o);
    }), i;
  }
  getMarkers() {
    var {
      points: e
    } = this, t = e.length - 1, A = [];
    return e.forEach((n, i) => {
      i !== t && A.push([n, n.angleTo(e[i + 1])]);
    }), A.length > 0 && A.push([e[e.length - 1], A[A.length - 1][1]]), A;
  }
}
class UF extends Zv {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(e) {
    var t = super.path(e), [{
      x: A,
      y: n
    }] = this.points;
    return e && (e.lineTo(A, n), e.closePath()), t;
  }
}
class IF extends mr {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(e, t, A) {
    var n = this.getStyle("width").getPixels("x", !0), i = this.getStyle("height").getPixels("y", !0), s = new jo(this.document, null);
    s.attributes.viewBox = new pt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), s.attributes.width = new pt(this.document, "width", "".concat(n, "px")), s.attributes.height = new pt(this.document, "height", "".concat(i, "px")), s.attributes.transform = new pt(this.document, "transform", this.getAttribute("patternTransform").getValue()), s.children = this.children;
    var a = this.document.createCanvas(n, i), o = a.getContext("2d"), l = this.getAttribute("x"), u = this.getAttribute("y");
    l.hasValue() && u.hasValue() && o.translate(l.getPixels("x", !0), u.getPixels("y", !0)), A.hasValue() ? this.styles["fill-opacity"] = A : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (var c = -1; c <= 1; c++)
      for (var f = -1; f <= 1; f++)
        o.save(), s.attributes.x = new pt(this.document, "x", c * a.width), s.attributes.y = new pt(this.document, "y", f * a.height), s.render(o), o.restore();
    var h = e.createPattern(a, "repeat");
    return h;
  }
}
class QF extends mr {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(e, t, A) {
    if (t) {
      var {
        x: n,
        y: i
      } = t, s = this.getAttribute("orient").getString("auto"), a = this.getAttribute("markerUnits").getString("strokeWidth");
      e.translate(n, i), s === "auto" && e.rotate(A), a === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
      var o = new jo(this.document, null);
      o.type = this.type, o.attributes.viewBox = new pt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), o.attributes.refX = new pt(this.document, "refX", this.getAttribute("refX").getValue()), o.attributes.refY = new pt(this.document, "refY", this.getAttribute("refY").getValue()), o.attributes.width = new pt(this.document, "width", this.getAttribute("markerWidth").getValue()), o.attributes.height = new pt(this.document, "height", this.getAttribute("markerHeight").getValue()), o.attributes.overflow = new pt(this.document, "overflow", this.getAttribute("overflow").getValue()), o.attributes.fill = new pt(this.document, "fill", this.getAttribute("fill").getColor("black")), o.attributes.stroke = new pt(this.document, "stroke", this.getAttribute("stroke").getValue("none")), o.children = this.children, o.render(e), e.restore(), a === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), s === "auto" && e.rotate(-A), e.translate(-n, -i);
    }
  }
}
class LF extends mr {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class mf extends ra {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(e) {
    var t = new Kn();
    return this.children.forEach((A) => {
      t.addBoundingBox(A.getBoundingBox(e));
    }), t;
  }
}
class e1 extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    var {
      stops: n,
      children: i
    } = this;
    i.forEach((s) => {
      s.type === "stop" && n.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, t, A) {
    var n = this;
    this.getHrefAttribute().hasValue() && (n = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(n));
    var {
      stops: i
    } = n, s = this.getGradient(e, t);
    if (!s)
      return this.addParentOpacity(A, i[i.length - 1].color);
    if (i.forEach((v) => {
      s.addColorStop(v.offset, this.addParentOpacity(A, v.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      var {
        document: a
      } = this, {
        MAX_VIRTUAL_PIXELS: o,
        viewPort: l
      } = a.screen, [u] = l.viewPorts, c = new Jv(a, null);
      c.attributes.x = new pt(a, "x", -o / 3), c.attributes.y = new pt(a, "y", -o / 3), c.attributes.width = new pt(a, "width", o), c.attributes.height = new pt(a, "height", o);
      var f = new mf(a, null);
      f.attributes.transform = new pt(a, "transform", this.getAttribute("gradientTransform").getValue()), f.children = [c];
      var h = new jo(a, null);
      h.attributes.x = new pt(a, "x", 0), h.attributes.y = new pt(a, "y", 0), h.attributes.width = new pt(a, "width", u.width), h.attributes.height = new pt(a, "height", u.height), h.children = [f];
      var g = a.createCanvas(u.width, u.height), p = g.getContext("2d");
      return p.fillStyle = s, h.render(p), p.createPattern(g, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(e.getAttribute(t).getValue());
    });
  }
  addParentOpacity(e, t) {
    if (e.hasValue()) {
      var A = new pt(this.document, "color", t);
      return A.addOpacity(e).getColor();
    }
    return t;
  }
}
class NF extends e1 {
  constructor(e, t, A) {
    super(e, t, A), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, t) {
    var A = this.getGradientUnits() === "objectBoundingBox", n = A ? t.getBoundingBox(e) : null;
    if (A && !n)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    var i = A ? n.x + n.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = A ? n.y + n.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), a = A ? n.x + n.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), o = A ? n.y + n.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return i === a && s === o ? null : e.createLinearGradient(i, s, a, o);
  }
}
class TF extends e1 {
  constructor(e, t, A) {
    super(e, t, A), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, t) {
    var A = this.getGradientUnits() === "objectBoundingBox", n = t.getBoundingBox(e);
    if (A && !n)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    var i = A ? n.x + n.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = A ? n.y + n.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), a = i, o = s;
    this.getAttribute("fx").hasValue() && (a = A ? n.x + n.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (o = A ? n.y + n.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    var l = A ? (n.width + n.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), u = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(a, o, u, i, s, l);
  }
}
class PF extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "stop";
    var n = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), i = this.getStyle("stop-opacity"), s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), i.hasValue() && (s = s.addOpacity(i)), this.offset = n, this.color = s.getColor();
  }
}
class vf extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new pt(e, "values", null);
    var n = this.getAttribute("values");
    n.hasValue() && this.values.setValue(n.getString().split(";"));
  }
  getProperty() {
    var e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent.getStyle(t, !0) : this.parent.getAttribute(t, !0);
  }
  calcValue() {
    var {
      initialUnits: e
    } = this, {
      progress: t,
      from: A,
      to: n
    } = this.getProgress(), i = A.getNumber() + (n.getNumber() - A.getNumber()) * t;
    return e === "%" && (i *= 100), "".concat(i).concat(e);
  }
  update(e) {
    var {
      parent: t
    } = this, A = this.getProperty();
    if (this.initialValue || (this.initialValue = A.getString(), this.initialUnits = A.getUnits()), this.duration > this.maxDuration) {
      var n = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (n === "freeze" && !this.frozen)
        this.frozen = !0, t.animationFrozen = !0, t.animationFrozenValue = A.getString();
      else if (n === "remove" && !this.removed)
        return this.removed = !0, A.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    var i = !1;
    if (this.begin < this.duration) {
      var s = this.calcValue(), a = this.getAttribute("type");
      if (a.hasValue()) {
        var o = a.getString();
        s = "".concat(o, "(").concat(s, ")");
      }
      A.setValue(s), i = !0;
    }
    return i;
  }
  getProgress() {
    var {
      document: e,
      values: t
    } = this, A = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };
    if (t.hasValue()) {
      var n = A.progress * (t.getValue().length - 1), i = Math.floor(n), s = Math.ceil(n);
      A.from = new pt(e, "from", parseFloat(t.getValue()[i])), A.to = new pt(e, "to", parseFloat(t.getValue()[s])), A.progress = (n - i) / (s - i);
    } else
      A.from = this.from, A.to = this.to;
    return A;
  }
}
class OF extends vf {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: A
    } = this.getProgress(), n = new Rm(t.getColor()), i = new Rm(A.getColor());
    if (n.ok && i.ok) {
      var s = n.r + (i.r - n.r) * e, a = n.g + (i.g - n.g) * e, o = n.b + (i.b - n.b) * e;
      return "rgb(".concat(Math.floor(s), ", ").concat(Math.floor(a), ", ").concat(Math.floor(o), ")");
    }
    return this.getAttribute("from").getColor();
  }
}
class MF extends vf {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: A
    } = this.getProgress(), n = on(t.getString()), i = on(A.getString()), s = n.map((a, o) => {
      var l = i[o];
      return a + (l - a) * e;
    }).join(" ");
    return s;
  }
}
class RF extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "font", this.glyphs = /* @__PURE__ */ Object.create(null), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    var {
      definitions: n
    } = e, {
      children: i
    } = this;
    for (var s of i)
      switch (s.type) {
        case "font-face": {
          this.fontFace = s;
          var a = s.getStyle("font-family");
          a.hasValue() && (n[a.getString()] = this);
          break;
        }
        case "missing-glyph":
          this.missingGlyph = s;
          break;
        case "glyph": {
          var o = s;
          o.arabicForm ? (this.isRTL = !0, this.isArabic = !0, typeof this.glyphs[o.unicode] > "u" && (this.glyphs[o.unicode] = /* @__PURE__ */ Object.create(null)), this.glyphs[o.unicode][o.arabicForm] = o) : this.glyphs[o.unicode] = o;
          break;
        }
      }
  }
  render() {
  }
}
class kF extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class HF extends rr {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class DF extends cs {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    var e = this.getHrefAttribute().getDefinition();
    if (e) {
      var t = e.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class GF extends cs {
  constructor(e, t, A) {
    super(e, t, A), this.type = "a";
    var {
      childNodes: n
    } = t, i = n[0], s = n.length > 0 && Array.from(n).every((a) => a.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(i) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      var {
        document: t,
        x: A,
        y: n
      } = this, {
        mouse: i
      } = t.screen, s = new pt(t, "fontSize", HA.parse(t.ctx.font).fontSize);
      i.isWorking() && i.checkBoundingBox(this, new Kn(A, n - s.getPixels("y"), A + this.measureText(e), n));
    } else if (this.children.length > 0) {
      var a = new mf(this.document, null);
      a.children = this.children, a.parent = this, a.render(e);
    }
  }
  onClick() {
    var {
      window: e
    } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    var e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
function mS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function Jc(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mS(Object(t), !0).forEach(function(A) {
      zv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : mS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
class VF extends cs {
  constructor(e, t, A) {
    super(e, t, A), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    var n = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(n);
  }
  getText() {
    return this.text;
  }
  path(e) {
    var {
      dataArray: t
    } = this;
    e && e.beginPath(), t.forEach((A) => {
      var {
        type: n,
        points: i
      } = A;
      switch (n) {
        case Ut.LINE_TO:
          e && e.lineTo(i[0], i[1]);
          break;
        case Ut.MOVE_TO:
          e && e.moveTo(i[0], i[1]);
          break;
        case Ut.CURVE_TO:
          e && e.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
          break;
        case Ut.QUAD_TO:
          e && e.quadraticCurveTo(i[0], i[1], i[2], i[3]);
          break;
        case Ut.ARC: {
          var [s, a, o, l, u, c, f, h] = i, g = o > l ? o : l, p = o > l ? 1 : o / l, v = o > l ? l / o : 1;
          e && (e.translate(s, a), e.rotate(f), e.scale(p, v), e.arc(0, 0, g, u, u + c, !!(1 - h)), e.scale(1 / p, 1 / v), e.rotate(-f), e.translate(-s, -a));
          break;
        }
        case Ut.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    var t = this.parent.getStyle("text-decoration").getString(), A = this.getFontSize(), {
      glyphInfo: n
    } = this, i = e.fillStyle;
    t === "underline" && e.beginPath(), n.forEach((s, a) => {
      var {
        p0: o,
        p1: l,
        rotation: u,
        text: c
      } = s;
      e.save(), e.translate(o.x, o.y), e.rotate(u), e.fillStyle && e.fillText(c, 0, 0), e.strokeStyle && e.strokeText(c, 0, 0), e.restore(), t === "underline" && (a === 0 && e.moveTo(o.x, o.y + A / 8), e.lineTo(l.x, l.y + A / 5));
    }), t === "underline" && (e.lineWidth = A / 20, e.strokeStyle = i, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, t, A, n, i, s, a, o, l) {
    var u = s, c = this.measureText(e, o);
    o === " " && t === "justify" && A < n && (c += (n - A) / i), l > -1 && (u += this.getLetterSpacingAt(l));
    var f = this.textHeight / 20, h = this.getEquidistantPointOnPath(u, f, 0), g = this.getEquidistantPointOnPath(u + c, f, 0), p = {
      p0: h,
      p1: g
    }, v = h && g ? Math.atan2(g.y - h.y, g.x - h.x) : 0;
    if (a) {
      var w = Math.cos(Math.PI / 2 + v) * a, b = Math.cos(-v) * a;
      p.p0 = Jc(Jc({}, h), {}, {
        x: h.x + w,
        y: h.y + b
      }), p.p1 = Jc(Jc({}, g), {}, {
        x: g.x + w,
        y: g.y + b
      });
    }
    return u += c, {
      offset: u,
      segment: p,
      rotation: v
    };
  }
  measureText(e, t) {
    var {
      measuresCache: A
    } = this, n = t || this.getText();
    if (A.has(n))
      return A.get(n);
    var i = this.measureTargetText(e, n);
    return A.set(n, i), i;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (!this.glyphInfo) {
      var t = this.getText(), A = t.split(""), n = t.split(" ").length - 1, i = this.parent.getAttribute("dx").split().map((B) => B.getPixels("x")), s = this.parent.getAttribute("dy").getPixels("y"), a = this.parent.getStyle("text-anchor").getString("start"), o = this.getStyle("letter-spacing"), l = this.parent.getStyle("letter-spacing"), u = 0;
      !o.hasValue() || o.getValue() === "inherit" ? u = l.getPixels() : o.hasValue() && o.getValue() !== "initial" && o.getValue() !== "unset" && (u = o.getPixels());
      var c = [], f = t.length;
      this.letterSpacingCache = c;
      for (var h = 0; h < f; h++)
        c.push(typeof i[h] < "u" ? i[h] : u);
      var g = c.reduce((B, x, U) => U === 0 ? 0 : B + x || 0, 0), p = this.measureText(e), v = Math.max(p + g, 0);
      this.textWidth = p, this.textHeight = this.getFontSize(), this.glyphInfo = [];
      var w = this.getPathLength(), b = this.getStyle("startOffset").getNumber(0) * w, S = 0;
      (a === "middle" || a === "center") && (S = -v / 2), (a === "end" || a === "right") && (S = -v), S += b, A.forEach((B, x) => {
        var {
          offset: U,
          segment: Q,
          rotation: N
        } = this.findSegmentToFitChar(e, a, v, w, n, S, s, B, x);
        S = U, !(!Q.p0 || !Q.p1) && this.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: A[x],
          p0: Q.p0,
          p1: Q.p1,
          rotation: N
        });
      });
    }
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    var t = [], {
      pathParser: A
    } = e;
    for (A.reset(); !A.isEnd(); ) {
      var {
        current: n
      } = A, i = n ? n.x : 0, s = n ? n.y : 0, a = A.next(), o = a.type, l = [];
      switch (a.type) {
        case Ut.MOVE_TO:
          this.pathM(A, l);
          break;
        case Ut.LINE_TO:
          o = this.pathL(A, l);
          break;
        case Ut.HORIZ_LINE_TO:
          o = this.pathH(A, l);
          break;
        case Ut.VERT_LINE_TO:
          o = this.pathV(A, l);
          break;
        case Ut.CURVE_TO:
          this.pathC(A, l);
          break;
        case Ut.SMOOTH_CURVE_TO:
          o = this.pathS(A, l);
          break;
        case Ut.QUAD_TO:
          this.pathQ(A, l);
          break;
        case Ut.SMOOTH_QUAD_TO:
          o = this.pathT(A, l);
          break;
        case Ut.ARC:
          l = this.pathA(A);
          break;
        case Ut.CLOSE_PATH:
          rr.pathZ(A);
          break;
      }
      a.type !== Ut.CLOSE_PATH ? t.push({
        type: o,
        points: l,
        start: {
          x: i,
          y: s
        },
        pathLength: this.calcLength(i, s, o, l)
      }) : t.push({
        type: Ut.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(e, t) {
    var {
      x: A,
      y: n
    } = rr.pathM(e).point;
    t.push(A, n);
  }
  pathL(e, t) {
    var {
      x: A,
      y: n
    } = rr.pathL(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathH(e, t) {
    var {
      x: A,
      y: n
    } = rr.pathH(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathV(e, t) {
    var {
      x: A,
      y: n
    } = rr.pathV(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathC(e, t) {
    var {
      point: A,
      controlPoint: n,
      currentPoint: i
    } = rr.pathC(e);
    t.push(A.x, A.y, n.x, n.y, i.x, i.y);
  }
  pathS(e, t) {
    var {
      point: A,
      controlPoint: n,
      currentPoint: i
    } = rr.pathS(e);
    return t.push(A.x, A.y, n.x, n.y, i.x, i.y), Ut.CURVE_TO;
  }
  pathQ(e, t) {
    var {
      controlPoint: A,
      currentPoint: n
    } = rr.pathQ(e);
    t.push(A.x, A.y, n.x, n.y);
  }
  pathT(e, t) {
    var {
      controlPoint: A,
      currentPoint: n
    } = rr.pathT(e);
    return t.push(A.x, A.y, n.x, n.y), Ut.QUAD_TO;
  }
  pathA(e) {
    var {
      rX: t,
      rY: A,
      sweepFlag: n,
      xAxisRotation: i,
      centp: s,
      a1: a,
      ad: o
    } = rr.pathA(e);
    return n === 0 && o > 0 && (o -= 2 * Math.PI), n === 1 && o < 0 && (o += 2 * Math.PI), [s.x, s.y, t, A, a, o, i, n];
  }
  calcLength(e, t, A, n) {
    var i = 0, s = null, a = null, o = 0;
    switch (A) {
      case Ut.LINE_TO:
        return this.getLineLength(e, t, n[0], n[1]);
      case Ut.CURVE_TO:
        for (i = 0, s = this.getPointOnCubicBezier(0, e, t, n[0], n[1], n[2], n[3], n[4], n[5]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnCubicBezier(o, e, t, n[0], n[1], n[2], n[3], n[4], n[5]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case Ut.QUAD_TO:
        for (i = 0, s = this.getPointOnQuadraticBezier(0, e, t, n[0], n[1], n[2], n[3]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnQuadraticBezier(o, e, t, n[0], n[1], n[2], n[3]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case Ut.ARC: {
        i = 0;
        var l = n[4], u = n[5], c = n[4] + u, f = Math.PI / 180;
        if (Math.abs(l - c) < f && (f = Math.abs(l - c)), s = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], l, 0), u < 0)
          for (o = l - f; o > c; o -= f)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        else
          for (o = l + f; o < c; o += f)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], c, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), i;
      }
    }
    return 0;
  }
  getPointOnLine(e, t, A, n, i) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : t, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : A, o = (i - A) / (n - t + Ma), l = Math.sqrt(e * e / (1 + o * o));
    n < t && (l *= -1);
    var u = o * l, c = null;
    if (n === t)
      c = {
        x: s,
        y: a + u
      };
    else if ((a - A) / (s - t + Ma) === o)
      c = {
        x: s + l,
        y: a + u
      };
    else {
      var f = 0, h = 0, g = this.getLineLength(t, A, n, i);
      if (g < Ma)
        return null;
      var p = (s - t) * (n - t) + (a - A) * (i - A);
      p /= g * g, f = t + p * (n - t), h = A + p * (i - A);
      var v = this.getLineLength(s, a, f, h), w = Math.sqrt(e * e - v * v);
      l = Math.sqrt(w * w / (1 + o * o)), n < t && (l *= -1), u = o * l, c = {
        x: f + l,
        y: h + u
      };
    }
    return c;
  }
  getPointOnPath(e) {
    var t = this.getPathLength(), A = 0, n = null;
    if (e < -5e-5 || e - 5e-5 > t)
      return null;
    var {
      dataArray: i
    } = this;
    for (var s of i) {
      if (s && (s.pathLength < 5e-5 || A + s.pathLength + 5e-5 < e)) {
        A += s.pathLength;
        continue;
      }
      var a = e - A, o = 0;
      switch (s.type) {
        case Ut.LINE_TO:
          n = this.getPointOnLine(a, s.start.x, s.start.y, s.points[0], s.points[1], s.start.x, s.start.y);
          break;
        case Ut.ARC: {
          var l = s.points[4], u = s.points[5], c = s.points[4] + u;
          if (o = l + a / s.pathLength * u, u < 0 && o < c || u >= 0 && o > c)
            break;
          n = this.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], o, s.points[6]);
          break;
        }
        case Ut.CURVE_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnCubicBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          break;
        case Ut.QUAD_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnQuadraticBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3]);
          break;
      }
      if (n)
        return n;
      break;
    }
    return null;
  }
  getLineLength(e, t, A, n) {
    return Math.sqrt((A - e) * (A - e) + (n - t) * (n - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, t) => t.pathLength > 0 ? e + t.pathLength : e, 0)), this.pathLength;
  }
  getPointOnCubicBezier(e, t, A, n, i, s, a, o, l) {
    var u = o * Gm(e) + s * Vm(e) + n * Km(e) + t * jm(e), c = l * Gm(e) + a * Vm(e) + i * Km(e) + A * jm(e);
    return {
      x: u,
      y: c
    };
  }
  getPointOnQuadraticBezier(e, t, A, n, i, s, a) {
    var o = s * qm(e) + n * zm(e) + t * Wm(e), l = a * qm(e) + i * zm(e) + A * Wm(e);
    return {
      x: o,
      y: l
    };
  }
  getPointOnEllipticalArc(e, t, A, n, i, s) {
    var a = Math.cos(s), o = Math.sin(s), l = {
      x: A * Math.cos(i),
      y: n * Math.sin(i)
    };
    return {
      x: e + (l.x * a - l.y * o),
      y: t + (l.x * o + l.y * a)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, t) {
    var A = this.getPathLength(), n = t || 0.25, i = e || A / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== i || this.equidistantCache.precision !== n) {
      this.equidistantCache = {
        step: i,
        precision: n,
        points: []
      };
      for (var s = 0, a = 0; a <= A; a += n) {
        var o = this.getPointOnPath(a), l = this.getPointOnPath(a + n);
        !o || !l || (s += this.getLineLength(o.x, o.y, l.x, l.y), s >= i && (this.equidistantCache.points.push({
          x: o.x,
          y: o.y,
          distance: a
        }), s -= i));
      }
    }
  }
  getEquidistantPointOnPath(e, t, A) {
    if (this.buildEquidistantCache(t, A), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    var n = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[n] || null;
  }
}
var Q8 = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class KF extends ra {
  constructor(e, t, A) {
    super(e, t, A), this.type = "image", this.loaded = !1;
    var n = this.getHrefAttribute().getString();
    if (n) {
      var i = n.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(n);
      e.images.push(this), i ? this.loadSvg(n) : this.loadImage(n), this.isSvg = i;
    }
  }
  loadImage(e) {
    var t = this;
    return us(function* () {
      try {
        var A = yield t.document.createImage(e);
        t.image = A;
      } catch (n) {
        console.error('Error while loading image "'.concat(e, '":'), n);
      }
      t.loaded = !0;
    })();
  }
  loadSvg(e) {
    var t = this;
    return us(function* () {
      var A = Q8.exec(e);
      if (A) {
        var n = A[5];
        A[4] === "base64" ? t.image = atob(n) : t.image = decodeURIComponent(n);
      } else
        try {
          var i = yield t.document.fetch(e), s = yield i.text();
          t.image = s;
        } catch (a) {
          console.error('Error while loading image "'.concat(e, '":'), a);
        }
      t.loaded = !0;
    })();
  }
  renderChildren(e) {
    var {
      document: t,
      image: A,
      loaded: n
    } = this, i = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), a = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!(!n || !A || !a || !o)) {
      if (e.save(), e.translate(i, s), this.isSvg) {
        var l = t.canvg.forkString(e, this.image, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: a,
          scaleHeight: o
        });
        l.document.documentElement.parent = this, l.render();
      } else {
        var u = this.image;
        t.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: a,
          desiredWidth: u.width,
          height: o,
          desiredHeight: u.height
        }), this.loaded && (typeof u.complete > "u" || u.complete) && e.drawImage(u, 0, 0);
      }
      e.restore();
    }
  }
  getBoundingBox() {
    var e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), A = this.getStyle("width").getPixels("x"), n = this.getStyle("height").getPixels("y");
    return new Kn(e, t, e + A, t + n);
  }
}
class jF extends ra {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(e) {
  }
}
class qF {
  constructor(e) {
    this.document = e, this.loaded = !1, e.fonts.push(this);
  }
  load(e, t) {
    var A = this;
    return us(function* () {
      try {
        var {
          document: n
        } = A, i = yield n.canvg.parser.load(t), s = i.getElementsByTagName("font");
        Array.from(s).forEach((a) => {
          var o = n.createElement(a);
          n.definitions[e] = o;
        });
      } catch (a) {
        console.error('Error while loading font "'.concat(t, '":'), a);
      }
      A.loaded = !0;
    })();
  }
}
class t1 extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "style";
    var n = Ya(
      Array.from(t.childNodes).map((s) => s.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ), i = n.split("}");
    i.forEach((s) => {
      var a = s.trim();
      if (a) {
        var o = a.split("{"), l = o[0].split(","), u = o[1].split(";");
        l.forEach((c) => {
          var f = c.trim();
          if (f) {
            var h = e.styles[f] || {};
            if (u.forEach((v) => {
              var w = v.indexOf(":"), b = v.substr(0, w).trim(), S = v.substr(w + 1, v.length - w).trim();
              b && S && (h[b] = new pt(e, b, S));
            }), e.styles[f] = h, e.stylesSpecificity[f] = gF(f), f === "@font-face") {
              var g = h["font-family"].getString().replace(/"|'/g, ""), p = h.src.getString().split(",");
              p.forEach((v) => {
                if (v.indexOf('format("svg")') > 0) {
                  var w = Wv(v);
                  w && new qF(e).load(g, w);
                }
              });
            }
          }
        });
      }
    });
  }
}
t1.parseExternalUrl = Wv;
class zF extends ra {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(e) {
    super.setContext(e);
    var t = this.getAttribute("x"), A = this.getAttribute("y");
    t.hasValue() && e.translate(t.getPixels("x"), 0), A.hasValue() && e.translate(0, A.getPixels("y"));
  }
  path(e) {
    var {
      element: t
    } = this;
    t && t.path(e);
  }
  renderChildren(e) {
    var {
      document: t,
      element: A
    } = this;
    if (A) {
      var n = A;
      if (A.type === "symbol" && (n = new jo(t, null), n.attributes.viewBox = new pt(t, "viewBox", A.getAttribute("viewBox").getString()), n.attributes.preserveAspectRatio = new pt(t, "preserveAspectRatio", A.getAttribute("preserveAspectRatio").getString()), n.attributes.overflow = new pt(t, "overflow", A.getAttribute("overflow").getString()), n.children = A.children, A.styles.opacity = new pt(t, "opacity", this.calculateOpacity())), n.type === "svg") {
        var i = this.getStyle("width", !1, !0), s = this.getStyle("height", !1, !0);
        i.hasValue() && (n.attributes.width = new pt(t, "width", i.getString())), s.hasValue() && (n.attributes.height = new pt(t, "height", s.getString()));
      }
      var a = n.parent;
      n.parent = this, n.render(e), n.parent = a;
    }
  }
  getBoundingBox(e) {
    var {
      element: t
    } = this;
    return t ? t.getBoundingBox(e) : null;
  }
  elementTransform() {
    var {
      document: e,
      element: t
    } = this;
    return Ys.fromElement(e, t);
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function Zc(r, e, t, A, n, i) {
  return r[t * A * 4 + e * 4 + i];
}
function eh(r, e, t, A, n, i, s) {
  r[t * A * 4 + e * 4 + i] = s;
}
function AA(r, e, t) {
  var A = r[e];
  return A * t;
}
function es(r, e, t, A) {
  return e + Math.cos(r) * t + Math.sin(r) * A;
}
class r1 extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feColorMatrix";
    var n = on(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case "saturate": {
        var i = n[0];
        n = [0.213 + 0.787 * i, 0.715 - 0.715 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 + 0.285 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 - 0.715 * i, 0.072 + 0.928 * i, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "hueRotate": {
        var s = n[0] * Math.PI / 180;
        n = [es(s, 0.213, 0.787, -0.213), es(s, 0.715, -0.715, -0.715), es(s, 0.072, -0.072, 0.928), 0, 0, es(s, 0.213, -0.213, 0.143), es(s, 0.715, 0.285, 0.14), es(s, 0.072, -0.072, -0.283), 0, 0, es(s, 0.213, -0.213, -0.787), es(s, 0.715, -0.715, 0.715), es(s, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "luminanceToAlpha":
        n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = n, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, t, A, n, i) {
    for (var {
      includeOpacity: s,
      matrix: a
    } = this, o = e.getImageData(0, 0, n, i), l = 0; l < i; l++)
      for (var u = 0; u < n; u++) {
        var c = Zc(o.data, u, l, n, i, 0), f = Zc(o.data, u, l, n, i, 1), h = Zc(o.data, u, l, n, i, 2), g = Zc(o.data, u, l, n, i, 3), p = AA(a, 0, c) + AA(a, 1, f) + AA(a, 2, h) + AA(a, 3, g) + AA(a, 4, 1), v = AA(a, 5, c) + AA(a, 6, f) + AA(a, 7, h) + AA(a, 8, g) + AA(a, 9, 1), w = AA(a, 10, c) + AA(a, 11, f) + AA(a, 12, h) + AA(a, 13, g) + AA(a, 14, 1), b = AA(a, 15, c) + AA(a, 16, f) + AA(a, 17, h) + AA(a, 18, g) + AA(a, 19, 1);
        s && (p = 0, v = 0, w = 0, b *= g / 255), eh(o.data, u, l, n, i, 0, p), eh(o.data, u, l, n, i, 1, v), eh(o.data, u, l, n, i, 2, w), eh(o.data, u, l, n, i, 3, b);
      }
    e.clearRect(0, 0, n, i), e.putImageData(o, 0, 0);
  }
}
class Tu extends mr {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(e, t) {
    var {
      document: A
    } = this, n = this.getAttribute("x").getPixels("x"), i = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), a = this.getStyle("height").getPixels("y");
    if (!s && !a) {
      var o = new Kn();
      this.children.forEach((g) => {
        o.addBoundingBox(g.getBoundingBox(e));
      }), n = Math.floor(o.x1), i = Math.floor(o.y1), s = Math.floor(o.width), a = Math.floor(o.height);
    }
    var l = this.removeStyles(t, Tu.ignoreStyles), u = A.createCanvas(n + s, i + a), c = u.getContext("2d");
    A.screen.setDefaults(c), this.renderChildren(c), new r1(A, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: "type",
        value: "luminanceToAlpha"
      }, {
        nodeName: "includeOpacity",
        value: "true"
      }]
    }).apply(c, 0, 0, n + s, i + a);
    var f = A.createCanvas(n + s, i + a), h = f.getContext("2d");
    A.screen.setDefaults(h), t.render(h), h.globalCompositeOperation = "destination-in", h.fillStyle = c.createPattern(u, "no-repeat"), h.fillRect(0, 0, n + s, i + a), e.fillStyle = h.createPattern(f, "no-repeat"), e.fillRect(0, 0, n + s, i + a), this.restoreStyles(t, l);
  }
  render(e) {
  }
}
Tu.ignoreStyles = ["mask", "transform", "clip-path"];
var vS = () => {
};
class WF extends mr {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(e) {
    var {
      document: t
    } = this, A = Reflect.getPrototypeOf(e), {
      beginPath: n,
      closePath: i
    } = e;
    A && (A.beginPath = vS, A.closePath = vS), Reflect.apply(n, e, []), this.children.forEach((s) => {
      if (!(typeof s.path > "u")) {
        var a = typeof s.elementTransform < "u" ? s.elementTransform() : null;
        a || (a = Ys.fromElement(t, s)), a && a.apply(e), s.path(e), A && (A.closePath = i), a && a.unapply(e);
      }
    }), Reflect.apply(i, e, []), e.clip(), A && (A.beginPath = n, A.closePath = i);
  }
  render(e) {
  }
}
class Pu extends mr {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(e, t) {
    var {
      document: A,
      children: n
    } = this, i = t.getBoundingBox(e);
    if (i) {
      var s = 0, a = 0;
      n.forEach((w) => {
        var b = w.extraFilterDistance || 0;
        s = Math.max(s, b), a = Math.max(a, b);
      });
      var o = Math.floor(i.width), l = Math.floor(i.height), u = o + 2 * s, c = l + 2 * a;
      if (!(u < 1 || c < 1)) {
        var f = Math.floor(i.x), h = Math.floor(i.y), g = this.removeStyles(t, Pu.ignoreStyles), p = A.createCanvas(u, c), v = p.getContext("2d");
        A.screen.setDefaults(v), v.translate(-f + s, -h + a), t.render(v), n.forEach((w) => {
          typeof w.apply == "function" && w.apply(v, 0, 0, u, c);
        }), e.drawImage(p, 0, 0, u, c, f - s, h - a, u, c), this.restoreStyles(t, g);
      }
    }
  }
  render(e) {
  }
}
Pu.ignoreStyles = ["filter", "transform", "clip-path"];
class XF extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(e, t, A, n, i) {
  }
}
class YF extends mr {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(e, t, A, n, i) {
  }
}
class $F extends mr {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(e, t, A, n, i) {
  }
}
class JF extends mr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, t, A, n, i) {
    var {
      document: s,
      blurRadius: a
    } = this, o = s.window ? s.window.document.body : null, l = e.canvas;
    l.id = s.getUniqueId(), o && (l.style.display = "none", o.appendChild(l)), l8(l, t, A, n, i, a), o && o.removeChild(l);
  }
}
class ZF extends mr {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class e4 extends mr {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
var L8 = {
  svg: jo,
  rect: Jv,
  circle: EF,
  ellipse: FF,
  line: _F,
  polyline: Zv,
  polygon: UF,
  path: rr,
  pattern: IF,
  marker: QF,
  defs: LF,
  linearGradient: NF,
  radialGradient: TF,
  stop: PF,
  animate: vf,
  animateColor: OF,
  animateTransform: MF,
  font: RF,
  "font-face": kF,
  "missing-glyph": HF,
  glyph: $v,
  text: cs,
  tspan: Nu,
  tref: DF,
  a: GF,
  textPath: VF,
  image: KF,
  g: mf,
  symbol: jF,
  style: t1,
  use: zF,
  mask: Tu,
  clipPath: WF,
  filter: Pu,
  feDropShadow: XF,
  feMorphology: YF,
  feComposite: $F,
  feColorMatrix: r1,
  feGaussianBlur: JF,
  title: ZF,
  desc: e4
};
function wS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function N8(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wS(Object(t), !0).forEach(function(A) {
      zv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : wS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
function T8(r, e) {
  var t = document.createElement("canvas");
  return t.width = r, t.height = e, t;
}
function P8(r) {
  return Xm.apply(this, arguments);
}
function Xm() {
  return Xm = us(function* (r) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = document.createElement("img");
    return e && (t.crossOrigin = "Anonymous"), new Promise((A, n) => {
      t.onload = () => {
        A(t);
      }, t.onerror = (i, s, a, o, l) => {
        n(l);
      }, t.src = r;
    });
  }), Xm.apply(this, arguments);
}
class ss {
  constructor(e) {
    var {
      rootEmSize: t = 12,
      emSize: A = 12,
      createCanvas: n = ss.createCanvas,
      createImage: i = ss.createImage,
      anonymousCrossOrigin: s
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.canvg = e, this.definitions = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = e.screen, this.rootEmSize = t, this.emSize = A, this.createCanvas = n, this.createImage = this.bindCreateImage(i, s), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
  }
  bindCreateImage(e, t) {
    return typeof t == "boolean" ? (A, n) => e(A, typeof n == "boolean" ? n : t) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    var {
      emSizeStack: e
    } = this;
    return e[e.length - 1];
  }
  set emSize(e) {
    var {
      emSizeStack: t
    } = this;
    t.push(e);
  }
  popEmSize() {
    var {
      emSizeStack: e
    } = this;
    e.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    var t = this.createElement(e.documentElement);
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(e) {
    var t = e.nodeName.replace(/^[^:]+:/, ""), A = ss.elementTypes[t];
    return typeof A < "u" ? new A(this, e) : new xF(this, e);
  }
  createTextNode(e) {
    return new I8(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox(N8({
      document: this
    }, e));
  }
}
ss.createCanvas = T8;
ss.createImage = P8;
ss.elementTypes = L8;
function yS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function Ba(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yS(Object(t), !0).forEach(function(A) {
      zv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : yS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
class La {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.parser = new ph(A), this.screen = new Lu(e, A), this.options = A;
    var n = new ss(this, A), i = n.createDocumentElement(t);
    this.document = n, this.documentElement = i;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static from(e, t) {
    var A = arguments;
    return us(function* () {
      var n = A.length > 2 && A[2] !== void 0 ? A[2] : {}, i = new ph(n), s = yield i.parse(t);
      return new La(e, s, n);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static fromString(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = new ph(A), i = n.parseFromString(t);
    return new La(e, i, A);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  fork(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return La.from(e, t, Ba(Ba({}, this.options), A));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  forkString(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return La.fromString(e, t, Ba(Ba({}, this.options), A));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  render() {
    var e = arguments, t = this;
    return us(function* () {
      var A = e.length > 0 && e[0] !== void 0 ? e[0] : {};
      t.start(Ba({
        enableRedraw: !0,
        ignoreAnimation: !0,
        ignoreMouse: !0
      }, A)), yield t.ready(), t.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      documentElement: t,
      screen: A,
      options: n
    } = this;
    A.start(t, Ba(Ba({
      enableRedraw: !0
    }, n), e));
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(e, t, A);
  }
}
const O8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AElement: GF,
  AnimateColorElement: OF,
  AnimateElement: vf,
  AnimateTransformElement: MF,
  BoundingBox: Kn,
  CB1: Gm,
  CB2: Vm,
  CB3: Km,
  CB4: jm,
  Canvg: La,
  CircleElement: EF,
  ClipPathElement: WF,
  DefsElement: LF,
  DescElement: e4,
  Document: ss,
  Element: mr,
  EllipseElement: FF,
  FeColorMatrixElement: r1,
  FeCompositeElement: $F,
  FeDropShadowElement: XF,
  FeGaussianBlurElement: JF,
  FeMorphologyElement: YF,
  FilterElement: Pu,
  Font: HA,
  FontElement: RF,
  FontFaceElement: kF,
  GElement: mf,
  GlyphElement: $v,
  GradientElement: e1,
  ImageElement: KF,
  LineElement: _F,
  LinearGradientElement: NF,
  MarkerElement: QF,
  MaskElement: Tu,
  Matrix: Xv,
  MissingGlyphElement: HF,
  Mouse: mF,
  PSEUDO_ZERO: Ma,
  Parser: ph,
  PathElement: rr,
  PathParser: Ut,
  PatternElement: IF,
  Point: Tr,
  PolygonElement: UF,
  PolylineElement: Zv,
  Property: pt,
  QB1: qm,
  QB2: zm,
  QB3: Wm,
  RadialGradientElement: TF,
  RectElement: Jv,
  RenderedElement: ra,
  Rotate: bF,
  SVGElement: jo,
  SVGFontLoader: qF,
  Scale: BF,
  Screen: Lu,
  Skew: Yv,
  SkewX: CF,
  SkewY: SF,
  StopElement: PF,
  StyleElement: t1,
  SymbolElement: jF,
  TRefElement: DF,
  TSpanElement: Nu,
  TextElement: cs,
  TextPathElement: VF,
  TitleElement: ZF,
  Transform: Ys,
  Translate: yF,
  UnknownElement: xF,
  UseElement: zF,
  ViewPort: pF,
  compressSpaces: Ya,
  default: La,
  getSelectorSpecificity: gF,
  normalizeAttributeName: fF,
  normalizeColor: dF,
  parseExternalUrl: Wv,
  presets: f8,
  toNumbers: on,
  trimLeft: cF,
  trimRight: hF,
  vectorMagnitude: Hm,
  vectorsAngle: Dm,
  vectorsRatio: Mh
}, Symbol.toStringTag, { value: "Module" }));
export {
  pA as default
};
//# sourceMappingURL=svgcanvas.js.map
